(function () {
    'use strict';

    angular
        .module('app.settings', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider
            .state('app.transform.settings', {
                abstract: true,
                url: '/settings',
                data: {
                    selectedTab: 1
                },
                defaultChild: 'app.settings.batches',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/settings/transform/settings.html',
                        controller: 'SettingsController as vm'
                    }
                }
            })
            .state('app.transform.settings.users', {
                url: '/users',
                data: {
                    selectedTab: 1
                },
                views: {
                    'settings@users': {
                        templateUrl: 'app/main/settings/transform/tabs/users/users.html',
                        controller: 'UsersController as vm'
                    }
                }
            })
            .state('app.transform.settings.programs', {
                url: '/programs',
                data: {
                    selectedTab: 2
                },
                views: {
                    'settings@programs': {
                        templateUrl: 'app/main/settings/transform/tabs/programs/programs.html',
                        controller: 'ProgramsController as vm'
                    }
                }
            })
            .state('app.transform.settings.batches', {
                url: '/batches',
                data: {
                    selectedTab: 3
                },
                views: {
                    'settings@batches': {
                        templateUrl: 'app/main/settings/transform/tabs/batches/batches.html',
                        controller: 'BatchesController as vm'
                    }
                }
            })
            .state('app.transform.settings.batches.weeks', {
                url: '/{id}/batch-weeks',
                data: {
                    selectedTab: 3
                },
                controller: 'BatchesController',
                controllerAs: 'vm'
            })
            .state('app.transform.settings.products', {
                url: '/products',
                data: {
                    selectedTab: 4
                },
                views: {
                    'settings@products': {
                        templateUrl: 'app/main/settings/transform/tabs/products/products.html',
                        controller: 'ProductsController as vm'
                    }
                }
            })
            .state('app.transform.settings.donors', {
                url: '/donors',
                data: {
                    selectedTab: 5
                },
                views: {
                    'settings@donors': {
                        templateUrl: 'app/main/settings/transform/tabs/donors/donors.html',
                        controller: 'DonorsController as vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular.module('app.settings')
        .controller('DenominationDialogController', DenominationDialogController);

    /** @ngInject */
    function DenominationDialogController($mdDialog,
                                          initDenominationsTable,
                                          denominationObj,
                                          DenominationService) {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.saveDenomination = saveDenomination;
        vm.apiErrors = {};

        if (!denominationObj) {
            vm.dialogTitle = "New Denomination";
            vm.denomination = {};
        } else {
            vm.dialogTitle = 'Edit Denomination';
            vm.denomination = {
                id: denominationObj.id,
                name: denominationObj.name
            };
        }

        function saveDenomination(denomination) {
            vm.saving = true;
            vm.apiErrors = {};

            if (!denominationObj) {
                return DenominationService.addDenomination(denomination)
                    .then(onComplete);
            } else {
                return DenominationService.editDenomination(denomination)
                    .then(onComplete);
            }
        }

        function onComplete() {
            vm.saving = false;
            initDenominationsTable();
            closeDialog();
        }

        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.settings')
        .controller('DeleteDenominationDialogController', DeleteDenominationDialogController);

    /** @ngInject */
    function DeleteDenominationDialogController($mdDialog,
                                                initDenominationsTable,
                                                denomination,
                                                DenominationService) {
        var vm = this;

        vm.closeDialog = closeDialog;
        vm.deleteCallback = deleteCallback;

        vm.dialogTitle = "Delete Denomination";
        vm.message = 'Are you sure to delete this denomination?';
        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteCallback(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        function deleteCallback() {
            vm.saving = true;
            return DenominationService.deleteDenomination(denomination)
                .then(function () {
                    vm.saving = false;
                    initDenominationsTable();
                    closeDialog();
                });
        }

        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.settings')
        .controller('SaveMayorDialogController', SaveMayorDialogController);

    /** @ngInject */
    function SaveMayorDialogController($mdDialog, initMayorsTable, mayor,
                                       MayorService, BaseService) {
        var vm         = this;
        vm.closeDialog = closeDialog;
        vm.saveMayor   = saveMayor;
        vm.apiErrors   = {};
        vm.cities      = [];
        vm.bases       = [];
        vm.selectBase  = selectBase;

        if (!mayor) {
            vm.dialogTitle = "New Mayor";
            vm.mayor       = {};
        } else {
            vm.dialogTitle  = 'Edit Mayor';
            vm.mayor        = angular.copy(mayor);
            vm.selectedBase = mayor.city.province.base;
            vm.selectedCity = mayor.city;
        }

        BaseService.getBases({with: "provinces.cities"}).then(function (response) {
            vm.bases = response.data;
        });

        /*
        Function used to save church mayor details
         */
        function saveMayor(mayor, city, form) {
            vm.saving = true;
            vm.apiErrors = {};

            mayor.city_id = city.id

            if (!mayor.id) {
                return MayorService.addMayor(mayor)
                    .then(onComplete)
                    .catch(function (response) {
                        form.$invalid = true;
                        vm.saving = false;
                        for (var field in response.data.errors) {
                            vm.apiErrors[field] = response.data.errors[field].shift();
                        }
                    });
            } else {
                return MayorService.editMayor(mayor)
                    .then(onComplete)
                    .catch(function (response) {
                        form.$invalid = true;
                        vm.saving = false;
                        for (var field in response.data.errors) {
                            vm.apiErrors[field] = response.data.errors[field].shift();
                        }
                    });
            }
        }

        /*
        Function triggered after saving church mayor details
         */
        function onComplete() {
            vm.saving = false;
            initMayorsTable();
            closeDialog();
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        /*
        Select the given base
         */
        function selectBase(base) {
            vm.cities = [];

            base.provinces.forEach(function (province) {
                vm.cities = vm.cities.concat(province.cities);
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.settings')
        .controller('DeleteMayorDialogController', DeleteMayorDialogController);

    /** @ngInject */
    function DeleteMayorDialogController($mdDialog, $document, initMayorsTable, mayor, MayorService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.deleteCallback = deleteCallback;

        vm.dialogTitle = "Delete Mayor";
        vm.message = 'Are you sure to delete this mayor?';
        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteCallback(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to delete church mayor
         */
        function deleteCallback() {
            vm.saving = true;
            return MayorService.deleteMayor(mayor)
                .then(function () {
                    vm.saving = false;
                    initMayorsTable();
                    closeDialog();
                });
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.thrivesettings', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider
            .state('app.thrive.settings', {
                abstract: true,
                url: '/settings',
                data: {
                    selectedTab: 1
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/settings/thrive/thrivesettings.html',
                        controller: 'ThriveSettingsController as vm'
                    }
                }
            })
            .state('app.thrive.settings.bases', {
                url: '/bases',
                data: {
                    selectedTab: 1
                },
                views: {
                    'settings@bases': {
                        templateUrl: 'app/main/settings/thrive/tabs/bases/bases.html',
                        controller: 'BasesController as vm'
                    }
                }
            })
            .state('app.thrive.settings.affiliations', {
                url: '/affiliations',
                data: {
                    selectedTab: 2
                },
                views: {
                    'settings@affiliations': {
                        templateUrl: 'app/main/settings/thrive/tabs/affiliations/affiliations.html',
                        controller: 'ChurchAffiliationsController as vm'
                    }
                }
            })
            .state('app.thrive.settings.mayors', {
                url: '/mayors',
                data: {
                    selectedTab: 3
                },
                views: {
                    'settings@mayors': {
                        templateUrl: 'app/main/settings/thrive/tabs/mayors/mayors.html',
                        controller: 'MayorsController as vm'
                    }
                }
            })
            .state('app.thrive.settings.datacard', {
                url: '/datacard',
                data: {
                    selectedTab: 4
                },
                views: {
                    'settings@datacard': {
                        templateUrl: 'app/main/settings/thrive/tabs/data-card/data-card.html',
                        controller: 'DataCardSettingsController as vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular.module('app.thrivesettings')
        .controller('BaseDialogController', BaseDialogController);

    /** @ngInject */
    function BaseDialogController($mdDialog,
                                      initBasesTable,
                                      baseObj,
                                      BaseService) {
        var vm = this;
        vm.countrys = [
            { id: "PH", name: "Philippines" },
            { id: "GU", name: "Guatemala" },
            { id: "UG", name: "Uganda" },
            { id: "BU", name: "Burundi" },
            { id: "KH", name: "Cambodia" },
        ];
        
        //Methods
        vm.closeDialog = closeDialog;
        vm.saveBase = saveBase;

        if(baseObj) {
            vm.dialogTitle = "Edit Base";
            vm.base = {
                id: baseObj.id,
                name: baseObj.name,
                country_code: baseObj.country_code
            };
        } else {
            vm.dialogTitle = "New Base";
            vm.base = {};
        }

        /*
        Function to save base
         */
        function saveBase(base) {
            vm.saving = true;

            if(baseObj) {
                return BaseService.editBase(base)
                    .then(onComplete);
            } else {
                return BaseService.addBase(base)
                    .then(onComplete);
            }
        }

        /*
        Function triggered after saving a base
         */
        function onComplete() {
            vm.saving = false;
            initBasesTable();
            closeDialog();
        }

        /*
        Function to close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.settings')
        .controller('NewProvinceDialogController', NewProvinceDialogController);

    /** @ngInject */
    function NewProvinceDialogController($mdDialog,
                                       base,
                                       initBasesTable,
                                       ProvinceService) {
        var vm = this;

        //Methods
        vm.base            = base;
        vm.closeDialog     = closeDialog;
        vm.addNewProvince  = addNewProvince;
        vm.searchProvinces = searchProvinces;
        vm.searchProvince  = null;

        vm.dialogTitle     = "New Province";
        vm.apiErrors       = {};

        /*
        Function to add new branch
         */
        function addNewProvince(branch, form) {
            vm.saving      = true;
            vm.apiErrors   = {};
            var data = {
                id      : vm.province.id,
                base_id : vm.base.id
            }

            return ProvinceService.updateBaseProvince(data)
                .then(function () {
                    vm.saving = false;
                    initBasesTable();
                    closeDialog();
                });
        }

        /*
        Search province
         */
        function searchProvinces(name) {
            return ProvinceService.getProvinces({
                search: name,
            }).then(function (response) {
                var data = []
                if (response.data) {
                    data = response.data.reduce((acc, crr) => {
                        if (!acc.find((ele) => ele.name === crr.name)) {
                            return [...acc, crr];
                        }
                        return acc;
                    }, []);
                }
                return data;
            });
        }

        /*
        Function to close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();
(function () {
    'use strict';

    angular.module('app.settings')
        .controller('NewBranchDialogController', NewBranchDialogController);

    /** @ngInject */
    function NewBranchDialogController($mdDialog,
                                       base,
                                       initBasesTable,
                                       BranchService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.addNewBranch = addNewBranch;

        vm.dialogTitle = "New Branch";
        vm.apiErrors = {};

        /*
        Function to add new branch
         */
        function addNewBranch(branch, form) {
            vm.saving = true;
            branch.base_id = base.id;
            vm.apiErrors = {};

            return BranchService.addBranch(branch)
                .then(function () {
                    vm.saving = false;
                    initBasesTable();
                    closeDialog();
                })
                .catch(function (response) {
                    form.$invalid = true;
                    vm.saving = false;

                    for (var field in response.data.errors) {
                        vm.apiErrors[field] = response.data.errors[field].shift();
                    }
                });
        }

        /*
        Function to close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.thrivesettings')
        .controller('EditBranchDialogController', EditBranchDialogController);

    /** @ngInject */
    function EditBranchDialogController($mdDialog,
                                        initBasesTable,
                                        base,
                                        branch,
                                        BranchService,
                                        BaseService,
                                        CityService) {
        var vm = this;

        //Methods
        vm.base        = base;
        vm.closeDialog = closeDialog;
        vm.editBranch  = editBranch;

        vm.dialogTitle = "Edit Branch";
        vm.apiErrors   = {};
        vm.provinceIds = base.provinces.map(function(item) {
            return item.id;
        });
        vm.selectedCities = branch.cities.map(function(item){ return item; });
        vm.selectedCity   = null;
        vm.searchCityText = null;
        vm.searchCities   = searchCities;

        vm.branch = {
            id: branch.id,
            name: branch.name,
            base_id: base.id,
            cities: branch.cities.map(function(item){ return item; })
        };

        getBases();

        /*
        Function to get all bases
         */
        function getBases() {
            BaseService.getBases({
                nopage: true,
            }).then(function (response) {
                vm.bases = response;
            });
        }

        function searchCities(name) {
            return CityService.getCities({
                'search'         : name,
                'with'           : 'province',
                'province_ids[]' : vm.provinceIds,
                'has_branch'     : 0
            }).then(function(cities) {
                return cities.data;
            });
        }

        /*
        Function to edit a branch
         */
        function editBranch(data, form) {
            var branch   = angular.copy(data);
            vm.saving    = true;
            vm.apiErrors = {};

            var oldCityIds = branch.cities.map(function(item) {
                return item.id;
            });

            for (var i in vm.selectedCities) {
                var item = vm.selectedCities[i];
                var pos  = oldCityIds.indexOf(item.id);

                if (pos >= 0) {
                    delete oldCityIds[pos];
                }

                CityService.updateBranch(item.id, branch.id)
                    .then(function() {
                        initBasesTable();
                    });
            }

            for (var i in oldCityIds) {
                var item = oldCityIds[i] || null;

                if (item) {
                    CityService.updateBranch(item, '')
                        .then(function() {
                            initBasesTable();
                        });
                }
            }

            return BranchService.editBranch(branch)
                .then(function () {
                    vm.saving = false;
                    initBasesTable();
                    closeDialog();
                })
                .catch(function (response) {
                    vm.saving = false;
                    form.$invalid = true;

                    for (var field in response.data.errors) {
                        if (field.indexOf(".")) {
                            field = field.split(".").shift();
                            vm.apiErrors[field] = "invalid";
                        } else {
                            vm.apiErrors[field] = response.data.errors[field].shift();
                        }
                    }
                });
        }

        /*
        Function to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.thrivesettings')
        .controller('DeleteProvinceDialogController', DeleteProvinceDialogController);

    /** @ngInject */
    function DeleteProvinceDialogController($mdDialog, $document,
                                          initBasesTable,
                                          province,
                                          ProvinceService) {
        var vm = this;

        //Methods
        vm.closeDialog    = closeDialog;
        vm.deleteProvince = deleteProvince;
        vm.province       = province;

        vm.dialogTitle = "Delete Province";
        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteProvince(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to delete base
         */
        function deleteProvince() {
            vm.saving = true;
            var data = {
                id      : province.id,
                base_id : ''
            }

            return ProvinceService.editProvince(data)
                .then(function () {
                    vm.saving = false;
                    initBasesTable();
                    closeDialog();
                });
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.thrivesettings')
        .controller('DeleteBranchDialogController', DeleteBranchDialogController);

    /** @ngInject */
    function DeleteBranchDialogController($mdDialog, $document,
                                          initBasesTable,
                                          branch,
                                          BranchService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.deleteBranch = deleteBranch;

        vm.dialogTitle = "Delete Branch";
        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteBranch(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to delete branch
         */
        function deleteBranch() {
            vm.saving = true;
            return BranchService.deleteBranch(branch)
                .then(function () {
                    vm.saving = false;
                    initBasesTable();
                    closeDialog();
                });
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.thrivesettings')
        .controller('DeleteBaseDialogController', DeleteBaseDialogController);

    /** @ngInject */
    function DeleteBaseDialogController($mdDialog, $document,
                                        initBasesTable,
                                        base,
                                        BaseService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.deleteBase = deleteBase;

        vm.dialogTitle = "Delete Base";
        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteBase(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to delete a base
         */
        function deleteBase() {
            vm.saving = true;
            return BaseService.deleteBase(base)
                .then(function () {
                    vm.saving = false;
                    initBasesTable();
                    closeDialog();
                });
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.settings')
        .controller('ChurchAffiliationDialogController', ChurchAffiliationDialogController);

    /** @ngInject */
    function ChurchAffiliationDialogController($mdDialog,
                                               initChurchAffiliationsTable,
                                               affiliationObj,
                                               ChurchAffiliationService) {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.saveChurchAffiliation = saveChurchAffiliation;
        vm.apiErrors = {};

        if (!affiliationObj) {
            vm.dialogTitle = "New Church Affiliation";
            vm.affiliation = {};
        } else {
            vm.dialogTitle = 'Edit Church Affiliation';
            vm.affiliation = {
                id: affiliationObj.id,
                name: affiliationObj.name
            };
        }

        /*
        Function used to save church affiliation details
         */
        function saveChurchAffiliation(affiliation) {
            vm.saving = true;
            vm.apiErrors = {};

            if (!affiliationObj) {
                return ChurchAffiliationService.addChurchAffiliation(affiliation)
                    .then(onComplete);
            } else {
                return ChurchAffiliationService.editChurchAffiliation(affiliation)
                    .then(onComplete);
            }
        }

        /*
        Function triggered after saving church affiliation details
         */
        function onComplete() {
            vm.saving = false;
            initChurchAffiliationsTable();
            closeDialog();
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.settings')
        .controller('DeleteChurchAffiliationDialogController', DeleteChurchAffiliationDialogController);

    /** @ngInject */
    function DeleteChurchAffiliationDialogController($mdDialog,
                                                $document,
                                                initChurchAffiliationsTable,
                                                affiliation,
                                                ChurchAffiliationService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.deleteCallback = deleteCallback;

        vm.dialogTitle = "Delete ChurchAffiliation";
        vm.message = 'Are you sure to delete this affiliation?';
        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteCallback(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to delete church affiliation
         */
        function deleteCallback() {
            vm.saving = true;
            return ChurchAffiliationService.deleteChurchAffiliation(affiliation)
                .then(function () {
                    vm.saving = false;
                    initChurchAffiliationsTable();
                    closeDialog();
                });
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.settings')
        .controller('NewUserDialogController', NewUserDialogController);

    /** @ngInject */
    function NewUserDialogController($mdDialog, activate, UserService, CityService, FormFieldService, BaseService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.addNewUser = addNewUser;
        vm.selectBase = selectBase;
        vm.branches = [];

        vm.dialogTitle = "New User";
        vm.apiErrors = {};
        vm.user = {
            base_id: -1
        };

        vm.countrys = [
            { id: "PH", name: "Philippines" },
            { id: "GM", name: "Guatemala" },
            { id: "UG", name: "Uganda" },
            { id: "BU", name: "Burundi" },
            { id: "KH", name: "Cambodia" },
        ]

        vm.handleCountryChange = function (country_code) {
            getBases(country_code);

            vm.user.base_id = -1;
            vm.branches = [];
            vm.user.branch_id = -1;
        }

        init();

        /*
        Function used to fetch user roles and bases
         */
        function init() {
            getUserRoles();
        }

        /*
        Function used to fetch bases
         */
        function getBases(country_code) {
            BaseService
                .getBases({
                    country_code: country_code,
                    nopage: 1,
                    with: 'branches'
                })
                .then(function (data) {
                    vm.bases = data;
                });
        }

        function selectBase(base) {
            vm.branches = base.branches;
            vm.user.branch_id = -1;
        }

        /*
        Function used to add new user
         */
        function addNewUser(user, form) {
            vm.saving = true;
            var userObject = {
                base_id: user.base_id > 0 ? user.base_id : null,
                branch_id: user.branch_id > 0 ? user.branch_id : null,
                username: user.username,
                email: user.email,
                country_code: user.country_code,
                password: user.password,
                password_confirmation: user.confirmPassword,
                firstname: user.firstname,
                lastname: user.lastname,
                roles: [user.role]
            };
            vm.apiErrors = {};

            return UserService.addUser(userObject)
                .then(function () {
                    vm.saving = false;
                    activate();
                    closeDialog();
                })
                .catch(function (response) {
                    form.$invalid = true;
                    vm.saving = false;

                    for (var field in response.data.errors) {
                        vm.apiErrors[field] = response.data.errors[field].shift();
                    }
                });
        }

        /*
        Function used to get user roles
         */
        function getUserRoles() {
            if (localStorage.getItem('userRoles')) {
                vm.roles = JSON.parse(localStorage.getItem('userRoles'));
            } else {
                return FormFieldService.getFields().then(function (data) {
                    vm.roles = data.user_role.definition;
                    localStorage.setItem('userRoles', JSON.stringify(vm.roles));
                    return vm.roles;
                });
            }
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.settings')
        .controller('EditUserDialogController', EditUserDialogController);

    /** @ngInject */
    function EditUserDialogController($mdDialog, callback, api, $localStorage, $http, user, UserService, CityService, $rootScope, FormFieldService, BaseService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.editUser = editUser;
        vm.selectBase = selectBase;

        vm.dialogTitle = "Edit User";
        vm.apiErrors = {};
        vm.branches = [];
        vm.user = {
            base_id: user.base_id || -1,
            branch_id: user.branch_id || -1,
            firstname: user.firstname,
            lastname: user.lastname,
            email: user.email,
            username: user.username,
            roles: user.roles,
            country_code: user.country_code ? user.country_code : null,
        };

        vm.countrys = [
            { id: "PH", name: "Philippines" },
            { id: "GM", name: "Guatemala" },
            { id: "UG", name: "Uganda" },
            { id: "BU", name: "Burundi" },
            { id: "KH", name: "Cambodia" },
        ]

        activate();

        /*
        Function used to fetch user roles and bases
         */
        function activate() {
            getUserRoles();
            if (vm.user.country_code) {
                getBases();
            }
        }

        /*
        Function used to fetch all bases
         */
        function getBases() {
            BaseService
                .getBases({ nopage: 1, country_code: vm.user.country_code, with: "branches" })
                .then(function (data) {
                    vm.bases = data;

                    var base = data.filter(function (item) {
                        return item.id == vm.user.base_id;
                    }).shift();
                    vm.branches = base ? base.branches : [];
                });
        }

        vm.handleCountryChange = function (country_code) {
            BaseService.getBases({
                nopage: 1,
                country_code: country_code,
                with: "branches"
            })
                .then(function (data) {
                    vm.user.base_id = -1;
                    vm.user.branch_id = -1;

                    vm.bases = data;

                    var base = data.filter(function (item) {
                        return item.id == vm.user.base_id;
                    }).shift();
                    vm.branches = base ? base.branches : [];
                });
        }


        function selectBase(base) {
            vm.branches = base.branches;
            vm.user.branch_id = -1;
        }

        /*
        Function used to edit a user
         */
        function editUser(data, form) {
            if (data.role !== user.roles[0]) {
                var agree = confirm("Please note that changing the user's role will destroy his association with other tables like the communities table. Are you sure you want to continue?");

                if (!agree) {
                    return false;
                }
            }
            vm.saving = true;
            var userObject = {};
            userObject.id = user.id;
            userObject.base_id = data.base_id > 0 ? data.base_id : null;
            userObject.branch_id = data.branch_id > 0 ? data.branch_id : null;
            userObject.firstname = data.firstname;
            userObject.lastname = data.lastname;
            userObject.email = data.email;
            userObject.username = data.username;
            userObject.country_code = data.country_code;
            userObject.roles = [data.role];

            vm.apiErrors = [];

            if (data.password) {
                userObject.password = data.password;
                userObject.password_confirmation = data.confirmPassword;
            }

            return UserService.editUser(userObject)
                .then(function (data) {
                    vm.saving = false;
                    callback();

                    if ($rootScope.currentUser.id === user.id) {
                        $rootScope.updateDisplayName(data);

                        $http(api.user.refreshToken()).then(function (data) {
                            var token = data.data.token;
                            if (token) {
                                $localStorage.currentUser.token = '';
                                $localStorage.currentUser.token = token;

                                $http.defaults.headers.common.Authorization = 'Bearer' + token;
                            }
                        });
                    }
                    closeDialog();
                })
                .catch(function (response) {
                    vm.saving = false;
                    form.$invalid = true;

                    for (var field in response.data.errors) {
                        vm.apiErrors[field] = response.data.errors[field].shift();
                    }
                });
        }

        /*
        Function used to fetch user roles
         */
        function getUserRoles() {
            return FormFieldService.getFields().then(function (data) {
                vm.roles = data.user_role.definition;
                vm.user.role = vm.roles[vm.user.roles[0]].value;
            });
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function ()
{
    'use strict';

    angular.module('app.settings')
        .controller('DeleteUserDialogController', DeleteUserDialogController);

    /** @ngInject */
    function DeleteUserDialogController($mdDialog, $document, activate, user, UserService)
    {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.deleteCallback = deleteCallback;

        vm.dialogTitle = "Delete User";
        vm.message = 'Are you sure to delete this user?';
        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteCallback(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to delete a user
         */
        function deleteCallback() {
            vm.saving = true;
            return UserService.deleteUser(user)
                .then( function () {
                    vm.saving = false;
                    activate();
                    closeDialog();
                });
        }

        /*
        Function to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.settings')
        .controller('ProgramDialogController', ProgramDialogController);

    /** @ngInject */
    function ProgramDialogController($mdDialog, initProgramsTable, $filter, programObj, ProgramService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.saveProgram = saveProgram;
        vm.loading = false;
        vm.programs = [];

        function init () {
            vm.loading = true;
            ProgramService.getPrograms({ noPage: true })
                .then(function (programs) {
                  vm.loading = false;
                  vm.programs = programs.data;
                });
        }
        init();

        if (programObj) {
            vm.dialogTitle = "Edit Program";

            vm.program = {
                id: programObj.id,
                parent_program_id: programObj.parent_program_id,
                name: programObj.name,
                has_16th_week: programObj.has_16th_week,
                active: programObj.active
            };
        } else {
            vm.dialogTitle = "New Program";
            vm.program = {};
        }

        /*
        Function used to save program details
         */
        function saveProgram(program) {
            vm.saving = true;

            if (program.parent_program_id <= 0) {
              program.parent_program_id = null;
            }

            if (programObj) {
                return ProgramService.editProgram(program)
                    .then(onComplete);
            } else {
                return ProgramService.addProgram(program)
                    .then(onComplete);
            }
        }

        /*
        Function triggered after saving program details
         */
        function onComplete() {
            vm.saving = false;
            initProgramsTable();
            closeDialog();
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.settings')
        .controller('DeleteProgramDialogController', DeleteProgramDialogController);

    /** @ngInject */
    function DeleteProgramDialogController($mdDialog, $document, initProgramsTable, program, ProgramService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.deleteCallback = deleteCallback;

        vm.dialogTitle = "Delete Program";
        vm.message = 'Are you sure to delete this program?';
        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteCallback(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to delete a program
         */
        function deleteCallback() {
            vm.saving = true;
            return ProgramService.deleteProgram(program)
                .then(function () {
                    vm.saving = false;
                    initProgramsTable();
                    closeDialog();
                });
        }

        /*
        Function used to close a dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.settings')
        .controller('DonorDialogController', DonorDialogController);

    /** @ngInject */
    function DonorDialogController($mdDialog, initDonorsTable, $filter, donorObj, DonorService) {
        var vm         = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.saveDonor = saveDonor;

        if(donorObj) {
            vm.dialogTitle = "Edit Donor";
            vm.donor = {
                id: donorObj.id,
                name: donorObj.name
            };
        } else {
            vm.dialogTitle   = "New Donor";
            vm.donor = {};
        }

        /*
        Function used to save donor details
         */
        function saveDonor(donor) {
            vm.saving = true;

            if(donorObj) {

                return DonorService.editDonor(donor)
                    .then(onComplete);
            } else {
                return DonorService.addDonor(donor)
                    .then(onComplete);
            }
        }

        /*
        Function triggered after saving donor details
         */
        function onComplete() {
            vm.saving = false;
            initDonorsTable();
            closeDialog();
        }

        /*
        Function to close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.settings')
        .controller('DeleteDonorDialogController', DeleteDonorDialogController);

    /** @ngInject */
    function DeleteDonorDialogController($mdDialog,
                                         $document,
                                         initDonorsTable,
                                         donor,
                                         DonorService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.deleteCallback = deleteCallback;

        vm.dialogTitle = "Delete Donor";
        vm.message = 'Are you sure to delete this donor?';
        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteCallback(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to delete a donor
         */
        function deleteCallback() {
            vm.saving = true;
            return DonorService.deleteDonor(donor)
                .then(function () {
                    vm.saving = false;
                    initDonorsTable();
                    closeDialog();
                });
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.settings')
        .controller('ProductDialogController', ProductDialogController);

    /** @ngInject */
    function ProductDialogController($mdDialog,
        initProductsTable,
        $filter,
        productObj,
        ProductService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.saveProduct = saveProduct;
        vm.repaymentValue = repaymentValue;
        vm.handleChangeCheck = handleChangeCheck;
        vm.repayment = true;


        function repaymentValue() {
            if (productObj.repayment == true) {
                // productObj.repayment = productObj.repayment == 1 ? vm.repayment = true : vm.repayment = false;
                console.log('nothing change ');
            }
            else if (productObj.repayment == false) {
                // productObj.repayment = productObj.repayment == 0 ? vm.repayment = true : vm.repayment = false;
                console.log('nothing change')
            }
            else if (productObj.repayment == 0 || productObj.repayment == 1) {
                productObj.repayment = productObj.repayment == 0 ? vm.repayment = false : vm.repayment = true;
            }

        }

        // }
        // if (!productObj && productObj.repayment == undefined) {
        //     productObj.repayment = false;
        // productObj.repayment = productObj.repayment == 0 ? true : false;
        // }


        if (productObj) {
            if (productObj.repayment == 1) {
                vm.repayment = true;
            }
            else {
                vm.repayment = false;
            }
            vm.dialogTitle = "Edit Product";
            vm.product = {
                id: productObj.id,
                repayment: productObj.repayment,
                name: productObj.name,
            };
        } else {
            vm.dialogTitle = "New Product";
            vm.product = {};
        }

        // Funtion used for repayment  
        function handleChangeCheck(e) {
            if (!e) {
                e = 1
                vm.product.repayment = e;
            } else {
                e = 0
                vm.product.repayment = e;
            }
        }

        /*
        Function used to save product (add/edit)
         */
        function saveProduct(product) {
            vm.saving = true;
            if (productObj) {
                return ProductService.editProduct(product)
                    .then(onComplete);
            } else {
                return ProductService.addProduct(product)
                    .then(onComplete);
            }
        }

        /*
        Function triggered after saving product details
         */
        function onComplete() {
            vm.saving = false;
            initProductsTable();
            closeDialog();
        }

        /*
        Function to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function ()
{
    'use strict';

    angular.module('app.settings')
        .controller('DeleteProductDialogController', DeleteProductDialogController);

    /** @ngInject */
    function DeleteProductDialogController($mdDialog, $document, initProductsTable, product, ProductService)
    {
        var vm           = this;

        //Methods
        vm.closeDialog   = closeDialog;
        vm.deleteProduct = deleteProduct;
        
        vm.dialogTitle   = "Delete Product";

        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteProduct(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function to delete product
         */
        function deleteProduct() {
            vm.saving = true;
            return ProductService.deleteProduct(product)
                .then( function () {
                    vm.saving = false;
                    initProductsTable();
                    closeDialog();
                });
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.settings')
        .controller('NewBatchDialogController', NewBatchDialogController);

    /** @ngInject */
    function NewBatchDialogController($mdDialog, initBatchesTable, BatchService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.addNewBatch = addNewBatch;

        vm.dialogTitle = "New Batch";
        vm.apiErrors = {};

        /*
        Function used to add new batch
         */
        function addNewBatch(batch, form) {
            vm.apiErrors = {};
            vm.saving = true;
            batch.start_at = moment(batch.start_at).format();
            if (batch.end_at) batch.end_at = moment(batch.end_at).format();
            return BatchService.addBatch(batch)
                .then(function (response) {
                    vm.saving = false;
                    initBatchesTable();
                    closeDialog();
                }).catch(function (response) {
                    form.$invalid = true;
                    vm.saving = false;

                    for (var field in response.data.errors) {
                        vm.apiErrors[field] = response.data.errors[field].shift();
                    }
                });
        }

        /*
        Function used to close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.settings')
        .controller('EditBatchWeekDialogController', EditBatchWeekDialogController);

    /** @ngInject */
    function EditBatchWeekDialogController(
        $mdDialog,
        initBatchWeeksTable,
        week,
        prevWeek,
        nextWeek,
        BatchWeekService
    ) {
        var vm = this;

        //Methods
        vm.closeDialog   = closeDialog;
        vm.editBatchWeek = editBatchWeek;

        vm.dialogTitle   = "Edit Batch Week";
        vm.apiErrors     = {};

        vm.week = {
            id       : week.id,
            batch_id : week.batch_id,
            week     : week.week,
            start_at : new Date(week.start_at),
            end_at   : new Date(week.end_at)
        };

        if (prevWeek) {
            if (prevWeek.end_at) {
                var lastDate = new Date(prevWeek.end_at);
                var nextDate = lastDate;
                nextDate.setDate(lastDate.getDate() + 1);

                vm.min_date = nextDate;
            }
        }

        if (nextWeek) {
            if (nextWeek.end_at) {
                var lastDate = new Date(nextWeek.start_at);
                var nextDate = lastDate;
                nextDate.setDate(lastDate.getDate() - 1);

                vm.max_date = nextDate;
            }
        }

        /*
        Function used to edit a week
         */
        function editBatchWeek(week, form) {
            vm.saving    = true;
            vm.apiErrors = {};

            return BatchWeekService.editBatchWeek(week)
                .then(function (data) {
                    vm.saving = false;

                    initBatchWeeksTable();
                    closeDialog();
                }).catch(function (response) {
                    form.$invalid = true;
                    vm.saving = false;

                    for (var field in response.data.errors) {
                        vm.apiErrors[field] = response.data.errors[field].shift();
                    }
                });
        }

        /*
        Function used to close a dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.settings')
        .controller('EditBatchDialogController', EditBatchDialogController);

    /** @ngInject */
    function EditBatchDialogController($mdDialog, initBatchesTable, batch, BatchService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.editBatch = editBatch;

        vm.dialogTitle = "Edit Batch";
        vm.apiErrors = {};

        vm.batch = {
            id: batch.id,
            batch_no: batch.batch_no,
            start_at: batch.start_at,
            stream_no: batch.stream_no,
            stream_name: batch.stream_name,
            fiscal_year: batch.fiscal_year,
            end_year: batch.end_year,
            end_at: batch.end_at
        };

        /*
        Function used to edit a batch
         */
        function editBatch(batch, form) {
            vm.saving = true;
            if (!batch.end_at) {
                delete batch.end_at;
            }
            vm.apiErrors = {};

            return BatchService.editBatch(batch)
                .then(function (data) {
                    vm.saving = false;
                    initBatchesTable();
                    closeDialog();
                }).catch(function (response) {
                    form.$invalid = true;
                    vm.saving = false;

                    for (var field in response.data.errors) {
                        vm.apiErrors[field] = response.data.errors[field].shift();
                    }
                });
        }

        /*
        Function used to close a dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.settings')
        .controller('DeleteBatchWeekDialogController', DeleteBatchWeekDialogController);

    /** @ngInject */
    function DeleteBatchWeekDialogController($mdDialog,
                                         $document,
                                         initBatchWeeksTable,
                                         week,
                                         BatchWeekService) {
        var vm = this;

        //Methods
        vm.closeDialog    = closeDialog;
        vm.deleteCallback = deleteCallback;

        vm.dialogTitle    = "Delete BatchWeek";
        vm.message        = 'Are you sure to delete this batch week?';
        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteCallback(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to delete a week
         */
        function deleteCallback() {
            vm.saving = true;
            return BatchWeekService.deleteBatchWeek(week)
                .then(function () {
                    vm.saving = false;
                    initBatchWeeksTable();
                    closeDialog();
                });
        }

        /*
        Function used to close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.settings')
        .controller('DeleteBatchDialogController', DeleteBatchDialogController);

    /** @ngInject */
    function DeleteBatchDialogController($mdDialog,
                                         $document,
                                         initBatchesTable,
                                         batch,
                                         BatchService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.deleteCallback = deleteCallback;

        vm.dialogTitle = "Delete Batch";
        vm.message = 'Are you sure to delete this batch?';
        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteCallback(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to delete a batch
         */
        function deleteCallback() {
            vm.saving = true;
            return BatchService.deleteBatch(batch)
                .then(function () {
                    vm.saving = false;
                    initBatchesTable();
                    closeDialog();
                });
        }

        /*
        Function used to close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.settings')
        .controller('AddBatchWeekDialogController', AddBatchWeekDialogController);

    /** @ngInject */
    function AddBatchWeekDialogController($mdDialog, batch, lastWeek, initBatchWeeksTable, BatchWeekService) {
        var vm = this;

        //Methods
        vm.closeDialog     = closeDialog;
        vm.addNewBatchWeek = addNewBatchWeek;

        vm.dialogTitle     = "New BatchWeek";
        vm.apiErrors       = {};
        vm.lastWeek        = lastWeek;
        vm.week            = {
            batch_id : batch.id
        }

        if (vm.lastWeek.end_at) {
            var lastDate = new Date(vm.lastWeek.end_at);
            var nextDate = lastDate;

            nextDate.setDate(lastDate.getDate() + 1);
            vm.lastWeek.end_at = nextDate;
            vm.week.start_at   = nextDate;
        }

        if (vm.lastWeek.week) {
            vm.lastWeek.week += 1;
        } else {
            vm.lastWeek.week = 1;
        }
        vm.week.week = vm.lastWeek.week;

        /*
        Function used to add new week
         */
        function addNewBatchWeek(week, form) {
            vm.apiErrors  = {};
            vm.saving     = true;
            week.start_at = moment(week.start_at).format();
            week.end_at   = moment(week.end_at).format();

            return BatchWeekService.addBatchWeek(week)
                .then(function (response) {
                    vm.saving = false;

                    initBatchWeeksTable();
                    closeDialog();
                }).catch(function (response) {
                    form.$invalid = true;
                    vm.saving     = false;

                    for (var field in response.data.errors) {
                        vm.apiErrors[field] = response.data.errors[field].shift();
                    }
                });
        }

        /*
        Function used to close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .controller('BatchWeekContentController', BatchWeekContentController);

    /** @ngInject */
    function BatchWeekContentController(
        $scope,
        $mdBottomSheet,
        $mdDialog,
        $document,
        BatchWeekService,
        batch
    )
    {
        var vm            = this;
        vm.batch          = batch;
        vm.isLoading      = false;
        vm.weeks          = [];

        //Methods
        vm.addWeek        = addWeek;
        vm.editWeek       = editWeek;
        vm.deleteWeek     = deleteWeek;
        vm.closeBatchWeek = closeBatchWeek;
        vm.stateChange    = stateChange;

        $('.content-white-holder').addClass('bcopen');

        //listen for state change
        $scope.$on('$stateChangeStart', function () {
            vm.stateChange();
        });

        /*
        Function that populates deleted applications table
         */
        function initBatchWeeks() {
            getBatchWeeks();
        }

        initBatchWeeks();

        //executed after listening to state change
        function stateChange() {
            closeBatchWeek();
        }

        /*
        Get the batch weeks
         */
        function getBatchWeeks() {
            BatchWeekService.getBatchWeeks({
                batch_id : vm.batch.id,
                nopage   : true
            })
                .then(function(results) {
                    vm.weeks = results;
                });
        }

        /*
        Function that shows permanent add week
         */
        function addWeek() {
            var lastWeek = {};
            if (vm.weeks.length) {
                lastWeek = angular.copy(vm.weeks[vm.weeks.length - 1]);
            }

            $mdDialog.show({
                controller: 'AddBatchWeekDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/transform/tabs/batches/dialogs/add-batch-week/add-batch-week.html',
                parent: angular.element($document.body),
                locals: {
                    batch               : vm.batch,
                    lastWeek            : lastWeek,
                    initBatchWeeksTable : initBatchWeeks
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that shows permanent edit week
         */
        function editWeek(weeks, index) {
            var week     = weeks[index];
            var prevWeek = weeks[index - 1] || null;
            var nextWeek = weeks[index + 1] || null;

            $mdDialog.show({
                controller: 'EditBatchWeekDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/transform/tabs/batches/dialogs/edit-batch-week/edit-batch-week.html',
                parent: angular.element($document.body),
                locals: {
                    week                : week || null,
                    prevWeek            : prevWeek,
                    nextWeek            : nextWeek,
                    initBatchWeeksTable : initBatchWeeks
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that shows permanent delete week
         */
        function deleteWeek(week) {
            $mdDialog.show({
                controller: 'DeleteBatchWeekDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    week: week || null,
                    initBatchWeeksTable: initBatchWeeks
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that closes deleted applications bottom sheet
         */
        function closeBatchWeek() {
            $mdBottomSheet.hide();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.changelogs', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider
            .state('app.changelogs', {
                abstract: true,
                url: '/changelogs/settings',
                data: {
                    selectedTab: 1
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/settings/changelogs/changelogs-settings.html',
                        controller: 'ChangelogsSettingsController as vm'
                    }
                }
            })
            .state('app.changelogs.changelogs', {
                url: '/changelogs',
                data: {
                    selectedTab: 1
                },
                views: {
                    'settings@changelogs': {
                        templateUrl: 'app/main/settings/changelogs/tabs/changelogs/changelogs.html',
                        controller: 'ChangelogsController as vm'
                    }
                }
            })
            .state('app.changelogs.apiErrors', {
                url: '/data-conflicts',
                data: {
                    selectedTab: 2
                },
                views: {
                    'settings@apiErrors': {
                        templateUrl: 'app/main/settings/changelogs/tabs/api-errors/api-errors.html',
                        controller: 'ApiErrorsController as vm'
                    }
                }
            })
            .state('app.changelogs.activeusers', {
                url: '/active-users',
                data: {
                    selectedTab: 3
                },
                views: {
                    'settings@activeusers': {
                        templateUrl: 'app/main/settings/changelogs/tabs/active-users/activeusers.html',
                        controller: 'ActiveUsersController as vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular.module('app.changelogs')
        .controller('ViewChangelogDialogController', ViewChangelogDialogController);

    /** @ngInject */
    function ViewChangelogDialogController($mdDialog, changelog) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.changelog = changelog;

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.changelogs')
        .controller('DeleteChangelogDialogController', DeleteChangelogDialogController);

    /** @ngInject */
    function DeleteChangelogDialogController($mdDialog, $document, ChangelogService, changelog, callback) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;

        vm.dialogTitle = "Delete Changelog";
        vm.message = 'Are you sure you want to delete this changelog?';

        vm.deleteCallback = deleteCallback;
        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteCallback(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to delete a changelog
         */
        function deleteCallback() {
            vm.saving = true;
            return ChangelogService.deleteChangelog(changelog)
                .then(function () {
                    vm.saving = false;
                    callback();
                    closeDialog();
                });
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.changelogs')
        .controller('ViewApiErrorDialogController', ViewApiErrorDialogController);

    /** @ngInject */
    function ViewApiErrorDialogController($mdDialog, apiError) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.apiError = apiError;

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.changelogs')
        .controller('DeleteApiErrorDialogController', DeleteApiErrorDialogController);

    /** @ngInject */
    function DeleteApiErrorDialogController($mdDialog, $document, ApiErrorService, item, callback) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;

        vm.dialogTitle = "Delete ApiError";
        vm.message = 'Are you sure you want to delete this item?';
        vm.deleteCallback = deleteCallback;
        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteCallback(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to delete a item
         */
        function deleteCallback() {
            vm.saving = true;
            return ApiErrorService.deleteApiError(item)
                .then(function () {
                    vm.saving = false;
                    callback();
                    closeDialog();
                });
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.changelogs')
        .controller('TotalDownloadsController', TotalDownloadsController);

    /**   @ngInject */
    function TotalDownloadsController(
        $mdBottomSheet,
        is_unique_users,
        Auth,
        UserService
    ) {
        var vm = this;
        vm.isLoading = true;
        var currentUser = Auth.getUser();
        vm.filters = {};

        //Methods
        vm.is_unique_users = Boolean(is_unique_users);
        vm.totalDownloads = [];
        vm.totalUniqueUsers = [];
        vm.closeSheet = closeSheet;
        vm.initTotalDownloads = initTotalDownloads
        vm.pageChange = pageChange;

        if (!vm.is_unique_users) {
            initTotalDownloads();
        } else {
            initTotalUniqueUsers();
        }

        function initTotalDownloads(query) {
            vm.isLoading = true;
            UserService.fetchTotalDownloads(query)
                .then(function (users) {
                    if (users) {
                        users.data = users.data.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));
                    }
                    vm.totalDownloads = users;
                    vm.isLoading = false;
                })
                .catch(function () {
                    vm.isLoading = false;
                });
        }

        function initTotalUniqueUsers(query) {
            vm.isLoading = true;
            UserService.fetchUniqueUsers(query)
                .then(function (users) {
                    vm.totalUniqueUsers = users;
                    vm.isLoading = false;
                })
                .catch(function () {
                    vm.isLoading = false;
                });
        }

        
        /*
        Function triggered when pagination changes page
        */
        function pageChange(page) {
            var payload = buildPayload({ 'page': page });

            //    initActiveUsersTable(payload);
        }

        /*
        Build the request payload.
        */
        function buildPayload(filters) {
            var filters = angular.extend({}, vm.filters, filters);
            var payload = {}

            payload.page = filters.page;

            return payload;
        }


        /*
        Function that closes deleted applications bottom sheet
         */
        function closeSheet() {
            $mdBottomSheet.hide();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.prevailsettings', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider
            .state('app.prevail.settings', {
                abstract: true,
                url: '/settings',
                data: {
                    selectedTab: 1
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/settings/prevail/prevailsettings.html',
                        controller: 'PrevailSettingsController as vm'
                    }
                }
            })
            .state('app.prevail.settings.partners', {
                url: '/partners',
                data: {
                    selectedTab: 1
                },
                views: {
                    'settings@partners': {
                        templateUrl: 'app/main/settings/prevail/tabs/partners/partners.html',
                        controller: 'PartnersController as vm'
                    }
                }
            })
            .state('app.prevail.settings.clusters', {
                url: '/clusters',
                data: {
                    selectedTab: 2
                },
                views: {
                    'settings@clusters': {
                        templateUrl: 'app/main/settings/prevail/tabs/clusters/clusters.html',
                        controller: 'ClustersController as vm'
                    }
                }
            })
            .state('app.prevail.settings.smallGroups', {
                url: '/small-group',
                data: {
                    selectedTab: 3
                },
                views: {
                    'settings@smallGroups': {
                        templateUrl: 'app/main/settings/prevail/tabs/small-group/small-group.html',
                        controller: 'SmallGroupsController as vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular.module('app.prevailsettings')
        .controller('DeleteSmallGroupDialogController', DeleteSmallGroupDialogController);

    /** @ngInject */
    function DeleteSmallGroupDialogController($mdDialog,
        $document,
        initSmallGroupsTable,
        smallGroup,
        SmallGroupService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.deleteCallback = deleteCallback;

        vm.dialogTitle = "Delete Small Group";
        vm.message = 'Are you sure you want to delete this small group?';
        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteCallback(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to delete a small group
         */
        function deleteCallback() {
            vm.saving = true;
            return SmallGroupService.deleteSmallGroup(smallGroup)
                .then(function () {
                    vm.saving = false;
                    initSmallGroupsTable();
                    closeDialog();
                });
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.prevailsettings')
        .controller('SaveSmallGroupDialogController', SaveSmallGroupDialogController);

    /** @ngInject */
    function SaveSmallGroupDialogController($mdDialog,
        initSmallGroupsTable,
        smallGroup,
        Auth,
        ClusterService,
        BaseService,
        SmallGroupService) {
        var vm = this;

        var currentUser = Auth.getUser();

        //Methods
        vm.closeDialog = closeDialog;
        vm.saveSmallGroup = saveSmallGroup;
        vm.isBaseChangeRun = false;

        vm.apiErrors = {};

        if (smallGroup) {
            vm.dialogTitle = "Edit Small Group";

            vm.smallGroup = {
                id: smallGroup.id,
                name: smallGroup.name,
                base: smallGroup.base ? smallGroup.base : null,
            };
        } else {
            vm.dialogTitle = 'New Small Group';
            vm.smallGroup = {};
        }

        vm.selectedClusterName = (smallGroup && smallGroup.cluster) ? smallGroup.cluster : null;
        vm.searchClusterName = null;
        vm.selectClusterName = selectClusterName;
        vm.searchClusterChange = searchClusterChange;
        vm.searchClusterNames = searchClusterNames;

        if (smallGroup && smallGroup.cluster) {
            selectClusterName(smallGroup.cluster);
            vm.smallGroup.base = smallGroup.cluster.branch ? (smallGroup.cluster.branch.base ? smallGroup.cluster.branch.base : null) : null;
        }

        //get all bases if the user has no base id
        BaseService.getBases({
            nopage: true,
            base_id: currentUser.base_id,
        }).then(function (bases) {
            vm.bases = bases;
        });

        vm.baseChange = function (base) {

            if (smallGroup && !smallGroup.base) {
                vm.isBaseChangeRun = true;
            }

            if (vm.isBaseChangeRun) {
                vm.selectedClusterName = null;
            }

            if (!smallGroup) {
                vm.selectedClusterName = null;
            }

            vm.isBaseChangeRun = true;
        }

        /*
        Function that assigns a cluster to the application
         */
        function selectClusterName(cluster) {
            if (cluster) {
                vm.selectedClusterName = cluster;
                vm.smallGroup.cluster_id = cluster.id;
            } else {
                vm.selectedClusterName = null;
                vm.smallGroup.cluster_id = null;
            }
        }

        /*
        Function that listens for cluster text change
        */
        function searchClusterChange(cluster) {
            vm.searchClusterName = cluster ? cluster : null;
        }

        /*
        Function that search base by search text
        */
        function searchClusterNames(query) {
            return ClusterService.getClusters({
                search: query,
                base_id: vm.smallGroup.base ? vm.smallGroup.base.id : null,
                nopage: true,
            });
        }

        /*
        Function that saves smallGroup details
         */
        function saveSmallGroup(group) {
            vm.saving = true;
            vm.apiErrors = [];

            var data = {
                cluster_id: group.cluster_id ? group.cluster_id : null,
                name: group.name
            };

            if (smallGroup) {
                data.id = smallGroup.id;
                return SmallGroupService.editSmallGroup(data)
                    .then(onComplete).catch(() => {
                        vm.saving = false;
                    });
            } else {
                return SmallGroupService.addSmallGroup(data)
                    .then(onComplete).catch(() => {
                        vm.saving = false;
                    });
            }
        }

        /*
        Function triggered after successfully savings smallGroup details
         */
        function onComplete() {
            vm.saving = false;
            initSmallGroupsTable();
            closeDialog();
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.prevailsettings')
        .controller('PartnerDialogController', PartnerDialogController);

    /** @ngInject */
    function PartnerDialogController($mdDialog,
                                         initPartnersTable,
                                         partnerObj,
                                         PartnerService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.savePartner = savePartner;

        if (partnerObj) {
            vm.dialogTitle = "Edit Partner";

            vm.partner = {
                id: partnerObj.id,
                name: partnerObj.name,
                no_of_months: partnerObj.no_of_months
            };
        } else {
            vm.dialogTitle = "New Partner";
            vm.partner = {};
        }

        /*
        Function used to save partner details
         */
        function savePartner(partner) {
            vm.saving = true;

            if (partnerObj) {
                return PartnerService.editPartner(partner)
                    .then(onComplete);
            } else {
                return PartnerService.addPartner(partner)
                    .then(onComplete);
            }
        }

        /*
        Function triggered after saving partner details
         */
        function onComplete() {
            vm.saving = false;
            initPartnersTable();
            closeDialog();
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.prevailsettings')
        .controller('DeletePartnerDialogController', DeletePartnerDialogController);

    /** @ngInject */
    function DeletePartnerDialogController($mdDialog,
                                        $document,
                                        initPartnersTable,
                                        partner,
                                        PartnerService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.deleteCallback = deleteCallback;

        vm.dialogTitle = "Delete Partner";
        vm.message = 'Are you sure you want to delete this partner?';
        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteCallback(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to delete a partner
         */
        function deleteCallback() {
            vm.saving = true;
            return PartnerService.deletePartner(partner)
                .then(function () {
                    vm.saving = false;
                    initPartnersTable();
                    closeDialog();
                });
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.prevailsettings')
        .controller('DeleteClusterDialogController', DeleteClusterDialogController);

    /** @ngInject */
    function DeleteClusterDialogController($mdDialog,
                                           $document,
                                           initClustersTable,
                                           cluster,
                                           ClusterService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.deleteCallback = deleteCallback;

        vm.dialogTitle = "Delete Cluster";
        vm.message = 'Are you sure you want to delete this cluster?';
        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteCallback(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to delete a cluster
         */
        function deleteCallback() {
            vm.saving = true;
            return ClusterService.deleteCluster(cluster)
                .then(function () {
                    vm.saving = false;
                    initClustersTable();
                    closeDialog();
                });
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.prevailsettings')
        .controller('ClusterDialogController', ClusterDialogController);

    /** @ngInject */
    function ClusterDialogController($mdDialog,
                                     initClustersTable,
                                     clusterObj,
                                     Auth,
                                     $timeout,
                                     BaseService,
                                     ClusterService) {
        var vm = this;

        var currentUser = Auth.getUser();

        //Methods
        vm.closeDialog = closeDialog;
        vm.saveCluster = saveCluster;
        vm.selectBase = selectBase;

        vm.apiErrors = {};

        if (clusterObj) {
            vm.dialogTitle = "Edit Cluster";

            vm.cluster = {
                id: clusterObj.id,
                base: clusterObj.branch.base,
                branch: clusterObj.branch,
                name: clusterObj.name
            };

            vm.baseCopy = angular.copy(vm.cluster.base);
        } else {
            vm.dialogTitle = 'New Cluster';
            vm.cluster = {};
        }

        function selectBase(cluster) {
            if(vm.baseCopy && vm.baseCopy.id !== vm.cluster.base.id) {
                cluster.branch = {};
            }
            vm.baseCopy = angular.copy(cluster);
        }

        //get all bases if the user has no base id
        BaseService.getBases({
            nopage: true,
            base_id: currentUser.base_id,
            with: 'branches'
        }).then(function (bases) {
            vm.bases = bases;
        });

        /*
        Function that saves cluster details
         */
        function saveCluster(cluster) {
            vm.saving = true;
            vm.apiErrors = [];

            var clusterObject = {
                base_id: cluster.base.id,
                branch_id: cluster.branch.id,
                name: cluster.name
            };

            if (clusterObj) {
                clusterObject.id = cluster.id;
                return ClusterService.editCluster(clusterObject)
                    .then(onComplete);
            } else {
                return ClusterService.addCluster(clusterObject)
                    .then(onComplete);
            }
        }

        /*
        Function triggered after successfully savings cluster details
         */
        function onComplete() {
            vm.saving = false;
            initClustersTable();
            closeDialog();
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.community', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider
            .state('app.community', {
                abstract: true,
                url: '/community/{id}',

                data: {
                    selectedTab: 0
                },
                defaultChild: 'app.community.attendance',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/community/community.html',
                        controller: 'CommunityController as vm'
                    }
                }
            })
            .state('app.community.attendance', {
                url: '/attendance',

                data: {
                    selectedTab: 0
                },
                views: {
                    'community@attendance': {
                        templateUrl: 'app/main/community/tabs/attendance/attendance.html',
                        controller: 'AttendanceController as vm'
                    }
                }
            })
            .state('app.community.weekly', {
                url: '/weekly',

                data: {
                    selectedTab: 1
                },
                views: {
                    'community@weekly': {
                        templateUrl: 'app/main/community/tabs/weekly/weekly.html',
                        controller: 'WeeklyController as vm'
                    }
                }
            })
            .state('app.community.bib', {
                url: '/bib',

                data: {
                    selectedTab: 2
                },
                views: {
                    'community@bib': {
                        templateUrl: 'app/main/community/tabs/bib/bib.html',
                        controller: 'BibController as vm'
                    }
                }
            })
            .state('app.community.bib.participants', {
                url: '/{bibid}/participants',
                data: {
                    selectedTab: 2
                },
                controller: 'BibController',
                controllerAs: 'vm'
            })
            .state('app.community.hbf', {
                url: '/hbf',

                data: {
                    selectedTab: 3
                },
                views: {
                    'community@hbf': {
                        templateUrl: 'app/main/community/tabs/hbf/hbf.html',
                        controller: 'HbfController as vm'
                    }
                }
            })
            .state('app.community.hbf.details', {
                url: '/{hbfid}/details',

                data: {
                    selectedTab: 3
                },
                controllerAs: 'vm',
                controller: 'HbfController'
            })
            .state('app.community.savings', {
                url: '/savings',

                data: {
                    selectedTab: 4
                },
                views: {
                    'community@savings': {
                        templateUrl: 'app/main/community/tabs/savings/savings.html',
                        controller: 'SavingsController as vm'
                    }
                }
            })
            .state('app.community.savings.details', {
                url: '/{savingsId}/details',

                data: {
                    selectedTab: 4
                },
                controllerAs: 'vm',
                controller: 'SavingsGroupDetailsController'
            })
            .state('app.community.business-loans', {
                url: '/business-loans',

                data: {
                    selectedTab: 5
                },
                views: {
                    'community@business-loans': {
                        templateUrl: 'app/main/community/tabs/business-loans/business-loans.html',
                        controller: 'BusinessLoansController as vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular.module('app.community')
        .controller('AddBibPastortDialogController', AddBibPastortDialogController);

    /** @ngInject */
    function AddBibPastortDialogController($mdDialog,
        BibParticipantService,
        initBibParticipants,
        participants,
        bib) {
        var vm = this;

        vm.bib = bib;

        //Methods
        vm.closeDialog = closeDialog;
        vm.addParticipant = addParticipant;

        vm.dialogTitle = "Add Pastor";
        vm.apiErrors = {};

        vm.types = [
            { label: "Individual", value: "individual" },
            { label: "Group", value: "group" }
        ];

        vm.pastor = [
            {
                label: bib.community.application.pastor.fullname,
                value: bib.community.application.pastor.fullname
            }
        ];

        vm.participants = participants;

        /*
        Function to add participant in bib
         */
        function addParticipant(data, bib, form) {
            vm.saving = true;
            var participant = {
                community_bib_id: bib.id,
                pastor_id: bib.community.application.pastor_id,
                base_capital: data.base_capital,
                kits: data.kits,
                type: data.type
            };

            vm.apiErrors = [];

            BibParticipantService.addBibParticipant(participant)
                .then(function () {
                    vm.saving = false;
                    initBibParticipants();
                    closeDialog();
                })
                .catch(function (response) {
                    form.$invalid = true;

                    for (var field in response.data.errors) {
                        vm.apiErrors[field] = response.data.errors[field].shift();
                    }
                });
        }

        /*
        Function to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.transform', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.transform', {
                abstract: true,
                url: '/transform',
                data: {
                    selectedTab: 0
                },
                defaultChild: 'app.transform.applications',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/transform/transform.html',
                        controller: 'TransformController as vm'
                    }
                }
            })
            .state('app.transform.applications', {
                url: '/applications',
                data: {
                    selectedTab: 0
                },
                views: {
                    'transform@applications': {
                        templateUrl: 'app/main/transform/tabs/applications/applications.html',
                        controller: 'ApplicationsController as vm'
                    }
                }
            })
            .state('app.transform.applications.archives', {
                url: '/archives',
                data: {
                    selectedTab: 0
                },
                controller: 'ApplicationsController',
                controllerAs: 'vm'
            })
            .state('app.transform.approval-lists', {
                url: '/approval-lists',
                data: {
                    selectedTab: 1
                },
                views: {
                    'transform@approval-list': {
                        templateUrl: 'app/main/transform/tabs/approval-lists/approval-lists.html',
                        controller: 'ApprovalListsController as vm'
                    }
                }
            })
            .state('app.transform.approval-lists.participants', {
                url: '/{id}/participants',
                data: {
                    selectedTab: 1
                },
                controller: 'ApprovalListsController',
                controllerAs: 'vm'
            })
            .state('app.transform.community-lists', {
                url: '/community-lists',
                data: {
                    selectedTab: 2
                },
                views: {
                    'transform@community-lists': {
                        templateUrl: 'app/main/transform/tabs/community-lists/community-lists.html',
                        controller: 'CommunityListsController as vm'
                    }
                }
            })
            .state('app.transform.reports', {
                url: '/reports',
                data: {
                    selectedTab: 3
                },
                views: {
                    'transform@reports': {
                        templateUrl: 'app/main/transform/tabs/reports/reports.html',
                        controller: 'ReportsController as vm'
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/transform');

        // Api
        msApiProvider.register('transform', ['app/data/transform/transform.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('fuse', {
            title: '',
            group: true,
            weight: 1
        });

        msNavigationServiceProvider.saveItem('fuse.transform', {
            title: 'Transform',
            icon: 'icon-tile-four',
            state: 'app.transform.applications',
            translate: 'TRANSFORM.TRANSFORM_NAV',
            weight: 1,
            lid: "stlink",
            regex: function (state) {
                return /^app\.(community|transform).*/.test(state);
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app.transform')
        .controller('EditReportTemplateDialogController', EditReportTemplateDialogController);

    /** @ngInject */
    function EditReportTemplateDialogController($mdDialog,
                                                mode,
                                                ReportService,
                                                template,
                                                Auth,
                                                templates) {
        var vm = this;

        var currentUser = Auth.getUser();

        //Methods
        vm.closeDialog = closeDialog;
        vm.editReportTemplate = editReportTemplate;

        vm.apiErrors = {};

        vm.dialogTitle = "Edit Report";

        vm.report = {
            name: template.name
        };

        /*
        Function that saves report template
         */
        function editReportTemplate(report, form) {
            vm.saving = true;
            vm.apiErrors = {};

            var templateObj = {
                id: template.id,
                name: report.name,
                filters: template.filters,
                user_id: currentUser.id
            };

            if (mode === 'transform') {
                templateObj.type = 'transform';
            } else if (mode === 'thrive') {
                templateObj.type = 'thrive';
                templateObj.filters.range = template.report;
            }

            return ReportService.editTemplate(templateObj)
                .then(function (response) {
                    vm.saving = false;
                    templates = templates.map(function (temp) {
                        if (response.data.id === temp.id) {
                            temp.name = response.data.name;
                        }
                    });
                    closeDialog();
                })
                .catch(function (response) {
                    vm.saving = false;
                    form.$invalid = true;

                    for (var field in response.data.errors) {
                        vm.apiErrors[field] = response.data.errors[field].shift();
                    }
                });
        }

        /*
        Function that closes modal dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.transform')
        .controller('DeleteReportTemplateDialogController', DeleteReportTemplateDialogController);

    /** @ngInject */
    function DeleteReportTemplateDialogController($mdDialog,
                                                  $document,
                                                  ReportService,
                                                  template,
                                                  callback) {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.deleteCallback = deleteCallback;
        vm.apiErrors = {};

        vm.dialogTitle = "Delete Report";
        vm.message = 'Are you sure to delete this report template?';

        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteCallback(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that saves report template
         */
        function deleteCallback() {
            vm.saving = true;
            vm.apiErrors = {};

            return ReportService.deleteTemplate(template)
                .then(function () {
                    vm.saving = false;
                    callback();
                    closeDialog();
                })
                .catch(function (response) {
                    vm.saving = false;
                    form.$invalid = true;

                    for (var field in response.data.errors) {
                        vm.apiErrors[field] = response.data.errors[field].shift();
                    }
                });
        }

        /*
        Function that closes modal dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.transform')
        .controller('AddReportTemplateDialogController', AddReportTemplateDialogController);

    /** @ngInject */
    function AddReportTemplateDialogController($mdDialog,
                                               ReportService,
                                               mode,
                                               csvObj,
                                               Auth,
                                               getTemplates) {
        var vm = this;

        var currentUser = Auth.getUser();

        //Methods
        vm.closeDialog = closeDialog;
        vm.addReportTemplate = addReportTemplate;

        vm.apiErrors = {};

        vm.dialogTitle = "Add Report";

        /*
        Function that saves report template
         */
        function addReportTemplate(report, form) {
            vm.saving = true;
            vm.apiErrors = {};

            if (mode === 'transform') {
                var templateObj = {
                    type: 'transform',
                    name: report.name,
                    filters: csvObj,
                    user_id: currentUser.id
                };
            } else if (mode === 'thrive') {
                var templateObj = {
                    type: 'thrive',
                    name: report.name,
                    filters: csvObj,
                    range: csvObj.range,
                    user_id: currentUser.id
                };
            } else if (mode === 'prevail') {
                var templateObj = {
                    type: 'prevail',
                    name: report.name,
                    filters: csvObj,
                    user_id: currentUser.id
                    // range: csvObj.range
                };
            }

            return ReportService.saveTemplate(templateObj)
                .then(function () {
                    vm.saving = false;
                    getTemplates();
                    closeDialog();
                })
                .catch(function (response) {
                    vm.saving = false;
                    form.$invalid = true;

                    for (var field in response.data.errors) {
                        vm.apiErrors[field] = response.data.errors[field].shift();
                    }
                });
        }

        /*
        Function that closes modal dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.transform')
        .controller('ReportPreviewController', ReportPreviewController);

    /** @ngInject */
    function ReportPreviewController(preview,
                                     api,
                                     $scope,
                                     csvUrl,
                                     ReportService,
                                     $mdBottomSheet) {
        var vm = this;


        //listen for state change
        $scope.$on('$stateChangeStart', function () {
            vm.hideSliderCard();
        });

        var htmlObj = {
            'batch_ids[]': preview.batch_ids,
            'base_ids[]': preview.base_ids,
            'programs[]': preview.programs,
            'branch_ids[]': preview.branch_ids,
            'donor_id': preview.donor_id
        };

        if (preview.program_type) {
            htmlObj.program_type = preview.program_type;
        }

        if (preview && preview.cluster_id) htmlObj.cluster_id = preview.cluster_id;
        if (preview && preview.batch_id) htmlObj.batch_id = preview.batch_id;
        if (preview && preview.start_date) htmlObj.start_date = preview.start_date;
        if (preview && preview.end_date) htmlObj.end_date = preview.end_date;
        if (preview && preview.base_id) htmlObj.base_id = preview.base_id;
        if (preview && preview.district_id) htmlObj.district_id = preview.district_id;
        if (preview && preview.branch_id) htmlObj.branch_id = preview.branch_id;
        if (preview && preview.with) htmlObj.with = preview.with;

        vm.reportDate = new Date();
        vm.preview = preview;

        vm.api = api;
        vm.csvUrl = csvUrl;

        vm.hideSliderCard = hideSliderCard;
        vm.drawTable = drawTable;

        activate();

        /*
         This function is triggered first upon show
         */
        function activate() {
            vm.loading = true;
            ReportService.getHTML(htmlObj).then(function (response) {
                vm.loading = false;
                vm.report = response.data.data;
                vm.reportSelect = vm.report.navs ? Object.keys(vm.report.navs)[0] : null;
                vm.table = vm.reportSelect ? vm.report.tables[vm.reportSelect] : null;
                vm.navsLength = vm.report.navs ? Object.keys(vm.report.navs).length : 0;
            }).catch(function (response) {
                if (response.data.code === 404) {
                    vm.navsLength = 0;
                    vm.noData = true;
                }
            });
        }

        /*
        This function plots preview table
         */
        function drawTable(key) {
            vm.table = vm.report.tables[key];
        }

        /*
         This function hides bottom sheet
         */
        function hideSliderCard() {
            $mdBottomSheet.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router'
            ]);
})();
(function () {
    'use strict';

    angular.module('app.core')
        .controller('ParticipantsContentController', ParticipantsContentController);

    /** @ngInject */
    function ParticipantsContentController($scope,
        $mdDialog,
        $state,
        $document,
        $mdBottomSheet,
        ApplicationService,
        ParticipantService,
        application,
        refreshApprovedApplications,
        Auth) {
        var vm = this;
        var currentUser = Auth.getUser();

        vm.$state = $state;
        vm.application = application;

        //Methods
        vm.dropApplication = dropApplication;
        vm.deleteParticipant = deleteParticipant;
        vm.approveApplication = approveApplication;
        vm.changeStatus = changeStatus;
        vm.editParticipant = editParticipant;
        vm.hideSliderCard = hideSliderCard;
        vm.stateChange = stateChange;
        vm.addParticipant = addParticipant;
        vm.issuesDialog = issuesDialog;

        vm.isReplacement = 0;
        vm.useExisting = 0;
        vm.selectedCounselor = null;

        vm.participants = [];

        vm.participant = {};

        var _parent = $scope;
        var rootName = null;
        do {
            if (!_parent.$parent.vm) break;

            rootName = _parent.$parent.vm.constructor.name;
            _parent = _parent.$parent;
        } while (rootName != "TransformController");

        $('.content-white-holder').addClass('bcopen');

        //listen for state change
        $scope.$on('$stateChangeStart', function () {
            vm.stateChange();
        });

        getParticipants();

        vm.participant.toggle = 0;

        /*
        Function that gets all participants in that application
         */
        function getParticipants(application) {
            var application = application || vm.application;
            vm.loadingParticipants = true;

            refreshApplication(application.id).then(function () {
                ParticipantService.getParticipants({
                    application_id: application.id,
                    is_visitor: -1,
                    nopage: true,
                    sort: 'selection_score:desc,firstname:asc',
                    with: 'scorecard,children'
                }).then(function (data) {

                    vm.originals = data.filter(function (participant) {
                        if (participant.type === 'original' || participant.type === 'original_replacement') {
                            return participant;
                        }
                    });

                    vm.counselors = data.filter(function (participant) {
                        if (participant.type === 'counselor' || participant.type === 'counselor_replacement') {
                            return participant;
                        }
                    });

                    vm.loadingParticipants = false;
                });
            });
        }

        function refreshApplication(applicationId) {
            var params = {
                with: 'pastor,pastor.contacts,program'
            };

            return ApplicationService.getApplication(applicationId, params).then(function (application) {
                vm.application = application;

                return application;
            });
        }

        /*
        Function that overrides status of the participant
         */
        function changeStatus(participant, role) {

            if (role !== 'area_head' && role !== 'national') {
                if (participant.status === 'qualified') {
                    participant.status = 'disqualified';
                } else if (participant.status === 'disqualified') {
                    participant.status = 'overriden';
                } else if (participant.status === 'overriden') {
                    participant.status = 'disqualified';
                }

                return ParticipantService.editParticipantStatus(participant, participant.status)
                    .then(function (response) {
                        getParticipants();
                    });
            }
        }

        //executed after listening to state change
        function stateChange() {
            hideSliderCard();
        }

        /*
        Function that opens edit participant modal
         */
        function editParticipant(participant, pastor) {
            if (currentUser.$roles.has(['admin', 'metrics', 'pastor_coordinator', 'branch_head', 'health_mentor'])) {
                $mdDialog.show({
                    controller: 'EditParticipantDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/transform/dialogs/edit-participant/edit-participant-dialog.html',
                    parent: angular.element($document.body),
                    locals: {
                        participant: participant || null,
                        pastor: pastor || null,
                        application: vm.application,
                        callback: getParticipants
                    },
                    clickOutsideToClose: true
                });
            }
        }

        function issuesDialog(participant, pastor) {
            if (currentUser.$roles.has(['admin', 'metrics', 'pastor_coordinator', 'branch_head'])) {
                $mdDialog.show({
                    controller: 'issuesDeleteParticipantDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/transform/dialogs/issue-dialog/issues-dialog.html',
                    parent: angular.element($document.body),
                    locals: {
                        participant: participant || null,
                        pastor: pastor || null,
                        application: vm.application,
                        callback: getParticipants
                    },
                    clickOutsideToClose: true
                });
            }
        }

        /*
        Function that shows add participant modal
         */
        function addParticipant() {
            $mdDialog.show({
                controller: 'AddParticipantInSelectionDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/transform/dialogs/add-participant-in-selection/add-participant-in-selection-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    application: vm.application,
                    callback: getParticipants,
                    guest: null
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that shows delete participant modal
         */
        function deleteParticipant(participant) {
            $mdDialog.show({
                controller: 'DeleteParticipantDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    participant: participant || null,
                    callback: getParticipants
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that shows drop application modal
         */
        function dropApplication() {
            $mdDialog.show({
                controller: 'DropApplicationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/transform/dialogs/drop-application/drop-application-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    application: vm.application,
                    mode: 'approved',
                    drawApplicationsTable: function () {
                        refreshApprovedApplications();
                        $state.transitionTo("app.transform.approval-lists", {}, true);
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that shows approve application modal
         */
        function approveApplication() {
            $mdDialog.show({
                controller: 'BatchSelectionDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/transform/dialogs/batch-selection/batch-selection-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    application: vm.application,
                    drawApplicationsTable: function () {
                        hideSliderCard();
                        $state.transitionTo("app.transform.approval-lists", {}, false);
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that closes slider card
         */
        function hideSliderCard() {
            refreshApprovedApplications();
            $mdBottomSheet.hide();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.thrive', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.thrive', {
                url: '/thrive',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/thrive/thrive.html',
                        controller: 'ThriveController as vm'
                    }
                }
            })
            .state('app.thrive.datacard', {
                url: '/datacard',
                data: {
                    selectedTab: 0
                },
                views: {
                    'thrive@datacard': {
                        templateUrl: 'app/main/thrive/tabs/datacard/datacard.html',
                        controller: 'DataCardController as vm'
                    }
                }
            })
            .state('app.thrive.districts', {
                url: '/districts',
                data: {
                    selectedTab: 1
                },
                views: {
                    'thrive@districts': {
                        templateUrl: 'app/main/thrive/tabs/districts/districts.html',
                        controller: 'DistrictsController as vm'
                    }
                }
            })
            .state('app.thrive.pastors', {
                url: '/pastors?district_id=&base_id=',
                data: {
                    selectedTab: 2
                },
                views: {
                    'thrive@pastors': {
                        templateUrl: 'app/main/thrive/tabs/pastors/pastors.html',
                        controller: 'PastorsController as vm'
                    }
                }
            })
            .state('app.thrive.pastors.details', {
                url: '/{id}',
                data: {
                    selectedTab: 2
                },
                controller: 'PastorsController',
                controllerAs: 'vm'
            })
            .state('app.thrive.churches', {
                url: '/churches',
                data: {
                    selectedTab: 3
                },
                views: {
                    'thrive@churches': {
                        templateUrl: 'app/main/thrive/tabs/churches/churches.html',
                        controller: 'ChurchesController as vm'
                    }
                }
            })
            .state('app.thrive.churches.details', {
                url: '/{id}',
                data: {
                    selectedTab: 3
                },
                controller: 'ChurchesController',
                controllerAs: 'vm'
            })
            // .state('app.thrive.counselors', {
            //     url: '/counselors',
            //     data: {
            //         selectedTab: 4
            //     },
            //     views: {
            //         'thrive@counselors': {
            //             templateUrl: 'app/main/thrive/tabs/counselors/counselors.html',
            //             controller: 'CounselorsController as vm'
            //         }
            //     }
            // })
            // .state('app.thrive.counselors.details', {
            //     url: '/{id}',
            //     data: {
            //         selectedTab: 4
            //     },
            //     controller: 'CounselorsController',
            //     controllerAs: 'vm'
            // })
            .state('app.thrive.reports', {
                url: '/reports',
                data: {
                    selectedTab: 4
                },
                views: {
                    'thrive@reports': {
                        templateUrl: 'app/main/thrive/tabs/reports/reports.html',
                        controller: 'ThriveReportsController as vm'
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/thrive');

        // Api
        // msApiProvider.register('thrive', ['app/data/thrive/thrive.json']);

        // Navigation
        // msNavigationServiceProvider.saveItem('fuse', {
        //     title : 'TRANSFORM',
        //     group : true,
        //     weight: 1
        // });

        msNavigationServiceProvider.saveItem('fuse.thrive', {
            title: 'only Thrives',
            icon: 'icon-people',
            state: 'app.thrive.datacard',
            translate: 'THRIVE.THRIVE_NAV',
            weight: 3,
            regex: function (state) {
                return /^app\.(thrive).*/.test(state);
            },
            lid: "stlink"
        });
    }
})();

(function () {
    'use strict';

    angular.module('app.thrive')
        .controller('NewPastorDialogController', NewPastorDialogController);

    /** @ngInject */
    function NewPastorDialogController($mdDialog,
        PastorService,
        enumFields,
        ProvinceService,
        CityService,
        BarangayService,
        BaseService,
        Auth,
        ChurchService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.addNewPastor = addNewPastor;

        vm.currentUser = Auth.getUser();

        vm.apiErrors = {};
        vm.pastor = {};

        vm.dialogTitle = "New Pastor";

        enumFields(["gender", "marital_status", "educational_attainment", "church_position"])
            .then(function (values) {
                vm.gender = values.gender;
                vm.marital_status = values.marital_status;
                vm.educational_attainment = values.educational_attainment;
                vm.church_position = values.church_position;
            });

        vm.countrys = [
            { id: "PH", name: "Philippines" },
            { id: "GM", name: "Guatemala" },
            { id: "UG", name: "Uganda" },
            { id: "BU", name: "Burundi" },
            { id: "KH", name: "Cambodia" },
        ]

        vm.handleCountryChange = function (country_code) {
            vm.pastor.base = null;
            initBases(country_code);
        }

        // yes/no select optoin
        vm.yesno = [
            { label: "Yes", value: true },
            { label: "No", value: false }
        ];

        // search province
        vm.selectedProvince = null;
        vm.searchProvince = null;
        vm.searchProvinces = function (name) {
            return ProvinceService.getProvinces({
                search: name,
                base_id: vm.pastor.base.id,
            }).then(function (response) {
                return response.data;
            });
        };
        vm.selectProvince = function (province) {
            vm.pastor.province_id = province.id;
            vm.pastor.parent_province_id = province.parent_province_id;
            vm.pastor.city_id = null;
            vm.pastor.barangay_id = null;
        };

        // search city
        vm.selectedCity = null;
        vm.searchCity = null;
        vm.searchCities = function (name) {
            return CityService.getCities({
                province_id: vm.pastor.parent_province_id ? vm.pastor.parent_province_id : vm.pastor.province_id,
                search: name
            }).then(function (response) {
                return response.data;
            });
        };
        vm.selectCity = function (city) {
            vm.pastor.city_id = city.id;
            vm.pastor.barangay_id = null;
        };

        // search barangay
        vm.selectedBarangay = null;
        vm.searchBarangay = null;
        vm.searchBarangays = function (name) {
            return BarangayService.getBarangays({
                city_id: vm.pastor.city_id,
                search: name
            });
        };
        vm.selectBarangay = function (barangay) {
            vm.pastor.barangay_id = barangay.id;
        };

        function initBases(country_code) {
            BaseService.getBases({
                nopage: 1,
                country_code: country_code,
                base_id: vm.currentUser.base_id,
                with: "districts"
            })
                .then(function (data) {
                    var base = data[0];

                    if (vm.pastor.base) {
                        vm.pastor.base = null;
                    }

                    vm.bases = data;

                    if (vm.currentUser.base_id) {
                        vm.pastor.base = base;
                    }
                });
        }

        // search church
        vm.selectedChurch = null;
        vm.searchChurch = null;
        vm.searchChurches = function (name) {
            return ChurchService.getChurches({
                search: name,
                with: 'province,city'
            }).then(function (response) {
                return response.data;
            });
        };
        vm.selectChurch = function (church) {
            vm.pastor.church_id = church.id;
        };

        // Search Go Viral Pastor Mentor
        vm.selectedGoViralPastorMentor = null;
        vm.searchGoViralPastorMentor = null;
        vm.searchGoViralPastorMentors = function (name) {
            var searchPastorPayload = {
                search: name,
                page: 1,
                check_status: 1,
                limit: 20
            }

            if (vm.pastor.base) {
                searchPastorPayload.base_id = vm.pastor.base.id;
            }

            if (vm.pastor.district) {
                searchPastorPayload.district_id = vm.pastor.district.id;
            }

            return PastorService.searchPastors(searchPastorPayload)
        };

        vm.selectGoViralPastorMentor = function (pastor) {
            vm.pastor.go_viral_pastor_id = pastor ? pastor.id : null;
        };

        vm.manageGoTOViralPastor = function (event) {
            if (event) {
                vm.pastor.district = null;
                vm.pastor.province = null;
                vm.pastor.city = null;
                vm.pastor.barangay = null;
            }
            vm.pastor.selectGoViralPastorMentor = null;
            vm.searchGoViralPastorMentor = null;
        }

        /*
        Function that adds new pastor
         */
        function addNewPastor(pastor, form) {
            vm.saving = true;
            vm.apiErrors = {};
            vm.errorPhone1 = '';
            vm.errorPhone2 = '';
            vm.errorPhone3 = '';

            var data = {
                country_code: pastor.country_code,
                base_id: pastor.base.id,
                district_id: pastor.district.id,
                province_id: pastor.province.id,
                city_id: pastor.city.id,
                barangay_id: pastor.barangay.id,
                address: pastor.address,

                firstname: pastor.firstname,
                middlename: pastor.middlename,
                lastname: pastor.lastname,

                email: pastor.email,
                birth_date: pastor.birth_date,
                gender: pastor.gender,
                status: pastor.status,
                educational_attainment: pastor.educational_attainment,
                seminary: pastor.seminary,
                messenger_id: pastor.messengerId,
                has_smartphone: pastor.hasSmartphone,

                member: 1,
                active: 1,

                go_viral_pastor_id: pastor.go_viral_pastor_id,
            };

            if (pastor.church) {
                data.church_id = pastor.church.id;

                if (pastor.position === 'other') {
                    data.church_position = pastor.otherposition;
                } else {
                    data.church_position = pastor.position;
                }
            }

            // add the contact numbers
            data.contact_nos = [];
            if (pastor.contacts1) data.contact_nos.push(pastor.contacts1);
            if (pastor.contacts2) data.contact_nos.push(pastor.contacts2);
            if (pastor.contacts3) data.contact_nos.push(pastor.contacts3);

            return PastorService.addPastor(data)
                .then(function (response) {
                    vm.saving = false;
                    closeDialog(response);
                })
                .catch(function (response) {
                    vm.saving = false;
                    form.$invalid = true;

                    for (var field in response.data.errors) {
                        vm.apiErrors[field] = response.data.errors[field].shift();
                    }

                    if (response.data && response.data.errors) {
                        if (response.data.errors['contact_nos.0']) {
                            vm.errorPhone1 = 'Invalid phone no.';
                        }

                        if (response.data.errors['contact_nos.1']) {
                            vm.errorPhone2 = 'Invalid phone no.';
                        }

                        if (response.data.errors['contact_nos.2']) {
                            vm.errorPhone3 = 'Invalid phone no.';
                        }
                    }
                });
        }

        /*
        Function that closees modal
         */
        function closeDialog(data) {
            $mdDialog.hide(data);
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.transform')
        .controller('DeletedApplicationsContentController', DeletedApplicationsContentController);

    /** @ngInject */
    function DeletedApplicationsContentController($scope,
                                                  $mdBottomSheet,
                                                  ApplicationService,
                                                  $mdDialog,
                                                  $document,
                                                  refreshApplicationsTable,
                                                  Auth) {
        var vm = this;
        var currentUser = Auth.getUser();
        vm.isLoading = false;

        //Methods
        vm.restoreApplication = restoreApplication;
        vm.deleteApplication = deleteApplication;
        vm.closeDeletedApplications = closeDeletedApplications;
        vm.callPastorInformation = callPastorInformation;
        vm.stateChange = stateChange;
        vm.pageChange = pageChange;

        $('.content-white-holder').addClass('bcopen');

        //listen for state change
        $scope.$on('$stateChangeStart', function () {
            vm.stateChange();
        });

        /*
        Function that populates deleted applications table
         */
        function initDeletedApplications() {
            getDeletedApplications(1);
        }

        initDeletedApplications();

        /*
        Function that fetches all deleted/dropped applications
         */
        function getDeletedApplications(page) {
            vm.isLoading = true;
            var params = {
                sort: 'application_id:desc',
                limit: 10,
                base_id: currentUser.base_id || null,
                page: page,
                trashed: 1
            };
            params.with = 'pastor.churches,pastor.churches.affiliation,pastor.base,pastor.province,pastor.city,pastor.barangay,pastor.contacts';
            ApplicationService.getDeletedApplications(params).then(function (data) {
                vm.isLoading = false;
                vm.deletedApplications = data;
            });
        }

        //executed after listening to state change
        function stateChange() {
            closeDeletedApplications();
        }

        /*
        Function that populate deleted applications when changing pagination page
         */
        function pageChange(page) {
            getDeletedApplications(page);
        }

        /*
        Function that checks if there is a pastor in that application and call show pastor dialog function
         */
        function callPastorInformation(pastorId) {
            if (pastorId) showPastorInformationDialog(pastorId);
        }

        /*
        Function that calls modal service for pastor information
         */
        function showPastorInformationDialog(pastor) {
            $mdDialog.show({
                controller: 'PastorInformationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/transform/dialogs/pastor-information/pastor-information-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    pastor: pastor
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that restores deleted application
         */
        function restoreApplication(application) {
            vm.isLoading = true;
            vm.deletedApplications = [];
            ApplicationService.restoreApplication(application)
                .then(function (data) {
                    refreshApplicationsTable();
                    getDeletedApplications(vm.deletedApplications.current_page);
                });
        }

        /*
        Function that shows permanent delete application
         */
        function deleteApplication(application) {
            $mdDialog.show({
                controller: 'DeleteApplicationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    application: application || null,
                    mode: 'deleted',
                    drawApplicationsTable: function () {
                        vm.deletedApplications = [];
                        getDeletedApplications(vm.deletedApplications.current_page);
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that closes deleted applications bottom sheet
         */
        function closeDeletedApplications() {
            $mdBottomSheet.hide();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.thrive')
        .controller('PermanentDeletePastorDialogController', PermanentDeletePastorDialogController);

    /** @ngInject */
    function PermanentDeletePastorDialogController($mdDialog, callback) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.deleteCallback = deleteCallback;

        vm.dialogTitle = "Delete Pastor";
        vm.message = 'Are you sure you want to delete this Pastor?';
        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteCallback(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        /*
        Function used to call delete callback
         */
        function deleteCallback() {
            callback();
            closeDialog();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.thrive')
        .controller('EditDataCardController', EditDataCardController);

    /** @ngInject */
    function EditDataCardController($mdDialog,
                                    PastorService,
                                    callback,
                                    datacard,
                                    pastor,
                                    DataCardService) {
        var vm = this;

        vm.dialogTitle = 'Edit Data Card';

        vm.thrive = {};
        vm.attendance = {};

        vm.submitAttendance = [];

        //Methods
        vm.changeDataCardForm = changeDataCardForm;
        vm.editThriveCard = editThriveCard;
        vm.resetForm = resetForm;
        vm.addNewAttendanceCard = addNewAttendanceCard;
        vm.selectPastor = selectPastor;
        vm.closeDialog = closeDialog;
        vm.searchPastors = searchPastors;
        vm.toggleCheckBox = toggleCheckBox;
        vm.isSelected = isSelected;

        activate();

        /*
        Function first called upon load
         */
        function activate() {
            vm.thrive = datacard;
            vm.selectedPastor = pastor;
            vm.name = pastor.firstname + ' ' + pastor.lastname;
            vm.base = '(' + pastor.base.name + ') ' + pastor.district_id;
        }

        /*
        Function that listens to dropdown change for Data Card type
         */
        function changeDataCardForm() {
            vm.thrive = {};
            vm.attendance = {};
            vm.selectedPastor = '';
        }

        /*
        Function that checks if the item is already in array or not. Pushes if there
        is already item to the array, otherwise splice.
         */
        function toggleCheckBox(item) {
            var index = vm.submitAttendance.indexOf(item);
            if (index > -1) {
                vm.submitAttendance.splice(index, 1);
            } else {
                vm.submitAttendance.push(item);
            }
        }

        /*
        Function that checks if the item is selected in the array
         */
        function isSelected(item) {
            return vm.submitAttendance.indexOf(item) > -1;
        }

        /*
        Function to save thrive card
         */
        function editThriveCard(thrive) {
            thrive.id = datacard.id;
            thrive.attendance_type = thrive.attendance_type === 1 ? 'meeting' : 'training';
            thrive.attended_at = moment(thrive.attended_at).format();
            vm.saving = true;
            DataCardService.editDataCard(thrive).then(function () {
                vm.saving = false;
                callback();
                closeDialog();
            })
        }

        /*
        Function to save 2nd day attendance card
         */
        function addNewAttendanceCard(attendance, form) {
            vm.saving = false;
            attendance.is_second = 1;

            DataCardService.addDataCard(attendance).then(function () {
                vm.saving = false;

                form.$setUntouched();
                form.$setPristine();

                vm.attendance = {};
                vm.selectedPastor = '';
            })
        }

        /*
        Function used to reset data form
         */
        function resetForm(form, vm) {
            form.$setUntouched();
            form.$setPristine();

            vm.thrive = {};
            vm.attendance = {};
            vm.selectedPastor = '';
        }

        /*
        Function that assigns pastor upon select in autocomplete
         */
        function selectPastor(pastor) {
            if (pastor) {
                vm.selectedPastor = pastor;
                vm.thrive.name = pastor.firstname + ' ' + pastor.lastname;
                vm.thrive.base = '(' + pastor.base.name + ') ' + pastor.district_id;
                vm.thrive.pastor_id = pastor.id;

                vm.attendance.pastor_id = pastor.id;
                vm.attendance.name = pastor.firstname + ' ' + pastor.lastname;
                vm.attendance.base = '(' + pastor.base.name + ') ' + pastor.district_id;
            }
        }

        /*
        Function that queries pastors upon autocomplete
         */
        function searchPastors(query) {
            return PastorService.searchPastors({
                search: query,
                page: 1,
                limit: 20
            });
        }

        /*
        Function for closing dialog box
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.thrive')
        .controller('EditPastorDialogController', EditPastorDialogController);

    /** @ngInject */
    function EditPastorDialogController($mdDialog,
        pastor,
        initPastorsTable,
        PastorService,
        enumFields,
        ProvinceService,
        CityService,
        BarangayService,
        BaseService,
        Auth,
        ChurchService) {
        var vm = this;

        vm.currentUser = Auth.getUser();

        //Methods
        vm.closeDialog = closeDialog;
        vm.editPastor = editPastor;

        vm.apiErrors = {};
        vm.pastor = pastor;

        vm.dialogTitle = "Edit Pastor";

        enumFields(["gender", "marital_status", "educational_attainment", "church_position"])
            .then(function (values) {
                vm.gender = values.gender;
                vm.marital_status = values.marital_status;
                vm.educational_attainment = values.educational_attainment;
                vm.church_position = values.church_position;
            });

        vm.countrys = [
            { id: "PH", name: "Philippines" },
            { id: "GM", name: "Guatemala" },
            { id: "UG", name: "Uganda" },
            { id: "BU", name: "Burundi" },
            { id: "KH", name: "Cambodia" },
        ]

        vm.handleCountryChange = function (country_code) {
            vm.pastor.base = null;
            vm.pastor.base_id = null;

            BaseService.getBases({
                nopage: 1,
                country_code: country_code,
                base_id: vm.currentUser.base_id,
                with: "districts"
            })
                .then(function (data) {
                    vm.bases = data;
                });

        }

        // fix the birthdate
        vm.pastor.birth_date = pastor.birth_date ? new Date(pastor.birth_date) : null;
        // console.log(vm.pastor, +"Sed");

        if (pastor.go_viral_pastor_id) {
            getGoViralPastor(pastor.go_viral_pastor_id);
        }

        // yes/no select optoin
        vm.yesno = [
            { label: "Yes", value: true },
            { label: "No", value: false }
        ];

        vm.selectBase = function (base) {
            vm.pastor.base = base;
        };

        // search province
        vm.selectedProvince = null;
        vm.searchProvince = null;
        vm.searchProvinces = function (name) {
            return ProvinceService.getProvinces({
                search: name,
                base_id: vm.pastor.base_id
            }).then(function (response) {
                return response.data;
            });
        };
        vm.selectProvince = function (province) {
            vm.pastor.province_id = province.id;
            vm.pastor.parent_province_id = province.parent_province_id;
            vm.pastor.city_id = null;
            vm.pastor.barangay_id = null;
        };

        // search city
        vm.selectedCity = null;
        vm.searchCity = null;
        vm.searchCities = function (name) {
            return CityService.getCities({
                province_id: vm.pastor.parent_province_id ? vm.pastor.parent_province_id : vm.pastor.province_id,
                search: name
            }).then(function (response) {
                return response.data;
            });
        };
        vm.selectCity = function (city) {
            vm.pastor.city_id = city.id;
            vm.pastor.barangay_id = null;
        };

        // search barangay
        vm.selectedBarangay = null;
        vm.searchBarangay = null;
        vm.searchBarangays = function (name) {
            return BarangayService.getBarangays({
                city_id: vm.pastor.city_id,
                search: name
            });
        };
        vm.selectBarangay = function (barangay) {
            vm.pastor.barangay_id = barangay.id;
        };

        /*
        Function that gets bases with districts
         */
        function initBases() {
            BaseService.getBases({
                nopage: 1,
                country_code: vm.pastor.country_code,
                base_id: vm.currentUser.base_id,
                with: "districts"
            })
                .then(function (data) {
                    vm.bases = data;

                    if (vm.currentUser.base_id) {
                        vm.pastor.base = data[0];
                    }
                });
        }

        initBases();

        vm.handleChangeBase = function () {
            vm.pastor.district = null;
            vm.pastor.province = null;
            vm.pastor.city = null;
            vm.pastor.barangay = null;
        }

        // search church
        vm.selectedChurch = null;
        vm.searchChurch = null;
        vm.searchChurches = function (name) {
            return ChurchService.getChurches({
                search: name
            }).then(function (response) {
                return response.data;
            });
        };
        vm.selectChurch = function (church) {
            vm.pastor.church_id = church.id;
        };


        /*
        Function that gets go viral mastor mentor
         */
        function getGoViralPastor(id) {
            var params = {
                check_status: 1
            };
            PastorService.getPastor(id, params).then(function (response) {
                vm.pastor.selectGoViralPastorMentor = response;
            }
            );
        }

        // Search Go Viral Pastor Mentor
        vm.searchGoViralPastorMentor = null;
        vm.searchGoViralPastorMentors = function (name) {
            var searchPastorPayload = {
                search: name,
                page: 1,
                check_status: 1,
                limit: 20
            }

            if (vm.pastor.base) {
                searchPastorPayload.base_id = vm.pastor.base.id;
            }

            if (vm.pastor.district) {
                searchPastorPayload.district_id = vm.pastor.district.id;
            }

            return PastorService.searchPastors(searchPastorPayload)
        };

        vm.selectGoViralPastorMentor = function (pastor) {
            vm.pastor.go_viral_pastor_id = pastor ? pastor.id : null;
        };

        /*
        Function that edits pastor details
         */
        function editPastor(id, pastor, form) {
            vm.saving = true;
            vm.apiErrors = {};

            var data = {
                id: id,
                country_code: pastor.country_code,
                base_id: pastor.base_id,
                district_id: pastor.district_id,
                province_id: pastor.province.id,
                city_id: pastor.city.id,
                barangay_id: pastor.barangay.id,
                address: pastor.address,

                firstname: pastor.firstname,
                middlename: pastor.middlename,
                lastname: pastor.lastname,

                email: pastor.email,
                birth_date: pastor.birth_date,
                gender: pastor.gender,
                status: pastor.status,
                educational_attainment: pastor.educational_attainment,
                seminary: pastor.seminary,

                messenger_id: pastor.messenger_id,
                has_smartphone: pastor.has_smartphone,

                member: pastor.member,
                active: pastor.active,

                go_viral_pastor_id: pastor.go_viral_pastor_id,
            };

            return PastorService.editPastorlist(data)
                .then(function () {
                    vm.saving = false;
                    initPastorsTable();
                    closeDialog();
                })
                .catch(function (response) {
                    vm.saving = false;
                    form.$invalid = true;

                    for (var field in response.data.errors) {
                        vm.apiErrors[field] = response.data.errors[field].shift();
                    }
                });
        }

        /*
        Function that closes modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();
(function () {
    'use strict';

    angular.module('app.thrive')
        .controller('EditContactDialogController', EditContactDialogController);

    /** @ngInject */
    function EditContactDialogController($mdDialog,
                                         pastorId,
                                         contact,
                                         pastor,
                                         callback,
                                         PastorService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.editContact = editContact;

        vm.dialogTitle = "Edit Contact";
        vm.apiErrors = {};

        vm.contact = {
            number: contact.contact_no
        };

        /*
        Function that edit the pastor contact
         */
        function editContact(contacts, form) {
            vm.apiErrors = {};
            vm.saving = true;

            var contactObj = {
                id: pastorId,
                contact_no: contacts.number
            };

            return PastorService.editContact(contactObj, contact.id)
                .then(function (response) {
                    vm.saving = false;
                    pastor.contacts = pastor.contacts.map(function (contactEdit) {
                        if (contact.id === contactEdit.id) {
                            contactEdit.contact_no = contactObj.contact_no;
                        }
                        return contactEdit;
                    });
                    callback();
                    closeDialog();
                })
                .catch(function (response) {
                    form.$invalid = true;
                    vm.saving = false;

                    for (var field in response.data.errors) {
                        vm.apiErrors[field] = response.data.errors[field].shift();
                    }
                });
        }

        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.thrive')
        .controller('EditPastorChurchDialogController', EditPastorChurchDialogController);

    /** @ngInject */
    function EditPastorChurchDialogController($mdDialog,
                                          callback,
                                          church,
                                          ChurchService,
                                          PastorService,
                                          enumFields) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.editChurch = editChurch;
        vm.selectChurch = selectChurch;
        vm.searchChurches = searchChurches;

        vm.selectedChurch = null;
        vm.church = {};

        vm.dialogTitle = "Edit Position";
        vm.apiErrors = {};
        vm.church = church;

        enumFields(['church_position'])
            .then(function (values) {
                vm.church_position = values.church_position;
            });

        selectChurch(church);

        /*
        Function triggered when a church is selected in autocomplete
         */
        function selectChurch(church) {
            vm.selectedChurch = church;
            vm.church.id = church.id;
        }

        /*
        Function triggered in autocomplete that seasrch for churches
         */
        function searchChurches(query) {
            return ChurchService.searchChurches({
                search: query,
                with : "province,barangay,city",
                limit: 20,
                page: 1
            }).then(function (response) {
                var churches = response.filter(function (church) {
                    if (church.name !== '') return church;
                });
                return churches;
            });
        }

        /*
        Function triggered when add church button is clicked
         */
        function editChurch(church, form) {
            vm.apiErrors = {};
            vm.saving = true;

            var churchObj = {
                position: church.position
            };

            return PastorService.addChurch({id: church.pastor_id}, church, churchObj)
                .then(function () {
                    vm.saving = false;
                    callback();
                    closeDialog();
                })
                .catch(function (response) {
                    form.$invalid = true;
                    vm.saving = false;

                    for (var field in response.data.errors) {
                        vm.apiErrors[field] = response.data.errors[field].shift();
                    }
                });
        }

        /*
        Function that closes modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.thrive')
        .controller('DeletePastorDialogController', DeletePastorDialogController);

    /** @ngInject */
    function DeletePastorDialogController(
        $mdDialog,
        $document,
        pastor,
        PastorService,
        callback) {
        var vm = this;

        //Methods

        vm.dialogTitle = "Drop Pastor";
        vm.pastors = false;
        vm.reason = [
            "Deceased",
            "No Longer a Pastor",
            "No Longer wants to be a part of ICM",
            "Duplicate",
            "Relocated to somewhere outside of ICM service",
            // 'Other'
        ];

        vm.form = {
            id: pastor.id,
            reason: pastor.reason_for_dropping,
            otherReason: ''
        };

        vm.closeDialog = function closeDialog() {
            $mdDialog.hide();
        }

        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.handleSubmit(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that deletes a pastor
         */
        vm.handleSubmit = function handleSubmit() {
            vm.pastors = true;
            if (Array.isArray(pastor)) {
                // Prepare URL-encoded data
                const urlencoded = new URLSearchParams();
                pastor.forEach(id => urlencoded.append("pastor_ids[]", id));
                urlencoded.append("reasons_for_dropping", vm.form.reason === 'Other' ? vm.form.otherReason : vm.form.reason);

                // Call the delete function with formatted data
                PastorService.deleteBulkPastor(urlencoded.toString())
                    .then(callback)
                    .then(vm.closeDialog)
                    .finally(function () {
                        vm.pastors = false;
                    });
                return;
            }

            var pastorslist = Object.assign(pastor, {
                reason_for_dropping: vm.form.reason === 'Other'
                    ? vm.form.otherReason
                    : vm.form.reason
            });

            PastorService.editPastorlist(pastorslist)
                .then(function () {
                    return PastorService.deletePastorlist(vm.form.id)
                })
                .then(callback)
                .then(vm.closeDialog)
                .finally(function () {
                    vm.pastors = false;
                });
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.thrive')
        .controller('DeleteDataCardDialogController', DeleteDataCardDialogController);

    /** @ngInject */
    function DeleteDataCardDialogController($mdDialog,
                                            $document,
                                            callback,
                                            datacard,
                                            DataCardService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.deleteCallback = deleteCallback;

        vm.dialogTitle = "Delete Data Card";
        vm.message = 'Are you sure to delete this Data Card?';
        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteCallback(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that deletes a data card of a pastor
         */
        function deleteCallback() {
            vm.saving = true;
            return DataCardService.deleteDataCard(datacard)
                .then(function () {
                    vm.saving = false;
                    callback();
                    closeDialog();
                });
        }

        /*
        Function that closes modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.thrive')
        .controller('DeleteContactInPastorDialogController', DeleteContactInPastorDialogController);

    /** @ngInject */
    function DeleteContactInPastorDialogController($mdDialog,
                                                  $document,
                                                   pastorId,
                                                   pastor,
                                                   contact,
                                                   PastorService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.deleteCallback = deleteCallback;

        vm.dialogTitle = "Delete Contact";
        vm.message = 'Are you sure to delete this contact?';
        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteCallback(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that deletes a contact of a pastor
         */
        function deleteCallback() {
            vm.saving = true;
            return PastorService.deleteContact(pastorId, contact.id)
                .then(function () {
                    vm.saving = false;
                    pastor.contacts = pastor.contacts.filter(function (contactEdit) {
                        if (contact.id !== contactEdit.id) {
                            return contactEdit;
                        }
                    });
                    closeDialog();
                });
        }

        /*
        Function that closes modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.thrive')
        .controller('DeleteChurchInPastorDialogController', DeleteChurchInPastorDialogController);

    /** @ngInject */
    function DeleteChurchInPastorDialogController($mdDialog,
                                                  $document,
                                                  church,
                                                  pastor,
                                                  callback,
                                                  PastorService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.deleteCallback = deleteCallback;

        vm.dialogTitle = "Delete Church";
        vm.message = 'Are you sure to delete this church?';
        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteCallback(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that deletes a church of a pastor
         */
        function deleteCallback() {
            vm.saving = true;
            return PastorService.deleteChurch(pastor, church)
                .then(function () {
                    vm.saving = false;
                    callback();
                    closeDialog();
                });
        }

        /*
        Function that closes modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.thrive')
        .controller('NewContactDialogController', NewContactDialogController);

    /** @ngInject */
    function NewContactDialogController($mdDialog,
                                        pastorId,
                                        pastor,
                                        callback,
                                        PastorService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.addNewContact = addNewContact;

        vm.dialogTitle = "New Contact";
        vm.apiErrors = {};

        /*
        Function that adds contact to a pastor
         */
        function addNewContact(contact, form) {
            vm.apiErrors = {};
            vm.saving = true;

            var contactObj = {
                id: pastorId,
                contact_no: contact.number
            };

            return PastorService.addContact(contactObj)
                .then(function () {
                    vm.saving = false;
                    pastor.contacts.push(contactObj);
                    callback();
                    closeDialog();
                })
                .catch(function (response) {
                    form.$invalid = true;
                    vm.saving = false;

                    for (var field in response.data.errors) {
                        vm.apiErrors[field] = response.data.errors[field].shift();
                    }
                });
        }

        /*
        Function that closes modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.thrive')
        .controller('AddNewChurchDialogController', AddNewChurchDialogController);

    /** @ngInject */
    function AddNewChurchDialogController($mdDialog,
                                          callback,
                                          pastor,
                                          ChurchService,
                                          PastorService,
                                          enumFields) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.addNewChurch = addNewChurch;
        vm.selectChurch = selectChurch;
        vm.searchChurches = searchChurches;

        vm.selectedChurch = null;
        vm.church = {};

        vm.dialogTitle = "New Church";
        vm.apiErrors = {};

        enumFields(['church_position'])
            .then(function (values) {
                vm.church_position = values.church_position;
            });

        /*
        Function triggered when a church is selected in autocomplete
         */
        function selectChurch(church) {
            vm.selectedChurch = church;
            vm.church.id = church.id;
        }

        /*
        Function triggered in autocomplete that seasrch for churches
         */
        function searchChurches(query) {
            return ChurchService.searchChurches({
                search: query,
                with : "province,barangay,city",
                limit: 20,
                page: 1
            }).then(function (response) {
                var churches = response.filter(function (church) {
                    if (church.name !== '') return church;
                });
                return churches;
            });
        }

        /*
        Function triggered when add church button is clicked
         */
        function addNewChurch(church, form) {
            vm.apiErrors = {};
            vm.saving = true;

            var churchObj = {
                position: church.position
            };

            return PastorService.addChurch(pastor, church, churchObj)
                .then(function () {
                    vm.saving = false;
                    callback();
                    closeDialog();
                })
                .catch(function (response) {
                    form.$invalid = true;
                    vm.saving = false;

                    for (var field in response.data.errors) {
                        vm.apiErrors[field] = response.data.errors[field].shift();
                    }
                });
        }

        /*
        Function that closes modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.transform')
        .controller('PastorDetailsController', PastorDetailsController);

    /** @ngInject */
    function PastorDetailsController($scope,
        $timeout,
        $mdBottomSheet,
        $location,
        PastorService,
        ProvinceService,
        CityService,
        BarangayService,
        enumFields,
        DataCardService,
        initPastorsTable,
        BaseService,
        ChurchService,
        $mdDialog,
        $document,
        pastor,
        Auth) {
        var vm = this;
        var currentUser = Auth.getUser();
        vm.userCountry = currentUser ? currentUser.country_code : null;

        vm.closeBottomSheet = closeBottomSheet;

        //Methods
        vm.selectContact = selectContact;
        vm.deleteChurch = deleteChurch;
        vm.editChurch = editChurch;
        vm.addContact = addContact;
        vm.getPastor = getPastor;
        vm.deleteContact = deleteContact;
        vm.addNewChurch = addNewChurch;
        vm.editPastor = editPastor;
        vm.deleteDataCard = deleteDataCard;
        vm.editDataCard = editDataCard;
        vm.editContact = editContact;
        vm.stateChange = stateChange;
        vm.setFocus = setFocus;
        vm.sliderHeight = $document.height() - 250;
        vm.isLoading1 = false;
        vm.pastor = {};
        vm.clickedEdit = false;

        vm.countrysEnum = {
            PH: "Philippines",
            GM: "Guatemala",
            UG: "Uganda",
            BU: "Burundi",
            KH: "Cambodia",
        }

        vm.countrys = [
            { id: "PH", name: "Philippines" },
            { id: "GM", name: "Guatemala" },
            { id: "UG", name: "Uganda" },
            { id: "BU", name: "Burundi" },
            { id: "KH", name: "Cambodia" },
        ]

        vm.handleCountryChange = function (country_code) {
            vm.pastor.base = null;
            vm.pastor.base_id = null;

            var basePayload = {
                nopage: 1,
                country_code: country_code,
                with: "districts"
            }

            if (vm.currentUser && vm.currentUser.base_id) {
                basePayload.base_id = vm.currentUser.base_id;
            }

            BaseService.getBases(basePayload)
                .then(function (data) {
                    vm.bases = data;
                });
        }

        vm.userstate = '';
        vm.states = ('Abello Guilbert Abello Guilbert Abello Guilbert Abello Guilbert').split(' ').map(function (state) { return { abbrev: state }; });
        vm.types = [
            { label: "Member - Amie Somogod (18)" },
            { label: "Member - Jonathan Suacito (42)" }
        ];

        $scope.message = 'No';
        $scope.onChange = function (cbState) {
            $scope.message = cbState;
        };

        //listen for state change
        $scope.$on('$stateChangeStart', function () {
            vm.stateChange();
        });

        // Get the current path from $location
        var path = $location.path();

        // Extract the ID from the path
        var parts = path.split('/');
        var pastor_id = parts[parts.length - 1];

        activate();

        /* 
        Function that initializes gender, marital status, educational attainment,
        and church position. Also fetches pastor details, datacards, and churches
        of the pastor
         */
        function activate() {
            enumFields(["gender", "marital_status", "educational_attainment", "church_position"])
                .then(function (values) {
                    vm.gender = values.gender;
                    vm.marital_status = values.marital_status;
                    vm.educational_attainment = values.educational_attainment;
                    vm.group_leader = values.group_leader;

                    vm.church_position = values.church_position;
                });
            vm.pastor.birth_date = (pastor && pastor.birth_date) ? new Date(pastor.birth_date) : null;
            vm.yesno = [
                { label: "Yes", value: true },
                { label: "No", value: false }
            ];

            vm.selectBase = function (base) {
                vm.pastor.base = base;

                if (base.districts && base.districts.length) {
                    vm.pastor.district_id = base.districts[0].id;
                }
            };
            getPastor(pastor ? pastor : pastor_id);
            getDataCards(pastor ? pastor : pastor_id);
            getChurches(pastor ? pastor : pastor_id);
        }


        //executed after listening to state change
        function stateChange() {
            closeBottomSheet();
        }

        /*
        Function that sets focus to pastor first name when editing pastor
         */
        function setFocus() {
            vm.clickedEdit = true;
            $timeout(function () {
                document.querySelector('#pastor-name-details').focus();
            }, 0);

        }

        // search province
        vm.selectedProvince = null;
        vm.searchProvince = null;
        vm.searchProvinces = function (name) {
            return ProvinceService.getProvinces({
                search: name
            }).then(function (response) {
                return response.data;
            });
        };
        vm.selectProvince = function (province) {
            vm.pastor.province_id = province.id;
            vm.pastor.parent_province_id = province.parent_province_id;
            vm.pastor.city_id = null;
            vm.pastor.barangay_id = null;
        };

        // search city
        vm.selectedCity = null;
        vm.searchCity = null;
        vm.searchCities = function (name) {
            return CityService.getCities({
                province_id: vm.pastor.parent_province_id ? vm.pastor.parent_province_id : vm.pastor.province_id,
                search: name
            }).then(function (response) {
                return response.data;
            });
        };
        vm.selectCity = function (city) {
            vm.pastor.city_id = city.id;
            vm.pastor.barangay_id = null;
        };

        // search barangay
        vm.selectedBarangay = null;
        vm.searchBarangay = null;
        vm.searchBarangays = function (name) {
            return BarangayService.getBarangays({
                city_id: vm.pastor.city_id,
                search: name
            });
        };
        vm.selectBarangay = function (barangay) {
            vm.pastor.barangay_id = barangay.id;
        };

        /*
        Function that gets bases with districts
         */
        function initBases() {
            BaseService.getBases({
                nopage: 1,
                country_code: vm.pastor.country_code,
                with: "districts"
            })
                .then(function (data) {
                    vm.bases = data;
                });
        }

        initBases();

        /*
        Function that gets pastor details
         */
        function getPastor(id) {
            vm.isLoading1 = true;
            var params = {
                with: 'base,province,city,barangay,contacts,district',
                check_status: 1
            };
            PastorService.getPastor(id, params).then(function (response) {
                vm.isLoading1 = false;
                vm.pastor = response;

                vm.pastor.contacts = vm.pastor.contacts.filter(function (item) {
                    if (item.contact_no) return item;
                });
                vm.educational_attainment.filter(function (item) {
                    if (item.value === vm.pastor.educational_attainment) {
                        vm.pastor.displayEducation_attainment = item;
                    }
                });

                BaseService.getBase(vm.pastor.base, {
                    nopage: 1,
                    with: "districts"
                })
                    .then(function (data) {
                        vm.pastor.base = data;
                    });
                searchgroupleader(response.district_id);

                if (response.go_viral_pastor_id) {
                    getGoViralPastor(response.go_viral_pastor_id)
                }
            }
            );
        }

        /*
        Function that gets group facilitator
         */
        // gl
        function searchgroupleader(group_leader) {

            PastorService.searchgroupleader({
                id: group_leader,
                with: 'base,district',
            }).then(function (response) {
                vm.selectedgroupleader = response.groupleader;
                vm.selectedgroupleaders = vm.selectedgroupleader.filter(function (el) {
                    return el.firstname !== vm.pastor.firstname;
                });
            });
        }


        /*
        Function that gets data cards of the pastor
         */
        function getDataCards(id) {
            DataCardService.getDataCards({
                pastor_id: id,
                nopage: true,
                sort: 'attended_at:asc',
                with: 'pastor'
            }).then(function (response) {
                vm.datacards = response;
            })
        }

        /*
        Function that gets churches affiliated to a pastor
         */
        function getChurches(id) {
            ChurchService.getChurches({
                pastor_id: id,
                nopage: true,
                with: "province,barangay,city",
            }).then(function (response) {
                vm.churches = response;

                var churches = angular.forEach(response, function (item) {
                    var pastor = item.pastors[0];
                    var position = pastor.pivot.position;

                    item.pastor_id = pastor.id;
                    item.position = position;

                    vm.church_position.forEach(function (pos) {
                        if (position === pos.value) {
                            item.pastor_position = pos.label;
                        }
                    });
                    return item;
                });
                vm.churches.data = churches;
            })
        }

        /*
        Function that gets go viral mastor mentor
         */
        function getGoViralPastor(id) {
            var params = {
                check_status: 1
            };
            PastorService.getPastor(id, params).then(function (response) {
                vm.pastor.selectGoViralPastorMentor = response;
            }
            );
        }

        // Search Go Viral Pastor Mentor
        vm.selectedGoViralPastorMentor = null;
        vm.searchGoViralPastorMentor = null;
        vm.searchGoViralPastorMentors = function (name) {
            var searchPastorPayload = {
                search: name,
                page: 1,
                check_status: 1,
                limit: 20
            }

            if (vm.pastor.base) {
                searchPastorPayload.base_id = vm.pastor.base.id;
            }

            if (vm.pastor.district) {
                searchPastorPayload.district_id = vm.pastor.district.id;
            }

            return PastorService.searchPastors(searchPastorPayload)
        };

        vm.selectGoViralPastorMentor = function (pastor) {
            vm.pastor.go_viral_pastor_id = pastor ? pastor.id : null;
        };

        /*
        Function triggered when a data card is deleted
         */
        function deleteDataCard(datacard) {
            $mdDialog.show({
                controller: 'DeleteDataCardDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
                parent: angular.element($document.body),
                bindToController: true,
                locals: {
                    datacard: datacard,
                    callback: function () {
                        getPastor(pastor);
                        getDataCards(pastor);
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function triggered when a data card is edited
         */
        function editDataCard(datacard) {
            $mdDialog.show({
                controller: 'EditDataCardController',
                controllerAs: 'vm',
                templateUrl: 'app/main/thrive/tabs/pastors/dialogs/edit-datacard/edit-datacard-dialog.html',
                parent: angular.element($document.body),
                bindToController: true,
                locals: {
                    datacard: datacard,
                    pastor: vm.pastor,
                    callback: function () {
                        getPastor(pastor);
                    }
                },
                clickOutsideToClose: true
            });
        }

        function checkGroupLeader() {
            vm.group_leader = !vm.pastor.group_leader;
            vm.pastor.group_leader = !vm.pastor.group_leader;
        }
        function UncheckGroupLeader() {
            vm.group_leader = !vm.pastor.group_leader;
            vm.pastor.group_leader = !vm.pastor.group_leader;
            vm.group_leader_id = !vm.pastor.group_leader_id;
            vm.pastor.group_leader_id = !vm.pastor.group_leader_id;
        }

        /*
        Function triggered when edit pastor button is clicked and opens a modal
         */
        function editPastor(pastorData, form) {
            vm.saving = true;
            vm.apiErrors = {};

            // vm.pastor.group_leader = vm.group_leader ? 0 : 1;
            // console.log(vm.pastor.group_leader)
            pastorData.group_leader_id = vm.group_leader_id ? 0 : pastorData.id;
            var data = {
                id: pastorData.id,
                country_code: pastorData.country_code,
                base_id: pastorData.base_id,
                district_id: pastorData.district_id,
                province_id: pastorData.province.id,
                city_id: pastorData.city.id,
                barangay_id: pastorData.barangay.id,
                messenger_id: pastorData.messenger_id,
                has_smartphone: pastorData.has_smartphone,

                firstname: pastorData.firstname,
                middlename: pastorData.middlename,
                lastname: pastorData.lastname,


                group_leader: pastorData.group_leader,
                group_leader_id: pastorData.group_leader_id,

                leaders: pastorData.group_leader,

                email: pastorData.email,
                birth_date: pastorData.birth_date,
                gender: pastorData.gendger,
                status: pastorData.status,
                educational_attainment: pastorData.educational_attainment,
                seminary: pastorData.seminary,
                member: pastorData.member,
                active: pastorData.active,

                go_viral_pastor_id: pastorData.go_viral_pastor_id,
            };

            return PastorService.editPastorlist(data)
                .then(function () {
                    vm.saving = false;
                    vm.clickedEdit = false;

                    vm.pastor.group_leader = vm.group_leader ? 1 : 0;
                    console.log(vm.pastor.group_leader + 'hii')
                    vm.pastor.group_leader_id = 1; // yaha maine edit kiyaa hai
                    // initPastorsTable();
                    getPastor(pastorData.id);
                    initPastorsTable();
                })
                .catch(function (response) {
                    vm.saving = false;
                    vm.clickedEdit = true;
                    form.$invalid = true;

                    for (var field in response.data.errors) {
                        vm.apiErrors[field] = response.data.errors[field].shift();
                    }
                });
        }

        /*
        Function triggered when delete contact icon is clicked
         */
        function deleteContact(contact) {
            $mdDialog.show({
                controller: 'DeleteContactInPastorDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
                parent: angular.element($document.body),
                bindToController: true,
                locals: {
                    pastorId: pastor,
                    pastor: vm.pastor,
                    contact: contact
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function triggered when new church button is clicked and pops up new church modal
         */
        function addNewChurch(pastor) {
            $mdDialog.show({
                controller: 'AddNewChurchDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/thrive/tabs/pastors/dialogs/add-church/add-church-dialog.html',
                parent: angular.element($document.body),
                bindToController: true,
                locals: {
                    pastor: pastor,
                    callback: function () {
                        getPastor(pastor.id);
                        getChurches(pastor.id);
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Updating a church
         */
        function editChurch(church) {
            $mdDialog.show({
                controller: 'EditPastorChurchDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/thrive/tabs/pastors/dialogs/edit-church/edit-pastor-church-dialog.html',
                parent: angular.element($document.body),
                bindToController: true,
                locals: {
                    church: church,
                    callback: function () {
                        getPastor(church.pastor_id);
                        getChurches(church.pastor_id);
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function triggered when a contact is selected
         */
        function selectContact(contact) {
            contact.selected = true;
            vm.newContact = false;

            vm.pastor.contacts = vm.pastor.contacts.map(function (contact) {
                if (contact && contact.selected) contact.selected = false;
                return contact;
            });
            contact.selected = true;

            if (currentUser.$roles.has(['admin', 'metrics', 'pastor_coordinator', 'branch_head'])) {
                $mdDialog.show({
                    controller: 'EditContactDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/thrive/tabs/pastors/dialogs/edit-contact/edit-contact-dialog.html',
                    parent: angular.element($document.body),
                    bindToController: true,
                    locals: {
                        pastorId: pastor,
                        contact: contact,
                        pastor: vm.pastor,
                        callback: function () {
                            contact.selected = false;
                        }
                    },
                    clickOutsideToClose: true
                });
            }
        }

        /*
        Function triggered when edit contact is clicked
         */
        function editContact(contact) {
            if (currentUser.$roles.has(['admin', 'metrics', 'pastor_coordinator', 'branch_head'])) {
                $mdDialog.show({
                    controller: 'EditContactDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/thrive/tabs/pastors/dialogs/edit-contact/edit-contact-dialog.html',
                    parent: angular.element($document.body),
                    bindToController: true,
                    locals: {
                        pastorId: pastor,
                        contact: contact,
                        pastor: vm.pastor,
                        callback: function () {
                            getPastor(pastor);
                        }
                    },
                    clickOutsideToClose: true
                });
            }
        }

        /*
        Function triggered when delete church button is clicked
         */
        function deleteChurch(church) {
            $mdDialog.show({
                controller: 'DeleteChurchInPastorDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
                parent: angular.element($document.body),
                bindToController: true,
                locals: {
                    pastor: vm.pastor,
                    church: church,
                    callback: function () {
                        getPastor(pastor);
                        getChurches(pastor);
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function triggered when add new contact is clicked
         */
        function addContact() {
            vm.newContact = true;

            $mdDialog.show({
                controller: 'NewContactDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/thrive/tabs/pastors/dialogs/add-contact/add-contact-dialog.html',
                parent: angular.element($document.body),
                bindToController: true,
                locals: {
                    pastorId: pastor,
                    pastor: vm.pastor,
                    callback: function () {
                        vm.newContact = false;
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Closes bottom sheet
         */
        function closeBottomSheet() {
            $mdBottomSheet.hide();
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.thrive')
        .controller('EditDistrictDialogController', EditDistrictDialogController);

    /** @ngInject */
    function EditDistrictDialogController($mdDialog,
                                          district,
                                          DistrictService,
                                          drawDistrictsTable,
                                          Auth,
                                          BaseService) {

        var vm = this;

        vm.currentUser = Auth.getUser();

        vm.dialogTitle = 'Edit district';
        vm.district = {};

        //Methods
        vm.closeDialog = closeDialog;
        vm.editDistrict = editDistrict;
        vm.searchBaseChange = searchBaseChange;
        vm.searchBaseNames = searchBaseNames;
        vm.selectBaseName = selectBaseName;

        activate();

        /*
        Function used to fetch all bases and get districts details
         */
        function activate() {
            vm.district = {
                id: district.id,
                name: district.name,
                base_id: district.base.id,
                branch_id: district.branch_id
            };

            BaseService.getBase(district.base, {
                nopage: 1,
                with: 'branches'
            })
                .then(function (data) {
                    vm.branches = data.branches;
                });

            vm.selectedBaseName = district.base.name;
        }

        /*
        Function used to add a district
         */
        function editDistrict(district) {
            vm.saving = true;
            DistrictService.editDistrict(district).then(function () {
                vm.saving = false;
                drawDistrictsTable();
                closeDialog();
            });
        }

        /*
        Function that assigns base upon select in autocomplete
         */
        function selectBaseName(base) {
            vm.selectedBaseName = base;
            vm.branches = base.branches;
            vm.district.base_id = base.id;
        }

        /*
        Function to close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        /*
        Function used to query bases in autocomplete
         */
        function searchBaseNames(query) {
            return BaseService.getBases({
                search: query,
                base_id: vm.currentUser.base_id,
                nopage: true,
                with: 'branches'
            });
        }

        /*
        Function used to listen base text change
         */
        function searchBaseChange(base) {
            // vm.application.base_id = base ? base.id : '';
            vm.branches = base ? base.branches : [];
        }

    }
})();
(function () {
    'use strict';

    angular.module('app.thrive')
        .controller('DeleteDistrictDialogController', DeleteDistrictDialogController);

    /** @ngInject */
    function DeleteDistrictDialogController($mdDialog,
                                            $document,
                                            district,
                                            DistrictService,
                                            drawDistrictsTable) {
        var vm = this;

        vm.dialogTitle = 'Delete district';
        vm.message = 'Are you sure to delete this district?';
        vm.passwordConfirmation = passwordConfirmation;

        //Methods
        vm.closeDialog = closeDialog;
        vm.deleteCallback = deleteCallback;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteCallback(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to delete district
         */
        function deleteCallback() {
            vm.saving = true;
            DistrictService.deleteDistrict(district).then(function () {
                vm.saving = false;
                drawDistrictsTable();
                closeDialog();
            });
        }

        /*
        Function to close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.thrive')
        .controller('NewDistrictDialogController', NewDistrictDialogController);

    /** @ngInject */
    function NewDistrictDialogController($mdDialog,
                                         DistrictService,
                                         drawDistrictsTable,
                                         Auth,
                                         BaseService) {

        var vm = this;

        vm.currentUser = Auth.getUser();
        if (vm.currentUser.base_id) {
            getBases();
        }

        vm.dialogTitle = 'Add district';
        vm.district = {};
        vm.branches = [];

        //Methods
        vm.closeDialog = closeDialog;
        vm.addDistrict = addDistrict;
        vm.searchBaseChange = searchBaseChange;
        vm.searchBaseNames = searchBaseNames;
        vm.selectBaseName = selectBaseName;

        /*
        Function used to add a district
         */
        function addDistrict(district) {
            vm.saving = true;
            DistrictService.addDistrict(district).then(function () {
                vm.saving = false;
                drawDistrictsTable();
                closeDialog();
            });
        }

        /*
        Function that assigns base upon select in autocomplete
         */
        function selectBaseName(base) {
            vm.selectedBaseName = base;
            vm.branches = base.branches;
            vm.district.base_id = base.id;
        }

        /*
        Function to close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        /*
        Function used to query bases in autocomplete
         */
        function searchBaseNames(query) {
            return BaseService.getBases({
                search: query,
                nopage: true,
                base_id: vm.currentUser.base_id,
                with: 'branches'
            });
        }

        /*
        Function that gets all bases by search text
         */
        function getBases() {
            BaseService.getBases({
                nopage: true,
                base_id: vm.currentUser.base_id,
                with: 'branches'
            }).then(function (response) {
                vm.selectedBaseName = response[0];
                vm.district.branch_id = vm.currentUser.branch_id;
            });
        }

        /*
        Function used to listen base text change
         */
        function searchBaseChange(base) {
            // vm.application.base_id = base ? base.id : '';
            vm.branches = base ? base.branches : [];
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.thrive')
        .controller('PromoteCounselorDialogController', PromoteCounselorDialogController);

    /** @ngInject */
    function PromoteCounselorDialogController($mdDialog,
                                              counselor,
                                              church,
                                              callback,
                                              PastorService,
                                              enumFields,
                                              ProvinceService,
                                              CityService,
                                              BarangayService,
                                              BaseService,
                                              ChurchService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.promoteCounselor = promoteCounselor;

        vm.apiErrors = {};
        vm.counselor = counselor;

        vm.dialogTitle = "Promote Lay Leader to Pastor";

        enumFields(["gender", "marital_status", "educational_attainment", "church_position"])
            .then(function (values) {
                vm.gender = values.gender;
                vm.marital_status = values.marital_status;
                vm.educational_attainment = values.educational_attainment;
                vm.church_position = values.church_position;
            });

        // fix the birthdate
        vm.counselor.birth_date = counselor.birthdate ? new Date(counselor.birthdate) : null;

        // yes/no select optoin
        vm.yesno = [
            {label: "Yes", value: true},
            {label: "No", value: false}
        ];

        vm.selectBase = function (base) {
            vm.counselor.base = base;
        };

        // search province
        vm.selectedProvince = null;
        vm.searchProvince = null;
        vm.searchProvinces = function (name) {
            return ProvinceService.getProvinces({
                search: name
            }).then(function (response) {
                return response.data;
            });
        };
        vm.selectProvince = function (province) {
            vm.counselor.province_id = province.id;
            vm.counselor.city_id = null;
            vm.counselor.barangay_id = null;
        };

        // search city
        vm.selectedCity = null;
        vm.searchCity = null;
        vm.searchCities = function (name) {
            return CityService.getCities({
                province_id: vm.counselor.province_id,
                search: name
            }).then(function (response) {
                return response.data;
            });
        };
        vm.selectCity = function (city) {
            vm.counselor.city_id = city.id;
            vm.counselor.barangay_id = null;
        };

        // search barangay
        vm.selectedBarangay = null;
        vm.searchBarangay = null;
        vm.searchBarangays = function (name) {
            return BarangayService.getBarangays({
                city_id: vm.counselor.city_id,
                search: name
            });
        };
        vm.selectBarangay = function (barangay) {
            vm.counselor.barangay_id = barangay.id;
        };

        function initBases() {
            BaseService.getBases({
                nopage: 1,
                with: "districts"
            })
                .then(function (data) {
                    vm.bases = data;
                });
        }

        initBases();

        // search church
        vm.selectedChurch = null;
        vm.searchChurch = null;
        vm.searchChurches = function (name) {
            return ChurchService.getChurches({
                search: name
            }).then(function (response) {
                return response.data;
            });
        };
        vm.selectChurch = function (church) {
            vm.counselor.church_id = church.id;
        };

        /*
        Function that is used to promote a counselor to a pastor
         */
        function promoteCounselor(counselor, form) {
            vm.saving = true;
            vm.apiErrors = {};

            var data = {
                counselor_id: counselor.id,
                base_id: counselor.base_id,
                district_id: counselor.district_id,
                province_id: counselor.province.id,
                city_id: counselor.city.id,
                barangay_id: counselor.barangay.id,
                address: counselor.address,

                firstname: counselor.firstname,
                middlename: counselor.middlename,
                lastname: counselor.lastname,

                email: counselor.email,
                birth_date: counselor.birth_date,
                gender: counselor.gender,
                status: counselor.status,
                educational_attainment: counselor.educational_attainment,
                seminary: counselor.seminary
            };

            return PastorService.addPastor(data)
                .then(function (response) {

                    ChurchService.deleteLayleader(church, counselor)
                        .then(function () {
                            vm.saving = false;
                            callback();
                            closeDialog();
                        });
                })
                .catch(function (response) {
                    vm.saving = false;
                    form.$invalid = true;

                    for (var field in response.data.errors) {
                        vm.apiErrors[field] = response.data.errors[field].shift();
                    }
                });
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.settings')
        .controller('NewChurchDialogController', NewChurchDialogController);

    /** @ngInject */
    function NewChurchDialogController($mdDialog,
        initChurchesTable,
        ChurchService,
        ChurchAffiliationService,
        BaseService,
        ProvinceService,
        CityService,
        BarangayService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.addNewChurch = addNewChurch;

        vm.apiErrors = {};
        vm.church = {};

        vm.dialogTitle = "Add Church";

        // handle shoe/hide alert note
        vm.showAlertNote = true;

        vm.closeNote = function () {
            vm.showAlertNote = false;
        };

        vm.selectedBaseName = null;
        vm.searchBaseName = null;
        vm.selectBaseName = selectBaseName;
        vm.searchBaseChange = searchBaseChange;
        vm.searchBaseNames = searchBaseNames;

        vm.countrys = [
            { id: "PH", name: "Philippines" },
            { id: "GM", name: "Guatemala" },
            { id: "UG", name: "Uganda" },
            { id: "BU", name: "Burundi" },
            { id: "KH", name: "Cambodia" },
        ]

        vm.handleCountryChange = function (country_code) {
            if (vm.selectedBaseName) {
                vm.selectedBaseName = null;
            }
        }

        /*
        Function that assigns a base to the application
         */
        function selectBaseName(base) {
            if (base) {
                vm.selectedBaseName = base;
                vm.branches = base.branches;
                vm.districts = base.districts;
                vm.church.base_id = base.id;
            } else {
                vm.selectedBaseName = null;
                vm.church.branch_id = null;
                vm.church.district_id = null;
                vm.church.base_id = null;
                vm.branches = [];
                vm.districts = [];
            }
            vm.selectedProvince = null;
            vm.searchProvince = null;
        }

        /*
        Function that listens for base text change
        */
        function searchBaseChange(base) {
            vm.searchBaseName = base ? base : null;
        }
        /*
        Function that search bases by search text
         */
        function searchBaseNames(query) {
            return BaseService.getBases({
                search: query,
                country_code: vm.church.country_code,
                nopage: true,
                with: 'branches,districts'
            });
        }

        /*
        Function that use to get districts from selected base and branch
         */
        vm.getDistricts = function () {
            if (vm.church.branch_id) {
                return vm.districts.filter(function (district) {
                    return district.branch_id === vm.church.branch_id;
                });
            } else {
                return [];
            }
        }

        // search affiliation
        vm.selectedChurchAffiliation = null;
        vm.searchChurchAffiliation = null;
        vm.searchChurchAffiliations = function (name) {
            return ChurchAffiliationService.getChurchAffiliations({
                search: name
            }).then(function (response) {
                return response.data;
            });
        };
        vm.selectChurchAffiliation = function (affiliation) {
            vm.church.church_affiliation_id = affiliation.id;
        };

        // search province
        vm.selectedProvince = null;
        vm.searchProvince = null;
        vm.searchProvinces = function (name) {
            return ProvinceService.getProvinces({
                search: name,
                // base_id: vm.church.base_id
            }).then(function (response) {
                return response.data;
            });
        };
        vm.selectProvince = function (province) {
            vm.church.province_id = province.id;
            vm.church.parent_province_id = province.parent_province_id;
            vm.church.city_id = null;
            vm.church.barangay_id = null;
        };

        // search city
        vm.selectedCity = null;
        vm.searchCity = null;
        vm.searchCities = function (name) {
            return CityService.getCities({
                province_id: vm.church.parent_province_id ? vm.church.parent_province_id : vm.church.province_id,
                search: name
            }).then(function (response) {
                return response.data;
            });
        };
        vm.selectCity = function (city) {
            vm.church.city_id = city.id;
            vm.church.barangay_id = null;
        };

        // search barangay
        vm.selectedBarangay = null;
        vm.searchBarangay = null;
        vm.searchBarangays = function (name) {
            return BarangayService.getBarangays({
                city_id: vm.church.city_id,
                search: name
            });
        };
        vm.selectBarangay = function (barangay) {
            vm.church.barangay_id = barangay.id;
        };

        /*
        Function used to add new church
         */
        function addNewChurch(church, form) {
            vm.saving = true;
            vm.apiErrors = {};

            return ChurchService.addChurch(church)
                .then(function () {
                    vm.saving = false;
                    initChurchesTable();
                    closeDialog();
                })
                .catch(function (response) {
                    vm.saving = false;
                    form.$invalid = true;

                    for (var field in response.data.errors) {
                        vm.apiErrors[field] = response.data.errors[field].shift();
                    }
                });
        }

        /*
        Function that closes modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.settings')
        .controller('EditChurchDialogController', EditChurchDialogController);

    /** @ngInject */
    function EditChurchDialogController($mdDialog,
        initChurchesTable,
        church,
        ChurchService,
        ChurchAffiliationService,
        ProvinceService,
        BaseService,
        CityService,
        BarangayService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.editChurch = editChurch;

        vm.dialogTitle = "Edit Church";
        vm.apiErrors = {};

        vm.church = {
            id: church.id,
            name: church.name,
            church_affiliation_id: church.church_affiliation_id,
            base_id: church.base_id,
            branch_id: church.branch_id,
            district_id: church.district_id,
            province_id: church.province_id,
            city_id: church.city_id,
            barangay_id: church.barangay_id,
            address: church.address,
            added_by_icm: church.added_by_icm,
            country_code: church.country_code || null,
        };
        vm.isUpdateProvince = false;
        vm.selectedBaseName = null;
        vm.searchBaseName = null;
        vm.selectBaseName = selectBaseName;
        vm.searchBaseChange = searchBaseChange;
        vm.searchBaseNames = searchBaseNames;

        vm.countrys = [
            { id: "PH", name: "Philippines" },
            { id: "GM", name: "Guatemala" },
            { id: "UG", name: "Uganda" },
            { id: "BU", name: "Burundi" },
            { id: "KH", name: "Cambodia" },
        ]

        vm.handleCountryChange = function (country_code) {
            if (vm.selectedBaseName) {
                vm.selectedBaseName = null;
            }
        }

        if (vm.church.base_id) {
            getBaseByID(vm.church.base_id)
        }

        /*
        Function that get base by base_id
         */
        function getBaseByID(base_id) {
            BaseService.getBase({ id: base_id }, {
                country_code: vm.church.country_code,
                nopage: true,
                with: 'branches,districts'
            }).then(function (response) {
                vm.selectedBaseName = response;
                vm.branches = response.branches;
                vm.districts = response.districts;
            });
        }


        /*
        Function that assigns a base to the application
         */
        function selectBaseName(base) {
            if (base) {
                vm.selectedBaseName = base;
                vm.branches = base.branches;
                vm.districts = base.districts;
                vm.church.base_id = base.id;
            } else {
                vm.selectedBaseName = null;
                vm.church.branch_id = null;
                vm.church.district_id = null;
                vm.church.base_id = null;
                vm.branches = [];
                vm.districts = [];
            }

            if (vm.isUpdateProvince) {
                vm.selectedProvince = null;
                vm.searchProvince = null;
            }
            vm.isUpdateProvince = true;
        }

        /*
        Function that listens for base text change
        */
        function searchBaseChange(base) {
            vm.searchBaseName = base ? base : null;
        }
        /*
        Function that search bases by search text
         */
        function searchBaseNames(query) {
            return BaseService.getBases({
                search: query,
                country_code: vm.church.country_code,
                nopage: true,
                with: 'branches,districts'
            });
        }

        /*
        Function that use to get districts from selected base and branch
         */
        vm.getDistricts = function () {
            if (vm.church.branch_id && vm.districts) {
                return vm.districts.filter(function (district) {
                    return district.branch_id === vm.church.branch_id;
                });
            } else {
                return [];
            }
        }


        // search affiliation
        vm.selectedChurchAffiliation = church.affiliation;
        vm.searchChurchAffiliation = null;
        vm.searchChurchAffiliations = function (name) {
            return ChurchAffiliationService.getChurchAffiliations({
                search: name
            }).then(function (response) {
                return response.data;
            });
        };
        vm.selectChurchAffiliation = function (affiliation) {
            vm.church.church_affiliation_id = affiliation.id;
        };

        // search province
        vm.selectedProvince = church.province;
        vm.searchProvince = null;
        vm.searchProvinces = function (name) {
            return ProvinceService.getProvinces({
                search: name,
                // base_id: vm.church.base_id
            }).then(function (response) {
                return response.data;
            });
        };
        vm.selectProvince = function (province) {
            if (province) {
                vm.church.province_id = province.id;
                vm.church.parent_province_id = province.parent_province_id;
                vm.church.city_id = null;
                vm.church.barangay_id = null;

                vm.selectedCity = null;
                vm.searchCity = null;
                vm.selectedBarangay = null;
                vm.searchBarangay = null;
            }
        };

        // search city
        vm.selectedCity = church.city;
        vm.searchCity = null;
        vm.searchCities = function (name) {
            return CityService.getCities({
                province_id: vm.church.parent_province_id ? vm.church.parent_province_id : vm.church.province_id,
                search: name
            }).then(function (response) {
                return response.data;
            });
        };
        vm.selectCity = function (city) {
            vm.church.city_id = city ? city.id : null;
            vm.church.barangay_id = null;

            vm.selectedBarangay = null;
            vm.searchBarangay = null;
        };

        // search barangay
        vm.selectedBarangay = church.barangay;
        vm.searchBarangay = null;
        vm.searchBarangays = function (name) {
            return BarangayService.getBarangays({
                city_id: vm.church.city_id,
                search: name
            });
        };
        vm.selectBarangay = function (barangay) {
            vm.church.barangay_id = barangay ? barangay.id : null;
        };

        /*
        Function used to edit church details
         */
        function editChurch(church, form) {
            vm.saving = true;
            vm.apiErrors = {};

            return ChurchService.editChurch(church)
                .then(function (data) {
                    vm.saving = false;
                    initChurchesTable();
                    closeDialog();
                })
                .catch(function (response) {
                    vm.saving = false;
                    form.$invalid = true;

                    for (var field in response.data.errors) {
                        vm.apiErrors[field] = response.data.errors[field].shift();
                    }
                });
        }

        /*
        Function that closes modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.thrive')
        .controller('DeletePastorInChurchDialogController', DeletePastorInChurchDialogController);

    /** @ngInject */
    function DeletePastorInChurchDialogController($mdDialog,
                                                 $document,
                                                  church,
                                                  pastor,
                                                  getPastors,
                                                  ChurchService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.deleteCallback = deleteCallback;

        vm.dialogTitle = "Delete Pastor";
        vm.message = 'Are you sure to delete this pastor in this church?';
        vm.passwordConfirmation = passwordConfirmation;
        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteCallback(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteCallback(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to delete a pastor of that church
         */
        function deleteCallback() {
            vm.saving = true;
            return ChurchService.deletePastor(church, pastor)
                .then(function () {
                    vm.saving = false;
                    getPastors();
                    closeDialog();
                });
        }

        /*
        Function used to close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.thrive')
        .controller('DeleteLayleaderInChurchDialogController', DeleteLayleaderInChurchDialogController);

    /** @ngInject */
    function DeleteLayleaderInChurchDialogController($mdDialog,
                                                     $document,
                                                     church,
                                                     layleader,
                                                     getCounselors,
                                                     ChurchService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.deleteCallback = deleteCallback;

        vm.dialogTitle = "Delete Lay Leader";
        vm.message = 'Are you sure to delete this lay leader in this church?';
        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteCallback(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to delete a lay leader in that church
         */
        function deleteCallback() {
            vm.saving = true;
            return ChurchService.deleteLayleader(church, layleader)
                .then(function () {
                    vm.saving = false;
                    getCounselors();
                    closeDialog();
                });
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.settings')
        .controller('DeleteChurchDialogController', DeleteChurchDialogController);

    /** @ngInject */
    function DeleteChurchDialogController($mdDialog,
        $document,
        callback,
        church,
        hardDelete,
        ChurchService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.deleteCallback = deleteCallback;

        vm.dialogTitle = "Delete Church";
        vm.message = 'Are you sure to permanent delete this church?';
        vm.hardDelete = hardDelete;

        vm.reason = [
            "No Longer wants to be a part of ICM",
            "Duplicate",
        ];

        vm.form = {
            reason: church.reason_for_dropping ? church.reason_for_dropping : "",
        };

        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteCallback(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        // Function use to delete a church
        function deleteCallback() {
            vm.saving = true;

            if (Array.isArray(church)) {
                // Prepare URL-encoded data
                const urlencoded = new URLSearchParams();
                church.forEach(id => urlencoded.append("church_ids[]", id));
                urlencoded.append("reasons_for_dropping", vm.form.reason || "");

                // Call the delete function with formatted data
                ChurchService.deleteBulkChurch(urlencoded.toString())
                    .then(function () {
                        callback();
                        closeDialog();
                    })
                    .finally(function () {
                        vm.saving = false;
                    });
                return;
            }

            if (vm.hardDelete) {
                return ChurchService.hardDeleteChurch(church)
                    .then(function () {
                        vm.saving = false;
                        callback();
                        closeDialog();
                    });
            }

            if (vm.form.reason) {
                church.reason_for_dropping = vm.form.reason;
            }

            // Update the church dropping reason
            return ChurchService.editChurch(church)
                .then(function (data) {
                    return ChurchService.deleteChurch(church)
                        .then(function () {
                            vm.saving = false;
                            callback();
                            closeDialog();
                        });
                })
                .catch(function (response) {
                    vm.saving = false;
                });
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.thrive')
        .controller('AddPastorInChurchController', AddPastorInChurchController);

    /** @ngInject */
    function AddPastorInChurchController($mdDialog,
                                         PastorService,
                                         church,
                                         enumFields,
                                         getPastors,
                                         ChurchService) {
        var vm = this;

        vm.dialogTitle = 'Add Pastor';
        vm.selectedPastor = null;
        vm.pastor = {};

        //Methods
        vm.closeDialog = closeDialog;
        vm.addPastor = addPastor;
        vm.selectPastor = selectPastor;
        vm.searchPastors = searchPastors;

        activate();

        function activate() {
            enumFields(["church_position"])
                .then(function (values) {
                    vm.church_position = values.church_position;
                });

        }

        /*
        Function used to add pastor to that church
         */
        function addPastor(pastor) {
            var pastorObj = {
                pastor_id: pastor.pastor_id,
                position: pastor.position
            };
            vm.saving = true;
            ChurchService.addPastor(church, pastorObj).then(function () {
                vm.saving = false;
                getPastors();
                closeDialog();
            })
        }

        /*
        Function used to select a pastor
         */
        function selectPastor(pastor) {
            vm.selectedPastor = pastor;
            vm.pastor.pastor_id = pastor.id;
        }

        /*
        Function used to search for pastors based on search text
         */
        function searchPastors(query) {
            return PastorService.searchPastors({
                search: query,
                check_status: 1,
                page: 1,
                limit: 20
            });
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.thrive')
        .controller('AddExistingLayleaderInChurchController', AddExistingLayleaderInChurchController);

    /** @ngInject */
    function AddExistingLayleaderInChurchController($mdDialog,
                                                    getCounselors,
                                                    church,
                                                    ParticipantService,
                                                    ChurchService) {
        var vm = this;

        vm.dialogTitle = 'Add Existing Lay Leader';
        vm.selectedLayleader = null;
        vm.layleader = {};

        //Methods
        vm.closeDialog = closeDialog;
        vm.addLayLeader = addLayLeader;
        vm.selectLayleader = selectLayleader;
        vm.searchLayleaders = searchLayleaders;

        /*
        Function used to open add layleader modal
         */
        function addLayLeader(layleader) {
            var layleaderObj = {
                counselor_id: layleader.id
            };
            vm.saving = true;
            ChurchService.addLayleader(church, layleaderObj).then(function () {
                vm.saving = false;
                getCounselors();
                closeDialog();
            });
        }

        /*
        Function used to select layleader
         */
        function selectLayleader(layleader) {
            vm.selectedLayleader = layleader;
            vm.layleader.id = layleader.id;
        }

        /*
        Function used to search for layleaders name based on search text
         */
        function searchLayleaders(query) {
            return ParticipantService.getParticipants({
                search: query,
                is_counselor: 1
            }).then(function(response) {
                return response.data;
            });
        }

        /*
        Function used to close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.thrive')
        .controller('AddLayleaderInChurchController', AddLayleaderInChurchController);

    /** @ngInject */
    function AddLayleaderInChurchController($mdDialog,
                                            enumFields,
                                            getCounselors,
                                            layLeaderObj,
                                            church,
                                            ParticipantService,
                                            ChurchService) {
        var vm = this;

        if (layLeaderObj) {
            vm.dialogTitle = 'Edit Lay Leader';
            vm.footerTitle = 'Edit Lay Leader';
            vm.participant = layLeaderObj;
        } else {
            vm.dialogTitle = 'Add New Lay Leader';
            vm.footerTitle = 'Add Lay Leader';
        }

        //Methods
        vm.closeDialog = closeDialog;
        vm.addLayLeader = addLayLeader;

        enumFields(["gender"])
            .then(function (values) {
                vm.genders = values.gender;
            });

        /*
        Function used to add layleader to the church
         */
        function addLayLeader(participant) {
            vm.saving = true;
            participant.is_counselor = 1;
            if(layLeaderObj) {
                participant.id = layLeaderObj.id;
                participant.birthdate = layLeaderObj.birthdate ? layLeaderObj.birthdate : undefined;
                participant.phone_number = layLeaderObj.phone_number ? layLeaderObj.phone_number : undefined;
                participant.participant_id = layLeaderObj.participant_id ? layLeaderObj.participant_id : undefined;
                delete participant.application_id;
                ParticipantService.editParticipant(participant).then(function(response) {
                    vm.saving = false;
                    getCounselors();
                    closeDialog();
                })
            } else {
                ParticipantService.addParticipant(participant)
                    .then(function (response) {
                        var counselor = response;
                        counselor.counselor_id = counselor.id;
                        ChurchService.addLayleader(church, counselor).then(function () {
                            vm.saving = false;
                            getCounselors();
                            closeDialog();
                        });
                    }).catch(function (response) {
                    vm.saving = false;
                });
            }
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }

})();
(function () {
    'use strict';

    angular
        .module('app.thrive')
        .controller('ChurchDetailsController', ChurchDetailsController);

    /** @ngInject */
    function ChurchDetailsController($mdBottomSheet,
        $scope,
        $timeout,
        $state,
        $mdDialog,
        $document,
        churchObj,
        BaseService,
        PastorService,
        enumFields,
        initChurchesTable,
        ChurchAffiliationService,
        ProvinceService,
        CityService,
        ParticipantService,
        BarangayService,
        ChurchService, Auth) {
        var vm = this;
        var currentUser = Auth.getUser();
        vm.userCountry = currentUser ? currentUser.country_code : null;

        vm.church = churchObj;
        vm.clickedEdit = false;

        vm.selectedDenomination = churchObj.affiliation;
        vm.selectedProvince = churchObj.province;
        vm.selectedCity = churchObj.city;
        vm.selectedBarangay = churchObj.barangay;
        vm.sliderHeight = $document.height() - 350;

        vm.searchProvince = null;
        vm.searchDenomination = null;
        vm.searchCity = null;
        vm.searchBarangay = null;

        // base
        vm.selectedBaseName = null;
        vm.searchBaseName = null;
        vm.selectBaseName = selectBaseName;
        vm.searchBaseChange = searchBaseChange;
        vm.searchBaseNames = searchBaseNames;

        vm.countrysEnum = {
            PH: "Philippines",
            GU: "Guatemala",
            UG: "Uganda",
            BI: "Burundi",
            KH: "Cambodia",
        }

        vm.countrys = [
            { id: "PH", name: "Philippines" },
            { id: "GM", name: "Guatemala" },
            { id: "UG", name: "Uganda" },
            { id: "BU", name: "Burundi" },
            { id: "KH", name: "Cambodia" },
        ]

        vm.handleCountryChange = function (country_code) {
            if (vm.selectedBaseName) {
                vm.selectedBaseName = null;
            }

            var basePayload = {
                nopage: 1,
                country_code: country_code,
                with: "districts"
            }

            BaseService.getBases(basePayload)
                .then(function (data) {
                    vm.pastor.base_id = null;
                    vm.bases = data;
                });
        }


        //Methods
        vm.closeBottomSheet = closeBottomSheet;
        vm.selectDenomination = selectDenomination;
        vm.searchDenominations = searchDenominations;
        vm.selectProvince = selectProvince;
        vm.searchProvinces = searchProvinces;
        vm.selectCity = selectCity;
        vm.searchCities = searchCities;
        vm.selectBarangay = selectBarangay;
        vm.searchBarangays = searchBarangays;
        vm.editChurch = editChurch;
        vm.addNewPastor = addNewPastor;
        vm.addNewLayLeader = addNewLayLeader;
        vm.deletePastor = deletePastor;
        vm.deleteLayleader = deleteLayleader;
        vm.pageChange = pageChange;
        vm.pageChangeLayleaders = pageChangeLayleaders;
        vm.stateChange = stateChange;
        vm.goToProfile = goToProfile;
        vm.goToCommunity = goToCommunity;
        vm.addExistingLayLeader = addExistingLayLeader;
        vm.promoteCounselor = promoteCounselor;
        vm.setFocus = setFocus;
        vm.editLayleader = editLayleader;

        //listen for state change
        $scope.$on('$stateChangeStart', function () {
            vm.stateChange();
        });

        activate();

        enumFields(["church_position"])
            .then(function (values) {
                vm.church_position = values.church_position;
            });

        /*
        Function used to fetch all pastors and couselors of the church
         */
        function activate() {
            getPastors(1);
            getCounselors(1);

            if (vm.church.base_id) {
                getBaseByID(vm.church.base_id)
            }
        }

        /*
        Function used to go to pastor profile
         */
        function goToProfile(pastor) {
            $state.go("app.thrive.pastors.details", { id: pastor.id }, false);
        }

        /*
        Function used to go to the community of that layleader
         */
        function goToCommunity(layleader) {
            if (layleader.community) {
                $state.go('app.community.attendance', { id: layleader.community.id });
            }
        }

        /*
        Function used to set focus the church name when editing church
         */
        function setFocus() {
            vm.clickedEdit = true;
            $timeout(function () {
                document.querySelector('#church-name-details').focus();
            }, 0);
        }

        /*
        Function used to get all pastors
         */
        function getPastors(page) {
            vm.isLoading1 = true;
            PastorService.getPastors({
                church_id: churchObj.id,
                page: page,
                with: 'churches'
            }).then(function (response) {
                vm.isLoading1 = false;
                vm.pastors = response;
                var pastors = angular.forEach(response.data, function (item) {
                    var position = item.churches[0].pivot.position;
                    vm.church_position.forEach(function (pos) {
                        if (position === pos.value) {
                            item.pastor_position = pos.label;
                        }
                    });
                    return item;
                });
                vm.pastors.data = pastors;
            })
        }

        /*
        Function that get base by base_id
         */
        function getBaseByID(base_id) {
            BaseService.getBase({ id: base_id }, {
                country_code: vm.church.country_code,
                nopage: true,
                with: 'branches,districts'
            }).then(function (response) {
                vm.selectedBaseName = response;
                vm.branches = response.branches || [];
                vm.districts = response.districts || [];

                if (vm.church.branch_id) {
                    vm.selectedBranchName = vm.branches.find(function (branch) {
                        return branch.id === vm.church.branch_id;
                    });
                }
                if (vm.church.district_id) {
                    vm.selectedDistrictName = vm.districts.find(function (district) {
                        return district.id === vm.church.district_id;
                    });
                }
            });
        }

        /*
        Function that assigns a base to the application
         */
        function selectBaseName(base) {
            if (base) {
                vm.selectedBaseName = base;
                vm.branches = base.branches;
                vm.districts = base.districts;
                vm.church.base_id = base.id;
            } else {
                vm.selectedBaseName = null;
                vm.church.branch_id = null;
                vm.church.district_id = null;
                vm.church.base_id = null;
                vm.branches = [];
                vm.districts = [];
            }

            if (vm.isUpdateProvince) {
                // Reset the province, city & barangay after initial render
                vm.selectedProvince = null;
                vm.searchProvince = null;
                vm.church.province_id = null;

                vm.selectedCity = null;
                vm.searchCity = null;
                vm.church.city_id = null;

                vm.selectedBarangay = null;
                vm.searchBarangay = null;
                vm.church.barangay_id = null;

            }
            vm.isUpdateProvince = true;
        }

        /*
           Function that listens for base text change
           */
        function searchBaseChange(base) {
            vm.searchBaseName = base ? base : null;
        }

        /*
        Function that search bases by search text
         */
        function searchBaseNames(query) {
            return BaseService.getBases({
                search: query,
                country_code: vm.church.country_code,
                nopage: true,
                with: 'branches,districts'
            });
        }

        /*
        Function that use to get districts from selected base and branch
         */
        vm.getDistricts = function () {
            if (vm.church.branch_id && vm.districts) {
                return vm.districts.filter(function (district) {
                    return district.branch_id === vm.church.branch_id;
                });
            } else {
                return [];
            }
        }

        //executed after listening to state change
        function stateChange() {
            closeBottomSheet();
        }

        /*
        Function that listens for every page change of pagination
         */
        function pageChange(page) {
            getPastors(page);
        }

        /*
        Function that listens for every page change of layleaders pagination
         */
        function pageChangeLayleaders(page) {
            getCounselors(page)
        }

        /*
        Function used to get layleaders of the church
         */
        function getCounselors(page) {
            vm.isLoading2 = true;
            ParticipantService.getParticipants({
                church_id: churchObj.id,
                limit: 10,
                page: page
            }).then(function (response) {
                vm.isLoading2 = false;
                vm.layleaders = response;
            })
        }

        /*
        Function used to select affiliation
         */
        function selectDenomination(affiliation) {
            vm.church.affiliation = affiliation;
            vm.church.church_affiliation_id = affiliation.id;
        }

        /*
        Function used to search for affiliations based on search text
         */
        function searchDenominations(name) {
            return ChurchAffiliationService.getChurchAffiliations({
                search: name
            }).then(function (response) {
                return response.data;
            });
        }

        /*
        Function used to search for provinces based on search text
         */
        function searchProvinces(name) {
            return ProvinceService.getProvinces({
                search: name
            }).then(function (response) {
                return response.data;
            });
        }

        /*
        Function used to select a church province
         */
        function selectProvince(province) {
            vm.church.province_id = province.id;
            vm.church.parent_province_id = province.parent_province_id;
            vm.church.city_id = null;
            vm.church.barangay_id = null;

            vm.selectedCity = null;
            vm.searchCity = null;
            vm.selectedBarangay = null;
            vm.searchBarangay = null;
        }

        /*
        Function used to select a city
         */
        function selectCity(city) {
            vm.church.city_id = city.id;
            vm.church.barangay_id = null;

            vm.selectedBarangay = null;
            vm.searchBarangay = null;
        }

        /*
        Function used to search for cities based on search text
         */
        function searchCities(name) {
            return CityService.getCities({
                province_id: vm.church.parent_province_id ? vm.church.parent_province_id : vm.church.province_id,
                search: name
            }).then(function (response) {
                return response.data;
            });
        }

        /*
        Function used to select a barangay location of the church
         */
        function selectBarangay(barangay) {
            vm.church.barangay_id = barangay.id;
        }

        /*
        Function used to search for barangay based on search text
         */
        function searchBarangays(name) {
            return BarangayService.getBarangays({
                city_id: vm.church.city_id,
                search: name
            });
        }

        /*
        Function used to edit church details
         */
        function editChurch(church, form) {
            vm.saving = true;
            vm.apiErrors = {};

            return ChurchService.editChurch(church)
                .then(function (data) {
                    vm.saving = false;
                    vm.clickedEdit = false;
                    initChurchesTable();
                    closeBottomSheet();
                })
                .catch(function (response) {
                    vm.saving = false;
                    vm.clickedEdit = true;
                    form.$invalid = true;

                    for (var field in response.data.errors) {
                        vm.apiErrors[field] = response.data.errors[field].shift();
                    }
                });
        }

        /*
        Function used to open add new pastor modal
         */
        function addNewPastor(church) {
            $mdDialog.show({
                controller: 'AddPastorInChurchController',
                controllerAs: 'vm',
                templateUrl: 'app/main/thrive/tabs/churches/dialogs/add-pastor/add-pastor.html',
                parent: angular.element($document.body),
                locals: {
                    church: church,
                    getPastors: function () {
                        getPastors(vm.pastors.current_page)
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to open add new layleader modal
         */
        function addNewLayLeader(church) {
            $mdDialog.show({
                controller: 'AddLayleaderInChurchController',
                controllerAs: 'vm',
                templateUrl: 'app/main/thrive/tabs/churches/dialogs/add-layleader/add-layleader-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    church: church,
                    layLeaderObj: null,
                    getCounselors: function () {
                        getCounselors(vm.layleaders.current_page);
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to open edit layleader modal
         */
        function editLayleader(layleader, church) {
            $mdDialog.show({
                controller: 'AddLayleaderInChurchController',
                controllerAs: 'vm',
                templateUrl: 'app/main/thrive/tabs/churches/dialogs/add-layleader/add-layleader-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    church: church,
                    layLeaderObj: layleader,
                    getCounselors: function () {
                        getCounselors(vm.layleaders.current_page);
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to open add existing layleader modal
         */
        function addExistingLayLeader(church) {
            $mdDialog.show({
                controller: 'AddExistingLayleaderInChurchController',
                controllerAs: 'vm',
                templateUrl: 'app/main/thrive/tabs/churches/dialogs/add-existing-layleader/add-existing-layleader-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    church: church,
                    getCounselors: function () {
                        getCounselors(vm.layleaders.current_page);
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function triggered when check icon is clicked in a counselor and pops up promote counselor modal
         */
        function promoteCounselor(counselor, church) {
            $mdDialog.show({
                controller: 'PromoteCounselorDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/thrive/tabs/churches/dialogs/promote-counselor/promote-counselor-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    counselor: counselor,
                    church: church,
                    callback: function () {
                        getCounselors(vm.layleaders.current_page);
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to open delete pastor dialog modal
         */
        function deletePastor(church, pastor) {
            $mdDialog.show({
                controller: 'DeletePastorInChurchDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    church: church,
                    pastor: pastor,
                    getPastors: function () {
                        getPastors(vm.pastors.current_page);
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to open delete layleader modal
         */
        function deleteLayleader(church, layleader) {
            $mdDialog.show({
                controller: 'DeleteLayleaderInChurchDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    church: church,
                    layleader: layleader,
                    getCounselors: function () {
                        getCounselors(vm.layleaders.current_page);
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Closes bottom sheet
         */
        function closeBottomSheet() {
            initChurchesTable();
            $mdBottomSheet.hide();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.prevail', [])
        .config(config);

   /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.prevail', {
                url: '/prevail',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/prevail/prevail.html',
                        controller: 'PrevailController as vm'
                    }
                }
            })
            .state('app.prevail.savings-groups', {
                url: '/savings-groups',
                data: {
                    selectedTab: 0
                },
                views: {
                    'prevail@savings-groups': {
                        templateUrl: 'app/main/prevail/tabs/savings-groups/savings-groups.html',
                        controller: 'SavingsGroupsController as vm'
                    }
                }
            })
            .state('app.prevail.reports', {
                url: '/reports',
                data: {
                    selectedTab: 1
                },
                views: {
                    'prevail@reports': {
                        templateUrl: 'app/main/prevail/tabs/reports/reports.html',
                        controller: 'PrevailReportsController as vm'
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/prevail');

        // Api
        msApiProvider.register('transform', ['app/data/prevail/prevail.json']);

         // Navigation
         msNavigationServiceProvider.saveItem('fuse', {
            title: '',
            group: true,
            weight: 1
        });

        msNavigationServiceProvider.saveItem('fuse.prevail', {
            title: 'Prevail',
            icon: 'icon-bank',
            state: 'app.prevail.savings-groups',
            translate: 'PREVAIL.PREVAIL_NAV',
            weight: 1,
            regex: function (state) {
                return /^app\.(savings-group-community|prevail).*/.test(state);
            },
            lid: "stlink"
        });
    }
})();
(function () {
    'use strict';

    angular.module('app.prevail')
        .controller('ReasonForDroppingDialogController', ReasonForDroppingDialogController);

    /** @ngInject */
    function ReasonForDroppingDialogController(
        $mdDialog, $document, $filter,
        SavingsGroupService,
        savingsGroup,
        callback
    ) {
        var vm = this;

        //Methods
        vm.dialogTitle = 'Reason for dropping';
        vm.saving = false;
        vm.reasons = [
          'Duplicate',
          'Savings group merged with another ICM savings group.',
          'Lack of loan repayment.',
          'Too difficult to continue compulsory payments.',
          'Lack of leadership / leadership disagreement.',
          'Distrust amongst the members.',
          'Pastor / Church no longer can support the group.',
          'Not enough support from ICM.',
          'Members don’t think the SG is working to increase their income.',
          'Too many members migrated / transferred.',
          'Group members joined other ICM SG groups.',
          'Group members joined other organizations / quick loans.',
          'Failed SG business.',
          'Other'
        ];
        vm.form = {
            id: savingsGroup.id,
            reason: savingsGroup.reason_for_dropping,
            otherReason: ''
        };
        
        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation() {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.handleSubmit(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        vm.closeDialog = function closeDialog() {
            $mdDialog.hide();
        }

        vm.handleSubmit = function handleSubmit() {
            vm.saving = true;
            var savings = Object.assign(savingsGroup, {
                reason_for_dropping: vm.form.reason === 'Other'
                    ? vm.form.otherReason
                    : vm.form.reason,
                partners: (savingsGroup.partners || []).map(function (partner) {
                    return {
                        partner_id: partner.id,
                        start_at: $filter('date')(partner.pivot.start_at, 'yyyy-MM-dd'),
                        end_at: $filter('date')(partner.pivot.end_at, 'yyyy-MM-dd')
                    };
                })
            });
            SavingsGroupService.editSavingsGroup(savings)
                .then(function () {
                    return SavingsGroupService.dropSavingsGroup(vm.form.id)
                })
                .then(callback)
                .then(vm.closeDialog)
                .finally(function () {
                    vm.saving = false;
                });
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.prevail')
        .controller('AddNewSavingsGroupController',
            AddNewSavingsGroupController);

    /** @ngInject */
    function AddNewSavingsGroupController($mdDialog, $filter,
        callback,
        savingsObj,
        SavingsGroupService,
        SmallGroupService,
        ClusterService,
        PastorService,
        BaseService,
        BatchService,
        Auth,
        PartnerService) {
        var vm = this;

        vm.currentUser = Auth.getUser();

        vm.checkedPartner = null;
        vm.cdaPartnerId = 7;
        vm.today = new Date();
        vm.partners = [];
        vm.selectedParners = [];
        vm.small_groups = [];

        if (savingsObj) {
            vm.isEdit = true;
            vm.checked = true;
            vm.dialogTitle = 'Edit Savings Group';
            vm.savingsGroup = {
                id: savingsObj.id,
                cluster: savingsObj.cluster,
                pastor: savingsObj.pastor,
                stream: savingsObj.batch,
                name: savingsObj.name,
                country_code: savingsObj.country_code,
                base: savingsObj.base,
                small_group: null,
            };

            if (savingsObj.partners.length) {
                vm.selectedParners = savingsObj.partners.map(function (ele) {
                    return Object.assign(ele, {
                        start_at: ele.pivot.start_at,
                        end_at: ele.pivot.end_at,
                    });
                })
            }

            if (savingsObj.small_group_id) {
                getSmallGroupById(savingsObj.small_group_id);
            }
        } else {
            vm.dialogTitle = 'Add New Savings Group';
            vm.savingsGroup = {};
        }

        //Methods
        vm.closeDialog = closeDialog;
        vm.addSavingsGroup = addSavingsGroup;
        vm.selectCluster = selectCluster;
        vm.searchClusters = searchClusters;
        vm.searchStreams = searchStreams;
        vm.selectPastor = selectPastor;
        vm.searchPastors = searchPastors;
        vm.selectPartner = selectPartner;
        vm.selectStream = selectStream;
        vm.isChecked = isChecked;
        vm.selectBase = selectBase;
        vm.saveCDADate = saveCDADate;
        vm.closeCDADialog = closeCDADialog;
        vm.onEditDate = onEditDate;
        vm.getSmallGroup = getSmallGroup;

        activate();

        vm.countrys = [
            { id: "PH", name: "Philippines" },
            { id: "GM", name: "Guatemala" },
            { id: "UG", name: "Uganda" },
            { id: "BU", name: "Burundi" },
            { id: "KH", name: "Cambodia" },
        ]

        vm.handleCountryChange = function (country_code) {
            vm.savingsGroup.base = null;
            vm.savingsGroup.base_id = null;
            getBases(country_code);
        }

        vm.changeCluster = function (cluster_id) {
            vm.savingsGroup.small_group = null;
            getSmallGroup(cluster_id)
        }

        /*
        Function used to fetch bases and partners
         */
        function activate() {
            if (vm.savingsGroup.country_code) {
                getBases(vm.savingsGroup.country_code);
            }
            if (savingsObj && savingsObj.cluster_id) {
                getSmallGroup(savingsObj.cluster_id);
            }

            getPartners();
        }

        /*
        Function used to fetch bases
         */
        function getBases(country_code) {
            BaseService.getBases({
                country_code: country_code,
                base_id: vm.currentUser.base_id,
                with: 'branches.clusters',
                nopage: true
            }).then(function (response) {
                if (vm.currentUser.base_id) {
                    vm.savingsGroup.base = response[0];
                }

                vm.bases = response.map(function (item) {
                    item.clusters = [];
                    angular.forEach(item.branches, function (branch) {
                        item.clusters = item.clusters.concat(branch.clusters);
                    });

                    return item;
                });
            });
        }

        /*
        Function used to fetch small groups
         */
        function getSmallGroup(cluster_id) {
            var params = {};

            params.nopage = true;
            params.cluster_id = cluster_id ? cluster_id : null;
            // params.with = 'cluster_id';

            SmallGroupService.getsmallGroups(params)
                .then(function (smallGroups) {
                    vm.small_groups = smallGroups;
                });
        }

        /*
        Function used to fetch small groups by ID
         * @param {number} small_group_id - The ID of the small group to fetch
         */
        function getSmallGroupById(small_group_id) {
            var params = {};

            params.nopage = true;

            SmallGroupService.getSmallGroup(small_group_id, params)
                .then(function (smallGroup) {
                    vm.savingsGroup.small_group = smallGroup;
                });
        }

        /*
        Function used to add a new Savings Group
         */
        function addSavingsGroup(savings) {
            vm.saving = true;
            var obj = {
                cluster_id: savings.cluster.id,
                batch_id: savings.stream.id,
                country_code: savings.country_code,
                base_id: savings.base.id,
                name: savings.name,
                pastor_id: savings.pastor.id,
                small_group_id: savings.small_group ? savings.small_group.id : null,
                partners: vm.selectedParners.map(ele => ({
                    partner_id: ele.id,
                    start_at: $filter('date')(ele.start_at, 'yyyy-MM-dd'), // Properly format the date
                    end_at: $filter('date')(ele.end_at, 'yyyy-MM-dd'), // Format end date as well
                })),
            };
            if (savingsObj) {
                obj.id = savings.id;
                SavingsGroupService.editSavingsGroup(obj).then(function () {
                    vm.saving = false;
                    callback();
                    closeDialog();
                }).catch(function () {
                    vm.saving = false;
                })
            } else {
                SavingsGroupService.addSavingsGroup(obj).then(function () {
                    vm.saving = false;
                    callback();
                    closeDialog();
                }).catch(function () {
                    vm.saving = false;
                })
            }
        }

        /*
        Function used to get partners
         */
        function getPartners() {
            PartnerService.getPartners({ nopage: true }).then(function (response) {
                vm.partners = response;
            })
        }

        /*
        Function used to select a cluster
         */
        function selectCluster(cluster) {
            vm.savingsGroup.cluster = cluster;
            if (cluster) {
                vm.savingsGroup.small_group = null;
                getSmallGroup(cluster.id);
            }
        }

        /*
        Function used to select a stream
         */
        function selectStream(stream) {
            vm.savingsGroup.stream = stream;
        }

        /*
        Function used to select a base
         */
        function selectBase() {
            if (!vm.isEdit && vm.savingsGroup.base.clusters.length) {
                vm.savingsGroup.cluster = vm.savingsGroup.base.clusters[0];
                vm.savingsGroup.small_group = null;
                getSmallGroup(vm.savingsGroup.base.clusters[0].id);
            }
        }

        /*
        Function used to search for clusters based on search text
         */
        function searchClusters(query) {
            return ClusterService.getClusters({
                search: query,
                base_id: vm.savingsGroup.base.id,
                nopage: true
            });
        }

        /*
        Function used to search for streams based on search text
         */
        function searchStreams(query) {
            return BatchService.getBatches({
                search: query,
                nopage: true
            })
        }

        /*
        Function used to select a pastor
         */
        function selectPastor(pastor) {
            vm.savingsGroup.pastor = pastor;
        }

        /*
        Function used to search for pastors based on search text
         */
        function searchPastors(query) {
            return PastorService.searchPastors({
                search: query,
                page: 1,
                limit: 20
            });
        }

        /*
        Function used to select a partner
         */
        function selectPartner(partner) {
            const newObj = angular.copy(partner);
            const clonedArray = Array.from(vm.selectedParners);
            var index = clonedArray.find((ele) => ele.id === partner.id);
            if (index) {
                vm.checkedPartner = null;
                vm.selectedParners = clonedArray.filter((ele) => ele.id != partner.id);
                vm.checked = true;
            } else {
                vm.checkedPartner = newObj;
            }
        }

        /*
        Function used to save date
         */
        function saveCDADate(partner) {
            const newObj = angular.copy(partner);
            const clonedArray = Array.from(vm.selectedParners);
            var index = clonedArray.find((ele) => ele.id === partner.id);
            if (index) {
                vm.selectedParners = clonedArray.map((ele) => {
                    if (ele.id === partner.id) {
                        return newObj;
                    }
                    return ele;
                });
                vm.checkedPartner = null;
            } else {
                vm.selectedParners.push(newObj);
                vm.checkedPartner = null;
            }

            vm.checked = true;
        }

        /*
        Function used to close dates modal
         */
        function closeCDADialog() {
            vm.checkedPartner = null;
        }

        /*
        Function used to set the defaults date on edit
         */
        function onEditDate(partnerId) {
            const selected = vm.selectedParners.find(ele => ele.id === partnerId);
            vm.checkedPartner = angular.copy(selected);
        }

        /*
        Function that checks if a partner has been selected
         */
        function isChecked(partnerId) {
            const clonedArray = Array.from(vm.selectedParners);
            return clonedArray.find((ele) => ele.id === partnerId);
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.prevail')
        .controller('DeleteSavingsGroupDialogController', DeleteSavingsGroupDialogController);

    /** @ngInject */
    function DeleteSavingsGroupDialogController($mdDialog, $document, callback) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.deleteCallback = deleteCallback;

        vm.dialogTitle = "Delete Savings Group";
        vm.message = 'Are you sure you want to delete this Savings Group?';

        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation() {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteCallback(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        /*
        Function used to call delete callback
         */
        function deleteCallback() {
            callback();
            closeDialog();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.community')
        .controller('JoinExistingGroupController',
            JoinExistingGroupController);

    /** @ngInject */
    function JoinExistingGroupController($mdDialog,
        fromPrevail,
        community,
        callback,
        SavingsGroupService,
        ParticipantService) {
        var vm = this;

        vm.dialogTitle = 'Join Existing Group';

        vm.apiErrors = {};
        vm.hasSGData = community.savings_group_data !== null;

        //Methods
        vm.joinExistingGroup = joinExistingGroup;
        vm.closeDialog = closeDialog;
        vm.selectSavingsGroup = selectSavingsGroup;
        vm.searchSavingsGroups = searchSavingsGroups;

        /*
        Function used to join existing SG in Prevail
         */
        function joinExistingGroup(selectedSavingsGroup) {
            vm.saving = true;
            vm.apiErrors = [];
            var communityObj = {
                community_id: community.id
            };


            if (fromPrevail) {
                SavingsGroupService.mergeExistingGroup({
                    saving_group_id: selectedSavingsGroup.id,
                    merge_into: community.id
                })
                    .then(function () {
                        vm.savings = false;
                        callback();
                        closeDialog();
                        alert("Savings Group merged successfully.");
                    })
                    .catch(function (response) {
                        vm.saving = false;

                        vm.apiErrors.community_id = response.data.message || "An error occurred.";

                        for (var field in response.data.errors) {
                            vm.apiErrors[field] = response.data.errors[field].shift();
                        }
                    });
            } else {
                SavingsGroupService.joinExistingGroup(selectedSavingsGroup, communityObj)
                    .then(function () {
                        vm.savings = false;
                        callback();
                        closeDialog();
                        alert("Savings Group joined successfully.");
                    })
                    .catch(function (response) {
                        vm.saving = false;

                        vm.apiErrors.community_id = response.data.message || "An error occurred.";

                        for (var field in response.data.errors) {
                            vm.apiErrors[field] = response.data.errors[field].shift();
                        }
                    });
            }
        }

        /*
        Function to assign a savings group
         */
        function selectSavingsGroup(savingsGroup) {
            vm.selectedSavingsGroup = savingsGroup;
        }

        /*
        Function used to query Savings Group based on search text
         */
        function searchSavingsGroups(query) {
            var application = community.application || null;

            if (fromPrevail) {

                var formData = new FormData();
                if (community.id) {
                    formData.append("saving_group_id", community.id);
                }

                formData.append("search", query);

                return SavingsGroupService.findSavingGroupsMethod({
                    saving_group_id: community.id,
                    search: query
                }).then(function (response) {
                    vm.apiErrors.community_id = ""
                    return response.data;
                }).catch(function (error) {
                    vm.apiErrors.community_id = error.data.message || "Search results not found.";
                    return [];
                })

            } else {
                if (!application && community.branch_id) {
                    application = {
                        base_branch_id: community.branch_id
                    }
                }
                return SavingsGroupService.getSavingsGroups({
                    branch_id: application.base_branch_id,
                    search: query
                }).then(function (response) {
                    return response.data;
                });
            }
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.community')
        .controller('EditDreamSaveIdController',
            EditDreamSaveIdController);

    /** @ngInject */
    function EditDreamSaveIdController($mdDialog,
        participant,
        callback,
        ParticipantService) {
        var vm = this;

        vm.dialogTitle = participant.dreamsave ? 'Edit' : 'Add';
        vm.participant = {};
        vm.defualtVerify = true;
        vm.isVerify = false;
        //Methods
        vm.closeDialog = closeDialog;
        vm.VerifyDreamSaveId = VerifyDreamSaveId;
        vm.editDreamSaveId = editDreamSaveId;
        vm.handleDreamSaveId = handleDreamSaveId;
        vm.checkNumberKey = checkNumberKey;

        activate();

        /*
        Function used to get phone number and kid saver details of the selected participant
         */
        function activate() {
            vm.participant.dreamsave = participant.dreamsave;
            if (participant.dreamsave) vm.showClear = true;
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        /*
        Function used to handle dream save id input value
         */
        function handleDreamSaveId() {
            vm.isVerify = false;
            vm.defualtVerify = false;
        }

        /*
        Function used to handle dream save id validation
         */
        function checkNumberKey(event) {
            var charCode = (event.which) ? event.which : event.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                event.preventDefault();
            }
        };

        /*
        Function used to verify dream save id
         */
        function VerifyDreamSaveId(participantObj) {
            if (participantObj.dreamsave) vm.verifying = true;
            if (!participantObj.dreamsave) vm.clear = true;
            vm.errorDreamSaveId = '';
            participantObj.id = participant.id;
            participantObj.application_id = participant.application_id;

            ParticipantService.verifyParticipantDreamSaveId(participantObj)
                .then(function (res) {
                    vm.verifying = false;
                    vm.clear = false;
                    if (res.status) {
                        vm.isVerify = true;
                        vm.isVerifyMsg = res.message;
                    } else {
                        vm.isVerify = false;
                    }
                })
                .catch(function (response) {
                    vm.errorDreamSaveId = response.data.message;
                    vm.verifying = false;
                    vm.clear = false;
                    vm.isVerify = false;
                });
        }


        function editDreamSaveId(participantObj) {
            if (participantObj.dreamsave) vm.saving = true;
            if (!participantObj.dreamsave) vm.clear = true;
            vm.errorDreamSaveId = '';
            participantObj.id = participant.id;
            participantObj.application_id = participant.application_id;

            ParticipantService.editParticipant(participantObj)
                .then(function () {
                    vm.saving = false;
                    vm.clear = false;
                    callback();
                    closeDialog();
                })
                .catch(function (response) {
                    vm.saving = false;
                    vm.clear = false;
                    if (response.data && response.data.errors) {
                        if (response.data.errors.dreamsave) {
                            vm.errorDreamSaveId = 'This DreamSave ID has already been used.';
                        }
                    }
                });
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.community')
        .controller('EditContactController',
            EditContactController);

    /** @ngInject */
    function EditContactController($mdDialog,
        participant,
        callback,
        ParticipantService) {
        var vm = this;

        vm.dialogTitle = 'Edit';
        vm.participant = {};

        //Methods
        vm.closeDialog = closeDialog;
        vm.editContact = editContact;

        activate();

        /*
        Function used to get phone number and kid saver details of the selected participant
         */
        function activate() {
            vm.participant.phone_number = participant.phone_number;
            vm.participant.is_kid_saver = participant.is_kid_saver;
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        /*
        Function used to edit phone number and kid saver details
         */
        function editContact(participantObj) {
            vm.saving = true;
            vm.errorPhone = '';
            if (!participantObj.phone_number) {
                delete participantObj.phone_number;
            }
            participantObj.id = participant.id;
            participantObj.application_id = participant.application_id;

            ParticipantService.editParticipant(participantObj)
                .then(function () {
                    vm.saving = false;
                    callback();
                    closeDialog();
                })
                .catch(function (response) {
                    vm.saving = false;
                    if (response.data && response.data.errors) {
                        if (response.data.errors.phone_number) {
                            vm.errorPhone = 'Invalid phone no.';
                        }
                    }
                });
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.community')
        .controller('ApproveForPrevailController',
            ApproveForPrevailController);

    /** @ngInject */
    function ApproveForPrevailController($mdDialog,
                                         callback,
                                         $filter,
                                         community,
                                         SavingsGroupService,
                                         ClusterService,
                                         PastorService,
                                         PartnerService) {
        var vm = this;

        vm.dialogTitle = 'Approve For Prevail';
        vm.savingsGroup = {
            pastor: community.application.pastor,
            name: community.group_name
        };

        //Methods
        vm.closeDialog     = closeDialog;
        vm.addSavingsGroup = addSavingsGroup;
        vm.selectPastor    = selectPastor;
        vm.searchPastors   = searchPastors;
        vm.selectPartner   = selectPartner;
        vm.isChecked       = isChecked;
        vm.saveCDADate     = saveCDADate;
        vm.closeCDADialog  = closeCDADialog;
        vm.onEditDate      = onEditDate;

        vm.partners        = [];
        vm.selectedParners = [];
        vm.checkedPartner  = null;
        vm.clusters        = [];

        activate();

        /*
        Function used to call method getPartners and fetch all selected partnets
         */
        function activate() {
            getPartners();
            getClusters();
        }

        /*
        Function used to approve for prevail and add community as Prevail Savings Group
         */
        function addSavingsGroup(savings) {
            vm.saving = true;
            var obj = {
                cluster_id: savings.cluster.id,
                name: savings.name,
                pastor_id: savings.pastor.id,
                community_id: community.id,
                partners: vm.selectedParners.map(ele => ({
                    partner_id: ele.id,
                    start_at: $filter('date')(ele.start_at, 'yyyy-MM-dd'), // Properly format the date
                    end_at: $filter('date')(ele.end_at, 'yyyy-MM-dd'), // Format end date as well
                })),
            };

            SavingsGroupService.addSavingsGroup(obj).then(function () {
                vm.saving = false;
                callback();
                closeDialog();
            }).catch(function () {
                vm.saving = false;
            });
        }

        function getClusters() {
            var application = community.application || null;
            ClusterService.getClusters({
                branch_id : application.base_branch_id,
                nopage    : true
            }).then(function(results) {
                vm.clusters = results;
            })
        }

        /*
        Function used to assign a pastor
         */
        function selectPastor(pastor) {
            vm.savingsGroup.pastor = pastor;
        }

        /*
        Function used to query pastors based on search text
         */
        function searchPastors(query) {
            return PastorService.searchPastors({
                search: query,
                page: 1,
                limit: 20
            });
        }

        /*
        Function used to add in a partner for the Prevail SG
         */
        function selectPartner(partner) {
            const newObj = angular.copy(partner);
            const clonedArray = Array.from(vm.selectedParners);
            var index = clonedArray.find((ele) => ele.id === partner.id);
            if (index) {
                vm.checkedPartner = null;
                vm.selectedParners = clonedArray.filter((ele) => ele.id != partner.id);
                vm.checked = true;
            } else {
                vm.checkedPartner = newObj;
            }
        }

        /*
        Function used to fetch partners
         */
        function getPartners() {
            PartnerService.getPartners({nopage: true}).then(function (response) {
                vm.partners = response;
            })
        }

        /*
        Function used to check if a partner is selected
         */
        function isChecked(partnerId) {
            const clonedArray = Array.from(vm.selectedParners);
            return clonedArray.find((ele) => ele.id === partnerId);
        }

        /*
        Function used to save date
         */
        function saveCDADate(partner) {
            const newObj = angular.copy(partner);
            const clonedArray = Array.from(vm.selectedParners);
            var index = clonedArray.find((ele) => ele.id === partner.id);
            if (index) {
                vm.selectedParners = clonedArray.map((ele) => {
                    if (ele.id === partner.id) {
                        return newObj;
                    }
                    return ele;
                });
                vm.checkedPartner = null;
            } else {
                vm.selectedParners.push(newObj);
                vm.checkedPartner = null;
            }

            vm.checked = true;
        }

        /*
        Function used to close dates modal
         */
        function closeCDADialog() {
            vm.checkedPartner = null;
        }

        /*
        Function used to set the defaults date on edit
         */
        function onEditDate(partnerId) {
            const selected = vm.selectedParners.find(ele => ele.id === partnerId);
            vm.checkedPartner = angular.copy(selected);
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.community')
        .controller('AssignRoleController',
            AssignRoleController);

    /** @ngInject */
    function AssignRoleController($mdDialog,
                                  participant,
                                  callback,
                                  role,
                                  participantsList,
                                  ParticipantService) {
        var vm = this;

        vm.dialogTitle = 'Assign Role';
        vm.participant = {};
        vm.participantObj = participant;
        vm.role = role;

        vm.displayReplace = false;

        //Methods
        vm.assignRole = assignRole;
        vm.closeDialog = closeDialog;

        activate();

        /*
        Function used to check if there is already a leader in the participants list
         */
        function activate() {
            participantsList.map(function (mapParticipant) {
                if (mapParticipant.sg_role === 'leader' && role.value === 'leader') {
                    vm.displayReplace = true;
                }
            });
            if (participant.phone_number) {
                vm.participant.phone_number = participant.phone_number;
            }
        }

        /*
        Function used to assign a role to participant and edit phone number
         */
        function assignRole(number, role) {
            vm.saving = true;
            var participantObj = {};
            vm.errorPhone = '';

            if (number) {
                participantObj.phone_number = number;
            }
            participantObj.sg_role = role.value;
            participantObj.id = participant.id;
            participantObj.application_id = participant.application_id;
            ParticipantService.editParticipant(participantObj)
                .then(function () {
                    vm.saving = false;
                    callback();
                    closeDialog();
                })
                .catch(function (response) {
                    vm.saving = false;
                    if (response.data && response.data.errors) {
                        if (response.data.errors.phone_number) {
                            vm.errorPhone = response.data.errors.phone_number.shift();
                        }
                    }
                });
        }

        /*
        Function used to close modal dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.community')
        .controller('AddNonICMParticipantController',
            AddNonICMParticipantController);

    /** @ngInject */
    function AddNonICMParticipantController($mdDialog,
        enumFields,
        callback,
        community,
        participantsList,
        ParticipantService) {
        var vm = this;

        vm.dialogTitle = 'Add Non-ICM Participant';
        vm.displayReplace = false;

        //Methods
        vm.closeDialog = closeDialog;
        vm.addParticipant = addParticipant;

        activate();

        /*
        Function used to initialize community details and sg roles
         */
        function activate() {
            vm.community = community;
            enumFields(["gender", 'sg_roles'])
                .then(function (values) {
                    vm.genders = values.gender;
                    vm.roles = values.sg_roles;
                });

            participantsList.map(function (mapParticipant) {
                if (mapParticipant.sg_role === 'leader') {
                    vm.displayReplace = true;
                }
            });
        }

        /*
        Function used to add non icm participant
         */
        function addParticipant(participant) {
            vm.saving = true;
            vm.errorPhone = '';
            participant.application_id = vm.community.application_id;
            participant.is_non_icm_participant = 1;
            participant.is_kid_saver = vm.kidSaver ? 1 : 0;

            ParticipantService.addParticipant(participant).then(function () {
                vm.saving = false;
                callback();
                closeDialog();
            }).catch(function (response) {
                vm.saving = false;
                if (response.data && response.data.errors) {
                    if (response.data.errors.phone_number) {
                        vm.errorPhone = 'Invalid phone no.';
                    }
                }
            });
        }

        /*
        Functin used to close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.community')
        .controller('SavingsGroupDetailsController',
            SavingsGroupDetailsController);

    /** @ngInject */
    function SavingsGroupDetailsController($scope,
                                           $mdDialog,
                                           $state,
                                           $document,
                                           callback,
                                           community,
                                           SavingsGroupDataService,
                                           CommunityService,
                                           $mdBottomSheet) {
        var vm = this;
        vm.$state = $state;

        //Methods
        vm.hideSliderCard = hideSliderCard;
        vm.stateChange = stateChange;
        vm.approveForPrevail = approveForPrevail;
        vm.addSavingsDetails = addSavingsDetails;

        if (community.savings_group_data) {
            vm.details = community.savings_group_data
        } else {
            vm.details = {
                report_at: new Date()
            };
        }

        vm.availableParticipants = [];
        vm.availableVisitors = [];

        //listen for state change
        $scope.$on('$stateChangeStart', function () {
            vm.stateChange();
        });

        $('.content-white-holder').addClass('bcopen');


        /*
        Function that hides slider card
         */
        function hideSliderCard() {
            $mdBottomSheet.hide();
        }

        //executed after listening to state change
        function stateChange() {
            hideSliderCard();
        }

        activate();

        function activate() {
            getSavingsGroupStats();
            getSavingsGroupDetail();
        }

        function approveForPrevail() {
            $mdDialog.show({
                controller: 'ApproveForPrevailController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/tabs/savings/dialogs' +
                '/approve-for-prevail/approve-for-prevail-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    community: community,
                    callback: function () {
                        callback();
                        hideSliderCard();
                    }
                },
                clickOutsideToClose: true
            });
        }

        function addSavingsDetails(details, stats) {
            vm.saving = true;

            for (var i in stats) {
                if (i !== "id") {
                    details[i] = parseInt(stats[i]);
                }
            }

            details.community_id = community.id;
            details.balance      = details.total_contributions - details.total_withdrawn || undefined;

            vm.details.report_at = moment(details.report_at).format('LL');
            delete details.savings_group_id;
            if (community.savings_group_data) {
                SavingsGroupDataService.editSavingsGroupData(details).then(function () {
                    callback();
                    vm.saving = false;
                });
            } else {
                SavingsGroupDataService.addSavingsGroupData(details).then(function () {
                    callback();
                    vm.saving = false;
                });
            }
        }

        function getSavingsGroupDetail() {
            CommunityService.getCommunity(community.id, {with: 'application,application.pastor'})
                .then(function (response) {
                    vm.savingsGroup = response;
                }).catch(handleSavingsGroupDetailsError.bind(this));
        }

        function getSavingsGroupStats() {
            CommunityService.getCommunityStats(community.id)
                .then(function(response) {
                    vm.stats = response;
                }).catch(handleSavingsGroupDetailsError.bind(this));
        }

        function handleSavingsGroupDetailsError() {
            vm.$state.go("app.community.savings", {id: vm.$state.params.id});
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.community')
        .controller('DropHbfDialogController', DropHbfDialogController);

    /** @ngInject */
    function DropHbfDialogController($mdDialog, callback) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.dropCallback = dropCallback;

        vm.dialogTitle = "Drop HBF";
        vm.message = 'Are you sure you want to drop this HBF?'

        /*
        Function that closes modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        /*
        Function that calls drop callback
         */
        function dropCallback() {
            callback();
            closeDialog();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.community')
        .controller('HbfDetailsContentController', HbfDetailsContentController);

    /** @ngInject */
    function HbfDetailsContentController($mdBottomSheet,
        $scope,
        $mdDialog,
        callback,
        $document,
        hbf,
        HbfService,
        Auth) {
        var vm = this;
        var currentUser = Auth.getUser();

        vm.hbf = hbf;
        vm.hbfId = hbf.id;

        vm.hbfStatus = [
            {
                label: vm.hbf.current_weight_log.label,
                value: 'active'
            },
            {
                label: 'Severe Acute Malnutrition',
                value: 'sam'
            },
            {
                label: 'Moderate Acute Malnutrition',
                value: 'mam'
            },
            {
                label: 'Cured',
                value: 'cured'
            }
        ];

        //Methods
        vm.hideSliderCard = hideSliderCard;
        vm.editHbf = editHbf;
        vm.logWeight = logWeight;
        vm.deleteWeigtLog = deleteWeigtLog;
        vm.addNote = addNote;
        vm.deleteNote = deleteNote;
        vm.editNote = editNote;
        vm.addParticipant = addParticipant;
        vm.getColor = getColor;
        vm.showLightBox = showLightBox;
        vm.replacePhoto = replacePhoto;
        vm.removePhoto = removePhoto;
        vm.stateChange = stateChange;
        vm.getMeasure = getMeasure;
        vm.updateCondition = updateCondition;
        vm.editWeightLog = editWeightLog;

        //listen for state change
        $scope.$on('$stateChangeStart', function () {
            vm.stateChange();
        });

        vm.updatingcondition = false;

        $('.content-white-holder').addClass('bcopen');

        vm.chart = {
            colors: ['#45b955', '#cccccc'],
            series: ["Target Weight", "Current Weight"],
            target: [2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2],
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            labels: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
            options: {
                elements: {
                    line: {
                        fill: false,
                        backgroundColor: '#386bba',
                        borderColor: '#386bba',
                        borderWidth: 2
                    }
                },
                scales: {
                    yAxes: [
                        {
                            id: 'y-axis-1',
                            type: 'linear',
                            display: true,
                            position: 'left',
                            ticks: {
                                beginAtZero: true
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Weight (kg)'
                            },
                            gridLines: {
                                color: "rgba(0, 0, 0, 0)"
                            }
                        }
                    ],
                    xAxes: [
                        {
                            scaleLabel: {
                                display: true,
                                labelString: 'Week'
                            },
                            gridLines: {
                                color: "rgba(0, 0, 0, 0)"
                            }
                        }
                    ]
                }
            }
        };

        $scope.$watch("vm.hbf", (function (data) {
            if (!data) return;

            var vm = this;
            var initial = vm.hbf.initial_weight_log;

            var startWeek = 3;
            for (var log in data.weight_logs) {
                startWeek = log;
                break;
            }

            // merge weight logs and notes
            var logs = [];

            // merge hbf notes data
            data.notes.forEach(function (note) {
                var week = note.week_no;
                var log = data.weight_logs[week] || {};

                note.note_id = note.id;

                if (note.id) {
                    delete note.id;
                }

                data.weight_logs[week] = angular.extend({}, log, note);
            });
            var lastNoteIndex = data.notes.length - 1;
            var lastNote = data.notes[lastNoteIndex];
            vm.hbf.current_weight_log = angular.extend({}, vm.hbf.current_weight_log, lastNote);

            vm.hbf.weight_logs_length = Object.keys(data.weight_logs).length;

            // clear previous data
            vm.chart.data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            vm.chart.target = [];

            vm.chart.labels = [];
            vm.tableRows = [];
            vm.chart.data.push(0);

            if (getObjectSize(data.weight_logs) > 1) {
                vm.chart.data = [];
                for (var i = startWeek; i <= 29; i++) {
                    if (i === 18 || i === 20 || i === 22 || i === 24 || i === 26 || i === 28) {
                        continue;
                    }

                    var log = data.weight_logs[i];

                    if (log && log.weight_kg > 0) {
                        console.log(log.target_weight);
                        vm.chart.labels.push(i);
                        vm.chart.data.push(log.weight_kg);
                        vm.chart.target.push(log.target_weight);
                    }

                    vm.tableRows.push(i);
                }
            } else {
                vm.chart.labels.push(initial.week_no);
                vm.chart.labels.push(initial.week_no + 1);

                for (var i = startWeek; i <= 29; i++) {
                    if (i === 18 || i === 20 || i === 22 || i === 24 || i === 26 || i === 28) {
                        continue;
                    }

                    vm.tableRows.push(i);
                }

                // replot data
                angular.forEach(data.weight_logs, function (log) {
                    var index = log.week_no - initial.week_no;
                    vm.chart.data[index] = log.weight_kg;
                });
            }

            if (vm.chart.data.length === 1) {
                vm.chart.labels.push(vm.chart.labels[0]);
                vm.chart.data.push(vm.chart.data[0]);
            }
        }).bind(this));

        /*
        Function that returns object size
         */
        function getObjectSize(obj) {
            var size = 0, key;
            for (key in obj) {
                if (obj.hasOwnProperty(key)) size++;
            }
            return size;
        }

        //executed after listening to state change
        function stateChange() {
            hideSliderCard();
        }

        /*
        Function that returns object with data color
         */
        function getColor(color) {
            return {
                color: 'text-' + color
            };
        }

        /*
        Function to get measure depending on age
         */
        function getMeasure(age) {
            var measure;
            if (parseInt(age) < 60) {
                measure = 'WFH';
            } else {
                measure = 'BMI';
            }

            return measure;
        }


        /*
        Function that adds note in hbf
         */
        function addNote(note) {
            if (note) {
                var noteObj = {
                    notes: note,
                    with: 'updatedBy'
                };
                HbfService.addNote(vm.hbfId, noteObj).then(function (response) {
                    vm.note = '';
                    vm.notes.push(response);
                });
            }
        }

        /*
        Function that edits a note in hbf
         */
        function editNote(note) {
            note.editing = false;
            HbfService.editNote(vm.hbfId, note).then(function (response) {
            });
        }

        /*
        Function that converts a guardian to a participant
         */
        function addParticipant() {
            $mdDialog.show({
                controller: 'AddParticipantDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/transform/dialogs/add-participant/add-participant-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    community: hbf.community,
                    callback: function (item) {
                        var hbfObj = {
                            participant: item,
                            participant_id: item.id
                        };

                        HbfService.updateHbf(hbf.id, hbfObj).then(function (response) {
                            vm.hbf = response;
                        });
                    },
                    guest: vm.hbf.guest_name
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that deletes a hbf note
         */
        function deleteNote(noteRemove) {
            $mdDialog.show({
                controller: 'DeleteNoteDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/tabs/hbf/dialogs/delete-note/delete-note-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    callback: function () {
                        HbfService.deleteNote(vm.hbfId, noteRemove.id).then(function (response) {
                            vm.notes = vm.notes.filter(function (note) {
                                return noteRemove.id !== note.id;
                            });
                        });
                    }
                },
                clickOutsideToClose: true
            });

        }

        /*
        Function that hides slider card and execute callback passed in its parent controller
         */
        function hideSliderCard() {
            callback();
            $mdBottomSheet.hide();
        }

        initHbf();

        /*
        Function that gets hbf details
         */
        function initHbf() {
            var params = {
                sort: 'created_at:asc',
                nopage: true,
                with: 'hbf,updatedBy'
            };
            HbfService.getNotes(vm.hbf.id, params).then(function (data) {
                vm.notes = data;
            });
        }

        /*
        Function that shows edit hbf modal
         */
        function editHbf() {
            $mdDialog.show({
                controller: 'EditHbfDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/tabs/hbf/dialogs/edit-hbf/edit-hbf-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    parentVm: vm
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that shows delete weight log
         */
        function deleteWeigtLog(log) {
            $mdDialog.show({
                controller: 'DeleteWeightLogDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/tabs/hbf/dialogs/delete-weight-log/delete-weight-log-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    log: log,
                    parentVm: vm
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that shows delete weight log
         */
        function editWeightLog(log, hbf) {
            $mdDialog.show({
                controller: 'EditWeightLogDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/tabs/hbf/dialogs/edit-weight-log/edit-weight-log-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    log: log,
                    hbf: hbf,
                    callback: logWeightCallback.bind(vm)
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that shows log weight modal
         */
        function logWeight(hbf) {
            $mdDialog.show({
                controller: 'AddWeightLogDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/tabs/hbf/dialogs/add-weight-log/add-weight-log-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    hbf: hbf,
                    callback: logWeightCallback.bind(vm)
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function callback that gets back hbf log weights
         */
        function logWeightCallback(response) {
            this.hbf = response.data;
        }

        /*
        Function that display image's modal display
         */
        function showLightBox(photo, ev) {
            if (photo) {
                $mdDialog.show({
                    controller: 'LightboxDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/community/tabs/hbf/dialogs/lightbox/lightbox-dialog.html',
                    parent: angular.element($document.body),
                    locals: {
                        photo: photo,
                        ev: ev
                    },
                    clickOutsideToClose: true
                });
            }
        }

        /*
        Function that replaces before or after photo of child
         */
        function replacePhoto(action) {
            if (action != "before" && action != "after") return;

            if (!currentUser.$roles.has(['pastor_coordinator', 'livelihood_coordinator', 'donor_services', 'donor_managers', 'view_only', 'area_head'])) {
                $mdDialog.show({
                    controller: 'ReplacePhotoDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/community/tabs/hbf/dialogs/replace-photo/replace-photo-dialog.html',
                    parent: angular.element($document.body),
                    locals: {
                        hbf: vm.hbf,
                        action: action,
                        callback: null
                    },
                    clickOutsideToClose: true
                });
            }
        }

        /*
        Function that removes before or after photo of a child
         */
        function removePhoto(hbf, action, ev) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure you want to want to delete this photo?')
                .targetEvent(ev)
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function () {
                if (action == 'before') {
                    HbfService.deleteBeforePhoto(hbf.id);

                    hbf.before_photo = null;
                    hbf.before_photo_url = null;
                } else {
                    HbfService.deleteAfterPhoto(hbf.id);

                    hbf.after_photo = null;
                    hbf.after_photo_url = null;
                }
            }, function () {
                // cancel action
            });
        }

        /*
        Function that manually updates condition of a child
         */
        function updateCondition(status) {
            vm.updatingcondition = true;
            HbfService.updateHbf(vm.hbf.id, {
                status: status
            })
                .then(handleUpdateConditionSuccess.bind(this))
                .then(handleUpdateConditionError.bind(this));

            function handleUpdateConditionSuccess(hbf) {
                this.hbf = hbf;
                this.updatingcondition = false;
            }

            function handleUpdateConditionError() {
                this.updatingcondition = false;
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.transform')
        .controller('ReplacePhotoDialogController', ReplacePhotoDialogController);

    /** @ngInject */
    function ReplacePhotoDialogController($mdDialog,
                                          hbf,
                                          action,
                                          callback,
                                          HbfService) {
        var vm = this;
        vm.hbf = hbf;
        vm.callback = callback;
        vm.action = action;

        //Methods
        vm.closeDialog = closeDialog;
        vm.uploadPhoto = uploadPhoto;

        vm.uploading = false;

        if (action == "before") {
            vm.dialogTitle = (hbf.before_photo ? "Replace" : "Upload") + " Start Photo";
        } else {
            vm.dialogTitle = (hbf.after_photo ? "Replace" : "Upload") + " End Photo";
        }

        /*
        Function to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        /*
        Function to replace or upload before or after photo of the child
         */
        function uploadPhoto(form) {
            vm.uploading = true;
            vm.apiErrors = {};

            if (action == "before") {
                HbfService.uploadBeforePhoto(hbf.id, vm.photo)
                    .then(beforeUploadSuccess.bind(this))
                    .catch(errorUploadHandler.bind(this));
            } else {
                HbfService.uploadAfterPhoto(hbf.id, vm.photo)
                    .then(afterUploadSuccess.bind(this))
                    .catch(errorUploadHandler.bind(this));
            }

            function beforeUploadSuccess(response) {
                this.uploading = false;
                this.hbf.before_photo = response.data.before_photo;
                this.hbf.before_photo_url = response.data.before_photo_url;

                if (this.callback) {
                    this.callback(this.hbf);
                }

                this.closeDialog();
            }

            function afterUploadSuccess(response) {
                this.uploading = false;
                this.hbf.after_photo = response.data.after_photo;
                this.hbf.after_photo_url = response.data.after_photo_url.replace(/(ts=)\d+/, '$1' + (+new Date()));

                if (this.callback) {
                    this.callback(this.hbf);
                }

                this.closeDialog();
            }

            function errorUploadHandler(response) {
                form.$invalid = true;
                vm.saving = false;
                vm.uploading = false;

                for (var field in response.data.errors) {
                    vm.apiErrors[field] = response.data.errors[field].shift();
                }
            }
        }
    }

})();

(function () {
    'use strict';

    angular.module('app.transform')
        .controller('LightboxDialogController', LightboxDialogController);

    /** @ngInject */
    function LightboxDialogController($mdDialog, photo, ev) {
        var vm = this;
        vm.photo = photo;

        //Methods
        vm.closeDialog = closeDialog;

        /*
        Function to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }

})();

(function () {
  'use strict';

  angular.module('app.community')
    .controller('EditWeightLogDialogController', EditWeightLogDialogController);

  /** @ngInject */
  function EditWeightLogDialogController($mdDialog,
    HbfService,
    hbf,
    log,
    FormFieldService,
    enumFields,
    callback) {
    var vm = this;

    //Methods
    vm.closeDialog = closeDialog;
    vm.editWeightLog = editWeightLog;
    vm.callback = callback;

    vm.hbf = angular.copy(hbf);
    vm.saving = false;
    vm.apiErrors = {};
    vm.weightLog = angular.copy(log);

    vm.discharge = log.discharge;
    if (vm.discharge) {
      vm.weightLog.dischargeOption = log.status;
    }
    vm.medicalCareNeeded = log.mcn;
    vm.absent = log.absent;
    vm.weightLog.dewormOption = log.deworm_option;

    vm.dischargeOptions = [];
    vm.dewormOptions = [];

    vm.dialogTitle = "Edit Weight Log";

    // find logged weeks
    vm.addedWeeks = [];

    // remove previously logged weeks
    vm.weeks = [];
    for (var x = 2; x <= 29; x++) {
      if (hbf.is_extended && (x === 18 || x === 20 || x === 22 || x === 24 || x === 26 || x === 28)) {
        continue;
      } else if (!hbf.is_extended && x > 16) {
        continue;
      }

      if (vm.addedWeeks.indexOf(x) === -1) {
        vm.weeks.push({
          label: 'Week ' + x,
          value: x
        });
      }
    }

    enumFields([
      "hbfStatus",
      "dewormOptions"
    ])
      .then(function (values) {
        vm.dischargeOptions = values.hbfStatus;
        vm.dewormOptions = values.dewormOptions;
      });

    /*
    Function to close modal
     */
    function closeDialog() {
      $mdDialog.hide();
    }

    /*
    Function to add weight log of a child
     */
    function editWeightLog(form, log) {
      vm.saving = true;
      vm.apiErrors = {};

      log.birthdate = vm.hbf.birthdate;
      log.gender = vm.hbf.gender;

      log.discharge = vm.discharge;

      if (vm.discharge) {
        log.status = log.dischargeOption;

        if (log.week_no === 15) {
          log.status = 'completed_treatment';
        }

        if (log.status !== 'refused_treatment') {
          log.reason_for_refused_treatment = '';
        }
      } else {
        log.status = null;
      }

      if (log.dewormed) {
        log.deworm_option = log.dewormOption;
      }

      log.mcn = vm.medicalCareNeeded;
      log.absent = vm.absent;

      if (log.week_no < 14 || !log.height_cm) {
        log.height_cm = vm.hbf.initial_weight_log.height_cm;
      }

      if (log.week_no === 14 || log.week_no === 15 || log.week_no === 16) {
        log.is_extended = vm.hbf.is_extended;
      }

      updateHbf(vm.hbf.id, log)
        .then(function () {
          return saveWeightLog(vm.hbf.id, log);
        })
        .then(function (response) {
          var note = angular.extend({}, log, {
            id: log.note_id
          });
          return saveNote(vm.hbf.id, note)
            .catch(function (error) {
              throw error;
            });
        })
        .then(function (response) {
          return getHbf(vm.hbf.id);
        })
        .then(function (response) {
          form.$invalid = false;
          vm.saving = false;

          callback({
            data: response
          });
          closeDialog();
        })
        .catch(function (response) {
          form.$invalid = true;
          vm.saving = false;

          for (var field in response.data.errors) {
            vm.apiErrors[field] = response.data.errors[field].shift();
          }
        });
    }

    /**
     * Update the HBF data.
     *
     * @param {integer} hbfId
     * @param {object} log
     */
    function updateHbf(hbfId, log) {
      if (typeof log.is_extended !== "undefined") {
        return HbfService.updateHbf(hbfId, {
          is_extended: log.is_extended
        });
      }

      return Promise.resolve(true);
    }

    /**
     * Save the weight log.
     *
     * @param {integer} hbfId
     * @param {object} log
     */
    function saveWeightLog(hbfId, log) {
      if (log.weight_kg > 0) {
        if (log.id) {
          return HbfService.editWeightLog(hbfId, log);
        } else {
          return HbfService.addWeightLog(hbfId, log);
        }
      } else if (log.id) {
        return HbfService.deleteWeightLog(hbfId, log.id)
      }

      return Promise.resolve(false);
    }

    /**
     * Save the weekly note.
     *
     * @param {integer} hbfId
     * @param {object} note
     */
    function saveNote(hbfId, note) {
      if (!note.nutripacks) {
        note.nutripacks = 0;
      }

      if (note && note.id) {
        return HbfService.editNote(hbfId, note);
      }

      return HbfService.addNote(hbfId, note);
    }

    /**
     * Get the hbf details.
     *
     * @param {integer} hbfId
     */
    function getHbf(hbfId) {
      return HbfService.getHbf(hbfId, {
        with: 'participant,notes'
      })
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.transform')
        .controller('EditHbfDialogController', EditHbfDialogController);

    /** @ngInject */
    function EditHbfDialogController($mdDialog, parentVm, FormFieldService, HbfService, ParticipantService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.updateHbf = updateHbf;
        vm.selectGuardian = selectGuardian;
        vm.searchGuardians = searchGuardians;
        vm.calculateAge = calculateAge;

        vm.$hbf = HbfService;

        vm.communityId = parentVm.hbf.community_id;
        vm.hbfId = parentVm.hbfId;
        vm.hbf = parentVm.hbf;

        vm.selectedGuardian = null;

        vm.calculateScore = calculateScore.bind(this);

        vm.dialogTitle = "Edit HBF";

        vm.weeks = [
            {label: 2, value: 2},
            {label: 3, value: 3},
            {label: 4, value: 4},
            {label: 5, value: 5},
            {label: 6, value: 6}
        ];

        if (localStorage.getItem('childRelationships')
            && localStorage.getItem('genders')) {
            vm.childRelationships = JSON.parse(localStorage.getItem('childRelationships'));
            vm.genders = JSON.parse(localStorage.getItem('genders'));
        } else {
            FormFieldService.getFields().then(function (response) {
                angular.forEach(response.child_relationship.definition, function (venue) {
                    vm.childRelationships.push({
                        label: venue.label,
                        value: venue.value
                    });

                });
                localStorage.setItem('childRelationships', JSON.stringify(vm.childRelationships));

                angular.forEach(response.gender.definition, function (venue) {
                    vm.genders.push({
                        label: venue.label,
                        value: venue.value
                    });

                });
                localStorage.setItem('genders', JSON.stringify(vm.genders));
            });
        }

        vm.form = {
            week_no: vm.hbf.initial_weight_log.week_no,
            child_firstname: vm.hbf.child_firstname,
            child_lastname: vm.hbf.child_lastname,
            // relationship    : vm.hbf.relationship,
            birthdate: new Date(vm.hbf.birthdate),
            weight_at: new Date(vm.hbf.initial_weight_log.weight_at),
            gender: vm.hbf.gender,
            contact_no: vm.hbf.contact_no,
            weight_kg: vm.hbf.initial_weight_log.weight_kg,
            height_cm: vm.hbf.initial_weight_log.height_cm,
            target_weight: vm.hbf.initial_weight_log.target_weight,
            calculatedScore: vm.hbf.initial_weight_log,
            breastfeeding: vm.hbf.breastfeeding,
            abcdef_test: vm.hbf.abcdef_test,
            appetite_test: vm.hbf.appetite_test
            // rhu_check: vm.hbf.rhu_check
        };

        if (!inArrayRelationship(vm.hbf.relationship)) {
            vm.form.relationship = 'Other';
            vm.form.relationshipOther = vm.hbf.relationship;
        } else {
            vm.form.relationship = vm.hbf.relationship;
        }

        if (vm.hbf.participant) {
            vm.selectedGuardian = vm.hbf.participant;
        } else {
            vm.searchGuardian = vm.hbf.guest_name;
        }

        /*
        Function that returns boolean if relationship is in the vm.childRelationships array
         */
        function inArrayRelationship(relationship) {
            for (var i = 0; i < vm.childRelationships.length; i++) {
                if (relationship === vm.childRelationships[i].value) {
                    return true;
                }
            }

            return false;
        }

        /*
        Function that updates hbf data
         */
        function updateHbf(form, data) {
            vm.apiErrors = {};
            vm.saving = true;

            var hbfObj = {
                community_id: vm.communityId,
                week_no: data.week_no || null,
                child_firstname: data.child_firstname || null,
                child_lastname: data.child_lastname || null,
                contact_no: data.contact_no || null,
                birthdate: data.birthdate || null,
                weight_kg: data.weight_kg || null,
                height_cm: data.height_cm || null,
                gender: data.gender || null,
                weight_at: data.weight_at || null,
                target_weight: data.target_weight || null,
                breastfeeding: data.breastfeeding || 0,
                abcdef_test: data.abcdef_test || 0,
                appetite_test: data.appetite_test || 0,
                with: 'participant,notes'
            };

            hbfObj.birthdate = moment(hbfObj.birthdate).format("LL");
            hbfObj.weight_at = moment(hbfObj.weight_at).format("LL");

            if (data.relationship === 'Other') {
                hbfObj.relationship = data.relationshipOther;
            } else {
                hbfObj.relationship = data.relationship;
            }

            if (vm.selectedGuardian) {
                hbfObj.participant_id = vm.selectedGuardian.id;
            } else {
                hbfObj.guest_name = vm.searchGuardian;
            }

            HbfService.updateHbf(parentVm.hbfId, hbfObj).then(function (response) {
                vm.saving = false;
                parentVm.hbf = response;

                closeDialog();
            }).catch(function (response) {
                vm.saving = false;
                form.$invalid = true;

                for (var field in response.data.errors) {
                    vm.apiErrors[field] = response.data.errors[field].shift();
                }
            });
        }

        /*
        Function to calculate wasting score
         */
        function calculateScore(form, card) {
            var vm = this;
            vm.apiErrors = [];
            card.calculatedScore = null;

            vm.$hbf.calculateScore(card)
                .then(function (response) {
                    card.calculatedScore = response.data;
                    card.target_weight = response.data.target_weight;
                })
                .catch(function (response) {
                    form.$invalid = true;

                    for (var field in response.data.errors) {
                        vm.apiErrors[field] = response.data.errors[field].shift();
                    }
                });
        }

        /*
        Function to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        /*
        Function to search guardian in participants table
         */
        function searchGuardians(communityId, query) {
            return ParticipantService.getParticipants({
                search: query,
                community_id: communityId
            }).then(function(response) {
                return response.data;
            });
        }

        /*
        Function to select a guardian
         */
        function selectGuardian(guardian) {
            vm.selectedGuardian = guardian;
        }

        calculateAge(vm.form);

        /*
        Function to calculate age of the child
         */
        function calculateAge(form) {
            if (form.birthdate) {
                form._age = {
                    months: moment().diff(form.birthdate, 'months'),
                    years: moment().diff(form.birthdate, 'years')
                }
            } else {
                delete form.age;
            }
        }
    }

})();

(function () {
    'use strict';

    angular.module('app.transform')
        .controller('DeleteWeightLogDialogController', DeleteWeightLogDialogController);

    /** @ngInject */
    function DeleteWeightLogDialogController($mdDialog, $document, log, parentVm, HbfService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.deleteHbf = deleteHbf;

        vm.dialogTitle = "Delete Weight Log";
        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteHbf(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that deletes hbf weight log
         */
        function deleteHbf() {
            deleteWeightLog(parentVm.hbfId, log.id)
                .then(function() {
                    return deleteNote(parentVm.hbfId, log.note_id);
                })
                .then(function() {
                    return getHbf(parentVm.hbfId);
                })
                .then(function (data) {
                    parentVm.hbf = data;

                    closeDialog();
                });
        }

        /**
         * Delete weight log.
         *
         * @param {integer} hbfId
         * @param {integer} logId
         */
        function deleteWeightLog(hbfId, logId)
        {
            if (logId) {
                return HbfService.deleteWeightLog(hbfId, logId);
            }

            return Promise.resolve(false);
        }

        /**
         * Delete the hbf note.
         *
         * @param {integer} hbfId
         * @param {integer} noteId
         */
        function deleteNote(hbfId, noteId)
        {
            return HbfService.deleteNote(hbfId, noteId);
        }

        /**
         * Get the hbf details.
         *
         * @param {integer} hbfId
         */
        function getHbf(hbfId) {
            return HbfService.getHbf(hbfId, {with: 'participant,notes'});
        }

        /*
        Function that close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }

})();

(function () {
    'use strict';

    angular.module('app.community')
        .controller('DeleteNoteDialogController', DeleteNoteDialogController);

    /** @ngInject */
    function DeleteNoteDialogController($mdDialog, callback) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.deleteNote = deleteNote;

        vm.dialogTitle = 'Delete Note';

        /*
        Function that deletes a note in hbf
         */
        function deleteNote() {
            callback();
            closeDialog();
        }

        /*
        Function that closes dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.community')
        .controller('DeleteBusinessLoanDialogController', DeleteBusinessLoanDialogController);

    /** @ngInject */
    function DeleteBusinessLoanDialogController($mdDialog, $document, callback) {
        var vm = this;

        vm.dialogTitle = 'Delete Business Loan';
        vm.message = 'Are you sure you want to delete this business loan?';
        vm.saving = false;

        vm.closeDialog = closeDialog;
        vm.deleteCallback = deleteCallback;
        vm.passwordConfirmation = passwordConfirmation;

        function passwordConfirmation() {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: vm.deleteCallback,
                    callback: function () {}
                },
                clickOutsideToClose: true
            });
        }

        function deleteCallback() {
            vm.saving = true;
            callback();
            closeDialog();
        }

        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.community')
        .controller('DeleteHbfDialogController', DeleteHbfDialogController);

    /** @ngInject */
    function DeleteHbfDialogController($mdDialog, $document, callback) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.deleteHbf = deleteHbf;

        vm.dialogTitle = "Delete HBF";
        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteHbf(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        /*
        Function to delete hbf and close modal
         */
        function deleteHbf() {
            callback();
            closeDialog();
        }
    }
})();

(function () {
  'use strict';

  angular.module('app.community')
    .controller('AddWeightLogDialogController', AddWeightLogDialogController);

  /** @ngInject */
  function AddWeightLogDialogController($mdDialog,
    HbfService,
    hbf,
    enumFields,
    callback) {
    var vm = this;

    //Methods
    vm.closeDialog = closeDialog;
    vm.addWeightLog = addWeightLog;
    vm.callback = callback;

    vm.hbf = angular.copy(hbf);
    vm.saving = false;
    vm.apiErrors = {};
    vm.weightLog = {
      nutripacks: 0
    };

    vm.dischargeOptions = [];
    vm.dewormOptions = [];

    vm.dialogTitle = "Log Weight";

    // find logged weeks
    vm.addedWeeks = [];
    angular.forEach(vm.hbf.weight_logs, function (log) {
      vm.addedWeeks.push(log.week_no);
    });

    // remove previously logged weeks
    vm.weeks = [];
    for (var x = vm.hbf.initial_weight_log.week_no; x <= 29; x++) {
      if (hbf.is_extended && (x === 18 || x === 20 || x === 22 || x === 24 || x === 26 || x === 28)) {
        continue;
      } else if (!hbf.is_extended && x > 16) {
        continue;
      }

      if (vm.addedWeeks.indexOf(x) === -1) {
        vm.weeks.push({
          label: 'Week ' + x,
          value: x
        });
      }
    }

    // default to first available week
    vm.weightLog.week_no = vm.weeks.length ? vm.weeks[0].value : 2;

    if (hbf.initial_weight_log) {
      vm.weightLog.height_cm = hbf.initial_weight_log.height_cm;
    }

    enumFields([
      "hbfStatus",
      "dewormOptions"
    ])
      .then(function (values) {
        vm.dischargeOptions = values.hbfStatus;
        vm.dewormOptions = values.dewormOptions;
      });

    /*
    Function to close modal
     */
    function closeDialog() {
      $mdDialog.hide();
    }

    /*
    Function to add weight log of a child
     */
    function addWeightLog(form, log) {
      vm.saving = true;
      vm.apiErrors = {};

      log.birthdate = vm.hbf.birthdate;
      log.gender = vm.hbf.gender;

      if (vm.discharge) {
        log.discharge = vm.discharge;
        log.status = log.dischargeOption;

        if (log.week_no === 15) {
          log.status = 'completed_treatment';
        }

        if (log.status !== 'refused_treatment') {
          log.reason_for_refused_treatment = '';
        }
      }

      if (log.dewormed) {
        log.deworm_option = log.dewormOption;
      }

      log.weight_at = new Date();
      log.mcn = vm.medicalCareNeeded;
      log.absent = vm.absent;

      if (log.week_no > 2 && log.week_no < 15) {
        log.height_cm = vm.hbf.initial_weight_log.height_cm;
      }

      if (log.week_no === 14 || log.week_no === 15) {
        log.is_extended = vm.hbf.is_extended;
      }

      updateHbf(vm.hbf.id, log)
        .then(function () {
          return saveWeightLog(vm.hbf.id, log)
        })
        .then(function (response) {
          return saveNote(vm.hbf.id, log)
            .catch(function (error) {
              throw error;
            });
        })
        .then(function (response) {
          return getHbf(vm.hbf.id);
        })
        .then(function (response) {
          form.$invalid = false;
          vm.saving = false;

          callback({
            data: response
          });
          closeDialog();
        })
        .catch(function (response) {
          form.$invalid = true;
          vm.saving = false;

          for (var field in response.data.errors) {
            vm.apiErrors[field] = response.data.errors[field].shift();
          }
        });
    }

    /**
     * Update the HBF data.
     *
     * @param {integer} hbfId
     * @param {object} log
     */
    function updateHbf(hbfId, log) {
      if (typeof log.is_extended !== "undefined") {
        return HbfService.updateHbf(hbfId, {
          is_extended: log.is_extended
        });
      }

      return Promise.resolve(true);
    }

    /**
     * Save the weight log.
     *
     * @param {integer} hbfId
     * @param {object} log
     */
    function saveWeightLog(hbfId, log) {
      if (log.weight_kg > 0) {
        return HbfService.addWeightLog(hbfId, log);
      }

      return Promise.resolve(false);
    }

    /**
     * Save the weekly note.
     *
     * @param {integer} hbfId
     * @param {object} log
     */
    function saveNote(hbfId, log) {
      return HbfService.addNote(hbfId, log);
    }

    /**
     * Get the hbf details.
     *
     * @param {integer} hbfId
     */
    function getHbf(hbfId) {
      return HbfService.getHbf(hbfId, {
        with: 'participant,notes'
      })
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.community')
        .controller('AddBusinessLoanDialogController', AddBusinessLoanDialogController);

    /** @ngInject */
    function AddBusinessLoanDialogController($mdDialog, BusinessLoansService, communityId, batchId, products, callback) {
        var vm = this;

        vm.products = products;
        vm.loan = {};
        vm.saving = false;

        vm.closeDialog = closeDialog;
        vm.saveLoan = saveLoan;

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveLoan() {
            if (vm.saving) {
                return;
            }
            vm.saving = true;

            BusinessLoansService.addBusinessLoan({
                community_id: communityId,
                batch_id: batchId,
                product_id: vm.loan.product_id,
                loan_amount: vm.loan.loan_amount
            }).then(function () {
                callback();
                closeDialog();
            }).catch(function () {
                vm.saving = false;
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.community')
        .controller('RepaymentBibDialogController', RepaymentBibDialogController);

    /** @ngInject */
    function RepaymentBibDialogController($mdDialog, callback, initBib) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.deleteBib = deleteBib;

        vm.dialogTitle = "Repayment";
        /*
        Function to close modal
         */
        function closeDialog() {
            vm.saving = false;
            $mdDialog.hide();
            initBib()
        }

        /*
        Function to delete bib
         */
        function deleteBib() {
            vm.saving = true;
            callback();
            closeDialog();
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.community')
        .controller('DeleteBibDialogController', DeleteBibDialogController);

    /** @ngInject */
    function DeleteBibDialogController($mdDialog, $document, callback) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.deleteBib = deleteBib;

        vm.dialogTitle = "Delete BIB";
        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteBib(),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }


        /*
        Function to close modal
         */
        function closeDialog() {
            vm.saving = false;
            $mdDialog.hide();
        }

        /*
        Function to delete bib
         */
        function deleteBib() {
            vm.saving = true;
            callback();
            closeDialog();
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.community')
        .controller('BibParticipantsContentController',
            BibParticipantsContentController);

    /** @ngInject */
    function BibParticipantsContentController($scope,
        $mdDialog,
        $state,
        $document,
        callback,
        $mdBottomSheet,
        BibService,
        ParticipantService,
        BibParticipantService,
        BibPaymentService,
        bib) {
        var vm = this;
        vm.$state = $state;

        //Methods
        vm.hideSliderCard = hideSliderCard;
        vm.initParticipants = initParticipants;
        vm.initTransactions = initTransactions;
        vm.addParticipant = addParticipant;
        vm.editParticipant = editParticipant;
        vm.deleteParticipant = deleteParticipant;
        vm.addPayment = addPayment;
        vm.showNotes = showNotes;
        vm.stateChange = stateChange;
        vm.addVisitor = addVisitor;
        vm.addPastor = addPastor;

        vm.availableParticipants = [];
        vm.availableVisitors = [];

        //listen for state change
        $scope.$on('$stateChangeStart', function () {
            vm.stateChange();
        });

        $('.content-white-holder').addClass('bcopen');

        function hideSliderCard() {
            callback();
            $mdBottomSheet.hide();
        }

        //executed after listening to state change
        function stateChange() {
            hideSliderCard();
        }

        initBibParticipants();

        /*
        Function that fetches participants, available participants, available visitors
        transactions and bib details
         */
        function initBibParticipants() {
            initParticipants();
            initAvailableParticipants();
            initAvailableVisitors();
            initTransactions();
            getBib();
        }

        /*
        Function that fetches bib details
         */
        function getBib() {
            var params = {
                with: 'community.application.pastor,product'
            };
            BibService.getBib(bib.id, params).then(function (data) {
                vm.bib = data;
            });
        }

        /*
        Function that fetches participants
         */
        function initParticipants() {
            BibParticipantService.getBibParticipants({
                community_bib_id: bib.id,
                nopage: 1,
                sort: 'id:desc',
                with: 'payments,bib,bib.product,participant,updatedBy'
            }).then(function (participants) {
                vm.participants = participants;
                vm.hasPastor = checkIfHasPastor(participants);
                vm.loadingParticipants = false;
            }).catch(handleBibParticipantsError.bind(this));

        }

        /*
        Function that checkes if a pastor has been added as bib participant
         */
        function checkIfHasPastor(participants) {
            var check = false;
            participants.map(function (participant) {
                if (participant.pastor_id)
                    check = true;
            });

            return check;
        }

        /*
        Function that fetches available participants
         */
        function initAvailableParticipants() {
            ParticipantService.getParticipants({
                community_id: bib.community_id,
                has_not_bib: bib.id,
                qualified: 1,
                nopage: 1
            }).then(function (participants) {
                vm.availableParticipants = participants;
                vm.loadingParticipants = false;
            }).catch(handleBibParticipantsError.bind(this));
        }

        /*
        Function that fetches available visitors
         */
        function initAvailableVisitors() {
            ParticipantService.getParticipants({
                community_id: bib.community_id,
                has_not_bib: bib.id,
                nopage: 1,
                is_visitor: 1
            }).then(function (participants) {
                vm.availableVisitors = participants;
                vm.loadingParticipants = false;
            }).catch(handleBibParticipantsError.bind(this));
        }

        /*
        Function that fetches transactions
         */
        function initTransactions() {
            BibPaymentService.getBibPayments({
                community_bib_id: bib.id,
                nopage: 1,
                sort: 'id:desc',
                with: 'participant,participant.bib,participant.bib.product,participant.participant,updatedBy'
            }).then(function (payments) {
                vm.payments = payments;
                vm.loadingTransactions = false;
            }).catch(handleBibParticipantsError.bind(this));
        }

        /*
        Function that fetches participant notes
         */
        function showNotes(participant) {
            $mdDialog.show({
                controller: 'ParticipantNotesDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/dialogs/participant-notes/' +
                    'participant-notes-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    participant: participant
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that shows add participant in bib modal
         */
        function addParticipant() {
            $mdDialog.show({
                controller: 'AddBibParticipantDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/dialogs/add-bib-participant/' +
                    'add-bib-participant-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    initBibParticipants: initBibParticipants,
                    participants: vm.availableParticipants,
                    bib: vm.bib
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that shows add visitor in bib modal
         */
        function addVisitor() {
            $mdDialog.show({
                controller: 'AddBibVisitorDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/dialogs/add-bib-visitor/' +
                    'add-bib-visitor-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    initBibParticipants: initBibParticipants,
                    visitors: vm.availableVisitors,
                    bib: vm.bib
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that shows add pastor in bib modal
         */
        function addPastor() {
            $mdDialog.show({
                controller: 'AddBibPastortDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/tabs/bib/bottom-sheets/' +
                    'dialogs/add-bib-pastor/add-bib-pastor-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    initBibParticipants: initBibParticipants,
                    participants: vm.availableParticipants,
                    bib: vm.bib,
                    pastor: vm.participants
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that shows add payment in bib modal
         */
        function addPayment(participant) {
            $mdDialog.show({
                controller: 'AddBibPaymentDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/dialogs/add-bib-payment/' +
                    'add-bib-payment-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    initBibParticipants: initBibParticipants,
                    participant: participant,
                    pastor: vm.bib.community.application.pastor,
                    callback: getBib
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that shows delete participant in bib modal
         */
        function deleteParticipant(participant) {
            $mdDialog.show({
                controller: 'DeleteBibParticipantDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/dialogs/' +
                    'delete-bib-participant/delete-bib-participant-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    initBibParticipants: initBibParticipants,
                    participant: participant
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that shows edit participant in bib modal
         */
        function editParticipant(participant) {
            $mdDialog.show({
                controller: 'EditBibParticipantDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/dialogs/edit-bib-participant/' +
                    'edit-bib-participant-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    initBibParticipants: initBibParticipants,
                    participant: participant,
                    pastor: vm.bib.community.application.pastor
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that handles error when showing bottom sheet
         */
        function handleBibParticipantsError(response) {
            vm.$state.go("app.community.bib", { id: vm.$state.params.id });
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.community')
        .controller('PromoteToVisitorDialogController', PromoteToVisitorDialogController);

    /** @ngInject */
    function PromoteToVisitorDialogController($mdDialog,
                                               callback,
                                               participant,
                                               ParticipantService) {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.promoteVisitor = promoteVisitor;

        vm.dialogTitle = "Promote To Visitor";
        vm.message = 'Are you sure you want to promote this participant to visitor?';

        /*
        Function to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        /*
        Function to delete visitor
         */
        function promoteVisitor() {
            vm.saving = true;
            var participantObj = {
                id: participant.id,
                is_visitor: 1
            };
            ParticipantService.editParticipant(participantObj)
                .then(function () {
                    vm.saving = false;
                    callback();
                    closeDialog();
                });
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.community')
        .controller('OverrideParticipantDialogController', OverrideParticipantDialogController);

    /** @ngInject */
    function OverrideParticipantDialogController($mdDialog,
                                              callback,
                                              participant,
                                              ParticipantService) {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.overrideParticipant = overrideParticipant;

        vm.dialogTitle = "Override Participant";
        vm.message = 'Are you sure you want to override this participant?';

        /*
        Function to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        /*
        Function to delete visitor
         */
        function overrideParticipant() {
            vm.saving = true;
            var participantObj = {
                id: participant.id,
                is_overriden: 1,
                has_score_card: 1
            };
            ParticipantService.editParticipant(participantObj)
                .then(function () {
                    vm.saving = false;
                    callback();
                    closeDialog();
                });
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.community')
        .controller('HardDeleteVisitorDialogController', HardDeleteVisitorDialogController);

    /** @ngInject */
    function HardDeleteVisitorDialogController($mdDialog,
                                               $document,
                                               callback,
                                               visitor,
                                               ParticipantService) {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.deleteCallback = deleteCallback;

        vm.dialogTitle = "Delete Visitor";
        vm.message = 'Are you sure you want to delete this visitor?'; 

        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation() {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: vm.deleteCallback,
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        /*
        Function to delete visitor
         */
        function deleteCallback() {
            vm.saving = true;
            ParticipantService.hardDeleteParticipant(visitor)
                .then(function () {
                    vm.saving = false;
                    callback();
                    closeDialog();
                });
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.community')
        .controller('HardDeleteParticipantDialogController', HardDeleteParticipantDialogController);

    /** @ngInject */
    function HardDeleteParticipantDialogController($mdDialog,
                                                   $document,
                                                   callback,
                                                   participant,
                                                   ParticipantService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.deleteCallback = deleteCallback;

        vm.dialogTitle = "Delete Participant";
        vm.dialogBody = '<p class="text-muted text-reminder"><em>Removing this participant will also remove all the associated records (e.g. attendance, bib, hbf)</em>.</p><hr><p>Are you sure you want to delete this participant?</p>';

        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation() {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: vm.deleteCallback,
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        /*
        Function to delete participant
         */
        function deleteCallback() {
            vm.saving = true;
            ParticipantService.hardDeleteParticipant(participant)
                .then(function () {
                    vm.saving = false;
                    callback();
                    closeDialog();
                });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.transform')
        .controller('VisitorsListController', VisitorsListController);

    /** @ngInject */
    function VisitorsListController($scope,
                                    $mdBottomSheet,
                                    ParticipantService,
                                    $mdDialog,
                                    $document,
                                    callback,
                                    community,
                                    $timeout,
                                    $element) {
        var vm = this;

        //Methods
        vm.promoteVisitor = promoteVisitor;
        vm.hardDeleteVisitor = hardDeleteVisitor;
        vm.closeVisitors = closeVisitors;
        vm.stateChange = stateChange;
        vm.pageChange = pageChange;
        vm.addVisitor = addVisitor;

        $('.content-white-holder').addClass('bcopen');

        // Solution to Prevent Drag to Close bottomSheet
        $timeout(function() {
            $element
                .on('$md.dragstart', preventDrag)
                .on('$md.drag', preventDrag)
                .on('$md.dragend', preventDrag);
            var parent = $element.parent();
            var backdrop = parent.find('md-backdrop');
            backdrop.on('$md.dragstart', preventDrag)
                .on('$md.drag', preventDrag)
                .on('$md.dragend', preventDrag);
        });

        function preventDrag(event) {
            event.stopPropagation();
            return false;
        }

        //listen for state change
        $scope.$on('$stateChangeStart', function () {
            vm.stateChange();
        });

        /*
        Function that populates deleted applications table
         */
        function initDisqualifiedParticipants() {
            getVisitors(1);
        }

        initDisqualifiedParticipants();

        /*
        Function that fetches all deleted/dropped applications
         */
        function getVisitors(page) {
            vm.isLoading = true;
            vm.visitors = [];
            ParticipantService.getParticipants({
                sort: 'lastname:asc',
                application_id: community.application_id,
                is_visitor: 1,
                with: 'scorecard,children',
                limit: 10,
                page: page,
            }).then(function (response) {
                vm.visitors = response;
                vm.isLoading = false;
            });
        }

        //executed after listening to state change
        function stateChange() {
            closeVisitors();
        }

        /*
        Function that populate deleted applications when changing pagination page
         */
        function pageChange(page) {
            getVisitors(page);
        }

        /*
        Function to show promote visitor modal
         */
        function promoteVisitor(visitor) {
            $mdDialog.show({
                controller: 'EditParticipantDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/transform/dialogs/edit-participant/edit-participant-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    participant: visitor || null,
                    pastor: community.application.pastor || null,
                    callback: function () {
                        getVisitors(vm.visitors.current_page);
                        callback();
                    },
                    application: community.application
                },
                clickOutsideToClose: true
            });
        }
        /*
        Function to show add visitor modal
         */
        function addVisitor() {
            $mdDialog.show({
                controller: 'AddVisitorDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/dialogs/add-visitor/add-visitor-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    community: community,
                    callback: function () {
                        getVisitors(vm.visitors.current_page);
                    },
                    guest: null
                },
                clickOutsideToClose: true
            });
        }


        /*
        Function to show hard delete visitor
         */
        function hardDeleteVisitor(visitor) {
            $mdDialog.show({
                controller: 'HardDeleteVisitorDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    visitor: visitor,
                    callback: function () {
                        getVisitors(vm.visitors.current_page);
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that closes deleted applications bottom sheet
         */
        function closeVisitors() {
            $('.content-white-holder').removeClass('bcopen');
            $mdBottomSheet.hide();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.transform')
        .controller('DroppedParticipantsController', DroppedParticipantsController);

    /** @ngInject */
    function DroppedParticipantsController($scope,
                                           $mdBottomSheet,
                                           ParticipantService,
                                           $mdDialog,
                                           $document,
                                           callback,
                                           community,
                                           $element,
                                           $timeout,
                                           Auth) {
        var vm = this;

        var currentUser = Auth.getUser();

        //Methods
        vm.restoreParticipant = restoreParticipant;
        vm.hardDeleteParticipant = hardDeleteParticipant;
        vm.closeDroppedParticipants = closeDroppedParticipants;
        vm.stateChange = stateChange;
        vm.pageChange = pageChange;

        $('.content-white-holder').addClass('bcopen');

        // Solution to Prevent Drag to Close bottomSheet
        $timeout(function() {
            $element
                .on('$md.dragstart', preventDrag)
                .on('$md.drag', preventDrag)
                .on('$md.dragend', preventDrag);
            var parent = $element.parent();
            var backdrop = parent.find('md-backdrop');
            backdrop.on('$md.dragstart', preventDrag)
                .on('$md.drag', preventDrag)
                .on('$md.dragend', preventDrag);
        });

        function preventDrag(event) {
            event.stopPropagation();
            return false;
        }

        //listen for state change
        $scope.$on('$stateChangeStart', function () {
            vm.stateChange();
        });

        /*
        Function that populates deleted applications table
         */
        function initDisqualifiedParticipants() {
            getTrashedParticipants(1);
        }

        initDisqualifiedParticipants();

        /*
        Function that fetches all deleted/dropped applications
         */
        function getTrashedParticipants(page) {
            vm.isLoading = true;
            vm.trashedParticipants = [];
            ParticipantService.getParticipants({
                sort: 'type:asc,lastname:asc',
                application_id: community.application_id,
                trashed: 1,
                limit: 10,
                page: page
            }).then(function (response) {
                vm.trashedParticipants = response;
                vm.isLoading = false;
            });
        }

        //executed after listening to state change
        function stateChange() {
            closeVisitors();
        }

        /*
        Function that populate deleted applications when changing pagination page
         */
        function pageChange(page) {
            getTrashedParticipants(page);
        }

        /*
        Function to restore soft deleted participant
         */
        function restoreParticipant(participant) {
            ParticipantService.restoreParticipant(participant).then(function () {
                getTrashedParticipants(vm.trashedParticipants.current_page);
            });
        }

        /*
        Function to show hard delete participant
         */
        function hardDeleteParticipant(participant) {
            $mdDialog.show({
                controller: 'HardDeleteParticipantDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/tabs/attendance/dialogs/hard-delete-participant/hard-delete-participant-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    participant: participant,
                    callback: function () {
                        getTrashedParticipants(vm.trashedParticipants.current_page);
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that closes deleted applications bottom sheet
         */
        function closeDroppedParticipants() {
            $('.content-white-holder').removeClass('bcopen');
            callback();
            $mdBottomSheet.hide();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.transform')
        .controller('DisqualifiedParticipantsController', DisqualifiedParticipantsController);

    /** @ngInject */
    function DisqualifiedParticipantsController($scope,
        $mdBottomSheet,
        ParticipantService,
        $mdDialog,
        callback,
        $document,
        community,
        Auth,
        $timeout,
        $element) {
        var vm = this;
        var currentUser = Auth.getUser();

        //Methods
        vm.community = community;
        vm.promoteToVisitor = promoteToVisitor;
        vm.closeDisqualifiedParticipants = closeDisqualifiedParticipants;
        vm.stateChange = stateChange;
        vm.pageChange = pageChange;
        vm.editParticipant = editParticipant;
        vm.overrideParticipant = overrideParticipant;

        $('.content-white-holder').addClass('bcopen');

        // Solution to Prevent Drag to Close bottomSheet
        $timeout(function () {
            $element
                .on('$md.dragstart', preventDrag)
                .on('$md.drag', preventDrag)
                .on('$md.dragend', preventDrag);
            var parent = $element.parent();
            var backdrop = parent.find('md-backdrop');
            backdrop.on('$md.dragstart', preventDrag)
                .on('$md.drag', preventDrag)
                .on('$md.dragend', preventDrag);
        });

        function preventDrag(event) {
            event.stopPropagation();
            return false;
        }

        //listen for state change
        $scope.$on('$stateChangeStart', function () {
            vm.stateChange();
        });

        /*
        Function that populates deleted applications table
         */
        function initDisqualifiedParticipants() {
            getDisqualifiedParticipants(1);
        }

        initDisqualifiedParticipants();

        /*
        Function that fetches all deleted/dropped applications
         */
        function getDisqualifiedParticipants(page) {
            vm.isLoading = true;
            vm.participants = [];
            ParticipantService.getParticipants({
                sort: 'type:asc,lastname:asc',
                application_id: community.application_id,
                qualified: 0,
                limit: 10,
                page: page,
                with: 'attendance,scorecard,children'
            }).then(function (response) {
                vm.participants = response;
                vm.isLoading = false;
            });
        }

        /*
        Function to show edit participant modal
         */
        function editParticipant(participant) {
            if (!currentUser.$roles.has(['national',
                'area_head',
                'donor_services',
                'donor_managers',
                'view_only'])) {

                var obj = {};
                for (var key in participant) {
                    var val = participant[key];
                    if (key != 'attendance') {
                        obj[key] = val;
                    }
                }
                obj.is_disqualified = true;
                obj.is_overriden = false;
                obj.is_visitor = false;

                $mdDialog.show({
                    controller: 'EditParticipantDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/transform/dialogs/edit-participant/edit-participant-dialog.html',
                    parent: angular.element($document.body),
                    locals: {
                        participant: obj,
                        pastor: vm.community.application.pastor || null,
                        callback: function () {
                            initDisqualifiedParticipants();
                            callback();
                        },
                        application: vm.community.application
                    },
                    clickOutsideToClose: true
                });
            }
        }

        //executed after listening to state change
        function stateChange() {
            closeDisqualifiedParticipants();
        }

        /*
        Function that populate deleted applications when changing pagination page
         */
        function pageChange(page) {
            getDisqualifiedParticipants(page);
        }

        /*
        Function that shows permanent delete application
         */
        function promoteToVisitor(participant) {
            $mdDialog.show({
                controller: 'PromoteToVisitorDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/tabs/attendance/dialogs/promote-to-visitor/promote-to-visitor-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    participant: participant,
                    callback: function () {
                        getDisqualifiedParticipants(vm.participants.current_page);
                        callback();
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that overrides participant
         */
        function overrideParticipant(participant) {
            $mdDialog.show({
                controller: 'OverrideParticipantDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/tabs/attendance/dialogs/override-participant/override-participant-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    participant: participant,
                    callback: function () {
                        getDisqualifiedParticipants(vm.participants.current_page)
                        callback();
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that closes deleted applications bottom sheet
         */
        function closeDisqualifiedParticipants() {
            $('.content-white-holder').removeClass('bcopen');
            $mdBottomSheet.hide();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.thrive')
        .controller('NewChcDialogController', NewChcDialogController);

    /** @ngInject */
    function NewChcDialogController($mdDialog,
        PastorService,
        enumFields,
        ProvinceService,
        CityService,
        BarangayService,
        BaseService,
        ClusterService,
        Auth,
        ChurchService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.addNewPastor = addNewPastor;

        vm.currentUser = Auth.getUser();

        vm.apiErrors = {};
        vm.pastor = {};

        vm.dialogTitle = "New CHC";

        enumFields(["gender", "marital_status", "educational_attainment", "church_position"])
            .then(function (values) {
                vm.gender = values.gender;
                vm.marital_status = values.marital_status;
                vm.educational_attainment = values.educational_attainment;
                vm.church_position = values.church_position;
            });

        // yes/no select optoin
        vm.yesno = [
            { label: "Yes", value: true },
            { label: "No", value: false }
        ];

        // search province
        vm.selectedProvince = null;
        vm.searchProvince = null;
        vm.searchProvinces = function (name) {
            return ProvinceService.getProvinces({
                search: name
            }).then(function (response) {
                return response.data;
            });
        };
        vm.selectProvince = function (province) {
            vm.pastor.province_id = province.id;
            vm.pastor.city_id = null;
            vm.pastor.barangay_id = null;
        };

        // search city
        vm.selectedCity = null;
        vm.searchCity = null;
        vm.searchCities = function (name) {
            return CityService.getCities({
                province_id: vm.pastor.province_id,
                search: name
            }).then(function (response) {
                return response.data;
            });
        };
        vm.selectCity = function (city) {
            vm.pastor.city_id = city.id;
            vm.pastor.barangay_id = null;
        };

        // search barangay
        vm.selectedBarangay = null;
        vm.searchBarangay = null;
        vm.searchBarangays = function (name) {
            return BarangayService.getBarangays({
                city_id: vm.pastor.city_id,
                search: name
            });
        };
        vm.selectBarangay = function (barangay) {
            vm.pastor.barangay_id = barangay.id;
        };

        function initBases() {
            getClusters()
            BaseService.getBases({
                nopage: 1,
                base_id: vm.currentUser.base_id,
                with: "districts"
            })
                .then(function (data) {
                    var base = data[0];

                    vm.bases = data;

                    if (vm.currentUser.base_id) {
                        vm.pastor.base = base;
                    }
                });
        }

        initBases();

        // search church
        vm.selectedChurch = null;
        vm.searchChurch = null;
        vm.searchChurches = function (name) {
            return ChurchService.getChurches({
                search: name,
                with: 'province,city'
            }).then(function (response) {
                return response.data;
            });
        };
        vm.selectChurch = function (church) {
            vm.pastor.church_id = church.id;
        };

        // // get clusters data 
        function getClusters(data) {
            var params = {};
            params.nopage = true;
            if (data && data.base) {
                params.base_id = data.base.id;
            }
            if (data && data.branch) {
                params.branch_id = data.branch.id;
            }
            ClusterService.getClusters(params).then(function (response) {
                vm.clusters = response;
                // vm.filters.cluster = data && data.cluster ? data.cluster : 'all';
            })
        }

        /*
        Function that adds new pastor
         */
        function addNewPastor(pastor, form) {
            vm.saving = true;
            vm.apiErrors = {};
            vm.errorPhone1 = '';
            vm.errorPhone2 = '';
            vm.errorPhone3 = '';

            var data = {
                base_id: pastor.base.id,
                district_id: pastor.district.id,
                province_id: pastor.province.id,
                city_id: pastor.city.id,
                barangay_id: pastor.barangay.id,
                address: pastor.address,

                firstname: pastor.firstname,
                middlename: pastor.middlename,
                lastname: pastor.lastname,

                email: pastor.email,
                birth_date: pastor.birth_date,
                gender: pastor.gender,
                status: pastor.status,
                educational_attainment: pastor.educational_attainment,
                seminary: pastor.seminary,
                messenger_id: pastor.messengerId,
                has_smartphone: pastor.hasSmartphone,

                member: 1,
                active: 1
            };

            if (pastor.church) {
                data.church_id = pastor.church.id;

                if (pastor.position === 'other') {
                    data.church_position = pastor.otherposition;
                } else {
                    data.church_position = pastor.position;
                }
            }

            // add the contact numbers
            data.contact_nos = [];
            if (pastor.contacts1) data.contact_nos.push(pastor.contacts1);
            if (pastor.contacts2) data.contact_nos.push(pastor.contacts2);
            if (pastor.contacts3) data.contact_nos.push(pastor.contacts3);

            return PastorService.addPastor(data)
                .then(function (response) {
                    vm.saving = false;
                    closeDialog(response);
                })
                .catch(function (response) {
                    vm.saving = false;
                    form.$invalid = true;

                    for (var field in response.data.errors) {
                        vm.apiErrors[field] = response.data.errors[field].shift();
                    }

                    if (response.data && response.data.errors) {
                        if (response.data.errors['contact_nos.0']) {
                            vm.errorPhone1 = 'Invalid phone no.';
                        }

                        if (response.data.errors['contact_nos.1']) {
                            vm.errorPhone2 = 'Invalid phone no.';
                        }

                        if (response.data.errors['contact_nos.2']) {
                            vm.errorPhone3 = 'Invalid phone no.';
                        }
                    }
                });
        }

        /*
        Function that closees modal
         */
        function closeDialog(data) {
            $mdDialog.hide(data);
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.community')
        .controller('LeaveSavingsGroupDialogController', LeaveSavingsGroupDialogController);

    /** @ngInject */
    function LeaveSavingsGroupDialogController(
        $mdDialog,
        ParticipantService,
        participant,
        callback
    ) {
        var vm = this;

        vm.dialogTitle = 'Leave Savings Group';
        vm.saving = false;
        vm.reasons = [
            "Dropped from the Community",
            "Did not join during Formation",
            "(Drop out) Unable to repay loans and/or compulsory payments.",
            "(Drop out) Internal family issues",
            "(Drop out) Issues with savings group members / leaders",
            "(Drop out) No longer wanted to save",
            "(Drop out) Deceased",
            "(Drop out) Transferred / Moved",
            "(Drop out) Other"
        ];
        vm.form = {
            id: participant.id,
            reasons: participant.reasons_for_leaving,
            date: participant.date_left || new Date(),
            otherReason: ''
        };

        vm.closeDialog = function closeDialog() {
            $mdDialog.hide();
        }

        vm.didNotJoin = function () {
            return vm.form.reasons === "Did not join during Formation";
        }

        vm.isOtherReason = function () {
            return vm.form.reasons === "(Drop out) Other";
        }

        vm.showOtherReason = function () {
            return vm.didNotJoin() || vm.isOtherReason();
        }

        vm.handleSubmit = function handleSubmit() {
            vm.saving = true;
            ParticipantService.leaveSG(
                vm.form.id,
                vm.form.date,
                vm.showOtherReason() ? vm.form.otherReason : vm.form.reasons
            )
                .then(callback)
                .then(vm.closeDialog)
                .finally(function () {
                    vm.saving = false;
                });
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.community')
        .controller('AssignRoleInPrevailController',
            AssignRoleController);

    /** @ngInject */
    function AssignRoleController($mdDialog,
                                  participant,
                                  callback,
                                  role,
                                  savings,
                                  participantsList,
                                  ParticipantService) {
        var vm = this;

        vm.dialogTitle = 'Assign Roles';
        vm.participant = {};
        vm.participantObj = participant;
        vm.role = role;

        vm.displayReplace = false;

        //Methods
        vm.assignRole = assignRole;
        vm.closeDialog = closeDialog;

        activate();

        /*
        Function used to check if there is a leader in the members list
         */
        function activate() {
            participantsList.map(function (mapParticipant) {
                if (mapParticipant.sg_role === 'leader' && role.value === 'leader') {
                    vm.displayReplace = true;
                }
            });
            if (participant.phone_number) {
                vm.participant.phone_number = participant.phone_number;
            }
        }

        /*
        Function used to assign role to a member of SG
         */
        function assignRole(number, role) {
            vm.saving = true;
            var participantObj = {};
            vm.errorPhone = '';

            if (number) {
                participantObj.phone_number = number;
            }
            participantObj.sg_role = role.value;
            participantObj.id = participant.id;
            participantObj.savings_group_id = savings.id;
            ParticipantService.editParticipant(participantObj)
                .then(function () {
                    vm.saving = false;
                    callback();
                    closeDialog();
                })
                .catch(function (response) {
                    vm.saving = false;
                    if (response.data && response.data.errors) {
                        if (response.data.errors.phone_number) {
                            vm.errorPhone = response.data.errors.phone_number.shift();
                        }
                    }
                });
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.community')
        .controller('AddNonICMParticipantPrevailController',
            AddNonICMParticipantController);

    /** @ngInject */
    function AddNonICMParticipantController($mdDialog,
                                            enumFields,
                                            callback,
                                            savings,
                                            ParticipantService) {
        var vm = this;

        vm.dialogTitle = 'Add Non-ICM Participant';


        //Methods
        vm.closeDialog = closeDialog;
        vm.addParticipant = addParticipant;

        activate();

        /*
        Function used to initialize genders and sg roles
         */
        function activate() {
            vm.savings = savings;
            enumFields(["gender", 'sg_roles'])
                .then(function (values) {
                    vm.genders = values.gender;
                    vm.roles = values.sg_roles;
                });
        }

        /*
        Function used to add non icm participant
         */
        function addParticipant(participant) {
            vm.saving = true;
            vm.errorPhone = '';
            participant.is_non_icm_participant = 1;
            participant.is_kid_saver = vm.kidSaver ? 1 : 0;

            ParticipantService.addParticipant(participant).then(function() {
                vm.saving = false;
                callback();
                closeDialog();
            }).catch(function (response) {
                vm.saving = false;
                if (response.data && response.data.errors) {
                    if (response.data.errors.phone_number) {
                        vm.errorPhone = 'Invalid phone no.';
                    }
                }
            });
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.community')
        .controller('AddSGDataController',
            AddSGDataController);

    /** @ngInject */
    function AddSGDataController($scope,
        $rootScope,
        $state,
        callback,
        sgData,
        participantsStats,
        savingsGroup,
        datas,
        SavingsGroupService,
        SavingsGroupDataService,
        $mdBottomSheet) {
        var vm = this;
        vm.$state = $state;

        //Methods
        sgData = angular.copy(sgData);
        vm.hideSliderCard = hideSliderCard;
        vm.stateChange = stateChange;
        vm.addSGData = addSGData;
        vm.datas = angular.copy(datas);
        vm.minContributions = 0;
        vm.maxContributions = 999999999;
        vm.minWithdrawal = 0;
        vm.maxWithdrawal = 0;
        vm.selectedData = {};
        vm.getMaxWithdrawal = getMaxWithdrawal;

        vm.availableParticipants = [];
        vm.availableVisitors = [];
        vm.attendanceTypes = [
            "Physical",
            "Virtual",
            "Dropzone"
        ];
        vm.onDateChange = onDateChange;
        // ? [ICMT-3538] Temporarily removed
        // vm.computeTotal = computeTotal;

        if (participantsStats) {
            vm.details = angular.copy(participantsStats);
            vm.visible_updated_form = false;
            vm.details.updated_form = true;
            // console.log("data check" + JSON.stringify(vm.details));
        }

        if (!sgData.cluster_id) {
            vm.details = angular.copy(sgData);
            vm.visible_updated_form = true;
            vm.details.updated_form = false;
        }

        /* [ICMT-3538] Temporarily removed
        vm.details.compulsory_contribution = Number(vm.details.compulsory_contribution || 0);
        vm.details.voluntary_contribution = Number(vm.details.voluntary_contribution || 0);

        if (
            vm.details.total_contributions &&
            !vm.details.compulsory_contribution &&
            !vm.details.voluntary_contribution
        ) {
            vm.details.compulsory_contribution = vm.details.total_contributions;
        }
        */

        //listen for state change
        $scope.$on('$stateChangeStart', function () {
            vm.stateChange();
        });

        $('.content-white-holder').addClass('bcopen');

        /*
        Function used to hide bottom sheet
         */
        function hideSliderCard() {
            $mdBottomSheet.hide();
        }

        //executed after listening to state change
        function stateChange() {
            hideSliderCard();
        }

        activate();

        /*
        Function used to fetch savings group details
         */
        function activate() {
            getSavingsGroupDetail();
        }

        function onDateChange(date) {
            var beforeDate, beforeData, afterDate, afterData,
                y = date.getFullYear(),
                m = date.getMonth(),
                firstDay = new Date(y, m, 1);

            // reset validation error and rules
            vm.report_at_error = null;
            vm.minContributions = 0;
            vm.maxContributions = 999999999;
            vm.minWithdrawal = 0;

            for (var index in vm.datas) {
                var data = vm.datas[index];
                var reportDate = moment(data.date, 'YYYY-M-DD');
                var isSame = reportDate.isSame(date, 'month');

                if (!isEditMode() && isSame) {
                    vm.selectedData = vm.datas[index];
                    vm.report_at_error = "There's already a data for this date.";
                }

                if (!isSame && reportDate.isBefore(date)) {
                    beforeDate = reportDate;
                    beforeData = data;
                }

                if (!isSame && !afterDate && reportDate.isAfter(date)) {
                    afterDate = reportDate;
                    afterData = data;
                }
            }

            if (beforeData) {
                vm.minContributions = beforeData.total_contributions;
                vm.minWithdrawal = beforeData.total_withdrawn;
            }

            if (afterData) {
                vm.maxContributions = afterData.total_contributions;
                vm.maxWithdrawal = afterData.total_withdrawn;
            }
        }

        /* [ICMT-3538] Temporarily removed
        function computeTotal () {
            vm.details.total_contributions = (vm.details.compulsory_contribution || 0) +
                (vm.details.voluntary_contribution || 0);
            var keys = Object.keys(savingsGroupDetailsForm.contribution);
            for (var i = 0; i < keys.lengt; i++) {
                var key = keys[i];
                if (savingsGroupDetailsForm.contribution[key].$ngModelController) break;
            }
            if (key) {
                savingsGroupDetailsForm.contribution[key].$ngModelController.$setTouched();
            }
        }
        */

        function getMaxWithdrawal() {
            var maxWithdrawal = 999999999;
            if (vm.maxWithdrawal > 0) {
                maxWithdrawal = vm.maxWithdrawal;
            } else if (vm.details.total_contributions > 0) {
                maxWithdrawal = vm.details.total_contributions;
            }

            return maxWithdrawal;
        }
        //Changes 
        function isEditMode() {
            return !sgData.cluster_id;
        }

        /*
        Function used to add sg data
         */
        function addSGData(details) {
            vm.saving = true;
            vm.report_at_error = '';
            details.savings_group_id = savingsGroup.id;

            details.total_participants = details.total_icm_participants + details.total_non_icm_participants;
            details.total_male_participants = details.total_participants - details.total_female_participants;
            details.balance = details.total_contributions - details.total_withdrawn;

            vm.details.report_at = moment(details.report_at).format('LL');
            delete details.community_id;

            if (!sgData.cluster_id) {
                details.total_contributions = details.total_contributions || 0;
                details.total_withdrawn = details.total_withdrawn || 0;
                details.balance = details.balance || 0;
                details.total_loans_released = details.total_loans_released || 0;
                details.no_of_loans_released = details.no_of_loans_released || 0;
                details.total_loans_repayments = details.total_loans_repayments || 0;
                details.total_social_fund_payout = details.total_social_fund_payout || 0;
                details.total_capital_for_business = details.total_capital_for_business || 0;
                details.gross_sale = details.gross_sale || 0;
                SavingsGroupDataService.editSavingsGroupData(details).then(function (response) {
                    vm.saving = false;
                    callback();
                    hideSliderCard();
                    $rootScope.$broadcast('updateSGData');
                }).catch(function (response) {
                    vm.saving = false;
                    if (response.data.errors && response.data.errors.report_at) {
                        vm.report_at_error = response.data.errors.report_at[0];
                    }
                })
            } else {
                SavingsGroupDataService.addSavingsGroupData(details).then(function (response) {
                    vm.saving = false;
                    callback();
                    hideSliderCard();
                    $rootScope.$broadcast('updateSGData');
                }).catch(function (response) {
                    vm.saving = false;
                    if (response.data.errors && response.data.errors.report_at) {
                        vm.report_at_error = response.data.errors.report_at[0];
                    }
                })
            }
        }

        /*
        Function used to get savings group details
         */
        function getSavingsGroupDetail() {
            SavingsGroupService.getSavingsGroup(savingsGroup)
                .then(function (response) {
                    vm.savingsGroup = response;
                    onDateChange(new Date(vm.details.report_at));
                }).catch(handleSavingsGroupDetailsError.bind(this));
        }

        /*
        Error handler function when getting savings group details fails
         */
        function handleSavingsGroupDetailsError() {
            vm.$state && vm.$state.go("app.community.savings", { id: vm.$state.params.id });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .controller('DenominationsController', DenominationsController);

    /** @ngInject */
    function DenominationsController($rootScope,
                                     $mdDialog,
                                     $document,
                                     DenominationService) {
        var vm = this;
        vm.currentPage = 1;
        vm.initDenominationsTable = initDenominationsTable;
        vm.addNewDenomination = addNewDenomination;
        vm.editDenomination = editDenomination;
        vm.deleteDenomination = deleteDenomination;

        vm.pageChange = pageChange;

        $rootScope.currentTab = 2;

        function initDenominationsTable(page) {
            page = page || vm.currentPage;

            DenominationService.getDenominations({"page": page})
                .then(function (denominations) {
                    vm.denominations = denominations;
                });
        }

        function pageChange(page) {
            vm.currentPage = page;

            initDenominationsTable(vm.currentPage);
        }

        function addNewDenomination() {
            showNewDenominationDialog();
        }

        function editDenomination(denomination) {
            showEditDenominationDialog(denomination);
        }

        function deleteDenomination(denomination) {
            showDeleteDenominationDialog(denomination);
        }

        function showDeleteDenominationDialog(denomination) {
            $mdDialog.show({
                controller: 'DeleteDenominationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    denomination: denomination,
                    initDenominationsTable: initDenominationsTable
                },
                clickOutsideToClose: true
            });
        }

        function showEditDenominationDialog(denomination) {
            $mdDialog.show({
                controller: 'DenominationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/thrive/tabs/denominations/dialogs/save-denomination/save-denomination-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    denominationObj: denomination,
                    initDenominationsTable: initDenominationsTable
                },
                clickOutsideToClose: true
            });
        }

        function showNewDenominationDialog() {
            $mdDialog.show({
                controller: 'DenominationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/thrive/tabs/denominations/dialogs/save-denomination/save-denomination-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    denominationObj: null,
                    initDenominationsTable: initDenominationsTable
                },
                clickOutsideToClose: true
            });
        }

        initDenominationsTable(vm.currentPage);
    }
})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .controller('MayorsController', MayorsController);

    /** @ngInject */
    function MayorsController($rootScope, $mdDialog, $document, MayorService) {
        var vm = this;

        vm.currentPage = 1;
        vm.filters = {};

        //Methods
        vm.initMayorsTable    = initMayorsTable;
        vm.addNewMayor        = addNewMayor;
        vm.editMayor          = editMayor;
        vm.deleteMayor        = deleteMayor;
        vm.pageChange         = pageChange;

        $rootScope.currentTab = 3;

        initMayorsTable(vm.currentPage);

        /*
        Function used to get all church mayors
         */
        function initMayorsTable(page, filters) {
            page = page || vm.currentPage;
            filters = filters || vm.filters;

            var params = {
                with   : "city.province.base",
                page   : page,
                search : filters.search || null
            }

            MayorService.getMayors(params)
                .then(function (mayors) {
                    vm.mayors = mayors;
                });
        }

        /*
        Function triggered when pagination changes page
         */
        function pageChange(page) {
            vm.currentPage = page;

            initMayorsTable(vm.currentPage);
        }

        /*
        Function used to show add new church mayor modal
         */
        function addNewMayor() {
            showNewMayorDialog();
        }

        /*
        Function used to show edit church mayor modal
         */
        function editMayor(mayor) {
            showEditMayorDialog(mayor);
        }

        /*
        Function used to show delete church mayor modal
         */
        function deleteMayor(mayor) {
            showDeleteMayorDialog(mayor);
        }

        /*
        Function used to show delete church mayor modal
         */
        function showDeleteMayorDialog(mayor) {
            $mdDialog.show({
                controller: 'DeleteMayorDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    mayor           : mayor,
                    initMayorsTable : initMayorsTable
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to show edit church mayor modal
         */
        function showEditMayorDialog(mayor) {
            $mdDialog.show({
                controller: 'SaveMayorDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/thrive/tabs/mayors/dialogs/save-mayor/save-mayor-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    mayor           : mayor,
                    initMayorsTable : initMayorsTable
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to show add new church mayor modal
         */
        function showNewMayorDialog() {
            $mdDialog.show({
                controller: 'SaveMayorDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/thrive/tabs/mayors/dialogs/save-mayor/save-mayor-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    mayor           : null,
                    initMayorsTable : initMayorsTable
                },
                clickOutsideToClose: true
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .controller('DataCardSettingsController', DataCardSettingsController);

    /** @ngInject */
    function DataCardSettingsController($rootScope, $timeout, DataCardSettingsService) {
        var vm = this;

        vm.datacard = false;
        vm.saving = false;

        //Methods
        vm.initDataCard = initDataCard;
        vm.onChangeDataCard = onChangeDataCard;

        $rootScope.currentTab = 4;

        $timeout(function () {
            initDataCard();
        }, 1000);

        var debounceTimeout;

        /*
        Function used to get data card status
         */
        function initDataCard() {
            if ($rootScope.userData.allPermissions) {
                const dataCard = $rootScope.userData.allPermissions.find((ele) => ele.role === "pastor_coordinator");
                vm.datacard = Boolean(dataCard.permission);
            }
        }

        /*
        Function used to update data card
        */
        function updateDataCard(data) {
            vm.saving = true;

            return DataCardSettingsService.updateDataCard(data)
                .then(function () {
                    vm.saving = false;
                })
                .catch(function () {
                    vm.saving = false;
                    initDataCard();
                });
        }

        function onChangeDataCard(value) {
            vm.datacard = value;

            if (debounceTimeout) {
                $timeout.cancel(debounceTimeout);
            }

            debounceTimeout = $timeout(function () {
                updateDataCard({
                    role: "pastor_coordinator",
                    permission: value,
                    module: "Data Card",
                });
            }, 500);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.thrivesettings')
        .controller('BasesController', BasesController);

    /** @ngInject */
    function BasesController($rootScope, $mdDialog, $document, BaseService) {
        var vm = this;

        vm.filters = {};

        //Methods
        vm.initBasesTable = initBasesTable;
        vm.addNewBase = addNewBase;
        vm.editBase = editBase;
        vm.deleteBase = deleteBase;
        vm.addNewBranch = addNewBranch;
        vm.editBranch = editBranch;
        vm.deleteBranch = deleteBranch;
        vm.deleteProvince = deleteProvince;
        vm.addNewProvince = addNewProvince;

        $rootScope.currentTab = 1;

        vm.countrysEnum = {
            PH: "Philippines",
            GM: "Guatemala",
            UG: "Uganda",
            BU: "Burundi",
            KH: "Cambodia",
        }

        /*
        Function used to populate base table
         */
        function initBasesTable(filters) {
            filters = filters || vm.filters;

            BaseService.getBases({
                nopage: true,
                with: 'region,branches,branches.cities,branches.cities.province,provinces',
                search: filters.search || null
            })
                .then(function (bases) {
                    vm.bases = bases;
                });
        }

        /*
        Function used to add new base
         */
        function addNewBase() {
            showNewBaseDialog();
        }

        /*
        Function used to edit Base
         */
        function editBase(base) {
            showEditBaseDialog(base);
        }

        /*
        Function used to delete base
         */
        function deleteBase(base) {
            showDeleteBaseDialog(base);
        }

        /*
        Function used to show delete base modal
         */
        function showDeleteBaseDialog(base) {
            $mdDialog.show({
                controller: 'DeleteBaseDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/thrive/tabs/bases/dialogs/delete-base/delete-base-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    base: base,
                    initBasesTable: initBasesTable
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to show edit base modal
         */
        function showEditBaseDialog(base) {
            $mdDialog.show({
                controller: 'BaseDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/thrive/tabs/bases/dialogs/save-base/save-base-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    baseObj: base,
                    initBasesTable: initBasesTable
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to show add base modal
         */
        function showNewBaseDialog() {
            $mdDialog.show({
                controller: 'BaseDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/thrive/tabs/bases/dialogs/save-base/save-base-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    baseObj: null,
                    initBasesTable: initBasesTable
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to add new branch in a base
         */
        function addNewBranch(base) {
            showNewBranchDialog(base);
        }

        /*
        Function used to show add branch dialog
         */
        function showNewBranchDialog(base) {
            $mdDialog.show({
                controller: 'NewBranchDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/thrive/tabs/bases/dialogs/new-branch/new-branch-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    base: base,
                    initBasesTable: initBasesTable
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to edit branch
         */
        function editBranch(base, branch) {
            showEditBranchDialog(base, branch);
        }

        /*
        Function used to delete branch
         */
        function deleteBranch(branch) {
            showDeleteBranchDialog(branch);
        }

        /*
        Function used to show delete branch dialog
         */
        function showDeleteBranchDialog(branch) {
            $mdDialog.show({
                controller: 'DeleteBranchDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/thrive/tabs/bases/dialogs/delete-branch/delete-branch-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    branch: branch,
                    initBasesTable: initBasesTable
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to add new province in a base
         */
        function addNewProvince(base) {
            showNewProvinceDialog(base);
        }

        /*
        Function used to show add province dialog
         */
        function showNewProvinceDialog(base) {
            $mdDialog.show({
                controller: 'NewProvinceDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/thrive/tabs/bases/dialogs/new-province/new-province-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    base           : base,
                    initBasesTable : initBasesTable
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to delete province
         */
        function deleteProvince(province) {
            showDeleteProvinceDialog(province);
        }

        /*
        Function used to show delete province dialog
         */
        function showDeleteProvinceDialog(province) {
            $mdDialog.show({
                controller: 'DeleteProvinceDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/thrive/tabs/bases/dialogs/delete-province/delete-province-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    province: province,
                    initBasesTable: initBasesTable
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to show edit branch dialog
         */
        function showEditBranchDialog(base, branch) {
            $mdDialog.show({
                controller: 'EditBranchDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/thrive/tabs/bases/dialogs/edit-branch/edit-branch-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    branch: branch,
                    base: base,
                    initBasesTable: initBasesTable
                },
                clickOutsideToClose: true
            });
        }

        initBasesTable();
    }
})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .controller('ChurchAffiliationsController', ChurchAffiliationsController);

    /** @ngInject */
    function ChurchAffiliationsController($rootScope,
                                          $mdDialog,
                                          $document,
                                          ChurchAffiliationService) {
        var vm = this;

        vm.currentPage = 1;
        vm.filters = {};

        //Methods
        vm.initChurchAffiliationsTable = initChurchAffiliationsTable;
        vm.addNewChurchAffiliation = addNewChurchAffiliation;
        vm.editChurchAffiliation = editChurchAffiliation;
        vm.deleteChurchAffiliation = deleteChurchAffiliation;
        vm.pageChange = pageChange;

        $rootScope.currentTab = 2;

        initChurchAffiliationsTable(vm.currentPage);

        /*
        Function used to get all church affiliations
         */
        function initChurchAffiliationsTable(page, filters) {
            page = page || vm.currentPage;
            filters = filters || vm.filters;

            ChurchAffiliationService.getChurchAffiliations({
                page: page,
                search: filters.search || null
            })
                .then(function (affiliations) {
                    vm.affiliations = affiliations;
                });
        }

        /*
        Function triggered when pagination changes page
         */
        function pageChange(page) {
            vm.currentPage = page;

            initChurchAffiliationsTable(vm.currentPage);
        }

        /*
        Function used to show add new church affiliation modal
         */
        function addNewChurchAffiliation() {
            showNewChurchAffiliationDialog();
        }

        /*
        Function used to show edit church affiliation modal
         */
        function editChurchAffiliation(affiliation) {
            showEditChurchAffiliationDialog(affiliation);
        }

        /*
        Function used to show delete church affiliation modal
         */
        function deleteChurchAffiliation(affiliation) {
            showDeleteChurchAffiliationDialog(affiliation);
        }

        /*
        Function used to show delete church affiliation modal
         */
        function showDeleteChurchAffiliationDialog(affiliation) {
            $mdDialog.show({
                controller: 'DeleteChurchAffiliationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    affiliation: affiliation,
                    initChurchAffiliationsTable: initChurchAffiliationsTable
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to show edit church affiliation modal
         */
        function showEditChurchAffiliationDialog(affiliation) {
            $mdDialog.show({
                controller: 'ChurchAffiliationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/thrive/tabs/affiliations/dialogs/save-affiliation/save-affiliation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    affiliationObj: affiliation,
                    initChurchAffiliationsTable: initChurchAffiliationsTable
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to show add new church affiliation modal
         */
        function showNewChurchAffiliationDialog() {
            $mdDialog.show({
                controller: 'ChurchAffiliationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/thrive/tabs/affiliations/dialogs/save-affiliation/save-affiliation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    affiliationObj: null,
                    initChurchAffiliationsTable: initChurchAffiliationsTable
                },
                clickOutsideToClose: true
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .controller('UsersController', UsersController);

    /** @ngInject */
    function UsersController($rootScope, $mdDialog, $document, UserService, FormFieldService, Auth) {
        var vm        = this;

        //Methods
        vm.addNewUser  = addNewUser;
        vm.editUser    = editUser;
        vm.deleteUser  = deleteUser;
        vm.pageChange  = pageChange;
        vm.filters     = {};
        vm.filterUsers = filterUsers;

        $rootScope.currentTab = 1;

        activate(1);

        if (localStorage.getItem('userRoles')) {
            vm.roles = JSON.parse(localStorage.getItem('userRoles'));
        } else {
            FormFieldService.getFields().then(function (data) {
                vm.roles = data.user_role.definition;
            });
        }

        /*
        Function used to fetch all users
         */
        function activate(page) {
            return getUsers(page);
        }

        /*
        Function used to get users with a specific page
         */
        function getUsers(page) {
            return UserService.getUsers(page)
                .then(function (data) {
                    vm.users = data;

                    return vm.users;
                })
        }

        /*
        Function triggered after pagination changes page
         */
        function pageChange(page) {
            vm.currentPage = page;
            getUsers(vm.currentPage);
        }

        /*
        Function used to delete user
         */
        function deleteUser(user) {
            showDeleteUserDialog(user);
        }

        /*
        Function used to edit user
         */
        function editUser(user) {
            showEditUserDialog(user);
        }

        /*
        Function used to add new user
         */
        function addNewUser(e) {
            showNewUserDialog(e);
        }

        /*
         * Filter users table.
         */
        function filterUsers(filters) {
            var payload = {};

            if (typeof filters.search !== "undefined" && filters.search.length) {
                payload.search = filters.search
            }

            UserService.fetchUsers(payload)
                .then(function (data) {
                    vm.users = data;

                    return vm.users;
                });
        }

        /*
        Function used to show delete user dialog
         */
        function showDeleteUserDialog(user) {
            $mdDialog.show({
                controller: 'DeleteUserDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    user: user,
                    activate: function () {
                        getUsers(vm.users.current_page);
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to show edit user dialog
         */
        function showEditUserDialog(user) {
            $mdDialog.show({
                controller: 'EditUserDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/transform/tabs/users/dialogs/edit-user/edit-user-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    user: user,
                    callback: function () {
                        getUsers(vm.users.current_page);
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to show new user dialog
         */
        function showNewUserDialog() {
            $mdDialog.show({
                controller: 'NewUserDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/transform/tabs/users/dialogs/new-user/new-user-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    activate: function () {
                        getUsers(vm.users.current_page);
                    }
                },
                clickOutsideToClose: true
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .controller('ProgramsController', ProgramsController);

    /** @ngInject */
    function ProgramsController($rootScope, $mdDialog, $document, ProgramService) {
        var vm = this;
        vm.currentPage = 1;
        vm.filters = {};

        //Methods
        vm.initProgramsTable = initProgramsTable;
        vm.addNewProgram = addNewProgram;
        vm.editProgram = editProgram;
        vm.deleteProgram = deleteProgram;
        vm.pageChange = pageChange;

        initProgramsTable(vm.currentPage);

        $rootScope.currentTab = 2;

        /*
        Function used to populate programs table
         */
        function initProgramsTable(page, filters) {
            page = page || vm.currentPage;
            filters = filters || vm.filters;

            ProgramService.getPrograms({
                page: page,
                with: "parent",
                search: filters.search || null
            })
                .then(function (programs) {
                    vm.programs = programs;
                });
        }

        /*
        Function used to populate programs table after changing pagination page
         */
        function pageChange(page) {
            vm.currentPage = page;

            initProgramsTable(vm.currentPage);
        }

        /*
        Function used to add new program
         */
        function addNewProgram() {
            showNewProgramDialog();
        }

        /*
        Function used to edit program
         */
        function editProgram(program) {
            showEditProgramDialog(program);
        }

        /*
        Function used to delete program
         */
        function deleteProgram(program) {
            showDeleteProgramDialog(program);
        }

        /*
        Function used to show delete program dialog
         */
        function showDeleteProgramDialog(program) {
            $mdDialog.show({
                controller: 'DeleteProgramDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    program: program,
                    initProgramsTable: initProgramsTable
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to show edit program dialog
         */
        function showEditProgramDialog(program) {
            $mdDialog.show({
                controller: 'ProgramDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/transform/tabs/programs/dialogs/save-program/save-program-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    programObj: program,
                    initProgramsTable: initProgramsTable
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to show new program dialog
         */
        function showNewProgramDialog() {
            $mdDialog.show({
                controller: 'ProgramDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/transform/tabs/programs/dialogs/save-program/save-program-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    programObj: null,
                    initProgramsTable: initProgramsTable
                },
                clickOutsideToClose: true
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .controller('DonorsController', DonorsController);

    /** @ngInject */
    function DonorsController($rootScope, $mdDialog, $document, DonorService) {
        var vm = this;
        vm.currentPage = 1;
        vm.filters = {};

        //Methods
        vm.initDonorsTable = initDonorsTable;
        vm.addNewDonor = addNewDonor;
        vm.editDonor = editDonor;
        vm.deleteDonor = deleteDonor;
        vm.pageChange = pageChange;

        $rootScope.currentTab = 5;

        initDonorsTable(vm.currentPage);

        /*
        Function to populate donors table
         */
        function initDonorsTable(page, filters) {
            page = page || vm.currentPage;
            filters = filters || vm.filters;

            DonorService.getDonors({
                page: page,
                search: filters.search || null
            })
                .then(function (donors) {
                    vm.donors = donors;
                });
        }

        /*
        Function to populate donors table on pagination page change
         */
        function pageChange(page) {
            vm.currentPage = page;

            initDonorsTable(vm.currentPage);
        }

        /*
        Function to add new donor
         */
        function addNewDonor() {
            showNewDonorDialog();
        }

        /*
        Function to edit donor
         */
        function editDonor(donor) {
            showEditDonorDialog(donor);
        }

        /*
        Function to delete donor
         */
        function deleteDonor(donor) {
            showDeleteDonorDialog(donor);
        }

        /*
        Function to show delete donor dialog
         */
        function showDeleteDonorDialog(donor) {
            $mdDialog.show({
                controller: 'DeleteDonorDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    donor: donor,
                    initDonorsTable: initDonorsTable
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function to show edit donor dialog
         */
        function showEditDonorDialog(donor) {
            $mdDialog.show({
                controller: 'DonorDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/transform/tabs/donors/dialogs/save-donor/save-donor-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    donorObj: donor,
                    initDonorsTable: initDonorsTable
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function to show new donor dialog
         */
        function showNewDonorDialog() {
            $mdDialog.show({
                controller: 'DonorDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/transform/tabs/donors/dialogs/save-donor/save-donor-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    donorObj: null,
                    initDonorsTable: initDonorsTable
                },
                clickOutsideToClose: true
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .controller('ProductsController', ProductsController);

    /** @ngInject */
    function ProductsController($rootScope, $mdDialog, $document, ProductService) {
        var vm = this;
        vm.currentPage = 1;

        //Methods
        vm.initProductsTable = initProductsTable;
        vm.addNewProduct = addNewProduct;
        vm.editProduct = editProduct;
        vm.deleteProduct = deleteProduct;
        vm.pageChange = pageChange;
        vm.filterProducts = filterProducts;
        vm.filters = {};

        $rootScope.currentTab = 4;

        initProductsTable(vm.currentPage);

        /*
        Function used to populate products table
         */
        function initProductsTable(page) {
            page = page || vm.currentPage;

            ProductService.getProducts({"page": page})
                .then(function (products) {
                    vm.products = products;
                });
        }
        
        /*
         * Filter product table.
         */
        function filterProducts(filters) {
            var payload = {};
            if (typeof filters.search !== "undefined" && filters.search.length) {
                payload.search = filters.search;
            }

            ProductService.getProducts(payload)
                .then(function (products) {
                    vm.products = products;
                });
        }

        /*
        Function triggered after changing pagination page
         */
        function pageChange(page) {
            vm.currentPage = page;

            initProductsTable(vm.currentPage);
        }

        /*
        Function used to add new product
         */
        function addNewProduct() {
            showNewProductDialog();
        }

        /*
        Function used to edit product
         */
        function editProduct(product) {
            showEditProductDialog(product);
        }

        /*
        Function used to delete product
         */
        function deleteProduct(product) {
            showDeleteProductDialog(product);
        }

        /*
        Function used to show delete product dialog
         */
        function showDeleteProductDialog(product) {
            $mdDialog.show({
                controller: 'DeleteProductDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/transform/tabs/products/dialogs/delete-product/delete-product-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    product: product,
                    initProductsTable: initProductsTable
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to show edit product dialog
         */
        function showEditProductDialog(product) {
            $mdDialog.show({
                controller: 'ProductDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/transform/tabs/products/dialogs/save-product/save-product-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    productObj: product,
                    initProductsTable: initProductsTable
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to show new product dialog
         */
        function showNewProductDialog() {
            $mdDialog.show({
                controller: 'ProductDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/transform/tabs/products/dialogs/save-product/save-product-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    productObj: null,
                    initProductsTable: initProductsTable
                },
                clickOutsideToClose: true
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .controller('BatchesController', BatchesController);

    /** @ngInject */
    function BatchesController($rootScope, $state, $mdDialog, $mdBottomSheet, $document, BatchService) {
        var vm         = this;

        vm.$state      = $state;
        vm.currentPage = 1;
        vm.filters     = {};

        // Methods
        vm.initBatchesTable = initBatchesTable;
        vm.addNewBatch      = addNewBatch;
        vm.editBatch        = editBatch;
        vm.deleteBatch      = deleteBatch;
        vm.pageChange       = pageChange;
        vm.showBatchWeeks   = showBatchWeeks;

        $rootScope.currentTab = 3;

        initBatchesTable(vm.currentPage);

        /*
        Function used to populate batches table
         */
        function initBatchesTable(page, filters) {
            page = page || vm.currentPage;
            filters = filters || vm.filters;

            BatchService.getBatches({
                page: page,
                sort: 'fiscal_year:desc,batch_no:asc',
                search: filters.search || null
            })
                .then(function(batches) {
                    vm.batches = batches;
                });
        }

        /*
        Function used to populate table when changing pagination page
         */
        function pageChange(page) {
            vm.currentPage = page;

            initBatchesTable(vm.currentPage);
        }

        /*
        Function used to add new batch
         */
        function addNewBatch() {
            showNewBatchDialog();
        }

        /*
        Function used to edit batch
         */
        function editBatch(batch) {
            showEditBatchDialog(batch);
        }

        /*
        Function used to delete batch
         */
        function deleteBatch(batch) {
            showDeleteBatchDialog(batch);
        }

        /*
        Function used to show delete batch dialog
         */
        function showDeleteBatchDialog(batch) {
            $mdDialog.show({
                controller: 'DeleteBatchDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    batch            : batch,
                    initBatchesTable : initBatchesTable
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to show edit batch dialog
         */
        function showEditBatchDialog(batch) {
            $mdDialog.show({
                controller: 'EditBatchDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/transform/tabs/batches/dialogs/edit-batch/edit-batch-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    batch            : batch,
                    initBatchesTable : initBatchesTable
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to show new batch dialog
         */
        function showNewBatchDialog() {
            $mdDialog.show({
                controller: 'NewBatchDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/transform/tabs/batches/dialogs/new-batch/new-batch-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    initBatchesTable : initBatchesTable
                },
                clickOutsideToClose: true
            });
        }

         /*
        Function that opens participant list bottom sheet
         */
        function showBatchWeeks(batch) {
            if ($state.current.name !== "app.transform.settings.batches.weeks") {
                $state.transitionTo("app.transform.settings.batches.weeks", {id: batch.id}, false);
            }

            $mdBottomSheet.show({
                controller: 'BatchWeekContentController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/transform/tabs/batches/bottom-sheets/batch-weeks/batch-weeks.html',
                parent: '#transform-content-wrapper',
                clickOutsideToClose: true,
                disableBackdrop: true,
                disableParentScroll: true,
                locals: {
                    batch: batch
                }
            })
                .then(handleBatchWeeksCloseEvent.bind(vm))
                .catch(handleBatchWeeksError.bind(vm));

            setTimeout(function() {
                var parent = angular.element('#transform-content-wrapper');
                parent.unbind('$md.dragstart')
                    .unbind('$md.drag')
                    .unbind('$md.dragend');
            }, 1000);
        }

        // open the batch weeks bottom sheet if it is active
        if ($state.current.name == "app.transform.settings.batches.weeks") {
            var data = {
                id : $state.params.id
            };

            BatchService.getBatch(data)
                .then(function (batch) {
                    showBatchWeeks(batch);
                })
                .catch(handleBatchWeeksError.bind(vm));
        }

        /*
        Function that handles bottom sheet close event
         */
        function handleBatchWeeksCloseEvent() {
            if ($state.current.name === 'app.transform.settings.batches.weeks') {
                $('.content-white-holder').removeClass('bcopen');
                this.$state.go("app.transform.settings.batches");
            }
        }

        /*
        Function that handles bottom sheet error
         */
        function handleBatchWeeksError() {
            $('.content-white-holder').removeClass('bcopen');
            this.$state.go("app.transform.settings.batches");
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.changelogs')
        .controller('ApiErrorsController', ApiErrorsController);

    /** @ngInject */
    function ApiErrorsController($rootScope, $mdDialog, $document, ApiErrorService) {
        var vm = this;

        //Methods
        vm.initApiErrorsTable = initApiErrorsTable;
        vm.viewApiError       = viewApiError;
        vm.deleteApiError     = deleteApiError;
        vm.pageChange          = pageChange;
        vm.filterApiErrors    = filterApiErrors;

        vm.isLoading = true;

        vm.filters = {
            device : 0
        }

        vm.devices = [
            'Desktop',
            'Mobile'
        ];

        initApiErrorsTable();

        $rootScope.currentTab = 2;

        /*
        Function used to populate apiErrors table
         */
        function initApiErrorsTable(query) {
            var query  = query || buildPayload();

            query.sort = 'created_at:desc';
            query.with = 'user';

            vm.isLoading = true;
            ApiErrorService.getApiErrors(query)
                .then(function (apiErrors) {
                    vm.apiErrors = apiErrors;
                    vm.isLoading = false;
                });
        }

        /*
        Function triggered when pagination changes page
         */
        function pageChange(page) {
            var payload = buildPayload({'page' : page});

            initApiErrorsTable(payload);
        }

        /*
        Function to show the apiError dialog
         */
        function viewApiError(apiError) {
            $mdDialog.show({
                controller: 'ViewApiErrorDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/changelogs/tabs/api-errors/dialogs/view-api-errors/view-api-errors-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    apiError: apiError
                },
                clickOutsideToClose: true
            });
        }

        /*
        Filter the apiErrors
         */
        function filterApiErrors(filters) {
            var payload = buildPayload(filters);

            initApiErrorsTable(payload);
        }

        function buildPayload(filters) {
            var filters = angular.extend({}, vm.filters, filters);
            var payload = {}

            payload.page = filters.page || 1;

            if (typeof filters.search !== "undefined") {
                payload.search = filters.search;
            }

            if (filters.device.length) {
                payload.device_type = filters.device.toLowerCase();
            }

            return payload;
        }

        /*
        Function to show delete apiError dialog
         */
        function deleteApiError(apiError) {
            showDeleteApiErrorDialog(apiError);
        }

        /*
        Function used to open delete apiError dialog
         */
        function showDeleteApiErrorDialog(apiError) {
            $mdDialog.show({
                controller: 'DeleteApiErrorDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    item: apiError,
                    callback: initApiErrorsTable
                },
                clickOutsideToClose: true
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.changelogs')
        .controller('ChangelogsController', ChangelogsController);

    /** @ngInject */
    function ChangelogsController($rootScope, $mdDialog, $document, ChangelogService) {
        var vm = this;

        //Methods
        vm.initChangelogsTable = initChangelogsTable;
        vm.viewChangelog = viewChangelog;
        vm.deleteChangelog = deleteChangelog;
        vm.pageChange = pageChange;
        vm.filterChangelogs = filterChangelogs;

        vm.isLoading = true;

        vm.filters = {
            action: 0,
            device: 0
        }

        vm.actions = [
            'create',
            'update',
            'restore',
            'soft_delete',
            'hard_delete'
        ];

        vm.devices = [
            'Desktop',
            'Mobile'
        ];

        initChangelogsTable();

        $rootScope.currentTab = 1;

        /*
        Function used to populate changelogs table
         */
        function initChangelogsTable(query) {
            var query = query || buildPayload();

            query.with = 'user';
            query.sort = 'created_at:desc';

            vm.isLoading = true;
            ChangelogService.getChangelogs(query)
                .then(function (changelogs) {
                    vm.changelogs = changelogs;
                    vm.isLoading = false;
                })
                .catch(function () {
                    vm.isLoading = false;
                });
        }

        /*
        Function triggered when pagination changes page
         */
        function pageChange(page) {
            var payload = buildPayload({ 'page': page });

            initChangelogsTable(payload);
        }

        /*
        Function to show the changelog dialog
         */
        function viewChangelog(changelog) {
            $mdDialog.show({
                controller: 'ViewChangelogDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/changelogs/tabs/changelogs/dialogs/view-changelog/view-changelog-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    changelog: changelog
                },
                clickOutsideToClose: true
            });
        }

        /*
        Filter the changelogs
         */
        function filterChangelogs(filters) {
            var payload = buildPayload(filters);

            initChangelogsTable(payload);
        }

        /*
        Build the request payload.
        */
        function buildPayload(filters) {
            var filters = angular.extend({}, vm.filters, filters);
            var payload = {}

            payload.page = filters.page;

            if (typeof filters.search !== "undefined") {
                payload.search = filters.search;
            }

            if (typeof filters.item !== "undefined") {
                payload.item_id = filters.item;
            }

            if (typeof filters.action !== "undefined" && filters.action != 0) {
                payload.action = filters.action;
            }

            if (filters.device.length) {
                payload.device_type = filters.device.toLowerCase();
            }

            return payload;
        }

        /*
        Function to show delete changelog dialog
         */
        function deleteChangelog(changelog) {
            showDeleteChangelogDialog(changelog);
        }

        /*
        Function used to open delete changelog dialog
         */
        function showDeleteChangelogDialog(changelog) {
            $mdDialog.show({
                controller: 'DeleteChangelogDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    changelog: changelog,
                    callback: initChangelogsTable
                },
                clickOutsideToClose: true
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.changelogs')
        .controller('ActiveUsersController', ActiveUsersController);

    /** @ngInject */
    function ActiveUsersController(
        $rootScope,
        $mdDialog,
        $document,
        $mdBottomSheet,
        UserService) {
        var vm = this;

        //Methods
        vm.initActiveUsersTable = initActiveUsersTable;
        vm.viewMobilelog = viewMobilelog;
        vm.showTotalDownloads = showTotalDownloads;
        vm.pageChange = pageChange;

        vm.isLoading = true;

        vm.filters = {};

        initActiveUsersTable();

        $rootScope.currentTab = 3;

        /*
        Function used to populate changelogs table
         */
        function initActiveUsersTable(query) {
            vm.isLoading = true;
            UserService.fetchActiveUsers(query)
                .then(function (users) {
                    vm.users = users;
                    vm.isLoading = false;
                })
                .catch(function () {
                    vm.isLoading = false;
                });
        }

        /*
        Function triggered when pagination changes page
         */
        function pageChange(page) {
            var payload = buildPayload({ 'page': page });
          
            initActiveUsersTable(payload);
        }

        /*
        Build the request payload.
        */
        function buildPayload(filters) {
            var filters = angular.extend({}, vm.filters, filters);
            var payload = {}

            payload.page = filters.page;
          
            return payload;
        }

        /*
        Function to show the mobile logs dialog
         */
        function viewMobilelog(changelog) {

            if (changelog) {
                changelog.action = changelog.activity;
                changelog.is_desktop = false;
                changelog.is_mobile = true;
                changelog.is_tablet = false;
            }

            $mdDialog.show({
                controller: 'ViewChangelogDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/changelogs/tabs/changelogs/dialogs/view-changelog/view-changelog-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    changelog: changelog
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function to show total downloads bottom sheet
         */
        function showTotalDownloads(is_unique_users) {
            $mdBottomSheet.show({
                controller: 'TotalDownloadsController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/changelogs/tabs/active-users/bottom-sheets/total-downloads/total-downloads.html',
                parent: '#changelogs-content-wrapper',
                clickOutsideToClose: true,
                disableBackdrop: true,
                disableParentScroll: true,
                locals: {
                    is_unique_users: is_unique_users
                }
            });

            setTimeout(function () {
                var parent = angular.element('#changelogs-content-wrapper');
                parent.unbind('$md.dragstart')
                    .unbind('$md.drag')
                    .unbind('$md.dragend');
            }, 1000);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.prevailsettings')
        .controller('SmallGroupsController', SmallGroupsController);

    /** @ngInject */
    function SmallGroupsController($rootScope, $mdDialog, $document, SmallGroupService, Auth) {
        var vm = this;
        var currentUser = Auth.getUser();

        //Methods
        vm.initSmallGroupsTable = initSmallGroupsTable;
        vm.addNewSmallGroup = addNewSmallGroup;
        vm.editSmallGroup = editSmallGroup;
        vm.deleteSmallGroup = deleteSmallGroup;
        vm.pageChange = pageChange;

        vm.filters = {};

        $rootScope.currentTab = 3;

        initSmallGroupsTable();

        /*
        Function used to get all smallGroups
         */
        function initSmallGroupsTable(filters) {
            var filters = filters || vm.filters;
            var params = {};

            params.search = filters.search || null;
            params.sort = 'id:asc';
            params.page = filters.page || 1;
            params.limit = filters.limit || 10;
            params.with = 'cluster,base';

            SmallGroupService.getsmallGroups(params)
                .then(function (smallGroups) {
                    vm.smallGroups = smallGroups;
                });
        }

        /*
        Function used to show add small group modal
         */
        function addNewSmallGroup() {
            showNewSmallGroupDialog();
        }

        /*
        Function used to show edit small group modal
         */
        function editSmallGroup(smallGroup) {
            showEditSmallGroupDialog(smallGroup);
        }

        /*
        Function used to delete small group modal
         */
        function deleteSmallGroup(smallGroup) {
            showDeleteSmallGroupDialog(smallGroup);
        }

        /*
        Function used to show delete small group modal
         */
        function showDeleteSmallGroupDialog(smallGroup) {
            $mdDialog.show({
                controller: 'DeleteSmallGroupDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    smallGroup: smallGroup,
                    initSmallGroupsTable: initSmallGroupsTable
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to show edit small group modal
         */
        function showEditSmallGroupDialog(smallGroup) {
            $mdDialog.show({
                controller: 'SaveSmallGroupDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/prevail/tabs/small-group/dialogs/save-small-group/save-small-group-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    smallGroup: smallGroup,
                    initSmallGroupsTable: initSmallGroupsTable
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to show add new small group modal
         */
        function showNewSmallGroupDialog() {
            $mdDialog.show({
                controller: 'SaveSmallGroupDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/prevail/tabs/small-group/dialogs/save-small-group/save-small-group-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    smallGroup: null,
                    initSmallGroupsTable: initSmallGroupsTable
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that listens for every page change of pagination
         */
        function pageChange(page) {
            initSmallGroupsTable({ page });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.prevailsettings')
        .controller('PartnersController', PartnersController);

    /** @ngInject */
    function PartnersController($rootScope, $mdDialog, $document, PartnerService) {
        var vm = this;

        vm.filters = {};

        //Methods
        vm.initPartnersTable = initPartnersTable;
        vm.addNewPartner = addNewPartner;
        vm.editPartner = editPartner;
        vm.deletePartner = deletePartner;
        vm.pageChange = pageChange;

        initPartnersTable();

        $rootScope.currentTab = 1;

        /*
        Function used to populate partners table
         */
        function initPartnersTable(page, filters) {
            page = page || vm.currentPage;
            filters = filters || vm.filters;

            PartnerService.getPartners({
                page: page,
                search: filters.search || null
            })
                .then(function (partners) {
                    vm.partners = partners;
                });
        }

        /*
        Function triggered when pagination changes page
         */
        function pageChange(page) {
            vm.currentPage = page;
            initPartnersTable(page);
        }

        /*
        Function to show new partner dialog
         */
        function addNewPartner() {
            showNewPartnerDialog();
        }

        /*
        Function to show edit partner dialog
         */
        function editPartner(partner) {
            showEditPartnerDialog(partner);
        }

        /*
        Function to show delete partner dialog
         */
        function deletePartner(partner) {
            showDeletePartnerDialog(partner);
        }

        /*
        Function used to open delete partner dialog
         */
        function showDeletePartnerDialog(partner) {
            $mdDialog.show({
                controller: 'DeletePartnerDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    partner: partner,
                    initPartnersTable: initPartnersTable
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to open edit partner dialog
         */
        function showEditPartnerDialog(partner) {
            $mdDialog.show({
                controller: 'PartnerDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/prevail/tabs/partners/dialogs/save-partner/save-partner-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    partnerObj: partner,
                    initPartnersTable: initPartnersTable
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to show new partner dialog
         */
        function showNewPartnerDialog() {
            $mdDialog.show({
                controller: 'PartnerDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/prevail/tabs/partners/dialogs/save-partner/save-partner-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    partnerObj: null,
                    initPartnersTable: initPartnersTable
                },
                clickOutsideToClose: true
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.prevailsettings')
        .controller('ClustersController', ClustersController);

    /** @ngInject */
    function ClustersController($rootScope, $mdDialog, $document, ClusterService, Auth) {
        var vm = this;
        var currentUser = Auth.getUser();

        //Methods
        vm.initClustersTable = initClustersTable;
        vm.addNewCluster = addNewCluster;
        vm.editCluster = editCluster;
        vm.deleteCluster = deleteCluster;

        vm.filters = {};

        $rootScope.currentTab = 2;

        initClustersTable();

        /*
        Function used to get all clusters
         */
        function initClustersTable(data) {
            var data = data || {};
            var params = {};

            params.limit = 10;
            params.nopage = true;
            params.search = data.search || null;
            params.base_id = data.base ? data.base.id : null;
            params.branch_id = data.branch && data.branch.base && data.branch.base.id ? data.base.branch.id : null;
            params.with = 'branch,branch.base';

            ClusterService.getClusters(params)
                .then(function (clusters) {
                    vm.clusters = clusters;
                });
        }

        /*
        Function used to show add cluster modal
         */
        function addNewCluster() {
            showNewClusterDialog();
        }

        /*
        Function used to show edit cluster modal
         */
        function editCluster(cluster) {
            showEditClusterDialog(cluster);
        }

        /*
        Function used to delete cluster modal
         */
        function deleteCluster(cluster) {
            showDeleteClusterDialog(cluster);
        }

        /*
        Function used to show delete cluster modal
         */
        function showDeleteClusterDialog(cluster) {
            $mdDialog.show({
                controller: 'DeleteClusterDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    cluster: cluster,
                    initClustersTable: initClustersTable
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to show edit cluster modal
         */
        function showEditClusterDialog(cluster) {
            $mdDialog.show({
                controller: 'ClusterDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/prevail/tabs/clusters/dialogs/save-cluster/save-cluster-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    clusterObj: cluster,
                    initClustersTable: initClustersTable
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to show add new cluster modal
         */
        function showNewClusterDialog() {
            $mdDialog.show({
                controller: 'ClusterDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/prevail/tabs/clusters/dialogs/save-cluster/save-cluster-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    clusterObj: null,
                    initClustersTable: initClustersTable
                },
                clickOutsideToClose: true
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.reports.branch-report', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.reports_branch', {
                abstract: true,
                url: '/reports/branch-report',
                data: {
                    selectedTab: 0
                },
                defaultChild: 'app.reports_branch.transform',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/reports/branch-report/branch-report.html',
                        controller: 'BranchReportController as vm'
                    }
                }
            })
            .state('app.reports_branch.transform', {
                url: '/transform',
                data: {
                    selectedTab: 0
                },
                views: {
                    'branch-report@transform': {
                        templateUrl: 'app/main/reports/branch-report/tabs/transform/transform.html',
                        controller: 'BranchReportTransformController as vm'
                    }
                }
            })
            .state('app.reports_branch.prevail', {
                url: '/prevail',
                data: {
                    selectedTab: 1
                },
                views: {
                    'branch-report@prevail': {
                        templateUrl: 'app/main/reports/branch-report/tabs/prevail/prevail.html',
                        controller: 'BranchReportPrevailController as vm'
                    }
                }
            })
            .state('app.reports_branch.thrive', {
                url: '/thrive',
                data: {
                    selectedTab: 2
                },
                views: {
                    'branch-report@thrive': {
                        templateUrl: 'app/main/reports/branch-report/tabs/thrive/thrive.html',
                        controller: 'BranchReportThriveController as vm'
                    }
                }
            })
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.reports.branch-report')
        .controller('BranchReportTransformController', BranchReportTransformController);

    /** @ngInject */
    function BranchReportTransformController($scope, Auth, api, BatchService, ProgramService, BaseService, ReportService, $localStorage, $httpParamSerializer)
    {
        var vm = this;

        var _parent = $scope;
        _parent.$parent.vm.currentTab = 0;

        // Data
        vm.filters = {};
        var currentUser = Auth.getUser();
        vm.api = api;

        // Methods
        vm.selectedBase = selectBase;
        vm.getReport = getReport;

        activate();

        function activate() {
            getBases();
            getPrograms();
            getBatches();
        }

        /*
        Function used to listen for base change
         */
        function selectBase(base) {
            vm.filters.branch = base.branches[0];
        }

        /*
        Function that fetches all bases if user has no assigned base
         */
        function getBases() {
            BaseService.getBases({
                nopage: true,
                base_id: currentUser.base_id,
                with: 'branches'
            }).then(function (response) {
                vm.bases = response;
                vm.filters.base = response[0];

                vm.filters.branch = response[0].branches[0];
            });
        }

        /*
        Function used to populate base report
         */
        function getReport(filters) {
            vm.table = '';
            vm.noData = '';
            var htmlObj = {
                'branch_id': filters.branch.id,
                'base_id': filters.base.id,
                'programs[]': 'monthly_transform_report'
            };

            var tempcsvobj = {
                'branch_id': filters.branch.id,
                'base_id': filters.base.id,
                'programs[]': 'monthly_transform_report',
                'token': $localStorage.currentUser.token
            };

            vm.csvUrl = $httpParamSerializer(tempcsvobj);

            vm.loading = true;
            ReportService.getHTML(htmlObj).then(function (response) {
                vm.loading = false;
                vm.report = response.data.data;
                vm.reportSelect = vm.report.navs ? Object.keys(vm.report.navs)[0] : null;
                vm.table = vm.reportSelect ? vm.report.tables[vm.reportSelect] : null;
                vm.navsLength = vm.report.navs ? Object.keys(vm.report.navs).length : 0;
            }).catch(function (response) {
                if (response.data.code === 404) {
                    vm.navsLength = 0;
                    vm.noData = true;
                }
            });
        }

        /*
        Function to get batches
         */
        function getBatches() {
            BatchService.getBatches({'nopage': true})
                .then(function (batches) {
                    vm.batches = batches;
                    vm.filters.batch = batches[0];
                });
        }

        /*
        Function to get all programs
         */
        function getPrograms(data) {
            ProgramService.getPrograms({
                nopage: true
            }).then(function (response) {
                vm.programs = response;
                vm.filters.program = response[0];
            })
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.reports.branch-report')
        .controller('BranchReportThriveController', BranchReportThriveController);

    /** @ngInject */
    function BranchReportThriveController($scope,
                                          $httpParamSerializer,
                                          $localStorage,
                                          Auth,
                                          api,
                                          BatchService,
                                          ReportService,
                                          BaseService) {
        var vm = this;

        var _parent = $scope;
        _parent.$parent.vm.currentTab = 2;

        var currentUser = Auth.getUser();
        vm.api = api;

        // Data
        vm.filters = {};

        // Methods
        vm.getReport = getReport;
        vm.selectBase = selectBase;

        activate();

        /*
        Function first called in the application
         */
        function activate() {
            getBases();
            getBatches();
        }


        /*
        Function used to populate base report
         */
        function getReport(filters) {
            vm.table = '';
            vm.noData = '';
            var htmlObj = {
                'branch_id': filters.branch.id,
                'base_id': filters.base.id,
                'programs[]': 'monthly_thrive_report'
            };

            var tempcsvobj = {
                'branch_id': filters.branch.id,
                'base_id': filters.base.id,
                'programs[]': 'monthly_thrive_report',
                'token': $localStorage.currentUser.token
            };

            vm.csvUrl = $httpParamSerializer(tempcsvobj);

            vm.loading = true;
            ReportService.getHTML(htmlObj).then(function (response) {
                vm.loading = false;
                vm.report = response.data.data;
                vm.reportSelect = vm.report.navs ? Object.keys(vm.report.navs)[0] : null;
                vm.table = vm.reportSelect ? vm.report.tables[vm.reportSelect] : null;
                vm.navsLength = vm.report.navs ? Object.keys(vm.report.navs).length : 0;
            }).catch(function (response) {
                if (response.data.code === 404) {
                    vm.navsLength = 0;
                    vm.noData = true;
                }
            });
        }

        /*
        Function used to listen for base change
         */
        function selectBase(base) {
            vm.filters.branch = base.branches[0];
        }

        /*
        Function that fetches all bases if user has no assigned base
         */
        function getBases() {
            BaseService.getBases({
                nopage: true,
                base_id: currentUser.base_id,
                with: 'branches'
            }).then(function (response) {
                vm.bases = response;
                vm.filters.base = response[0];

                vm.filters.branch = response[0].branches[0];
            });
        }

        /*
        Function to get Batches
         */
        function getBatches() {
            BatchService.getBatches({'nopage': true})
                .then(function (batches) {
                    vm.batches = batches;
                    vm.filters.batch = batches[0];
                });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.reports.branch-report')
        .controller('BranchReportPrevailController', BranchReportPrevailController);

    /** @ngInject */
    function BranchReportPrevailController($scope, Auth, api, BatchService, BaseService, ReportService, $localStorage, $httpParamSerializer) {
        var vm = this;

        var _parent = $scope;
        _parent.$parent.vm.currentTab = 1;

        // Data
        vm.filters = {};
        var currentUser = Auth.getUser();
        vm.api = api;

        // Methods
        vm.selectedBase = selectBase;
        vm.getReport = getReport;

        activate();

        /*
        Function first called in the application
         */
        function activate() {
            getBases();
            getBatches();
        }

        /*
        Function used to listen for base change
         */
        function selectBase(base) {
            vm.filters.branch = base.branches[0];
        }

        /*
        Function that fetches all bases if user has no assigned base
         */
        function getBases() {
            BaseService.getBases({
                nopage: true,
                base_id: currentUser.base_id,
                with: 'branches'
            }).then(function (response) {
                vm.bases = response;
                vm.filters.base = response[0];

                vm.filters.branch = response[0].branches[0];
            });
        }

        /*
        Function used to populate base report
         */
        function getReport(filters) {
            vm.table = '';
            vm.noData = '';
            var htmlObj = {
                'branch_id': filters.branch.id,
                'base_id': filters.base.id,
                'programs[]': 'monthly_prevail_report'
            };

            var tempcsvobj = {
                'branch_id': filters.branch.id,
                'base_id': filters.base.id,
                'programs[]': 'monthly_prevail_report',
                'token': $localStorage.currentUser.token
            };

            vm.csvUrl = $httpParamSerializer(tempcsvobj);

            vm.loading = true;
            ReportService.getHTML(htmlObj).then(function (response) {
                vm.loading = false;
                vm.report = response.data.data;
                vm.reportSelect = vm.report.navs ? Object.keys(vm.report.navs)[0] : null;
                vm.table = vm.reportSelect ? vm.report.tables[vm.reportSelect] : null;
                vm.navsLength = vm.report.navs ? Object.keys(vm.report.navs).length : 0;
            }).catch(function (response) {
                if (response.data.code === 404) {
                    vm.navsLength = 0;
                    vm.noData = true;
                }
            });
        }

        /*
        Function to get Batches
         */
        function getBatches() {
            BatchService.getBatches({'nopage': true})
                .then(function (batches) {
                    vm.batches = batches;
                    vm.filters.batch = batches[0];
                });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.reports.base-report', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.reports_base', {
                abstract: true,
                url: '/reports/base-report',
                data: {
                    selectedTab: 0
                },
                defaultChild: 'app.reports_base.transform',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/reports/base-report/base-report.html',
                        controller: 'BaseReportController as vm'
                    }
                }
            })
            .state('app.reports_base.dashboard', {
                url: '/dashboard',
                data: {
                    selectedTab: 0
                },
                views: {
                    'base-report@dashboard': {
                        templateUrl: 'app/main/reports/base-report/tabs/transform/dashboard.html',
                        controller: 'BaseReportDashboardController as vm'
                    }
                }
            })
            .state('app.reports_base.transform', {
                url: '/transform',
                data: {
                    selectedTab: 1
                },
                views: {
                    'base-report@transform': {
                        templateUrl: 'app/main/reports/base-report/tabs/transform/transform.html',
                        controller: 'BaseReportTransformController as vm'
                    }
                }
            })
            .state('app.reports_base.prevail', {
                url: '/prevail',
                data: {
                    selectedTab: 2
                },
                views: {
                    'base-report@prevail': {
                        templateUrl: 'app/main/reports/base-report/tabs/prevail/prevail.html',
                        controller: 'BaseReportPrevailController as vm'
                    }
                }
            })
            .state('app.reports_base.thrive', {
                url: '/thrive',
                data: {
                    selectedTab: 3
                },
                views: {
                    'base-report@thrive': {
                        templateUrl: 'app/main/reports/base-report/tabs/thrive/thrive.html',
                        controller: 'BaseReportThriveController as vm'
                    }
                }
            })
    }

})();

(function () {
    'use strict';

    angular
        .module('app.reports.base-report')
        .controller('BaseReportTransformController', BaseReportTransformController);

    /** @ngInject */
    function BaseReportTransformController($scope, ProgramService, BaseService, Auth, api, $localStorage, $httpParamSerializer, ReportService, BatchService) {
        var vm = this;

        var _parent = $scope;
        _parent.$parent.vm.currentTab = 1;

        // Data
        vm.filters = {};
        var currentUser = Auth.getUser();
        vm.api = api;

        // Methods
        vm.getReport = getReport;

        activate();

        function activate() {
            getBases();
            getPrograms();
            getBatches();
        }

        /*
        Function to get batches
         */
        function getBatches() {
            BatchService.getBatches({'nopage': true})
                .then(function (batches) {
                    vm.batches = batches;
                    vm.filters.batch = batches[0];
                });
        }

        /*
        Function to get all programs
         */
        function getPrograms(data) {
            ProgramService.getPrograms({
                nopage: true
            }).then(function (response) {
                vm.programs = response;
                vm.filters.program = response[0];
            })
        }


        /*
        Function used to populate base report
         */
        function getReport(filters) {
            vm.table = '';
            vm.noData = '';
            var htmlObj = {
                'batch_id': filters.batch.id,
                'base_id': filters.base.id,
                'program_id': filters.program.id,
                'programs[]': 'monthly_transform_report'
            };

            var tempcsvobj = {
                'batch_id': filters.batch.id,
                'base_id': filters.base.id,
                'program_id': filters.program.id,
                'programs[]': 'monthly_transform_report',
                'token': $localStorage.currentUser.token
            };

            vm.csvUrl = $httpParamSerializer(tempcsvobj);

            vm.loading = true;
            ReportService.getHTML(htmlObj).then(function (response) {
                vm.loading = false;
                vm.report = response.data.data;
                vm.reportSelect = vm.report.navs ? Object.keys(vm.report.navs)[0] : null;
                vm.table = vm.reportSelect ? vm.report.tables[vm.reportSelect] : null;
                vm.navsLength = vm.report.navs ? Object.keys(vm.report.navs).length : 0;
            }).catch(function (response) {
                if (response.data.code === 404) {
                    vm.navsLength = 0;
                    vm.noData = true;
                }
            });
        }

        /*
        Function that fetches all bases if user has no assigned base
         */
        function getBases(data) {
            BaseService.getBases({
                nopage: true,
                base_id: currentUser.base_id,
                with: 'branches'
            }).then(function (response) {
                vm.bases = response;
                vm.filters.base = response[0];

                vm.filters.branch = data && data.branch ? data.branch : 'all'
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.reports.base-report')
        .controller('BaseReportThriveController', BaseReportThriveController);

    /** @ngInject */
    function BaseReportThriveController($scope,
                                        BatchService,
                                        $localStorage,
                                        Auth,
                                        api,
                                        $httpParamSerializer,
                                        BaseService,
                                        ReportService) {
        var vm = this;

        var _parent = $scope;
        _parent.$parent.vm.currentTab = 3;

        var currentUser = Auth.getUser();
        vm.api = api;

        // Data
        vm.filters = {};

        // Methods
        vm.getReport = getReport;

        activate();

        /*
        Function first called in the application
         */
        function activate() {
            getBases();
            getBatches();
        }

        /*
        Function used to populate base report
         */
        function getReport(filters) {
            vm.table = '';
            vm.noData = '';
            var htmlObj = {
                'batch_id': filters.batch.id,
                'base_id': filters.base.id,
                'programs[]': 'monthly_thrive_report'
            };

            var tempcsvobj = {
                'batch_id': filters.batch.id,
                'base_id': filters.base.id,
                'programs[]': 'monthly_thrive_report',
                'token': $localStorage.currentUser.token
            };

            vm.csvUrl = $httpParamSerializer(tempcsvobj);

            vm.loading = true;
            ReportService.getHTML(htmlObj).then(function (response) {
                vm.loading = false;
                vm.report = response.data.data;
                vm.reportSelect = vm.report.navs ? Object.keys(vm.report.navs)[0] : null;
                vm.table = vm.reportSelect ? vm.report.tables[vm.reportSelect] : null;
                vm.navsLength = vm.report.navs ? Object.keys(vm.report.navs).length : 0;
            }).catch(function (response) {
                if (response.data.code === 404) {
                    vm.navsLength = 0;
                    vm.noData = true;
                }
            });
        }

        /*
        Function that fetches all bases if user has no assigned base
         */
        function getBases(data) {
            BaseService.getBases({
                nopage: true,
                base_id: currentUser.base_id,
                with: 'branches'
            }).then(function (response) {
                vm.bases = response;
                vm.filters.base = response[0];

                vm.filters.branch = data && data.branch ? data.branch : 'all'
            });
        }

        /*
        Function to get Batches
         */
        function getBatches() {
            BatchService.getBatches({'nopage': true})
                .then(function (batches) {
                    vm.batches = batches;
                    vm.filters.batch = batches[0];
                });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.reports.base-report')
        .controller('BaseReportPrevailController', BaseReportPrevailController);

    /** @ngInject */
    function BaseReportPrevailController($scope, BaseService, Auth, api, $localStorage, $httpParamSerializer, ReportService, BatchService) {
        var vm = this;

        var _parent = $scope;
        _parent.$parent.vm.currentTab = 1;

        // Data
        vm.filters = {};
        var currentUser = Auth.getUser();
        vm.api = api;

        // Methods
        vm.getReport = getReport;

        activate();

        /*
        Function first called in the application
         */
        function activate() {
            getBases();
            getBatches();
        }

        /*
        Function used to populate base report
         */
        function getReport(filters) {
            vm.table = '';
            vm.noData = '';
            var htmlObj = {
                'batch_id': filters.batch.id,
                'base_id': filters.base.id,
                'programs[]': 'monthly_prevail_report'
            };

            var tempcsvobj = {
                'batch_id': filters.batch.id,
                'base_id': filters.base.id,
                'programs[]': 'monthly_prevail_report',
                'token': $localStorage.currentUser.token
            };

            vm.csvUrl = $httpParamSerializer(tempcsvobj);

            vm.loading = true;
            ReportService.getHTML(htmlObj).then(function (response) {
                vm.loading = false;
                vm.report = response.data.data;
                vm.reportSelect = vm.report.navs ? Object.keys(vm.report.navs)[0] : null;
                vm.table = vm.reportSelect ? vm.report.tables[vm.reportSelect] : null;
                vm.navsLength = vm.report.navs ? Object.keys(vm.report.navs).length : 0;
            }).catch(function (response) {
                if (response.data.code === 404) {
                    vm.navsLength = 0;
                    vm.noData = true;
                }
            });
        }

        /*
        Function that fetches all bases if user has no assigned base
         */
        function getBases(data) {
            BaseService.getBases({
                nopage: true,
                base_id: currentUser.base_id,
                with: 'branches'
            }).then(function (response) {
                vm.bases = response;
                vm.filters.base = response[0];

                vm.filters.branch = data && data.branch ? data.branch : 'all'
            });
        }

        /*
        Function to get Batches
         */
        function getBatches() {
            BatchService.getBatches({'nopage': true})
                .then(function (batches) {
                    vm.batches = batches;
                    vm.filters.batch = batches[0];
                });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.reports.base-report')
        .controller('BaseReportDashboard2Controller', BaseReportDashboard2Controller);

    /** @ngInject */
    function BaseReportDashboard2Controller($scope, BaseService, Auth, api, $localStorage, $httpParamSerializer, ReportService, BatchService) {
        var vm = this;

        var _parent = $scope;
        _parent.$parent.vm.currentTab = 1;

        // Data
        vm.filters = {};
        var currentUser = Auth.getUser();
        vm.api = api;

        // Methods
        vm.getReport = getReport;

        activate();

        /*
        Function first called in the application
         */
        function activate() {
            getBases();
            getBatches();
        }

        /*
        Function used to populate base report
         */
        function getReport(filters) {
            vm.table = '';
            vm.noData = '';
            var htmlObj = {
                'batch_id': filters.batch.id,
                'base_id': filters.base.id,
                'programs[]': 'monthly_dashboard2_report'
            };

            var tempcsvobj = {
                'batch_id': filters.batch.id,
                'base_id': filters.base.id,
                'programs[]': 'monthly_dashboard2_report',
                'token': $localStorage.currentUser.token
            };

            vm.csvUrl = $httpParamSerializer(tempcsvobj);

            vm.loading = true;
            ReportService.getHTML(htmlObj).then(function (response) {
                vm.loading = false;
                vm.report = response.data.data;
                vm.reportSelect = vm.report.navs ? Object.keys(vm.report.navs)[0] : null;
                vm.table = vm.reportSelect ? vm.report.tables[vm.reportSelect] : null;
                vm.navsLength = vm.report.navs ? Object.keys(vm.report.navs).length : 0;
            }).catch(function (response) {
                if (response.data.code === 404) {
                    vm.navsLength = 0;
                    vm.noData = true;
                }
            });
        }

        /*
        Function that fetches all bases if user has no assigned base
         */
        function getBases(data) {
            BaseService.getBases({
                nopage: true,
                base_id: currentUser.base_id,
                with: 'branches'
            }).then(function (response) {
                vm.bases = response;
                vm.filters.base = response[0];

                vm.filters.branch = data && data.branch ? data.branch : 'all'
            });
        }

        /*
        Function to get Batches
         */
        function getBatches() {
            BatchService.getBatches({'nopage': true})
                .then(function (batches) {
                    vm.batches = batches;
                    vm.filters.batch = batches[0];
                });
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.thrive')
        .controller('NewCaseDialogController', NewCaseDialogController);

    /** @ngInject */
    function NewCaseDialogController($mdDialog,
        PastorService,
        enumFields,
        ProvinceService,
        CityService,
        BarangayService,
        BaseService,
        ClusterService,
        Auth,
        ChurchService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.addNewPastor = addNewPastor;
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.updateHbf = updateHbf;
        // vm.selectGuardian = selectGuardian;
        // vm.searchGuardians = searchGuardians;
        // vm.calculateAge = calculateAge;
        // vm.$hbf = HbfService;


        // vm.communityId = parentVm.hbf.community_id;
        // vm.hbfId = parentVm.hbfId;
        // vm.hbf = parentVm.hbf;

        // vm.selectedGuardian = null;
        // vm.currentUser = Auth.getUser();

        vm.apiErrors = {};
        vm.pastor = {};
        vm.weeks = [
            { label: 2, value: 2 },
            { label: 3, value: 3 },
            { label: 4, value: 4 },
            { label: 5, value: 5 },
            { label: 6, value: 6 }
        ];

        vm.dialogTitle = "NEW CASE";
        if (localStorage.getItem('childRelationships')
            && localStorage.getItem('genders')) {
            vm.childRelationships = JSON.parse(localStorage.getItem('childRelationships'));
            vm.genders = JSON.parse(localStorage.getItem('genders'));
        } else {
            FormFieldService.getFields().then(function (response) {
                angular.forEach(response.child_relationship.definition, function (venue) {
                    vm.childRelationships.push({
                        label: venue.label,
                        value: venue.value
                    });

                });
                localStorage.setItem('childRelationships', JSON.stringify(vm.childRelationships));

                angular.forEach(response.gender.definition, function (venue) {
                    vm.genders.push({
                        label: venue.label,
                        value: venue.value
                    });

                });
                localStorage.setItem('genders', JSON.stringify(vm.genders));
            });
        }

        enumFields(["gender", "marital_status", "educational_attainment", "church_position"])
            .then(function (values) {
                vm.gender = values.gender;
                vm.marital_status = values.marital_status;
                vm.educational_attainment = values.educational_attainment;
                vm.church_position = values.church_position;
            });


        // search province
        vm.selectedProvince = null;
        vm.searchProvince = null;
        vm.searchProvinces = function (name) {
            return ProvinceService.getProvinces({
                search: name
            }).then(function (response) {
                return response.data;
            });
        };
        vm.selectProvince = function (province) {
            vm.pastor.province_id = province.id;
            vm.pastor.city_id = null;
            vm.pastor.barangay_id = null;
        };

        // search city
        vm.selectedCity = null;
        vm.searchCity = null;
        vm.searchCities = function (name) {
            return CityService.getCities({
                province_id: vm.pastor.province_id,
                search: name
            }).then(function (response) {
                return response.data;
            });
        };
        vm.selectCity = function (city) {
            vm.pastor.city_id = city.id;
            vm.pastor.barangay_id = null;
        };

        function updateHbf(form, data) {
            vm.apiErrors = {};
            vm.saving = true;

            var hbfObj = {
                community_id: vm.communityId,
                week_no: data.week_no || null,
                child_firstname: data.child_firstname || null,
                child_lastname: data.child_lastname || null,
                contact_no: data.contact_no || null,
                birthdate: data.birthdate || null,
                weight_kg: data.weight_kg || null,
                height_cm: data.height_cm || null,
                gender: data.gender || null,
                weight_at: data.weight_at || null,
                target_weight: data.target_weight || null,
                breastfeeding: data.breastfeeding || 0,
                abcdef_test: data.abcdef_test || 0,
                appetite_test: data.appetite_test || 0,
                with: 'participant,notes'
            };

            hbfObj.birthdate = moment(hbfObj.birthdate).format("LL");
            hbfObj.weight_at = moment(hbfObj.weight_at).format("LL");

            if (data.relationship === 'Other') {
                hbfObj.relationship = data.relationshipOther;
            } else {
                hbfObj.relationship = data.relationship;
            }

            if (vm.selectedGuardian) {
                hbfObj.participant_id = vm.selectedGuardian.id;
            } else {
                hbfObj.guest_name = vm.searchGuardian;
            }

            HbfService.updateHbf(parentVm.hbfId, hbfObj).then(function (response) {
                vm.saving = false;
                parentVm.hbf = response;

                closeDialog();
            }).catch(function (response) {
                vm.saving = false;
                form.$invalid = true;

                for (var field in response.data.errors) {
                    vm.apiErrors[field] = response.data.errors[field].shift();
                }
            });
        }

        function initBases() {
            // getClusters()
            // BaseService.getBases({
            //     nopage: 1,
            //     base_id: vm.currentUser.base_id,
            //     with: "districts"
            // })
            //     .then(function (data) {
            //         var base = data[0];

            //         vm.bases = data;

            //         if (vm.currentUser.base_id) {
            //             vm.pastor.base = base;
            //         }
            //     });
        }

        initBases();

        // search church
        vm.selectedChurch = null;
        vm.searchChurch = null;
        vm.searchChurches = function (name) {
            return ChurchService.getChurches({
                search: name,
                with: 'province,city'
            }).then(function (response) {
                return response.data;
            });
        };
        vm.selectChurch = function (church) {
            vm.pastor.church_id = church.id;
        };

        // // get clusters data 
        function getClusters(data) {
            var params = {};
            params.nopage = true;
            if (data && data.base) {
                params.base_id = data.base.id;
            }
            if (data && data.branch) {
                params.branch_id = data.branch.id;
            }
            ClusterService.getClusters(params).then(function (response) {
                vm.clusters = response;
                // vm.filters.cluster = data && data.cluster ? data.cluster : 'all';
            })
        }

        /*
        Function that adds new pastor
         */
        function addNewPastor(pastor, form) {
            vm.saving = true;
            vm.apiErrors = {};
            vm.errorPhone1 = '';
            vm.errorPhone2 = '';
            vm.errorPhone3 = '';

            var data = {
                base_id: pastor.base.id,
                district_id: pastor.district.id,
                province_id: pastor.province.id,
                city_id: pastor.city.id,
                barangay_id: pastor.barangay.id,
                address: pastor.address,

                firstname: pastor.firstname,
                middlename: pastor.middlename,
                lastname: pastor.lastname,

                email: pastor.email,
                birth_date: pastor.birth_date,
                gender: pastor.gender,
                status: pastor.status,
                educational_attainment: pastor.educational_attainment,
                seminary: pastor.seminary,
                messenger_id: pastor.messengerId,
                has_smartphone: pastor.hasSmartphone,

                member: 1,
                active: 1
            };

            if (pastor.church) {
                data.church_id = pastor.church.id;

                if (pastor.position === 'other') {
                    data.church_position = pastor.otherposition;
                } else {
                    data.church_position = pastor.position;
                }
            }

            // add the contact numbers
            data.contact_nos = [];
            if (pastor.contacts1) data.contact_nos.push(pastor.contacts1);
            if (pastor.contacts2) data.contact_nos.push(pastor.contacts2);
            if (pastor.contacts3) data.contact_nos.push(pastor.contacts3);

            return PastorService.addPastor(data)
                .then(function (response) {
                    vm.saving = false;
                    closeDialog(response);
                })
                .catch(function (response) {
                    vm.saving = false;
                    form.$invalid = true;

                    for (var field in response.data.errors) {
                        vm.apiErrors[field] = response.data.errors[field].shift();
                    }

                    if (response.data && response.data.errors) {
                        if (response.data.errors['contact_nos.0']) {
                            vm.errorPhone1 = 'Invalid phone no.';
                        }

                        if (response.data.errors['contact_nos.1']) {
                            vm.errorPhone2 = 'Invalid phone no.';
                        }

                        if (response.data.errors['contact_nos.2']) {
                            vm.errorPhone3 = 'Invalid phone no.';
                        }
                    }
                });
        }

        /*
        Function that closees modal
         */
        function closeDialog(data) {
            $mdDialog.hide(data);
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.transform')
        .controller('ReportsController', ReportsController);

    /** @ngInject */
    function ReportsController($scope,
                               BatchService,
                               api,
                               $localStorage,
                               $httpParamSerializer,
                               BaseService,
                               ReportService,
                               $mdDialog,
                               $document,
                               Auth,
                               $mdBottomSheet,
                               ProgramService,
                               DonorService) {
        var vm = this;

        var currentUser = Auth.getUser();
        vm.isAdmin = Boolean(currentUser && currentUser.roles && currentUser.$roles.has(["admin"]));
        vm.userCountry = currentUser ? currentUser.country_code : null;
        vm.currentUser = currentUser;


        vm.reportBatches = [];
        vm.reportBases = [];
        vm.reportPrograms = [];
        vm.reportBranches = [];

        vm.templateSelected = false;

        vm.noData = false;

        vm.batches = [];
        vm.bases = [];
        vm.programs = [];

        vm.report = {};
        vm.template = {};

        vm.selectAllBatch = false;
        vm.selectAllBase = false;
        vm.selectAllPrograms = false;

        vm.newReport = true;

        vm.api = api;

        //Methods
        vm.showPreview = showPreview;
        vm.saveTemplate = saveTemplate;
        vm.isSelected = isSelected;
        vm.presetIsSelected = presetIsSelected;
        vm.selectFilter = selectFilter;
        vm.presetSelectFilter = presetSelectFilter;
        vm.showTemplate = showTemplate;
        vm.editTemplate = editTemplate;
        vm.deleteTemplate = deleteTemplate;
        vm.presetShowPreview = presetShowPreview;
        vm.selectDonorInNew = selectDonorInNew;
        vm.presetSelectDonor = presetSelectDonor;
        vm.searchDonors = searchDonors;
        vm.selectBatch = selectBatch;
        vm.selectProgram = selectProgram;
        vm.selectBase = selectBase;
        vm.selectBranch = selectBranch;
        vm.presetSelectBatch = presetSelectBatch;
        vm.presetSelectProgram = presetSelectProgram;
        vm.presetSelectBase = presetSelectBase;
        vm.presetSelectBranch = presetSelectBranch;

        var _parent = $scope;
        _parent.$parent.vm.currentTab = 3;

        activate();

        /*
         This function is called first upon show and gets all batches, bases and report templates
         fiscal_year:asc,batch_no:asc
         */
        function activate() {
            BatchService.getBatches({
                current: 1,
                limit: 1
            }).then(function (response) {
                vm.currentBatch = response.data && response.data.length > 0 ? response.data[0] : '';
            });

            BatchService.getBatches({
                'nopage': true,
                'sort': 'fiscal_year:desc,batch_no:desc'
            })
                .then(function (batches) {
                    var currentBatch = batches[0];
                    if (vm.currentBatch) {
                        currentBatch = batches.filter(function (item) {
                            return item.id == vm.currentBatch.id;
                        }).shift();
                    }

                    vm.batches = batches;
                    vm.report.batch = currentBatch;
                    vm.reportBatches.push(currentBatch.id);
                });

            getBases();

            getTemplates();
            getPrograms();
            // initBases();

            vm.programs = [
                {
                    name: 'Community Overview',
                    id: 'community_overview'
                },
                {
                    name: 'Applications',
                    id: 'applications'
                },
                {
                    name: 'Approval List',
                    id: 'approval_lists'
                },
                {
                    name: 'Selection Data',
                    id: 'selection_data'
                },
                {
                    name: 'Nutripacks',
                    id: 'nutripacks'
                },
                {
                    name: 'Attendance',
                    id: 'participant_attendance'
                },
                {
                    name: 'Livelihood',
                    id: 'community_bibs'
                },
                {
                    name: 'Home Based Feeding',
                    id: 'community_hbfs'
                },
                {
                    name: 'Savings Group',
                    id: 'savings_groups'
                },
                {
                    name: 'Savings Group Membership',
                    id: 'savings_group_members'
                }
            ];
        }

        /*
        Function that gets all bases with branches
         */
        function initBases() {
            BaseService.getBases({
                nopage: 1,
                with: "branches"
            })
                .then(function (data) {
                    vm.bases = data;
                    vm.reportBases = [];
                    vm.reportBranches = []
                    for (var i = 0; i < vm.bases.length; i++) {
                        vm.reportBases.push(vm.bases[i].id);
                    }
                });
        }

        /*
        Function that fetches all programs that has Active sorted first
         */
        function getPrograms() {
            return ProgramService.getPrograms({
                nopage: true,
                sort: 'active:desc'
            }).then(function (data) {
                vm.programTypes = data;
                return vm.programTypes;
            });
        }

        /*
        Function in report preset that selects a batch filter
         */
        function presetSelectBatch(report) {
            vm.template.filters['batch_ids[]'] = [];
            vm.presetSelectedBatch = report.filters.batch;
            vm.template.filters['batch_ids[]'].push(report.filters.batch.id);

            var tempcsvobj = {
                'batch_ids[]': vm.template.filters['batch_ids[]'],
                'base_ids[]': vm.template.filters['base_ids[]'],
                'programs[]': vm.template.filters['programs[]'],
                'branch_ids[]': vm.template.filters['branch_ids[]'],
                'donor_id': vm.template.filters['donor_id'],
                'token': $localStorage.currentUser.token
            };

            if (report.filters.program_type !== 'all') {
                tempcsvobj.program_type = report.filters.program_type;
            }

            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
        Function in report preset that selects a program filter
         */
        function presetSelectProgram(report) {
            var tempcsvobj = {
                'batch_ids[]': vm.template.filters['batch_ids[]'],
                'base_ids[]': vm.template.filters['base_ids[]'],
                'programs[]': vm.template.filters['programs[]'],
                'branch_ids[]': vm.template.filters['branch_ids[]'],
                'donor_id': vm.template.filters['donor_id'],
                'token': $localStorage.currentUser.token
            };

            if (report.filters.program_type !== 'all') {
                tempcsvobj.program_type = report.filters.program_type;
            }

            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
        Function in report preset that selects a base filter
         */
        function presetSelectBase(report) {
            vm.template.filters['base_ids[]'] = [];
            vm.template.filters['branch_ids[]'] = [];
            vm.presetSelectedBase = report.filters.base;
            report.filters.branch = 'all';

            if (report.filters.base !== 'all') {
                vm.template.filters['base_ids[]'].push(report.filters.base.id);
            } else {
                for (var i = 0; i < vm.bases.length; i++) {
                    vm.template.filters['base_ids[]'].push(vm.bases[i].id);
                }
            }

            var tempcsvobj = {
                'batch_ids[]': vm.template.filters['batch_ids[]'],
                'base_ids[]': vm.template.filters['base_ids[]'],
                'programs[]': vm.template.filters['programs[]'],
                'branch_ids[]': vm.template.filters['branch_ids[]'],
                'donor_id': vm.template.filters['donor_id'],
                'token': $localStorage.currentUser.token
            };

            if (report.filters.program_type !== 'all') {
                tempcsvobj.program_type = report.filters.program_type;
            }

            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
        Function in report preset that selects a branch filter
         */
        function presetSelectBranch(report) {
            vm.template.filters['branch_ids[]'] = [];
            if (report.filters.branch !== 'all') {
                vm.template.filters['branch_ids[]'].push(report.filters.branch.id);
            }

            var tempcsvobj = {
                'batch_ids[]': vm.template.filters['batch_ids[]'],
                'base_ids[]': vm.template.filters['base_ids[]'],
                'programs[]': vm.template.filters['programs[]'],
                'branch_ids[]': vm.template.filters['branch_ids[]'],
                'donor_id': vm.template.filters['donor_id'],
                'token': $localStorage.currentUser.token
            };

            if (report.filters.program_type !== 'all') {
                tempcsvobj.program_type = report.filters.program_type;
            }

            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
        Function that selects a batch filter
         */
        function selectBatch(report) {
            vm.reportBatches = [];
            vm.selectedBatch = report.batch;
            vm.reportBatches.push(report.batch.id);

            var tempcsvobj = {
                'batch_ids[]': vm.reportBatches,
                'base_ids[]': vm.reportBases,
                'programs[]': vm.reportPrograms,
                'branch_ids[]': vm.reportBranches,
                'token': $localStorage.currentUser.token
            };

            if (report.program_type !== 'all') {
                tempcsvobj.program_type = report.program_type;
            }

            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
        Function that selects a program filter
         */
        function selectProgram(report) {
            var tempcsvobj = {
                'batch_ids[]': vm.reportBatches,
                'base_ids[]': vm.reportBases,
                'programs[]': vm.reportPrograms,
                'branch_ids[]': vm.reportBranches,
                'token': $localStorage.currentUser.token
            };

            if (report.program_type !== 'all') {
                tempcsvobj.program_type = report.program_type;
            }

            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
        Function that pushes ids into the destination array
         */
        function pushIds(destination, source) {
            for (var i = 0; i < source.length; i++) {
                destination.push(source[i].id);
            }
        }

        /*
        Function that fetches all bases if user has no assigned base
         */
        function getBases(data) {
            var params = {
                nopage: true,
                base_id: currentUser.base_id,
                with: 'branches'
            };

            if (!vm.isAdmin && vm.userCountry) {
                params.country_code = vm.userCountry;
            }

            BaseService.getBases(params).then(function (response) {
                vm.reportBases = [];
                vm.reportBranches = []
                vm.bases          = response;
                var base          = response[0];

                vm.bases = response;
                if (currentUser.base_id) {
                    vm.selectedBase = vm.report.base = base;
                }

                if (currentUser.branch_id) {
                    vm.report.branch  = base.branches.filter(function(item) {
                      return item.id == currentUser.branch_id;
                    }).shift();

                    vm.reportBranches.push(vm.report.branch.id);
                }

                for (var i = 0; i < vm.bases.length; i++) {
                    vm.reportBases.push(vm.bases[i].id);
                }
            });
        }

        /*
        Function that selects a base filter
         */
        function selectBase(report) {
            vm.reportBases = [];
            vm.reportBranches = [];
            vm.selectedBase = report.base;
            report.branch = 'all';
            if (report.base !== 'all') {
                vm.reportBases.push(report.base.id);
            } else {
                for (var i = 0; i < vm.bases.length; i++) {
                    vm.reportBases.push(vm.bases[i].id);
                }
            }

            var tempcsvobj = {
                'batch_ids[]': vm.reportBatches,
                'base_ids[]': vm.reportBases,
                'programs[]': vm.reportPrograms,
                'branch_ids[]': vm.reportBranches,
                'token': $localStorage.currentUser.token
            };

            if (report.program_type !== 'all') {
                tempcsvobj.program_type = report.program_type;
            }

            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
        Function that selects a branch filter
         */
        function selectBranch(report) {
            vm.reportBranches = [];
            if (report.branch !== 'all') {
                vm.reportBranches.push(report.branch.id);
            }

            var tempcsvobj = {
                'batch_ids[]': vm.reportBatches,
                'base_ids[]': vm.reportBases,
                'programs[]': vm.reportPrograms,
                'branch_ids[]': vm.reportBranches,
                'token': $localStorage.currentUser.token
            };

            if (report.program_type !== 'all') {
                tempcsvobj.program_type = report.program_type;
            }

            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
        Function is triggered when an item in donor autocomplete is selected
         */
        function selectDonorInNew(donor) {
            var tempcsvobj = {
                'batch_ids[]': vm.reportBatches,
                'base_ids[]': vm.reportBases,
                'branch_ids[]': vm.reportBranches,
                'programs[]': vm.reportPrograms,
                'token': $localStorage.currentUser.token
            };

            if (donor) {
                vm.selectedDonor = donor;
                tempcsvobj.donor_id = vm.selectedDonor.id;
                BatchService.getBatches({
                    nopage: true,
                    donor_id: vm.selectedDonor.id
                }).then(function (data) {
                    vm.batches = data;
                    vm.report.batch = data[0];
                    vm.reportBatches.push(data[0].id);
                });

                BaseService.getBases({
                    nopage: true,
                    donor_id: vm.selectedDonor.id,
                    with: 'branches'
                }).then(function (data) {
                    vm.bases = data;
                });
            }
            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
        Function in preset that is triggered when an item in donor autocomplete is selected
         */
        function presetSelectDonor(donor) {
            if (vm.template.filters && vm.template.filters.donor_id) vm.template.filters.donor_id = donor.id;
            vm.template.filters = vm.template.filters || {};

            var tempcsvobj = {
                'batch_ids[]': vm.template.filters['batch_ids[]'] || [],
                'base_ids[]': vm.template.filters['base_ids[]'] || [],
                'programs[]': vm.template.filters['programs[]'] || [],
                'branch_ids[]': vm.template.filters['branch_ids[]'] || [],
                'donor_id': vm.template.filters['donor_id'] || [],
                'token': $localStorage.currentUser.token
            };

            if (vm.template.filters.program_type !== 'all') {
                tempcsvobj.program_type = vm.template.filters.program_type;
            }

            if (donor) {
                vm.template.selectedDonor = donor;
                tempcsvobj.donor_id = vm.template.selectedDonor.id;
                BatchService.getBatches({
                    nopage: true,
                    donor_id: vm.template.selectedDonor.id
                }).then(function (data) {
                    vm.batches = data;
                    vm.template.filters.batch = data[0];
                    // vm.reportBatches.push(data[0].id);
                });

                BaseService.getBases({
                    nopage: true,
                    donor_id: vm.template.selectedDonor.id,
                    with: 'branches'
                }).then(function (data) {
                    vm.bases = data;
                });
            }
            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
        Function is triggered when searching a donor in autocomplete
         */
        function searchDonors(query) {
            return DonorService.getDonors({
                search: query,
                nopage: true
            })
        }

        /*
        Function that shows preset report template
         */
        function showTemplate(template) {
            vm.templateSelected = true;
            if (template.filters && template.filters.donor_id) {
                DonorService.getDonor(template.filters.donor_id).then(function (response) {
                    vm.template.selectedDonor = response;
                });
            }
            vm.newReport = false;
            vm.template = template;
            vm.template.noData = false;
            vm.templates = vm.templates.map(function (template) {
                if (template && template.selected) template.selected = false;
                return template;
            });
            template.selected = true;

            // vm.template.filters.batch = template.batch;

            vm.batches.filter(function (batch) {
                if (batch.id === template.filters['batch_ids[]'][0]) {
                    vm.template.filters.batch = batch;
                    vm.presetSelectedBatch = batch;
                    return batch;
                }
            });

            vm.template.filters.program_type = template.filters.program_type ? template.filters.program_type : 'all';

            if (template.filters['base_ids[]'].length > 1 && vm.bases.length > 1) {
                vm.template.filters.base = 'all';
            } else {
                var templateBase = vm.bases.filter(function (base) {
                    if (base.id === template.filters['base_ids[]'][0]) {
                        vm.template.filters.base = base;
                        vm.presetSelectedBase = base;
                        return base;
                    }
                });
            }
            if (vm.presetSelectedBase.branches && vm.presetSelectedBase.branches.length > 1) {
                if (template.filters['branch_ids[]'].length > 1 && vm.presetSelectedBase.branches.length > 1) {
                    vm.template.filters.branch = 'all';
                } else {
                    templateBase[0].branches.filter(function (branch) {
                        if (branch.id === template.filters['branch_ids[]'][0]) {
                            vm.template.filters.branch = branch;
                            return;
                        }
                    });
                }
            } else {
                vm.template.filters.branch = 'all';
            }

            var tempcsvobj = {
                'batch_ids[]': vm.template.filters['batch_ids[]'],
                'base_ids[]': vm.template.filters['base_ids[]'],
                'programs[]': vm.template.filters['programs[]'],
                'branch_ids[]': vm.template.filters['branch_ids[]'],
                'donor_id': vm.template.filters['donor_id'],
                'token': $localStorage.currentUser.token
            };

            if (vm.template.filters.program_type !== 'all') {
                tempcsvobj.program_type = vm.template.filters.program_type;
            }

            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
        Function that gets all report templates
         */
        function getTemplates() {
            ReportService.getTemplates({
                type: 'transform',
                nopage: true,
                user_id: currentUser.id
            }).then(function (response) {
                vm.templates = response.data;
            });
        }

        /*
         Checks if a checkbox is being selected
         */
        function isSelected(item) {
            return vm.reportPrograms.indexOf(item) > -1;
        }

        /*
        Checks in the preset template if a checkbox is being selected
         */
        function presetIsSelected(item) {
            if (vm.templateSelected && vm.template && vm.template.filters)
                return vm.template.filters['programs[]'].indexOf(item) > -1;
        }

        /*
        Function in preset template to select a checkbox filter
         */
        function presetSelectFilter(item) {
            var index = vm.template.filters['programs[]'].indexOf(item);
            if (index > -1) {
                vm.template.filters['programs[]'].splice(index, 1);
            } else {
                vm.template.filters['programs[]'].push(item);
            }
            vm.template.selectAllPrograms = false;
            var tempcsvobj = {
                'batch_ids[]': vm.template.filters['batch_ids[]'],
                'base_ids[]': vm.template.filters['base_ids[]'],
                'programs[]': vm.template.filters['programs[]'],
                'branch_ids[]': vm.template.filters['branch_ids[]'],
                'donor_id': vm.template.filters['donor_id'],
                'token': $localStorage.currentUser.token
            };

            if (vm.template.filters.program_type !== 'all') {
                tempcsvobj.program_type = vm.template.filters.program_type;
            }

            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
         This function selects a checkbox filter
         */
        function selectFilter(item) {
            var index = vm.reportPrograms.indexOf(item);
            if (index > -1) {
                vm.reportPrograms.splice(index, 1);
            } else {
                vm.reportPrograms.push(item);
            }
            vm.selectAllPrograms = false;

            var tempcsvobj = {
                'batch_ids[]': vm.reportBatches,
                'base_ids[]': vm.reportBases,
                'programs[]': vm.reportPrograms,
                'branch_ids[]': vm.reportBranches,
                'donor_id': vm.selectedDonor ? vm.selectedDonor.id : null,
                'token': $localStorage.currentUser.token
            };

            if (vm.report && vm.report.program_type !== 'all') {
                tempcsvobj.program_type = vm.report.program_type;
            }

            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
         Calls bottom sheet UI for Preview
         */
        function showPreview() {
            vm.programMessage = '';
            vm.baseMessage = '';
            vm.branchMessage = '';
            vm.batchMessage = '';

            if (vm.currentUser.base_id) {
                vm.reportBases = [vm.currentUser.base_id];
            }

            if (vm.currentUser.branch_id) {
                vm.reportBranches = [vm.currentUser.branch_id];
            }

            var htmlObj = {
                'batch_ids': vm.reportBatches,
                'base_ids': vm.reportBases,
                'branch_ids': vm.reportBranches,
                'programs': vm.reportPrograms,
                'donor_id': vm.selectedDonor ? vm.selectedDonor.id : null
            };

            if (vm.report.program_type !== 'all') {
                htmlObj.program_type = vm.report.program_type;
            }

            if (vm.reportBases.length > 0 && vm.reportPrograms.length > 0) {
                $mdBottomSheet.show({
                    controller: 'ReportPreviewController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/transform/tabs/reports/bottom-sheets/report-preview/report-preview.html',
                    parent: '#transform-content-wrapper',
                    locals: {
                        preview: htmlObj,
                        csvUrl: vm.csvUrl

                    },
                    clickOutsideToClose: true,
                    disableBackdrop: true,
                    disableParentScroll: true
                });

                setTimeout(function() {
                    var parent = angular.element('#transform-content-wrapper');
                    parent.unbind('$md.dragstart')
                        .unbind('$md.drag')
                        .unbind('$md.dragend');
                }, 1000);
            } else {
                if (vm.reportBatches.length < 1) {
                    vm.batchMessage = 'Please select at least one batch';
                }
                if (vm.reportBases.length < 1) {
                    vm.baseMessage = 'Please select at least one base';
                }

                if (vm.reportBranches.length < 1) {
                    vm.branchMessage = 'Please select at least one branch';
                }

                if (vm.reportPrograms.length < 1) {
                    vm.programMessage = 'Please select at least one program';
                }
            }

        }

        /*
        Function to show preview of presets report
         */
        function presetShowPreview() {
            vm.template.programMessage = '';
            vm.template.baseMessage = '';
            vm.template.branchMessage = '';
            vm.template.batchMessage = '';
            var htmlObj = {
                'batch_ids': vm.template.filters['batch_ids[]'],
                'base_ids': vm.template.filters['base_ids[]'],
                'programs': vm.template.filters['programs[]'],
                'branch_ids': vm.template.filters['branch_ids[]'],
                'donor_id': vm.template.selectedDonor ? vm.template.selectedDonor.id : null
            };

            if (vm.template.filters.program_type !== 'all') {
                htmlObj.program_type = vm.template.filters.program_type;
            }

            if (vm.template.filters['batch_ids[]'].length > 0
                && vm.template.filters['base_ids[]'].length > 0
                && vm.template.filters['programs[]'].length > 0) {
                $mdBottomSheet.show({
                    controller: 'ReportPreviewController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/transform/tabs/reports/bottom-sheets/report-preview/report-preview.html',
                    parent: '#transform-content-wrapper',
                    locals: {
                        preview: htmlObj,
                        csvUrl: vm.csvUrl,
                    },
                    clickOutsideToClose: true,
                    disableBackdrop: true,
                    disableParentScroll: true
                });

                setTimeout(function() {
                    var parent = angular.element('#transform-content-wrapper');
                    parent.unbind('$md.dragstart')
                        .unbind('$md.drag')
                        .unbind('$md.dragend');
                }, 1000);
            } else {
                if (vm.template.filters['batch_ids[]'].length < 1) {
                    vm.template.batchMessage = 'Please select at least one batch';
                }
                if (vm.template.filters['base_ids[]'].length < 1) {
                    vm.template.baseMessage = 'Please select at least one base';
                }
                if (vm.template.filters['branch_ids[]'].length < 1) {
                    vm.template.branchMessage = 'Please select at least one branch';
                }
                if (vm.template.filters['programs[]'].length < 1) {
                    vm.template.programMessage = 'Please select at least one program';
                }
            }
        }

        /*
        Function to open save template modal
         */
        function saveTemplate() {
            var csvObj = {
                'batch_ids[]': vm.reportBatches,
                'base_ids[]': vm.reportBases,
                'programs[]': vm.reportPrograms,
                'branch_ids[]': vm.reportBranches
            };

            if (vm.report.program_type !== 'all') {
                csvObj.program_type = vm.report.program_type;
            }

            if (vm.selectedDonor) csvObj.donor_id = vm.selectedDonor.id;
            $mdDialog.show({
                controller: 'AddReportTemplateDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/transform/tabs/reports/dialogs/add-report-template/add-report-template-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    csvObj: csvObj,
                    getTemplates: getTemplates,
                    mode: 'transform'
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function to open edit template modal
         */
        function editTemplate() {
            if (vm.template.filters['batch_ids[]'].length > 0
                && vm.template.filters['base_ids[]'].length > 0
                && vm.template.filters['programs[]'].length > 0) {
                $mdDialog.show({
                    controller: 'EditReportTemplateDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/transform/tabs/reports/dialogs/edit-report-template/edit-report-template-dialog.html',
                    parent: angular.element($document.body),
                    locals: {
                        template: vm.template,
                        templates: vm.templates,
                        mode: 'transform'
                    },
                    clickOutsideToClose: true
                });
            } else {
                if (vm.template.filters['batch_ids[]'].length < 1) {
                    vm.template.batchMessage = 'Please select at least one batch';
                }
                if (vm.template.filters['base_ids[]'].length < 1) {
                    vm.template.baseMessage = 'Please select at least one base';
                }
                if (vm.template.filters['branch_ids[]'].length < 1) {
                    vm.template.branchMessage = 'Please select at least one branch';
                }
                if (vm.template.filters['programs[]'].length < 1) {
                    vm.template.programMessage = 'Please select at least one program';
                }
            }
        }

        /*
        Function to open delete template modal
         */
        function deleteTemplate() {
            $mdDialog.show({
                controller: 'DeleteReportTemplateDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    template: vm.template,
                    callback: function () {
                        getTemplates();
                        vm.newReport = true;
                    }
                },
                clickOutsideToClose: true
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.transform')
        .controller('ApprovalListsController', ApprovalListsController);

    /** @ngInject */
    function ApprovalListsController($scope,
        ProgramService,
        $mdDialog,
        $document,
        $state,
        $mdBottomSheet,
        ApplicationService,
        BaseService,
        Auth) {
        var vm = this;
        
        var currentUser = Auth.getUser();
        vm.isAdmin = Boolean(currentUser && currentUser.roles && currentUser.$roles.has(["admin"]));
        vm.userCountry = currentUser ? currentUser.country_code : null;

        vm.$state = $state;

        //Methods
        vm.batchSelection = batchSelection;
        vm.callPastorInformation = callPastorInformation;
        vm.dropApplication = dropApplication;
        vm.refreshTables = refreshTables;
        vm.pageChange = pageChange;
        vm.addParticipants = showParticipants;
        vm.drawApprovedApplicationsTable = drawApprovedApplicationsTable;
        vm.getBases = getBases;
        vm.getPrograms = getPrograms;
        vm.selectBase = selectBase;
        vm.selectBranch = selectBranch;
        vm.selectProgram = selectProgram;
        vm.editApplication = editApplication;
        vm.totalParticipants = "loading..";
        vm.totalChildren = "loading..";

        vm.selectedCity = 'All Bases';
        vm.isLoading2 = false;
        vm.approvedApplications = [];

        var _parent = $scope;
        _parent.$parent.vm.currentTab = 1;

        refreshTables();

        /*
        Function that fetches bases, programs and approved applications
         */
        function refreshTables() {
            vm.filters = {
                base: 'all',
                branch: 'all',
                program: 'all',
            };

            var data;
            if (localStorage.getItem('approved')) {
                data = JSON.parse(localStorage.getItem('approved'));
            }
            getBases(data);
            getPrograms(data);
            drawApprovedApplicationsTable(data);
        }

        /*
        Function that fetches all bases if user has no assigned base
         */
        function getBases(data) {
            var params = {
                nopage: true,
                base_id: currentUser.base_id,
                with: 'branches'
            };

            if (!vm.isAdmin && vm.userCountry) {
                params.country_code = vm.userCountry;
            }

            BaseService.getBases(params).then(function (response) {
                var base = response[0];

                vm.bases = response;
                if (currentUser.base_id) {
                    vm.filters.base = base;
                } else {
                    vm.filters.base = data && data.base ? data.base : 'all';
                }

                if (currentUser.branch_id) {
                    vm.filters.branch = base.branches.filter(function (item) {
                        return item.id == currentUser.branch_id;
                    }).shift();
                } else {
                    vm.filters.branch = data && data.branch ? data.branch : 'all';
                }
            });
        }

        /*
        Function that fetches all active programs
         */
        function getPrograms(data) {
            ProgramService.getPrograms({
                nopage: true,
                active: true
            }).then(function (response) {
                vm.programs = response;
                vm.filters.program = data && data.program ? data.program : 'all';
            })
        }

        /*
        Function that selects a base filter
         */
        function selectBase(data) {
            vm.filters.branch = 'all';
            data.page = 1;
            drawApprovedApplicationsTable(data);
            localStorage.setItem('approved', JSON.stringify(data));
        }

        /*
        Function that selects a program filter
         */
        function selectProgram(data) {
            data.page = 1;
            drawApprovedApplicationsTable(data);
            localStorage.setItem('approved', JSON.stringify(data));
        }

        /*
        Function that selects a branch filter
         */
        function selectBranch(data) {
            data.page = 1;
            drawApprovedApplicationsTable(data);
            localStorage.setItem('approved', JSON.stringify(data));
        }

        /*
        Function that calls the function for editing application
         */
        function editApplication(application) {
            showApplicationDialog(application);
        }

        /*
        Function that calls modal service for new application
         */
        function showApplicationDialog(application) {
            $mdDialog.show({
                controller: 'NewApplicationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/transform/dialogs/new-application/new-application-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    application: application || null,
                    drawApplicationsTable: function () {
                        var data = {
                            page: vm.approvedApplications.current_page
                        };
                        drawApprovedApplicationsTable(data);
                    }
                },
                clickOutsideToClose: true
            });

        }

        /*
        Function that populates approved applications
         */
        function drawApprovedApplicationsTable(data) {
            vm.approvedApplications = [];
            var data = data || {};
            var params = {};

            params.approved = 1;
            params.limit = 10;
            params.sort = 'applied_at:asc';
            params.page = data.page || 1;
            params.program_id = data.program ? data.program.id : null;
            params.base_id = data.base ? data.base.id : (currentUser.base_id || null);
            params.base_branch_id = data.branch ? data.branch.id : (currentUser.branch_id || null);

            if (!vm.isAdmin && vm.userCountry) {
                params.country_code = vm.userCountry;
            }

            params.with = 'church,' +
                'program,' +
                'base,' +
                'church.barangay,' +
                'church.city,' +
                'program,' +
                'base.branches,' +
                'pastor,' +
                'pastor.churches,' +
                'pastor.churches.affiliation,' +
                'pastor.base,' +
                'pastor.province,' +
                'pastor.city,' +
                'pastor.barangay,' +
                'pastor.contacts,' +
                'pastor.churches.barangay,' +
                'pastor.churches.city';

            vm.isLoading2 = true;

            ApplicationService.queryApplications(params).then(function (data) {
                vm.isLoading2 = false;
                vm.approvedApplications = data;
            });

            vm.totalParticipants = "loading..";
            vm.totalChildren = "loading..";
            var params2 = angular.copy(params);
            delete params2.sort;
            delete params2.with;
            params2.participant_status = 'overriden';
            ApplicationService.getTotalParticipants(params2).then(function (data) {
                vm.totalParticipants = data.total;

                var params3 = angular.copy(params2);
                params3.count_children = 1;
                delete params3.participant_status;
                ApplicationService.getTotalParticipants(params3).then(function (data) {
                    vm.totalChildren = data.total;
                });
            });
        }

        /*
        Function that shows drop application modal
         */
        function dropApplication(application, mode) {
            $mdDialog.show({
                controller: 'DropApplicationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/transform/dialogs/drop-application/drop-application-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    application: application || null,
                    mode: mode,
                    drawApplicationsTable: function () {
                        pageChange(vm.approvedApplications.current_page, vm.filters);
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that repopulate the table when changing pagination page
         */
        function pageChange(page, filters) {
            filters.page = page;
            var data = filters;
            drawApprovedApplicationsTable(data);
            localStorage.setItem('approved', JSON.stringify(data));
        }

        /*
        Function that checks if application has pastor and show pastor modal
         */
        function callPastorInformation(pastor, church) {
            if (pastor) {
                pastor.church = church;

                showPastorInformationDialog(pastor);
            }
        }

        /*
        Function that shows up pastor details modal
         */
        function showPastorInformationDialog(pastor) {
            $mdDialog.show({
                controller: 'PastorInformationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/transform/dialogs/pastor-information/pastor-information-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    pastor: pastor
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that opens batch selection modal
         */
        function batchSelection(application) {
            $mdDialog.show({
                controller: 'BatchSelectionDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/transform/dialogs/batch-selection/batch-selection-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    application: application,
                    participants: {
                        total_approved_participants: application.total_approved_participants,
                        total_participants: application.total_participants,
                        total_approved_counselors: application.total_approved_counselors,
                        total_counselors: application.total_counselors
                    },
                    drawApplicationsTable: function () {
                        pageChange(vm.approvedApplications.current_page, vm.filters);
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that opens participant list bottom sheet
         */
        function showParticipants(application) {
            if ($state.current.name !== "app.transform.approval-lists.participants") {
                $state.transitionTo("app.transform.approval-lists.participants", { id: application.id }, false);
            }

            $mdBottomSheet.show({
                controller: 'ParticipantsContentController',
                controllerAs: 'vm',
                templateUrl: 'app/main/transform/tabs/approval-lists/bottom-sheets/application-participants/application-participants.html',
                parent: '#transform-content-wrapper',
                clickOutsideToClose: true,
                disableBackdrop: true,
                disableParentScroll: true,
                locals: {
                    application: application,
                    refreshApprovedApplications: refreshTables
                }
            })
                .then(handleParticipantCloseEvent.bind(vm))
                .catch(handleParticipantsError.bind(vm));

            setTimeout(function () {
                var parent = angular.element('#transform-content-wrapper');
                parent.unbind('$md.dragstart')
                    .unbind('$md.drag')
                    .unbind('$md.dragend');
            }, 1000);
        }

        //checks if state is in participant list then opens up bottom sheet
        if ($state.current.name == "app.transform.approval-lists.participants") {
            var params = {};
            params.with = 'program,base.branches,pastor.churches,pastor.churches.affiliation,' +
                'pastor.base,pastor.province,pastor.city,' +
                'pastor.barangay,pastor.contacts';
            ApplicationService.getApplication($state.params.id, params).then(function (application) {
                showParticipants(application);
            }).catch(handleParticipantsError.bind(vm));
        }

        /*
        Function that handles bottom sheet close event
         */
        function handleParticipantCloseEvent() {
            if ($state.current.name === 'app.transform.approval-lists.participants') {
                $('.content-white-holder').removeClass('bcopen');
                this.$state.go("app.transform.approval-lists");
            }
        }

        /*
        Function that handles bottom sheet error
         */
        function handleParticipantsError() {
            $('.content-white-holder').removeClass('bcopen');
            this.$state.go("app.transform.approval-lists");
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.transform')
        .controller('CommunityListsController', CommunityListsController);

    /** @ngInject */
    function CommunityListsController($scope,
        $state,
        $mdDialog,
        $document,
        BatchService,
        CommunityService,
        BaseService,
        Auth,
        PastorService,
        ProgramService) {
        var vm = this;
        
        var currentUser = Auth.getUser();
        vm.isAdmin = Boolean(currentUser && currentUser.roles && currentUser.$roles.has(["admin"]));
        vm.userCountry = currentUser ? currentUser.country_code : null;

        //Methods
        vm.callPastorInformation = callPastorInformation;
        vm.dropApplication = dropApplication;
        vm.refreshTables = refreshTables;
        vm.communityPageChange = communityPageChange;
        vm.getCommunityList = getCommunityList;
        vm.goToCommunity = goToCommunity;
        vm.selectBase = selectBase;
        vm.selectBatch = selectBatch;
        vm.selectBranch = selectBranch;
        vm.selectProgram = selectProgram;
        vm.editCommunity = editCommunity;
        vm.selectCommunityId = selectCommunityId;
        vm.searchPastors = searchPastors;
        vm.selectPastor = selectPastor;

        vm.selectedCommunityCity = 'All Bases';
        vm.isLoading3 = false;
        vm.communities = [];
        vm.batches = [];

        vm.batchFilter = {};

        vm.totalParticipants = "loading..";
        vm.totalChildren = "loading..";
        vm.communities.total = "loading..";


        var _parent = $scope;
        _parent.$parent.vm.currentTab = 2;

        vm.barangayLebel = 'Barangay';
        vm.municipalityLebel = 'Municipality';
        refreshTables();

        /*
        Function first called in the controller
         */
        function refreshTables() {
            vm.filters = {
                base: 'all',
                branch: 'all',
                search: '',
                pastor: ''
            };

            var data;
            if (localStorage.getItem('community')) {
                data = JSON.parse(localStorage.getItem('community'));

                vm.filters.search = data && data.search ? data.search : null;
                vm.selectedPastor = data && data.pastor ? data.pastor : null;
                vm.filters.pastor = data && data.pastor ? data.pastor : null;
            }
            getPrograms(data);
            getBases(data);
            getCurrentBatch(data);
        }

        /*
        Function to get Batches that takes parameter data to filter request
         */
        function getBatches(data) {
            BatchService.getBatches({ 'nopage': true, sort: 'fiscal_year:desc,batch_no:desc' })
                .then(function (batches) {
                    vm.batches = batches;
                    vm.filters.batch = vm.currentBatch || batches[0];

                    getCommunityList(vm.filters);
                });
        }

        /*
        Function to get the current running Batch
         */
        function getCurrentBatch(data) {
            BatchService.getBatches({
                current: 1,
                limit: 1
            }).then(function (response) {
                vm.currentBatch = response.data && response.data.length > 0 ? response.data[0] : '';
                getBatches(data);
            })
        }

        /*
        Function to get all bases
         */
        function getBases(data) {
            var params = {
                nopage: true,
                base_id: currentUser.base_id,
                with: 'branches'
            };

            if (!vm.isAdmin && vm.userCountry) {
                params.country_code = vm.userCountry;
            }

            BaseService.getBases(params).then(function (response) {
                var base = response[0];

                vm.bases = response;

                if (currentUser.base_id) {
                    vm.filters.base = base;
                } else {
                    vm.filters.base = data && data.base ? data.base : 'all';
                }

                if (vm.filters.base && vm.filters.base.name) {
                    updateBarangayLebel(vm.filters.base.name)
                }

                if (currentUser.branch_id) {
                    vm.filters.branch = base.branches.filter(function (item) {
                        return item.id == currentUser.branch_id;
                    }).shift();
                } else {
                    vm.filters.branch = data && data.branch ? data.branch : 'all';
                }
            });
        }

        /*
        Function to get all programs
         */
        function getPrograms(data) {
            ProgramService.getPrograms({
                nopage: true,
                active: true
            }).then(function (response) {
                vm.programs = response;
                vm.filters.program = data && data.program ? data.program : 'all';
            })
        }

        /*
        Function that calls the function for editing application
         */
        function editCommunity(community) {
            showApplicationDialog(community);
        }

        /*
        Function that calls modal service for new application
         */
        function showApplicationDialog(community) {
            $mdDialog.show({
                controller: 'NewApplicationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/transform/dialogs/new-application/new-application-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    application: community || null,
                    drawApplicationsTable: function () {
                        communityPageChange(vm.communities.current_page, vm.filters);
                    }
                },
                clickOutsideToClose: true
            });

        }

        /*
        Function that is triggered to redirect to community page
         */
        function goToCommunity(id) {
            $state.go('app.community.attendance', { id: id });
        }

        /*
        Function that opens drop application modal
         */
        function dropApplication(application, mode) {
            $mdDialog.show({
                controller: 'DropApplicationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/transform/dialogs/drop-application/drop-application-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    application: application || null,
                    mode: mode,
                    drawApplicationsTable: function () {
                        communityPageChange(vm.communities.current_page, vm.filters);
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function triggered when changing page in pagination
         */
        function communityPageChange(page, filters) {
            filters.page = page;
            var data = filters;
            getCommunityList(data);
            localStorage.setItem('community', JSON.stringify(data));
        }

        /*
        Function validating if there is pastor id then display pastor modal
         */
        function callPastorInformation(pastor, church) {
            if (pastor) {
                pastor.church = church;

                showPastorInformationDialog(pastor);
            }
        }

        /*
        Function triggered to show pastor details modal
         */
        function showPastorInformationDialog(pastor) {
            $mdDialog.show({
                controller: 'PastorInformationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/transform/dialogs/pastor-information/pastor-information-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    pastor: pastor
                },
                clickOutsideToClose: true
            });
        }

        /*
         Function user to update the barangay column
         */
        function updateBarangayLebel(baseName) {
            vm.barangayLebel = "Barangay";
            vm.municipalityLebel = 'Municipality';

            if (baseName === "Burundi") {
                vm.barangayLebel = "Colline";
                vm.municipalityLebel = 'Commune';
            }

            if (baseName === "Uganda") {
                vm.barangayLebel = "Parish/Village";
                vm.municipalityLebel = 'Sub County';
            }

            if (baseName === "Guatemala") {
                vm.barangayLebel = "Aldea";
                vm.municipalityLebel = 'Municipalidad';
            }
        }

        /*
        Function called when changing base filter
         */
        function selectBase(data) {
            if (data && data.base && data.base.name) {
                updateBarangayLebel(data.base.name)
            }

            vm.filters.branch = 'all';
            data.page = 1;
            getCommunityList(data);
            localStorage.setItem('community', JSON.stringify(data));
        }

        /*
        Function called when changing program filter
         */
        function selectProgram(data) {
            data.page = 1;
            getCommunityList(data);
            localStorage.setItem('community', JSON.stringify(data));
        }

        /*
        Function called when changing batch filter
         */
        function selectBatch(data) {
            data.page = 1;
            getCommunityList(data);
        }

        /*
        Function called when changing batch filter
         */
        function selectCommunityId(data) {
            data.page = 1;
            getCommunityList(data);
            localStorage.setItem('community', JSON.stringify(vm.filters));
        }

        /*
        Function that filters applications by pastor name
         */
        function selectPastor(pastor) {
            vm.selectedPastor = pastor;
            vm.filters.pastor = pastor;

            getCommunityList(vm.filters);
            localStorage.setItem('community', JSON.stringify(vm.filters));
        }

        /*
        Function that search for pastors for filters
         */
        function searchPastors(query) {
            return PastorService.searchPastors({
                search: query,
                page: 1,
                limit: 20
            });
        }

        /*
        Function called when changing branch filter
         */
        function selectBranch(data) {
            data.page = 1;
            getCommunityList(data);
            localStorage.setItem('community', JSON.stringify(data));
        }

        /*
        Function to display community list with given params
         */
        function getCommunityList(data) {
            vm.communities = [];
            var data = data || {};
            var params = {};

            params.approved = 1;
            params.limit = 10;
            params.page = data.page || 1;
            params.sort = "communities.id:desc";
            params.program_id = data.program ? data.program.id : null;
            params.batch_id = data.batch ? data.batch.id : null;
            params.search = data.search ? data.search : null;
            params.pastor_id = data.pastor ? data.pastor.id : null;
            params.base_branch_id = data.base && data.base.id && data.branch ? data.branch.id : null;

            if (!vm.isAdmin && vm.userCountry) {
                params.country_code = vm.userCountry;
            }

            params.with = "application.base.branches,application.program," +
                "application.community," +
                "application.pastor," +
                "application.church," +
                "application.pastor.churches," +
                "application.pastor.churches.barangay," +
                "application.pastor.churches.city," +
                "application.pastor.churches.affiliation," +
                "application.pastor.base," +
                "application.pastor.province," +
                "application.pastor.city," +
                "application.pastor.barangay," +
                "application.pastor.contacts," +
                "donor,application,savingsGroup,savingsGroupData";

            if (currentUser.base_id) {
                params.base_id = currentUser.base_id;
            } else {
                params.base_id = data.base ? data.base.id : null;
            }

            vm.isLoading3 = true;
            vm.totalParticipants = "loading..";
            vm.totalChildren = "loading..";
            vm.communities.total = "loading..";

            CommunityService.queryCommunities(params).then(function (data) {
                vm.communities = data;
                vm.isLoading3 = false;
            });

            delete params.sort;
            params.participant_status = 'overriden';
            CommunityService.getTotalParticipants(params).then(function (data) {
                vm.totalParticipants = data.total;

                var params2 = angular.copy(params);
                params2.count_children = 1;
                delete params2.participant_status;
                CommunityService.getTotalParticipants(params2).then(function (data) {
                    vm.totalChildren = data.total;
                });
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.transform')
        .controller('ApplicationsController', ApplicationsController);

    /** @ngInject */
    function ApplicationsController($rootScope,
                                    $scope,
                                    $mdDialog,
                                    $document,
                                    $mdBottomSheet,
                                    $state,
                                    BaseService,
                                    ApplicationService,
                                    PastorService,
                                    Auth) {
        var vm = this;
        
        var currentUser = Auth.getUser();
        vm.isAdmin = Boolean(currentUser && currentUser.roles && currentUser.$roles.has(["admin"]));
        vm.userCountry = currentUser ? currentUser.country_code : null;

        vm.$state = $state;

        //Methods
        vm.editApplication = editApplication;
        vm.addApplication = addApplication;
        vm.approveApplication = approveApplication;
        vm.openDeletedApplications = showDeletedApplications;
        vm.callPastorInformation = callPastorInformation;
        vm.deleteApplication = deleteApplication;
        vm.pageChange = pageChange;
        vm.selectBase = selectBase;
        vm.selectBranch = selectBranch;
        vm.selectSearch = selectSearch;
        vm.selectPastor = selectPastor;
        vm.searchPastors = searchPastors;

        vm.isLoading1 = false;
        vm.isLoading2 = false;
        vm.isLoading3 = false;
        vm.applications = [];
        vm.currentPage = 1;

        var _parent = $scope;
        _parent.$parent.vm.currentTab = 0;

        refreshTables();

        /*
        Function that is first called upon load
         */
        function refreshTables() {

            vm.filters = {
                base: 'all',
                branch: 'all',
                pastor: ''
            };

            var data;
            if (localStorage.getItem('applications')) {
                data = JSON.parse(localStorage.getItem('applications'));
                vm.selectedPastor = data && data.pastor ? data.pastor : null;
            }
            getBases(data);
            drawApplicationsTable(data);
        }

        /*
        Function that filters applications by pastor name
         */
        function selectPastor(pastor) {
            if (pastor && pastor.id) {
                vm.selectedPastor = pastor;
                vm.filters.pastor = pastor;

                drawApplicationsTable(vm.filters);
                localStorage.setItem('applications', JSON.stringify(vm.filters));
            } else if (!pastor) {
                vm.selectedPastor = null;
                vm.filters.pastor = null;

                drawApplicationsTable(vm.filters);
                localStorage.setItem('applications', JSON.stringify(vm.filters));
            }
        }

        /*
        Function that search for pastors for filters
         */
        function searchPastors(query) {
            return PastorService.searchPastors({
                search: query,
                page: 1,
                limit: 20
            });
        }

        /*
        Function that filters applications by base
         */
        function selectBase(data) {
            vm.filters.branch = 'all';
            data.page = 1;
            drawApplicationsTable(data);
            localStorage.setItem('applications', JSON.stringify(data));
        }

        /*
        Function that filters applications by branch
         */
        function selectBranch(data) {
            data.page = 1;
            drawApplicationsTable(data);
            localStorage.setItem('applications', JSON.stringify(data));
        }

        /*
        Function that fetches all bases if user has no assigned base
         */
        function getBases(data) {

            var params = {
                nopage: true,
                base_id: currentUser.base_id,
                with: 'branches'
            };

            if (!vm.isAdmin && vm.userCountry) {
                params.country_code = vm.userCountry;
            }

            BaseService.getBases(params).then(function (response) {
                var base = response[0];

                vm.bases = response;
                if (currentUser.base_id) {
                    vm.filters.base = base;
                } else {
                    vm.filters.base = data && data.base ? data.base : 'all';
                }

                if (currentUser.branch_id) {
                    vm.filters.branch = base.branches.filter(function(item) {
                      return item.id == currentUser.branch_id;
                    }).shift();
                } else {
                    vm.filters.branch = data && data.branch ? data.branch : 'all';
                }
            });
        }

        /*
        Function that populates application table when changing pagination page
         */
        function pageChange(page, filters) {
            filters.page = page;
            var data = filters;
            drawApplicationsTable(data);
            localStorage.setItem('applications', JSON.stringify(data));
        }

        /*
        Function that populates applications by search text
         */
        function selectSearch(data) {
            drawApplicationsTable(data);
            localStorage.setItem('applications', JSON.stringify(data));
        }

        /*
        Function that plots applications table
         */
        function drawApplicationsTable(data) {
            vm.applications = [];
            var data = data || {};
            var params = {};

            params.limit = 10;
            params.page = data.page || 1;
            params.sort = 'applied_at:asc';
            params.pastor_id = data.pastor ? data.pastor.id : null;
            params.base_id = data.base ? data.base.id : (currentUser.base_id || null);
            params.base_branch_id = data.branch ? data.branch.id : (currentUser.branch_id || null);

            if (!vm.isAdmin && vm.userCountry) {
                params.country_code = vm.userCountry;
            }

            params.with = 'branch,' +
                'program,' +
                'church,' +
                'church.barangay,' +
                'church.city,' +
                'base.branches,' +
                'pastor,' +
                'pastor.churches,' +
                'pastor.churches.affiliation,' +
                'pastor.churches.barangay,' +
                'pastor.churches.city,' +
                'pastor.base,' +
                'pastor.branch,' +
                'pastor.province,' +
                'pastor.city,' +
                'pastor.barangay,' +
                'pastor.contacts';

            vm.isLoading1 = true;
            ApplicationService.queryApplications(params).then(function (data) {
                vm.isLoading1 = false;
                vm.applications = data;
            });
        }

        /*
        Function that calls the function for adding application
         */
        function addApplication(e) {
            showApplicationDialog();
        }

        /*
        Function that calls modal service for new application
         */
        function showApplicationDialog(application) {
            if (currentUser.$roles.has(['admin', 'metrics', 'pastor_coordinator', 'branch_head', 'health_mentor'])) {
                $mdDialog.show({
                    controller: 'NewApplicationDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/transform/dialogs/new-application/new-application-dialog.html',
                    parent: angular.element($document.body),
                    locals: {
                        application: application || null,
                        drawApplicationsTable: function () {
                            pageChange(vm.applications.current_page, vm.filters);
                        }
                    },
                    clickOutsideToClose: true
                });
            }
        }

        /*
        Function that calls the function for editing application
         */
        function editApplication(application) {
            showApplicationDialog(application);
        }

        /*
        Function that calls modal service for edit application
         */
        function deleteApplication(application) {
            $mdDialog.show({
                controller: 'DeleteApplicationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    application: application || null,
                    mode: 'application',
                    drawApplicationsTable: function () {
                        pageChange(vm.applications.current_page, vm.filters);
                        $rootScope.$broadcast('deleteApplication');
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that calls modal service for approving application
         */
        function approveApplication(application) {
            $mdDialog.show({
                controller: 'ApproveApplicationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/transform/dialogs/approve-application/approve-application-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    application: application || null,
                    drawApplicationsTable: function () {
                        pageChange(vm.applications.current_page, vm.filters);
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that checks if there is a pastor in that application and call show pastor dialog function
         */
        function callPastorInformation(pastor, church) {
            if (pastor){
                pastor.church = church;

                showPastorInformationDialog(pastor);
            }
        }

        /*
        Function that calls modal service for pastor information
         */
        function showPastorInformationDialog(pastor) {
            $mdDialog.show({
                controller: 'PastorInformationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/transform/dialogs/pastor-information/pastor-information-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    pastor: pastor
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that calls bottom sheet for deleted applications
         */
        function showDeletedApplications() {
            if ($state.current.name !== "app.transform.applications.archives") {
                $state.transitionTo("app.transform.applications.archives", {id: $state.params.id}, false);
            }

            $mdBottomSheet.show({
                controller: 'DeletedApplicationsContentController',
                controllerAs: 'vm',
                templateUrl: 'app/main/transform/tabs/applications/bottom-sheets/deleted-applications/deleted-applications.html',
                parent: '#transform-content-wrapper',
                clickOutsideToClose: true,
                disableBackdrop: true,
                disableParentScroll: true,
                locals: {
                    refreshApplicationsTable: refreshTables
                }
            })
                .then(handleDeletedApplicationCloseEvent.bind(vm))
                .catch(handleDeletedApplicationsError.bind(vm));

            setTimeout(function() {
                var parent = angular.element('#transform-content-wrapper');
                parent.unbind('$md.dragstart')
                    .unbind('$md.drag')
                    .unbind('$md.dragend');
            }, 1000);
        }

        /*
        Checks the state if it goes to archives and will show deleted applications bottom sheet
         */
        if ($state.current.name == "app.transform.applications.archives") {
            showDeletedApplications();
        }

        /*
        Function that triggers when bottom sheet is closed
         */
        function handleDeletedApplicationCloseEvent() {
            if ($state.current.name === 'app.transform.applications.archives') {
                $('.content-white-holder').removeClass('bcopen');
                this.refreshTables();
                this.$state.go("app.transform.applications");
            }
        }

        /*
        Function that handles error for deleted applications
         */
        function handleDeletedApplicationsError() {
            $('.content-white-holder').removeClass('bcopen');
            this.$state.go("app.transform.applications");
        }
    }
})();
(function () {
    'use strict'

    angular.module('app.transform')
        .controller('PastorInformationDialogController', PastorInformationDialogController);

    /** @ngInject */
    function PastorInformationDialogController($mdDialog, $state, pastor, enumFields) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.goToProfile = goToProfile;

        vm.pastor = pastor;

        if (pastor.church) {
            vm.church = pastor.churches.filter(function (item) {
                return item.id == pastor.church.id;
            }).shift();
        } else {
            vm.church = pastor.churches.shift();
        }

        activate();

        /*
        Function that populates pastor details table
         */
        function activate() {
            enumFields(["educational_attainment", "church_position"])
                .then(function (values) {
                    vm.educational_attainment = values.educational_attainment;
                    vm.educational_attainment.filter(function (item) {
                        if (item.value === vm.pastor.educational_attainment) {
                            vm.pastor.education = item;
                        }
                    });

                    vm.church_position = values.church_position;
                    vm.church_position.filter(function (item) {
                        if (vm.church && vm.pastor.churches.length > 0 && item.value === vm.church.pivot.position) {
                            vm.pastor.church_position = item;
                        }
                    });

                    populateTable();

                });
        }

        /*
        Function that redirects user to the selected pastor profile
         */
        function goToProfile(pastor) {
            $state.go("app.thrive.pastors.details", { id: pastor.id }, false);
            closeDialog();
        }

        /*
        Function populate pastor information
         */
        function populateTable() {
            vm.firstTable = [
                {
                    name: 'Gender',
                    value: vm.pastor.gender.charAt(0).toUpperCase() + vm.pastor.gender.slice(1)
                },
                {
                    name: 'Date of Birth',
                    value: moment(vm.pastor.birth_date).format('MMM DD, YYYY')
                },
                {
                    name: 'Status',
                    value: vm.pastor.status.charAt(0).toUpperCase() + vm.pastor.status.slice(1)
                }, {
                    name: 'Educ. Level',
                    value: vm.pastor.education ? vm.pastor.education.label : ''
                },
                {
                    name: 'Attended Seminary',
                    value: vm.pastor.seminary ? 'Yes' : 'No'
                },
                {
                    name: 'Church',
                    value: (vm.church && vm.church.name) ? vm.church.name : ""
                },
                {
                    name: 'Church Affiliation',
                    value: (vm.church && vm.church.affiliation) ? vm.church.affiliation.name : ''
                }, {
                    name: 'Position',
                    value: vm.pastor.church_position ? vm.pastor.church_position.label : ''
                },
                {
                    name: 'Church Address',
                    value: (vm.church && vm.church.address) ? vm.church.address : ""
                }
            ];

            vm.secondTable = [
                {
                    name: 'Base - Thrive Area',
                    value: vm.pastor.base ? vm.pastor.base.name : ''
                },
                {
                    name: 'Thrive',
                    value: vm.pastor.thrive_id
                },
                {
                    name: 'Info Created',
                    value: moment(vm.pastor.created_at).format('MMM DD, YYYY')
                },
                {
                    name: 'Info Updated',
                    value: moment(vm.pastor.updated_at).format('MMM DD, YYYY')
                },
                {
                    name: 'Membership Date',
                    value: vm.pastor.membership_date
                }
            ];


            if (typeof vm.pastor.data_count !== "undefined") {
                vm.firstTable.push({
                    name: 'City or Municipality',
                    value: vm.pastor.city ? vm.pastor.city.name : ''
                });
                vm.firstTable.push({
                    name: 'Province',
                    value: vm.pastor.province ? vm.pastor.province.name : ''
                });

                vm.secondTable.push({
                    name: 'Active',
                    value: vm.pastor.is_active ? 'Yes' : 'No'
                });
                vm.secondTable.push({
                    name: 'Member',
                    value: vm.pastor.is_member ? 'Yes' : 'No'
                });
            } else {
                vm.secondTable.push({
                    name: 'City or Municipality',
                    value: vm.pastor.city ? vm.pastor.city.name : ''
                });
                vm.secondTable.push({
                    name: 'Province',
                    value: vm.pastor.province ? vm.pastor.province.name : ''
                });
            }
        }

        /*
        Function that closes modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict'

    angular.module('app.transform')
        .controller('NewApplicationDialogController', NewApplicationDialogController);

    /** @ngInject */
    function NewApplicationDialogController($mdDialog,
        $scope,
        application,
        drawApplicationsTable,
        ApplicationService,
        enumFields,
        ProgramService,
        PastorService,
        BaseService,
        Auth,
        BarangayService,
        CityService,
        ProvinceService) {
        var vm = this;

        vm.currentUser = Auth.getUser();
        if (vm.currentUser.base_id) {
            getBases();
        }

        vm.isAdmin = Boolean(vm.currentUser && vm.currentUser.roles && vm.currentUser.$roles.has(["admin"]));
        vm.userCountry = vm.currentUser ? vm.currentUser.country_code : null;

        vm.originalApplication = application;

        //Methods
        vm.closeDialog = closeDialog;
        vm.addNewApplication = addNewApplication;
        vm.selectPastor = selectPastor;
        vm.selectBaseName = selectBaseName;
        vm.isSelected = isSelected;
        vm.toggleCheckBox = toggleCheckBox;
        vm.searchPastorChange = searchPastorChange;
        vm.searchBaseChange = searchBaseChange;
        vm.searchCommunityCityChange = searchCommunityCityChange;
        vm.searchCommunityBarangayChange = searchCommunityBarangayChange;
        vm.searchPastors = searchPastors;
        vm.searchBaseNames = searchBaseNames;
        vm.searchCommunityCities = searchCommunityCities;
        vm.searchCommunityBarangays = searchCommunityBarangays;
        vm.selectCommunityCity = selectCommunityCity;
        vm.selectCommunityBarangay = selectCommunityBarangay;
        vm.autoFillCommunityAddress = autoFillCommunityAddress;
        vm.selectProvince = selectProvince;
        vm.searchProvinceChange = searchProvinceChange;
        vm.searchProvinces = searchProvinces;

        if (application) {
            vm.dialogTitle = "Edit Application";
        } else {
            vm.dialogTitle = "New Application";
        }
        vm.application = {};
        vm.application.date = new Date();

        // autocomplete
        vm.pastors = [];
        vm.selectedPastor = null;
        vm.selectedChurchCity = null;
        vm.selectedChurchBarangay = null;
        vm.selectedCommunityCity = null;
        vm.selectedCommunityBarangay = null;
        vm.selectedChurchBarangay = null;
        vm.selectedProvince = null;
        vm.selectedCommunityBarangay = null;

        vm.saving = false;

        vm.programVenues = [];
        vm.meansTransportation = [];
        vm.sourcesOfIncome = [];
        vm.sourcesOfWater = [];
        vm.geoType = [];

        vm.submitTranspo = [];
        vm.submitIncome = [];
        vm.submitWater = [];
        vm.branches = [];
        vm.provinces = [];

        vm.countrys = [
            { id: "PH", name: "Philippines" },
            { id: "GM", name: "Guatemala" },
            { id: "UG", name: "Uganda" },
            { id: "BU", name: "Burundi" },
            { id: "KH", name: "Cambodia" },
        ]

        vm.handleCountryChange = function (country_code) {
            vm.selectedBaseName = null;
            vm.branches = [];
            vm.application.base_id = null;
        }

        getPrograms();

        //load program venues, means of transporation, sources of income and water
        enumFields([
            "church_position",
            "program_venue",
            "means_of_transportation",
            "source_of_income",
            "source_of_water",
            "geo_type"
        ]).then(function (values) {
            vm.churchPositions = values.church_position;
            vm.programVenues = values.program_venue;
            vm.meansTransportation = values.means_of_transportation;
            vm.sourcesOfIncome = values.source_of_income;
            vm.sourcesOfWater = values.source_of_water;
            vm.geoType = values.geo_type;

            if (application) {
                assignValuesForEdit();
            }
        });

        /*
        Function that fetches all programs
         */
        function getPrograms() {
            return ProgramService.getPrograms({
                nopage: true,
                active: true
            }).then(function (data) {
                vm.programs = data;
                return vm.programs;
            });
        }

        /*
        Function that assigns values to application if it is in edit mode
         */
        function assignValuesForEdit() {
            vm.branches = application.base.branches;
            vm.selectedPastor = application.pastor;
            vm.selectedBaseName = application.base || application.pastor.base;
            vm.selectedChurch = application.church;

            vm.application = {
                application_id: application.application_id,
                id: application.id,
                program: application.program ? application.program.id : null,
                country_code: application.country_code || application.pastor.country_code,
                base_branch_id: application.base_branch_id,
                branch_id: application.base_branch_id,
                date: application.applied_at,
                churchName: application.church_name,
                churchStreet: application.church_street,
                churchBarangay: application.church_barangay,
                communityStreet: application.community_street,
                brgyChairman: application.brgy_chairman,
                distance: application.distance,
                geoType: application.geo_type,
                programVenue: application.program_venue,
            };

            transformCommunityAddress(vm.selectedPastor)

            var pastorChurch = application.pastor.churches.filter(function (item) {
                return item.id == application.church.id;
            }).shift();

            vm.application.church_position = pastorChurch ? pastorChurch.pivot.position : '';

            var incomeType = [];
            for (var x = 0; x < vm.sourcesOfIncome.length; x++) {
                incomeType.push(vm.sourcesOfIncome[x].value);
            }
            for (var x = 0; x < application.source_of_income.length; x++) {
                if (incomeType.indexOf(application.source_of_income[x]) == -1 && application.source_of_income[x] != 'other') {
                    vm.other = true;
                    vm.application.sourceIncomeText = application.source_of_income[x];
                    break;
                }
            }

            vm.submitIncome = application.source_of_income instanceof Array ? application.source_of_income : [];
            vm.submitTranspo = application.means_of_transportation instanceof Array ? application.means_of_transportation : [];
            vm.submitWater = application.source_of_water instanceof Array ? application.source_of_water : [];
        }

        /*
        Function that search for pastors by search text to be assigned to application
         */
        function searchPastors(query) {
            var params = {
                search: query,
                page: 1,
                check_status: 1,
                with: 'churches,churches.barangay,churches.city,district,base,district.branch',
                limit: 20
            };

            if (!vm.isAdmin && vm.userCountry) {
                params.country_code = vm.userCountry;
            }

            return PastorService.searchPastors(params);
        }

        /*
        Function that search bases by search text
         */
        function searchBaseNames(query) {
            return BaseService.getBases({
                search: query,
                nopage: true,
                country_code: vm.application.country_code,
                with: 'branches',
            });
        }

        /*
        Function that gets all bases by search text
         */
        function getBases() {
            BaseService.getBases({
                nopage: true,
                base_id: vm.currentUser.base_id,
                with: 'branches'
            }).then(function (response) {
                vm.selectedBaseName = response[0];
                vm.application.base_branch_id = vm.currentUser.branch_id;
            });
        }

        /*
        Function that search community cities by search text
         */
        function searchCommunityCities(query) {
            return CityService.getCities({
                province_id: vm.selectedProvince.parent_province_id ? vm.selectedProvince.parent_province_id : vm.selectedProvince.id,
                search: query,
                limit: 100
            }).then(function (response) {
                return [
                    ...response.data,
                    {
                        name: 'Type manually for more..',
                        disabled: true
                    }
                ]
            })
        }

        /*
        Function that search community cities by search text
         */
        function searchCommunityBarangays(query) {
            var payload = {
                city_id: vm.selectedCommunityCity.id,
                search: query,
                limit: 100
            };

            if (vm.selectedCommunityCity) {
                payload.city_id = vm.selectedCommunityCity.id;
            }

            return BarangayService.getBarangays(payload).then(function (response) {
                return [
                    ...response,
                    {
                        name: 'Type manually for more..',
                        disabled: true
                    }
                ]
            })
        }

        /*
        Function that assigns a pastor to the application
         */
        function selectPastor(pastor) {
            if (!pastor) return;

            vm.selectedPastor = pastor;
            vm.application.pastor_id = pastor ? pastor.id : '';
            vm.application.churchName = (pastor && pastor.churches.length > 0) ? pastor.churches[0].name : '';
            vm.application.churchStreet = (pastor && pastor.churches.length > 0) ? pastor.churches[0].address : '';
            vm.selectedBaseName = pastor.base;
            vm.application.base_branch_id = pastor.district && pastor.district.branch ? pastor.district.branch.id : vm.application.base_branch_id;
            BaseService.getBase(pastor.base, { with: 'branches,provinces' }).then(function (response) {
                vm.branches = response.branches;
                vm.provinces = response.provinces;
            });

            vm.application.country_code = pastor.country_code || vm.application.country_code;

            if (pastor.churches.length > 0) {
                vm.churches = pastor.churches;
                if (!application) {
                    vm.selectedChurch = pastor.churches[0]
                }
                BarangayService.getBarangay(pastor.churches[0].barangay_id).then(function (response) {
                    vm.application.churchBarangay = response.name;
                });
                CityService.getCity(pastor.churches[0].city_id).then(function (response) {
                    vm.selectedChurchCity = response;
                });
            }
            transformCommunityAddress(pastor);
        }

        $scope.$watch("vm.selectedChurch", selectChurch);
        function selectChurch(newValue, oldValue) {
            var church = vm.selectedChurch;
            if (church) {
                var position = church.pivot ? church.pivot.position : null;
                var positionExists = vm.churchPositions.filter(function (item) {
                    return item.value == position;
                });
                vm.selectedChurch = church;

                if (positionExists && positionExists.length) {
                    vm.application.church_position = position;
                } else {
                    vm.application.church_position = vm.churchPositions[0].value;
                }
            }
        }

        /*
     Function that listens for set Transform Community Address
      */
        function transformCommunityAddress(pastor) {
            if (vm.application.programVenue === "main_church") {
                ProvinceService.getProvince(pastor.province_id).then(function (response) {
                    vm.selectedProvince = response;
                });

                CityService.getCity(pastor.city_id).then(function (response) {
                    vm.selectedCommunityCity = response;
                });

                BarangayService.getBarangay(pastor.barangay_id).then(function (response) {
                    vm.selectedCommunityBarangay = response;
                });
            } else {
                if (!application) {
                    vm.selectedProvince = null;
                    vm.selectedCommunityCity = null;
                    vm.selectedCommunityBarangay = null;
                } else {
                    if (application.community_province) {
                        selectProvince({ id: null, name: application.community_province });
                    }
                    if (application.community_city) {
                        selectCommunityCity({ id: null, name: application.community_city });
                    }
                    if (application.community_barangay) {
                        selectCommunityBarangay({ id: null, name: application.community_barangay });
                    }
                }
            }
        }

        /*
        Function that listens for pastor text change
         */
        function searchPastorChange(pastor) {
            vm.application.pastor_id = null;
        }

        /*
        Function that listens for base text change
         */
        function searchBaseChange(base) {
            vm.application.base_id = base ? base.id : '';
            vm.branches = base ? base.branches : [];
        }

        /*
        Function that assigns a base to the application
         */
        function selectBaseName(base) {
            if (base) {
                vm.selectedBaseName = base;
                vm.branches = base.branches;
                vm.application.base_id = base.id;
            }
        }

        /*
        Function that assigns a community city to the application
         */
        function selectCommunityCity(communityCity) {
            if (communityCity === null || communityCity === undefined || communityCity.disabled) {
                vm.selectedCommunityCity = null;
                vm.application.communityCityName = '';
            } else {
                vm.selectedCommunityCity = communityCity;
                vm.application.communityCityName = communityCity.name || '';
            }
        }

        /*
        Function that assigns a community barangay
         */
        function selectCommunityBarangay(communityBarangay) {
            if (communityBarangay === null || communityBarangay === undefined || communityBarangay.disabled) {
                vm.selectedCommunityBarangay = null;
                vm.application.communityBarangayName = '';
            } else {
                vm.selectedCommunityBarangay = communityBarangay;
                vm.application.communityBarangayName = communityBarangay.name || '';
            }
        }

        /*
        Function that listens for community city text change
         */
        function searchCommunityCityChange(communityCity) {
            vm.application.communityCityName = communityCity ? communityCity.name : '';
        }

        /*
        Function that listens for community barangay text change
         */
        function searchCommunityBarangayChange(communityBarangay) {
            vm.application.communityBarangayName = communityBarangay ? communityBarangay.name : '';
        }

        /*
       Function that assigns a community province to the application
       */
        function selectProvince(Province) {
            if (Province === null || Province === undefined || Province.disabled) {
                vm.selectedProvince = null;
                vm.application.ProvinceName = '';
            } else {
                vm.selectedProvince = Province;
                vm.application.ProvinceName = Province.name || '';

                if (vm.application.programVenue != "main_church") {
                    vm.selectedCommunityCity = null;
                    vm.selectedCommunityBarangay = null;
                }
            }
        }

        /*
       Function that listens for province text change
       */
        function searchProvinceChange(Province) {
            vm.application.ProvinceName = Province ? Province.name : '';
        }

        /*
      Function that search province by search text
       */
        function searchProvinces(query) {
            return ProvinceService.getProvinces({
                search: query,
                limit: 100
            }).then(function (response) {
                return [
                    ...response.data,
                    {
                        name: 'Type manually for more..',
                        disabled: true
                    }
                ]
            })
        }

        /*
        Function that pushes or aplice an item to/in array
         */
        function toggleCheckBox(key, item) {
            if (key === 'transpo') {
                var index = vm.submitTranspo.indexOf(item);
                if (index > -1) {
                    vm.submitTranspo.splice(index, 1);
                } else {
                    vm.submitTranspo.push(item);
                }
            } else if (key === 'water') {
                var index = vm.submitWater.indexOf(item);
                if (index > -1) {
                    vm.submitWater.splice(index, 1);
                } else {
                    vm.submitWater.push(item);
                }
            } else if (key === 'income') {
                var index = vm.submitIncome.indexOf(item);
                if (index > -1) {
                    vm.submitIncome.splice(index, 1);
                    vm.submitIncome = vm.submitIncome.filter(function (income) {
                        if (income !== undefined || income !== '' || income !== null) {
                            return income;
                        }
                    });
                } else {
                    if (item) {
                        vm.submitIncome.push(item);
                    }
                }
            }
        }

        /*
        Function that checks if an items is in the array of transpo, water or income
         */
        function isSelected(key, item) {
            if (key === 'transpo') {
                return vm.submitTranspo.indexOf(item) > -1;
            } else if (key === 'water') {
                return vm.submitWater.indexOf(item) > -1;
            } else if (key === 'income') {
                return vm.submitIncome.indexOf(item) > -1;
            }
        }

        /*
        Function that adds/edits application to the system
         */
        function addNewApplication(newApplication) {
            // check if we are about to update the community id
            if (vm.originalApplication) {
                var community = vm.originalApplication.community || null;
                if (community) {
                    if (community.current_batch_data.monthDiff <= 0 &&
                        (newApplication.program != vm.originalApplication.program_id ||
                            newApplication.base_id != vm.originalApplication.base_id)) {
                        if (!showRegenerateIdConfirmationDialog()) {
                            return;
                        }
                    }
                }
            }

            var sendApplication = newApplication;
            vm.saving = true;

            vm.errorSourceIncome = '';
            vm.errorSourceWater = '';
            vm.errorMeansTranspo = '';
            vm.errorProgVenue = '';

            if (application) {
                var incomeType = [];
                for (var x = 0; x < vm.sourcesOfIncome.length; x++) {
                    if (vm.sourcesOfIncome[x].value) {
                        incomeType.push(vm.sourcesOfIncome[x].value);
                    }
                }

                /*
                Loop that checks if other option is checked in source of income
                and has a custom text to be added in editing the application
                 */

                for (var x = 0; x < application.source_of_income.length; x++) {
                    if ((application.source_of_income instanceof Array && application.source_of_income.length > 0)
                        && incomeType.indexOf(application.source_of_income[x]) === -1
                        && application.source_of_income[x] !== 'other') {
                        vm.submitIncome.splice(x, 1);
                        break;
                    }
                }
                var sourceIncome = sendApplication.sourceIncomeText;
                vm.submitIncome.push(sourceIncome);

                vm.submitIncome = vm.submitIncome.filter(function (income) {
                    if (income) {
                        return income;
                    }
                });
                var payload = {
                    id: sendApplication.id,
                    program_id: sendApplication.program,
                    pastor_id: sendApplication.pastor_id,
                    barangay_id: sendApplication.barangay_id,
                    applied_at: sendApplication.date,
                    church_id: vm.selectedChurch.id || null,
                    church_position: sendApplication.church_position,
                    country_code: sendApplication.country_code,
                    base_id: sendApplication.base_id,
                    base_branch_id: sendApplication.base_branch_id,
                    means_of_transportation: vm.submitTranspo,
                    source_of_water: vm.submitWater,
                    source_of_income: vm.submitIncome,
                    program_venue: sendApplication.programVenue,
                    community_street: sendApplication.communityStreet || '',
                    brgy_chairman: sendApplication.brgyChairman || '',
                    distance: sendApplication.distance || '',
                    geo_type: sendApplication.geoType || '',
                    community_province: sendApplication.ProvinceName || '',
                    community_barangay: sendApplication.communityBarangayName || '',
                    community_city: sendApplication.communityCityName
                };
                ApplicationService.editApplication(payload).then(function () {
                    vm.saving = false;
                    drawApplicationsTable();
                    closeDialog();
                }).catch(function (response) {
                    vm.saving = false;
                    if (response.data && response.data.errors) {
                        angular.forEach(response.data.errors, function (error, index) {
                            if (index.match(/source_of_income/)) {
                                vm.errorSourceIncome = 'Please specify other source of income';
                            }
                        });
                        if (response.data.errors.program_venue) {
                            vm.errorProgVenue = response.data.errors.program_venue[0];
                        }
                        if (response.data.errors.source_of_income) {
                            vm.errorSourceIncome = response.data.errors.source_of_income[0];
                        }
                        if (response.data.errors.source_of_water) {
                            vm.errorSourceWater = response.data.errors.source_of_water[0];
                        }
                        if (response.data.errors.means_of_transportation) {
                            vm.errorMeansTranspo = response.data.errors.means_of_transportation[0];
                        }

                    }
                });
            } else {
                if (vm.other) {
                    var sourceIncome = sendApplication.sourceIncomeText;
                    vm.submitIncome.push(sourceIncome);
                }
                ApplicationService.addApplication({
                    pastor_id: sendApplication.pastor_id,
                    program_id: sendApplication.program,
                    barangay_id: sendApplication.barangay_id,
                    applied_at: sendApplication.date,
                    country_code: sendApplication.country_code,
                    base_id: sendApplication.base_id,
                    base_branch_id: sendApplication.base_branch_id,
                    church_id: vm.selectedChurch && vm.selectedChurch.id ? vm.selectedChurch.id : null,
                    church_position: sendApplication.church_position,
                    means_of_transportation: vm.submitTranspo,
                    source_of_water: vm.submitWater,
                    source_of_income: vm.submitIncome,
                    program_venue: sendApplication.programVenue,
                    community_street: sendApplication.communityStreet,
                    brgy_chairman: sendApplication.brgyChairman,
                    distance: sendApplication.distance,
                    geo_type: sendApplication.geoType,
                    community_province: sendApplication.ProvinceName,
                    community_barangay: sendApplication.communityBarangayName,
                    community_city: sendApplication.communityCityName
                }).then(function () {
                    vm.saving = false;
                    drawApplicationsTable();
                    closeDialog();
                }).catch(function (response) {
                    vm.saving = false;
                    if (response.data && response.data.errors) {
                        angular.forEach(response.data.errors, function (error, index) {
                            if (index.match(/source_of_income/)) {
                                vm.errorSourceIncome = 'Please specify other source of income';
                            }
                        });
                        if (response.data.errors.program_venue) {
                            vm.errorProgVenue = response.data.errors.program_venue[0];
                        }
                        if (response.data.errors.source_of_income) {
                            vm.errorSourceIncome = response.data.errors.source_of_income[0];
                        }
                        if (response.data.errors.source_of_water) {
                            vm.errorSourceWater = response.data.errors.source_of_water[0];
                        }
                        if (response.data.errors.means_of_transportation) {
                            vm.errorMeansTranspo = response.data.errors.means_of_transportation[0];
                        }
                    }
                });
            }
        }

        /*
        Display a confirmation dialog if the community is about to be updated.
         */
        function showRegenerateIdConfirmationDialog() {
            return window.confirm("If you proceed this will change the community ID, this will notify the System Administrator. Are you sure to proceed with this change?");
        }

        /*
        Function that closes modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        /*
        Auto-fill the community address
         */
        var totalCommunityAddressCalls = 0;
        function autoFillCommunityAddress() {
            totalCommunityAddressCalls++;

            transformCommunityAddress(vm.selectedPastor)

            if ((application && totalCommunityAddressCalls === 1) || !vm.selectedChurch) {
                return;
            }

            if (vm.application.programVenue === "main_church") {
                vm.application.communityStreet = vm.selectedChurch.address;
            } else {
                vm.application.communityStreet = '';
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.transform')
        .controller('DropApplicationDialogController', DropApplicationDialogController);

    /** @ngInject */
    function DropApplicationDialogController($mdDialog,
                                             $document,
                                             drawApplicationsTable,
                                             application,
                                             ApplicationService,
                                             mode,
                                             CommunityService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.dropApplication = dropApplication;

        if (mode === 'approved') {
            vm.dialogTitle = 'Drop Application';
            vm.dialogBody = '<p class="text-muted text-reminder"><em>Dropping this application will move it back to the Applications list</em>.</p><hr><p>Are you sure to drop this application?</p>';
            vm.dialogFooter = 'Drop';
        } else if (mode === 'community') {
            vm.dialogTitle = 'Remove Community';
            vm.dialogBody = '<p class="text-muted text-reminder"><em>Removing this community will also remove all the associated records (e.g. attendance, bib, hbf)</em>.</p><hr><p>Are you sure you want to delete this community?</p>';
            vm.dialogFooter = 'Remove';
        }

        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation() {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: vm.dropApplication,
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to drop an application
         */
        function dropApplication() {
            vm.saving = true;
            if (mode === 'approved') {
                return ApplicationService.dropApplication(application)
                    .then(function () {
                        vm.saving = false;
                        drawApplicationsTable();
                        closeDialog();
                    });
            } else if (mode === 'community') {
                return CommunityService.deleteCommunity(application)
                    .then(function () {
                        vm.saving = false;
                        drawApplicationsTable();
                        closeDialog();
                    })
            }
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.transform')
        .controller('issuesDeleteParticipantDialogController', issuesDeleteParticipantDialogController);

    /** @ngInject */
    function issuesDeleteParticipantDialogController($mdDialog,
        callback,
        participant,
        pastor,
        ParticipantService,
        PastorService) {
        var vm = this;
        vm.issues = [];
        vm.pastor = null;
        vm.pastors = [];
        vm.saving = false;
        vm.isPastor = false;
        vm.loadIssues = true;
        vm.remarkParticipant = remarkParticipant;
        vm.closeDialog = closeDialog;
        vm.dialogTitle = "Found Issue/s";

        vm.remarkReasons = [
            {
                id: 1,
                label: 'No previous attendance'
            },
            {
                id: 2,
                label: 'Did not Graduate'
            },
            {
                id: 3,
                label: 'Graduated, but the participant still requires assistance.'
            },
            {
                id: 4,
                label: 'Successfully graduated; nevertheless, the Pastor suggests that the participants undergo the program again.'
            },
            {
                id: 5,
                label: 'Successfully graduated; nevertheless, the participant insists on rejoining.'
            },
        ]

        vm.pastorRemarkReasons = [
            {
                id: 1,
                label: 'Duplicate (On process on deletion)'
            },
            {
                id: 2,
                label: 'Duplicate (Keep for now )'
            },
            {
                id: 3,
                label: 'Not Duplicate (This is different Pastor)'
            }
        ]

        // Get participants issues
        function getParticipantsIssues() {
            return ParticipantService.getParticipantsIssues({
                participants_id: participant.id
            })
                .then(function (response) {
                    vm.loadIssues = false;
                    vm.issues = response.community_list;
                    if (response.remarks) {
                        vm.remarkReasons.forEach(element => {
                            if (element.id == response.remarks) {
                                vm.isremarks = element.label;
                            }
                        });
                    }
                }).catch(function (response) {
                    vm.loadIssues = false;
                    console.log("🚀 ~ file: issues-dialog.js:33 ~ response:", response)
                });
        }
        if (pastor && pastor.duplicatePastors) {
            vm.isPastor = true;
            vm.pastors = pastor.duplicatePastors;
            vm.pastor = pastor;
            if (pastor.remark) {
                vm.pastorRemarkReasons.forEach((element) => {
                    if (element.id == pastor.remark) {
                        vm.isremarks = element.label;
                    }
                });
            }
            vm.loadIssues = false;
        } else {
            getParticipantsIssues()
        }

        /*Function used  to remark a participant */
        function remarkParticipant() {
            if (vm.isPastor) {
                if (vm.isremarks) {
                    closeDialog();
                    return;
                }
                vm.saving = true;
                vm.apiErrors = {};

                var data = {
                    id: pastor.id,
                    remark: vm.remark.id,
                };

                return PastorService.editPastorlist(data)
                    .then(function () {
                        vm.saving = false;
                        callback();
                        closeDialog();
                    })
                    .catch(function (response) {
                        vm.saving = false;

                        for (var field in response.data.errors) {
                            vm.apiErrors[field] = response.data.errors[field].shift();
                        }
                    });
            } else {
                if (vm.isremarks) {
                    closeDialog();
                    return;
                }
                vm.saving = true;

                var participantObj = {
                    id: participant.id,
                    remarks: vm.remark.id,
                    application_id: participant.application_id
                };

                return ParticipantService.addRemarks(participantObj)
                    .then(function () {
                        vm.saving = false;
                        callback();
                        closeDialog();
                    }).catch(function (response) {
                        vm.saving = false;
                        for (var field in response.data.errors) {
                            vm.apiErrors[field] = response.data.errors[field].shift();
                        }
                    });

            }
        }

        /*
        Function used  to close a dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.transform')
        .controller('EditParticipantDialogController', EditParticipantDialogController);

    /** @ngInject */
    function EditParticipantDialogController($mdDialog,
        callback,
        participant,
        pastor,
        application,
        enumFields,
        ParticipantService,
        Auth) {
        var vm = this;
        var currentUser = Auth.getUser();

        //Methods
        vm.closeDialog = closeDialog;
        vm.editParticipant = editParticipant;
        vm.toggleCheckBox = toggleCheckBox;
        vm.isSelected = isSelected;
        vm.addChild = addChild;
        vm.removeChild = removeChild;

        vm.application = application;

        vm.apiErrors = {};

        vm.toAddChildren = [];

        vm.submitAppliances = [];
        vm.submitFurnitures = [];
        vm.submitTransports = [];

        vm.genders = [];
        vm.buildingSizes = [];
        vm.floorMaterials = [];
        vm.roofMaterials = [];
        vm.wallMaterials = [];
        vm.landStatuses = [];
        vm.waterSupplies = [];
        vm.electricities = [];
        vm.fuelsCooking = [];
        vm.toilets = [];
        vm.furnitures = [];
        vm.appliances = [];
        vm.transports = [];
        vm.submitAppliances = [];
        vm.submitFurnitures = [];
        vm.submitTransports = [];
        vm.CENOMAR_required = false;
        vm.civilStatuses = [];
        vm.childRelationships = [];
        vm.participant = participant;

        vm.isEditParticipant = false;


        vm.isReplacement = 0;
        vm.house_hold_field_validation = false;

        vm.dialogTitle = "Edit Participant";

        // Calculate minimum birthdate allowed (13 years ago from today)
        var minDate = new Date();
        minDate.setFullYear(minDate.getFullYear() - 13);

        // Set maximum allowed birthdate (today's date minus 13 years)
        var maxBirthdate = new Date();
        maxBirthdate.setFullYear(maxBirthdate.getFullYear() - 13);

        // Set maximum allowed date (13 years ago from today)
        vm.maxDate = maxBirthdate;

        // Set minimum birthdate allowed
        vm.participant.birthdate = vm.participant.birthdate ? vm.participant.birthdate : participant.birthdate;

        vm.isDateValid = function () {
            var participantBirthdate = new Date(vm.participant.birthdate);
            var maxDate = new Date(vm.maxDate);

            if (participantBirthdate <= maxDate) {
                vm.isDateValidParticipantBirthdate = true;
            } else {
                vm.isDateValidParticipantBirthdate = false;
            }
        };

        vm.isDateValid()

        enumFields([
            "gender",
            "building_size",
            "floor_materials",
            "roof_materials",
            "wall_materials",
            "land_status",
            "water_supply",
            "electricity",
            "fuel_for_cooking",
            "toilet",
            "furnitures",
            "appliances",
            "transportations",
            "civil_status",
            "child_relationship"
        ])
            .then(function (values) {
                vm.genders = values.gender;
                vm.buildingSizes = values.building_size;
                vm.floorMaterials = values.floor_materials;
                vm.roofMaterials = values.roof_materials;
                vm.wallMaterials = values.wall_materials;
                vm.landStatuses = values.land_status;
                vm.waterSupplies = values.water_supply;
                vm.electricities = values.electricity;
                vm.fuelsCooking = values.fuel_for_cooking;
                vm.toilets = values.toilet;
                vm.furnitures = values.furnitures;
                vm.appliances = values.appliances;
                vm.transports = values.transportations;
                vm.civilStatuses = values.civil_status;
                vm.childRelationships = values.child_relationship;

                getDropDownitems();
                activate();
            });

        var editCheck = ((vm.participant.attendance ? (vm.participant.attendance.week7 || vm.participant.attendance.week8 || vm.participant.attendance.week9 || vm.participant.attendance.week10 || vm.participant.attendance.week11 || vm.participant.attendance.week12 || vm.participant.attendance.week13 || vm.participant.attendance.week14 || vm.participant.attendance.week15) : false) && !currentUser.$roles.has(['admin']));

        if (editCheck) {
            vm.isEditParticipant = true;
        }

        /*
        Function used to load genders, buildingSizes, floorMaterials, etc. and
        participant details
         */
        function activate() {
            getDropDownitems();
            if (participant.scorecard.total_phones > 3) {
                participant.scorecard.total_phones = '3';
            }
            vm.pastor = pastor;
            vm.participant = participant;
            vm.participant = {
                id: participant.id,
                toggle: participant.has_score_card ? 1 : 0,
                firstName: participant.firstname,
                lastName: participant.lastname,
                middleName: participant.middlename,
                suffix: participant.suffix,
                gender: participant.gender,
                attendance: participant.attendance,
                has_score_card: participant.has_score_card,
                income: participant.total_income,
                isCounselor: participant.type === 'original' || participant.type === 'original_replacement' ? 0 : 1,
                has_community: participant.community ? 1 : 0,
                building: participant.scorecard.building_size,
                floor: participant.scorecard.floor_materials,
                roof: participant.scorecard.roof_materials,
                wall: participant.scorecard.wall_materials,
                land: participant.scorecard.land_status,
                water: participant.scorecard.water_supply,
                married: participant.scorecard.is_married,
                certificate: participant.scorecard.has_marriage_certificate,
                electricity: participant.scorecard.electricity,
                fuel: participant.scorecard.fuel_for_cooking,
                toilet: participant.scorecard.toilet,
                telephones: participant.scorecard.total_phones,
                scorecard: {
                    is_participants_household_head: participant.scorecard.is_participants_household_head,
                    house_hold_first_name: participant.scorecard.house_hold_first_name,
                    house_hold_middle_name: participant.scorecard.house_hold_middle_name,
                    house_hold_last_name: participant.scorecard.house_hold_last_name,
                    house_hold_suffix: participant.scorecard.house_hold_suffix,
                    house_hold_relation: participant.scorecard.house_hold_relation,
                    house_hold_gender: participant.scorecard.house_hold_gender,
                }
            };

            if (vm.participant.attendance) { //if participant, toggle ON poverty score card
                vm.participant.toggle = 1
            }

            if (typeof participant.is_visitor !== "undefined") {
                vm.participant.is_visitor = participant.is_visitor;

                if (vm.participant.is_visitor) {
                    vm.dialogTitle = "Edit Visitor";
                    vm.participant.isCounselor = -1;
                    vm.participant.toggle = 0;
                }
            }

            if (participant.children && participant.children.length > 0) {
                vm.toAddChildren = participant.children.filter(function (item, index) {
                    item.number = index;

                    var relationshipExists = vm.childRelationships.filter(function (relationship) {
                        return relationship.value == item.relationship;
                    }).length > 0;

                    if (!relationshipExists) {
                        item.other_relationship = item.relationship;
                        item.relationship = 'other';
                    }

                    return item;
                });
            }

            if (participant.type === 'counselor_replacement' || participant.type === 'original_replacement') {
                vm.isReplacement = 1;
            }

            if (participant.birthdate) {
                vm.participant.birthdate = participant.birthdate;
            }

            if (participant.phone_number) {
                vm.participant.phoneNumber = participant.phone_number;
            }

            if (participant.scorecard) {
                vm.participant.privacy_act = participant.scorecard.privacy_act || 0;
                vm.participant.philhealth_member = participant.scorecard.philhealth_member || 0;
                vm.participant.civil_status = participant.scorecard.civil_status;
                vm.participant.householdMembers = participant.scorecard.has_no_birth_reg;
                vm.participant.p4 = participant.scorecard.has_4ps_member;
                vm.participant.peopleLive = participant.scorecard.total_occupants;
                vm.participant.building = participant.scorecard.building_size;
                vm.participant.floor = participant.scorecard.floor_materials;
                vm.participant.roof = participant.scorecard.roof_materials;
                vm.participant.wall = participant.scorecard.wall_materials;
                vm.participant.land = participant.scorecard.land_status;
                vm.participant.water = participant.scorecard.water_supply;
                vm.participant.married = participant.scorecard.is_married;
                vm.participant.certificate = participant.scorecard.has_marriage_certificate;
                vm.participant.electricity = participant.scorecard.electricity;
                vm.participant.fuel = participant.scorecard.fuel_for_cooking;
                vm.participant.toilet = participant.scorecard.toilet;
                vm.submitFurnitures = participant.scorecard.furnitures || [];
                vm.submitAppliances = participant.scorecard.appliances || [];
                vm.submitTransports = participant.scorecard.transportations || [];
                if (vm.submitTransports.indexOf('none') !== -1) {
                    vm.noneDisabled = false;
                    vm.othersDisabled = true;
                } else if (vm.submitTransports.length === 0) {
                    vm.noneDisabled = false;
                    vm.othersDisabled = false;
                } else {
                    vm.noneDisabled = true;
                    vm.othersDisabled = false;
                }
                vm.participant.telephones = participant.scorecard.total_phones;
            } else {
                vm.submitFurnitures = [];
                vm.submitAppliances = [];
                vm.submitTransports = [];
                vm.participant.toggle = 1
            }

            if (vm.participant.civil_status != 'live_in') {
                delete vm.participant.certificate;
            }
        }

        /*
        Function to add card
         */
        function addChild() {
            var cardsLength = vm.toAddChildren.length;
            vm.toAddChildren.push({
                number: cardsLength,
                relationship: vm.childRelationships[0].value,
                firstname: '',
                lastname: '',
            });
        }

        function removeChild(child) {
            vm.toAddChildren = vm.toAddChildren.filter(function (item) {
                if (child.number != item.number) {
                    return item;
                }
            })
        }

        /*
        Function used to check if a furniture, appliance, or transportation is already
        selected. If selected, push. Otherwise, splice.
         */
        function toggleCheckBox(key, item) {
            if (key === 'furniture') {
                var tempFurnitures = angular.copy(participant.scorecard.furnitures);
                var index = vm.submitFurnitures.indexOf(item);
                if (index > -1) {
                    vm.submitFurnitures.splice(index, 1);
                } else {
                    vm.submitFurnitures.push(item);
                }
                participant.scorecard.furnitures = tempFurnitures;
            } else if (key === 'appliances') {
                var tempAppliances = angular.copy(participant.scorecard.appliances);
                var index = vm.submitAppliances.indexOf(item);
                if (index > -1) {
                    vm.submitAppliances.splice(index, 1);
                } else {
                    vm.submitAppliances.push(item);
                }
                participant.scorecard.appliances = tempAppliances;
            } else if (key === 'transport') {
                var tempAppliances = angular.copy(participant.scorecard.transportations);
                var index = vm.submitTransports.indexOf(item);
                if (index > -1) {
                    vm.submitTransports.splice(index, 1);
                } else {
                    vm.submitTransports.push(item);
                }
                if (item !== 'none' && vm.submitTransports.length > 0) {
                    vm.noneDisabled = true;
                } else {
                    vm.noneDisabled = false;
                }
                participant.scorecard.transportations = tempAppliances;
            }

            vm.checked = true;
        }

        /*
        Function used to check if a furniture, appliances, and transporation is in the
        array
         */
        function isSelected(key, item) {
            if (key === 'furniture') {
                return vm.submitFurnitures.indexOf(item) > -1;
            } else if (key === 'appliances') {
                return vm.submitAppliances.indexOf(item) > -1;
            } else if (key === 'transport') {
                return vm.submitTransports.indexOf(item) > -1;
            }
        }

        /*
        Function used to populate options in the dropdown
         */
        function getDropDownitems() {

            vm.building = {
                key: 'building',
                question: 'What is the size of the home/building?',
                items: vm.buildingSizes
            };
            vm.floor = {
                key: 'floor',
                question: 'What material is the floor made of?',
                items: vm.floorMaterials
            };
            vm.roof = {
                key: 'roof',
                question: 'what type of construction materials are the roofs made of?',
                items: vm.roofMaterials
            };
            vm.wall = {
                key: 'wall',
                question: 'What type of construction materials are the outer walls made of?',
                items: vm.wallMaterials
            };
            vm.land = {
                key: 'land',
                question: 'What is the status of the land?',
                items: vm.landStatuses
            };
            vm.water_supply = {
                key: 'water',
                question: "What is the family's main source of water supply that is available within 50 meters?",
                items: vm.waterSupplies
            };
            vm.electricity = {
                key: 'electricity',
                question: 'Is there any electricity in the building/house?',
                items: vm.electricities
            };
            vm.fuel_for_cooking = {
                key: 'fuel',
                question: 'What type of fuel does your household use for cooking?',
                items: vm.fuelsCooking
            };
            vm.toilet = {
                key: 'toilet',
                question: 'What type of toilet does the household have?',
                items: vm.toilets
            };

            vm.dropdownItems = [
                {
                    key: 'building',
                    question: 'What is the size of the home/building?',
                    items: vm.buildingSizes
                },
                {
                    key: 'floor',
                    question: 'Floor Material',
                    items: vm.floorMaterials
                },
                {
                    key: 'roof',
                    question: 'Roof Material',
                    items: vm.roofMaterials
                },
                {
                    key: 'wall',
                    question: 'Wall Material',
                    items: vm.wallMaterials
                },
                {
                    key: 'land',
                    question: 'Land Status',
                    items: vm.landStatuses
                },
                {
                    key: 'water',
                    question: 'Water Supply',
                    items: vm.waterSupplies
                },
                {
                    key: 'electricity',
                    question: 'Electricity',
                    items: vm.electricities
                },
                {
                    key: 'fuel',
                    question: 'Fuel for cooking',
                    items: vm.fuelsCooking
                },
                {
                    key: 'toilet',
                    question: 'Toilet',
                    items: vm.toilets
                }
            ];

            vm.checkBoxItems = [
                {
                    key: 'furniture',
                    question: 'Furniture',
                    items: vm.furnitures
                },
                {
                    key: 'appliances',
                    question: 'Appliances',
                    items: vm.appliances
                }
                // {
                //     key: 'transport',
                //     question: 'Transport',
                //     items: vm.transports
                // }
            ];
        }

        /*
        Function used to edit participant details
         */
        function editParticipant(participantPass) {
            vm.saving = true;
            vm.errorPhone = '';

            var participantObj = {
                id: participant.id,
                application_id: participant.application_id,
                firstname: participantPass.firstName || '',
                lastname: participantPass.lastName || '',
                middlename: participantPass.middleName || '',
                suffix: participantPass.suffix || '',
                gender: participantPass.gender,
                total_income: participantPass.income || 0,
                has_score_card: participantPass.toggle ? participantPass.toggle : 0,
                has_no_birth_reg: participantPass.householdMembers,
                has_4ps_member: participantPass.p4,
                total_occupants: participantPass.peopleLive,
                total_phones: participantPass.telephones,
                building_size: participantPass.building,
                is_replacement: vm.isReplacement,
                floor_materials: participantPass.floor,
                roof_materials: participantPass.roof,
                wall_materials: participantPass.wall,
                land_status: participantPass.land,
                is_visitor: participantPass.is_visitor || 0,
                water_supply: participantPass.water,
                electricity: participantPass.electricity,
                is_married: participantPass.married,
                has_marriage_certificate: participantPass.certificate,
                fuel_for_cooking: participantPass.fuel,
                toilet: participantPass.toilet,
                appliances: vm.submitAppliances,
                transportations: vm.submitTransports,
                furnitures: vm.submitFurnitures,
                is_counselor: participantPass.isCounselor === 1 ? 1 : 0,
                children: [],
                privacy_act: participantPass.privacy_act,
                philhealth_member: participantPass.philhealth_member,
                civil_status: participantPass.civil_status,
                is_participants_household_head: participantPass.scorecard.is_participants_household_head,
                house_hold_first_name: participantPass.scorecard.house_hold_first_name,
                house_hold_middle_name: participantPass.scorecard.house_hold_middle_name,
                house_hold_last_name: participantPass.scorecard.house_hold_last_name,
                house_hold_suffix: participantPass.scorecard.house_hold_suffix,
                house_hold_relation: participantPass.scorecard.house_hold_relation,
                house_hold_gender: participantPass.scorecard.house_hold_gender,
            };

            if (typeof participant.is_disqualified !== "undefined") {
                participantObj.is_disqualified = participant.is_disqualified;
            }

            if (participantPass.phoneNumber) {
                participantObj.phone_number = participantPass.phoneNumber;
            }

            if (participantPass.birthdate) {
                participantObj.birthdate = moment(participantPass.birthdate).format('LL');
            }

            if (participantPass.isCounselor == -1) {
                participantObj.is_visitor = 1;
                participantObj.is_counselor = 0;
            } else {
                participantObj.is_visitor = 0;
            }

            for (var i in vm.toAddChildren) {
                var child = vm.toAddChildren[i];

                if (child.relationship == "other") {
                    child.relationship = child.other_relationship;
                }

                participantObj.children.push(child);
            }

            return ParticipantService.editParticipant(participantObj)
                .then(function () {
                    vm.saving = false;
                    callback();
                    closeDialog();
                }).catch(function (response) {
                    vm.saving = false;
                    if (response.data && response.data.errors) {
                        if (response.data.errors.phone_number) {
                            vm.errorPhone = 'Invalid phone no.';
                        }
                    }

                    for (var field in response.data.errors) {
                        vm.apiErrors[field] = response.data.errors[field].shift();
                    }
                });
        }

        /*
     Function used to show three more question for house hold head if he is not belongs to participants
      */



        vm.onHouseholdParticipantKnowChange = function () {
            if (vm.participant.scorecard.is_participants_household_head == 0) {
                vm.house_hold_field_validation = true;
            } else {
                vm.house_hold_field_validation = false;
            }
        }

        vm.onCivilStatusChange = function () {
            if (vm.participant.civil_status == 'live_in') {
                vm.CENOMAR_required = true;
            } else {
                vm.CENOMAR_required = false;
                delete vm.participant.certificate;
            }
            console.log(vm.participant);

        }
        /*
        Function used to close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();
(function () {
    'use strict';

    angular.module('app.transform')
        .controller('DeleteParticipantDialogController', DeleteParticipantDialogController);

    /** @ngInject */
    function DeleteParticipantDialogController($mdDialog,
                                               $document,
                                               callback,
                                               participant,
                                               ParticipantService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.deleteCallback = deleteCallback;

        vm.dialogTitle = "Delete Participant";
        vm.message = 'Are you sure you want to delete this participant?';

        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation() {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: vm.deleteCallback,
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used  to delete a participant
         */
        function deleteCallback() {
            vm.saving = true;
            return ParticipantService.deleteParticipant(participant)
                .then(function () {
                    vm.saving = false;
                    callback();
                    closeDialog();
                });
        }

        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();
(function () {
    'use strict';

    angular.module('app.transform')
        .controller('DeleteApplicationDialogController', DeleteApplicationDialogController);

    /** @ngInject */
    function DeleteApplicationDialogController($mdDialog,
        $document,
        drawApplicationsTable,
        mode,
        application,
        ApplicationService) {
        var vm = this;
        vm.dialogTitle = "Delete Application";
        vm.message = 'Are you sure you want to delete this application?';

        //Methods
        vm.closeDialog = closeDialog;
        vm.deleteCallback = deleteCallback;
        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(application) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: vm.deleteCallback,
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to delete an application
         */
        function deleteCallback() {
            vm.saving = true;

            if (mode == 'application') {
                return ApplicationService.deleteApplication(application)
                    .then(function () {
                        vm.saving = false;
                        drawApplicationsTable();
                        closeDialog();
                    });
            } else if (mode == 'deleted') {
                return ApplicationService.deleteDeletedApplication(application)
                    .then(function (data) {
                        vm.saving = false;
                        drawApplicationsTable();
                        closeDialog();
                    });
            }
        }

        /*
        Function used to close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();
(function () {
    'use strict';

    angular.module('app.transform')
        .controller('BatchSelectionDialogController', BatchSelectionDialogController);

    /** @ngInject */
    function BatchSelectionDialogController($mdDialog,
                                            drawApplicationsTable,
                                            application,
                                            CommunityService,
                                            BatchService) {
        var vm = this;

        //Methods
        vm.approveApplication = approveApplication;
        vm.closeDialog = closeDialog;

        vm.application = application;

        vm.dialogTitle = "Approve Application";

        /*
        Function used to get all available batches
         */
        function initForm() {
            BatchService.getAvailableBatches()
                .then(function (batches) {
                    vm.batches = batches;

                    getCurrentBatch();
                });
        }

        initForm();

        /*
        Function used to approve appliation to community list
         */
        function approveApplication() {
            vm.saving = true;
            return CommunityService.addCommunity({
                application_id: this.application.id,
                batch_id: this.batch,
                year: this.batch.year
            })
                .then(function () {
                    vm.saving = false;
                    drawApplicationsTable();
                    closeDialog();
                });
        }

        /*
        Function to get the current running Batch
         */
        function getCurrentBatch() {
            BatchService.getBatches({
                current: 1,
                limit: 1
            }).then(function(response) {
                vm.batch = response.data && response.data.length > 0 ? response.data[0].id : '';
            })
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.transform')
        .controller('ApproveApplicationDialogController', ApproveApplicationDialogController);

    /** @ngInject */
    function ApproveApplicationDialogController($mdDialog,
                                                drawApplicationsTable,
                                                application,
                                                ApplicationService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.approveApplication = approveApplication;

        vm.dialogTitle = "Approve Application";

        /*
        Function used to approve an application
         */
        function approveApplication() {
            vm.saving = true;
            return ApplicationService.approveApplication(application)
                .then(function () {
                    vm.saving = false;
                    drawApplicationsTable();
                    closeDialog();
                });
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();
(function () {
    'use strict';

    angular.module('app.transform')
        .controller('AddParticipantInSelectionDialogController', AddParticipantInSelectionDialogController);

    /** @ngInject */
    function AddParticipantInSelectionDialogController($mdDialog,
        $scope,
        callback,
        guest,
        ParticipantService,
        application,
        enumFields) {
        var vm = this;
        //Methods
        vm.closeDialog = closeDialog;
        vm.addParticipant = addParticipant;
        vm.toggleCheckBox = toggleCheckBox;
        vm.isSelected = isSelected;
        vm.selectCounselor = selectCounselor;
        vm.searchCounselors = searchCounselors;
        vm.addChild = addChild;
        vm.removeChild = removeChild;

        vm.application = application;

        vm.apiErrors = {};

        vm.toAddChildren = [];

        vm.isReplacement = 0;
        vm.useExisting = 0;
        vm.selectedCounselor = null;

        vm.submitAppliances = [];
        vm.submitFurnitures = [];
        vm.submitTransports = [];

        vm.genders = [];
        vm.buildingSizes = [];
        vm.floorMaterials = [];
        vm.roofMaterials = [];
        vm.wallMaterials = [];
        vm.landStatuses = [];
        vm.waterSupplies = [];
        vm.electricities = [];
        vm.fuelsCooking = [];
        vm.toilets = [];
        vm.furnitures = [];
        vm.appliances = [];
        vm.transports = [];
        vm.civilStatuses = [];
        vm.childRelationships = [];

        vm.dialogTitle = "Add Participant";

        vm.participant = {};
        vm.CENOMAR_required = false;

        if (guest) {
            vm.participant.firstName = guest;
        }

        // Calculate minimum birthdate allowed (13 years ago from today)
        var minDate = new Date();
        minDate.setFullYear(minDate.getFullYear() - 13);

        // Set maximum allowed birthdate (today's date minus 13 years)
        var maxBirthdate = new Date();
        maxBirthdate.setFullYear(maxBirthdate.getFullYear() - 13);

        // Set maximum allowed date (13 years ago from today)
        vm.maxDate = maxBirthdate;

        activate();

        /*
        Function used to load genders, buildingSizes, floorMaterials, etc.
         */
        function activate() {
            vm.pastor = application.pastor;

            enumFields([
                "gender",
                "building_size",
                "floor_materials",
                "roof_materials",
                "wall_materials",
                "land_status",
                "water_supply",
                "electricity",
                "fuel_for_cooking",
                "toilet",
                "furnitures",
                "appliances",
                "transportations",
                "civil_status",
                "child_relationship"
            ])
                .then(function (values) {
                    console.log("values", values);
                    vm.genders = values.gender;
                    vm.buildingSizes = values.building_size;
                    vm.floorMaterials = values.floor_materials;
                    vm.roofMaterials = values.roof_materials;
                    vm.wallMaterials = values.wall_materials;
                    vm.landStatuses = values.land_status;
                    vm.waterSupplies = values.water_supply;
                    vm.electricities = values.electricity;
                    vm.fuelsCooking = values.fuel_for_cooking;
                    vm.toilets = values.toilet;
                    vm.furnitures = values.furnitures;
                    vm.appliances = values.appliances;
                    vm.transports = values.transportations;
                    vm.civilStatuses = values.civil_status;
                    vm.childRelationships = values.child_relationship;

                    getDropDownitems();
                });
        }

        /*
        Function to add card
         */
        function addChild() {
            var cardsLength = vm.toAddChildren.length;
            vm.toAddChildren.push({
                number: cardsLength,
                relationship: vm.childRelationships[0].value
            });
        }

        function removeChild(child) {
            vm.toAddChildren = vm.toAddChildren.filter(function (item) {
                if (child.number != item.number) {
                    return item;
                }
            })
        }

        /*
        Function used to select existing counselor
         */
        function selectCounselor(counselor) {
            vm.selectedCounselor = counselor;
            vm.participant.firstName = counselor.firstname;
            vm.participant.lastName = counselor.lastname;
            vm.participant.middleName = counselor.middlename;
            vm.participant.suffix = counselor.suffix;
            vm.participant.gender = counselor.gender;
            vm.participant.income = counselor.total_income;
            vm.participant.id = counselor.id;

            if (counselor.birthdate) {
                vm.participant.birthdate = moment(counselor.birthdate).format('LL');
            }

            if (counselor.phone_number) {
                vm.participant.phoneNumber = counselor.phone_number;
            }
        }

        /*
        Function used to search for counselors by search text
         */
        function searchCounselors(query) {
            return ParticipantService.getParticipants({
                is_counselor: 1,
                is_promoted: 0,
                search: query,
                is_available: 1
            }).then(function (response) {
                return response.data;
            });
        }

        /*
        Function used to check if a furniture, appliance, or transportation is already
        selected. If selected, push. Otherwise, splice.
         */
        function toggleCheckBox(key, item) {
            if (key === 'furniture') {
                var index = vm.submitFurnitures.indexOf(item);
                if (index > -1) {
                    vm.submitFurnitures.splice(index, 1);
                } else {
                    vm.submitFurnitures.push(item);
                }
            } else if (key === 'appliances') {
                var index = vm.submitAppliances.indexOf(item);
                if (index > -1) {
                    vm.submitAppliances.splice(index, 1);
                } else {
                    vm.submitAppliances.push(item);
                }
            } else if (key === 'transport') {
                var index = vm.submitTransports.indexOf(item);
                if (index > -1) {
                    vm.submitTransports.splice(index, 1);
                } else {
                    vm.submitTransports.push(item);
                }

                //checks if none is selected in transporation
                if (item !== 'none' && vm.submitTransports.length > 0) {
                    vm.noneDisabled = true;
                } else {
                    vm.noneDisabled = false;
                }
            }
        }

        /*
        Function used to check if a furniture, appliances, and transporation is in the
        array
         */
        function isSelected(key, item) {
            if (key === 'furniture') {
                return vm.submitFurnitures.indexOf(item) > -1;
            } else if (key === 'appliances') {
                return vm.submitAppliances.indexOf(item) > -1;
            } else if (key === 'transport') {
                return vm.submitTransports.indexOf(item) > -1;
            }
        }

        /*
        Function used to populate options in the dropdown
         */
        function getDropDownitems() {
            vm.building = {
                key: 'building',
                question: 'What is the size of the home/building?',
                items: vm.buildingSizes
            };
            vm.floor = {
                key: 'floor',
                question: 'What material is the floor made of?',
                items: vm.floorMaterials
            };
            vm.roof = {
                key: 'roof',
                question: 'what type of construction materials are the roofs made of?',
                items: vm.roofMaterials
            };
            vm.wall = {
                key: 'wall',
                question: 'What type of construction materials are the outer walls made of?',
                items: vm.wallMaterials
            };
            vm.land = {
                key: 'land',
                question: 'What is the status of the land?',
                items: vm.landStatuses
            };
            vm.water_supply = {
                key: 'water',
                question: "What is the family's main source of water supply that is available within 50 meters?",
                items: vm.waterSupplies
            };
            vm.electricity = {
                key: 'electricity',
                question: 'Is there any electricity in the building/house?',
                items: vm.electricities
            };
            vm.fuel_for_cooking = {
                key: 'fuel',
                question: 'What type of fuel does your household use for cooking?',
                items: vm.fuelsCooking
            };
            vm.toilet = {
                key: 'toilet',
                question: 'What type of toilet does the household have?',
                items: vm.toilets
            };

            vm.dropdownItems = [
                {
                    key: 'building',
                    question: 'What is the size of the home/building?',
                    items: vm.buildingSizes
                },
                {
                    key: 'floor',
                    question: 'Floor Material',
                    items: vm.floorMaterials
                },
                {
                    key: 'roof',
                    question: 'Roof Material',
                    items: vm.roofMaterials
                },
                {
                    key: 'wall',
                    question: 'Wall Material',
                    items: vm.wallMaterials
                },
                {
                    key: 'land',
                    question: 'Land Status',
                    items: vm.landStatuses
                },
                {
                    key: 'water',
                    question: 'Water Supply',
                    items: vm.waterSupplies
                },
                {
                    key: 'electricity',
                    question: 'Electricity',
                    items: vm.electricities
                },
                {
                    key: 'fuel',
                    question: 'Fuel for cooking',
                    items: vm.fuelsCooking
                },
                {
                    key: 'toilet',
                    question: 'Toilet',
                    items: vm.toilets
                }
            ];

            vm.checkBoxItems = [
                {
                    key: 'furniture',
                    question: 'Furniture',
                    items: vm.furnitures
                },
                {
                    key: 'appliances',
                    question: 'Appliances',
                    items: vm.appliances
                }
            ];

            // set defaults
            if (!vm.participant.civil_status) {
                vm.participant.civil_status = vm.civilStatuses[0].value;
            }
        }


        /*
        Function used to add participant in the application
         */
        function addParticipant(participantPass) {
            vm.saving = true;

            var participantObj = {
                application_id: application.id,
                firstname: participantPass.firstName,
                lastname: participantPass.lastName,
                middlename: participantPass.middleName,
                suffix: participantPass.suffix,
                gender: participantPass.gender,
                total_income: participantPass.income,
                has_score_card: participantPass.toggle ? participantPass.toggle : 0,
                has_no_birth_reg: participantPass.householdMembers,
                has_4ps_member: participantPass.p4,
                total_occupants: participantPass.peopleLive,
                total_phones: participantPass.telephones,
                building_size: participantPass.building,
                phone_number: participantPass.phoneNumber,
                floor_materials: participantPass.floor,
                roof_materials: participantPass.roof,
                wall_materials: participantPass.wall,
                is_replacement: vm.isReplacement,
                is_married: participantPass.married,
                has_marriage_certificate: participantPass.certificate,
                land_status: participantPass.land,
                water_supply: participantPass.water,
                electricity: participantPass.electricity,
                fuel_for_cooking: participantPass.fuel,
                toilet: participantPass.toilet,
                appliances: vm.submitAppliances,
                transportations: vm.submitTransports,
                furnitures: vm.submitFurnitures,
                children: [],
                privacy_act: participantPass.privacy_act,
                philhealth_member: participantPass.philhealth_member,
                civil_status: participantPass.civil_status,
                is_participants_household_head: participantPass.is_participants_household_head,
                house_hold_first_name: participantPass.house_hold_first_name,
                house_hold_middle_name: participantPass.house_hold_middle_name,
                house_hold_last_name: participantPass.house_hold_last_name,
                house_hold_suffix: participantPass.house_hold_suffix,
                house_hold_relation: participantPass.house_hold_relation,
                house_hold_gender: participantPass.house_hold_gender,
            };

            if (participantPass.isCounselor && participantPass.isCounselor.is_counselor) {
                participantObj.is_counselor = 1;
            } else if (participantPass.isCounselor && participantPass.isCounselor.is_participant) {
                participantObj.is_counselor = 0;
            }

            if (participantPass.birthdate) {
                participantObj.birthdate = moment(participantPass.birthdate).format('LL');
            }

            for (var i in vm.toAddChildren) {
                var child = vm.toAddChildren[i];

                if (child.relationship == "other") {
                    child.relationship = child.other_relationship;
                }

                participantObj.children.push(child);
            }

            if (!vm.useExisting) {
                ParticipantService.addParticipant(participantObj)
                    .then(function () {
                        vm.saving = false;
                        callback();
                        closeDialog();
                    }).catch(function (response) {
                        vm.saving = false;
                        if (response.data && response.data.errors) {
                            if (response.data.errors.phone_number) {
                                vm.errorPhone = 'Invalid phone no.';
                            }
                        }

                        for (var field in response.data.errors) {
                            vm.apiErrors[field] = response.data.errors[field].shift();
                        }
                    });
            } else {
                participantObj.id = participantPass.id;
                ParticipantService.editParticipant(participantObj)
                    .then(function (item) {
                        vm.saving = false;
                        callback();
                        closeDialog();
                    }).catch(function (response) {
                        vm.saving = false;
                        if (response.data && response.data.errors) {
                            if (response.data.errors.phone_number) {
                                vm.errorPhone = 'Invalid phone no.';
                            }
                        }

                        for (var field in response.data.errors) {
                            vm.apiErrors[field] = response.data.errors[field].shift();
                        }
                    });
            }
        }

        vm.onParticipantTypeChange = function () {
            if (vm.participant.isCounselor.is_participant) {
                vm.participant.toggle = 1;
                vm.useExisting = false;
            } else {
                vm.participant.toggle = 0
            }
        }

        /*
        Function used to show three more question for house hold head if he is not belongs to participants
         */
        vm.onHouseholdParticipantKnowChange = function () {

            if (vm.participant.isCounselor.is_participant) {
                vm.participant.toggle = 1;
                vm.useExisting = false;
            } else {
                vm.participant.toggle = 0;

            }

            if (vm.participant.is_participants_household_head === 0) {
                vm.house_hold_field_validation = true;
            } else {
                vm.house_hold_field_validation = false;
            }
        }

        vm.onGenderofHouseholdHeadChange = function () {
            console.log(vm.participant);
            if (vm.participant.isCounselor.is_participant) {
                vm.participant.toggle = 1;
                vm.useExisting = false;
            } else {
                vm.participant.toggle = 0
            }
        }
        vm.onRelationHouseholdChange = function () {
            console.log(vm.participant);

            if (vm.participant.isCounselor.is_participant) {
                vm.participant.toggle = 1;
                vm.useExisting = false;
            } else {
                vm.participant.toggle = 0
            }
        }
        vm.onCivilStatusChange = function () {
            console.log(vm.participant);
            if (vm.participant.civil_status == 'live_in') {
                vm.CENOMAR_required = true;
            } else {
                vm.CENOMAR_required = false;
                delete vm.participant.certificate;
            }
        }


        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();
(function () {
    'use strict';

    angular.module('app.transform')
        .controller('AddParticipantDialogController', AddParticipantDialogController);

    /** @ngInject */
    function AddParticipantDialogController($mdDialog,
        callback,
        guest,
        ParticipantService,
        community,
        enumFields) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.addParticipant = addParticipant;
        vm.toggleCheckBox = toggleCheckBox;
        vm.isSelected = isSelected;
        vm.selectCounselor = selectCounselor;
        vm.searchCounselors = searchCounselors;
        vm.clickUseExisting = clickUseExisting;
        vm.addChild = addChild;
        vm.removeChild = removeChild;

        vm.community = community;

        vm.apiErrors = {};

        vm.toAddChildren = [];

        vm.isReplacement = community ? community.current_batch_data.hasStarted : 0;
        vm.useExisting = 0;
        vm.selectedCounselor = null;


        vm.submitAppliances = [];
        vm.submitFurnitures = [];
        vm.submitTransports = [];

        vm.genders = [];
        vm.buildingSizes = [];
        vm.floorMaterials = [];
        vm.roofMaterials = [];
        vm.wallMaterials = [];
        vm.landStatuses = [];
        vm.waterSupplies = [];
        vm.electricities = [];
        vm.fuelsCooking = [];
        vm.toilets = [];
        vm.furnitures = [];
        vm.appliances = [];
        vm.transports = [];
        vm.civilStatuses = [];
        vm.childRelationships = [];
        vm.CENOMAR_required = false;
        vm.dialogTitle = "Add Participant";
        vm.house_hold_field_validation = false;
        vm.participant = {
            isCounselor: 0,
            gender: 'male'
        };

        // Calculate minimum birthdate allowed (13 years ago from today)
        var minDate = new Date();
        minDate.setFullYear(minDate.getFullYear() - 13);

        // Set maximum allowed birthdate (today's date minus 13 years)
        var maxBirthdate = new Date();
        maxBirthdate.setFullYear(maxBirthdate.getFullYear() - 13);

        // Set maximum allowed date (13 years ago from today)
        vm.maxDate = maxBirthdate;

        if (guest) {
            if (guest.is_visitor) {
                // vm.dialogTitle             = "Add Visitor";
                // vm.participant.is_visitor  = 1;
                // vm.participant.isCounselor = -1;
            } else {
                vm.participant.firstName = guest;
            }
        }

        activate();

        /*
        Function used to check Use Existing when counselor is selected as
        participant type
         */
        function clickUseExisting() {
            vm.useExisting = !vm.useExisting;

            if (!vm.useExisting) {
                vm.searchCounselor = '';
            }
        }

        /*
        Function used to load genders, buildingSizes, floorMaterials, etc.
         */
        function activate() {
            vm.pastor = community.application.pastor;

            enumFields([
                "gender",
                "building_size",
                "floor_materials",
                "roof_materials",
                "wall_materials",
                "land_status",
                "water_supply",
                "electricity",
                "fuel_for_cooking",
                "toilet",
                "furnitures",
                "appliances",
                "transportations",
                "civil_status",
                "child_relationship"
            ])
                .then(function (values) {
                    vm.genders = values.gender;
                    vm.buildingSizes = values.building_size;
                    vm.floorMaterials = values.floor_materials;
                    vm.roofMaterials = values.roof_materials;
                    vm.wallMaterials = values.wall_materials;
                    vm.landStatuses = values.land_status;
                    vm.waterSupplies = values.water_supply;
                    vm.electricities = values.electricity;
                    vm.fuelsCooking = values.fuel_for_cooking;
                    vm.toilets = values.toilet;
                    vm.furnitures = values.furnitures;
                    vm.appliances = values.appliances;
                    vm.transports = values.transportations;
                    vm.civilStatuses = values.civil_status;
                    vm.childRelationships = values.child_relationship;

                    getDropDownitems();
                });
        }

        /*
        Function to add card
         */
        function addChild() {
            var cardsLength = vm.toAddChildren.length;
            vm.toAddChildren.push({
                number: cardsLength,
                relationship: vm.childRelationships[0].value,
                firstname: '',
                lastname: '',
            });
        }

        function removeChild(child) {
            vm.toAddChildren = vm.toAddChildren.filter(function (item) {
                if (child.number != item.number) {
                    return item;
                }
            })
        }

        /*
        Function used to select existing counselor
         */
        function selectCounselor(counselor) {
            vm.selectedCounselor = counselor;
            vm.participant.firstName = counselor.firstname;
            vm.participant.lastName = counselor.lastname;
            vm.participant.middleName = counselor.middlename;
            vm.participant.suffix = counselor.suffix;
            vm.participant.gender = counselor.gender;
            vm.participant.income = counselor.total_income;
            vm.participant.id = counselor.id;

            if (counselor.birthdate) {
                vm.participant.birthdate = moment(counselor.birthdate).format('LL');
            }

            if (counselor.phone_number) {
                vm.participant.phoneNumber = counselor.phone_number;
            }
        }

        /*
        Function used to search for counselors by search text
         */
        function searchCounselors(query) {
            return ParticipantService.getParticipants({
                is_counselor: 1,
                is_promoted: 0,
                search: query,
                is_available: 1
            }).then(function (response) {
                return response.data;
            });
        }

        /*
        Function used to check if a furniture, appliance, or transportation is already
        selected. If selected, push. Otherwise, splice.
         */
        function toggleCheckBox(key, item) {
            if (key === 'furniture') {
                var index = vm.submitFurnitures.indexOf(item);
                if (index > -1) {
                    vm.submitFurnitures.splice(index, 1);
                } else {
                    vm.submitFurnitures.push(item);
                }
            } else if (key === 'appliances') {
                var index = vm.submitAppliances.indexOf(item);
                if (index > -1) {
                    vm.submitAppliances.splice(index, 1);
                } else {
                    vm.submitAppliances.push(item);
                }
            } else if (key === 'transport') {
                var index = vm.submitTransports.indexOf(item);
                if (index > -1) {
                    vm.submitTransports.splice(index, 1);
                } else {
                    vm.submitTransports.push(item);
                }

                //checks if none is selected in transporation
                if (item !== 'none' && vm.submitTransports.length > 0) {
                    vm.noneDisabled = true;
                } else {
                    vm.noneDisabled = false;
                }
            }
        }

        /*
        Function used to check if a furniture, appliances, and transporation is in the
        array
         */
        function isSelected(key, item) {
            if (key === 'furniture') {
                return vm.submitFurnitures.indexOf(item) > -1;
            } else if (key === 'appliances') {
                return vm.submitAppliances.indexOf(item) > -1;
            } else if (key === 'transport') {
                return vm.submitTransports.indexOf(item) > -1;
            }
        }

        /*
        Function used to populate options in the dropdown
         */
        function getDropDownitems() {
            vm.building = {
                key: 'building',
                question: 'What is the size of the home/building?',
                items: vm.buildingSizes
            };
            vm.floor = {
                key: 'floor',
                question: 'What material is the floor made of?',
                items: vm.floorMaterials
            };
            vm.roof = {
                key: 'roof',
                question: 'what type of construction materials are the roofs made of?',
                items: vm.roofMaterials
            };
            vm.wall = {
                key: 'wall',
                question: 'What type of construction materials are the outer walls made of?',
                items: vm.wallMaterials
            };
            vm.land = {
                key: 'land',
                question: 'What is the status of the land?',
                items: vm.landStatuses
            };
            vm.water_supply = {
                key: 'water',
                question: "What is the family's main source of water supply that is available within 50 meters?",
                items: vm.waterSupplies
            };
            vm.electricity = {
                key: 'electricity',
                question: 'Is there any electricity in the building/house?',
                items: vm.electricities
            };
            vm.fuel_for_cooking = {
                key: 'fuel',
                question: 'What type of fuel does your household use for cooking?',
                items: vm.fuelsCooking
            };
            vm.toilet = {
                key: 'toilet',
                question: 'What type of toilet does the household have?',
                items: vm.toilets
            };


            vm.dropdownItems = [
                {
                    key: 'building',
                    question: 'What is the size of the home/building?',
                    items: vm.buildingSizes
                },
                {
                    key: 'floor',
                    question: 'Floor Material',
                    items: vm.floorMaterials
                },
                {
                    key: 'roof',
                    question: 'Roof Material',
                    items: vm.roofMaterials
                },
                {
                    key: 'wall',
                    question: 'Wall Material',
                    items: vm.wallMaterials
                },
                {
                    key: 'land',
                    question: 'Land Status',
                    items: vm.landStatuses
                },
                {
                    key: 'water',
                    question: 'Water Supply',
                    items: vm.waterSupplies
                },
                {
                    key: 'electricity',
                    question: 'Electricity',
                    items: vm.electricities
                },
                {
                    key: 'fuel',
                    question: 'Fuel for cooking',
                    items: vm.fuelsCooking
                },
                {
                    key: 'toilet',
                    question: 'Toilet',
                    items: vm.toilets
                }
            ];

            vm.checkBoxItems = [
                {
                    key: 'furniture',
                    question: 'Furniture',
                    items: vm.furnitures
                },
                {
                    key: 'appliances',
                    question: 'Appliances',
                    items: vm.appliances
                }
            ];

            // set defaults
            if (!vm.participant.civil_status) {
                vm.participant.civil_status = vm.civilStatuses[0].value;
            }
        }

        /*
        Function used to add participant in the application
         */
        function addParticipant(participantPass) {
            vm.saving = true;
            vm.errorPhone = '';

            var participantObj = {
                community_id: community.id,
                application_id: community.application_id,
                firstname: participantPass.firstName,
                lastname: participantPass.lastName,
                middlename: participantPass.middleName,
                suffix: participantPass.suffix,
                gender: participantPass.gender,
                total_income: participantPass.income,
                has_score_card: participantPass.toggle ? participantPass.toggle : 0,
                has_no_birth_reg: participantPass.householdMembers,
                has_4ps_member: participantPass.p4,
                total_occupants: participantPass.peopleLive,
                // total_sick_members: participantPass.individualSick,
                total_phones: participantPass.telephones,
                building_size: participantPass.building,
                phone_number: participantPass.phoneNumber,
                floor_materials: participantPass.floor,
                roof_materials: participantPass.roof,
                is_replacement: vm.isReplacement,
                wall_materials: participantPass.wall,
                land_status: participantPass.land,
                water_supply: participantPass.water,
                is_married: participantPass.married,
                has_marriage_certificate: participantPass.certificate,
                electricity: participantPass.electricity,
                fuel_for_cooking: participantPass.fuel,
                toilet: participantPass.toilet,
                appliances: vm.submitAppliances,
                transportations: vm.submitTransports,
                furnitures: vm.submitFurnitures,
                children: [],
                privacy_act: participantPass.privacy_act,
                philhealth_member: participantPass.philhealth_member,
                civil_status: participantPass.civil_status,
                is_participants_household_head: participantPass.is_participants_household_head,
                house_hold_first_name: participantPass.house_hold_first_name,
                house_hold_middle_name: participantPass.house_hold_middle_name,
                house_hold_last_name: participantPass.house_hold_last_name,
                house_hold_suffix: participantPass.house_hold_suffix,
                house_hold_relation: participantPass.house_hold_relation,
                house_hold_gender: participantPass.house_hold_gender,
            };

            if (typeof participantPass.is_visitor !== "undefined") {
                participantObj.is_visitor = participantPass.is_visitor;
            }

            if (participantPass.isCounselor == -1) {
                participantObj.is_visitor = 1;
                participantObj.is_counselor = 0;
                participantObj.is_replacement = 0;
            } else {
                participantObj.is_counselor = participantPass.isCounselor ? 1 : 0;
            }

            if (participantPass.isCounselor && participantPass.isCounselor.is_counselor) {
                participantObj.is_counselor = 1;
            } else if (participantPass.isCounselor && participantPass.isCounselor.is_participant) {
                participantObj.is_counselor = 0;
            }

            if (participantPass.birthdate) {
                participantObj.birthdate = moment(participantPass.birthdate).format('LL');
            }

            for (var i in vm.toAddChildren) {
                var child = vm.toAddChildren[i];

                if (child.relationship == "other") {
                    child.relationship = child.other_relationship;
                }

                participantObj.children.push(child);
            }

            if (!vm.useExisting) {
                return ParticipantService.addParticipant(participantObj)
                    .then(function (item) {
                        vm.saving = false;
                        callback(item);
                        closeDialog();
                    }).catch(function (response) {
                        vm.saving = false;
                        if (response.data && response.data.errors) {
                            if (response.data.errors.phone_number) {
                                vm.errorPhone = 'Invalid phone no.';
                            }
                        }

                        for (var field in response.data.errors) {
                            vm.apiErrors[field] = response.data.errors[field].shift();
                        }
                    });
            } else {
                participantObj.id = participantPass.id;
                ParticipantService.editParticipant(participantObj)
                    .then(function (item) {
                        vm.saving = false;
                        callback(item);
                        closeDialog();
                    }).catch(function (response) {
                        vm.saving = false;
                        if (response.data && response.data.errors) {
                            if (response.data.errors.phone_number) {
                                vm.errorPhone = 'Invalid phone no.';
                            }
                        }

                        for (var field in response.data.errors) {
                            vm.apiErrors[field] = response.data.errors[field].shift();
                        }
                    });
            }
        }

        vm.onParticipantTypeChange = function () {
            if (vm.participant.isCounselor.is_participant) {
                vm.participant.toggle = 1;
                vm.useExisting = false;
            } else {
                vm.participant.toggle = 0
            }
        }

        /*
        Function used to show three more question for house hold head if he is not belongs to participants
         */
        vm.onHouseholdParticipantKnowChange = function () {
            if (vm.participant.is_participants_household_head === 0) {
                vm.house_hold_field_validation = true;
            } else {
                vm.house_hold_field_validation = false;
            }
        }

        vm.onCivilStatusChange = function () {
            if (vm.participant.civil_status == 'live_in') {
                vm.CENOMAR_required = true;
            } else {
                vm.CENOMAR_required = false;
                delete vm.participant.certificate;
            }

        }
        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.thrive')
        .controller('ThriveReportsController', ThriveReportsController);

    /** @ngInject */
    function ThriveReportsController(ReportService,
                                     $scope,
                                     $mdBottomSheet,
                                     $localStorage,
                                     $httpParamSerializer,
                                     api,
                                     Auth,
                                     $mdDialog,
                                     $document,
                                     BaseService) {
        var vm = this;

        var currentUser = Auth.getUser();
        vm.currentUser = currentUser;

        var _parent = $scope;
        _parent.$parent.vm.currentTab = 4;

        vm.newReport = true;
        vm.noData = false;
        vm.templateSelected = false;

        vm.reportPrograms = [];

        vm.report = {};
        vm.api = api;

        vm.programs = [
            {
                name: 'Pastor Profile',
                id: 'pastors'
            },
            {
                name: 'Thrive Data Card',
                id: 'data_cards'
            }
        ];

        //Methods
        vm.selectAll = selectAll;
        vm.isSelectedAll = isSelectedAll;
        vm.isSelected = isSelected;
        vm.selectFilter = selectFilter;
        vm.showPreview = showPreview;
        vm.updateFilters = updateFilters;
        vm.saveTemplate = saveTemplate;
        vm.showTemplate = showTemplate;
        vm.presetIsSelectedAll = presetIsSelectedAll;
        vm.presetSelectAll = presetSelectAll;
        vm.presetIsSelected = presetIsSelected;
        vm.presetSelectFilter = presetSelectFilter;
        vm.presetShowPreview = presetShowPreview;
        vm.presetUpdateFilters = presetUpdateFilters;
        vm.editTemplate = editTemplate;
        vm.deleteTemplate = deleteTemplate;
        vm.selectBase = selectBase;
        vm.presetSelectBase = presetSelectBase;
        vm.selectLocation = selectLocation;
        vm.presetSelectLocation = presetSelectLocation;

        vm.selectedBase = {
            districts: [],
            bases: []
        };

        vm.presetSelectedBase = {
            districts: [],
            bases: []
        };

        activate();

        /*
        Function first called upon load
         */
        function activate() {
            getTemplates();
            getBases();
        }

        /*
        Function that fetches all bases if user has no assigned base
         */
        function getBases(data) {
            BaseService.getBases({
                nopage: true,
                base_id: currentUser.base_id,
                with: "districts,branches"
            }).then(function (response) {
                vm.bases = response;
                var base = response[0];

                vm.bases = response;
                if (currentUser.base_id) {
                    vm.selectedBase = vm.report.base = base;
                }

                if (currentUser.branch_id) {
                    vm.report.branch  = base.branches.filter(function(item) {
                      return item.id == currentUser.branch_id;
                    }).shift();
                }
            });
        }

        /*
        Function used to select a base as a filter
         */
        function selectBase(report) {
            report = report || {};
            report.branch = 'all';
            report.district = 'all';
            vm.selectedBase = report.base;
            updateFilters(report);
        }

        /*
        Function used in report preset to select a base as a filter
         */
        function presetSelectBase(report) {
            report = report || {};
            report.filters.branch = 'all';
            report.filters.district = 'all';
            vm.presetSelectedBase = report.filters.base;
            presetUpdateFilters(report);
        }

        /*
        Function used to select either district or branch
         */
        function selectLocation(report) {
            report = report || {};
            updateFilters(report);
        }

        /*
        Function used in report preset to select district or branch
         */
        function presetSelectLocation(report) {
            report = report || {};
            presetUpdateFilters(report);
        }

        /*
         Selects all options in a category
         */
        function selectAll(report) {
            vm.reportPrograms = [];

            if (!vm.selectAllPrograms) {
                for (var i = 0; i < vm.programs.length; i++) {
                    vm.reportPrograms.push(vm.programs[i].id);
                }
            }

            vm.selectAllPrograms = !vm.selectAllPrograms;

            var tempcsvobj = {
                'programs[]': vm.reportPrograms,
                'token': $localStorage.currentUser.token,
                'start_date': report.start_date ? moment(report.start_date).format() : null,
                'end_date': report.end_date ? moment(report.end_date).format() : null,
                'base_id': report.base.id || null,
                'district_id': report.district.id || null,
                'branch_id': report.branch.id || null
            };
            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
         Checks if a Select All option is selected
         */
        function isSelectedAll() {
            if (vm.programs.length !== vm.reportPrograms.length) {
                return false;
            } else {
                if (vm.programs.length) {
                    for (var i = 0; i < vm.programs.length; i++) {
                        if (vm.programs[i].id !== vm.reportPrograms[i]) {
                            return false;
                        }
                    }
                } else {
                    return false;
                }
            }

            return true;
        }

        /*
         Checks if a checkbox is being selected
         */
        function isSelected(item) {
            return vm.reportPrograms.indexOf(item) > -1;
        }

        /*
         This function selects a checkbox filter
         */
        function selectFilter(item, report) {
            var index = vm.reportPrograms.indexOf(item);
            if (index > -1) {
                vm.reportPrograms.splice(index, 1);
            } else {
                vm.reportPrograms.push(item);
            }
            vm.selectAllPrograms = false;

            var tempcsvobj = {
                'programs[]': vm.reportPrograms,
                'token': $localStorage.currentUser.token,
                'start_date': report.start_date ? moment(report.start_date).format() : null,
                'end_date': report.end_date ? moment(report.end_date).format() : null,
                'base_id': report.base.id || null,
                'district_id': report.district.id || null,
                'branch_id': report.branch.id || null
            };
            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
         Calls bottom sheet UI for Preview
         */
        function showPreview(report) {
            vm.programMessage = '';
            vm.dateRangeError = '';

            if (vm.currentUser.base_id) {
                vm.reportBases = [vm.currentUser.base_id];
            }

            if (vm.currentUser.branch_id) {
                vm.reportBranches = [vm.currentUser.branch_id];
            }

            var htmlObj = {
                'programs': vm.reportPrograms,
                'start_date': report.start_date ? moment(report.start_date).format() : null,
                'end_date': report.end_date ? moment(report.end_date).format() : null,
                'base_id': report && report.base ? report.base.id : null,
                'district_id': report && report.district ? report.district.id : null,
                'branch_id': report && report.branch ? report.branch.id : null
            };

            if (vm.reportPrograms.length > 0) {
                $mdBottomSheet.show({
                    controller: 'ReportPreviewController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/transform/tabs/reports/bottom-sheets/report-preview/report-preview.html',
                    parent: '#transform-content-wrapper',
                    locals: {
                        preview: htmlObj,
                        csvUrl: vm.csvUrl
                    },
                    clickOutsideToClose: true,
                    disableBackdrop: true,
                    disableParentScroll: true
                });

                setTimeout(function() {
                    var parent = angular.element('#transform-content-wrapper');
                    parent.unbind('$md.dragstart')
                        .unbind('$md.drag')
                        .unbind('$md.dragend');
                }, 1000);
            } else {
                if (vm.reportPrograms.length < 1) {
                    vm.programMessage = 'Please select at least one program';
                }
            }

        }

        /*
        Function triggers after selecting a date
         */
        function updateFilters(report) {
            var tempcsvobj = {
                'programs[]': vm.reportPrograms,
                'token': $localStorage.currentUser.token,
                'start_date': report.start_date ? moment(report.start_date).format() : null,
                'end_date': report.end_date ? moment(report.end_date).format() : null,
                'base_id': report && report.base ? report.base.id : null,
                'district_id': report && report.district ? report.district.id : null,
                'branch_id': report && report.branch ? report.branch.id : null
            };
            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
        Function triggers after selecting a date
         */
        function presetUpdateFilters(report) {
            var tempcsvobj = {
                'programs[]': vm.template.filters['programs[]'],
                'token': $localStorage.currentUser.token,
                'start_date': report.filters.start_date ? moment(report.filters.start_date).format() : null,
                'end_date': report.filters.end_date ? moment(report.filters.end_date).format() : null,
                'base_id': report.filters.base_id || null,
                'district_id': report.filters.district_id || null,
                'branch_id': report.filters.branch_id || null
            };
            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
        Function to open save template modal
         */
        function saveTemplate(report) {
            vm.programMessage = '';
            if (vm.reportPrograms.length > 0) {
                $mdDialog.show({
                    controller: 'AddReportTemplateDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/transform/tabs/reports/dialogs/add-report-template/add-report-template-dialog.html',
                    parent: angular.element($document.body),
                    locals: {
                        csvObj: {
                            'programs[]': vm.reportPrograms,
                            'start_date': report.start_date ? moment(report.start_date).format() : null,
                            'end_date': report.end_date ? moment(report.end_date).format() : null,
                            'base_id': report && report.base ? report.base.id : null,
                            'district_id': report && report.district ? report.district.id : null,
                            'branch_id': report && report.branch ? report.branch.id : null
                        },
                        getTemplates: getTemplates,
                        mode: 'thrive'
                    },
                    clickOutsideToClose: true
                });
            } else {
                if (vm.reportPrograms.length < 1) {
                    vm.programMessage = 'Please select at least one program';
                }
            }
        }

        /*
        Function that gets all report templates
         */
        function getTemplates() {
            ReportService.getTemplates({
                type: 'thrive',
                nopage: true,
                user_id: currentUser.id
            }).then(function (response) {
                vm.templates = response.data;
            });
        }

        /*
        Function that shows preset report template
         */
        function showTemplate(template) {
            vm.templateSelected = true;
            vm.newReport = false;
            vm.template = template;
            vm.template.noData = false;
            console.log(template);
            vm.templates = vm.templates.map(function (template) {
                if (template && template.selected) template.selected = false;
                return template;
            });
            template.selected = true;
            vm.template.start_date = template.filters.start_date;
            vm.template.end_date = template.filters.end_date;

            if (!template.filters.base_id) {
                vm.template.filters.base = 'all';
            } else {
                var templateBase = vm.bases.filter(function (base) {
                    if (base.id === template.filters.base_id) {
                        vm.template.filters.base = base;
                        vm.presetSelectedBase = base;
                        return base;
                    }
                });
            }

            if (!template.filters.branch_id) {
                vm.template.filters.branch = 'all';
            } else {
                templateBase[0].branches.filter(function (branch) {
                    if (branch.id === template.filters.branch_id) {
                        vm.template.filters.branch = branch;
                        return;
                    }
                });
            }

            if (!template.filters.district_id) {
                vm.template.filters.district = 'all';
            } else {
                templateBase[0].districts.filter(function (district) {
                    if (district.id === template.filters.district.id) {
                        vm.template.filters.district = district;
                        return;
                    }
                });
            }


            var tempcsvobj = {
                'programs[]': vm.template.filters['programs[]'],
                'token': $localStorage.currentUser.token,
                'start_date': template.start_date ? moment(template.start_date).format() : null,
                'end_date': template.end_date ? moment(template.end_date).format() : null,
                'base_id': template.filters.base_id,
                'district_id': template.filters.district_id,
                'branch_id': template.filters.branch_id
            };
            vm.csvUrl = $httpParamSerializer(tempcsvobj);

            vm.bases.forEach(function (item) {
                if (item.id == template.filters.base_id) {
                    vm.presetSelectedBase = item;
                }
            });
        }

        /*
        Function in the preset that checks if select all is checked
         */
        function presetIsSelectedAll() {
            if (vm.templateSelected && vm.template && vm.template.filters) {
                if (vm.programs.length !== vm.template.filters['programs[]'].length) {
                    return false;
                } else {
                    if (vm.programs.length) {
                        for (var i = 0; i < vm.programs.length; i++) {
                            if (vm.programs[i].id !== vm.template.filters['programs[]'][i]) {
                                return false;
                            }
                        }
                    } else {
                        return false;
                    }
                }
            }

            return true;
        }

        /*
        Selects all checkboxes in the preset settings
         */
        function presetSelectAll(report) {
            if (presetIsSelectedAll('program')) {
                vm.template.selectAllPrograms = true;
            }
            vm.template.filters['programs[]'] = [];

            if (presetIsSelectedAll('program')) {
                vm.template.selectAllPrograms = true;
            }

            if (!vm.template.selectAllPrograms) {
                for (var i = 0; i < vm.programs.length; i++) {
                    vm.template.filters['programs[]'].push(vm.programs[i].id);
                }
            }

            vm.template.selectAllPrograms = !vm.template.selectAllPrograms;

            var tempcsvobj = {
                'programs': vm.template.filters['programs[]'],
                'token': $localStorage.currentUser.token,
                'start_date': report.start_date ? moment(report.start_date).format() : null,
                'end_date': report.end_date ? moment(report.end_date).format() : null,
                'base_id': report && report.filters.base ? report.filters.base.id : null,
                'district_id': report && report.filters.district ? report.filters.district.id : null,
                'branch_id': report && report.filters.branch ? report.filters.branch.id : null
            };
            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
        Checks in the preset template if a checkbox is being selected
         */
        function presetIsSelected(item) {
            if (vm.templateSelected && vm.template && vm.template.filters)
                return vm.template.filters['programs[]'].indexOf(item) > -1;
        }

        /*
        Function in preset template to select a checkbox filter
         */
        function presetSelectFilter(item, report) {
            var index = vm.template.filters['programs[]'].indexOf(item);
            if (index > -1) {
                vm.template.filters['programs[]'].splice(index, 1);
            } else {
                vm.template.filters['programs[]'].push(item);
            }
            vm.template.selectAllPrograms = false;

            var tempcsvobj = {
                'programs': vm.template.filters['programs[]'],
                'token': $localStorage.currentUser.token,
                'start_date': report.start_date ? moment(report.start_date).format() : null,
                'end_date': report.end_date ? moment(report.end_date).format() : null,
                'base_id': report && report.filters.base ? report.filters.base.id : null,
                'district_id': report && report.filters.district ? report.filters.district.id : null,
                'branch_id': report && report.filters.branch ? report.filters.branch.id : null
            };
            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
        Function to show preview of presets report
         */
        function presetShowPreview(report) {
            vm.template.programMessage = '';
            vm.template.dateRangeError = '';
            var htmlObj = {
                'programs': vm.template.filters['programs[]'],
                'start_date': report.start_date ? moment(report.start_date).format() : null,
                'end_date': report.end_date ? moment(report.end_date).format() : null,
                'base_id': report && report.filters.base ? report.filters.base.id : null,
                'district_id': report && report.filters.district ? report.filters.district.id : null,
                'branch_id': report && report.filters.branch ? report.filters.branch.id : null
            };

            if (vm.template.filters['programs[]'].length > 0) {
                $mdBottomSheet.show({
                    controller: 'ReportPreviewController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/transform/tabs/reports/bottom-sheets/report-preview/report-preview.html',
                    parent: '#transform-content-wrapper',
                    locals: {
                        preview: htmlObj,
                        csvUrl: vm.csvUrl
                    },
                    clickOutsideToClose: true,
                    disableBackdrop: true,
                    disableParentScroll: true
                });

                setTimeout(function() {
                    var parent = angular.element('#transform-content-wrapper');
                    parent.unbind('$md.dragstart')
                        .unbind('$md.drag')
                        .unbind('$md.dragend');
                }, 1000);
            } else {
                if (vm.template.filters['programs[]'].length < 1) {
                    vm.template.programMessage = 'Please select at least one program';
                }
            }
        }

        /*
        Function to open edit template modal
         */
        function editTemplate() {
            vm.template.programMessage = '';
            vm.template.dateRangeError = '';

            if (vm.template.filters['programs[]'].length > 0) {
                $mdDialog.show({
                    controller: 'EditReportTemplateDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/transform/tabs/reports/dialogs/edit-report-template/edit-report-template-dialog.html',
                    parent: angular.element($document.body),
                    locals: {
                        template: vm.template,
                        templates: vm.templates,
                        mode: 'thrive'
                    },
                    clickOutsideToClose: true
                });
            } else {
                if (vm.template.filters['programs[]'].length < 1) {
                    vm.template.programMessage = 'Please select at least one program';
                }
            }
        }

        /*
        Function to open delete template modal
         */
        function deleteTemplate() {
            $mdDialog.show({
                controller: 'DeleteReportTemplateDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    template: vm.template,
                    callback: function () {
                        getTemplates();
                        vm.newReport = true;
                    }
                },
                clickOutsideToClose: true
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.thrive')
        .controller('PastorsController', PastorsController);

    /** @ngInject */
    function PastorsController($stateParams,
        $state,
        $scope,
        $location,
        $mdDialog,
        $mdBottomSheet,
        $document,
        PastorService,
        Auth,
        BaseService) {

        var vm = this;

        var currentUser = Auth.getUser();
        vm.isAdmin = Boolean(currentUser && currentUser.roles && currentUser.$roles.has(["admin"]));
        vm.userCountry = currentUser ? currentUser.country_code : null;

        this.$state = $state;

        //Methods
        vm.initPastorsTable = initPastorsTable;
        vm.displayDroppedPastorsTable = displayDroppedPastorsTable;
        vm.resetFilters = resetFilters;
        vm.addNewPastor = addNewPastor;
        vm.editPastor = editPastor;
        vm.deletePastor = deletePastor;
        vm.permanentDeletePastor = permanentDeletePastor;
        vm.showPastorDetails = showPastorDetails;
        vm.selectSearch = selectSearch;
        vm.selectDistrict = selectDistrict;
        vm.selectBase = selectBase;
        vm.selectBranch = selectBranch;
        vm.restorePastor = restorePastor;
        vm.droppedPastorsPageChange = droppedPastorsPageChange;

        vm.pageChange = pageChange;
        vm.isLoading = true;
        vm.totals = {};
        vm.total_gold = 0;
        vm.total_silver = 0;
        vm.total_bronze = 0;
        vm.total_inactive = 0;
        vm.total_pastors = 0;
        // vm.restorePastors = restorePastors;

        vm.isLoading1 = false;
        vm.isLoading2 = false;

        vm.pastorsList = [];
        vm.droppedPastorsDetails = [];

        vm.bulkDeleteIDs = [];

        vm.bulkDelete = function (pastor) {
            if (vm.bulkDeleteIDs.includes(pastor.id)) {
                vm.bulkDeleteIDs = vm.bulkDeleteIDs.filter((_id) => _id !== pastor.id)
            } else {
                vm.bulkDeleteIDs.push(pastor.id)
            }
        }

        vm.isChecked = function (pastor) {
            return vm.bulkDeleteIDs.includes(pastor.id)
        }

        vm.issuesDialog = issuesDialog;

        var _parent = $scope;
        _parent.$parent.vm.currentTab = 2;

        refreshTables();

        /*
        Function that fetches districts, bases, and pastors with filters
         */
        function refreshTables() {

            vm.filters = {
                base: 'all',
                branch: 'all',
                district: 'all'
            };

            var data;
            if (localStorage.getItem('pastorslist')) {
                data = JSON.parse(localStorage.getItem('pastorslist'));

                vm.filters.search = data && data.search ? data.search : null;
                vm.filters.base = data && data.base ? data.base : null;
                vm.filters.branch = data && data.branch ? data.branch : null;
            }
            getBases(data);
            initPastorsTable(data);
            displayDroppedPastorsTable(data);

        }

        /*
        Function that get the totals based on filter
         */
        function getTotals(data) {
            var params = {};
            params.base_id = data && data.base ? data.base.id : (currentUser.base_id || null);
            params.branch_id = data && data.branch ? data.branch.id : (currentUser.branch_id || null);

            PastorService.getTotals(params).then(function (response) {
                vm.totals.gold = response.total_gold;
                vm.totals.silver = response.total_silver;
                vm.totals.bronze = response.total_bronze;
                vm.totals.inactive = response.total_inactive;
            })
        }

        // Function that populates pastor table

        function initPastorsTable(filters) {
            vm.isLoading1 = true;
            filters = filters || {};
            var params = {};
            if ($stateParams.district_id) {
                filters.district = $stateParams.district_id;
            }
            if (filters.district !== "all") {
                params.district_id = filters.district ? filters.district : null;
            }


            params.limit = 10;
            params.check_status = 1;
            params.page = filters.page || 1;
            params.base_id = filters.base ? filters.base.id : currentUser.base_id || null;
            params.branch_id = filters.branch ? filters.branch.id : currentUser.branch_id || null;
            params.search = filters.search || null;
            if (!vm.isAdmin && vm.userCountry) {
                params.country_code = vm.userCountry;
            }

            params.with = "base.districts,base.branches,district.base,province,city,barangay,applications";
            params.sort = "lastname:asc";


            vm.total_gold = "loading..";
            vm.total_silver = "loading..";
            vm.total_bronze = "loading..";
            vm.total_inactive = "loading..";
            vm.total_pastors = "loading..";
            PastorService.getPastors(params)
                .then(function (data) {
                    vm.isLoading1 = false;
                    vm.pastorsList = data;


                    var filters = angular.copy(params);
                    filters.with = '';
                    filters.limit = 1;

                    if (params.base_id !== 11) {
                        filters.exclude_base = 11; // exclude manila base
                    }
                    PastorService.getTotals(filters).then(function (results) {  //  where data is api response value and
                        vm.total_pastors = results.data.active; // we call getTotal funtion to get api response
                        vm.total_gold = results.data.gold;
                        vm.total_silver = results.data.silver;
                        vm.total_bronze = results.data.bronze;
                        vm.total_inactive = results.data.inactive;

                        // filters.member_status = 'gold';   // this code is calling multitime same api
                        // PastorService.getTotals(filters).then(function (gold) {
                        //     vm.total_gold = gold.data.gold;
                        //     filters.member_status = 'silver';
                        //     PastorService.getTotals(filters).then(function (silver) {
                        //         vm.total_silver = silver.data.silver;;

                        //         filters.member_status = 'bronze';
                        //         PastorService.getTotals(filters).then(function (bronze) {
                        //             vm.total_bronze = bronze.data.bronze;;

                        //             filters.member_status = 'inactive';
                        //             PastorService.getTotals(filters).then(function (inactive) {
                        //                 vm.total_inactive = inactive.data.inactive;
                        //             });
                        //         });
                        //     });
                        // });//
                    })
                });
        }

        // });

        /*
Function to open issuesDialog
 */
        function issuesDialog(pastor) {
            if (currentUser.$roles.has(['admin', 'metrics', 'pastor_coordinator', 'branch_head'])) {
                $mdDialog.show({
                    controller: 'issuesDeleteParticipantDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/transform/dialogs/issue-dialog/issues-dialog.html',
                    parent: angular.element($document.body),
                    locals: {
                        participant: null,
                        pastor: pastor || null,
                        application: null,
                        callback: refreshTables
                    },
                    clickOutsideToClose: true
                });
            }
        }

        // Function that populates pastor table
        // Changes
        function displayDroppedPastorsTable(filters) {
            vm.isLoading2 = true;
            filters = filters || {};
            var params = {};

            if (filters.district !== 'all') {
                params.district_id = filters.district ? filters.district : null;
            }

            if ($stateParams.district_id) {
                filters.district = $stateParams.district_id;
            }

            params.limit = 10;
            params.check_status = 1;
            params.trashed = 1;
            params.page = filters.page || 1;
            params.base_id = filters.base ? filters.base.id : currentUser.base_id || null;
            params.branch_id = filters.branch ? filters.branch.id : currentUser.branch_id || null;
            params.search = filters.search || null;

            if (!vm.isAdmin && vm.userCountry) {
                params.country_code = vm.userCountry;
            }

            params.with = "base.districts,base.branches,district.base,province,city,barangay,applications";
            params.sort = "lastname:asc";

            // vm.total_gold = "loading..";
            // vm.total_silver = "loading..";
            // vm.total_bronze = "loading..";
            // vm.total_inactive = "loading..";
            // vm.total_pastors = "loading..";
            PastorService.getPastors(params)
                .then(function (data) {
                    vm.isLoading2 = false;
                    vm.droppedPastorsDetails = data;

                    vm.droppedPastorsDetails.data = data.data.map(function (d) {
                        d.deleted_at = d.deleted_at.split(' ')[0];
                        return d;
                    });

                    // var filters = angular.copy(params);
                    // filters.with = '';
                    // filters.limit = 1;
                    // filters.search = 1;

                    // if (params.base_id !== 11) {
                    //     filters.exclude_base = 11; // exclude manila base
                    // }

                    // PastorService.getPastors(filters).then(function (results) {
                    //     vm.total_pastors = results.total;

                    //     filters.member_status = 'gold';
                    //     PastorService.getPastors(filters).then(function (gold) {
                    //         vm.total_gold = gold.total;

                    //         filters.member_status = 'silver';
                    //         PastorService.getPastors(filters).then(function (silver) {
                    //             vm.total_silver = silver.total;

                    //             filters.member_status = 'bronze';
                    //             PastorService.getPastors(filters).then(function (bronze) {
                    //                 vm.total_bronze = bronze.total;

                    //                 filters.member_status = 'inactive';
                    //                 PastorService.getPastors(filters).then(function (inactive) {
                    //                     vm.total_inactive = inactive.total;
                    //                 });
                    //             });
                    //         });
                    //     });
                    // });
                });
        }

        /*
        Function that fetches districts
         */
        function initDistricts(filters) {
            vm.isLoading1 = true;
            var params = {
                nopage: 1,
                base_id: filters && filters.base ? filters.base.id : currentUser.base_id ? currentUser.base_id : null
            };

            params.nopage = 1;
            if ($stateParams.base_id) {
                params.base_id = $stateParams.base_id;
            }

            params.with = 'base,branch,base.branches';
            DistrictService.queryDistricts(params)
                .then(function (data) {
                    vm.districts = data;
                    if ($stateParams.district_id) {
                        data.forEach(function (item) {
                            if (item.id == $stateParams.district_id) {
                                vm.filters.district = item.id;
                                vm.filters.base = item.base;
                                vm.filters.branch = item.branch;
                            }
                        });
                    } else {
                        var district = filters && filters.district ? filters.district : 'all';

                        if (params.base_id) {
                            vm.filters.district = 'all';
                            data.forEach(function (item) {
                                if (item.base_id == params.base_id && item.id == district) {
                                    vm.filters.district = item.id;
                                }
                            });
                        } else {
                            vm.filters.district = district;
                        }
                    }
                    initPastorsTable();
                })
        }

        /*
        Function that fetches all bases if user has no base id
         */
        function getBases(data) {
            var params = {
                nopage: true,
                base_id: currentUser.base_id,
                with: 'branches'
            };

            if (!vm.isAdmin && vm.userCountry) {
                params.country_code = vm.userCountry;
            }

            BaseService.getBases(params).then(function (response) {
                var base = response[0];

                vm.bases = response;

                if (currentUser.base_id) {
                    vm.filters.base = base;
                } else {
                    vm.filters.base = data && data.base ? data.base : 'all';
                }

                if (currentUser.branch_id) {
                    base.branches = base.branches.filter(function (item) {
                        return item.id == currentUser.branch_id;
                    })
                    vm.filters.base = base;

                    vm.filters.branch = base.branches.filter(function (item) {
                        return item.id == currentUser.branch_id;
                    }).shift();
                } else {
                    vm.filters.branch = data && data.branch ? data.branch : 'all';
                }
            });
        }


        /*
        Function that selects district filter
         */
        // Here write the code  
        function selectDistrict(data) {
            $stateParams = {};
            initPastorsTable(data);
            displayDroppedPastorsTable(data);
            localStorage.setItem('pastorslist', JSON.stringify(data));
        }

        /*
        Function that selects base filter
         */
        function selectBase(data) {
            localStorage.setItem('pastorslist', JSON.stringify(data));
            $stateParams = {};
            vm.filters.branch = 'all';
            vm.filters.district = 'all';
            data.page = 1;
            initPastorsTable(data);
            displayDroppedPastorsTable(data);
            initDistricts(data);
        }

        /*
        Function that selects branch filter
         */
        function selectBranch(data) {
            data.page = 1;
            initPastorsTable(data);
            displayDroppedPastorsTable(data);
            localStorage.setItem('pastorslist', JSON.stringify(data));
        }

        /*
      Function used to display all pastors and dropped pastors based on search text
       */
        function selectSearch(data) {
            if (data.search.length != 0 && data.search.length != null) {
                if (data.search.length >= 2) {
                    initPastorsTable(data);
                    displayDroppedPastorsTable(data);
                    localStorage.setItem('pastorslist', JSON.stringify(data));
                }
            }
            if (data.search.length == 0 || data.search.length == null) {
                // getTotals(data);
                displayDroppedPastorsTable(data);
                initPastorsTable(data);
            }
        }

        /*
        Function that reset all selected filters
         */
        function resetFilters() {
            if (!currentUser.base_id) {
                vm.filters = {
                    base: 'all',
                    branch: 'all',
                    district: 'all',
                    search: ''
                };
            } else {
                if (!currentUser.branch_id) {
                    vm.filters.branch = 'all';
                    vm.filters.search = '';
                    vm.filters.district = 'all';
                } else {
                    vm.filters.search = '';
                    vm.filters.district = 'all';
                }
            }
            $location.url($location.path());
            localStorage.setItem('pastorslist', JSON.stringify(vm.filters));
            initPastorsTable();
            // getTotals();
        }

        /*
        Function triggered when changing pagination page
         */
        function pageChange(page, filters) {
            filters.page = page;
            var data = filters;
            initPastorsTable(data);
            localStorage.setItem('pastorslist', JSON.stringify(data));
            // console.log(data);
        }

        /*
       Function triggered when pagination in pastors dropped list changes
        */
        function droppedPastorsPageChange(page, filters) {
            filters.page = page;
            var data = filters;
            displayDroppedPastorsTable(data);
            localStorage.setItem('pastorslist', JSON.stringify(data));
        }

        /*
        Function that adds new pastor
         */
        function addNewPastor(pastors) {
            $mdDialog.show({
                controller: 'NewPastorDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/thrive/tabs/pastors/dialogs/new-pastor/new-pastor-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    pastorsObj: pastors || null,
                    callback: function () {
                        initPastorsTable(vm.filters);
                    }
                },
                clickOutsideToClose: true
            });
        }


        /*
        Function that edit pastor
         */
        function editPastor(pastor) {
            showEditPastorDialog(pastor);
        }

        /*
        Function that deletes pastor
         */
        function deletePastor(pastor) {
            if (vm.bulkDeleteIDs.length && !Array.isArray(pastor)) {
                return;
            }

            $mdDialog.show({
                controller: 'DeletePastorDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/thrive/tabs/pastors/dialogs/delete-pastor/delete-pastor-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    pastor: pastor,
                    callback: function () {
                        getTotals(vm.filters);
                        initPastorsTable(vm.filters);
                        displayDroppedPastorsTable(vm.filters);
                        vm.bulkDeleteIDs = [];
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
       Function used to permanently delete a savings group
        */
        function permanentDeletePastor(pastorDelete) {
            $mdDialog.show({
                controller: 'PermanentDeletePastorDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    callback: function () {
                        PastorService.permanentDeletePastor(pastorDelete).then(function () {
                            getTotals(vm.filters);
                            initPastorsTable(vm.filters);
                            displayDroppedPastorsTable(vm.filters);
                        });
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that show edit pastor dialog
         */
        function showEditPastorDialog(pastor) {
            $mdDialog.show({
                controller: 'EditPastorDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/thrive/tabs/pastors/dialogs/edit-pastor/edit-pastor-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    pastor: pastor,
                    initPastorsTable: function () {
                        initPastorsTable(vm.filters);
                    }
                },
                clickOutsideToClose: true

            });
        }

        /*
        Function used to restore a dropped pastor
         */
        function restorePastor(pastorRestore) {
            PastorService.restorePastor(pastorRestore).then(function () {
                getTotals(vm.filters);
                initPastorsTable(vm.filters);
                displayDroppedPastorsTable(vm.filters);
            })
        }

        /*
        Function that shows pastor details in bottom sheet
         */
        function showPastorDetails(pastor) {
            if ($state.current.name !== "app.thrive.pastors.details") {
                $state.go("app.thrive.pastors.details", { id: pastor.id }, false);
            }
            $mdBottomSheet.show({
                controller: 'PastorDetailsController',
                controllerAs: 'vm',
                templateUrl: 'app/main/thrive/tabs/pastors/bottom-sheets/pastor-details/pastor-details.html',
                clickOutsideToClose: false,
                disableBackdrop: false,
                disableParentScroll: false,
                locals: {
                    initPastorsTable: initPastorsTable,
                    pastor: pastor.id,
                    parentVm: vm
                }
            }).then(handleParticipantCloseEvent.bind(vm))
                .catch(handleParticipantsError.bind(vm));

            setTimeout(function () {
                var parent = angular.element('#transform-content-wrapper');
                parent.unbind('$md.dragstart')
                    .unbind('$md.drag')
                    .unbind('$md.dragend');
            }, 1000);
        }

        //checks if the state is in pastor details, will open bottom sheet
        if ($state.current.name == "app.thrive.pastors.details") {
            PastorService.getPastors($state.params.id).then(function (pastor) {
                showPastorDetails(pastor);
            }).catch(handleParticipantsError.bind(vm));
        }

        /*
        Function that handles pastor details bottom sheet close event
         */
        function handleParticipantCloseEvent() {
            if ($state.current.name === 'app.thrive.pastors.details') {
                $('.content-white-holder').removeClass('bcopen');
                this.$state.go("app.thrive.pastors");
            }
        }

        /*
        Function that handles bottom sheet error
         */
        function handleParticipantsError(err) {
            $('.content-white-holder').removeClass('bcopen');
            this.$state.go("app.thrive.pastors");
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.thrive')
        .controller('DistrictsController', DistrictsController);

    /** @ngInject */
    function DistrictsController($state,
        BaseService,
        DistrictService,
        $scope,
        $mdDialog,
        PastorService,
        $document,
        Auth) {
        var vm = this;
        var currentUser = Auth.getUser();

        var _parent = $scope;
        _parent.$parent.vm.currentTab = 1;

        vm.filters = {
            base: 'all',
            branches: []
        };
        vm.districts = [];

        //Methods
        vm.addDistrict = addDistrict;
        vm.editDistrict = editDistrict;
        vm.deleteDistrict = deleteDistrict;
        vm.filterByBase = filterByBase;
        vm.filterByBranch = filterByBranch;
        vm.pageChange = pageChange;
        vm.goToPastors = goToPastors;

        //triggers first upon load
        activate();

        /*
        Function used to fetch pastors, districts, and bases
         */
        function activate() {
            vm.filters = {
                base: 'all',
                branch: 'all'
            };

            var data;
            if (localStorage.getItem('districts')) {
                data = JSON.parse(localStorage.getItem('districts'));
            }
            getPastors(data);
            drawDistrictsTable(data);
            getBases(data);
        }

        /*
        Function used to get all bases
         */
        function getBases(data) {
            BaseService.getBases({
                nopage: true,
                with: 'branches',
                base_id: currentUser.base_id
            }).then(function (response) {
                var base = response[0];

                vm.bases = response;

                if (currentUser.base_id) {
                    vm.filters.base = base;
                } else {
                    vm.filters.base = data && data.base ? data.base : 'all';
                }

                if (currentUser.branch_id) {
                    vm.filters.branch = base.branches.filter(function (item) {
                        return item.id == currentUser.branch_id;
                    }).shift();
                } else {
                    vm.filters.branch = data && data.branch ? data.branch : 'all';
                }
            });
        }

        function getPastors(data) {
            var params = {};
            params.limit = 1;

            if (data && data.base) {
                params.base_id = data.base.id;
            } else if (currentUser.base_id) {
                params.base_id = currentUser.base_id;
            }

            if (data && data.branch) {
                params.branch_id = data.branch.id;
            } else if (currentUser.branch_id) {
                params.branch_id = currentUser.branch_id;
            }

            PastorService.getPastors(params).then(function (pastors) {
                vm.pastors = pastors;
            });
        }

        /*
        Function triggered when district row is clicked and redirects to pastors page with default filters
         */
        function goToPastors(district) {
            $state.go('app.thrive.pastors', {
                district_id: district.id,
                base_id: district.base_id
            });
        }

        /*
        Function used to get all districts depending upon the selected base
         */
        function filterByBase(data) {
            vm.filters.branch = 'all';
            getPastors(vm.filters);
            drawDistrictsTable(data);
            localStorage.setItem('districts', JSON.stringify(data));
        }

        /*
        Function used to get all districts depending upon the selected base
         */
        function filterByBranch(data) {
            getPastors(vm.filters);
            drawDistrictsTable(data);
            localStorage.setItem('districts', JSON.stringify(data));
        }

        /*
        Function used to populate districts table
         */
        function drawDistrictsTable(data) {
            vm.districts = [];
            var data = data || {};
            var params = {};

            params.limit = 10;
            params.page = data.page || 1;
            params.sort = 'id:asc,name:asc';
            params.base_id = data.base ? data.base.id : (currentUser.base_id || null);
            params.branch_id = data.branch ? data.branch.id : (currentUser.branch_id || null);
            params.with = 'base,branch';
            vm.isLoading1 = true;
            DistrictService.getDistricts(params).then(function (data) {
                vm.isLoading1 = false;
                vm.districts = data;
            });
        }

        /*
        Function used to show modal when adding new district
         */
        function addDistrict() {
            $mdDialog.show({
                controller: 'NewDistrictDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/thrive/tabs/districts/dialogs/add-district/add-district-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    drawDistrictsTable: function () {
                        pageChange(vm.districts.current_page, vm.filters);
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to show modal for edit district
         */
        function editDistrict(district) {
            $mdDialog.show({
                controller: 'EditDistrictDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/thrive/tabs/districts/dialogs/edit-district/edit-district-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    district: district,
                    drawDistrictsTable: function () {
                        pageChange(vm.districts.current_page, vm.filters);
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to show modal for delete distrct
         */
        function deleteDistrict(district) {
            $mdDialog.show({
                controller: 'DeleteDistrictDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    district: district,
                    drawDistrictsTable: function () {
                        pageChange(vm.districts.current_page, vm.filters);
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that handles page change for pagination
         */
        function pageChange(page, filters) {
            filters.page = page;
            var data = filters;
            drawDistrictsTable(data);
            localStorage.setItem('districts', JSON.stringify(data));
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.thrive')
        .controller('ChurchesController', ChurchesController);

    /** @ngInject */
    function ChurchesController($mdBottomSheet,
        $timeout,
        $scope,
        $state,
        $mdDialog,
        $document,
        ChurchService,
        ProvinceService,
        CityService,
        BarangayService,
        ChurchAffiliationService,
        Auth,
        BaseService) {
        var vm = this;

        var currentUser = Auth.getUser();
        vm.isAdmin = Boolean(currentUser && currentUser.roles && currentUser.$roles.has(["admin"]));
        vm.userCountry = currentUser ? currentUser.country_code : null;

        vm.church = {};
        vm.filters = {};

        this.$state = $state;

        //Methods
        vm.initChurchesTable = initChurchesTable;
        vm.addNewChurch = addNewChurch;
        vm.editChurch = editChurch;
        vm.deleteChurch = deleteChurch;
        vm.restoreChurch = restoreChurch;
        vm.permanentDeleteChurch = permanentDeleteChurch;
        vm.showChurchDetails = showChurchDetails;
        vm.selectBase = selectBase;
        vm.searchProvinces = searchProvinces;
        vm.selectProvince = selectProvince;
        vm.searchCities = searchCities;
        vm.selectCity = selectCity;
        vm.searchBarangays = searchBarangays;
        vm.selectBarangay = selectBarangay;
        vm.searchDenominations = searchDenominations;
        vm.selectDenomination = selectDenomination;
        vm.resetFilters = resetFilters;
        vm.selectSearch = selectSearch;

        vm.isLoading = true;
        vm.pageChange = pageChange;
        vm.droppedChurchesPageChange = droppedChurchesPageChange;

        var _parent = $scope;
        _parent.$parent.vm.currentTab = 3;

        refreshTables();

        vm.bulkDeleteIDs = [];

        vm.bulkDelete = function (church) {
            if (vm.bulkDeleteIDs.includes(church.id)) {
                vm.bulkDeleteIDs = vm.bulkDeleteIDs.filter((_id) => _id !== church.id)
            } else {
                vm.bulkDeleteIDs.push(church.id)
            }
        }

        vm.isChecked = function (church) {
            return vm.bulkDeleteIDs.includes(church.id)
        }

        /*
        Fucnction that populate church table with a preset filters
         */
        function refreshTables() {
            vm.filters = {
                search: null
            };

            var data;
            if (localStorage.getItem('churches')) {
                data = JSON.parse(localStorage.getItem('churches'));
                vm.filters.search = data.search;
                vm.filters.page = data && data.page ? data.page : 1;
                $timeout(function () {
                    vm.selectedDenomination = data.denomination;
                    vm.selectedProvince = data.province;
                    vm.selectedCity = data.city;
                    vm.selectedBarangay = data.barangay;
                    vm.filters.base = data.base;
                    if (data.base) {
                        vm.filters.base_id = data.base.id;
                    }
                }, 200);
            }
            getBases(data);
            initChurchesTable(data);
            initDropedChurchesTable(data);
        }

        /*
        Function that populates church table
         */
        function initChurchesTable(filters) {
            var filters = filters || vm.filters;
            var params = {};

            params.base_id = filters.base_id;
            params.denomination_id = filters.denomination_id;
            params.province_id = filters.province_id;
            params.city_id = filters.city_id;
            params.barangay_id = filters.barangay_id;
            params.search = filters.search || null;
            params.page = filters.page || 1;
            params.sort = 'id:asc';
            params.with = 'denomination,province,city,barangay,participants,affiliation';

            if (currentUser.branch_id) {
                params.branch_id = currentUser.branch_id;
            }

            if (currentUser.base_id) {
                params.base_id = currentUser.base_id;
            }

            if (!vm.isAdmin && vm.userCountry) {
                params.country_code = vm.userCountry;
            }

            vm.isLoading = true;
            ChurchService.getChurches(params)
                .then(function (churches) {
                    vm.isLoading = false;
                    vm.churches = churches;
                });
        }

        /*
        Function that populates droped church table
         */
        function initDropedChurchesTable(filters) {
            var filters = filters || vm.filters;
            var params = {};

            params.denomination_id = filters.denomination_id;
            params.province_id = filters.province_id;
            params.city_id = filters.city_id;
            params.barangay_id = filters.barangay_id;
            params.search = filters.search || null;
            params.page = filters.page || 1;
            params.trashed = 1;
            params.sort = 'id:asc';
            params.with = 'denomination,province,city,barangay,participants,affiliation';

            if (currentUser.branch_id) {
                params.branch_id = currentUser.branch_id;
            }

            if (currentUser.base_id) {
                params.base_id = currentUser.base_id;
            }

            if (!vm.isAdmin && vm.userCountry) {
                params.country_code = vm.userCountry;
            }

            vm.isDropedChurchesLoading = true;
            ChurchService.getChurches(params)
                .then(function (churches) {
                    vm.isDropedChurchesLoading = false;
                    vm.dropedChurches = churches;
                });
        }

        /*
        Function used to filter church table by search text
         */
        function selectSearch(data) {
            initChurchesTable(data);
            initDropedChurchesTable(data);
            localStorage.setItem('churches', JSON.stringify(data));
        }

        //search denomination
        vm.selectedDenomination = null;
        vm.searchDenomination = null;

        /*
        Function used to search denominations by search text
         */
        function searchDenominations(name) {
            return ChurchAffiliationService.getChurchAffiliations({
                search: name
            }).then(function (response) {
                return response.data;
            });
        }

        /*
        Function used to assign a denomination
         */
        function selectDenomination(denomination) {
            if (denomination) {
                vm.filters.denomination_id = denomination.id;
            } else {
                vm.filters.denomination_id = null;
            }
            vm.filters.denomination = vm.selectedDenomination;
            initChurchesTable(vm.filters);
            localStorage.setItem('churches', JSON.stringify(vm.filters));
        }

        function getBases(data) {
            BaseService.getBases({
                nopage: true,
                base_id: currentUser.base_id,
                with: 'branches'
            }).then(function (response) {
                var base = response[0];

                vm.bases = response;

                if (currentUser.base_id) {
                    vm.filters.base = base;
                    vm.filters.base_id = base.id;
                } else {
                    vm.filters.base = data && data.base ? data.base : 'all';
                }
            });
        }

        function selectBase(data) {
            vm.filters.base = data.base;
            vm.filters.base_id = data.base.id;
            vm.selectedProvince = null;
            vm.church.province_id = null;
            localStorage.setItem('churches', JSON.stringify(vm.filters));
            initChurchesTable(vm.filters);
        }

        // search province
        vm.selectedProvince = null;
        vm.searchProvince = null;

        function searchProvinces(name) {
            var searchParams = { base_id: vm.filters.base_id, search: name };

            if (currentUser) {
                searchParams.branch_id = currentUser.branch_id;
            }

            return ProvinceService.getProvinces(searchParams)
                .then(function (response) {
                    return response.data;
                });
        }

        /*
        Function triggered when clearing filters
         */
        function resetFilters() {
            if (!currentUser.base_id) {
                vm.filters = {}
            }
            vm.searchDenomination = null;
            vm.searchProvince = null;
            vm.searchCity = null;
            vm.searchBarangay = null;
            vm.selectedDenomination = null;
            vm.selectedProvince = null;
            vm.selectedCity = null;
            vm.selectedBarangay = null;
            vm.church = {};
            localStorage.removeItem('churches');
            getBases();
            initChurchesTable();
            initDropedChurchesTable();
        }

        /*
        Function used to assign a province
         */
        function selectProvince(province) {
            if (province) {
                vm.filters.province_id = province.id;
                vm.church.province_id = province.id;
                vm.church.city_id = null;
                vm.church.barangay_id = null;
            } else {
                vm.filters.province_id = null;
                vm.selectedCity = null;
                vm.selectedBarangay = null;
                vm.church.city_id = null;
                vm.church.barangay_id = null;
            }
            vm.filters.province = vm.selectedProvince;
            initChurchesTable(vm.filters);
            localStorage.setItem('churches', JSON.stringify(vm.filters));
        }

        // search city
        vm.selectedCity = null;
        vm.searchCity = null;

        function searchCities(name) {
            var cityParams = {
                province_id: vm.church.province_id,
                search: name
            };

            if (currentUser.branch_id) {
                cityParams.branch_id = currentUser.branch_id;
            }

            return CityService.getCities(cityParams)
                .then(function (response) {
                    return response.data;
                });
        }

        /*
        Function used to assign to a city
         */
        function selectCity(city) {
            if (city) {
                vm.filters.city_id = city.id;
                vm.church.city_id = city.id;
                vm.church.barangay_id = null;
            } else {
                vm.filters.city_id = null;
                vm.selectedBarangay = null;
                vm.church.barangay_id = null;
            }
            vm.filters.city = vm.selectedCity;
            initChurchesTable(vm.filters);
            localStorage.setItem('churches', JSON.stringify(vm.filters));
        }

        // search barangay
        vm.selectedBarangay = null;
        vm.searchBarangay = null;

        /*
        Function used to search barangays by search text
         */
        function searchBarangays(name) {
            return BarangayService.getBarangays({
                city_id: vm.church.city_id,
                search: name
            });
        }

        /*
        Function used to assign to a barangay
         */
        function selectBarangay(barangay) {
            if (barangay) {
                vm.filters.barangay_id = barangay.id;
                vm.church.barangay_id = barangay.id;
            } else {
                vm.filters.barangay_id = null;
            }
            vm.filters.barangay = vm.selectedBarangay;
            initChurchesTable(vm.filters);
            localStorage.setItem('churches', JSON.stringify(vm.filters));
        }

        /*
        Function triggered when pagination changes page
         */
        function pageChange(page, filters) {
            filters.page = page;
            var data = filters;
            initChurchesTable(data);
            localStorage.setItem('churches', JSON.stringify(data));
        }

        /*
       Function triggered when pagination in churches dropped list changes
        */
        function droppedChurchesPageChange(page, filters) {
            filters.page = page;
            var data = filters;
            initDropedChurchesTable(data);
            localStorage.setItem('churches', JSON.stringify(data));
        }

        /*
        Function used to add new church
         */
        function addNewChurch() {
            showNewChurchDialog();
        }

        /*
        Function used to edit church
         */
        function editChurch(church) {
            showEditChurchDialog(church);
        }

        /*
        Function used to delete church
         */
        function deleteChurch(church) {

            if (vm.bulkDeleteIDs.length && !Array.isArray(church)) {
                return;
            }

            showDeleteChurchDialog(church);
        }

        /*
        Function used to show delete church dialog
         */
        function showDeleteChurchDialog(church) {
            $mdDialog.show({
                controller: 'DeleteChurchDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/thrive/tabs/churches/dialogs/delete-church/delete-church-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    church: church,
                    hardDelete: false,
                    callback: () => {
                        refreshTables();
                        vm.bulkDeleteIDs = [];
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to restore a dropped church
        */
        function restoreChurch(churchRestore) {
            ChurchService.restoreChurch(churchRestore).then(function () {
                initChurchesTable();
                initDropedChurchesTable();
            })
        }

        /*
       Function used to permanently delete a church
        */
        function permanentDeleteChurch(church) {
            $mdDialog.show({
                controller: 'DeleteChurchDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    church: church,
                    hardDelete: true,
                    initChurchesTable: refreshTables
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function to display church details bottom sheet
         */
        function showChurchDetails(church) {
            if ($state.current.name !== "app.thrive.churches.details") {
                $state.transitionTo("app.thrive.churches.details", { id: church.id }, false);
            }
            $mdBottomSheet.show({
                controller: 'ChurchDetailsController',
                controllerAs: 'vm',
                templateUrl: 'app/main/thrive/tabs/churches/bottom-sheets/church-details/church-details.html',
                parent: '#transform-content-wrapper',
                clickOutsideToClose: true,
                disableBackdrop: true,
                disableParentScroll: true,
                locals: {
                    churchObj: church,
                    initChurchesTable: initChurchesTable
                }
            }).then(handleChurchCloseEvent.bind(vm))
                .catch(handleChurchError.bind(vm));

            setTimeout(function () {
                var parent = angular.element('#transform-content-wrapper');
                parent.unbind('$md.dragstart')
                    .unbind('$md.drag')
                    .unbind('$md.dragend');
            }, 1000);
        }

        /*
        Checks if the state is on church details, it will open church details bottom sheet
         */
        if ($state.current.name == "app.thrive.churches.details") {
            var params = {};
            params.with = 'denomination,province,city,barangay,participants,affiliation';
            ChurchService.getChurch($state.params.id, params).then(function (church) {
                showChurchDetails(church);
            }).catch(handleChurchError.bind(vm));
        }

        /*
        Function that handles church details bottom sheet close event
         */
        function handleChurchCloseEvent() {
            if ($state.current.name === 'app.thrive.churches.details') {
                $('.content-white-holder').removeClass('bcopen');
                this.$state.go("app.thrive.churches");
            }
        }

        /*
        Function that handles church details bottom sheet error
         */
        function handleChurchError(err) {
            $('.content-white-holder').removeClass('bcopen');
            this.$state.go("app.thrive.churches");
        }

        /*
        Function triggered to pop up edit church modal
         */
        function showEditChurchDialog(church) {
            $mdDialog.show({
                controller: 'EditChurchDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/thrive/tabs/churches/dialogs/edit-church/edit-church-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    church: church,
                    initChurchesTable: initChurchesTable
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function triggered to pop up new church modal
         */
        function showNewChurchDialog() {
            $mdDialog.show({
                controller: 'NewChurchDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/thrive/tabs/churches/dialogs/new-church/new-church-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    initChurchesTable: initChurchesTable
                },
                clickOutsideToClose: true
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.thrive')
        .controller('DataCardController', DataCardController);

    /** @ngInject */
    function DataCardController(PastorService, $scope, DataCardService, BaseService, $element) {

        var vm = this;

        var _parent = $scope;
        _parent.$parent.vm.currentTab = 0;


        //Methods
        vm.addNewThriveCard = addNewThriveCard;
        vm.resetForm = resetForm;
        vm.selectPastor = selectPastor;
        vm.selectgroupleader = selectgroupleader
        vm.searchPastors = searchPastors;

        vm.searchgroupleader = searchgroupleader;

        vm.isLoading1 = false;
        vm.pastor = {};
        vm.educational_attainment = []

        setDefaultValues();

        /*
        Function to save thrive card
         */
        function addNewThriveCard(thrive, form) {
            // console.log(vm.thrive.group_leader_id);
            thrive.group_leader = vm.thrive.group_leader_id === "0" || vm.thrive.group_leader_id === "1" ? parseInt(vm.thrive.group_leader_id) : vm.thrive.group_leader_id;
            console.log(thrive.group_leader)
            // thrive.group_leader_id = vm.group_leader_id?.id ? 0 : vm.selectedPastor?.id;
            thrive.is_meeting = thrive.is_meeting ? true : false;
            thrive.is_training = thrive.is_training ? true : false;
            thrive.attended_at = moment(thrive.attended_at).format();
            thrive.no_of_timothy = thrive.no_of_timothy || 0;
            thrive.adults_last_sunday = thrive.adults_last_sunday || 0;
            thrive.kids_last_sunday = thrive.kids_last_sunday || 0;
            thrive.offerings_last_sunday = thrive.offerings_last_sunday || 0;

            vm.saving = true;
            DataCardService.addDataCard(thrive).then(function () {
                vm.saving = false;
                form.$setUntouched();
                form.$setPristine();
                setDefaultValues();
            }
            )
                .catch(function (response) {
                    form.$invalid = true;
                    vm.saving = false;

                    for (var field in response.data.errors) {
                        vm.apiErrors[field] = response.data.errors[field].shift();
                    }
                });
        }

        function addFacilitator(thrives) {
            thrives.group_leader = vm.group_leader ? 1 : 0;
            // thrives.group_leader_id = vm.group_leader_id.id;

            PastorService.editPastorlist(thrives).then(function () {

                vm.pastor.group_leader = 1;
                // vm.pastor.group_leader_id = 1;
            })
        }
        function clickCountSelector() {
            console.log('hiii')
        }

        function checkGroupLeader() {
            vm.group_leader = !vm.pastor.group_leader;
            vm.pastor.group_leader = !vm.pastor.group_leader;
        }
        function UncheckGroupLeader() {
            vm.group_leader = !vm.pastor.group_leader;
            vm.pastor.group_leader = !vm.pastor.group_leader;
            vm.group_leader_id = !vm.pastor.group_leader_id;
            // vm.pastor.group_leader_id = !vm.pastor.group_leader_id;
        }

        /*
        Function used to reset data form
         */
        function resetForm(form, vm) {
            form.$setUntouched();
            form.$setPristine();

            vm.thrive = {};
            vm.selectedPastor = ''; pastor
            vm.selectedgroupleader = '';
        }

        /*
        Function that assigns pastor upon select in autocomplete
         */
        function selectPastor(pastor) {
            if (pastor) {
                vm.selectedPastor = pastor;
                vm.thrive.name = pastor.firstname + ' ' + pastor.lastname;
                vm.thrive.base = '(' + pastor.base.name + ') ' + pastor.district.name;
                vm.thrive.pastor_id = pastor.id;
                if (!pastor.group_leader) {
                    vm.thrive.group_leader_id = "0";

                } else if (pastor.group_leader && pastor.data_card_member === "") {
                    vm.thrive.group_leader_id = "1";
                }
                else {
                    vm.thrive.group_leader_id = "member";
                }
                searchgroupleader(pastor.district_id);
                searchSelectedpastor(pastor.id);
            }
        }

        // gl
        function selectgroupleader(group_leader) {
            if (group_leader) {
                vm.selectedgroupleader = group_leader;
                vm.thrive.name = group_leader.fullname;
                vm.selectedBaseName = group_leader.id;
            }
        }

        /*
        Function that queries pastors upon autocomplete
         */
        function searchPastors(query) {
            return PastorService.searchPastors({
                search: query,
                with: 'base,district',
                check_status: 1,
                page: 1,
                limit: 20
            });
        }

        // gl
        function searchgroupleader(group_leader) {

            PastorService.searchgroupleader({
                id: group_leader,
                with: 'base,district',
            }).then(function (response) {
                vm.selectedBaseName = response.groupleader;
                vm.selectedBaseNames = vm.selectedBaseName.filter(function (el) {
                    return el.firstname !== vm.selectedPastor.firstname;
                });
            });
        }

        /*
        Function that gets pastor details
         */
        function searchSelectedpastor(Selectedpastor) {
            vm.isLoading1 = true;
            var params = {
                with: 'base,province,city,barangay,contacts,district',
                check_status: 1
            };
            PastorService.getPastor(Selectedpastor, params).then(function (response) {
                vm.isLoading1 = false;
                vm.pastor = response;

                vm.pastor.contacts = vm.pastor.contacts.filter(function (item) {
                    if (item.contact_no) return item;
                });
                vm.educational_attainment.filter(function (item) {
                    if (item.value === vm.pastor.educational_attainment) {
                        vm.pastor.displayEducation_attainment = item;
                    }
                });
                BaseService.getBase(vm.pastor.base, {
                    nopage: 1,
                    with: "districts"
                })
                    .then(function (data) {
                        vm.pastor.base = data;
                    });
            }
            );
        }
        /*
        Set the default values for the thrive form
         */
        function setDefaultValues() {
            vm.thrive = {};
            vm.selectedgroupleader = '';
            vm.selectedPastor = '';
            vm.selectedBaseName = '';
            vm.thrive.attended_at = new Date;
            vm.thrive.is_meeting = true;
            vm.apiErrors = {};
        }
    }
})();

// vm.selectedgroupleader = '';
// vm.selectedPastor = '';
// vm.selectedBaseName = '';

(function () {
    'use strict';

    angular
        .module('app.thrivesettings')
        .service('MayorService', MayorService);

    /** @ngInject */
    function MayorService($http, api, helpers) {

        var service = {
            getMayors: getMayors,
            getMayor: getMayor,
            addMayor: addMayor,
            deleteMayor: deleteMayor,
            editMayor: editMayor
        };

        function getMayor(mayor, params) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'mayors/' + mayor.id,
                params: params
            };


            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getMayors(params) {
            var defaults = {
                sort: 'lastname:asc',
                limit: 10,
                page: 1
            };

            var params = $.extend({}, defaults, params);

            var promise = {
                method: 'GET',
                url: api.baseUrl + 'mayors',
                params: params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editMayor(mayor) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'mayors/' + mayor.id,
                data: mayor
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addMayor(mayor) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'mayors',
                data: mayor
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteMayor(mayor) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'mayors/' + mayor.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .service('DenominationService', DenominationService);

    /** @ngInject */
    function DenominationService($http, api, helpers) {

        var service = {
            getDenominations: getDenominations,
            addDenomination: addDenomination,
            deleteDenomination: deleteDenomination,
            editDenomination: editDenomination
        };

        function getDenominations(params) {
            var defaults = {
                sort: 'name:asc',
                limit: 10,
                page: 1
            };

            var params = $.extend({}, defaults, params);

            var promise = {
                method: 'GET',
                url: api.baseUrl + 'denominations',
                params: params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editDenomination(denomination) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'denominations/' + denomination.id,
                data: denomination
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addDenomination(denomination) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'denominations',
                data: denomination
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteDenomination(denomination) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'denominations/' + denomination.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.thrivesettings')
        .service('DataCardSettingsService', DataCardSettingsService);

    /** @ngInject */
    function DataCardSettingsService($http, api, helpers) {

        var service = {
            updateDataCard: updateDataCard,
        };

        function updateDataCard(data) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'users/updatePermission',
                data: data
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .service('ChurchAffiliationService', ChurchAffiliationService);

    /** @ngInject */
    function ChurchAffiliationService($http, api, helpers) {

        var service = {
            getChurchAffiliations: getChurchAffiliations,
            addChurchAffiliation: addChurchAffiliation,
            deleteChurchAffiliation: deleteChurchAffiliation,
            editChurchAffiliation: editChurchAffiliation
        };

        function getChurchAffiliations(params) {
            var defaults = {
                sort: 'name:asc',
                limit: 10,
                page: 1
            };

            var params = $.extend({}, defaults, params);

            var promise = {
                method: 'GET',
                url: api.baseUrl + 'church-affiliations',
                params: params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editChurchAffiliation(affiliation) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'church-affiliations/' + affiliation.id,
                data: affiliation
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addChurchAffiliation(affiliation) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'church-affiliations',
                data: affiliation
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteChurchAffiliation(affiliation) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'church-affiliations/' + affiliation.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.thrivesettings')
        .service('BaseService', BaseService);

    /** @ngInject */
    function BaseService($http, api, helpers) {

        var service = {
            getBases: getBases,
            getBase: getBase,
            addBase: addBase,
            deleteBase: deleteBase,
            editBase: editBase
        };

        function getBase(base, params) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'bases/' + base.id,
                params: params
            };


            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getBases(params) {
            var defaults = {
                sort: 'name:asc',
                limit: 10,
                page: 1
            };

            var params = $.extend({}, defaults, params);

            var promise = {
                method: 'GET',
                url: api.baseUrl + 'bases',
                params: params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editBase(base) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'bases/' + base.id,
                data: base
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addBase(base) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'bases',
                data: base
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteBase(base) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'bases/' + base.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .service('UserService', UserService);

    /** @ngInject */
    function UserService($http, api, helpers) {

        var service = {
            getUsers: getUsers,
            fetchUsers: fetchUsers,
            fetchActiveUsers: fetchActiveUsers,
            addUser: addUser,
            deleteUser: deleteUser,
            editUser: editUser,
            fetchTotalDownloads: fetchTotalDownloads,
            fetchUniqueUsers: fetchUniqueUsers,
        };

        function getUsers(page) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'users',
                params: {
                    sort: 'firstname:asc',
                    limit: 10,
                    page: page
                }
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function fetchUsers(params) {
            var payload = angular.extend({
                sort: 'firstname:asc',
                limit: 10,
                page: 1
            }, params);
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'users',
                params: payload
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function fetchActiveUsers(params) {
            var payload = angular.extend({
                limit: 10,
                page: 1
            }, params);
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'users/user_activities',
                params: payload
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function fetchTotalDownloads(params) {
            var payload = angular.extend({
                limit: 10,
                page: 1
            }, params);
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'users/get-app-info',
                params: payload
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function fetchUniqueUsers(params) {
            var payload = angular.extend({
                limit: 10,
                page: 1
            }, params);
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'users/unique-users',
                params: payload
            };
            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editUser(user) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'users/' + user.id,
                data: user
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addUser(user) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'users',
                data: user
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteUser(user) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'users/' + user.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }

        return service;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.settings')
        .service('ProgramService', ProgramService);

    /** @ngInject */
    function ProgramService($http, api, helpers) {

        var service = {
            getPrograms   : getPrograms,
            addProgram    : addProgram,
            deleteProgram : deleteProgram,
            editProgram   : editProgram
        };

        function getPrograms(params) {
            var defaults = {
                    sort  : 'name:asc',
                    limit : 10,
                    page  : 1
                };

            var params  = $.extend({}, defaults, params);

            var promise = {
                method : 'GET',
                url    : api.baseUrl + 'programs',
                params : params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editProgram(program) {
            var promise = {
                method : 'PATCH',
                url    : api.baseUrl + 'programs/' + program.id,
                data   : program
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addProgram(program) {
            var promise = {
                method : 'POST',
                url    : api.baseUrl + 'programs',
                data   : program
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteProgram(program) {
            var promise = {
                method : 'DELETE',
                url    : api.baseUrl + 'programs/' + program.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .service('ProductService', ProductService);

    /** @ngInject */
    function ProductService($http, api, helpers) {

        var service = {
            getProducts: getProducts,
            addProduct: addProduct,
            deleteProduct: deleteProduct,
            editProduct: editProduct,
            // repaymentProduct: repaymentProduct
        };

        function getProducts(params) {
            var defaults = {
                sort: 'name:asc',
                limit: 10,
                page: 1
            };

            var params = $.extend({}, defaults, params);

            var promise = {
                method: 'GET',
                url: api.baseUrl + 'products',
                params: params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editProduct(product) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'products/' + product.id,
                data: product
            };
            // console.log(product);
            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addProduct(product) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'products',
                data: product
            };
            console.log(product);
            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);

        }

        function deleteProduct(product) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'products/' + product.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }

        return service;
    }
})();
 // function repaymentProduct(repayment) {
        //     var promise = {
        //         method: 'PATCH',
        //         url: api.baseUrl + 'products/'  ,  //url
        //         data: repayment
        //     };

        //     return $http(promise)
        //         .then(onComplete)
        //         .catch(helpers.catchInvalidRequests);
        // }
(function () {
    'use strict';

    angular
        .module('app.settings')
        .service('FormFieldService', FormFieldService);

    /** @ngInject */
    function FormFieldService($http, api) {

        var service = {
            getFields: getFields
        };

        function getFields() {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'form/fields',
            };

            return $http(promise)
                .then(onComplete);
        }

        function onComplete(response) {
            console.log("response", response);
            return response.data;
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .service('DonorService', DonorService);

    /** @ngInject */
    function DonorService($http, api, helpers) {

        var service = {
            getDonors   : getDonors,
            addDonor    : addDonor,
            deleteDonor : deleteDonor,
            editDonor   : editDonor,
            getDonor    : getDonor
        };

        function getDonor(donor, params) {
            var promise = {
                method : 'GET',
                url    : api.baseUrl + 'donors/' + donor,
                params : params
            };


            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getDonors(params) {
            var defaults = {
                    sort  : 'name:asc',
                    limit : 10,
                    page  : 1
                };

            var params  = $.extend({}, defaults, params);

            var promise = {
                method : 'GET',
                url    : api.baseUrl + 'donors',
                params : params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editDonor(donor) {
            var promise = {
                method : 'PATCH',
                url    : api.baseUrl + 'donors/' + donor.id,
                data   : donor
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addDonor(donor) {
            var promise = {
                method : 'POST',
                url    : api.baseUrl + 'donors',
                data   : donor
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteDonor(donor) {
            var promise = {
                method : 'DELETE',
                url    : api.baseUrl + 'donors/' + donor.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .service('BranchService', BranchService);

    /** @ngInject */
    function BranchService($http, api, helpers) {

        var service = {
            getBranches          : getBranches,
            addBranch            : addBranch,
            deleteBranch         : deleteBranch,
            editBranch           : editBranch
        };

        function getBranches(params) {
            var defaults = {
                    sort  : 'id:desc',
                    limit : 10,
                    page  : 1
                };

            var params  = $.extend({}, defaults, params);

            var promise = {
                method : 'GET',
                url    : api.baseUrl + 'branches',
                params : params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editBranch(branch) {
            var promise = {
                method : 'PATCH',
                url    : api.baseUrl + 'branches/' + branch.id,
                data   : branch
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addBranch(branch) {
            var promise = {
                method : 'POST',
                url    : api.baseUrl + 'branches',
                data   : branch
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteBranch(branch) {
            var promise = {
                method : 'DELETE',
                url    : api.baseUrl + 'branches/' + branch.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .service('BatchService', BatchService);

    /** @ngInject */
    function BatchService($http, api, helpers) {

        var service = {
            getBatches          : getBatches,
            getBatch            : getBatch,
            getAvailableBatches : getAvailableBatches,
            addBatch            : addBatch,
            deleteBatch         : deleteBatch,
            editBatch           : editBatch
        };

        function getBatches(params) {
            var defaults = {
                    sort  : 'id:desc',
                    limit : 10,
                    page  : 1
                };

            var params  = $.extend({}, defaults, params);

            var promise = {
                method : 'GET',
                url    : api.baseUrl + 'batches',
                params : params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getBatch(batch) {
            var promise = {
                method : 'GET',
                url    : api.baseUrl + 'batches/' + batch.id,
                data   : batch
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getAvailableBatches() {
            var promise = {
                method : 'GET',
                url    : api.baseUrl + 'batches?upcoming=1&sort=start_at:asc,batch_no:asc',
            };

            return $http(promise)
                .then(getAvailableBatchesComplete)
                .catch(helpers.catchInvalidRequests);

            function getAvailableBatchesComplete(response) {
                return response.data.data;
            }
        }

        function editBatch(batch) {
            var promise = {
                method : 'PATCH',
                url    : api.baseUrl + 'batches/' + batch.id,
                data   : batch
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addBatch(batch) {
            var promise = {
                method : 'POST',
                url    : api.baseUrl + 'batches',
                data   : batch
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteBatch(batch) {
            var promise = {
                method : 'DELETE',
                url    : api.baseUrl + 'batches/' + batch.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .service('BatchWeekService', BatchWeekService);

    /** @ngInject */
    function BatchWeekService($http, api, helpers) {

        var service = {
            getBatchWeeks   : getBatchWeeks,
            addBatchWeek    : addBatchWeek,
            deleteBatchWeek : deleteBatchWeek,
            editBatchWeek   : editBatchWeek,
            getBatchWeek    : getBatchWeek
        };

        function getBatchWeek(week, params) {
            var promise = {
                method : 'GET',
                url    : api.baseUrl + 'batch-weeks/' + week,
                params : params
            };


            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getBatchWeeks(params) {
            var defaults = {
                    sort  : 'week:asc'
                };

            var params  = $.extend({}, defaults, params);

            var promise = {
                method : 'GET',
                url    : api.baseUrl + 'batch-weeks',
                params : params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editBatchWeek(week) {
            var promise = {
                method : 'PATCH',
                url    : api.baseUrl + 'batch-weeks/' + week.id,
                data   : week
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addBatchWeek(week) {
            var promise = {
                method : 'POST',
                url    : api.baseUrl + 'batch-weeks',
                data   : week
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteBatchWeek(week) {
            var promise = {
                method : 'DELETE',
                url    : api.baseUrl + 'batch-weeks/' + week.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .service('BaseService', BaseService);

    /** @ngInject */
    function BaseService($http, api, helpers) {

        var service = {
            getBases          : getBases,
            addBase           : addBase,
            deleteBase        : deleteBase,
            editBase          : editBase
        };

        function getBases(params) {
            var defaults = {
                    sort  : 'name:asc',
                    limit : 10,
                    page  : 1
                };

            var params  = $.extend({}, defaults, params);

            var promise = {
                method : 'GET',
                url    : api.baseUrl + 'bases',
                params : params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editBase(base) {
            var promise = {
                method : 'PATCH',
                url    : api.baseUrl + 'bases/' + base.id,
                data   : base
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addBase(base) {
            var promise = {
                method : 'POST',
                url    : api.baseUrl + 'bases',
                data   : base
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteBase(base) {
            var promise = {
                method : 'DELETE',
                url    : api.baseUrl + 'bases/' + base.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.changelogs')
        .service('ChangelogService', ChangelogService);

    /** @ngInject */
    function ChangelogService($http, api, helpers) {

        var service = {
            getChangelogs: getChangelogs,
            getChangelog: getChangelog,
            addChangelog: addChangelog,
            deleteChangelog: deleteChangelog,
            editChangelog: editChangelog
        };

        function getChangelog(changelog, params) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'changelogs/' + changelog.id,
                params: params
            };


            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getChangelogs(params) {
            var defaults = {
                sort: 'created_at:desc',
                limit: 10,
                page: 1
            };

            var params = $.extend({}, defaults, params);

            var promise = {
                method: 'GET',
                url: api.baseUrl + 'changelogs',
                params: params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editChangelog(changelog) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'changelogs/' + changelog.id,
                data: changelog
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addChangelog(changelog) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'changelogs',
                data: changelog
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteChangelog(changelog) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'changelogs/' + changelog.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.changelogs')
        .service('ApiErrorService', ApiErrorService);

    /** @ngInject */
    function ApiErrorService($http, api, helpers) {

        var service = {
            getApiErrors: getApiErrors,
            getApiError: getApiError,
            addApiError: addApiError,
            deleteApiError: deleteApiError,
            editApiError: editApiError
        };

        function getApiError(apiError, params) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'api-errors/' + apiError.id,
                params: params
            };


            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getApiErrors(params) {
            var defaults = {
                sort: 'created_at:desc',
                limit: 10,
                page: 1
            };

            var params = $.extend({}, defaults, params);

            var promise = {
                method: 'GET',
                url: api.baseUrl + 'api-errors',
                params: params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editApiError(apiError) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'api-errors/' + apiError.id,
                data: apiError
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addApiError(apiError) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'apiErrors',
                data: apiError
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteApiError(apiError) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'api-errors/' + apiError.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.prevailsettings')
        .service('SmallGroupService', SmallGroupService);

    /** @ngInject */
    function SmallGroupService($http, api, helpers) {

        var service = {
            getsmallGroups: getsmallGroups,
            getSmallGroup: getSmallGroup,
            addSmallGroup: addSmallGroup,
            deleteSmallGroup: deleteSmallGroup,
            editSmallGroup: editSmallGroup
        };

        function getSmallGroup(id, params) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'small-group/' + id,
                params: params
            };


            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getsmallGroups(params) {
            var defaults = {
                sort: 'name:asc',
                limit: 10,
                page: 1
            };

            var params = $.extend({}, defaults, params);

            var promise = {
                method: 'GET',
                url: api.baseUrl + 'small-group',
                params: params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editSmallGroup(smallGroup) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'small-group/' + smallGroup.id,
                data: smallGroup
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addSmallGroup(smallGroup) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'small-group',
                data: smallGroup
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteSmallGroup(smallGroup) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'small-group/' + smallGroup.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.prevailsettings')
        .service('PartnerService', PartnerService);

    /** @ngInject */
    function PartnerService($http, api, helpers) {

        var service = {
            getPartners: getPartners,
            getPartner: getPartner,
            addPartner: addPartner,
            deletePartner: deletePartner,
            editPartner: editPartner
        };

        function getPartner(partner, params) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'partners/' + partner.id,
                params: params
            };


            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getPartners(params) {
            var defaults = {
                sort: 'name:asc',
                limit: 10,
                page: 1
            };

            var params = $.extend({}, defaults, params);

            var promise = {
                method: 'GET',
                url: api.baseUrl + 'partners',
                params: params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editPartner(partner) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'partners/' + partner.id,
                data: partner
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addPartner(partner) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'partners',
                data: partner
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deletePartner(partner) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'partners/' + partner.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.prevailsettings')
        .service('ClusterService', ClusterService);

    /** @ngInject */
    function ClusterService($http, api, helpers) {

        var service = {
            getClusters: getClusters,
            getCluster: getCluster,
            addCluster: addCluster,
            deleteCluster: deleteCluster,
            editCluster: editCluster
        };

        function getCluster(cluster, params) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'clusters/' + cluster.id,
                params: params
            };


            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getClusters(params) {
            var defaults = {
                sort: 'name:asc',
                limit: 10,
                page: 1
            };

            var params = $.extend({}, defaults, params);

            var promise = {
                method: 'GET',
                url: api.baseUrl + 'clusters',
                params: params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editCluster(cluster) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'clusters/' + cluster.id,
                data: cluster
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addCluster(cluster) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'clusters',
                data: cluster
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteCluster(cluster) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'clusters/' + cluster.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.prevail')
        .controller('SavingsGroupsController', SavingsGroupsController);

    /** @ngInject */
    function SavingsGroupsController($rootScope,
        $scope,
        $mdDialog,
        $document,
        $state,
        BaseService,
        ClusterService,
        SavingsGroupService,
        Auth) {
        var vm = this;

        var currentUser = Auth.getUser();
        vm.isAdmin = Boolean(currentUser && currentUser.roles && currentUser.$roles.has(["admin"]));
        vm.userCountry = currentUser ? currentUser.country_code : null;

        vm.$state = $state;

        //Methods
        vm.addSavingsGroup = addSavingsGroup;
        vm.callPastorInformation = callPastorInformation;
        vm.pageChange = pageChange;
        vm.savingsPageChange = savingsPageChange;
        vm.selectCluster = selectCluster;
        vm.selectSearch = selectSearch;
        vm.selectBase = selectBase;
        vm.selectBranch = selectBranch;
        vm.goToSavingsGroup = goToSavingsGroup;
        vm.dropSavingsGroup = dropSavingsGroup;
        vm.deleteSavingsGroup = deleteSavingsGroup;
        vm.restoreSavingsGroup = restoreSavingsGroup;
        vm.droppedSavingsPageChange = droppedSavingsPageChange;

        vm.totals = {};

        vm.isLoading1 = false;
        vm.isLoading2 = false;

        vm.savingsGroups = [];
        vm.droppedSavingsGroups = [];

        var _parent = $scope;
        _parent.$parent.vm.currentTab = 0;

        activate();

        /*
        Function that is first called upon load
         */
        function activate() {
            vm.filters = {
                base: 'all',
                branch: 'all',
                cluster: 'all'
            };

            var data;
            if (localStorage.getItem('savingsgroups')) {
                data = JSON.parse(localStorage.getItem('savingsgroups'));

                vm.filters.search = data && data.search ? data.search : null;
            }
            getTotals(data);
            getBases(data);
            getClusters(data);
            displaySavingsGroups(data);
            displayDroppedSavingsGroups(data);
        }

        /*
        Function that get the totals based on filter
         */
        function getTotals(data) {
            var params = {};
            params.cluster_id = data && data.cluster ? data.cluster.id : null;
            params.stream_id = data && data.stream ? data.stream.id : null;
            params.base_id = data && data.base ? data.base.id : (currentUser.base_id || null);
            params.branch_id = data && data.branch ? data.branch.id : (currentUser.branch_id || null);
            params.search = data && data.search || null;

            SavingsGroupService.getTotals(params).then(function (response) {
                vm.totals.gold = response.total_gold;
                vm.totals.silver = response.total_silver;
                vm.totals.inactive = response.total_inactive;
            })
        }

        /*
        Function that plots savings groups table
         */
        function displaySavingsGroups(data) {
            vm.isLoading1 = true;
            data = data || {};
            var params = {};
            params.limit = 10;
            params.page = data.page || 1;
            params.cluster_id = data.cluster ? data.cluster.id : null;
            params.stream_id = data.stream ? data.stream.id : null;
            params.base_id = data.base ? data.base.id : (currentUser.base_id || null);
            params.branch_id = data.branch ? data.branch.id : (currentUser.branch_id || null);
            params.search = data.search || null;

            if (!vm.isAdmin && vm.userCountry) {
                params.country_code = vm.userCountry;
            }

            params.with = "batch,communities,communities.application," +
                "stream,batch,cluster,base,pastor,pastor.churches,pastor.churches.affiliation," +
                "pastor.base,pastor.province,pastor.city,pastor.barangay,pastor.contacts," +
                "partners,startData,smallgroup";
            SavingsGroupService.getSavingsGroups(params).then(function (data) {
                vm.isLoading1 = false;
                vm.savingsGroups = data;
            });
        }

        /*
        Function that plots savings groups table
         */
        function displayDroppedSavingsGroups(data) {
            vm.isLoading2 = true;
            data = data || {};
            var params = {};

            params.limit = 10;
            params.trashed = 1;
            params.page = data.page || 1;
            params.cluster_id = data.cluster ? data.cluster.id : null;
            params.stream_id = data.stream ? data.stream.id : null;
            params.base_id = data.base ? data.base.id : (currentUser.base_id || null);
            params.branch_id = data.branch ? data.branch.id : (currentUser.branch_id || null);
            params.search = data.search || null;

            if (!vm.isAdmin && vm.userCountry) {
                params.country_code = vm.userCountry;
            }

            params.with = "batch,communities,stream,cluster,base,smallgroup";
            params.sort = "savings_groups.deleted_at:desc";
            SavingsGroupService.getSavingsGroups(params).then(function (data) {
                vm.isLoading2 = false;
                vm.droppedSavingsGroups = data;
                vm.droppedSavingsGroups.data = data.data.map(function (d) {
                    d.deleted_at = d.deleted_at.split(' ')[0];
                    return d;
                });
            });
        }

        /*
        Function used to get all bases if the user has no base id
         */
        function getBases(data) {
            var params = {
                nopage: true,
                base_id: currentUser.base_id,
                with: 'branches'
            };

            if (!vm.isAdmin && vm.userCountry) {
                params.country_code = vm.userCountry;
            }

            BaseService.getBases(params).then(function (response) {
                var base = response[0];

                vm.bases = response;

                if (currentUser.base_id) {
                    vm.filters.base = base;
                } else {
                    vm.filters.base = data && data.base ? data.base : 'all';
                }

                if (currentUser.branch_id) {
                    vm.filters.branch = base.branches.filter(function (item) {
                        return item.id == currentUser.branch_id;
                    }).shift();
                } else {
                    vm.filters.branch = data && data.branch ? data.branch : 'all';
                }
            });
        }

        /*
        Function used to get clusters
         */
        function getClusters(data) {
            var params = {};
            params.nopage = true;
            if (data && data.base) {
                params.base_id = data.base.id;
            }

            if (data && data.branch) {
                params.branch_id = data.branch.id;
            }

            if (!vm.isAdmin && currentUser && currentUser.base_id) {
                params.base_id = currentUser.base_id;
            }

            if (!vm.isAdmin && currentUser && currentUser.branch_id) {
                params.branch_id = currentUser.branch_id;
            }

            ClusterService.getClusters(params).then(function (response) {
                vm.clusters = response;
                vm.filters.cluster = data && data.cluster ? data.cluster : 'all';
            })
        }

        /*
        Function that calls the function for adding savings group
         */
        function addSavingsGroup(savings) {
            console.log(savings)
            $mdDialog.show({
                controller: 'AddNewSavingsGroupController',
                controllerAs: 'vm',
                templateUrl: 'app/main/prevail/tabs/savings-groups/dialogs/add-new-sg/add-new-sg-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    savingsObj: savings || null,
                    callback: function () {
                        displaySavingsGroups(vm.filters);
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to drop a savings group
         */
        function dropSavingsGroup(savings) {
            $mdDialog.show({
                controller: 'ReasonForDroppingDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/prevail/tabs/savings-groups/dialogs/reason-for-dropping/reason-for-dropping-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    savingsGroup: savings || null,
                    callback: function () {
                        getTotals(vm.filters);
                        displaySavingsGroups(vm.filters);
                        displayDroppedSavingsGroups(vm.filters);
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to permanently delete a savings group
         */
        function deleteSavingsGroup(savingsDelete) {
            $mdDialog.show({
                controller: 'DeleteSavingsGroupDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    callback: function () {
                        SavingsGroupService.deleteSavingsGroup(savingsDelete).then(function () {
                            getTotals(vm.filters);
                            displaySavingsGroups(vm.filters);
                            console.log(vm.filters)
                            displayDroppedSavingsGroups(vm.filters);
                        });
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to restore a dropped savings group
         */
        function restoreSavingsGroup(savingsRestore) {
            SavingsGroupService.restoreSavingsGroup(savingsRestore).then(function () {
                getTotals(vm.filters);
                displaySavingsGroups(vm.filters);
                displayDroppedSavingsGroups(vm.filters);
            })
        }

        /*
        Function that is triggered to redirect to community page
         */
        function goToSavingsGroup(id) {
            $state.go('app.savings-group-community.savings-group-data', { id: id });
        }

        /*
        Function that listens for every page change of pagination
         */
        function pageChange(page) {
            drawApplicationsTable(page);
        }

        /*
        Function triggered when pagination changes page
         */
        function savingsPageChange(page, filters) {
            filters.page = page;
            var data = filters;
            displaySavingsGroups(data);
            localStorage.setItem('savingsgroups', JSON.stringify(data));
        }

        /*
        Function triggered when pagination in savings group drop list changes
         */
        function droppedSavingsPageChange(page, filters) {
            filters.page = page;
            var data = filters;
            displayDroppedSavingsGroups(data)
            localStorage.setItem('savingsgroups', JSON.stringify(data));
        }

        /*
        Function used to select a base and filter results
         */
        function selectBase(data) {
            vm.filters.branch = 'all';
            vm.filters.cluster = 'all';
            data.page = 1;
            getTotals(data);
            getClusters(data);
            displaySavingsGroups(data);
            displayDroppedSavingsGroups(data);
            localStorage.setItem('savingsgroups', JSON.stringify(data));
        }

        /*
        Function used to select a branch and filter results
         */
        function selectBranch(data) {
            data.page = 1;
            vm.filters.cluster = 'all';
            getTotals(data);
            getClusters(data);
            displaySavingsGroups(data);
            displayDroppedSavingsGroups(data);
            localStorage.setItem('savingsgroups', JSON.stringify(data));
        }

        /*
        Function used to display all savings group and dropped savings group based on search text
         */
        function selectSearch(data) {
            getTotals(data);
            displaySavingsGroups(data);
            displayDroppedSavingsGroups(data);
            localStorage.setItem('savingsgroups', JSON.stringify(data));
        }

        /*
        Function used to select a cluster and filter results
         */
        function selectCluster(data) {
            data.page = 1;
            getTotals(data);
            displaySavingsGroups(data);
            displayDroppedSavingsGroups(data);
            localStorage.setItem('savingsgroups', JSON.stringify(data));
        }

        /*
        Function that checks if there is a pastor in that application and call show pastor dialog function
         */
        function callPastorInformation(pastor) {
            if (pastor) showPastorInformationDialog(pastor);
        }

        /*
        Function that calls modal service for pastor information
         */
        function showPastorInformationDialog(pastor) {
            $mdDialog.show({
                controller: 'PastorInformationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/transform/dialogs/pastor-information/pastor-information-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    pastor: pastor
                },
                clickOutsideToClose: true
            });
        }
    }
})();



(function () {
    'use strict';

    angular
        .module('app.prevail')
        .controller('PrevailReportsController', PrevailReportsController);

    /** @ngInject */
    function PrevailReportsController($scope,
                                      ReportService,
                                      BaseService,
                                      api,
                                      Auth,
                                      $mdDialog,
                                      $httpParamSerializer,
                                      $localStorage,
                                      ClusterService,
                                      BatchService,
                                      $mdBottomSheet,
                                      $document) {
        var vm = this;

        var currentUser = Auth.getUser();
        vm.currentUser  = currentUser;

        var _parent = $scope;
        _parent.$parent.vm.currentTab = 1;

        vm.newReport = true;

        vm.api = api;

        vm.reportClusters = [];
        vm.reportStreams = [];
        vm.reportBases = [];
        vm.reportBranches = [];
        vm.reportPrograms = [];

        vm.templateSelected = false;

        vm.noData = false;

        vm.batches = [];
        vm.bases = [];

        vm.selectAllBatch = false;
        vm.selectAllBase = false;
        vm.selectAllPrograms = false;

        vm.programs = [
            {
                name: 'Savings Group',
                id: 'prevail_savings_group'
            },
            {
                name: 'Savings Group Membership',
                id: 'prevail_savings_group_members'
            }
        ];

        //Methods
        vm.saveTemplate = saveTemplate;
        vm.selectAll = selectAll;
        vm.selectFilter = selectFilter;
        vm.isSelectedAll = isSelectedAll;
        vm.isSelected = isSelected;
        vm.showTemplate = showTemplate;
        vm.presetSelectFilter = presetSelectFilter;
        vm.presetIsSelected = presetIsSelected;
        vm.presetIsSelectedAll = presetIsSelectedAll;
        vm.presetSelectAll = presetSelectAll;
        vm.showPreview = showPreview;
        vm.presetShowPreview = presetShowPreview;
        vm.selectBase = selectBase;
        vm.selectBranch = selectBranch;
        vm.selectCluster = selectCluster;
        vm.selectStream = selectStream;
        vm.presetSelectBase = presetSelectBase;
        vm.presetSelectBranch = presetSelectBranch;
        vm.editTemplate = editTemplate;
        vm.deleteTemplate = deleteTemplate;
        vm.presetSelectCluster = presetSelectCluster;
        vm.presetSelectStream = presetSelectStream;
        vm.updateFilters = updateFilters;
        vm.presetUpdateFilters = presetUpdateFilters;
        vm.clusters = [];
        vm.branches = [];

        activate();

        /*
        Function used to fetch report templates, bases, clusters, and streams
         */
        function activate() {
            getTemplates();
            getBases();
            getStreams();
        }

        /*
        Function that fetches all bases if user has no assigned base
         */
        function getBases(data) {
            BaseService.getBases({
                nopage: true,
                base_id: currentUser.base_id,
                with: 'branches,branches.clusters'
            }).then(function (response) {
                vm.bases = response;
                var base = response[0];

                vm.bases = response;

                if (currentUser.base_id) {
                    vm.report.base = base;
                    selectBase(vm.report);
                }

                 if (currentUser.branch_id) {
                    vm.report.branch = base.branches.filter(function(item) {
                      return item.id == currentUser.branch_id;
                    }).shift();

                    selectBranch(vm.report);
                }
            });
        }

        /*
        Function used to fetch all streams
         */
        function getStreams() {
            BatchService.getBatches({nopage: true, sort: 'start_at:desc'}).then(function (response) {
                vm.streams = response;
            })
        }

        /*
        Function used to push an ID to an array
         */
        function pushIds(destination, source) {
            for (var i = 0; i < source.length; i++) {
                destination.push(source[i].id);
            }
        }

        /*
        Function used to select base for the report
         */
        function selectBase(report) {
            vm.reportBases = [];
            vm.reportBranches = [];
            vm.selectedBase = report.base;

            vm.branches    = vm.selectedBase.branches;
            report.cluster = 'all';

            report.branch = 'all';
            if (report.base !== 'all') {
                vm.reportBases.push(report.base.id);
            } else {
                for (var i = 0; i < vm.bases.length; i++) {
                    vm.reportBases.push(vm.bases[i].id);
                }
            }

            var tempcsvobj = {
                'cluster_id': vm.reportClusters,
                'batch_id': vm.reportStreams,
                'base_ids[]': vm.reportBases,
                'start_date': vm.report.start_date ? moment(vm.report.start_date).format() : null,
                'end_date': vm.report.end_date ? moment(vm.report.end_date).format() : null,
                'programs[]': vm.reportPrograms,
                'branch_ids[]': vm.reportBranches,
                'token': $localStorage.currentUser.token,
                'with': 'data'
            };
            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
        Function used to select cluster for the report
         */
        function selectCluster(report) {
            vm.reportClusters = [];
            if (report.cluster !== 'all') {
                vm.reportClusters.push(report.cluster.id);
            }

            var tempcsvobj = {
                'cluster_id': vm.reportClusters,
                'batch_id': vm.reportStreams,
                'base_ids[]': vm.reportBases,
                'start_date': vm.report.start_date ? moment(vm.report.start_date).format() : null,
                'end_date': vm.report.end_date ? moment(vm.report.end_date).format() : null,
                'programs[]': vm.reportPrograms,
                'branch_ids[]': vm.reportBranches,
                'token': $localStorage.currentUser.token,
                'with': 'data'
            };
            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
        Function triggers after selecting a date
         */
        function updateFilters(report) {
            var tempcsvobj = {
                'programs[]': vm.reportPrograms,
                'cluster_id': vm.reportClusters,
                'batch_id': vm.reportStreams,
                'token': $localStorage.currentUser.token,
                'start_date': report.start_date ? moment(report.start_date).format() : null,
                'end_date': report.end_date ? moment(report.end_date).format() : null,
                'base_id': report && report.base ? report.base.id : null,
                'district_id': report && report.district ? report.district.id : null,
                'branch_id': report && report.branch ? report.branch.id : null,
                'with': 'data'
            };
            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
        Function triggers after selecting a date
         */
        function presetUpdateFilters() {
            var tempcsvobj = {
                'cluster_id': vm.template.filters['cluster_id'],
                'batch_id': vm.template.filters['batch_id'],
                'base_ids[]': vm.template.filters['base_ids[]'],
                'start_date': vm.template.filters.start_date ? moment(vm.template.filters.start_date).format() : null,
                'end_date': vm.template.filters.end_date ? moment(vm.template.filters.end_date).format() : null,
                'programs[]': vm.template.filters['programs[]'],
                'branch_ids': vm.template.filters['branch_ids'],
                'token': $localStorage.currentUser.token,
                'with': 'data'
            };
            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
        Function used to select stream for the report
         */
        function selectStream(report) {
            vm.reportStreams = [];
            if (report.stream !== 'all') {
                vm.reportStreams.push(report.stream.id);
            } else {
                if (report.base !== 'all') {
                    if (vm.streams && vm.streams.length) {
                        pushIds(vm.reportStreams, vm.streams);
                    }
                }
            }

            var tempcsvobj = {
                'cluster_id': vm.reportClusters,
                'batch_id': vm.reportStreams,
                'base_ids[]': vm.reportBases,
                'start_date': vm.report.start_date ? moment(vm.report.start_date).format() : null,
                'end_date': vm.report.end_date ? moment(vm.report.end_date).format() : null,
                'programs[]': vm.reportPrograms,
                'branch_ids[]': vm.reportBranches,
                'token': $localStorage.currentUser.token,
                'with': 'data'
            };
            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
        Function used to select branch for the report
         */
        function selectBranch(report) {
            vm.reportBranches = [];
            if (report.branch !== 'all') {
                vm.reportBranches.push(report.branch.id);
                vm.clusters    = report.branch.clusters;
                report.cluster = 'all';
            } else {
                if (report.base !== 'all') {
                    // pushIds(vm.reportBranches, report.base.branches);
                }
            }

            var tempcsvobj = {
                'cluster_id': vm.reportClusters,
                'batch_id': vm.reportStreams,
                'base_ids[]': vm.reportBases,
                'programs[]': vm.reportPrograms,
                'start_date': vm.report.start_date ? moment(vm.report.start_date).format() : null,
                'end_date': vm.report.end_date ? moment(vm.report.end_date).format() : null,
                'branch_ids[]': vm.reportBranches,
                'token': $localStorage.currentUser.token,
                'with': 'data'
            };
            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
        Function used for the report template to select a base
         */
        function presetSelectBase(report) {
            vm.template.filters['base_ids[]'] = [];
            vm.template.filters['branch_ids[]'] = [];
            vm.presetSelectedBase = report.filters.base;
            report.filters.cluster = 'all';
            report.filters.branch = 'all';

            vm.branches = vm.presetSelectedBase.branches;

            if (report.filters.base !== 'all') {
                vm.template.filters['base_ids[]'].push(report.filters.base.id);
                // pushIds(vm.template.filters['branch_ids[]'], vm.presetSelectedBase.branches);
            } else {
                for (var i = 0; i < vm.bases.length; i++) {
                    vm.template.filters['base_ids[]'].push(vm.bases[i].id);
                    // pushIds(vm.template.filters['branch_ids[]'], vm.bases[i].branches);
                }
            }

            var tempcsvobj = {
                'cluster_id': vm.template.filters['cluster_id'],
                'batch_id': vm.template.filters['batch_id'],
                'base_ids[]': vm.template.filters['base_ids[]'],
                'start_date': vm.template.start_date ? moment(vm.template.start_date).format() : null,
                'end_date': vm.template.end_date ? moment(vm.template.end_date).format() : null,
                'programs[]': vm.template.filters['programs[]'],
                'branch_ids': vm.template.filters['branch_ids'],
                'token': $localStorage.currentUser.token,
                'with': 'data'
            };
            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
        Function used for the report template to select a branch
         */
        function presetSelectBranch(report) {
            vm.template.filters['branch_ids[]'] = [];
            if (report.filters.branch !== 'all') {
                vm.template.filters['branch_ids[]'].push(report.filters.branch.id);
                vm.clusters = report.filters.branch.clusters;
            } else {
                if (report.filters.base !== 'all') {
                    // pushIds(vm.template.filters['branch_ids[]'], report.filters.base.branches);
                }
            }

            var tempcsvobj = {
                'cluster_id': vm.template.filters['cluster_id'],
                'batch_id': vm.template.filters['batch_id'],
                'base_ids[]': vm.template.filters['base_ids[]'],
                'start_date': vm.template.start_date ? moment(vm.template.start_date).format() : null,
                'end_date': vm.template.end_date ? moment(vm.template.end_date).format() : null,
                'programs[]': vm.template.filters['programs[]'],
                'branch_ids': vm.template.filters['branch_ids'],
                'token': $localStorage.currentUser.token,
                'with': 'data'
            };
            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
        Function used for the report template to select a cluster
         */
        function presetSelectCluster(report) {
            vm.template.filters['cluster_id'] = [];
            if (report.filters.cluster !== 'all') {
                vm.template.filters['cluster_id'].push(report.filters.cluster.id);
            }

            var tempcsvobj = {
                'cluster_id': vm.template.filters['cluster_id'],
                'batch_id': vm.template.filters['batch_id'],
                'base_ids[]': vm.template.filters['base_ids[]'],
                'start_date': vm.template.start_date ? moment(vm.template.start_date).format() : null,
                'end_date': vm.template.end_date ? moment(vm.template.end_date).format() : null,
                'programs[]': vm.template.filters['programs[]'],
                'branch_ids': vm.template.filters['branch_ids'],
                'token': $localStorage.currentUser.token,
                'with': 'data'
            };
            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
        Function used for the report template to select a stream
         */
        function presetSelectStream(report) {
            vm.template.filters['batch_id'] = [];
            if (report.filters.stream !== 'all') {
                vm.template.filters['batch_id'].push(report.filters.stream.id);
            } else {
                if (report.filters.base !== 'all') {
                    if (vm.streams && vm.streams.length) {
                        pushIds(vm.template.filters['batch_id'], vm.streams);
                    }
                }
            }

            var tempcsvobj = {
                'cluster_id': vm.template.filters['cluster_id'],
                'batch_id': vm.template.filters['batch_id'],
                'start_date': vm.template.start_date ? moment(vm.template.start_date).format() : null,
                'end_date': vm.template.end_date ? moment(vm.template.end_date).format() : null,
                'base_ids[]': vm.template.filters['base_ids[]'],
                'programs[]': vm.template.filters['programs[]'],
                'branch_ids': vm.template.filters['branch_ids'],
                'token': $localStorage.currentUser.token,
                'with': 'data'

            };
            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
        Function that gets all report templates
         */
        function getTemplates() {
            ReportService.getTemplates({
                type: 'prevail',
                nopage: true,
                user_id: currentUser.id
            }).then(function (response) {
                vm.templates = response.data;
            });
        }

        /*
         Selects all options in a category
         */
        function selectAll() {
            vm.reportPrograms = [];

            if (!vm.selectAllPrograms) {
                for (var i = 0; i < vm.programs.length; i++) {
                    vm.reportPrograms.push(vm.programs[i].id);
                }
            }

            vm.selectAllPrograms = !vm.selectAllPrograms;

            var tempcsvobj = {
                'cluster_id': vm.reportClusters,
                'batch_id': vm.reportStreams,
                'base_ids[]': vm.reportBases,
                'start_date': vm.report.start_date ? moment(vm.report.start_date).format() : null,
                'end_date': vm.report.end_date ? moment(vm.report.end_date).format() : null,
                'programs[]': vm.reportPrograms,
                'branch_ids[]': vm.reportBranches,
                'token': $localStorage.currentUser.token,
                'with': 'data'
            };
            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
         Checks if a Select All option is selected
         */
        function isSelectedAll() {
            if (vm.programs.length !== vm.reportPrograms.length) {
                return false;
            } else {
                if (vm.programs.length) {
                    for (var i = 0; i < vm.programs.length; i++) {
                        if (vm.programs[i].id !== vm.reportPrograms[i]) {
                            return false;
                        }
                    }
                } else {
                    return false;
                }
            }

            return true;
        }

        /*
         Checks if a checkbox is being selected
         */
        function isSelected(item) {
            return vm.reportPrograms.indexOf(item) > -1;
        }

        /*
         This function selects a checkbox filter
         */
        function selectFilter(item) {
            var index = vm.reportPrograms.indexOf(item);
            if (index > -1) {
                vm.reportPrograms.splice(index, 1);
            } else {
                vm.reportPrograms.push(item);
            }
            vm.selectAllPrograms = false;

            var tempcsvobj = {
                'cluster_id': vm.reportClusters,
                'batch_id': vm.reportStreams,
                'base_ids[]': vm.reportBases,
                'programs[]': vm.reportPrograms,
                'start_date': vm.report.start_date ? moment(vm.report.start_date).format() : null,
                'end_date': vm.report.end_date ? moment(vm.report.end_date).format() : null,
                'branch_ids[]': vm.reportBranches,
                'token': $localStorage.currentUser.token,
                'with': 'data'
            };
            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
        Function to open save template modal
         */
        function saveTemplate(report) {
            var csvObj = {
                'cluster_id': vm.reportClusters,
                'batch_id': vm.reportStreams,
                'base_ids[]': vm.reportBases,
                'start_date': report.start_date ? moment(report.start_date).format() : null,
                'end_date': report.end_date ? moment(report.end_date).format() : null,
                'programs[]': vm.reportPrograms,
                'branch_ids[]': vm.reportBranches
            };

            if (vm.selectedDonor) csvObj.donor_id = vm.selectedDonor.id;
            $mdDialog.show({
                controller: 'AddReportTemplateDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/transform/tabs/reports/dialogs/add-report-template/add-report-template-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    csvObj: csvObj,
                    getTemplates: getTemplates,
                    mode: 'prevail'
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function to open delete template modal
         */
        function deleteTemplate() {
            $mdDialog.show({
                controller: 'DeleteReportTemplateDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    template: vm.template,
                    callback: function () {
                        getTemplates();
                        vm.newReport = true;
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function to open edit template modal
         */
        function editTemplate() {
            if (vm.template.filters['programs[]'].length > 0) {
                $mdDialog.show({
                    controller: 'EditReportTemplateDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/transform/tabs/reports/dialogs/edit-report-template/edit-report-template-dialog.html',
                    parent: angular.element($document.body),
                    locals: {
                        template: vm.template,
                        templates: vm.templates,
                        mode: 'prevail'
                    },
                    clickOutsideToClose: true
                });
            } else {
                if (vm.template.filters['programs[]'].length < 1) {
                    vm.template.programMessage = 'Please select at least one program';
                }
            }
        }

        /*
        Function that shows preset report template
         */
        function showTemplate(template) {
            vm.templateSelected = true;
            vm.newReport = false;
            vm.template = template;
            vm.template.noData = false;
            vm.templates = vm.templates.map(function (template) {
                if (template && template.selected) template.selected = false;
                return template;
            });
            template.selected = true;
            vm.template.start_date = template.filters.start_date;
            vm.template.end_date = template.filters.end_date;

            if (vm.bases && vm.bases.length) {
                if (template.filters['base_ids[]'].length === 1) {
                    vm.bases.filter(function (base) {
                        if (base.id === template.filters['base_ids[]'][0]) {
                            vm.template.filters.base = base;
                            vm.branches = base.branches;
                            return;
                        }
                    });
                } else {
                    vm.template.filters.base = 'all';
                }
            }

            if (vm.branches && vm.branches.length) {
                if (template.filters['branch_ids[]'].length === 1) {
                    vm.branches.filter(function (branch) {
                        if (branch.id === template.filters['branch_ids[]'][0]) {
                            vm.template.filters.branch = branch;
                            vm.clusters = branch.clusters;
                            return;
                        }
                    });
                } else {
                    vm.template.filters.branch = 'all';
                }
            }

            if (vm.clusters && vm.clusters.length) {
                if (template.filters.cluster_id.length === 1) {
                    vm.clusters.filter(function (cluster) {
                        if (cluster.id === template.filters['cluster_id'][0]) {
                            vm.template.filters.cluster = cluster;
                            return;
                        }
                    });
                } else {
                    vm.template.filters.cluster = 'all';
                }
            }

            if (vm.streams && vm.streams.length) {
                if (template.filters.batch_id.length === 1) {
                    vm.streams.filter(function (stream) {
                        if (stream.id === template.filters['batch_id'][0]) {
                            vm.template.filters.stream = stream;
                            return;
                        }
                    });
                } else {
                    vm.template.filters.stream = 'all';
                }
            }

            var tempcsvobj = {
                'cluster_id': vm.template.filters['cluster_id'],
                'batch_id': vm.template.filters['batch_id'],
                'base_ids[]': vm.template.filters['base_ids[]'],
                'branch_ids[]': vm.template.filters['branch_ids[]'],
                'start_date': template.start_date ? moment(template.start_date).format() : null,
                'end_date': template.end_date ? moment(template.end_date).format() : null,
                'programs[]': vm.template.filters['programs[]'],
                'branch_ids': vm.template.filters['branch_ids'],
                'token': $localStorage.currentUser.token,
                'with': 'data'
            };
            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
        Function in preset template to select a checkbox filter
         */
        function presetSelectFilter(item) {
            var index = vm.template.filters['programs[]'].indexOf(item);
            if (index > -1) {
                vm.template.filters['programs[]'].splice(index, 1);
            } else {
                vm.template.filters['programs[]'].push(item);
            }
            vm.template.selectAllPrograms = false;
            var tempcsvobj = {
                'cluster_id': vm.template.filters['cluster_id'],
                'batch_id': vm.template.filters['batch_id'],
                'base_ids[]': vm.template.filters['base_ids[]'],
                'start_date': vm.template.start_date ? moment(vm.template.start_date).format() : null,
                'end_date': vm.template.end_date ? moment(vm.template.end_date).format() : null,
                'programs[]': vm.template.filters['programs[]'],
                'branch_ids': vm.template.filters['branch_ids'],
                'token': $localStorage.currentUser.token,
                'with': 'data'
            };
            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
        Checks in the preset template if a checkbox is being selected
         */
        function presetIsSelected(item) {
            if (vm.templateSelected && vm.template && vm.template.filters)
                return vm.template.filters['programs[]'].indexOf(item) > -1;
        }

        function presetIsSelectedAll() {
            if (vm.templateSelected && vm.template && vm.template.filters) {
                if (vm.programs.length !== vm.template.filters['programs[]'].length) {
                    return false;
                } else {
                    if (vm.programs.length) {
                        for (var i = 0; i < vm.programs.length; i++) {
                            if (vm.programs[i].id !== vm.template.filters['programs[]'][i]) {
                                return false;
                            }
                        }
                    } else {
                        return false;
                    }
                }
            }

            return true;
        }

        /*
        Selects all checkboxes in the preset settings
         */
        function presetSelectAll() {
            if (presetIsSelectedAll('program')) {
                vm.template.selectAllPrograms = true;
            }
            vm.template.filters['programs[]'] = [];

            if (presetIsSelectedAll('program')) {
                vm.template.selectAllPrograms = true;
            }

            if (!vm.template.selectAllPrograms) {
                for (var i = 0; i < vm.programs.length; i++) {
                    vm.template.filters['programs[]'].push(vm.programs[i].id);
                }
            }

            vm.template.selectAllPrograms = !vm.template.selectAllPrograms;
            var tempcsvobj = {
                'cluster_id': vm.template.filters['cluster_id'],
                'batch_id': vm.template.filters['batch_id'],
                'base_ids[]': vm.template.filters['base_ids[]'],
                'start_date': vm.template.start_date ? moment(vm.template.start_date).format() : null,
                'end_date': vm.template.end_date ? moment(vm.template.end_date).format() : null,
                'programs[]': vm.template.filters['programs[]'],
                'branch_ids': vm.template.filters['branch_ids'],
                'token': $localStorage.currentUser.token,
                'with': 'data'
            };
            vm.csvUrl = $httpParamSerializer(tempcsvobj);
        }

        /*
         Calls bottom sheet UI for Preview
         */
        function showPreview() {
            vm.programMessage = '';
            vm.baseMessage = '';
            vm.branchMessage = '';
            vm.batchMessage = '';
            vm.dataMessage = '';

            if (vm.currentUser.base_id) {
                vm.reportBases = [vm.currentUser.base_id];
            }

            var htmlObj = {
                'cluster_id': vm.reportClusters,
                'batch_id': vm.reportStreams,
                'base_ids': vm.reportBases,
                'programs': vm.reportPrograms,
                'start_date': vm.report.start_date ? moment(vm.report.start_date).format() : null,
                'end_date': vm.report.end_date ? moment(vm.report.end_date).format() : null,
                'branch_ids': vm.reportBranches,
                'with': 'data'
            };

            if (vm.reportPrograms.length > 0) {
                $mdBottomSheet.show({
                    controller: 'ReportPreviewController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/transform/tabs/reports/bottom-sheets/report-preview/report-preview.html',
                    parent: '#transform-content-wrapper',
                    locals: {
                        preview: htmlObj,
                        csvUrl: vm.csvUrl

                    },
                    clickOutsideToClose: true,
                    disableBackdrop: true,
                    disableParentScroll: true
                });

                setTimeout(function() {
                var parent = angular.element('#transform-content-wrapper');
                    parent.unbind('$md.dragstart')
                        .unbind('$md.drag')
                        .unbind('$md.dragend');
                }, 1000);
            } else {
                if (vm.reportPrograms.length < 1) {
                    vm.dataMessage = 'Please select at least one data';
                }
            }

        }

        /*
        Function to show preview of presets report
         */
        function presetShowPreview() {
            vm.template.programMessage = '';
            vm.template.baseMessage = '';
            vm.template.branchMessage = '';
            vm.template.batchMessage = '';
            vm.template.dataMessage = '';
            var htmlObj = {
                'cluster_id': vm.template.filters['cluster_id'],
                'batch_id': vm.template.filters['batch_id'],
                'base_ids': vm.template.filters['base_ids[]'],
                'programs': vm.template.filters['programs[]'],
                'start_date': vm.template.start_date ? moment(vm.template.start_date).format() : null,
                'end_date': vm.template.end_date ? moment(vm.template.end_date).format() : null,
                'branch_ids': vm.template.filters['branch_ids[]'],
                'with': 'data'
            };

            if (vm.template.filters['programs[]'].length > 0) {
                $mdBottomSheet.show({
                    controller: 'ReportPreviewController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/transform/tabs/reports/bottom-sheets/report-preview/report-preview.html',
                    parent: '#transform-content-wrapper',
                    locals: {
                        preview: htmlObj,
                        csvUrl: vm.csvUrl
                    },
                    clickOutsideToClose: true,
                    disableBackdrop: true,
                    disableParentScroll: true
                });

                setTimeout(function() {
                var parent = angular.element('#transform-content-wrapper');
                    parent.unbind('$md.dragstart')
                        .unbind('$md.drag')
                        .unbind('$md.dragend');
                }, 1000);
            } else {
                if (vm.template.filters['programs[]'].length < 1) {
                    vm.template.dataMessage = 'Please select at least one data';
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.community')
        .controller('WeeklyController', WeeklyController);

    /** @ngInject */
    function WeeklyController($rootScope, $stateParams, CommunityService, Auth, enumFields) {
        var vm = this;
        var currentUser = Auth.getUser();

        //Methods
        vm.updateWeeklyStats = updateWeeklyStats;
        vm.saveWeeklyStats = saveWeeklyStats;

        vm.weeklyObj = {};

        $rootScope.currentTab = 1;

        vm.communityId = $stateParams.id;

        vm.weeks = [
            'week1',
            'week2',
            'week3',
            'week4',
            'week5',
            'week6',
            'week7',
            'week8',
            'week9',
            'week10',
            'week11',
            'week12',
            'week13',
            'week14',
            'week15',
            'week16'
        ];

        enumFields([
            "community_weekly_stats"
        ]).then(function (value) {
            vm.weeklyStatsFields = value.community_weekly_stats;

            // force logout if the weekly stats fields are not available
            if (!vm.weeklyStatsFields || vm.weeklyStatsFields.length === 0) {
                Auth.logout();
            }

            activate();
        });

        /*
        Function used to get weekly attendance of the community
         */
        function activate() {
            CommunityService.getWeeklyStats(vm.communityId)
                .then(function (response) {
                    vm.weeklyAttendance = response;

                    vm.labels = [];
                    vm.weeklyStatsFields.forEach(function (stat) {
                        // force logout if the extras are not available
                        if (!stat.extras) {
                            Auth.logout();
                        }

                        vm.labels.push({
                            label: stat.label,
                            key: stat.value,
                            data: response[stat.value],
                            type: stat.extras.type,
                            excludes: stat.extras.excludes
                        });
                    });

                    /*
                    This for loop is used to iterate weekly attendance and checks if the objects keys in vm.labels are not null.
                    Tt will assign its keys to vm.weeklyObj which will be used for saving Weekly Attendance
                     */
                    for (var index = 0; index < vm.labels.length; index++) {
                        if (vm.weeklyAttendance[vm.labels[index].key]) {
                            vm.weeklyObj[vm.labels[index].key] = vm.weeklyAttendance[vm.labels[index].key]
                        } else {
                            vm.weeklyObj[vm.labels[index].key] = {};
                        }

                        /*
                        This loop is assigning values with corresponding objects keys to vm.weeklyObj
                         */
                        for (var i = 1; i <= 16; i++) {
                            if (vm.weeklyAttendance[vm.labels[index].key] &&
                                vm.weeklyAttendance[vm.labels[index].key]['week' + i]) {
                                vm.weeklyObj[vm.labels[index].key]['week' + i] = vm.weeklyAttendance[vm.labels[index].key]['week' + i]
                            } else {
                                vm.weeklyObj[vm.labels[index].key]['week' + i] = null;
                            }
                        }
                    }
                });
        }

        /*
        Function used to save weekly attendance
         */
        function saveWeeklyStats() {
            vm.saving = true;
            CommunityService.updateWeeklyStats(vm.communityId, vm.weeklyObj).then(function (response) {
                vm.weeklyObj = response;
                vm.hasEdited = false;
                vm.saving = false;
            });
        }

        /*
        Function triggered upon keyup in the input elements in the weekly stats
        and assign them to vm.weeklyObj
         */
        function updateWeeklyStats(label, weekName, value, vm) {
            vm.hasEdited = true;
            if (value) {
                vm.weeklyObj[label.key][weekName] = value;
            } else {
                vm.weeklyObj[label.key][weekName] = null;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.community')
        .controller('SavingsController', SavingsController);

    /** @ngInject */
    function SavingsController($rootScope,
        $scope,
        $mdDialog,
        $mdBottomSheet,
        $document,
        enumFields,
        $state,
        Auth,
        CommunityService,
        PastorService,
        SavingsGroupService,
        ParticipantService) {
        var vm = this;

        var currentUser = Auth.getUser();

        $rootScope.currentTab = 4;

        vm.participants = [];
        vm.isLoading = false;
        vm.isLoading2 = false;

        vm.savings = {};

        //Methods
        vm.addNonIcmParticipant = addNonIcmParticipant;
        vm.openMenu = openMenu;
        vm.openLeaveSavingsGroupDialog = openLeaveSavingsGroupDialog;
        vm.changeRole = changeRole;
        vm.editContact = editContact;
        vm.editDreamSaveID = editDreamSaveID;
        vm.editSavingsGroup = editSavingsGroup;
        vm.dropParticipant = dropParticipant;
        vm.restoreParticipant = restoreParticipant;
        vm.openSavingsDetails = openSavingsDetails;
        vm.joinExistingGroup = joinExistingGroup;
        vm.canJoinExistingGroup = canJoinExistingGroup;
        vm.formatNumber = formatNumber;

        $scope.$parent.$watch("vm.community", function (community) {
            if (community) {
                vm.community = community;
                activate();
            } else {
                vm.isLoading = true;
                vm.isLoading2 = true;
            }
        });

        enumFields(['sg_roles'])
            .then(function (values) {
                vm.roles = values.sg_roles;
            });

        /*
        Function used to fetch participants and dropped participants in the savings group
         */
        function activate() {
            getParticipants();
            getPastor();
            getDroppedParticipants();
        }

        /*
        Function to get pastor details
        */
        function getPastor() {
            if (!vm.community.application.pastor_id) {
                return;
            }

            var params = {
                community_id: vm.community.id,
                with: "base.districts,district.base,"
            };
            PastorService.getPastor(vm.community.application.pastor_id, params)
                .then(function (response) {
                    vm.isLoading1 = false;
                    if (response) {
                        vm.pastor = [response];
                    }
                })
        }



        /*
        Function used to fetch community details
         */
        function refreshCommunity(community) {
            CommunityService.getCommunity(community.id, { with: 'application,application.pastor,savingsGroupData,savingsGroup' }).then(function (community) {
                vm.community = community;
                $scope.$parent.vm.community = community;
            })
        }

        /*
        Function used to fetch participants
         */
        function getParticipants() {
            vm.isLoading = true;
            vm.participants = [];
            ParticipantService.getParticipants({
                sort: 'lastname:asc,type:asc',
                application_id: vm.community.application_id,
                is_visitor: -1,
                nopage: true,
                is_non_sg: 0
            }).then(function (participants) {
                vm.isLoading = false;
                arrangeRoles(participants);
            });
        }

        /*
        Function used to sort participants by user roles
         */
        function arrangeRoles(participants) {
            filterParticipant('leader', participants);
            filterParticipant('secretary', participants);
            filterParticipant('treasurer', participants);
            filterParticipant('auditor', participants);
            filterParticipant('member', participants);
        }

        /*
        Function used to filter only participants based on the given key
         */
        function filterParticipant(key, participants) {
            participants.filter(function (participant) {
                if (participant.sg_role === key) {
                    vm.participants.push(participant);
                }
            });
        }

        /*
        Function used to fetch dropped participants
         */
        function getDroppedParticipants() {
            vm.isLoading2 = true;
            ParticipantService.getParticipants({
                sort: 'lastname:asc,type:asc',
                is_non_sg: 1,
                application_id: vm.community.application_id,
                nopage: true
            }).then(function (response) {
                vm.isLoading2 = false;
                vm.trashedParticipants = response;
            });
        }

        /*
        Function used to edit savings group
         */
        function editSavingsGroup(savings) {
            var savingsObj = {
                name: savings.name,
                id: vm.community.savings_group.id
            };
            SavingsGroupService.editSavingsGroup(savingsObj)
                .then(function () {
                });
        }

        /*
        Function used to open sg roles menu
         */
        function openMenu($mdMenu, ev) {
            $mdMenu.open(ev);
        }

        /*
        Function used to open change/assign role modal
         */
        function changeRole(participant, role) {
            $mdDialog.show({
                controller: 'AssignRoleController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/tabs/savings/dialogs' +
                    '/assign-role/assign-role-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    participant: participant,
                    role: role,
                    participantsList: vm.participants,
                    callback: getParticipants
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to open join existing group modal
         */
        function joinExistingGroup(community) {
            $mdDialog.show({
                controller: 'JoinExistingGroupController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/tabs/savings/dialogs' +
                    '/join-existing-group/join-existing-group-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    fromPrevail: false,
                    community: community,
                    callback: function () {
                        refreshCommunity(community);
                    }
                },
                clickOutsideToClose: true
            });
        }

        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.dropParticipant(participant),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to drop a participant in the sg participants list
         */
        function dropParticipant(participant) {
            var participantObj = {};
            participantObj.is_non_sg = 1;
            participantObj.id = participant.id;
            participantObj.application_id = participant.application_id;

            ParticipantService.editParticipant(participantObj)
                .then(function () {
                    getParticipants();
                    getDroppedParticipants();
                });
        }

        /*
        Function used to restore a dropped participant
         */
        function restoreParticipant(participant) {
            var participantObj = {};
            participantObj.is_non_sg = 0;
            participantObj.id = participant.id;
            participantObj.application_id = participant.application_id;
            ParticipantService.editParticipant(participantObj)
                .then(function () {
                    getParticipants();
                    getDroppedParticipants();
                })
        }

        /*
        Function used to open edit contact modal
         */
        function editContact(participant) {
            if (!vm.community.savings_group && currentUser.$roles.has(['admin', 'metrics', 'livelihood_coordinator', 'livelihood_trainer', 'branch_head', 'health_mentor'])) {
                $mdDialog.show({
                    controller: 'EditContactController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/community/tabs/savings/dialogs' +
                        '/edit-contact-no/edit-contact-no-dialog.html',
                    parent: angular.element($document.body),
                    locals: {
                        participant: participant,
                        callback: getParticipants
                    },
                    clickOutsideToClose: true
                });
            }
        }


        /*
        Function used to open edit DreamSave ID modal
         */
        function editDreamSaveID(participant) {
            if (!vm.community.savings_group && currentUser.$roles.has(['admin', 'metrics', 'livelihood_coordinator', 'livelihood_trainer', 'branch_head', 'health_mentor'])) {
                $mdDialog.show({
                    controller: 'EditDreamSaveIdController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/community/tabs/savings/dialogs/edit-dream-save-id/edit-dream-save-id-dialog.html',
                    parent: angular.element($document.body),
                    locals: {
                        participant: participant,
                        callback: function () {
                            getParticipants(vm.savings);
                        }
                    },
                    clickOutsideToClose: true
                });
            }
        }

        /*
        Function used to open add non-icm participant modal
         */
        function addNonIcmParticipant() {
            $mdDialog.show({
                controller: 'AddNonICMParticipantController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/tabs/savings/dialogs' +
                    '/add-non-icm-participant/add-non-icm-participant-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    participantsList: vm.participants,
                    callback: getParticipants,
                    community: vm.community
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to open the leave savings group modal
         */
        function openLeaveSavingsGroupDialog(participant) {
            if (currentUser.$roles.has(['admin', 'metrics', 'livelihood_coordinator', 'health_mentor'])) {
                $mdDialog.show({
                    controller: 'LeaveSavingsGroupDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/community-savings-group/tabs/members/dialogs' +
                        '/leave-savings-group/leave-savings-group-dialog.html',
                    parent: angular.element($document.body),
                    locals: {
                        participant: participant,
                        callback: function () {
                            getDroppedParticipants();
                            return getParticipants();
                        }
                    },
                    clickOutsideToClose: true
                });
            }
        }

        /*
        Function used to open savings group details bottom sheet
         */
        function openSavingsDetails(savings) {
            if ($state.current.name !== "app.community.savings.details") {
                $state.go("app.community.savings.details", {
                    id: $state.params.id,
                    savingsId: savings.id
                }, false);
            }

            $mdBottomSheet.show({
                controller: 'SavingsGroupDetailsController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/tabs/savings/bottom-sheets/' +
                    'savings-group-details/savings-group-details.html',
                parent: '#community-content-wrapper',
                clickOutsideToClose: true,
                disableBackdrop: true,
                disableParentScroll: true,
                locals: {
                    callback: function () {
                        refreshCommunity(savings);
                    },
                    community: savings
                }
            })
                .then(handleSavingsGroupCloseEvent.bind(vm))
                .catch(handlSavingsGroupError.bind(vm));

            setTimeout(function () {
                var parent = angular.element('#community-content-wrapper');
                parent.unbind('$md.dragstart')
                    .unbind('$md.drag')
                    .unbind('$md.dragend');
            }, 1000);
        }

        //checks if the state is in the details, it will open the bottom sheet
        if ($state.current.name == "app.community.savings.details") {
            CommunityService.getCommunity($state.params.savingsId, { with: 'application,application.pastor,savingsGroupData,savingsGroup' })
                .then(function (savings) {
                    openSavingsDetails(savings);
                }).catch(handlSavingsGroupError.bind(vm));
        }

        /*
        Function triggered when closing the savings group details bottom sheet
         */
        function handleSavingsGroupCloseEvent() {
            if ($state.current.name === 'app.community.savings.details') {
                $('.content-white-holder').removeClass('bcopen');
                $state.go("app.community.savings", { id: $state.params.id });
            }
        }

        /*
        Function checks if there are error in opening savings group details bottom sheet,
        it will just go to community savings state
         */
        function handlSavingsGroupError(res) {
            $('.content-white-holder').removeClass('bcopen');
            $state.go("app.community.savings", { id: $state.params.id });
        }

        function canJoinExistingGroup() {
            if (vm.community &&
                vm.community.application &&
                vm.community.application.program &&
                vm.community.application.program.name) {

                return !/transform\s(level 1|with fa)/gi.test(vm.community.application.program.name);
            }

            return true;
        }


        function formatNumber(input) {
            if (!input) return
            // Remove any non-digit characters
            const digitsOnly = input.replace(/\D/g, '');

            // Apply the desired pattern
            const formattedNumber = digitsOnly.replace(/(\d{3})(\d{3})(\d{3})/, '$1-$2-$3');

            return formattedNumber;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.community')
        .controller('HbfController', HbfController);

    /** @ngInject */
    function HbfController($rootScope,
                           $mdDialog,
                           $mdBottomSheet,
                           $document,
                           $state,
                           $stateParams,
                           HbfService,
                           ParticipantService,
                           FormFieldService,
                           Auth) {
        var vm = this;
        var currentUser = Auth.getUser();

        vm.$state = $state;

        //Methods
        vm.addCardSaving = false;
        vm.addCard = addCard;
        vm.cancelCard = cancelCard;
        vm.addHbf = addHbf;
        vm.softDeleteHbf = softDeleteHbf;
        vm.restoreHbf = restoreHbf;
        vm.hardDeleteHbf = hardDeleteHbf;
        vm.selectGuardian = selectGuardian;
        vm.searchGuardians = searchGuardians;
        vm.disableLogWeight = disableLogWeight;
        vm.logWeight = logWeight;
        vm.showLightBox = showLightBox;
        vm.replacePhoto = replacePhoto;
        vm.removePhoto = removePhoto;
        vm.showHbfDetails = showHbfDetails;
        vm.refreshHbfs = refreshHbfs;
        vm.calculateAge = calculateAge;
        vm.bustCache = bustCache;

        vm.selectedGuardian = null;

        vm.calculateScore = calculateScore.bind(this);

        vm.isLoadingHbfs = false;

        vm.$hbf = HbfService;

        vm.apiErrors = [];

        vm.hbfs = [];
        vm.trashedHbfs = [];

        $rootScope.currentTab = 3;

        vm.communityId = $stateParams.id;
        vm.weeks = [
            {label: 2, value: 2},
            {label: 3, value: 3},
            {label: 4, value: 4},
            {label: 5, value: 5},
            {label: 6, value: 6}
        ];
        vm.toAddCards = [];
        vm.defaultThumb = 'http://via.placeholder.com/200x200/ffffff/4575BE?text=UPLOAD';


        refreshHbfs();

        /*
        Function that fetches hbfs
         */
        function refreshHbfs() {
            getHbfs();
        }

        vm.childRelationships = [];
        vm.genders = [];

        if (localStorage.getItem('childRelationships')
            && localStorage.getItem('genders')) {
            vm.childRelationships = JSON.parse(localStorage.getItem('childRelationships'));
            vm.genders = JSON.parse(localStorage.getItem('genders'));
        } else {
            FormFieldService.getFields().then(function (response) {
                angular.forEach(response.child_relationship.definition, function (venue) {
                    vm.childRelationships.push({
                        label: venue.label,
                        value: venue.value
                    });

                });
                vm.childRelationships.push({
                    label: 'Other',
                    value: 'Other'
                });
                localStorage.setItem('childRelationships', JSON.stringify(vm.childRelationships));

                angular.forEach(response.gender.definition, function (venue) {
                    vm.genders.push({
                        label: venue.label,
                        value: venue.value
                    });

                });
                localStorage.setItem('genders', JSON.stringify(vm.genders));
            });
        }

        /*
        Function that gets hbfs
         */
        function getHbfs() {
            vm.isLoadingHbfs = true;
            vm.hbfs = [];
            vm.trashedHbfs = [];
            var params = {
                with: 'weightLogs,community,community.application,participant,notes',
                nopage: true,
                community_id: vm.communityId,
                sort : 'created_at:asc'
            };

            if (currentUser.base_id) {
                params.base_id = currentUser.base_id;
            }

            HbfService.getHbfs(params).then(function (response) {
                vm.tempHbfs = response.map(function (item) {
                    var lastNoteIndex = item.notes.length - 1;
                    var lastNote = item.notes[lastNoteIndex];
                    item.current_weight_log = angular.extend({}, item.current_weight_log, lastNote);

                    return item;
                });

                vm.samHbfs = vm.tempHbfs.filter(function(hbf) {
                   if(!hbf.initial_weight_log || hbf.initial_weight_log.code === 'SAM')
                       return hbf;
                });

                vm.mamHbfs = vm.tempHbfs.filter(function(hbf) {
                    if(hbf.initial_weight_log.code === 'MAM')
                        return hbf;
                });

                vm.normalHbfs = vm.tempHbfs.filter(function(hbf) {
                    if(hbf.initial_weight_log.code === 'NORMAL')
                        return hbf;
                });

                vm.curedHbfs = vm.tempHbfs.filter(function(hbf) {
                    if(hbf.initial_weight_log.code === 'CURED')
                        return hbf;
                });

                pushItem(vm.hbfs, vm.samHbfs);
                pushItem(vm.hbfs, vm.mamHbfs);
                pushItem(vm.hbfs, vm.normalHbfs);
                pushItem(vm.hbfs, vm.curedHbfs);

                // vm.
                vm.isLoadingHbfs = false;

                var params2 = {
                    nopage : true,
                    community_id : vm.communityId,
                    trashed : 1,
                    sort : 'created_at:asc'
                };

                if (currentUser.base_id) {
                    params2.base_id = currentUser.base_id;
                }

                HbfService.getHbfs(params2).then(function (response) {
                    vm.tempHbfs2 = response;

                    var samHbfs = vm.tempHbfs2.filter(function(hbf) {
                        if(hbf.condition.code === 'SAM')
                            return hbf;
                    });

                    var mamHbfs = vm.tempHbfs2.filter(function(hbf) {
                        if(hbf.condition.code === 'MAM')
                            return hbf;
                    });

                    var normalHbfs = vm.tempHbfs2.filter(function(hbf) {
                        if(hbf.condition.code === 'NORMAL')
                            return hbf;
                    });

                    var curedHbfs = vm.tempHbfs2.filter(function(hbf) {
                        if(hbf.condition.code === 'CURED')
                            return hbf;
                    });

                    pushItem(vm.trashedHbfs, samHbfs);
                    pushItem(vm.trashedHbfs, mamHbfs);
                    pushItem(vm.trashedHbfs, normalHbfs);
                    pushItem(vm.trashedHbfs, curedHbfs);
                });
            });
        }

        /*
        Function that pushes an item to array
         */
        function pushItem(destination, source) {
            for(var i = 0; i < source.length ; i++) {
                destination.push(source[i]);
            }
        }

        /*
        Function that soft deletes hbf
         */
        function softDeleteHbf(hbfRemove) {
            $mdDialog.show({
                controller: 'DropHbfDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/templates/drop-dialog/drop-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    callback: function () {
                        HbfService.softDeleteHbf(hbfRemove).then(function () {
                            getHbfs();
                        })
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that hard deletes hbf
         */
        function hardDeleteHbf(hbfRemove) {
            $mdDialog.show({
                controller: 'DeleteHbfDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/tabs/hbf/dialogs/delete-hbf/delete-hbf-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    callback: function () {
                        HbfService.hardDeleteHbf(hbfRemove).then(function () {
                            vm.trashedHbfs = vm.trashedHbfs.filter(function (hbf) {
                                return hbf.id != hbfRemove.id;
                            })
                            getHbfs();
                        });
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that restores a soft deleted hbf
         */
        function restoreHbf(hbf) {
            HbfService.restoreHbf(hbf).then(function () {
                getHbfs();
            })
        }

        /*
        Function that checks if weight logs already reached 14 and disables log weight button
         */
        function disableLogWeight(hbf) {
            var length = 0;
            angular.forEach(hbf.weight_logs, function (value) {
                length++;
            });

            return length === 14 || hbf.current_weight_log.discharge;
        }

        /*
        Function that adds a card in hbf
         */
        function addCard() {
            var cardsLength = vm.toAddCards.length;

            vm.toAddCards.push({
                id: cardsLength,
                week_no: 2,
                weight_at: new Date(),
                gender: 'male'
            });
        }

        /*
        Function that saves and adds a hbf
         */
        function addHbf(form, card) {
            card.apiErrors = {};
            vm.addCardSaving = true;

            var hbfObj = {
                community_id: vm.communityId,
                photo: card.photo || null,
                week_no: card.week_no || null,
                child_firstname: card.child_firstname || null,
                child_lastname: card.child_lastname || null,
                relationship: card.other ? card.other : card.relationship,
                contact_no: card.contact_no || '',
                birthdate: card.birthdate ? moment(card.birthdate).format("LL") : null,
                weight_kg: card.weight_kg || null,
                height_cm: card.height_cm || null,
                gender: card.gender || null,
                weight_at: card.weight_at ? moment(card.weight_at).format("LL") : null,
                target_weight: card.target_weight || null,
                breastfeeding: card.breastfeeding ? 1 : 0,
                abcdef_test: card.abcdef_test ? 1 : 0,
                appetite_test: card.appetite_test ? 1 : 0,
                // rhu_check: card.rhu_check ? 1 : 0,
                with: 'participant,notes'
            };

            if (card.selectedGuardian) {
                hbfObj.participant_id = card.selectedGuardian.id;
            } else {
                hbfObj.guest_name = card.searchGuardian;
            }

            HbfService.addHbf(hbfObj).then(function (response) {
                vm.hbfs.push(response);

                switch (response.initial_weight_log.code) {
                    case 'SAM': vm.samHbfs.push(response); break;
                    case 'MAM': vm.mamHbfs.push(response); break;
                    case 'NORMAL': vm.normalHbfs.push(response); break;
                    case 'CURED': vm.curedHbfs.push(response); break;
                }

                vm.toAddCards = vm.toAddCards.filter(function (item) {
                    if (item.id != card.id) {
                        return item;
                    }
                });

                vm.addCardSaving = false;
            }).catch(function (response) {
                form.$invalid = true;

                for (var field in response.data.errors) {
                    card.apiErrors[field] = response.data.errors[field].shift();
                }

                vm.addCardSaving = false;
            });
        }

        /*
        Function that cancels a hbf card
         */
        function cancelCard(cardRemove) {
            vm.toAddCards = vm.toAddCards.filter(function (card) {
                if (card.id != cardRemove.id) {
                    return card;
                }
            })
        }

        /*
        Function that calculates wasting score
         */
        function calculateScore(form, card) {
            var vm = this;
            card.apiErrors = [];
            card.calculatedScore = null;

            vm.$hbf.calculateScore(card)
                .then(function (response) {
                    card.calculatedScore = response.data;
                    card.target_weight = response.data.target_weight;
                })
                .catch(function (response) {
                    form.$invalid = true;

                    for (var field in response.data.errors) {
                        card.apiErrors[field] = response.data.errors[field].shift();
                    }
                });
        }

        /*
        Function that searches a guardian from participant table
         */
        function searchGuardians(communityId, query) {
            return ParticipantService.getParticipants({
                search: query,
                qualified: 1,
                community_id: communityId
            }).then(function(response) {
                return response.data;
            })
        }

        /*
        Function that selects a guardian from participant table
         */
        function selectGuardian(guardian) {
            vm.selectedGuardian = guardian;
        }

        /*
        Function that opens log weight modal
         */
        function logWeight(hbf) {
            $mdDialog.show({
                controller: 'AddWeightLogDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/tabs/hbf/dialogs/add-weight-log/add-weight-log-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    hbf: hbf,
                    callback: refreshHbfs
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that opens full view of image using modal
         */
        function showLightBox(photo, ev) {
            if (photo) {
                $mdDialog.show({
                    controller: 'LightboxDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/community/tabs/hbf/dialogs/lightbox/lightbox-dialog.html',
                    parent: angular.element($document.body),
                    locals: {
                        photo: photo,
                        ev: ev
                    },
                    clickOutsideToClose: true
                });
            }
        }

        /*
        Function that uploads a before or after photo
         */
        function replacePhoto(hbf, action, ev) {
            if (action != "before" && action != "after") return;

            if (!currentUser.$roles.has(['pastor_coordinator', 'livelihood_coordinator', 'livelihood_trainer', 'donor_services', 'donor_managers', 'view_only', 'area_head', 'health_mentor'])) {
                $mdDialog.show({
                    controller: 'ReplacePhotoDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/community/tabs/hbf/dialogs/replace-photo/replace-photo-dialog.html',
                    parent: angular.element($document.body),
                    locals: {
                        hbf: hbf,
                        action: action,
                        callback: refreshHbfs
                    },
                    clickOutsideToClose: true
                });
            }
        }

        /*
        Function that removes before or after photo
         */
        function removePhoto(hbf, action, ev) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure you want to want to delete this photo?')
                .targetEvent(ev)
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function () {
                if (action == 'before') {
                    HbfService.deleteBeforePhoto(hbf.id).then(function () {
                        refreshHbfs();
                    });

                    hbf.before_photo = null;
                    hbf.before_photo_url = null;
                } else {
                    HbfService.deleteAfterPhoto(hbf.id).then(function () {
                        refreshHbfs();
                    });

                    hbf.after_photo = null;
                    hbf.after_photo_url = null;
                }
            }, function () {
                // cancel action
            });
        }

        /*
        Function that display hbf details modal
         */
        function showHbfDetails(hbf) {
            if ($state.current.name !== "app.community.hbf.details") {
                $state.transitionTo("app.community.hbf.details", {
                    id: $state.params.id,
                    hbfid: hbf.id
                }, false);
            }

            $mdBottomSheet.show({
                controller: 'HbfDetailsContentController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/tabs/hbf/bottom-sheets/hbf-details/hbf-details.html',
                parent: '#community-content-wrapper',
                clickOutsideToClose: false,
                disableBackdrop: true,
                disableParentScroll: true,
                locals: {
                    hbf: hbf,
                    refreshHbfs: refreshHbfs,
                    callback: getHbfs
                }
            })
                .then(handleHbfCloseEvent.bind(this))
                .catch(handleHbfDetailsError.bind(this));

            setTimeout(function() {
                var parent = angular.element('#community-content-wrapper');
                parent.unbind('$md.dragstart')
                    .unbind('$md.drag')
                    .unbind('$md.dragend');
            }, 1000);

        }

        //checks if the state is in details it will open hbf bottom sheet
        if ($state.current.name == "app.community.hbf.details") {
            HbfService.getHbf(
                $state.params.hbfid,
                {
                    with : 'participant,notes'
                }
            ).then(function (hbf) {
                showHbfDetails(hbf);
            }).catch(handleHbfDetailsError.bind(this));
        }

        /*
        Function that handles hbf close event
         */
        function handleHbfCloseEvent() {
            if ($state.current.name === 'app.community.hbf.details') {
                $('.content-white-holder').removeClass('bcopen');
                this.$state.go("app.community.hbf", {id: this.$state.params.id});
            }
        }

        /*
        Function that handles hbf details error
         */
        function handleHbfDetailsError() {
            var state = this && this.$state ? this.$state : $state;

            refreshHbfs();
            $('.content-white-holder').removeClass('bcopen');

            if (state) {
                state.go("app.community.hbf", {id: state.params.id});
            }
        }

        /*
        Function that calculates child age
         */
        function calculateAge(card) {
            if (card.birthdate) {
                card.age = {
                    months: moment().diff(card.birthdate, 'months'),
                    years: moment().diff(card.birthdate, 'years')
                }
            } else {
                delete card.age;
            }
        }

        /*
         * Forces browser to reload a resource by appending
         * a unique timestamp as a cache-busting query parameter
         */
        function bustCache(url, uniqueKey) {
            if (!url) {
                return vm.defaultThumb;
            };

            if (!uniqueKey) {
                uniqueKey = Math.random();
            }

            const separator = url.includes('?') ? '&' : '?';
            return url + separator + 'v=' + uniqueKey;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.community')
        .controller('BusinessLoansController', BusinessLoansController);

    /** @ngInject */
    function BusinessLoansController($rootScope,
        $mdDialog,
        $mdToast,
        $document,
        $stateParams,
        BusinessLoansService,
        ProductService,
        Auth,
        CommunityService) {

        var vm = this;
        var currentUser = Auth.getUser();

        vm.communityId = $stateParams.id;
        vm.batchId = null;
        vm.loans = [];
        vm.products = [];
        vm.isLoading = false;

        vm.addLoan = addLoan;
        vm.updateLoanAmount = updateLoanAmount;
        vm.deleteLoan = deleteLoan;

        $rootScope.currentTab = 5;

        initBusinessLoans();

        function initBusinessLoans() {
            vm.isLoading = true;
            getProducts();
            CommunityService.getCommunity(vm.communityId).then(function (community) {
                vm.batchId = community.batch_id;
                getBusinessLoans();
            }).catch(function () {
                $mdToast.show($mdToast.simple().textContent('Failed to load community information.').toastClass('toast-error').position('bottom right').hideDelay(4000));
                vm.isLoading = false;
            });
        }

        function getBusinessLoans() {
            vm.isLoading = true;
            BusinessLoansService.getBusinessLoans({
                nopage: true,
                community_id: vm.communityId,
                batch_id: vm.batchId,
                with: 'product'
            }).then(function (loans) {
                vm.loans = loans;
                vm.isLoading = false;
            }).catch(function () {
                $mdToast.show($mdToast.simple().textContent('Failed to load business loans.').toastClass('toast-error').position('bottom right').hideDelay(4000));
                vm.isLoading = false;
            });
        }

        function getProducts() {
            ProductService.getProducts({ nopage: true })
                .then(function (products) {
                    vm.products = products;
                });
        }

        function addLoan() {
            var usedProductIds = vm.loans.map(function (loan) { return loan.product_id; });
            var availableProducts = vm.products.filter(function (product) {
                return usedProductIds.indexOf(product.id) === -1;
            });

            $mdDialog.show({
                controller: 'AddBusinessLoanDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/tabs/business-loans/dialogs/add-business-loan/add-business-loan-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    communityId: vm.communityId,
                    batchId: vm.batchId,
                    products: availableProducts,
                    callback: getBusinessLoans
                },
                clickOutsideToClose: true
            });
        }

        function updateLoanAmount(loan) {
            if (!loan.id) {
                BusinessLoansService.addBusinessLoan({
                    community_id: vm.communityId,
                    batch_id: vm.batchId,
                    product_id: loan.product_id,
                    loan_amount: loan.loan_amount
                }).then(function () {
                    getBusinessLoans();
                }).catch(function (error) {
                    var message = 'Failed to update loan.';
                    $mdToast.show($mdToast.simple().textContent(message).toastClass('toast-error').position('bottom right').hideDelay(4000));
                });
                return;
            }

            BusinessLoansService.updateBusinessLoan(loan.id, {
                loan_amount: loan.loan_amount,
                batch_id: vm.batchId
            }).catch(function (error) {
                var message = 'Failed to update loan.';
                $mdToast.show($mdToast.simple().textContent(message).toastClass('toast-error').position('bottom right').hideDelay(4000));
            });
        }

        function deleteLoan(loan) {
            $mdDialog.show({
                controller: 'DeleteBusinessLoanDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    callback: function () {
                        BusinessLoansService.deleteBusinessLoan(loan.id).then(function () {
                            getBusinessLoans();
                        });
                    }
                },
                clickOutsideToClose: true
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.community')
        .controller('BibController', BibController);

    /** @ngInject */
    function BibController($rootScope,
        $mdDialog,
        $document,
        $state,
        $mdBottomSheet,
        $stateParams,
        BibService,
        ProductService,
        Auth) {
        var vm = this;
        var currentUser = Auth.getUser();
        vm.$state = $state;

        //Methods
        vm.addCard = addCard;
        vm.cancelCard = cancelCard;
        vm.addBib = addBib;
        vm.softDeleteBib = softDeleteBib;
        vm.bulkDeleteBib = bulkDeleteBib;
        vm.restoreBib = restoreBib;
        vm.hardDeleteBib = hardDeleteBib;
        vm.updateBib = updateBib;
        vm.showBibParticipants = showBibParticipants;
        vm.handleRepayment = handleRepayment;
        // vm.repayment = repayment;

        vm.isLoadingBibs = false;

        $rootScope.currentTab = 2;

        vm.communityId = $stateParams.id;
        vm.weeks = [];

        for (var x = 4; x <= 15; x++) {
            vm.weeks.push(
                {
                    label: 'Week ' + x,
                    value: x
                }
            );
        }
        vm.toAddCards = [];

        initBib();

        /*
        Function that fetches bibs and products
         */
        function initBib() {
            getBibs();
            getProducts();
        }

        vm.bulkDeleteIDs = [];

        vm.bulkDelete = function (bib) {
            if (vm.bulkDeleteIDs.includes(bib.id)) {
                vm.bulkDeleteIDs = vm.bulkDeleteIDs.filter((_id) => _id !== bib.id)
            } else {
                vm.bulkDeleteIDs.push(bib.id)
            }
        }

        vm.isChecked = function (bib) {
            return vm.bulkDeleteIDs.includes(bib.id)
        }

        // For trashed BIB
        vm.bulkTrashedIDs = [];

        vm.bulkTrashed = function (bib) {
            if (vm.bulkTrashedIDs.includes(bib.id)) {
                vm.bulkTrashedIDs = vm.bulkTrashedIDs.filter((_id) => _id !== bib.id)
            } else {
                vm.bulkTrashedIDs.push(bib.id)
            }
        }

        vm.isCheckedTrashed = function (bib) {
            return vm.bulkTrashedIDs.includes(bib.id)
        }


        /*
        Function that fetches products
         */
        function getProducts() {
            ProductService.getProducts({ nopage: true })
                .then(function (products) {
                    vm.products = products;
                });
        }

        /*
        Function that updates bib product or capital
         */
        function updateBib(bib, value, mode) {
            // vm.show = true;

            // console.log(vm.show);
            // console.log('update' + bib.product.repayment, value, JSON.stringify(bib));
            // if (bib.product.repayment == 1) {
            //     vm.show = false;
            // }
            // else {
            //     vm.show = true;
            // }
            var updateBibObj = {};
            if (mode === 'product') {
                updateBibObj.product_id = value;
            } else if (mode === 'capital') {
                updateBibObj.capital = value;
            } else if (mode === 'repayment') {
                updateBibObj.repayment = !value;
            }
            BibService.updateBib(bib.id, updateBibObj);
            initBib();
        }

        /*
     Function use to handle change repayment status
      */
        function handleRepayment(bib, value, mode) {
            $mdDialog.show({
                controller: 'RepaymentBibDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/tabs/bib/dialogs/repayment-bib/repayment-bib-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    callback: function () {
                        updateBib(bib, value, mode)
                    },
                    initBib: initBib
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that fetches bibs
         */
        function getBibs() {
            vm.isLoadingBibs = true;
            var params = {};
            params.nopage = true;
            params.community_id = vm.communityId;
            params.with = 'community,product';

            if (currentUser.base_id) {
                params.base_id = currentUser.base_id;
            }

            BibService.getBibs(params).then(function (response) {
                vm.bibs = response;
                vm.bibs = vm.bibs.map(function (bib) {
                    vm.weeks = vm.weeks.filter(ele => ele.value != bib.week);
                    bib.repayment = typeof (bib.repayment) == 'object' ? false : bib.repayment ? false : true;
                    return bib;
                });

                vm.isLoadingBibs = false;
                var params2 = {};
                params2.nopage = true;
                params2.community_id = vm.communityId;
                params2.with = 'community,product';
                params2.trashed = 1;

                if (currentUser.base_id) {
                    params2.base_id = currentUser.base_id;
                }

                BibService.getTrashedBibs(params2).then(function (response) {
                    vm.trashedBibs = response;
                    vm.trashedBibs = vm.trashedBibs.map(function (bib) {
                        vm.weeks = vm.weeks.filter(ele => ele.value != bib.week);
                        bib.repayment = typeof (bib.repayment) == 'object' ? false : bib.repayment ? false : true;
                        return bib;
                    });
                });
            });
        }

        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(bulkDeleteIDs, isDeleted) {
            if (!isDeleted) {
                if (!bulkDeleteIDs.length) {
                    return;
                }

                $mdDialog.show({
                    controller: 'PasswordConfirmationDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                    parent: angular.element($document.body),
                    locals: {
                        deleteCallback: () => vm.bulkDeleteBib(bulkDeleteIDs, isDeleted),
                        callback: function () {
                        }
                    },
                    clickOutsideToClose: true
                });

            } else {
                if (!bulkDeleteIDs.length) {
                    return;
                }

                $mdDialog.show({
                    controller: 'DeleteBibDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/community/tabs/bib/dialogs/delete-bib/delete-bib-dialog.html',
                    parent: angular.element($document.body),
                    locals: {
                        callback: () => vm.bulkDeleteBib(bulkDeleteIDs, isDeleted),
                    },
                    clickOutsideToClose: true
                });
            }
        }

        /*
        Function that bulk deletes bib
         */
        function bulkDeleteBib(bibRemove, isDeleted) {

            // Prepare URL-encoded data
            const urlencoded = new URLSearchParams();
            bibRemove.forEach(id => urlencoded.append("community_bibs_ids[]", id));

            // Call the delete function with formatted data
            BibService.bulkDeleteBib(urlencoded.toString()).then(function () {
                getBibs();
                if (isDeleted) {
                    vm.bulkTrashedIDs = [];
                } else {
                    vm.bulkDeleteIDs = [];
                }
            })
        }

        /*
        Function that soft deletes bib
         */
        function softDeleteBib(bibRemove) {
            BibService.softDeleteBib(bibRemove).then(function () {
                getBibs()
            })
        }

        /*
        Function that hard deletes bib
         */
        function hardDeleteBib(bibRemove) {
            $mdDialog.show({
                controller: 'DeleteBibDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/tabs/bib/dialogs/delete-bib/delete-bib-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    callback: function () {
                        BibService.hardDeleteBib(bibRemove).then(function () {
                            vm.trashedBibs = vm.trashedBibs.filter(function (bib) {
                                return bib.id != bibRemove.id;
                            })
                        });
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that restores bib
         */
        function restoreBib(bib) {
            BibService.restoreBib(bib).then(function () {
                getBibs()
            })
        }

        // function repayment(id, product) {
        //     console.log("--" + id, product);
        //     for (let i = 0; i < product.length; i++) {
        //         const element = product[i];
        //         // console.log(element.id);
        //         if (element.id == id) {
        //             console.log(element.id, element.repayment);
        //             if (element.repayment = 0) {
        //                 vm.show = false;
        //             }
        //             else {
        //                 vm.show = true;
        //             }
        //             console.log(vm.show);
        //         }
        //     }


        // }

        /*
        Function to add card
         */
        function addCard(product) {
            var cardsLength = vm.toAddCards.length;
            vm.toAddCards.push({
                id: cardsLength,
                repayment: false
            });

        }

        /*
        Function to add bib
         */
        function addBib(cardRemove) {
            getBibs();
            var bibObj = {
                community_id: vm.communityId,
                product_id: cardRemove.product,
                week: cardRemove.week,
                capital: cardRemove.capital,
                repayment: !cardRemove.repayment
            };

            BibService.addBib(bibObj).then(function (response) {
                getBibs();
                vm.toAddCards = vm.toAddCards.filter(function (card) {
                    if (card.id != cardRemove.id) {
                        return card;
                    }
                });
            });
        }

        /*
        Function to cancel add card
         */
        function cancelCard(cardRemove) {
            vm.toAddCards = vm.toAddCards.filter(function (card) {
                if (card.id != cardRemove.id) {
                    return card;
                }
            })
        }

        /*
        Function to show bib participants bottom sheet
         */
        function showBibParticipants(bib) {
            if ($state.current.name !== "app.community.bib.participants") {
                $state.transitionTo("app.community.bib.participants", {
                    id: $state.params.id,
                    bibid: bib.id
                }, false);
            }

            $mdBottomSheet.show({
                controller: 'BibParticipantsContentController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/tabs/bib/bottom-sheets/bib-participants/bib-participants.html',
                parent: '#community-content-wrapper',
                clickOutsideToClose: true,
                disableBackdrop: true,
                disableParentScroll: true,
                locals: {
                    bib: bib,
                    callback: initBib
                }
            })
                .then(handleBibParticipantCloseEvent.bind(vm))
                .catch(handleBibParticipantsError.bind(vm));

            setTimeout(function () {
                var parent = angular.element('#community-content-wrapper');
                parent.unbind('$md.dragstart')
                    .unbind('$md.drag')
                    .unbind('$md.dragend');
            }, 1000);
        }

        //checks if the state is in bib participant, it will open bib bottom sheet
        if ($state.current.name == "app.community.bib.participants") {
            BibService.getBib($state.params.bibid).then(function (bib) {
                showBibParticipants(bib);
            }).catch(handleBibParticipantsError.bind(vm));
        }

        /*
        Function that handles bottom sheet close event
         */
        function handleBibParticipantCloseEvent() {
            if ($state.current.name === 'app.community.bib.participants') {
                $('.content-white-holder').removeClass('bcopen');
                this.$state.go("app.community.bib", { id: this.$state.params.id });
            }
        }

        /*
        Function that handles bottom sheet error
         */
        function handleBibParticipantsError(res) {
            $('.content-white-holder').removeClass('bcopen');
            this.$state.go("app.community.bib", { id: this.$state.params.id });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.community')
        .controller('AttendanceController', AttendanceController);

    /** @ngInject */
    function AttendanceController($rootScope,
        $scope,
        $mdDialog,
        $state,
        $mdBottomSheet,
        $document,
        api,
        PastorService,
        ParticipantService,
        Auth) {
        var vm = this;
        var currentUser = Auth.getUser();

        //Methods
        vm.addParticipantAttendance = addParticipantAttendance;
        vm.addParticipant = addParticipant;
        vm.menuItemClick = menuItemClick;
        vm.openMenu = openMenu;
        vm.softDeleteParticipant = softDeleteParticipant;
        vm.editParticipant = editParticipant;
        vm.addPastorAttendance = addPastorAttendance;
        vm.pastorMenuItemClick = pastorMenuItemClick;
        vm.saveAttendance = saveAttendance;
        vm.showDisqualifiedParticipants = showDisqualifiedParticipants;
        vm.showVisitors = showVisitors;
        vm.showDroppedParticipants = showDroppedParticipants;
        vm.hasAttendance = hasAttendance;
        vm.api = api;
        vm.issuesDialog = issuesDialog;

        $rootScope.currentTab = 0;

        vm.isLoading = false;

        vm.attendanceArray = [];

        vm.bulkDeleteIDs = [];

        vm.bulkDelete = function (Participant) {
            if (vm.bulkDeleteIDs.includes(Participant.id)) {
                vm.bulkDeleteIDs = vm.bulkDeleteIDs.filter((_id) => _id !== Participant.id)
            } else {
                vm.bulkDeleteIDs.push(Participant.id)
            }
        }

        vm.isChecked = function (Participant) {
            return vm.bulkDeleteIDs.includes(Participant.id)
        }

        vm.weeks = [
            "garden_week1",
            "garden_week14",
            "week_existing_church_member",
            "h2h_week1",
            "h2h_week2",
            "h2h_week3",
            "h2h_week4",
            "week1",
            "week2",
            "week3",
            "week4",
            "week5",
            "week6",
            "week7",
            "week8",
            "week9",
            "week10",
            "week11",
            "week12",
            "week13",
            "week14",
            "week15",
            "week_attend_church",
            "week_religious_meeting",
            "week_became_church_member",
        ];

        vm.certificates = [
            'bcr',
            'mcr'
        ];

        vm.options = [
            {
                label: 'Required',
                icon: 'icon-check'
            },
            {
                label: 'Not Required',
                icon: 'icon-close text-danger'
            },
            {
                label: 'Obtained',
                icon: 'icon-check-all'
            }
        ];

        vm.has_16_weeks = false;
        $scope.$parent.$watch("vm.community", function (community) {
            if (community) {
                vm.community = community;

                // append week16 if program has 16 weeks
                if (community.application.program && community.application.program.has_16th_week) {
                    vm.has_16_weeks = true;
                    vm.weeks.push("week16");
                }

                initAttendance();
            } else {
                vm.isLoading = true;
            }
        });

        $scope.$on('$stateChangeStart', function (event) {
            if (vm.participantHasEdit || vm.pastorHasEdit) {
                var answer = confirm("Changes have been made. Are you sure you want to leave this page?");
                if (!answer) {
                    event.preventDefault();
                    $rootScope.currentTab = 0;
                }
            }
        });

        /*
        Function to get and initialize pastor
         */
        function initAttendance() {
            getPastor();
        }

        /*
        Function triggered when clicking Save attendance to save attendance data
         */
        function saveAttendance() {
            vm.saving = true;
            var data = {
                data: vm.attendanceArray
            };
            vm.attendanceArray.map(function (item) {
                delete item.community_id;
                delete item.graduate;
            });

            vm.pastor.attendance = vm.pastor.attendance || {};
            vm.pastor.attendance.pastor_id = vm.pastor.id;
            vm.pastor.attendance.community_id = vm.community.id;
            delete vm.pastor.attendance.id;
            var pastorArray = [];
            pastorArray.push(vm.pastor.attendance);
            var pastorData = {
                data: pastorArray
            };

            if (vm.participantHasEdit) {
                ParticipantService.saveParticipantAttendance(data).then(function () {
                    vm.participants.map(function (item) {
                        item.attendance2 = {};
                    });

                    vm.isLoading = true;
                    vm.participants = [];

                    PastorService.savePastorAttendance(pastorData).then(function () {
                        vm.saving = false;
                        vm.participantHasEdit = false;
                        vm.pastorHasEdit = false;
                        vm.pastor.attendance2 = {};

                        initAttendance();
                    }).catch(function () {
                        vm.isLoading = true;
                    });
                }).catch(function () {
                    vm.isLoading = true;
                });
            } else {
                PastorService.savePastorAttendance(pastorData).then(function () {
                    vm.saving = false;
                    vm.participantHasEdit = false;
                    vm.pastorHasEdit = false;
                    vm.pastor.attendance2 = {};
                }).catch(function () {
                    vm.isLoading = true;
                });
            }
        }

        /*
        Function to get pastor details
         */
        function getPastor() {
            if (!vm.community.application.pastor_id) {
                return getParticipants();
            }

            var params = {
                community_id: vm.community.id,
                with: 'attendance'
            };
            PastorService.getPastor(vm.community.application.pastor_id, params)
                .then(function (response) {
                    vm.pastor = response;
                    vm.pastor.attendance2 = {};
                    getParticipants();
                })
        }

        /*
      Function to get list of participants
       */
        function getParticipants() {
            vm.isLoading = true;
            vm.participants = [];

            ParticipantService.getParticipants({
                sort: '',
                application_id: vm.community.application_id,
                nopage: true,
                qualified: 2,
                is_visitor: -1,
                with: 'attendance,scorecard,children'
            }).then(function (response) {
                vm.participants = response;
                vm.isLoading = false;
            });
        }

        /*
        Function to open issuesDialog
         */
        function issuesDialog(participant, pastor) {
            if (currentUser.$roles.has(['admin', 'metrics', 'pastor_coordinator', 'branch_head'])) {
                $mdDialog.show({
                    controller: 'issuesDeleteParticipantDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/transform/dialogs/issue-dialog/issues-dialog.html',
                    parent: angular.element($document.body),
                    locals: {
                        participant: participant || null,
                        pastor: pastor || null,
                        application: vm.application,
                        callback: getParticipants
                    },
                    clickOutsideToClose: true
                });
            }
        }

        /*
        Function that handles bottom sheet error
         */
        function handleBottomSheetError() {
            $('.content-white-holder').removeClass('bcopen');
            $state.go('app.community.attendance', { id: vm.community.id });
        }

        /*
        Function that handles bottom sheet close event
         */
        function handleCloseEvent() {
            if ($state.current.name === 'app.community.attendance.dropped') {
                $('.content-white-holder').removeClass('bcopen');
                $state.go('app.community.attendance', { id: vm.community.id });
            }
        }

        /*
        Function to show disqualified participants bottom sheet
         */
        function showDisqualifiedParticipants() {
            $mdBottomSheet.show({
                controller: 'DisqualifiedParticipantsController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/tabs/attendance/bottom-sheets/disqualified-participants/disqualified-participants.html',
                parent: '#community-content-wrapper',
                clickOutsideToClose: true,
                disableBackdrop: true,
                disableParentScroll: true,
                locals: {
                    community: vm.community,
                    callback: getParticipants
                }
            })
                .then(handleCloseEvent.bind(vm))
                .catch(handleBottomSheetError.bind(vm));

            setTimeout(function () {
                var parent = angular.element('#community-content-wrapper');
                parent.unbind('$md.dragstart')
                    .unbind('$md.drag')
                    .unbind('$md.dragend');
            }, 1000);
        }

        /*
        Function to show disqualified participants bottom sheet
         */
        function showVisitors() {
            $mdBottomSheet.show({
                controller: 'VisitorsListController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/tabs/attendance/bottom-sheets/visitors-list/visitors-list.html',
                parent: '#community-content-wrapper',
                clickOutsideToClose: true,
                disableBackdrop: true,
                disableParentScroll: true,
                locals: {
                    community: vm.community,
                    callback: getParticipants
                }
            })
                .then(handleCloseEvent.bind(vm))
                .catch(handleBottomSheetError.bind(vm));

            setTimeout(function () {
                var parent = angular.element('#community-content-wrapper');
                parent.unbind('$md.dragstart')
                    .unbind('$md.drag')
                    .unbind('$md.dragend');
            }, 1000);
        }

        /*
        Function to show disqualified participants bottom sheet
         */
        function showDroppedParticipants() {
            $mdBottomSheet.show({
                controller: 'DroppedParticipantsController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/tabs/attendance/bottom-sheets/dropped-participants/dropped-participants.html',
                parent: '#community-content-wrapper',
                clickOutsideToClose: true,
                disableBackdrop: true,
                disableParentScroll: true,
                locals: {
                    community: vm.community,
                    callback: getParticipants
                }
            })
                .then(handleCloseEvent.bind(vm))
                .catch(handleBottomSheetError.bind(vm));

            setTimeout(function () {
                var parent = angular.element('#community-content-wrapper');
                parent.unbind('$md.dragstart')
                    .unbind('$md.drag')
                    .unbind('$md.dragend');
            }, 1000);
        }

        /*
        Function to edit participant bcr or mcr data
         */
        function menuItemClick(certificate, participant, value) {
            vm.participantHasEdit = true;
            var attendanceObj = {
                participant_id: participant.id,
                bcr: '',
                mcr: '',
                h2h_week1: 0,
                h2h_week2: 0,
                h2h_week3: 0,
                h2h_week4: false,
                week1: false,
                week2: false,
                week3: false,
                week4: false,
                week5: false,
                week6: false,
                week7: false,
                week8: false,
                week9: false,
                week10: false,
                week11: false,
                week12: false,
                week13: false,
                week14: false,
                week15: false
            };

            participant.value = value;
            if (certificate === 'bcr') {
                if (participant.attendance) {
                    participant.attendance.bcr = value;
                } else {
                    participant.attendance = {};
                    participant.attendance.bcr = value;
                }

                attendanceObj.bcr = value;


            } else if (certificate === 'mcr') {
                if (participant.attendance) {
                    participant.attendance.mcr = value;
                } else {
                    participant.attendance = {};
                    participant.attendance.mcr = value;
                }

                attendanceObj.mcr = value;

            }

            var result = $.grep(vm.attendanceArray, function (item) {
                return item.participant_id === participant.id;
            });

            if (result.length != 0) {
                for (var index = 0; index < vm.attendanceArray.length; index++) {
                    if (vm.attendanceArray[index].participant_id === participant.id) {
                        Object.assign(vm.attendanceArray[index], participant.attendance);
                    }
                }
            } else {
                Object.assign(attendanceObj, participant.attendance);
                vm.attendanceArray.push(attendanceObj);
            }

        }

        /*
        Function to edit pastor bcr or mcr data
         */
        function pastorMenuItemClick(certificate, pastor, value) {
            vm.pastorHasEdit = true;
            pastor.value = value;
            if (certificate === 'bcr') {
                if (pastor.attendance) {
                    pastor.attendance.bcr = value;
                } else {
                    pastor.attendance = {};
                    pastor.attendance.bcr = value;
                }

            } else if (certificate === 'mcr') {
                if (pastor.attendance) {
                    pastor.attendance.mcr = value;
                } else {
                    pastor.attendance = {};
                    pastor.attendance.mcr = value;
                }
            }
        }

        /*
        Function to open bcr and mcr menu for users that have rights
         */
        function openMenu($mdMenu, ev) {
            if (currentUser.$roles.has(['pastor_coordinator',
                'health_coordinator',
                'livelihood_coordinator',
                'donor_services',
                'donor_managers',
                'view_only',
                'area_head',
                'national'])) {
            } else {
                $mdMenu.open(ev);
            }
        }

        /*
        Function to show edit participant modal
         */
        function editParticipant(participant) {
            if (!currentUser.$roles.has(['national',
                'area_head',
                'donor_services',
                'donor_managers',
                'view_only'])) {
                $mdDialog.show({
                    controller: 'EditParticipantDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/transform/dialogs/edit-participant/edit-participant-dialog.html',
                    parent: angular.element($document.body),
                    locals: {
                        participant: participant || null,
                        pastor: vm.community.application.pastor || null,
                        callback: initAttendance,
                        application: vm.community.application
                    },
                    clickOutsideToClose: true
                });
            }
        }

        /*
        Function to mark pastor attendance
         */
        function addPastorAttendance(pastor, weekName, vm) {

            if (weekName === "week_existing_church_member" && pastor.attendance.week_became_church_member) {
                return;
            }

            if (weekName === "week_became_church_member" && pastor.attendance.week_existing_church_member) {
                return;
            }

            if ((!/garden_week\d+/.test(weekName) && !currentUser.$roles.has(['pastor_coordinator']))
                && currentUser.$roles.has(['pastor_coordinator',
                    'health_coordinator',
                    'livelihood_coordinator',
                    'donor_services',
                    'donor_managers',
                    'view_only',
                    'area_head',
                    'national'])) {

            } else {
                pastor.attendance2[weekName] = true;
                vm.pastorHasEdit = true;
                var attendance = pastor.attendance || {};

                if (!vm.pastor.attendance) {
                    vm.pastor.attendance = {};
                }

                if (attendance.hasOwnProperty(weekName)) {
                    if (/^(h2h_)?week/.test(weekName) && attendance[weekName] && !attendance[weekName + '_proxy']) {
                        attendance[weekName + '_proxy'] = true;
                    } else if (/^(h2h_)?week/.test(weekName) && attendance[weekName + '_proxy']) {
                        attendance[weekName + '_proxy'] = false;
                        attendance[weekName] = false;
                    } else if (attendance[weekName]) {
                        vm.pastor.attendance[weekName] = false;
                    } else {
                        vm.pastor.attendance[weekName] = true;
                    }
                } else {
                    vm.pastor.attendance[weekName] = true;
                }

                var counter = 0;
                for (var index in vm.pastor.attendance) {
                    if (index.match(/^week\d+/)) {
                        if (vm.pastor.attendance[index]) {
                            counter++;
                        }
                    }
                }

                vm.pastor.attendance.graduate = (counter >= 9);
            }
        }

        /*
        Function to mark participant attendance
         */
        function addParticipantAttendance(participant, weekName, vm) {

            if (weekName === "week_existing_church_member" && participant.attendance && participant.attendance.week_became_church_member) {
                return;
            }

            if (weekName === "week_became_church_member" && participant.attendance && participant.attendance.week_existing_church_member) {
                return;
            }

            if ((!/garden_week\d+/.test(weekName) && !currentUser.$roles.has(['pastor_coordinator']))
                && currentUser.$roles.has(['pastor_coordinator',
                    'health_coordinator',
                    'livelihood_coordinator',
                    'donor_services',
                    'donor_managers',
                    'view_only',
                    'area_head',
                    'national'])) {

            } else {
                vm.participantHasEdit = true;
                participant.attendance2[weekName] = true;

                var attendance = participant.attendance || {};

                var participantIndex = -1;
                vm.participants.forEach(function (item, index) {
                    if (item.id == participant.id) {
                        participantIndex = index;
                    }
                });

                if (!vm.participants[participantIndex].attendance) {
                    vm.participants[participantIndex].attendance = {};
                }

                if (attendance.hasOwnProperty(weekName)) {
                    if (/^(h2h_)?week/.test(weekName) && attendance[weekName] && !attendance[weekName + '_proxy']) {
                        attendance[weekName + '_proxy'] = true;
                    } else if (/^(h2h_)?week/.test(weekName) && attendance[weekName + '_proxy']) {
                        attendance[weekName + '_proxy'] = false;
                        attendance[weekName] = false;
                    } else if (attendance[weekName]) {
                        vm.participants[participantIndex].attendance[weekName] = false;
                    } else {
                        vm.participants[participantIndex].attendance[weekName] = true;
                    }
                } else {
                    vm.participants[participantIndex].attendance[weekName] = true;
                }

                var result = $.grep(vm.attendanceArray, function (item) {
                    return item.participant_id === participant.id;
                });

                if (result.length != 0) {
                    for (var index = 0; index < vm.attendanceArray.length; index++) {
                        if (vm.attendanceArray[index].participant_id === participant.id) {
                            Object.assign(vm.attendanceArray[index], vm.participants[participantIndex].attendance);
                        }
                    }
                } else {
                    var attendanceObj = {
                        participant_id: participant.id,
                        h2h_week1: false,
                        h2h_week2: false,
                        h2h_week3: false,
                        h2h_week4: false,
                        week1: false,
                        week2: false,
                        week3: false,
                        week4: false,
                        week5: false,
                        week6: false,
                        week7: false,
                        week8: false,
                        week9: false,
                        week10: false,
                        week11: false,
                        week12: false,
                        week13: false,
                        week14: false,
                        week15: false,
                        h2h_week1_proxy: false,
                        h2h_week2_proxy: false,
                        h2h_week3_proxy: false,
                        h2h_week4_proxy: false,
                        week1_proxy: false,
                        week2_proxy: false,
                        week3_proxy: false,
                        week4_proxy: false,
                        week5_proxy: false,
                        week6_proxy: false,
                        week7_proxy: false,
                        week8_proxy: false,
                        week9_proxy: false,
                        week1_proxy0: false,
                        week1_proxy1: false,
                        week1_proxy2: false,
                        week1_proxy3: false,
                        week1_proxy4: false,
                        week1_proxy5: false
                    };
                    Object.assign(attendanceObj, vm.participants[participantIndex].attendance);
                    vm.attendanceArray.push(attendanceObj);
                }

                // auto-graduate
                var counter = 0;
                for (var week in vm.participants[participantIndex].attendance) {
                    if (/^week\d+/.test(week) &&
                        vm.participants[participantIndex].attendance[week]) {
                        counter++;
                    }
                }

                vm.participants[participantIndex].attendance.graduate = (counter >= 9);
            }
        }

        /*
        Function to show soft delete participant modal
         */
        function softDeleteParticipant(participant) {

            if (vm.bulkDeleteIDs.length && !Array.isArray(participant)) {
                return;
            }

            if (Array.isArray(participant)) {
                $mdDialog.show({
                    controller: 'SoftDeleteParticipantDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/community/dialogs/soft-delete-participant/soft-delete-participant-dialog.html',
                    parent: angular.element($document.body),
                    locals: {
                        participant: participant,
                        callback: function () {
                            getParticipants();
                            vm.bulkDeleteIDs = [];
                        }
                    },
                    clickOutsideToClose: true
                });
                return;
            }

            if (participant.is_visitor) {
                $mdDialog.show({
                    controller: 'HardDeleteVisitorDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
                    parent: angular.element($document.body),
                    locals: {
                        visitor: participant,
                        callback: initAttendance
                    },
                    clickOutsideToClose: true
                });
            } else {
                $mdDialog.show({
                    controller: 'SoftDeleteParticipantDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/community/dialogs/soft-delete-participant/soft-delete-participant-dialog.html',
                    parent: angular.element($document.body),
                    locals: {
                        participant: participant,
                        callback: function () {
                            getParticipants();
                        }
                    },
                    clickOutsideToClose: true
                });
            }
        }

        /*
        Function to show add participant modal
         */
        function addParticipant(isVisitor) {
            isVisitor = isVisitor || 0;

            $mdDialog.show({
                controller: 'AddParticipantDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/transform/dialogs/add-participant/add-participant-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    community: vm.community,
                    callback: function () {
                        initAttendance();
                    },
                    guest: isVisitor ? { is_visitor: true } : null
                },
                clickOutsideToClose: true
            });
        }

        /**
         * Check if participant has attendance
         * @param {object} attendance
         */
        function hasAttendance(attendance) {
            if (attendance) {
                var isCheckbox = /week|graduate/g;
                var isBcr = /^bcr|mcr/;
                var keys = Object.keys(attendance);
                for (var i = 0; i < keys.length; i++) {
                    var key = keys[i];
                    if (isBcr.test(key) && attendance[key] && attendance[key] !== 'not required') {
                        return true;
                    } else if (isCheckbox.test(key) && !!attendance[key]) {
                        return true;
                    }
                }
            }

            return false;
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.transform')
        .controller('SoftDeleteParticipantDialogController', SoftDeleteParticipantDialogController);

    /** @ngInject */
    function SoftDeleteParticipantDialogController($mdDialog,
                                                   $document,
                                                   participant,
                                                   callback,
                                                   ParticipantService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.deleteParticipant = deleteParticipant;

        vm.dialogTitle = "Delete Participant";
        vm.reasons = [
            "Duplicate",
            "Incorrect Status (original vs. replacement)",
            "Encoded in the Wrong Community",
            "(Before Week 1) Previously attended the Transform program (re-tag as visitor)",
            "(Before Week 1) Refused to attend due to personal reasons",
            "(Before Week 1) Deceased"
        ];

        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteParticipant(participant),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function to delete participant data
         */
        function deleteParticipant(part) {
            if (Array.isArray(participant)) {
                // Prepare URL-encoded data
                const urlencoded = new URLSearchParams();
                participant.forEach(id => urlencoded.append("participants_ids[]", id));
                urlencoded.append("reasons_for_dropping", part.reason_for_dropping);

                // Call the delete function with formatted data
                ParticipantService.deleteBulkParticipant(urlencoded.toString())
                    .then(function () {
                        callback();
                        closeDialog();
                    });
                return;
            }

            var participantObj = {
                id: participant.id,
                reasons_for_dropping: part.reason_for_dropping
            };
            ParticipantService.deleteParticipant(participantObj)
                .then(function () {
                    callback();
                    closeDialog();
                });
        }

        /*
        Function to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();
(function () {
    'use strict';

    angular.module('app.community')
        .controller('ParticipantNotesDialogController', ParticipantNotesDialogController);

    /** @ngInject */
    function ParticipantNotesDialogController($mdDialog,
                                              participant,
                                              PastorService,
                                              Auth,
                                              ParticipantService) {
        var vm = this;
        vm.currentUser = Auth.getUser();

        //Methods
        vm.closeDialog = closeDialog;
        vm.addNote = addNote;
        vm.deleteNote = deleteNote;
        vm.editNote = editNote;
        vm.activateEditNote = activateEditNote;

        vm.dialogTitle = "Notes";

        activate();

        /*
        Function to initialize participant or pastor
         */
        function activate() {
            vm.participant = participant;

            if(!vm.participant.participant) {
                PastorService.getPastor(vm.participant.pastor_id).then(function(response) {
                    vm.participant.participant = {
                        lastname: response.lastname,
                        firstname: response.firstname
                    };
                });
            }
            getNotes();
        }

        /*
        Function to check user who have rights to edit a note
         */
        function activateEditNote(note) {
            if(vm.currentUser.$roles.has(['admin', 'metrics', 'livelihood_coordinator', 'livelihood_trainer', 'branch_head', 'health_mentor'])) {
                note.editing = true;
            }
        }

        /*
        Function that gets all participant notes
         */
        function getNotes() {
            var params = {
                sort: 'created_at:asc',
                nopage: true,
                with: 'participant,updatedBy'
            };
            ParticipantService.getNotes(participant.id, params)
                .then(function (response) {
                vm.notes = response;
            });
        }

        /*
        Function to add note data
         */
        function addNote(note) {
            if (note) {
                var noteObj = {
                    notes: note,
                    with: 'updatedBy'
                };
                ParticipantService.addNote(participant.id, noteObj)
                    .then(function (response) {
                    vm.note = '';
                    vm.notes.push(response);
                });
            }
        }

        /*
        Function to save edited note
         */
        function editNote(note) {
            note.editing = false;
            ParticipantService.editNote(participant.id, note)
                .then(function (response) {
            });
        }

        /*
        Function to delete note data
         */
        function deleteNote(noteRemove) {
            ParticipantService.deleteNote(participant.id, noteRemove.id)
                .then(function (response) {
                vm.notes = vm.notes.filter(function (note) {
                    return noteRemove.id !== note.id;
                });
            });
        }

        /*
        Function to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.transform')
        .controller('EditBibParticipantDialogController', EditBibParticipantDialogController);

    /** @ngInject */
    function EditBibParticipantDialogController($mdDialog,
                                                initBibParticipants,
                                                participant,
                                                pastor,
                                                BibParticipantService,
                                                BibPaymentService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.editBibParticipant = editBibParticipant;
        vm.deletePayment = deletePayment;

        vm.loading = false;

        vm.dialogTitle = "Edit";
        vm.participant = participant;
        vm.pastor = pastor;
        vm.saving = false;
        vm.deletedPayments = [];
        vm.apiErrors = {};

        vm.sales = ["No", "Yes"];
        vm.weeks = [];
        vm.paymentsWeeks = [];

        if (participant.payments) {
            vm.paymentsWeeks = [...new Set(participant.payments.map(ele => ele.week))];
        }

        for (var x = participant.bib.week; x <= 15; x++) {
            vm.weeks.push(x);
        }

        vm.types = [
            {label: "Individual", value: "individual"},
            {label: "Group", value: "group"}
        ];

        vm.isParticipantPaymentWeekDisabled = function (week, selectedWeek) {
            if (week === selectedWeek) {
                return false;
            }

            return vm.paymentsWeeks.includes(week);
        }

        /*
        Function triggered to save bib participant details
         */
        function editBibParticipant(participant, form) {
            var counter = 0;
            var maxTrans = participant.payments.length + vm.deletedPayments.length;
            vm.saving = true;
            vm.apiErrors = {};

            function executeSave() {
                vm.saving = false;
                initBibParticipants();
                closeDialog();
            }

            delete participant.pastor_id;
            delete participant.participant_id;

            return BibParticipantService.editBibParticipant(participant)
                .then(function () {

                    if (participant.payments.length
                        || vm.deletedPayments.length) {
                        participant.payments.forEach(function (payment) {
                            BibPaymentService.editBibPayment(payment)
                                .then(function () {
                                    counter++;

                                    if (counter >= maxTrans) {
                                        executeSave();
                                    }
                                }).catch(function () {
                                counter++;

                                if (counter >= maxTrans) {
                                    executeSave();
                                }
                            });
                        });

                        vm.deletedPayments.forEach(function (paymentId) {
                            BibPaymentService.deleteBibPayment(paymentId)
                                .then(function () {
                                    counter++;

                                    if (counter >= maxTrans) {
                                        executeSave();
                                    }
                                }).catch(function () {
                                counter++;

                                if (counter >= maxTrans) {
                                    executeSave();
                                }
                            });
                        });
                    } else {
                        executeSave();
                    }
                })
                .catch(function (response) {
                    form.$invalid = true;
                    vm.saving = false;

                    for (var field in response.data.errors) {
                        vm.apiErrors[field] = response.data.errors[field].shift();
                    }
                });
        }

        /*
        Function triggered to close modal
         */
        function closeDialog() {
            initBibParticipants();
            $mdDialog.hide();
        }

        /*
        Function triggered to delete payment data
         */
        function deletePayment(vm, paymentIndex) {
            vm.deletedPayments.push(vm.participant.payments[paymentIndex]);
            vm.participant.payments.splice(paymentIndex, 1);
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.transform')
        .controller('DeleteBibParticipantDialogController', DeleteBibParticipantDialogController);

    /** @ngInject */
    function DeleteBibParticipantDialogController($mdDialog, $document,
                                                  initBibParticipants,
                                                  participant,
                                                  BibParticipantService) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.deleteBibParticipant = deleteBibParticipant;

        vm.dialogTitle = "Delete Participant";
        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.deleteBibParticipant(participant),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function triggered to delete bib participant
         */
        function deleteBibParticipant() {
            vm.saving = true;
            return BibParticipantService.deleteBibParticipant(participant)
                .then(function () {
                    vm.saving = false;
                    initBibParticipants();
                    closeDialog();
                });
        }

        /*
        Function triggered to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.community')
        .controller('AddBibParticipantDialogController', AddBibParticipantDialogController);

    /** @ngInject */
    function AddBibParticipantDialogController($mdDialog,
                                               BibParticipantService,
                                               initBibParticipants,
                                               participants,
                                               bib) {
        var vm = this;

        vm.bib = bib;

        //Methods
        vm.closeDialog = closeDialog;
        vm.addParticipant = addParticipant;

        vm.dialogTitle = "Add Participant";
        vm.apiErrors = {};

        vm.types = [
            {label: "Individual", value: "individual"},
            {label: "Group", value: "group"}
        ];

        vm.participants = participants;

        /*
        Function triggered to save participant data
         */
        function addParticipant(data, bib, form) {
            vm.saving = true;
            var participant = {
                community_bib_id: bib.id,
                participant_id: data.participant_id,
                base_capital: data.base_capital,
                kits: data.kits,
                type: data.type
            };

            vm.apiErrors = [];

            BibParticipantService.addBibParticipant(participant)
                .then(function () {
                    vm.saving = false;
                    initBibParticipants();
                    closeDialog();
                })
                .catch(function (response) {
                    form.$invalid = true;
                    vm.saving = false;
                    for (var field in response.data.errors) {
                        vm.apiErrors[field] = response.data.errors[field].shift();
                    }
                });
        }

        /*
        Function to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.community')
        .controller('CommunityDetailsController', CommunityDetailsController);

    /** @ngInject */
    function CommunityDetailsController($mdDialog,
        community,
        callback,
        BatchService,
        CommunityService,
        PastorService,
        DonorService,
        $state,
        BaseService,
        UserService,
        $document,
        $http,
        Auth) {
        var vm = this;
        var currentUser = Auth.getUser();
        vm.currentUser = currentUser;

        //Methods
        vm.healthTrainers = [];
        vm.livelihoodTrainers = [];
        vm.healthMentors = [];
        vm.closeDialog = closeDialog;
        vm.dropApplication = dropApplication;
        vm.editCommunity = editCommunity;
        vm.selectPastor = selectPastor;
        vm.searchPastors = searchPastors;
        vm.showNewPastorDialog = showNewPastorDialog;
        vm.replacePhoto = replacePhoto;
        vm.uploadPhoto = uploadPhoto;
        vm.removePhoto = removePhoto;

        vm.originalBatchId = community.batch_id;
        vm.originalBaseId  = community.application.base_id;

        vm.community = angular.copy(community);
        vm.community.latitude = parseFloat(vm.community.latitude);
        vm.community.longitude = parseFloat(vm.community.longitude);
        vm.selectedPastor = community.application.pastor;

        vm.community.updated_at = new Date(vm.community.updated_at);

        vm.dialogTitle = "Community Details";

        vm.labels = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15"];
        vm.schedules = [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday"
        ];
        vm.options = {
            elements: {
                line: {
                    fill: false,
                    backgroundColor: '#386bba',
                    borderColor: '#386bba',
                    borderWidth: 2
                }
            },
            scales: {
                yAxes: [
                    {
                        id: 'y-axis-1',
                        type: 'linear',
                        display: true,
                        position: 'left',
                        ticks: {
                            beginAtZero: true,
                            userCallback: function (label) {
                                if (Math.floor(label) === label) {
                                    return label;
                                }

                            }
                        },
                        gridLines: {
                            color: "rgba(0, 0, 0, 0)"
                        }
                    }
                ]
            }
        };

        activate();
        initBases();

        function hasProgram (program, name) {
          return program && (program.name === name || (program.parent && program.parent.name === name));
        }

        /*
        Function triggered first in the controller that fetches batches, attendance
        and community
         */
        function activate() {
            BatchService.getBatches({'nopage': true, sort: 'start_at:desc'})
                .then(function (batches) {
                    vm.batches = batches;
                    vm.batch = community.batch_id;
                });

            CommunityService.getAttendance(community)
                .then(function (response) {
                    vm.data = response.slice(0, 15);
                });

            CommunityService.getCommunity(community.id)
                .then(function (response) {
                    vm.totalParticipants = response.total_participants_with_attendance;
                    vm.totalCounselors = response.total_counselors;
                    vm.totalGraduates = response.total_graduates;

                    if (response.pastor_has_attendance) {
                        vm.totalParticipants++;
                    }

                    if (response.pastor_has_graduated) {
                        vm.totalGraduates++;
                    }
                });

            var program = community.application.program;

            if (program) {
                if (hasProgram("Transform Level 1") || hasProgram("Transform with FA")) {
                    if (community.health_trainer) {
                        vm.healthTrainers = [community.health_trainer];
                    }
                    UserService.fetchUsers({
                        limit:50,
                        roles    : "health_mentor,health_trainer",
                        branch_id: community.application.base_branch_id
                    }).then(function(response) {
                        response.data.forEach(function (item) {
                            if (item.id !== community.health_trainer_id) {
                                vm.healthTrainers.push(item);
                            }
                        });
                    });

                    if (community.livelihood_trainer) {
                        vm.livelihoodTrainers = [community.livelihood_trainer];
                    }
                    UserService.fetchUsers({
                        limit:50,
                        roles    : "health_mentor,livelihood_trainer",
                        branch_id: community.application.base_branch_id
                    }).then(function(response) {
                        response.data.forEach(function (item) {
                            if (item.id !== community.livelihood_trainer_id) {
                                vm.livelihoodTrainers.push(item);
                            }
                        });
                    });
                }

                if (hasProgram("Transform Level 2")) {
                    if (community.health_mentor) {
                        vm.healthMentors = [community.health_mentor];
                    }
                    UserService.fetchUsers({
                        limit:50,
                        roles    : "health_mentor",
                        branch_id: community.application.base_branch_id
                    }).then(function(response) {
                        response.data.forEach(function (item) {
                            if (item.id !== community.health_mentor_id) {
                                vm.healthMentors.push(item);
                            }
                        })
                    });
                }
            }
        }

        /*
        Function triggered to replace and save photo of community
         */
        function replacePhoto(hbf, action, ev) {
            if (action != "before" && action != "after") return;

            $mdDialog.show({
                controller: 'ReplacePhotoDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/tabs/hbf/dialogs/replace-photo/replace-photo-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    hbf: hbf,
                    action: action,
                    callback: null
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function triggered to save photo of community
         */
        function uploadPhoto(mode, photo, community) {
            if (mode === 'banner') {
                CommunityService.uploadBannerPhoto(community, photo).then(function(response) {
                    vm.community.banner_photo_url = response.banner_photo_url;
                });
            } else if (mode === 'graduation') {
                CommunityService.uploadGraduationPhoto(community, photo).then(function(response) {
                    vm.community.graduation_photo_url = response.graduation_photo_url;
                });
            }
        }

        /*
        Function triggered to remove photo in community
         */
        function removePhoto(mode, community, ev) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure you want to want to delete this photo?')
                .targetEvent(ev)
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function () {
                if (mode == 'banner') {
                    CommunityService.deleteBannerPhoto(community);

                    vm.community.banner_photo = null;
                    vm.community.banner_photo_url = null;
                } else {
                    CommunityService.deleteGraduationPhoto(community);

                    vm.community.graduation_photo = null;
                    vm.community.graduation_photo_url = null;
                }
                $mdDialog.show({
                    controller: 'CommunityDetailsController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/community/dialogs/community-details/community-details-dialog.html',
                    parent: angular.element($document.body),
                    locals: {
                        community: vm.community || null,
                        callback: (function (community) {
                            this.vm.community = community;
                        }).bind({
                            $state: $state,
                            vm: vm
                        })
                    },
                    clickOutsideToClose: true
                });
            }, function () {
                // cancel action
                $mdDialog.show({
                    controller: 'CommunityDetailsController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/community/dialogs/community-details/community-details-dialog.html',
                    parent: angular.element($document.body),
                    locals: {
                        community: vm.community || null,
                        callback: (function (community) {
                            this.vm.community = community;
                        }).bind({
                            $state: $state,
                            vm: vm
                        })
                    },
                    clickOutsideToClose: true
                });
            });
        }

        /*
        Function triggered to save participant data
         */
        function showNewPastorDialog() {
            $mdDialog.show({
                controller: 'NewPastorDialogController',
                controllerAs: 'vm',
                multiple: true,
                templateUrl: 'app/main/thrive/tabs/pastors/dialogs/new-pastor/new-pastor-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    initPastorsTable: activate
                },
                clickOutsideToClose: true
            }).then(function (response) {
                vm.addedPastor = true;
                vm.selectedPastor = response;
            });
        }

        vm.selectedBase = community.application.base;

        /*
        Function triggered to get bases
         */
        function initBases() {
            BaseService.getBases({
                nopage: 1,
                with: "branches",
                base_id: currentUser.base_id
            })
                .then(function (data) {
                    vm.bases = data;
                });
        }

        /*
        Function triggered to select a base
         */
        vm.updateCommunityBase = function (base) {
            vm.selectedBase = base;
        };

        /*
        Function triggered when pastor is selected
         */
        function selectPastor(pastor) {
            vm.selectedPastor = pastor;
        }

        /*
        Function triggered when typing a letter in autocomplete
         */
        function searchPastors(query) {
            return PastorService.searchPastors({
                search: query,
                check_status: 1,
                page: 1,
                limit: 20
            });
        }

        // donor auto-complete
        vm.searchDonor = vm.community.donor ? vm.community.donor.name : null;
        vm.selectedDonor = null;
        vm.selectDonor = selectDonor;
        vm.searchDonors = searchDonors;

        /*
        Function triggered to select a donor
         */
        function selectDonor(donor) {
            vm.selectedDonor = donor;
        }

        /*
        Function triggered to search for donors
         */
        function searchDonors(query) {
            return DonorService.getDonors({
                search: query,
                nopage: true
            })
        }

        /*
        Function triggered to search for locations using Nominatim (OpenStreetMap)
         */
        vm.selectedLocation = null;
        vm.searchLocation = null;
        vm.showSearchLocation = false;
        vm.selectLocation = selectLocation;
        vm.searchLocations = searchLocations;

        vm.handleSearchLocation = function () {
            vm.searchLocation = '';
        }

        function selectLocation(location) {
            if (location) {
                vm.selectedLocation = location;
                vm.community.latitude = parseFloat(location.lat);
                vm.community.longitude = parseFloat(location.lon);
                vm.showSearchLocation = false;
            }
        }

        function searchLocations(query) {
            if (!query || query.length < 2) {
                return [];
            }

            return $http.get('https://nominatim.openstreetmap.org/search', {
                params: {
                    q: query,
                    format: 'json',
                    limit: 10
                }
            }).then(function (response) {
                return response.data || [];
            }).catch(function (err) {
                console.error('Error searching locations:', err);
                return [];
            });
        }

        /*
        Function triggered to open drop application modal
         */
        function dropApplication() {
            $mdDialog.show({
                controller: 'DropApplicationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/transform/dialogs/drop-application/drop-application-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    application: community || null,
                    mode: 'community',
                    drawApplicationsTable: function () {
                        $state.go('app.transform.community-lists');
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function triggered to save modified details in community
         */
        function editCommunity(batch, donor, pastor, community) {
            if (community.current_batch_data.monthDiff <= 0 &&
                (vm.originalBaseId != community.application.base_id ||
                vm.originalBatchId != batch)) {
                if (!showRegenerateIdConfirmationDialog()) {
                    return;
                }
            }

            var communityObj = {
                batch_id: batch,
                donor: donor,
                pastor_id: pastor ? pastor.id : '',
                base_id: community.application.base_id,
                map: community.map,
                branch_id: community.application.base_branch_id,
                schedule: community.schedule,
                latitude: community.latitude,
                longitude: community.longitude,
                with: 'application.pastor,application.program.parent,application.base,application.base.branches,application.program,donor,healthTrainer,healthMentor,livelihoodTrainer'
            };

            if (community.health_trainer) {
                communityObj.health_trainer_id = community.health_trainer.id;
            }

            if (community.livelihood_trainer) {
                communityObj.livelihood_trainer_id = community.livelihood_trainer.id;
            }

            if (community.health_mentor) {
                communityObj.health_mentor_id = community.health_mentor.id;
            }

            CommunityService.editCommunity(community, communityObj).then(function (community) {
                callback(community);
                $mdDialog.hide();
            });
        }

        /*
        Display a confirmation dialog if the community is about to be updated.
         */
        function showRegenerateIdConfirmationDialog() {
            return window.confirm("If you proceed this will change the community ID, this will notify the System Administrator. Are you sure to proceed with this change?");
        }

        /*
        Function to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.community')
        .controller('AddVisitorDialogController', AddVisitorDialogController);

    /** @ngInject */
    function AddVisitorDialogController($mdDialog,
                                        ParticipantService,
                                        callback,
                                        community) {
        var vm = this;

        //Methods
        vm.closeDialog = closeDialog;
        vm.addVisitor = addVisitor;

        vm.dialogTitle = "Add Visitor";

        /*
        Function triggered to save visitor data
         */
        function addVisitor(visitor) {
            visitor.application_id = community.application.id;
            visitor.is_visitor = 1;
            ParticipantService.addParticipant(visitor)
                .then(function () {
                callback();
                closeDialog();
            });
        }

        /*
        Function to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.community')
        .controller('AddBibPaymentDialogController', AddBibPaymentDialogController);

    /** @ngInject */
    function AddBibPaymentDialogController($mdDialog, $timeout,
                                           BibPaymentService,
                                           initBibParticipants,
                                           callback,
                                           pastor,
                                           participant) {
        var vm = this;

        vm.participant = participant;
        vm.pastor = pastor;
        vm.saving = false;
        //Methods
        vm.closeDialog = closeDialog;
        vm.addPayment = addPayment;

        vm.dialogTitle = "Add Payment";
        vm.weeks = [];
        vm.paymentsWeeks = [];

        if (participant.payments) {
            vm.paymentsWeeks = [...new Set(participant.payments.map(ele => ele.week))];
        }

        for (var x = participant.bib.week; x <= 15; x++) {
            if (!vm.paymentsWeeks.includes(x)) {
                vm.weeks.push(x);
            }
        }

        vm.payment = {
            week: 1
        };

        vm.paymentErrors = {};
        var debounceTimeout;
        /*
        Function triggered to save participant payment data
         */
        function addPayment(form, participant) {
            vm.saving = true;
            if (debounceTimeout) {
                $timeout.cancel(debounceTimeout);
            }

            debounceTimeout = $timeout(function () {
                var payment = {
                    bib_participant_id: participant.id,
                    sale: form.sale ? 1 : 0,
                    week: form.week,
                    cash: form.cash,
                    non_cash: form.non_cash
                };

                BibPaymentService.addBibPayment(payment)
                    .then(function () {
                        initBibParticipants();
                        callback();
                        vm.saving = false;
                        closeDialog();
                    }).catch(function (errors) {
                        var messages = errors.data.errors
                        for (var field in messages) {
                            vm.paymentErrors[field] = messages[field].pop();
                        }
                    });
            }, 1000);
        }

        /*
        Function to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.community')
        .controller('AddBibVisitorDialogController', AddBibVisitorDialogController);

    /** @ngInject */
    function AddBibVisitorDialogController($mdDialog,
                                           BibParticipantService,
                                           initBibParticipants,
                                           visitors,
                                           bib) {
        var vm = this;

        vm.bib = bib;

        //Methods
        vm.closeDialog = closeDialog;
        vm.addVisitor = addVisitor;

        vm.dialogTitle = "Add Visitor";
        vm.apiErrors = {};

        vm.types = [
            {label: "Individual", value: "individual"},
            {label: "Group", value: "group"}
        ];

        vm.visitors = visitors;

        /*
        Function triggered to add bib visitor
         */
        function addVisitor(data, bib, form) {
            vm.saving = true;
            var participant = {
                community_bib_id: bib.id,
                participant_id: data.participant_id,
                base_capital: data.base_capital,
                kits: data.kits,
                type: data.type
            };

            vm.apiErrors = [];

            BibParticipantService.addBibParticipant(participant)
                .then(function () {
                    vm.saving = false;
                    initBibParticipants();
                    closeDialog();
                })
                .catch(function (response) {
                    vm.saving = false;
                    form.$invalid = true;

                    for (var field in response.data.errors) {
                        vm.apiErrors[field] = response.data.errors[field].shift();
                    }
                });
        }

        /*
        Function to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.flourish', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.flourish', {
                url: '/flourish',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/flourish/flourish.html',
                        controller: 'FlourishController as vm'
                    }
                }
            })
            .state('app.flourish.datacard', {
                url: '/datacard',
                data: {
                    selectedTab: 0
                },
                views: {
                    'flourish@datacard': {
                        templateUrl: 'app/main/flourish/tabs/datacard/datacard.html',
                        controller: 'FlourishDataCardController as vm'
                    }
                }
            })
            .state('app.flourish.cluster', {
                url: '/cluster',
                data: {
                    selectedTab: 1
                },
                views: {
                    'flourish@cluster': {
                        templateUrl: 'app/main/flourish/tabs/cluster/cluster.html',
                        controller: 'ClusterController as vm'
                    }
                }
            })
            .state('app.flourish.chc', {
                url: '/chc',
                data: {
                    selectedTab: 2
                },
                views: {
                    'flourish@chc': {
                        templateUrl: 'app/main/flourish/tabs/chc/chc.html',
                        controller: 'ChcController as vm'
                    }
                }
            })
            .state('app.flourish.mcp', {
                url: '/mcp',
                data: {
                    selectedTab: 3
                },
                views: {
                    'flourish@mcp': {
                        templateUrl: 'app/main/flourish/tabs/mcp/mcp.html',
                        controller: 'McpController as vm'
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/flourish');

        // Api
        msApiProvider.register('thrive', ['app/data/thrive/thrive.json']);

        // // Navigation
        msNavigationServiceProvider.saveItem('fuse', {
            title: '',
            group: true,
            weight: 1
        });

        // msNavigationServiceProvider.saveItem('fuse.flourish', {
        //     title: 'only Flourish',
        //     icon: 'icon-plus',
        //     state: 'app.flourish.datacard',
        //     translate: 'FLOURISH.FLOURISH_NAV',
        //     weight: 4,
        //     regex: function (state) {
        //         return /^app\.(flourish).*/.test(state);
        //     },
        //     lid: "stlink"
        // });
        // Condition base render
    }
})();

(function () {
    'use strict';

    angular
        .module('app.flourish')
        .controller('FlourishDataCardController', FlourishDataCardController);

    /** @ngInject */
    function FlourishDataCardController(PastorService, $scope, DataCardService) {

        var vm = this;

        var _parent = $scope;
        _parent.$parent.vm.currentTab = 0;


        //Methods
        vm.addNewFlourishCard = addNewFlourishCard;
        vm.resetForm = resetForm;
        vm.selectPastor = selectPastor;
        vm.searchPastors = searchPastors;

        setDefaultValues();

        /*
        Function to save flourish card
         */
        function addNewFlourishCard(flourish, form) {
            flourish.group_leader_id = vm.group_leader_id.id
            flourish.is_meeting = flourish.is_meeting ? true : false;
            flourish.is_training = flourish.is_training ? true : false;
            flourish.attended_at = moment(flourish.attended_at).format();
            flourish.no_of_timothy = flourish.no_of_timothy || 0;
            flourish.adults_last_sunday = flourish.adults_last_sunday || 0;
            flourish.kids_last_sunday = flourish.kids_last_sunday || 0;
            flourish.offerings_last_sunday = flourish.offerings_last_sunday || 0;

            vm.saving = true;
            DataCardService.addDataCard(flourish).then(function () {
                vm.saving = false;
                form.$setUntouched();
                form.$setPristine();

                setDefaultValues();
            }
            )
                .catch(function (response) {
                    form.$invalid = true;
                    vm.saving = false;

                    for (var field in response.data.errors) {
                        vm.apiErrors[field] = response.data.errors[field].shift();
                    }
                });
        }

        /*
        Function used to reset data form
         */
        function resetForm(form, vm) {
            form.$setUntouched();
            form.$setPristine();

            vm.flourish = {};
            vm.selectedPastor = '';
        }

        /*
        Function that assigns pastor upon select in autocomplete
         */
        function selectPastor(pastor) {
            if (pastor) {
                vm.selectedPastor = pastor;
                vm.flourish.name = pastor.firstname + ' ' + pastor.lastname;
                vm.flourish.base = '(' + pastor.base.name + ') ' + pastor.district.name;
                vm.flourish.pastor_id = pastor.id;
            }

        }

        /*
        Function that queries pastors upon autocomplete
         */
        function searchPastors(query) {
            return PastorService.searchPastors({
                search: query,
                with: 'base,district',
                check_status: 1,
                page: 1,
                limit: 20
            });
        }

        /*
        Set the default values for the flourish form
         */
        function setDefaultValues() {
            vm.flourish = {};
            vm.selectedPastor = '';
            vm.selectedBaseName = '';
            vm.flourish.attended_at = new Date;
            vm.flourish.is_meeting = true;
            vm.apiErrors = {};
        }
    }
})();


(function () {
    'use strict';

    angular
        .module('app.flourish')
        .controller('McpController', McpController);

    /** @ngInject */
    function McpController($stateParams,
        $state,
        $scope,
        $location,
        $mdDialog,
        $mdBottomSheet,
        $document,
        PastorService,
        Auth,
        BaseService,
        DistrictService) {

        var vm = this;
        var currentUser = Auth.getUser();

        this.$state = $state;

        //Methods
        vm.initPastorsTable = initPastorsTable;
        vm.resetFilters = resetFilters;
        vm.addNewPastor = addNewPastor;
        vm.addNewCase = addNewCase;
        vm.editPastor = editPastor;
        vm.deletePastor = deletePastor;
        vm.showPastorDetails = showPastorDetails;
        vm.selectSearch = selectSearch;
        vm.selectDistrict = selectDistrict;
        vm.selectBase = selectBase;
        vm.selectBranch = selectBranch;

        vm.pageChange = pageChange;
        vm.isLoading = true;
        vm.totals = {};
        vm.total_gold = 0;
        vm.total_silver = 0;
        vm.total_bronze = 0;
        vm.total_inactive = 0;
        vm.total_pastors = 0;

        vm.isLoading1 = false;
        vm.isLoading2 = false;

        vm.pastorsList = [];


        var _parent = $scope;
        _parent.$parent.vm.currentTab = 3;

        refreshTables();

        /*
        Function that fetches districts, bases, and pastors with filters
         */
        function refreshTables() {

            vm.filters = {
                base: 'all',
                branch: 'all',
                district: 'all'
            };

            var data;
            if (localStorage.getItem('pastorslist')) {
                data = JSON.parse(localStorage.getItem('pastorslist'));

                vm.filters.search = data && data.search ? data.search : null;
            }
            getBases(data);
            getTotals(data);
            initDistricts(data);
            initPastorsTable(data);
        }

        /*
        Function that get the totals based on filter
         */
        function getTotals(data) {
            var params = {};
            params.base_id = data && data.base ? data.base.id : (currentUser.base_id || null);
            params.branch_id = data && data.branch ? data.branch.id : (currentUser.branch_id || null);
            params.search = data && data.search || null;

            PastorService.getTotals(params).then(function (response) {
                vm.totals.gold = response.total_gold;
                vm.totals.silver = response.total_silver;
                vm.totals.inactive = response.total_inactive;
            })
        }

        // Function that populates pastor table

        function initPastorsTable(filters) {
            vm.isLoading1 = true;
            filters = filters || {};
            var params = {};

            if (filters.district !== 'all') {
                params.district_id = filters.district ? filters.district : null;
            }

            if ($stateParams.district_id) {
                filters.district = $stateParams.district_id;
            }
            params.limit = 10;
            params.check_status = 1;
            params.page = filters.page || 1;
            params.base_id = filters.base ? filters.base.id : currentUser.base_id || null;
            params.branch_id = filters.branch ? filters.branch.id : currentUser.branch_id || null;
            params.search = filters.search || null;
            params.with = "base.districts,base.branches,district.base,province,city,barangay,applications";


            vm.total_gold = "loading..";
            vm.total_silver = "loading..";
            vm.total_bronze = "loading..";
            vm.total_inactive = "loading..";
            vm.total_pastors = "loading..";
            PastorService.getPastors(params)
                .then(function (data) {
                    vm.isLoading1 = false;
                    vm.pastorsList = data;

                    // var uniqueArray = data?.data?.reduce(function (a, d) {
                    //     if (a.findIndex(todo => todo.id === d.id) === -1) {
                    //         a.push(d);
                    //     }
                    //     return a;
                    // }, []);
                    // vm.pastorsList['data'] = uniqueArray;

                    var filters = angular.copy(params);
                    filters.with = '';
                    filters.limit = 1;

                    if (params.base_id !== 11) {
                        filters.exclude_base = 11; // exclude manila base
                    }
                    PastorService.getPastors(filters).then(function (results) {
                        vm.total_pastors = results.total;

                        filters.member_status = 'gold';
                        PastorService.getPastors(filters).then(function (gold) {
                            vm.total_gold = gold.total;

                            filters.member_status = 'silver';
                            PastorService.getPastors(filters).then(function (silver) {
                                vm.total_silver = silver.total;

                                filters.member_status = 'bronze';
                                PastorService.getPastors(filters).then(function (bronze) {
                                    vm.total_bronze = bronze.total;

                                    filters.member_status = 'inactive';
                                    PastorService.getPastors(filters).then(function (inactive) {
                                        vm.total_inactive = inactive.total;
                                    });
                                });
                            });
                        });
                    });
                });
        }

        /*
        Function that fetches districts
         */
        function initDistricts(filters) {
            vm.isLoading1 = true;
            var params = {
                nopage: 1,
                base_id: filters && filters.base ? filters.base.id : currentUser.base_id ? currentUser.base_id : null
            };

            params.nopage = 1;
            if ($stateParams.base_id) {
                params.base_id = $stateParams.base_id;
            }

            params.with = 'base,branch,base.branches';
            DistrictService.queryDistricts(params)
                .then(function (data) {
                    vm.districts = data;
                    if ($stateParams.district_id) {
                        data.forEach(function (item) {
                            if (item.id == $stateParams.district_id) {
                                vm.filters.district = item.id;
                                vm.filters.base = item.base;
                                vm.filters.branch = item.branch;
                            }
                        });
                    } else {
                        var district = filters && filters.district ? filters.district : 'all';

                        if (params.base_id) {
                            vm.filters.district = 'all';
                            data.forEach(function (item) {
                                if (item.base_id == params.base_id && item.id == district) {
                                    vm.filters.district = item.id;
                                }
                            });
                        } else {
                            vm.filters.district = district;
                        }
                    }

                    initPastorsTable();
                })
        }

        /*
        Function that fetches all bases if user has no base id
         */
        function getBases(data) {
            BaseService.getBases({
                nopage: true,
                base_id: currentUser.base_id,
                with: 'branches'
            }).then(function (response) {
                var base = response[0];

                vm.bases = response;

                if (currentUser.base_id) {
                    vm.filters.base = base;
                } else {
                    vm.filters.base = data && data.base ? data.base : 'all';
                }

                if (currentUser.branch_id) {
                    vm.filters.branch = base.branches.filter(function (item) {
                        return item.id == currentUser.branch_id;
                    }).shift();
                } else {
                    vm.filters.branch = data && data.branch ? data.branch : 'all';
                }
            });
        }


        /*
        Function that selects district filter
         */
        function selectDistrict(data) {
            $stateParams = {};
            initPastorsTable(data);
            localStorage.setItem('pastorslist', JSON.stringify(data));
        }
        // add new cases 
        /*
       Function that adds new pastor
        */
        function addNewCase(pastors) {
            $mdDialog.show({
                controller: 'NewCaseDialogController',
                controllerAs: 'vm',
                // /Users/baps/Desktop/transform/transform-web-main/src/app/main/flourish/tabs/mcp/new case/new-case-dialog.html
                templateUrl: 'app/main/flourish/tabs/mcp/new case/new-case-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    pastorsObj: pastors || null,
                    callback: function () {
                        initPastorsTable(vm.filters);
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function that selects base filter
         */
        function selectBase(data) {
            $stateParams = {};
            vm.filters.branch = 'all';
            vm.filters.district = 'all';
            data.page = 1;
            initPastorsTable(data);
            initDistricts(data);
            localStorage.setItem('pastorslist', JSON.stringify(data));
        }

        /*
        Function that selects branch filter
         */
        function selectBranch(data) {
            data.page = 1;
            initPastorsTable(data);
            localStorage.setItem('pastorslist', JSON.stringify(data));
        }


        /*
      Function used to display all pastors and dropped pastors based on search text
       */
        function selectSearch(data) {
            initPastorsTable(data);
            displayDroppedPastorsTable(data);
            localStorage.setItem('pastorslist', JSON.stringify(data));
        }

        /*
        Function that reset all selected filters
         */
        function resetFilters() {
            if (!currentUser.base_id) {
                vm.filters = {
                    base: 'all',
                    branch: 'all',
                    district: 'all',
                    search: ''
                };
            } else {
                vm.filters.branch = 'all';
                vm.filters.search = '';
                vm.filters.district = 'all';
            }
            $location.url($location.path());
            localStorage.setItem('pastorslist', JSON.stringify(vm.filters));
            initPastorsTable();
        }

        /*
        Function triggered when changing pagination page
         */
        function pageChange(page, filters) {
            filters.page = page;
            if ($stateParams.district_id) {
                filters.district = $stateParams.district_id;
            }

            var data = filters;
            initPastorsTable(data);
            localStorage.setItem('pastorslist', JSON.stringify(data));
        }

        /*
        Function that adds new pastor
         */
        function addNewPastor(pastors) {
            $mdDialog.show({
                controller: 'NewPastorDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/thrive/tabs/pastors/dialogs/new-pastor/new-pastor-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    pastorsObj: pastors || null,
                    callback: function () {
                        initPastorsTable(vm.filters);
                    }
                },
                clickOutsideToClose: true
            });
        }


        /*
        Function that edit pastor
         */
        function editPastor(pastor) {
            showEditPastorDialog(pastor);
        }

        /*
        Function that deletes pastor
         */
        function deletePastor(pastor) {
            $mdDialog.show({
                controller: 'DeletePastorDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/thrive/tabs/pastors/dialogs/delete-pastor/delete-pastor-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    pastor: pastor,
                    callback: function () {
                        getTotals(vm.filters);
                        initPastorsTable(vm.filters);
                        displayDroppedPastorsTable(vm.filters);
                    }
                },
                clickOutsideToClose: true
            });
        }

        //     /*
        //    Function used to permanently delete a savings group
        //     */
        //     function permanentDeletePastor(pastorDelete) {
        //         $mdDialog.show({
        //             controller: 'PermanentDeletePastorDialogController',
        //             controllerAs: 'vm',
        //             templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
        //             parent: angular.element($document.body),
        //             locals: {
        //                 callback: function () {
        //                     PastorService.permanentDeletePastor(pastorDelete).then(function () {
        //                         getTotals(vm.filters);
        //                         initPastorsTable(vm.filters);
        //                         displayDroppedPastorsTable(vm.filters);
        //                     });
        //                 }
        //             },
        //             clickOutsideToClose: true
        //         });
        //     }

        /*
        Function that show edit pastor dialog
         */
        function showEditPastorDialog(pastor) {
            $mdDialog.show({
                controller: 'EditPastorDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/thrive/tabs/pastors/dialogs/edit-pastor/edit-pastor-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    pastor: pastor,
                    initPastorsTable: initPastorsTable
                },
                clickOutsideToClose: true
            });
        }

        // /*
        // Function used to restore a dropped pastor
        //  */
        // function restorePastor(pastorRestore) {
        //     PastorService.restorePastor(pastorRestore).then(function () {
        //         getTotals(vm.filters);
        //         initPastorsTable(vm.filters);
        //         displayDroppedPastorsTable(vm.filters);
        //     })
        // }

        /*
        Function that shows pastor details in bottom sheet
         */
        function showPastorDetails(pastor) {
            if ($state.current.name !== "app.thrive.pastors.details") {
                $state.go("app.thrive.pastors.details", { id: pastor.id }, false);
            }
            $mdBottomSheet.show({
                controller: 'PastorDetailsController',
                controllerAs: 'vm',
                templateUrl: 'app/main/thrive/tabs/pastors/bottom-sheets/pastor-details/pastor-details.html',
                clickOutsideToClose: false,
                disableBackdrop: false,
                disableParentScroll: false,
                locals: {
                    initPastorsTable: initPastorsTable,
                    pastor: pastor.id,
                    parentVm: vm
                }
            }).then(handleParticipantCloseEvent.bind(vm))
                .catch(handleParticipantsError.bind(vm));

            setTimeout(function () {
                var parent = angular.element('#transform-content-wrapper');
                parent.unbind('$md.dragstart')
                    .unbind('$md.drag')
                    .unbind('$md.dragend');
            }, 1000);
        }

        //checks if the state is in pastor details, will open bottom sheet
        if ($state.current.name == "app.thrive.pastors.details") {
            PastorService.getPastor($state.params.id).then(function (pastor) {
                showPastorDetails(pastor);
            }).catch(handleParticipantsError.bind(vm));
        }

        /*
        Function that handles pastor details bottom sheet close event
         */
        function handleParticipantCloseEvent() {
            if ($state.current.name === 'app.thrive.pastors.details') {
                $('.content-white-holder').removeClass('bcopen');
                this.$state.go("app.thrive.pastors");
            }
        }

        /*
        Function that handles bottom sheet error
         */
        function handleParticipantsError(err) {
            $('.content-white-holder').removeClass('bcopen');
            this.$state.go("app.thrive.pastors");
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.flourish')
        .controller('ClusterController', ClusterController);

    /** @ngInject */
    function ClusterController(PastorService, $scope, DataCardService) {

        var vm = this;

        var _parent = $scope;
        _parent.$parent.vm.currentTab = 1;


        //Methods
        vm.addNewFlourishCard = addNewFlourishCard;
        vm.resetForm = resetForm;
        vm.selectPastor = selectPastor;
        vm.searchPastors = searchPastors;

        setDefaultValues();

        /*
        Function to save flourish card
         */

    }
})();


(function () {
    'use strict';

    angular
        .module('app.flourish')
        .controller('ChcController', ChcController);

    /** @ngInject */
    function ChcController($stateParams,
        $state,
        $scope,
        $location,
        $mdDialog,
        $mdBottomSheet,
        $document,
        PastorService,
        Auth,
        BaseService,
        DistrictService) {

        var vm = this;
        var currentUser = Auth.getUser();

        this.$state = $state;

        //Methods
        vm.initPastorsTable = initPastorsTable;
        vm.resetFilters = resetFilters;
        vm.addNewChc = addNewChc;
        vm.editPastor = editPastor;
        vm.deletePastor = deletePastor;
        vm.showPastorDetails = showPastorDetails;
        vm.selectSearch = selectSearch;
        vm.selectDistrict = selectDistrict;
        vm.selectBase = selectBase;
        vm.selectBranch = selectBranch;

        vm.pageChange = pageChange;
        vm.isLoading = true;
        vm.totals = {};
        vm.total_gold = 0;
        vm.total_silver = 0;
        vm.total_bronze = 0;
        vm.total_inactive = 0;
        vm.total_pastors = 0;
        // vm.restorePastors = restorePastors;

        vm.isLoading1 = false;
        vm.isLoading2 = false;

        vm.pastorsList = [];


        var _parent = $scope;
        _parent.$parent.vm.currentTab = 2;

        refreshTables();

        /*
        Function that fetches districts, bases, and pastors with filters
         */
        function refreshTables() {

            vm.filters = {
                base: 'all',
                branch: 'all',
                district: 'all'
            };

            var data;
            if (localStorage.getItem('pastorslist')) {
                data = JSON.parse(localStorage.getItem('pastorslist'));

                vm.filters.search = data && data.search ? data.search : null;
            }
            getBases(data);
            getTotals(data);
            initDistricts(data);
            initPastorsTable(data);
        }

        /*
        Function that get the totals based on filter
         */
        function getTotals(data) {
            var params = {};
            params.base_id = data && data.base ? data.base.id : (currentUser.base_id || null);
            params.branch_id = data && data.branch ? data.branch.id : (currentUser.branch_id || null);
            params.search = data && data.search || null;

            PastorService.getTotals(params).then(function (response) {
                vm.totals.gold = response.total_gold;
                vm.totals.silver = response.total_silver;
                vm.totals.inactive = response.total_inactive;
            })
        }

        // Function that populates pastor table

        function initPastorsTable(filters) {
            vm.isLoading1 = true;
            filters = filters || {};
            var params = {};

            if (filters.district !== 'all') {
                params.district_id = filters.district ? filters.district : null;
            }

            if ($stateParams.district_id) {
                filters.district = $stateParams.district_id;
            }
            params.limit = 10;
            params.check_status = 1;
            params.page = filters.page || 1;
            params.base_id = filters.base ? filters.base.id : currentUser.base_id || null;
            params.branch_id = filters.branch ? filters.branch.id : currentUser.branch_id || null;
            params.search = filters.search || null;
            params.with = "base.districts,base.branches,district.base,province,city,barangay,applications";


            vm.total_gold = "loading..";
            vm.total_silver = "loading..";
            vm.total_bronze = "loading..";
            vm.total_inactive = "loading..";
            vm.total_pastors = "loading..";
            PastorService.getPastors(params)
                .then(function (data) {
                    vm.isLoading1 = false;
                    vm.pastorsList = data;

                    // var uniqueArray = data?.data?.reduce(function (a, d) {
                    //     if (a.findIndex(todo => todo.id === d.id) === -1) {
                    //         a.push(d);
                    //     }
                    //     return a;
                    // }, []);
                    // vm.pastorsList['data'] = uniqueArray;

                    var filters = angular.copy(params);
                    filters.with = '';
                    filters.limit = 1;

                    if (params.base_id !== 11) {
                        filters.exclude_base = 11; // exclude manila base
                    }
                    PastorService.getPastors(filters).then(function (results) {
                        vm.total_pastors = results.total;

                        filters.member_status = 'gold';
                        PastorService.getPastors(filters).then(function (gold) {
                            vm.total_gold = gold.total;

                            filters.member_status = 'silver';
                            PastorService.getPastors(filters).then(function (silver) {
                                vm.total_silver = silver.total;

                                filters.member_status = 'bronze';
                                PastorService.getPastors(filters).then(function (bronze) {
                                    vm.total_bronze = bronze.total;

                                    filters.member_status = 'inactive';
                                    PastorService.getPastors(filters).then(function (inactive) {
                                        vm.total_inactive = inactive.total;
                                    });
                                });
                            });
                        });
                    });
                });
        }

        /*
        Function that fetches districts
         */
        function initDistricts(filters) {
            vm.isLoading1 = true;
            var params = {
                nopage: 1,
                base_id: filters && filters.base ? filters.base.id : currentUser.base_id ? currentUser.base_id : null
            };

            params.nopage = 1;
            if ($stateParams.base_id) {
                params.base_id = $stateParams.base_id;
            }

            params.with = 'base,branch,base.branches';
            DistrictService.queryDistricts(params)
                .then(function (data) {
                    vm.districts = data;
                    if ($stateParams.district_id) {
                        data.forEach(function (item) {
                            if (item.id == $stateParams.district_id) {
                                vm.filters.district = item.id;
                                vm.filters.base = item.base;
                                vm.filters.branch = item.branch;
                            }
                        });
                    } else {
                        var district = filters && filters.district ? filters.district : 'all';

                        if (params.base_id) {
                            vm.filters.district = 'all';
                            data.forEach(function (item) {
                                if (item.base_id == params.base_id && item.id == district) {
                                    vm.filters.district = item.id;
                                }
                            });
                        } else {
                            vm.filters.district = district;
                        }
                    }

                    initPastorsTable();
                })
        }

        /*
        Function that fetches all bases if user has no base id
         */
        function getBases(data) {
            BaseService.getBases({
                nopage: true,
                base_id: currentUser.base_id,
                with: 'branches'
            }).then(function (response) {
                var base = response[0];

                vm.bases = response;

                if (currentUser.base_id) {
                    vm.filters.base = base;
                } else {
                    vm.filters.base = data && data.base ? data.base : 'all';
                }

                if (currentUser.branch_id) {
                    vm.filters.branch = base.branches.filter(function (item) {
                        return item.id == currentUser.branch_id;
                    }).shift();
                } else {
                    vm.filters.branch = data && data.branch ? data.branch : 'all';
                }
            });
        }


        /*
        Function that selects district filter
         */
        function selectDistrict(data) {
            $stateParams = {};
            initPastorsTable(data);
            localStorage.setItem('pastorslist', JSON.stringify(data));
        }

        /*
        Function that selects base filter
         */
        function selectBase(data) {
            $stateParams = {};
            vm.filters.branch = 'all';
            vm.filters.district = 'all';
            data.page = 1;
            initPastorsTable(data);
            initDistricts(data);
            localStorage.setItem('pastorslist', JSON.stringify(data));
        }

        /*
        Function that selects branch filter
         */
        function selectBranch(data) {
            data.page = 1;
            initPastorsTable(data);
            localStorage.setItem('pastorslist', JSON.stringify(data));
        }


        /*
      Function used to display all pastors and dropped pastors based on search text
       */
        function selectSearch(data) {
            initPastorsTable(data);
            displayDroppedPastorsTable(data);
            localStorage.setItem('pastorslist', JSON.stringify(data));
        }

        /*
        Function that reset all selected filters
         */
        function resetFilters() {
            if (!currentUser.base_id) {
                vm.filters = {
                    base: 'all',
                    branch: 'all',
                    district: 'all',
                    search: ''
                };
            } else {
                vm.filters.branch = 'all';
                vm.filters.search = '';
                vm.filters.district = 'all';
            }
            $location.url($location.path());
            localStorage.setItem('pastorslist', JSON.stringify(vm.filters));
            initPastorsTable();
        }

        /*
        Function triggered when changing pagination page
         */
        function pageChange(page, filters) {
            filters.page = page;
            if ($stateParams.district_id) {
                filters.district = $stateParams.district_id;
            }

            var data = filters;
            initPastorsTable(data);
            localStorage.setItem('pastorslist', JSON.stringify(data));
        }

        /*
        Function that adds new pastor
         */
        function addNewChc(pastors) {
            $mdDialog.show({
                controller: 'NewChcDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/flourish/tabs/chc/dialogs/new-chc/new-chc-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    pastorsObj: pastors || null,
                    callback: function () {
                        initPastorsTable(vm.filters);
                    }
                },
                clickOutsideToClose: true
            });
        }


        /*
        Function that edit pastor
         */
        function editPastor(pastor) {
            showEditPastorDialog(pastor);
        }

        /*
        Function that deletes pastor
         */
        function deletePastor(pastor) {
            $mdDialog.show({
                controller: 'DeletePastorDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/thrive/tabs/pastors/dialogs/delete-pastor/delete-pastor-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    pastor: pastor,
                    callback: function () {
                        getTotals(vm.filters);
                        initPastorsTable(vm.filters);
                        displayDroppedPastorsTable(vm.filters);
                    }
                },
                clickOutsideToClose: true
            });
        }

        //     /*
        //    Function used to permanently delete a savings group
        //     */
        //     function permanentDeletePastor(pastorDelete) {
        //         $mdDialog.show({
        //             controller: 'PermanentDeletePastorDialogController',
        //             controllerAs: 'vm',
        //             templateUrl: 'app/common/templates/delete-dialog/delete-dialog.html',
        //             parent: angular.element($document.body),
        //             locals: {
        //                 callback: function () {
        //                     PastorService.permanentDeletePastor(pastorDelete).then(function () {
        //                         getTotals(vm.filters);
        //                         initPastorsTable(vm.filters);
        //                         displayDroppedPastorsTable(vm.filters);
        //                     });
        //                 }
        //             },
        //             clickOutsideToClose: true
        //         });
        //     }

        /*
        Function that show edit pastor dialog
         */
        function showEditPastorDialog(pastor) {
            $mdDialog.show({
                controller: 'EditPastorDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/thrive/tabs/pastors/dialogs/edit-pastor/edit-pastor-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    pastor: pastor,
                    initPastorsTable: initPastorsTable
                },
                clickOutsideToClose: true
            });
        }

        // /*
        // Function used to restore a dropped pastor
        //  */
        // function restorePastor(pastorRestore) {
        //     PastorService.restorePastor(pastorRestore).then(function () {
        //         getTotals(vm.filters);
        //         initPastorsTable(vm.filters);
        //         displayDroppedPastorsTable(vm.filters);
        //     })
        // }

        /*
        Function that shows pastor details in bottom sheet
         */
        function showPastorDetails(pastor) {
            if ($state.current.name !== "app.thrive.pastors.details") {
                $state.go("app.thrive.pastors.details", { id: pastor.id }, false);
            }
            $mdBottomSheet.show({
                controller: 'PastorDetailsController',
                controllerAs: 'vm',
                templateUrl: 'app/main/thrive/tabs/pastors/bottom-sheets/pastor-details/pastor-details.html',
                clickOutsideToClose: false,
                disableBackdrop: false,
                disableParentScroll: false,
                locals: {
                    initPastorsTable: initPastorsTable,
                    pastor: pastor.id,
                    parentVm: vm
                }
            }).then(handleParticipantCloseEvent.bind(vm))
                .catch(handleParticipantsError.bind(vm));

            setTimeout(function () {
                var parent = angular.element('#transform-content-wrapper');
                parent.unbind('$md.dragstart')
                    .unbind('$md.drag')
                    .unbind('$md.dragend');
            }, 1000);
        }

        //checks if the state is in pastor details, will open bottom sheet
        if ($state.current.name == "app.thrive.pastors.details") {
            PastorService.getPastor($state.params.id).then(function (pastor) {
                showPastorDetails(pastor);
            }).catch(handleParticipantsError.bind(vm));
        }

        /*
        Function that handles pastor details bottom sheet close event
         */
        function handleParticipantCloseEvent() {
            if ($state.current.name === 'app.thrive.pastors.details') {
                $('.content-white-holder').removeClass('bcopen');
                this.$state.go("app.thrive.pastors");
            }
        }

        /*
        Function that handles bottom sheet error
         */
        function handleParticipantsError(err) {
            $('.content-white-holder').removeClass('bcopen');
            this.$state.go("app.thrive.pastors");
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.savings-group-community', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider
            .state('app.savings-group-community', {
                abstract: true,
                url: '/savings-group/{id}',

                data: {
                    selectedTab: 0
                },
                defaultChild: 'app.savings-group-community.savings-group-data',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/community-savings-group/community-savings-group.html',
                        controller: 'CommunitySavingsGroupController as vm'
                    }
                }
            })
            .state('app.savings-group-community.savings-group-data', {
                url: '/savings-group-data',

                data: {
                    selectedTab: 0
                },
                views: {
                    'savings-group-community@savings-group-data': {
                        templateUrl: 'app/main/community-savings-group/tabs/savings-group-data/savings-group-data.html',
                        controller: 'SavingsGroupDataController as vm'
                    }
                }
            })
            .state('app.savings-group-community.members', {
                url: '/members',

                data: {
                    selectedTab: 1
                },
                views: {
                    'savings-group-community@members': {
                        templateUrl: 'app/main/community-savings-group/tabs/members/members.html',
                        controller: 'MembersController as vm'
                    }
                }
            })
    }
})();

(function () {
    'use strict';

    angular
        .module('app.savings-group-community')
        .controller('SavingsGroupDataController', SavingsGroupDataController);

    /** @ngInject */
    function SavingsGroupDataController($rootScope,
        $scope,
        $state,
        $stateParams,
        $mdBottomSheet,
        Auth,
        SavingsGroupDataService,
        SavingsGroupService) {
        var vm = this;

        vm.currentUser = Auth.getUser();

        $rootScope.currentTab = 0;

        vm.amounts = [
            {
                label: 'Total Contribution',
                key: 'total_contributions'
            },
            {
                label: 'Total Withdrawn',
                key: 'total_withdrawn'
            },
            {
                label: 'Total Loans Released',
                key: 'total_loans_released'
            },
            {
                label: 'Number of Loans Released',
                key: 'no_of_loans_released'
            },
            {
                label: 'Total Loans Repayments',
                key: 'total_loans_repayments'
            },
            {
                label: 'Total Capital for Group Business',
                key: 'total_capital_for_business'
            },
            {
                label: 'Gross Sales',
                key: 'gross_sale'
            },
            {
                label: 'Total Social Fund Payout',
                key: 'total_social_fund_payout'
            },
            {
                label: 'Number of Kid Savers',
                key: ''
            }
        ];

        //Methods
        vm.addSGData = addSGData;
        vm.editSGData = editSGData;
        vm.checkAttendance = checkAttendance;
        vm.filterSavingsGroupData = filterSavingsGroupData;

        activate();

        /*
        Function used to fetch savings group details and data
         */
        function activate() {
            getSavingsGroup();
            getSavingsGroupDatas();
        }

        /*
        Function used to fetch savings group data
         */
        function getSavingsGroupDatas() {
            SavingsGroupDataService.getSavingsGroupDatas({
                savings_group_id: $stateParams.id,
                sort: 'report_at:asc',
                limit: 100
            })
                .then(function (response) {
                    /* ? [ICMT-3538] temporarily removed
                    vm.datas = response.data.map(function(data) {
                        if (
                            data.total_contributions &&
                            !data.compulsory_contribution &&
                            !data.voluntary_contribution
                        ) {
                            data.compulsory_contribution = data.total_contributions;
                        }

                        return data;
                    });
                    */
                    vm.datas = response.data;
                    vm.all_datas = response.data;
                    vm.tab_datas = [...new Set(response.data.map(date => date.year))].reverse()
                    vm.filterSavingsGroupData(vm.selectedSGYear ? vm.selectedSGYear : vm.tab_datas[0])
                    scrollRight();
                });

        }

        /*
        Function used to check pastor attendance in one sg data
         */
        function checkAttendance(data) {
            if (vm.currentUser.$roles.has(['admin', 'metrics', 'livelihood_coordinator', 'branch_head'])) {
                data.attended = !data.attended;
                delete data.community_id;
                SavingsGroupDataService.editSavingsGroupData(data)
                    .then(function () {
                        $scope.$parent.vm.getSavingsGroup();
                    });
            }
        }

        /*
        Function used to filter sg data
         */
        function filterSavingsGroupData(year) {
            vm.selectedSGYear = year;
            vm.datas = vm.all_datas.filter(date => date.year == year);
        }

        /*
        Function used to automatically scroll the table to the right
         */
        function scrollRight() {
            var width = $('.savings-group-data-table-values').width();

            $('.savings-group-data-table-values').animate({ scrollLeft: width }, 100);
        }

        /*
        Function used to get savings group details
         */
        function getSavingsGroup() {
            var params = {
                with: 'partners'
            };
            SavingsGroupService.getSavingsGroup($stateParams, params)
                .then(function (savings) {
                    vm.savings = savings;

                    SavingsGroupService.getParticipantStats(savings.id)
                        .then(function (stats) {
                            vm.participantStats = stats;
                        });
                });
        }

        /*
        Function used to open add sg data bottom sheet
         */
        function addSGData() {
            $mdBottomSheet.show({
                controller: 'AddSGDataController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community-savings-group/tabs/savings-group-data/bottom-sheets/' +
                    'savings-group-details/savings-group-details.html',
                parent: '#community-content-wrapper',
                clickOutsideToClose: true,
                disableBackdrop: true,
                disableParentScroll: true,
                locals: {
                    sgData: vm.savings,
                    savingsGroup: vm.savings,
                    participantsStats: vm.participantStats,
                    datas: vm.datas,
                    callback: getSavingsGroupDatas
                }
            })
                .then(handleSavingsGroupCloseEvent.bind(vm))
                .catch(handlSavingsGroupError.bind(vm));

            setTimeout(function () {
                var parent = angular.element('#community-content-wrapper');
                parent.unbind('$md.dragstart')
                    .unbind('$md.drag')
                    .unbind('$md.dragend');
            }, 1000);
        }

        /*
        Function used to open edit sg data modal
         */
        function editSGData(data) {
            if (!vm.currentUser.$roles.has(['health_coordinator', 'health_trainer', 'livelihood_trainer', 'health_mentor'])) {
                $mdBottomSheet.show({
                    controller: 'AddSGDataController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/community-savings-group/tabs/savings-group-data/bottom-sheets/' +
                        'savings-group-details/savings-group-details.html',
                    parent: '#community-content-wrapper',
                    clickOutsideToClose: true,
                    disableBackdrop: true,
                    disableParentScroll: true,
                    locals: {
                        sgData: data,
                        savingsGroup: vm.savings,
                        participantsStats: vm.participantStats,
                        datas: vm.datas,
                        callback: getSavingsGroupDatas
                    }
                })
                    .then(handleSavingsGroupCloseEvent.bind(vm))
                    .catch(handlSavingsGroupError.bind(vm));

                setTimeout(function () {
                    var parent = angular.element('#community-content-wrapper');
                    parent.unbind('$md.dragstart')
                        .unbind('$md.drag')
                        .unbind('$md.dragend');
                }, 1000);
            }
        }

        /*
        Function triggered when closing SG data bottom sheet
         */
        function handleSavingsGroupCloseEvent() {
            if ($state.current.name === 'app.community.savings.details') {
                $('.content-white-holder').removeClass('bcopen');
                $state.go("app.community.savings", { id: $state.params.id });
            }
        }

        /*
        Error handle for showing up sg data bottom sheet
         */
        function handlSavingsGroupError(res) {
            $('.content-white-holder').removeClass('bcopen');

            $state.go("app.community.savings", { id: $state.params.id });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.savings-group-community')
        .controller('MembersController', MembersController);

    /** @ngInject */
    function MembersController($rootScope,
        $stateParams,
        $mdDialog,
        $document,
        enumFields,
        Auth,
        SavingsGroupService,
        PastorService,
        ParticipantService) {
        var vm = this;

        var currentUser = Auth.getUser();

        //Methods
        vm.addNonIcmParticipant = addNonIcmParticipant;
        vm.openLeaveSavingsGroupDialog = openLeaveSavingsGroupDialog;
        vm.openMenu = openMenu;
        vm.changeRole = changeRole;
        vm.editContact = editContact;
        vm.editDreamSaveID = editDreamSaveID;
        vm.dropParticipant = dropParticipant;
        vm.restoreParticipant = restoreParticipant;
        vm.formatNumber = formatNumber;

        $rootScope.currentTab = 1;

        vm.isLoading = false;

        activate();

        /*
        Function used to initialize sg roles
         */
        function activate() {
            enumFields(['sg_roles'])
                .then(function (values) {
                    vm.roles = values.sg_roles;
                });
            getSavingsGroup();
        }

        /*
        Function used to get savings group details and fetch members and
        dropped members list
         */
        function getSavingsGroup() {
            SavingsGroupService.getSavingsGroup($stateParams, { with: 'communities' })
                .then(function (savings) {
                    vm.savings = savings;

                    getParticipants(vm.savings);
                    getDroppedParticipants(vm.savings);
                    if (vm.savings.pastor_id) {
                        getPastor(vm.savings.pastor_id);
                    }
                })
        }

        /*
        Function used to get members list
         */
        function getParticipants(savings) {
            vm.isLoading = true;
            vm.participants = [];
            ParticipantService.getParticipants({
                sort: 'lastname:asc',
                is_sg_participant: 1,
                savings_group_id: savings.id,
                nopage: true,
                with: 'community'
            }).then(function (participants) {
                vm.isLoading = false;
                arrangeRoles(participants);
            });

        }

        /*
        Function to get pastor details
        */
        function getPastor(pastor_id) {
            var params = {
            };
            PastorService.getPastor(pastor_id, params)
                .then(function (response) {
                    vm.isLoading1 = false;
                    if (response) {
                        vm.pastor = [response];
                    }
                })
        }

        /*
        Function used to sort members by role
         */
        function arrangeRoles(participants) {
            filterParticipant('leader', participants);
            filterParticipant('secretary', participants);
            filterParticipant('treasurer', participants);
            filterParticipant('auditor', participants);
            filterParticipant('member', participants);
        }

        /*
        Function used to filter member by sg role
         */
        function filterParticipant(key, participants) {
            participants.filter(function (participant) {
                if (participant.sg_role === key) {
                    vm.participants.push(participant);
                }
            });
        }

        /*
        Function used to get dropped members list
         */
        function getDroppedParticipants(savings) {
            vm.isLoading2 = true;
            ParticipantService.getParticipants({
                sort: 'participant_id:asc',
                is_non_sg: 1,
                savings_group_id: savings.id,
                nopage: true,
                with: 'community'
            }).then(function (response) {
                vm.isLoading2 = false;
                vm.trashedParticipants = response;
            });
        }

        /*
        Function used to open menu for the roles
         */
        function openMenu($mdMenu, ev) {
            $mdMenu.open(ev);
        }

        /*
        Function used to open change/assign role modal
         */
        function changeRole(participant, role) {
            $mdDialog.show({
                controller: 'AssignRoleInPrevailController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/tabs/savings/dialogs' +
                    '/assign-role/assign-role-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    participant: participant,
                    savings: vm.savings,
                    participantsList: vm.participants,
                    role: role,
                    callback: function () {
                        getParticipants(vm.savings);
                        getDroppedParticipants(vm.savings);
                    }
                },
                clickOutsideToClose: true
            });
        }

        vm.passwordConfirmation = passwordConfirmation;

        /*
        Function used to open password confirmation dialog 
         */
        function passwordConfirmation(participant) {
            $mdDialog.show({
                controller: 'PasswordConfirmationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/common/password-confirmation-dialog/password-confirmation-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    deleteCallback: () => vm.dropParticipant(participant),
                    callback: function () {
                    }
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to drop a member
         */
        function dropParticipant(participant) {
            var participantObj = {};
            participantObj.is_non_sg = 1;
            participantObj.id = participant.id;
            participantObj.application_id = participant.application_id;

            ParticipantService.editParticipant(participantObj)
                .then(function () {
                    getParticipants(vm.savings);
                    getDroppedParticipants(vm.savings);
                });
        }

        /*
        Function used to restore a member from the drop list
         */
        function restoreParticipant(participant) {
            var participantObj = {};
            participantObj.is_non_sg = 0;
            participantObj.id = participant.id;
            participantObj.application_id = participant.application_id;
            ParticipantService.editParticipant(participantObj)
                .then(function () {
                    getParticipants(vm.savings);
                    getDroppedParticipants(vm.savings);
                })
        }

        /*
        Function used to open edit DreamSave ID modal
         */
        function editDreamSaveID(participant) {
            if (currentUser.$roles.has(['admin', 'metrics', 'livelihood_coordinator'])) {
                $mdDialog.show({
                    controller: 'EditDreamSaveIdController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/community/tabs/savings/dialogs/edit-dream-save-id/edit-dream-save-id-dialog.html',
                    parent: angular.element($document.body),
                    locals: {
                        participant: participant,
                        callback: function () {
                            getParticipants(vm.savings);
                        }
                    },
                    clickOutsideToClose: true
                });
            }
        }

        /*
        Function used to open edit contact modal
         */
        function editContact(participant) {
            if (currentUser.$roles.has(['admin', 'metrics', 'livelihood_coordinator'])) {
                $mdDialog.show({
                    controller: 'EditContactController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/community/tabs/savings/dialogs/edit-contact-no/edit-contact-no-dialog.html',
                    parent: angular.element($document.body),
                    locals: {
                        participant: participant,
                        callback: function () {
                            getParticipants(vm.savings);
                        }
                    },
                    clickOutsideToClose: true
                });
            }
        }

        /*
        Function used to open add non icm participant
         */
        function addNonIcmParticipant() {
            $mdDialog.show({
                controller: 'AddNonICMParticipantPrevailController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community-savings-group/tabs/members/dialogs' +
                    '/add-non-icm-participant/add-non-icm-participant-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    savings: vm.savings,
                    callback: function () {
                        getParticipants(vm.savings);
                        getDroppedParticipants(vm.savings);
                    },
                    community: vm.community
                },
                clickOutsideToClose: true
            });
        }

        /*
        Function used to open the leave savings group modal
         */
        function openLeaveSavingsGroupDialog(participant) {
            if (currentUser.$roles.has(['admin', 'metrics', 'livelihood_coordinator'])) {
                $mdDialog.show({
                    controller: 'LeaveSavingsGroupDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/community-savings-group/tabs/members/dialogs' +
                        '/leave-savings-group/leave-savings-group-dialog.html',
                    parent: angular.element($document.body),
                    locals: {
                        participant: participant,
                        callback: function () {
                            getDroppedParticipants(vm.savings);
                            return getParticipants(vm.savings);
                        }
                    },
                    clickOutsideToClose: true
                });
            }
        }

        function formatNumber(input) {
            if (!input) return
            // Remove any non-digit characters
            const digitsOnly = input.replace(/\D/g, '');

            // Apply the desired pattern
            const formattedNumber = digitsOnly.replace(/(\d{3})(\d{3})(\d{3})/, '$1-$2-$3');

            return formattedNumber;
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular.module('app.toolbar')
        .controller('ChangePasswordDialogController', ChangePasswordDialogController);

    /** @ngInject */
    function ChangePasswordDialogController($mdDialog, ChangePasswordService, required, $rootScope)
    {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.changePassword = changePassword;
        vm.required = required;

        vm.dialogTitle = "Change Password";

        function changePassword(newPassword, confirmPassword) {
            var userObject = {
                id: $rootScope.currentUser.id,
                password: newPassword,
                password_confirmation: confirmPassword
            };
            return ChangePasswordService.changePassword(userObject)
                .then( function () {
                    closeDialog();
                });
        }

        function closeDialog()
        {
            $mdDialog.hide();
        }

    }
})();

(function ()
{
    'use strict';

    angular.module('app.toolbar')
        .controller('SessionExpiredController', SessionExpiredController);

    /** @ngInject */
    function SessionExpiredController($mdDialog)
    {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.dialogTitle = 'Error';

        function closeDialog()
        {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.transform')
        .service('ReportService', ReportService);

    /** @ngInject */
    function ReportService($http, api, helpers) {
        return {
            getXLS: getXLS,
            getCSV: getCSV,
            getHTML: getHTML,
            getReport: getReport,
            saveTemplate: saveTemplate,
            editTemplate: editTemplate,
            deleteTemplate: deleteTemplate,
            getTemplates: getTemplates
        };

        function getXLS(filters) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'reports/xls',
                params: filters
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getCSV(filters) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'reports/csv',
                params: filters
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getHTML(filters) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'reports/html',
                params: filters
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getReport(filters) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'reports',
                params: filters
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function saveTemplate(data) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'report-presets',
                data: data
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editTemplate(preset) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'report-presets/' + preset.id,
                data: preset
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteTemplate(preset) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'report-presets/' + preset.id,
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getTemplates(params) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'report-presets',
                params: params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.transform')
        .service('RegionService', RegionService);

    /** @ngInject */
    function RegionService($http, api, helpers)
    {

        return {
            getRegions : getRegions
        };

        function getRegions(filters)
        {
            var filters = $.extend({sort: 'name:asc'}, filters);
            var promise = {
                method : 'GET',
                url    : api.baseUrl + 'regions',
                params : filters
            };

            return $http(promise)
                .then(getRegionsComplete)
                .catch(helpers.catchInvalidRequests);

            function getRegionsComplete(response)
            {
                return response.data.data;
            }
        }

        function getRegion(region)
        {
            var promise = {
                method : 'GET',
                url    : api.baseUrl + 'regions/' + region
            };

            return $http(promise)
                .then(editRegionComplete)
                .catch(helpers.catchInvalidRequests);

            function editRegionComplete(response)
            {
                return response.data;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.thrive')
        .service('ProvinceService', ProvinceService);

    /** @ngInject */
    function ProvinceService($http, api, helpers) {

        return {
            getProvinces: getProvinces,
            getProvince: getProvince,
            addProvince: addProvince,
            deleteProvince: deleteProvince,
            editProvince: editProvince,
            updateBaseProvince: updateBaseProvince
        };

        function getProvinces(filters) {
            var filters = filters || {};

            filters.limit = filters.limit || 10;
            filters.page = filters.page || 1;

            var promise = {
                method: 'GET',
                url: api.baseUrl + 'provinces',
                params: filters
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getProvince(province) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'provinces/' + province
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addProvince(province) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'provinces',
                data: province
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteProvince(province) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'provinces/' + province.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editProvince(province) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'provinces/' + province.id,
                data: province
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function updateBaseProvince(province) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'bases/update-base',
                data: province
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }
    }
})();


(function () {
    'use strict';

    angular
        .module('app.transform')
        .service('PastorService', PastorService);

    /** @ngInject */
    function PastorService($http, api, helpers) {

        return {
            getPastors: getPastors,
            getPastor: getPastor
        };

        function getPastors(filters) {
            var filters = $.extend({ sort: 'firstname:asc' }, filters);
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'pastors',
                params: filters
            };

            return $http(promise)
                .then(getPastorsComplete)
                .catch(helpers.catchInvalidRequests);

            function getPastorsComplete(response) {
                return response.data.data;
            }
        }

        function getPastor(pastor) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'pastors/' + pastor
            };

            return $http(promise)
                .then(editPastorComplete)
                .catch(helpers.catchInvalidRequests);

            function editPastorComplete(response) {
                return response.data;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.transform')
        .service('ParticipantService', ParticipantService);

    /** @ngInject */
    function ParticipantService($http, $q, api, helpers, xhrQueue) {

        var deferred = $q.defer();

        return {
            getParticipants: getParticipants,
            getParticipantsIssues: getParticipantsIssues,
            getCommunityIdList: getCommunityIdList,
            getParticipant: getParticipant,
            addParticipant: addParticipant,
            deleteParticipant: deleteParticipant,
            deleteBulkParticipant: deleteBulkParticipant,
            editParticipantStatus: editParticipantStatus,
            addParticipantAttendance: addParticipantAttendance,
            removeParticipantAttendance: removeParticipantAttendance,
            getTrashedParticipants: getTrashedParticipants,
            editParticipant: editParticipant,
            verifyParticipantDreamSaveId: verifyParticipantDreamSaveId,
            addRemarks: addRemarks,
            postMCR: postMCR,
            postBCR: postBCR,

            saveParticipantAttendance: saveParticipantAttendance,

            addNote: addNote,
            getNotes: getNotes,
            deleteNote: deleteNote,
            editNote: editNote,

            addGibNote: addGibNote,
            getGibNotes: getGibNotes,
            deleteGibNote: deleteGibNote,
            editGibNote: editGibNote,


            restoreParticipant: restoreParticipant,
            hardDeleteParticipant: hardDeleteParticipant,

            leaveSG: leaveSG
        };

        function postMCR(participant) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'participants/' + participant.id + '/mcr',
                data: participant
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function postBCR(participant) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'participants/' + participant.id + '/bcr',
                data: participant
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getParticipants(filters) {
            var filters = $.extend({ sort: 'firstname:asc' }, filters);
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'participants',
                params: filters
            };

            return $http(promise)
                .then(getParticipantsComplete)
                .catch(helpers.catchInvalidRequests);

            function getParticipantsComplete(response) {
                var data = response.data.data || response.data;
                var counter = 0;
                var items = angular.forEach(data, function (item) {
                    if (item.status !== 'disqualified') {
                        counter += 1;
                        item.participant_no = counter;
                    } else {
                        item.participant_no = null;
                    }
                });

                if (response.data.data) {
                    response.data.data = items;

                    return response.data;
                } else {
                    return items;
                }
            }
        }

        function getParticipantsIssues(participant) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'participants/icondata',
                data: participant
            };

            return $http(promise)
                .then(getParticipantsComplete)
                .catch(helpers.catchInvalidRequests);

            function getParticipantsComplete(response) {
                return response.data.data || response.data;;
            }
        }

        function getCommunityIdList(community) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'communityHistory/' + community.id,
            };

            return $http(promise)
                .then(getParticipantsComplete)
                .catch(helpers.catchInvalidRequests);

            function getParticipantsComplete(response) {
                return response.data.data || response.data;;
            }
        }

        function getTrashedParticipants(filter) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'participants',
                params: filter
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addParticipant(participant) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'participants',
                data: participant
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function restoreParticipant(participant) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'participants/' + participant.id + '/restore'
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteParticipant(participant) {
            var url = api.baseUrl + 'participants/' + participant.id;

            if (typeof participant.reasons_for_dropping !== "undefined") {
                url += '?reasons_for_dropping=' + participant.reasons_for_dropping;
            }

            var promise = {
                method: 'DELETE',
                url: url
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteBulkParticipant(participant) {
            var url = api.baseUrl + 'participants/bulkdelete';

            var promise = {
                method: 'DELETE',
                url: url,
                data: participant,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function hardDeleteParticipant(participant) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'participants/' + participant.id + '/remove'
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editParticipantStatus(participant, toStatus) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'participants/' + participant.id,
                data: {
                    status: toStatus
                }
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editParticipant(participant) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'participants/' + participant.id,
                data: participant
            };

            if (!participant.id) {
                return deferred.reject();
            }

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function verifyParticipantDreamSaveId(participant) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'participants/' + participant.id + "/dreamsaver?application_id=" + participant.application_id + "&dreamsave=" + participant.dreamsave + "&id=" + participant.id,
            };

            if (!participant.id) {
                return deferred.reject();
            }

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addRemarks(participant) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'participants/' + participant.id + "?remarks=" + participant.remarks + "&application_id=" + participant.application_id,
            };

            if (!participant.id) {
                return deferred.reject();
            }

            if (!participant.remarks) {
                return deferred.reject();
            }

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function saveParticipantAttendance(data) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'participants/attendance',
                data: data
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addParticipantAttendance(participantId, weekNames) {
            if (weekNames.constructor !== Array) {
                weekNames = [weekNames];
            }

            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'participants/' + participantId + '/attendance',
                data: {
                    weeks: weekNames,
                    attend: 1
                }
            };

            return xhrQueue("pattendance", promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function removeParticipantAttendance(participantId, weekNames) {
            if (weekNames.constructor !== Array) {
                weekNames = [weekNames];
            }

            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'participants/' + participantId + '/attendance',
                data: {
                    weeks: weekNames,
                    attend: 0
                }
            };

            return xhrQueue("pattendance", promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getParticipant(participant, params) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'participants/' + participant,
                params: params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getNotes(participant, params) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'community-bib-participants/' + participant + '/notes',
                params: params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addNote(participant, note) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'community-bib-participants/' + participant + '/notes',
                data: note
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteNote(participant, note) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'community-bib-participants/' + participant + '/notes/' + note,
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editNote(participant, note) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'community-bib-participants/' + participant + '/notes/' + note.id,
                data: note
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getGibNotes(participant) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'community-gib-participants/' + participant + '/notes',
                params: {
                    sort: 'created_at:asc',
                    nopage: true
                }
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addGibNote(participant, note) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'community-gib-participants/' + participant + '/notes',
                data: note
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteGibNote(participant, note) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'community-gib-participants/' + participant + '/notes/' + note,
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editGibNote(participant, note) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'community-gib-participants/' + participant + '/notes/' + note.id,
                data: note
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function leaveSG(id, date, reason) {
            var options = {
                method: 'PATCH',
                url: api.baseUrl + 'participants/' + id,
                data: {
                    date_left: date,
                    reasons_for_leaving: reason
                }
            };

            return $http(options)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.transform')
        .service('HbfService', HbfService);

    /** @ngInject */
    function HbfService($http, api, Upload, helpers) {

        return {
            getHbfs           : getHbfs,
            getHbf            : getHbf,
            getTrashedHbfs    : getTrashedHbfs,
            addHbf            : addHbf,
            softDeleteHbf     : softDeleteHbf,
            restoreHbf        : restoreHbf,
            hardDeleteHbf     : hardDeleteHbf,
            updateHbf         : updateHbf,
            calculateScore    : calculateScore,

            addWeightLog      : addWeightLog,
            editWeightLog     : editWeightLog,
            deleteWeightLog   : deleteWeightLog,

            uploadBeforePhoto : uploadBeforePhoto,
            uploadAfterPhoto  : uploadAfterPhoto,
            deleteBeforePhoto : deleteBeforePhoto,
            deleteAfterPhoto  : deleteAfterPhoto,

            getNotes           : getNotes,
            addNote            : addNote,
            deleteNote         : deleteNote,
            editNote           : editNote
        };

        function getNotes(hbf, params) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'community-hbfs/' + hbf + '/notes',
                params: params
            };

            return $http(promise)
                .then(getNotesComplete)
                .catch(helpers.catchInvalidRequests);

            function getNotesComplete(response) {
                return response.data;
            }
        }

        function addNote(hbf, note) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'community-hbfs/' + hbf + '/notes',
                data: note
            };

            return $http(promise)
                .then(addNoteComplete)
                .catch(helpers.catchInvalidRequests);

            function addNoteComplete(response) {
                return response.data;
            }
        }

        function deleteNote(hbf, note) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'community-hbfs/' + hbf + '/notes/' + note,
            };

            return $http(promise)
                .then(deleteNoteComplete)
                .catch(helpers.catchInvalidRequests);

            function deleteNoteComplete(response) {
                return response.data;
            }
        }

        function editNote(hbf, note) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'community-hbfs/' + hbf + '/notes/' + note.id,
                data: note
            };

            return $http(promise)
                .then(editNoteComplete)
                .catch(helpers.catchInvalidRequests);

            function editNoteComplete(response) {
                return response.data;
            }
        }

        function getHbfs(params) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'community-hbfs',
                params: params
            };

            return $http(promise)
                .then(getHbfsComplete)
                .catch(helpers.catchInvalidRequests);

            function getHbfsComplete(response) {
                return response.data;
            }
        }

        function getHbf(hbfId, params) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'community-hbfs/' + hbfId,
                params: params || {}
            };

            return $http(promise)
                .then(getHbfsComplete)
                .catch(helpers.catchInvalidRequests);

            function getHbfsComplete(response) {
                return response.data;
            }
        }

        function getTrashedHbfs(community) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'community-hbfs',
                params: {
                    nopage : true,
                    community_id : community,
                    trashed : 1,
                    sort : 'created_at:asc'
                }
            };

            return $http(promise)
                .then(getTrashedHbfsComplete)
                .catch(helpers.catchInvalidRequests);

            function getTrashedHbfsComplete(response) {
                return response.data;
            }
        }

        function addHbf(hbf) {
            if (hbf.photo) {
                var promise = Upload.upload({
                    url  : api.baseUrl + 'community-hbfs',
                    data : hbf
                });
            } else {
                var promise = $http({
                    method : 'POST',
                    url    : api.baseUrl + 'community-hbfs',
                    data   : hbf
                });
            }

            return promise.then(addCommunityComplete)
                    .catch(helpers.catchInvalidRequests);

            function addCommunityComplete(response) {
                return response.data;
            }
        }

        function restoreHbf(hbf) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'community-hbfs/' + hbf.id + '/restore'
            };

            return $http(promise)
                .then(restoreHbfComplete)
                .catch(helpers.catchInvalidRequests);

            function restoreHbfComplete(response) {
                return response.data;
            }
        }

        function softDeleteHbf(hbf) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'community-hbfs/' + hbf.id
            };

            return $http(promise)
                .then(softDeleteHbfComplete)
                .catch(helpers.catchInvalidRequests);

            function softDeleteHbfComplete(response) {
                return response.data;
            }
        }

        function hardDeleteHbf(hbf) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'community-hbfs/' + hbf.id + '/remove'
            };

            return $http(promise)
                .then(hardDeleteHbfComplete)
                .catch(helpers.catchInvalidRequests);

            function hardDeleteHbfComplete(response) {
                return response.data;
            }
        }

        function updateHbf(hbf, data) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'community-hbfs/' + hbf,
                data: data
            };

            return $http(promise)
                .then(updateHbfComplete)
                .catch(helpers.catchInvalidRequests);

            function updateHbfComplete(response) {
                return response.data;
            }
        }

        function calculateScore(data) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'community-hbfs/calculate',
                data: data
            };

            return $http(promise)
                .then(calculateScoreComplete)
                .catch(helpers.catchInvalidRequests);

            function calculateScoreComplete(response) {
                return response;
            }
        }

        function addWeightLog(hbfId, data) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'community-hbfs/' + hbfId + '/weight-logs',
                data: data
            };

            return $http(promise)
                .then(addWeightLogComplete)
                .catch(helpers.catchInvalidRequests);

            function addWeightLogComplete(response) {
                return response;
            }
        }

        function editWeightLog(hbfId, data) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'community-hbfs/' + hbfId + '/weight-logs/' + data.id,
                data: data
            };

            return $http(promise)
                .then(editWeightLogComplete)
                .catch(helpers.catchInvalidRequests);

            function editWeightLogComplete(response) {
                return response;
            }
        }

        function deleteWeightLog(hbfId, logId) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'community-hbfs/' + hbfId + '/weight-logs/' + logId,
            };

            return $http(promise)
                .then(deleteWeightLogComplete)
                .catch(helpers.catchInvalidRequests);

            function deleteWeightLogComplete(response) {
                return response;
            }
        }

        function uploadBeforePhoto(hbfId, photo) {
            var promise = {
                url  : api.baseUrl + 'community-hbfs/' + hbfId + '/before-photo',
                data : {
                    photo : photo
                }
            };

            return Upload.upload(promise)
                .then(uploadBeforePhotoComplete, photo)
                .catch(helpers.catchInvalidRequests);

            function uploadBeforePhotoComplete(response, photo) {
                return response;
            }
        }

        function uploadAfterPhoto(hbfId, photo) {
            var promise = {
                url  : api.baseUrl + 'community-hbfs/' + hbfId + '/after-photo',
                data : {
                    photo : photo
                }
            };

            return Upload.upload(promise)
                .then(uploadBeforePhotoComplete, photo)
                .catch(helpers.catchInvalidRequests);

            function uploadBeforePhotoComplete(response, photo) {
                return response;
            }
        }

        function deleteBeforePhoto(hbfId) {
            var promise = {
                method : 'DELETE',
                url    : api.baseUrl + 'community-hbfs/' + hbfId + '/before-photo'
            };

            return $http(promise)
                .then(deleteBeforePhotoComplete)
                .catch(helpers.catchInvalidRequests);

            function deleteBeforePhotoComplete(response) {
                return response;
            }
        }

        function deleteAfterPhoto(hbfId) {
            var promise = {
                method : 'DELETE',
                url    : api.baseUrl + 'community-hbfs/' + hbfId + '/after-photo'
            };

            return $http(promise)
                .then(deleteBeforePhotoComplete)
                .catch(helpers.catchInvalidRequests);

            function deleteBeforePhotoComplete(response) {
                return response;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.transform')
        .service('GibService', GibService);

    /** @ngInject */
    function GibService($http, api, helpers) {

        return {
            getGibs: getGibs,
            getGib: getGib,
            getTrashedGibs: getTrashedGibs,
            addGib: addGib,
            softDeleteGib: softDeleteGib,
            restoreGib: restoreGib,
            hardDeleteGib: hardDeleteGib,
            updateGib: updateGib
        };

        function updateGib(gib, data) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'community-gibs/' + gib,
                data: data
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getGibs(community) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'community-gibs',
                params: {
                    nopage: true,
                    community_id: community
                }
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getGib(gibId) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'community-gibs/' + gibId,
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getTrashedGibs(community) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'community-gibs',
                params: {
                    nopage: true,
                    community_id: community,
                    trashed: 1
                }
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addGib(gib) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'community-gibs',
                data: gib
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function restoreGib(gib) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'community-gibs/' + gib.id + '/restore'
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function softDeleteGib(gib) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'community-gibs/' + gib.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function hardDeleteGib(gib) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'community-gibs/' + gib.id + '/remove'
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.transform')
        .service('GibPaymentService', GibPaymentService);

    /** @ngInject */
    function GibPaymentService($http, api, helpers) {

        return {
            getGibPayments   : getGibPayments,
            getGibPayment    : getGibPayment,
            editGibPayment   : editGibPayment,
            addGibPayment    : addGibPayment,
            deleteGibPayment : deleteGibPayment
        };

        function getGibPayments(params) {
            var params = $.extend({}, {
                page  : 1,
                limit : 10,
                sort  : "updated_at:desc"
            }, params);

            var promise = {
                method : 'GET',
                url    : api.baseUrl + 'community-gib-payments',
                params : params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getGibPayment(id) {
            var promise = {
                method : 'GET',
                url    : api.baseUrl + 'community-gib-payments/' + id,
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editGibPayment(payment) {
            var promise = {
                method : 'PATCH',
                url    : api.baseUrl + 'community-gib-payments/' + payment.id,
                data   : payment
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addGibPayment(payment) {
            var promise = {
                method : 'POST',
                url    : api.baseUrl + 'community-gib-payments',
                data   : payment
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteGibPayment(payment) {
            var promise = {
                method : 'DELETE',
                url    : api.baseUrl + 'community-gib-payments/' + payment.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.transform')
        .service('GibParticipantService', GibParticipantService);

    /** @ngInject */
    function GibParticipantService($http, api, helpers) {

        return {
            getGibParticipants   : getGibParticipants,
            getGibParticipant    : getGibParticipant,
            editGibParticipant   : editGibParticipant,
            addGibParticipant    : addGibParticipant,
            deleteGibParticipant : deleteGibParticipant
        };

        function getGibParticipants(params) {
            var params = $.extend({}, {
                page  : 1,
                limit : 10,
                sort  : "id:desc"
            }, params);

            var promise = {
                method : 'GET',
                url    : api.baseUrl + 'community-gib-participants',
                params : params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getGibParticipant(id) {
            var promise = {
                method : 'GET',
                url    : api.baseUrl + 'community-gib-participants/' + id,
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editGibParticipant(participant) {
            var promise = {
                method : 'PATCH',
                url    : api.baseUrl + 'community-gib-participants/' + participant.id,
                data   : participant
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addGibParticipant(participant) {
            var promise = {
                method : 'POST',
                url    : api.baseUrl + 'community-gib-participants',
                data   : participant
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteGibParticipant(participant) {
            var promise = {
                method : 'DELETE',
                url    : api.baseUrl + 'community-gib-participants/' + participant.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.thrive')
        .service('DenominationService', DenominationService);

    /** @ngInject */
    function DenominationService($http, api, helpers) {

        return {
            getDenominations: getDenominations,
            getDenomination  : getDenomination,
            addDenomination: addDenomination,
            deleteDenomination: deleteDenomination,
            editDenomination: editDenomination
        };

        function getDenominations(page) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'denominations',
                params: {
                    limit: 10,
                    page: page
                }
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getDenomination(denomination)
        {
            var promise = {
                method : 'GET',
                url    : api.baseUrl + 'denominations/' + denomination
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addDenomination(denomination) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'denominations',
                data: denomination
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);

        }

        function deleteDenomination(denomination) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'denominations/' + denomination.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editDenomination(denomination) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'denominations/' + denomination.id,
                data: denomination
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }
    }
})();


(function () {
    'use strict';

    angular
        .module('app.transform')
        .service('CommunityService', CommunityService);

    /** @ngInject */
    function CommunityService($http, api, xhrQueue, Upload, helpers) {

        return {
            queryCommunities: queryCommunities,
            getCommunity: getCommunity,
            getTotalParticipants: getTotalParticipants,
            editCommunity: editCommunity,
            addCommunity: addCommunity,
            deleteCommunity: deleteCommunity,
            getAttendance: getAttendance,
            getWeeklyStats: getWeeklyStats,
            updateWeeklyStats: updateWeeklyStats,
            getBibs: getBibs,
            getTrashedBibs: getTrashedBibs,
            addBib: addBib,
            softDeleteBib: softDeleteBib,
            restoreBib: restoreBib,
            hardDeleteBib: hardDeleteBib,
            getCommunityStats: getCommunityStats,
            uploadBannerPhoto: uploadBannerPhoto,
            uploadGraduationPhoto: uploadGraduationPhoto,
            deleteBannerPhoto: deleteBannerPhoto,
            deleteGraduationPhoto: deleteGraduationPhoto
        };

        function queryCommunities(data) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'communities',
                params: data
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getAttendance(community) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'communities/' + community.id + '/weekly-attendance'
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getTotalParticipants(data) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'communities/total-participants',
                params: data
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getWeeklyStats(community) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'communities/' + community + '/weekly-stats'
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getBibs(community) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'community-bibs',
                params: {
                    nopage: true,
                    community_id: community
                }
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getTrashedBibs(community) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'community-bibs',
                params: {
                    nopage: true,
                    community_id: community,
                    trashed: 1
                }
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addBib(community) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'community-bibs',
                data: community
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function restoreBib(bib) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'community-bibs/' + bib.id + '/restore'
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function softDeleteBib(bib) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'community-bibs/' + bib.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function hardDeleteBib(bib) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'community-bibs/' + bib.id + '/remove'
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function updateWeeklyStats(community, data) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'communities/' + community + '/weekly-stats',
                data: data
            };

            return xhrQueue("weeklystats", promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getCommunity(id, params) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'communities/' + id,
                params: params || {}
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getCommunityStats(id, params) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'communities/' + id + '/sg-stats',
                params: params || {}
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editCommunity(community, data) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'communities/' + community.id,
                data: data
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function uploadBannerPhoto(community, photo) {
            var promise = {
                url  : api.baseUrl + 'communities/' + community.id + '/banner-photo',
                data : {
                    photo : photo
                }
            };

            return Upload.upload(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function uploadGraduationPhoto(community, photo) {
            var promise = {
                url  : api.baseUrl + 'communities/' + community.id + '/graduation-photo',
                data : {
                    photo : photo
                }
            };

            return Upload.upload(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteBannerPhoto(community) {
            var promise = {
                method : 'DELETE',
                url    : api.baseUrl + 'communities/' + community.id + '/banner-photo'
            };

            return $http(promise)
                .then(onComplete);
        }

        function deleteGraduationPhoto(community) {
            var promise = {
                method : 'DELETE',
                url    : api.baseUrl + 'communities/' + community.id + '/graduation-photo'
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addCommunity(community) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'communities',
                data: community
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteCommunity(community) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'communities/' + community.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.transform')
        .service('CityService', CityService);

    /** @ngInject */
    function CityService($http, api, xhrQueue, helpers)
    {

        return {
            getCities    : getCities,
            getCity      : getCity,
            editCity     : editCity,
            updateBranch : updateBranch
        };

        function getCities(filters)
        {
            var filters = $.extend({sort: 'name:asc'}, filters);
            var promise = {
                method : 'GET',
                url    : api.baseUrl + 'cities',
                params : filters
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getCity(city)
        {
            var promise = {
                method : 'GET',
                url    : api.baseUrl + 'cities/' + city
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editCity(city) {
            var promise = {
                method : 'PATCH',
                url    : api.baseUrl + 'cities/' + city.id,
                data   : city
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function updateBranch(cityId, branchId) {
            var promise = {
                method : 'PATCH',
                url    : api.baseUrl + 'cities/' + cityId,
                data   : {
                    branch_id : branchId
                }
            };

            return xhrQueue("citybranch", promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.transform')
        .service('BusinessLoansService', BusinessLoansService);

    /** @ngInject */
    function BusinessLoansService($http, api, helpers) {

        return {
            getBusinessLoans: getBusinessLoans,
            addBusinessLoan: addBusinessLoan,
            updateBusinessLoan: updateBusinessLoan,
            deleteBusinessLoan: deleteBusinessLoan
        };

        function getBusinessLoans(params) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'community-product-business-loans',
                params: params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addBusinessLoan(loan) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'community-product-business-loans',
                data: loan
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function updateBusinessLoan(id, data) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'community-product-business-loans/' + id,
                data: data
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteBusinessLoan(id) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'community-product-business-loans/' + id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.transform')
        .service('BibService', BibService);

    /** @ngInject */
    function BibService($http, api, helpers) {

        return {
            getBibs: getBibs,
            getBib: getBib,
            getTrashedBibs: getTrashedBibs,
            addBib: addBib,
            softDeleteBib: softDeleteBib,
            bulkDeleteBib: bulkDeleteBib,
            restoreBib: restoreBib,
            hardDeleteBib: hardDeleteBib,
            updateBib: updateBib
        };

        function updateBib(bib, data) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'community-bibs/' + bib,
                data: data
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getBibs(params) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'community-bibs',
                params: params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getBib(bibId, params) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'community-bibs/' + bibId,
                params: params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getTrashedBibs(params) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'community-bibs',
                params: params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addBib(bib) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'community-bibs',
                data: bib
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function restoreBib(bib) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'community-bibs/' + bib.id + '/restore'
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function softDeleteBib(bib) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'community-bibs/' + bib.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }


        function bulkDeleteBib(bib) {
            var url = api.baseUrl + 'community-bibs/bulkdelete';

            var promise = {
                method: 'DELETE',
                url: url,
                data: bib,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function hardDeleteBib(bib) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'community-bibs/' + bib.id + '/remove'
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.transform')
        .service('BibPaymentService', BibPaymentService);

    /** @ngInject */
    function BibPaymentService($http, api, helpers) {

        return {
            getBibPayments: getBibPayments,
            getBibPayment: getBibPayment,
            editBibPayment: editBibPayment,
            addBibPayment: addBibPayment,
            deleteBibPayment: deleteBibPayment
        };

        function getBibPayments(params) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'community-bib-payments',
                params: params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getBibPayment(id) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'community-bib-payments/' + id,
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editBibPayment(payment) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'community-bib-payments/' + payment.id,
                data: payment
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addBibPayment(payment) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'community-bib-payments',
                data: payment
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);

        }

        function deleteBibPayment(payment) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'community-bib-payments/' + payment.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.transform')
        .service('BibParticipantService', BibParticipantService);

    /** @ngInject */
    function BibParticipantService($http, api, helpers) {

        return {
            getBibParticipants   : getBibParticipants,
            getBibParticipant    : getBibParticipant,
            editBibParticipant   : editBibParticipant,
            addBibParticipant    : addBibParticipant,
            deleteBibParticipant : deleteBibParticipant
        };

        function getBibParticipants(params) {
            var promise = {
                method : 'GET',
                url    : api.baseUrl + 'community-bib-participants',
                params : params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getBibParticipant(id) {
            var promise = {
                method : 'GET',
                url    : api.baseUrl + 'community-bib-participants/' + id,
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editBibParticipant(participant) {
            var promise = {
                method : 'PATCH',
                url    : api.baseUrl + 'community-bib-participants/' + participant.id,
                data   : participant
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addBibParticipant(participant) {
            var promise = {
                method : 'POST',
                url    : api.baseUrl + 'community-bib-participants',
                data   : participant
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);

        }

        function deleteBibParticipant(participant) {
            var promise = {
                method : 'DELETE',
                url    : api.baseUrl + 'community-bib-participants/' + participant.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.transform')
        .service('BarangayService', BarangayService);

    /** @ngInject */
    function BarangayService($http, api, helpers)
    {

        return {
            getBarangays : getBarangays,
            getBarangay  : getBarangay
        };

        function getBarangays(filters)
        {
            var promise = {
                method : 'GET',
                url    : api.baseUrl + 'barangays',
                params : filters
            };

            return $http(promise)
                .then(getBarangaysComplete)
                .catch(helpers.catchInvalidRequests);

            function getBarangaysComplete(response)
            {
                return response.data.data;
            }
        }

        function getBarangay(barangay)
        {
            var promise = {
                method : 'GET',
                url    : api.baseUrl + 'barangays/' + barangay
            };

            return $http(promise)
                .then(editBarangayComplete)
                .catch(helpers.catchInvalidRequests);

            function editBarangayComplete(response)
            {
                return response.data;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.transform')
        .service('ApplicationService', ApplicationService);

    /** @ngInject */
    function ApplicationService($http, api, helpers) {

        return {
            queryApplications: queryApplications,
            getApplication: getApplication,
            getTotalParticipants: getTotalParticipants,
            getDeletedApplications: getDeletedApplications,
            editApplication: editApplication,
            addApplication: addApplication,
            deleteApplication: deleteApplication,
            approveApplication: approveApplication,
            dropApplication: dropApplication,
            restoreApplication: restoreApplication,
            deleteDeletedApplication: deleteDeletedApplication
        };

        function getDeletedApplications(params) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'applications',
                params: params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function restoreApplication(application) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'applications/' + application.id + '/restore'
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteDeletedApplication(application) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'applications/' + application.id + '/remove'
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function queryApplications(data) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'applications',
                params: data
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getApplication(id, params) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'applications/' + id,
                params: params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getTotalParticipants(data) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'applications/total-participants',
                params: data
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editApplication(application) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'applications/' + application.id,
                data: application
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addApplication(application) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'applications',
                data: application
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);

        }

        function deleteApplication(application) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'applications/' + application.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function dropApplication(application) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'applications/' + application.id,
                data: {
                    approved: 0
                }
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function approveApplication(application) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'applications/' + application.id,
                data: {
                    approved: 1
                }
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.thrive')
        .service('PastorService', PastorService);

    /** @ngInject */
    function PastorService($http, api, xhrQueue, helpers, $q) {

        var service = {
            getPastors: getPastors,
            addPastor: addPastor,
            deletePastorlist: deletePastorlist,
            editPastorlist: editPastorlist,
            getPastor: getPastor,
            addContact: addContact,
            editContact: editContact,
            deleteContact: deleteContact,
            addChurch: addChurch,
            deleteChurch: deleteChurch,
            deleteBulkPastor: deleteBulkPastor,
            addPastorAttendance: addPastorAttendance,
            removePastorAttendance: removePastorAttendance,
            searchPastors: searchPastors,
            searchgroupleader: searchgroupleader,
            postMCR: postMCR,
            postBCR: postBCR,
            savePastorAttendance: savePastorAttendance,
            getTotals: getTotals,
            restorePastor: restorePastor,
            permanentDeletePastor: permanentDeletePastor
        };

        function getPastors(params) {
            var defaults = {
                // limit: 10,
                // page: 1
            };

            var params = $.extend({}, defaults, typeof params === 'object' ? params : { search: params });

            var promise = {
                method: 'GET',
                url: api.baseUrl + 'pastors',
                params: params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getPastor(pastor, params) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'pastors/' + pastor,
                params: params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getTotals(params) {
            var defaults = {
                // limit: 10,
                // page: 1
            };

            var params = $.extend({}, defaults, typeof params === 'object' ? params : { search: params });

            var promise = {
                method: 'GET',
                url: api.baseUrl + 'pastors/statuscount',
                params: params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function postMCR(participant) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'pastors/' + participant.id + '/mcr',
                data: participant
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function postBCR(participant) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'pastors/' + participant.id + '/bcr',
                data: participant
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function savePastorAttendance(data) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'pastors/attendance',
                data: data
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function searchPastors(params) {
            var defaults = {
                sort: 'lastname:asc',
                limit: 10,
                page: 1
            };

            var params = $.extend({}, defaults, params);

            var promise = {
                method: 'GET',
                url: api.baseUrl + 'pastors',
                params: params
            };

            return $http(promise)
                .then(searchPastorsComplete)
                .catch(helpers.catchInvalidRequests);

            function searchPastorsComplete(response) {
                return response.data.data;
            }
        }

        // gl
        function searchgroupleader(params) {
            var defaults = {

            };

            // var params = $.extend({}, defaults, params);

            var promise = {
                method: 'GET',
                url: api.baseUrl + 'pastors/groupleaderlist/' + params.id,
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);

        }

        function addPastorAttendance(pastorId, community, weekNames) {
            if (weekNames.constructor !== Array) {
                weekNames = [weekNames];
            }

            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'pastors/' + pastorId + '/attendance',
                data: {
                    weeks: weekNames,
                    attend: 1,
                    community_id: community
                }
            };

            return xhrQueue("pattendance", promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function removePastorAttendance(pastorId, community, weekNames) {
            if (weekNames.constructor !== Array) {
                weekNames = [weekNames];
            }

            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'pastors/' + pastorId + '/attendance',
                data: {
                    weeks: weekNames,
                    attend: 0,
                    community: community
                }
            };

            return xhrQueue("pattendance", promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editPastorlist(pastors) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'pastors/' + pastors.id,
                data: pastors
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deletePastorlist(id) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'pastors/' + id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function permanentDeletePastor(pastor) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'pastors/' + pastor.id + '/remove',
                data: pastor
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addPastor(pastor) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'pastors',
                data: pastor
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addChurch(pastor, church, data) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'pastors/' + pastor.id + '/churches/' + church.id,
                data: data
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteBulkPastor(pastor) {
            var url = api.baseUrl + 'pastors/bulkdelete';

            var promise = {
                method: 'DELETE',
                url: url,
                data: pastor,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteChurch(pastor, church) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'pastors/' + pastor.id + '/churches/' + church.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addContact(pastor) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'pastors/' + pastor.id + '/contacts',
                data: pastor
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editContact(pastor, contact) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'pastors/' + pastor.id + '/contacts/' + contact,
                data: pastor
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteContact(pastor, contact) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'pastors/' + pastor + '/contacts/' + contact,
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function restorePastor(pastor) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'pastors/' + pastor.id + '/restore',
                data: pastor
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }
        // function onDestroy(canceler) {
        //     setTimeout(() => {
        //         console.log('dis', canceler)
        //         canceler.resolve()
        //     }, 1000);
        // }
        return service;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.thrive')
        .service('DistrictService', DistrictService);

    /** @ngInject */
    function DistrictService($http, api, helpers) {

        return {
            getDistricts: getDistricts,
            queryDistricts: queryDistricts,
            addDistrict: addDistrict,
            deleteDistrict: deleteDistrict,
            editDistrict: editDistrict
        };

        function getDistricts(params) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'districts',
                params: params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function queryDistricts(params) {
            var params = params || {};

            if (!params.nopage) {
                params.page = params.page || 1;
                params.limit = params.limit || 10;
            }

            var promise = {
                method: 'GET',
                url: api.baseUrl + 'districts',
                params: params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addDistrict(district) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'districts',
                data: district
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteDistrict(district) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'districts/' + district.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editDistrict(district) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'districts/' + district.id,
                data: district
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.thrive')
        .service('DataCardService', DataCardService);

    /** @ngInject */
    function DataCardService($http, api, helpers) {

        var service = {
            getDataCards: getDataCards,
            addDataCard: addDataCard,
            deleteDataCard: deleteDataCard,
            editDataCard: editDataCard
        };

        function getDataCards(params) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'data-cards',
                params: params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addDataCard(datacard) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'data-cards',
                data: datacard
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteDataCard(datacard) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'data-cards/' + datacard.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function editDataCard(datacard) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'data-cards/' + datacard.id,
                data: datacard
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.thrive')
        .service('CounselorService', CounselorService);

    /** @ngInject */
    function CounselorService($http, api, helpers) {

        var service = {
            addChurch: addChurch,
            deleteChurch: deleteChurch
        };

        function addChurch(counselor, church, data) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'participants/' + counselor.id + '/churches/' + church.id,
                data: data
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteChurch(counselor, church) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'participants/' + counselor.id + '/churches/' + church.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.thrive')
        .service('ChurchService', ChurchService);

    /** @ngInject */
    function ChurchService($http, api, helpers) {

        return {
            getChurches: getChurches,
            addChurch: addChurch,
            deleteChurch: deleteChurch,
            deleteBulkChurch: deleteBulkChurch,
            hardDeleteChurch: hardDeleteChurch,
            restoreChurch: restoreChurch,
            editChurch: editChurch,
            getChurch: getChurch,
            addPastor: addPastor,
            deletePastor: deletePastor,
            addLayleader: addLayleader,
            searchChurches: searchChurches,
            deleteLayleader: deleteLayleader
        };

        function getChurch(church, params) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'churches/' + church,
                params: params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getChurches(filters) {
            var filters = filters || {};

            filters.limit = filters.limit || 10;
            filters.page = filters.page || 1;

            var promise = {
                method: 'GET',
                url: api.baseUrl + 'churches',
                params: filters
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function searchChurches(params) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'churches',
                params: params
            };

            return $http(promise)
                .then(searchChurchesComplete)
                .catch(helpers.catchInvalidRequests);

            function searchChurchesComplete(response) {
                return response.data.data;
            }
        }

        function addChurch(church) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'churches',
                data: church
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteChurch(church) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'churches/' + church.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteBulkChurch(church) {
            var url = api.baseUrl + 'churches/bulkdelete';

            var promise = {
                method: 'DELETE',
                url: url,
                data: church,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function hardDeleteChurch(churche) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'churches/' + churche.id + '/remove',
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function restoreChurch(churche) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'churches/' + churche.id + '/restore',
                data: churche
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }


        function editChurch(church) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'churches/' + church.id,
                data: church
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addPastor(church, data) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'churches/' + church.id + '/pastors',
                data: data
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deletePastor(church, pastor) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'churches/' + church.id + '/pastors/' + pastor.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addLayleader(church, data) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'churches/' + church.id + '/counselors',
                data: data
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteLayleader(church, layleader) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'churches/' + church.id + '/counselors/' + layleader.id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.thrivesettings')
        .controller('ThriveSettingsController', ThriveSettingsController);

    /** @ngInject */
    function ThriveSettingsController($rootScope, $state) {
        var vm = this;

        // default tab
        $rootScope.currentTab = 1;

        // change tab on state change
        $rootScope.$on('$stateChangeSuccess', function (event, toState) {
            if (typeof toState.data !== "undefined") {
                $rootScope.currentTab = toState.data.selectedTab || 1;
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .controller('SettingsController', SettingsController);

    /** @ngInject */
    function SettingsController($rootScope, $state) {
        var vm = this;

        // default tab
        $rootScope.currentTab = 1;

        // change tab on state change
        $rootScope.$on('$stateChangeSuccess', function (event, toState) {
            if (typeof toState.data !== "undefined") {
                $rootScope.currentTab = toState.data.selectedTab || 0;
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.changelogs')
        .controller('ChangelogsSettingsController', ChangelogsSettingsController);

    /** @ngInject */
    function ChangelogsSettingsController($rootScope, $state) {
        var vm = this;

        // default tab
        $rootScope.currentTab = 1;

        // change tab on state change
        $rootScope.$on('$stateChangeSuccess', function (event, toState) {
            if (typeof toState.data !== "undefined") {
                $rootScope.currentTab = toState.data.selectedTab || 1;
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.prevailsettings')
        .controller('PrevailSettingsController', PrevailSettingsController);

    /** @ngInject */
    function PrevailSettingsController($rootScope, $state) {
        var vm = this;

        // default tab
        $rootScope.currentTab = 1;

        // change tab on state change
        $rootScope.$on('$stateChangeSuccess', function (event, toState) {
            if (typeof toState.data !== "undefined") {
                $rootScope.currentTab = toState.data.selectedTab || 1;
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.reports.monthly-report', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {

        // State
        $stateProvider
            .state('app.reports_monthly_report', {
                url: '/reports/monthly-report',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/reports/monthly-report/monthly-report.html',
                        controller: 'MonthlyReportController as vm'
                    }
                }
            });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.reports.monthly-report')
        .controller('MonthlyReportController', MonthlyReportController);

    /** @ngInject */
    function MonthlyReportController(
        $scope,
        $sce,
        Auth,
        api,
        BatchService,
        ProgramService,
        BaseService,
        ReportService,
        $localStorage,
        $httpParamSerializer
    )
    {
        var vm = this;

        var _parent = $scope;
        _parent.$parent.vm.currentTab = 0;

        // Data
        vm.filters        = {};
        var currentUser   = Auth.getUser();
        vm.currentUser    = currentUser;
        vm.api            = api;

        vm.reports        = [];
        vm.downloadParams = '';

        // Methods
        vm.selectedBase   = selectBase;
        vm.getReport      = getReport;
        vm.selectBatch    = selectBatch;

        vm.isLoading      = false;

        activate();

        function activate() {
            getBases();
            getPrograms();
            getBatches();
        }

        /*
        Function used to listen for base change
         */
        function selectBase() {
            vm.filters.branch = 'all';
        }

        function selectBatch(data) {
        }

        /*
        Function that fetches all bases if user has no assigned base
         */
        function getBases() {
            BaseService.getBases({
                nopage: true,
                base_id: currentUser.base_id,
                with: 'branches'
            }).then(function (response) {
                var base = response[0];

                vm.bases = response;

                if (currentUser.base_id) {
                    vm.filters.base = base;
                } else {
                    vm.filters.base = base;
                }

                if (currentUser.branch_id) {
                    vm.filters.branch = base.branches.filter(function(item) {
                      return item.id == currentUser.branch_id;
                    }).shift();
                } else {
                    vm.filters.branch = 'all';
                }
            });
        }

        /*
        Function used to populate base report
         */
        function getReport(filters) {
            vm.isLoading      = true;
            vm.reports        = [];
            vm.downloadParams = '';
            vm.selectedReport = false;

            getReportsHtml(filters.program);
        }

        /*
        Build the reports html
         */
        function getReportsHtml(program) {
            var htmlObj = {
                'base_id': vm.filters.base.id,
            };

            var tempcsvobj = {
                'base_id': vm.filters.base.id,
                'token': $localStorage.currentUser.token
            };

            if (program === "prevail") {
                htmlObj['programs[]'] = 'monthly_prevail_report';
            } else if (program === "thrive") {
                htmlObj['programs[]'] = 'monthly_thrive_report';
            } else if (program && typeof program === "object") {
                htmlObj['programs[]']   = 'monthly_transform_report';
                htmlObj['program_id[]'] = program.id;
            } else {
                htmlObj['programs[]'] = [
                    'monthly_thrive_report',
                    'monthly_prevail_report',
                    'monthly_transform_report',
                ];

                htmlObj['program_id[]'] = [];
                vm.programs.forEach(function(item) {
                    htmlObj['program_id[]'].push(item.id);
                });
            }

            if (vm.filters.branch) {
                htmlObj.branch_id = vm.filters.branch.id;
            }

            if (vm.filters.batch) {
                htmlObj.batch_id = vm.filters.batch.id;
            }

            htmlObj = cleanupObject(htmlObj);

            vm.downloadParams = $.param(htmlObj);

            ReportService.getHTML(htmlObj).then(function (response) {
                vm.reports = response.data.data;

                // select the first entry as the default report
                var selectedReport = null;
                for (var i in vm.reports.navs) {
                    selectedReport = i;
                    break;
                }
                vm.reports.selectedReport = selectedReport;

                vm.isLoading = false;
            }).catch(function (response) {
                vm.isLoading = false;
            });
        }

        /*
        Removes null attributes
         */
        function cleanupObject(obj) {
            var tmp = {};

            for (var key in obj) {
                var val = obj[key];

                if (val !== null && typeof val !== "undefined") {
                    tmp[key] = val;
                }
            }

            return tmp;
        }

        /*
        Function to get batches
         */
        function getBatches() {
            BatchService.getBatches({
                current: 1,
                limit: 1
            }).then(function(response) {
                vm.currentBatch = response.data && response.data.length > 0 ? response.data[0] : '';
            });

            BatchService.getBatches({
                'nopage': true,
                'sort': 'fiscal_year:desc,batch_no:desc'
            })
                .then(function (batches) {
                    vm.batches = batches;
                    vm.filters.batch = vm.currentBatch || batches[0];
                });
        }

        /*
        Function to get all programs
         */
        function getPrograms(data) {
            ProgramService.getPrograms({
                nopage: true,
                active: true
            }).then(function (response) {
                vm.programs = response;
                vm.filters.program = 'prevail';
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.reports.donors-report', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {

        // State
        $stateProvider
            .state('app.reports_donors', {
                url: '/reports/donors',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/reports/donors-report/donors-report.html',
                        controller: 'DonorsReportController as vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.reports.donors-report')
        .controller('DonorsReportController', DonorsReportController);

    /** @ngInject */
    function DonorsReportController($state,
                                    $timeout,
                                    $mdDialog,
                                    $document,
                                    CommunityService,
                                    Auth) {
        var vm = this;
        var currentUser = Auth.getUser();

        if(currentUser.roles[0] !== 'admin' && currentUser.roles[0] !== 'donor_services' && currentUser.roles[0] !== 'donor_managers') {
            $state.go('app.transform.applications');
        }

        //Methods
        vm.callPastorInformation = callPastorInformation;
        vm.communityPageChange = communityPageChange;
        vm.getCommunityList = getCommunityList;
        vm.searchCommunities = searchCommunities;
        vm.goToFilter = goToFilter;

        vm.isLoading3 = false;
        vm.communities = [];

        activate();

        /*
        Function used to initialize filters
         */
        function activate() {
            vm.filters = {
                search_donor: '',
                page: 1
            };

            var data;
            if (localStorage.getItem('donors')) {
                data = JSON.parse(localStorage.getItem('donors'));
                vm.filters.search_donor = data && data.search_donor ? data.search_donor : null;
                getCommunityList(data)
            }
        }

        /*
        Function that is triggered to redirect to donors pdf page
         */
        function goToFilter(id) {
            $state.go('app.donorsfilter', {id: id});
        }

        /*
        Function triggered when changing page of the community list
         */
        function communityPageChange(page, filters) {
            filters.page = page;
            var data = filters;
            getCommunityList(data);
            localStorage.setItem('donors', JSON.stringify(data));
        }

        /*
        Function used to check if a community has pastor then open pastor details modal
         */
        function callPastorInformation(pastorId) {
            if (pastorId) showPastorInformationDialog(pastorId);
        }

        /*
        Function used to open pastor details modal
         */
        function showPastorInformationDialog(pastor) {
            $mdDialog.show({
                controller: 'PastorInformationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/transform/dialogs/pastor-information/pastor-information-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    pastor: pastor
                },
                clickOutsideToClose: true
            });
        }

        var prevSearchCalls = null;
        function searchCommunities(data) {
            if (prevSearchCalls) {
                $timeout.cancel(prevSearchCalls);
            }

            prevSearchCalls = $timeout(function() {
                getCommunityList(data);
            }, 1000);
        }

        /*
        Function used to get community list
         */
        function getCommunityList(data) {
            if (!data.search_donor) {
                vm.communities.data = [];
                return;
            }

            localStorage.setItem('donors', JSON.stringify(data));

            vm.communities = [];
            var data = data || {};
            var params = {};

            params.approved = 1;
            params.limit = 10;
            params.page = data.page || 1;
            params.program_id = data.program ? data.program.id : null;
            params.batch_id = data.batch ? data.batch.id : null;
            params.search_donor = data.search_donor;
            params.base_branch_id = data.base && data.base.id && data.branch ? data.branch.id : null;
            params.with = "application.base.branches,application.program," +
                "application.pastor,application.pastor.churches," +
                "application.pastor.churches.affiliation," +
                "application.pastor.base," +
                "application.pastor.province," +
                "application.pastor.city," +
                "application.pastor.barangay," +
                "application.pastor.contacts," +
                "donor,application,savingsGroup,savingsGroupData";

            if (currentUser.base_id) {
                params.base_id = currentUser.base_id;
            } else {
                params.base_id = data.base ? data.base.id : null;
            }

            vm.isLoading3 = true;

            CommunityService.queryCommunities(params).then(function (data) {
                vm.communities = data;
                vm.isLoading3 = false;
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.reports.branch-report')
        .controller('BranchReportController', BranchReportController);

    /** @ngInject */
    function BranchReportController()
    {
        var vm = this;

        vm.currentTab = 0;

        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.reports.base-report')
        .controller('BaseReportController', BaseReportController);

    /** @ngInject */
    function BaseReportController()
    {
        var vm = this;

        vm.currentTab = 0;

        // Data

        // Methods

        //////////
    }
})();
(function () {
    'use strict';

    angular
        .module('app.prevail')
        .service('SavingsGroupService', SavingsGroupService);

    /** @ngInject */
    function SavingsGroupService($http, api, helpers) {

        return {
            addSavingsGroup: addSavingsGroup,
            editSavingsGroup: editSavingsGroup,
            getSavingsGroup: getSavingsGroup,
            getSavingsGroups: getSavingsGroups,
            findSavingGroupsMethod: findSavingGroupsMethod,
            getParticipantStats: getParticipantStats,
            joinExistingGroup: joinExistingGroup,
            mergeExistingGroup: mergeExistingGroup,
            dropSavingsGroup: dropSavingsGroup,
            deleteSavingsGroup: deleteSavingsGroup,
            restoreSavingsGroup: restoreSavingsGroup,
            getTotals: getTotals
        };

        function getSavingsGroup(savings, params) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'savings-groups/' + savings.id,
                params: params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function mergeExistingGroup(payload) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'savings-groups/merge-savings-groups/',
                data: JSON.stringify(payload)
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function joinExistingGroup(savings, community) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'savings-groups/' + savings.id + '/add-community',
                data: community
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function findSavingGroupsMethod(payload) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'savings-groups/findSavingGroups',
                data: payload,
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getSavingsGroups(params) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'savings-groups',
                params: params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getParticipantStats(id) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'savings-groups/' + id + '/participants-stats'
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getTotals(params) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'savings-groups/stats',
                params: params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }


        function editSavingsGroup(savings) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'savings-groups/' + savings.id,
                data: savings
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function dropSavingsGroup(id) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'savings-groups/' + id
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteSavingsGroup(savings) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'savings-groups/' + savings.id + '/remove',
                data: savings
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addSavingsGroup(savings) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'savings-groups',
                data: savings
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function restoreSavingsGroup(savings) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'savings-groups/' + savings.id + '/restore',
                data: savings
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.prevail')
        .service('SavingsGroupDataService', SavingsGroupDataService);

    /** @ngInject */
    function SavingsGroupDataService($http, api, helpers) {

        return {
            addSavingsGroupData: addSavingsGroupData,
            editSavingsGroupData: editSavingsGroupData,
            getSavingsGroupDatas: getSavingsGroupDatas,
            getSavingsGroupData: getSavingsGroupData,
            deleteSavingsGroupData: deleteSavingsGroupData,
        };

        function getSavingsGroupData(data) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'savings-group-data/' + data.id,
                params: {}
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function getSavingsGroupDatas(params) {
            var promise = {
                method: 'GET',
                url: api.baseUrl + 'savings-group-data',
                params: params
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }


        function editSavingsGroupData(data) {
            console.log("--edit", +data);
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'savings-group-data/' + data.id,
                data: data
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function deleteSavingsGroupData(data) {
            var promise = {
                method: 'DELETE',
                url: api.baseUrl + 'savings-group-data/' + data.id,
                data: data
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function addSavingsGroupData(data) {
            console.log(data)
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'savings-group-data',
                data: data
            };

            return $http(promise)
                .then(onComplete)
                .catch(helpers.catchInvalidRequests);
        }

        function onComplete(response) {
            return response.data;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider ) {
        // State
        $stateProvider
            .state('app.login', {
                url: '/login',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.login': {
                        templateUrl: 'app/main/login/login.html',
                        controller: 'LoginController as vm'
                    }
                },
                bodyClass: 'login'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/login');
    }
})();
(function () {
    'use strict';

    angular
        .module('app.login')
        .service('LoginService', LoginService);

    /** @ngInject */
    function LoginService($http, api) {

        var service = {
            login: login
        };

        function login(username, password) {
            var promise = {
                method: 'POST',
                url: api.baseUrl + 'users/login',
                data: {
                    username: username,
                    password: password
                }
            };

            return $http(promise)
                .then(loginComplete)

            function loginComplete(response) {
                return response.data;
            }
        }

        return service;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('pagination', pagination);

    /** @ngInject */
    function pagination() {
        var directive = {
            restrict: 'EA',
            templateUrl: 'app/core/directives/pagination/pagination.html',
            controllerAs: 'vm',
            scope: {
                items: '=items',
                callback: '&'
            }
        };

        return directive;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('ngEnter', ngEnter);

    /** @ngInject */
    function ngEnter() {
        return function (scope, element, attrs) {
            element.bind("keydown keypress", function (event) {
                if(event.which === 13) {
                    scope.$apply(function (){
                        scope.$eval(attrs.ngEnter);
                    });

                    event.preventDefault();
                }
            });
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider() {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item) {
            if (!angular.isString(path)) {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for (var i = 0; i < parent.length; i++) {
                if (parent[i]._id === id) {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if (updateItem) {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if (angular.isUndefined(item.weight) || !angular.isNumber(item.weight)) {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path) {
            if (!angular.isString(path)) {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for (var p = 0; p < parts.length; p++) {
                var id = parts[p];

                for (var i = 0; i < item.length; i++) {
                    if (item[i]._id === id) {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if (item[i]._path === path) {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent) {
            // If parent not provided, sort the root items
            if (!parent) {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for (var i = 0; i < parent.length; i++) {
                var children = parent[i].children;

                if (children.length > 1) {
                    children.sort(_byWeight);
                }

                if (children.length > 0) {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts) {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if (parts.length === 1) {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for (var i = 0; i < parts.length; i++) {
                var _id = parts[i],
                    createParent = true;

                for (var p = 0; p < parent.length; p++) {
                    if (parent[p]._id === _id) {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if (createParent) {
                    var item = {
                        _id: _id,
                        _path: parts.join('.'),
                        title: _id,
                        weight: 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y) {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item) {
            var uisref = '';

            if (angular.isDefined(item.state)) {
                uisref = item.state;

                if (angular.isDefined(item.stateParams) && angular.isObject(item.stateParams)) {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function () {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem: saveItem,
                deleteItem: deleteItem,
                sort: sortByWeight,
                clearNavigation: clearNavigation,
                setActiveItem: setActiveItem,
                getActiveItem: getActiveItem,
                getNavigation: getNavigation,
                getFlatNavigation: getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded: setFolded,
                getFolded: getFolded,
                setFoldedOpen: setFoldedOpen,
                getFoldedOpen: getFoldedOpen,
                toggleFolded: toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation() {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if (navigationScope) {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope) {
                activeItem = {
                    node: node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem() {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root) {
                if (root) {
                    for (var i = 0; i < navigation.length; i++) {
                        if (navigation[i]._id === root) {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root) {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope) {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status) {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded() {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status) {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen() {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded() {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation) {
                var flatNav = [];

                for (var x = 0; x < navigation.length; x++) {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if (navigation[x].children.length > 0) {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService) {
        var vm = this;

        // Data
        if ($scope.root) {
            vm.navigation = msNavigationService.getNavigation($scope.root);

        }
        else {
            vm.navigation = msNavigationService.getNavigation();
        }
        // console.log(vm.navigation);
        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();
        /**
         * Initialize
         */
        function init() {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService) {
        return {
            restrict: 'E',
            scope: {
                folded: '=',
                root: '@'
            },
            controller: 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude: true,
            compile: function (tElement) {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement) {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init() {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if (msNavigationService.getFolded() === null) {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if (msNavigationService.getFolded()) {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function () {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function () {
                        return sidenav.isLockedOpen();
                    }, function (current, old) {
                        if (angular.isUndefined(current) || angular.equals(current, old)) {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if (folded) {
                            if (current) {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if (activeItem) {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old) {
                        if (angular.isUndefined(current) || angular.equals(current, old)) {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded) {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if (folded) {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if (activeItem) {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander() {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function () {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser() {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser() {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event) {
                        if (event) {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if (activeItem) {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event) {
                        if (event) {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function () {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function () {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function () {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService) {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        vm.hasMatchedRegex = hasMatchedRegex;
        vm.stateName = $state.current.name;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if (!vm.hasChildren || vm.group) {
                vm.collapsable = false;
            }
            else {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if (!vm.collapsable) {
                vm.collapsed = false;
            }
            else {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function () {
                // Expand if the current scope is collapsable and is collapsed
                if (vm.collapsable && vm.collapsed) {
                    $scope.$evalAsync(function () {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path) {
                if (vm.collapsed || !vm.collapsable) {
                    return;
                }

                // If there is no path defined, collapse
                if (angular.isUndefined(path)) {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if (activeItem) {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if (givenPathParts.indexOf(vm.node._id) > -1) {
                        return;
                    }

                    // Test for active path
                    if (activePathParts.indexOf(vm.node._id) > -1) {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function () {
                vm.stateName = $state.current.name;

                if (vm.node.state === $state.current.name) {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ($state.includes(vm.node.state)) {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed() {
            if (vm.collapsed) {
                vm.expand();
            }
            else {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse() {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function () {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height': height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function () {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height': ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand() {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position': 'absolute',
                'visibility': 'hidden',
                'display': 'block',
                'height': 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position': '',
                'visibility': '',
                'display': '',
                'height': ''
            });

            $scope.$evalAsync(function () {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height': '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function () {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass() {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden() {
            if (angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden)) {
                return vm.node.hidden();
            }

            return false;
        }

        function hasMatchedRegex() {
            return vm.node.regex && vm.node.regex(vm.stateName);
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective() {
        return {
            restrict: 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller: 'MsNavigationNodeController as vm',
            compile: function (tElement) {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl) {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if (MsNavigationNodeCtrl.group) {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective() {
        return {
            restrict: 'A',
            require: '^msNavigationNode',
            compile: function (tElement) {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl) {
                    // If the item is collapsable...
                    if (MsNavigationNodeCtrl.collapsable) {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function () {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService) {
        return {
            restrict: 'E',
            scope: {
                root: '@'
            },
            controller: 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude: true,
            compile: function (tElement) {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope) {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService) {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function () {
                // Mark as active if has children
                if (vm.hasChildren) {
                    $scope.$evalAsync(function () {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function () {
                if (!vm.hasChildren) {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if (activeItem) {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if (activePathParts.indexOf(vm.node._id) > -1) {
                    $scope.$evalAsync(function () {
                        vm.isActive = true;
                    });
                }
                else {
                    $scope.$evalAsync(function () {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function () {
                if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass() {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective() {
        return {
            restrict: 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller: 'MsNavigationHorizontalNodeController as vm',
            compile: function (tElement) {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl) {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if (MsNavigationHorizontalNodeCtrl.group) {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia) {
        return {
            restrict: 'A',
            require: '^msNavigationHorizontalNode',
            compile: function (tElement) {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl) {
                    iElement.on('click', onClick);

                    function onClick() {
                        if (!MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md')) {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function () {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('contentover', contentoverDirective);

    /** @ngInject */
    function contentoverDirective($compile)
    {
    	return {
			restrict : 'A',
			link     : function(scope, element, attrs) {
				var x, y;

				element.on('mousemove', function(e) {
					x = e.pageX, y = e.pageY;
					this.children[0].style.top = (y + 15) + 'px';
					this.children[0].style.left = (x + 15) + 'px';
				});
			}
		};
    }
});

(function () {
    'use strict';

    angular
        .module('app.settings')
        .service('ChangePasswordService', ChangePasswordService);

    /** @ngInject */
    function ChangePasswordService($http, api) {

        var service = {
            changePassword: changePassword
        };

        function changePassword(user) {
            var promise = {
                method: 'PATCH',
                url: api.baseUrl + 'users/me',
                data: user
            };

            return $http(promise)
                .then(changePasswordComplete);

            function changePasswordComplete(response) {
                return response.data;
            }
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.transform')
        .controller('TransformController', TransformController);

    /** @ngInject */
    function TransformController($rootScope, $state) {
        var vm = this;
        var userRole = localStorage.getItem('userRole');

        // default tab
        vm.currentTab = 0;

        if (vm.currentTab === 0 || vm.currentTab === 1) {
            if (userRole === 'health_coordinator' || userRole === 'livelihood_coordinator'
                || userRole === 'health_trainer' || userRole === 'livelihood_trainer') {
                $state.go('app.transform.community-lists');
            }
        }
        // change tab on state change
        $rootScope.$on('$stateChangeSuccess', handleTansitionTabStates.bind(this));

        function handleTansitionTabStates(event, toState) {
            if (typeof toState.data !== "undefined") {
                this.currentTab = toState.data.selectedTab || 0;
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.thrive')
        .controller('ThriveController', ThriveController);

    /** @ngInject */
    function ThriveController($rootScope, $state) {
        var vm = this;
        var userRole = localStorage.getItem('userRole');
        // default tab
        vm.currentTab = 0;

        if (vm.currentTab === 0) {
            if (userRole === 'health_coordinator' || userRole === 'livelihood_coordinator'
                || userRole === 'health_trainer' || userRole === 'livelihood_trainer'
                || userRole === 'donor_managers' || userRole === 'donor_services'
                || userRole === 'health_mentor') {
                $state.go('app.thrive.districts');
            }
        }

        // change tab on state change
        $rootScope.$on('$stateChangeSuccess', handleTansitionTabStates.bind(this));

        function handleTansitionTabStates(event, toState) {
            if (typeof toState.data !== "undefined") {
                this.currentTab = toState.data.selectedTab || 0;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.prevail')
        .controller('PrevailController', PrevailController);

    /** @ngInject */
    function PrevailController($rootScope, $state) {
        var vm = this;

        // default tab
        vm.currentTab = 0;

        // change tab on state change
        $rootScope.$on('$stateChangeSuccess', handleTansitionTabStates.bind(this));

        function handleTansitionTabStates(event, toState) {
            if (typeof toState.data !== "undefined") {
                this.currentTab = toState.data.selectedTab || 0;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($http, api, $state, $localStorage, LoginService) {
        var vm = this;

        //Methods
        vm.login = login;

        /*
        Function used to login and set Bearer token to headers
         */
        function login(username, password) {
            vm.errorLogin = '';
            LoginService.login(username, password).then(function (data) {
                var token = data.token;
                if (token) {
                    $localStorage.currentUser = {
                        username: username,
                        token: token
                    };

                    $http.defaults.headers.common.Authorization = 'Bearer' + token;
                    $http(api.user.me()).then(function (response) {
                        localStorage.setItem('userRole', response.data.roles[0]);
                        var userRole = response.data.roles[0];
                        if (userRole === 'health_coordinator' || userRole === 'livelihood_coordinator'
                            || userRole === 'health_trainer' || userRole === 'livelihood_trainer') {
                            $state.go('app.transform.community-lists');
                        } else {
                            $state.go('app.transform.applications');
                        }
                    });
                }
            }, function (data) {
                if (data.data.status_code === 500) {
                    vm.errorLogin = 'Invalid credentials';
                } else {
                    vm.errorLogin = data.data.message;
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.community')
        .controller('CommunityController', CommunityController);

    /** @ngInject */
    function CommunityController($rootScope,
                                 $stateParams,
                                 $state,
                                 $mdDialog,
                                 $document,
                                 CommunityService) {
        var vm = this;

        //Methods
        vm.showCommunityDetails = showCommunityDetails;
        vm.goToCommunity = goToCommunity;

        initCommunity();

        // default tab
        $rootScope.currentTab = 0;

        // change tab on state change
        $rootScope.$on('$stateChangeSuccess', function (event, toState) {
            if (typeof toState.data !== "undefined") {
                $rootScope.currentTab = toState.data.selectedTab || 0;
            }
        });

        /*
        Function used to initialize community
         */
        function initCommunity() {
            CommunityService.getCommunity($stateParams.id, {with: 'application.pastor,application.program.parent,application.base,application.base.branches,savingsGroup,savingsGroupData,updatedby,donor,healthMentor,healthTrainer,livelihoodTrainer'})
                .then(function (community) {
                    vm.community = community;
                });
        }

        /*
        Function used to go back in the community list
         */
        function goToCommunity() {
            $state.go('app.transform.community-lists');
        }

        /*
        Function used to show community details modal
         */
        function showCommunityDetails() {
            $mdDialog.show({
                controller: 'CommunityDetailsController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/dialogs/community-details/community-details-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    community: vm.community || null,
                    callback: (function (community) {
                        this.vm.community = community;
                    }).bind({
                        $state: $state,
                        vm: vm
                    })
                },
                clickOutsideToClose: true
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.flourish')
        .controller('FlourishController', FlourishController);

    /** @ngInject */
    function FlourishController($rootScope, $state) {
        var vm = this;
        var userRole = localStorage.getItem('userRole');
        // default tab
        vm.currentTab = 0;

        if (vm.currentTab === 0) {
            if (userRole === 'health_coordinator' || userRole === 'livelihood_coordinator'
                || userRole === 'health_trainer' || userRole === 'livelihood_trainer'
                || userRole === 'donor_managers' || userRole === 'donor_services'
                || userRole === 'health_mentor') {
                $state.go('app.flourish.mcp');
            }
        }

        // change tab on state change
        $rootScope.$on('$stateChangeSuccess', handleTansitionTabStates.bind(this));

        function handleTansitionTabStates(event, toState) {
            if (typeof toState.data !== "undefined") {
                this.currentTab = toState.data.selectedTab || 0;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.donorsfilter', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {

        // State
        $stateProvider
            .state('app.donorsfilter', {
                url: '/donors/{id}/filter',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/donors-filter/donors-filter.html',
                        controller: 'DonorsFilterController as vm'
                    }
                },
                params: {
                    reportData: {}
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.donorsfilter')
        .controller('DonorsFilterController', DonorsFilterController);

    /** @ngInject */
    function DonorsFilterController($state,
                                    $stateParams,
                                    $mdDialog,
                                    HbfService,
                                    BibService,
                                    $localStorage,
                                    $httpParamSerializer,
                                    CommunityService,
                                    Auth) {
        var vm = this;
        var currentUser = Auth.getUser();

        if(currentUser.roles[0] !== 'admin' && currentUser.roles[0] !== 'donor_services' && currentUser.roles[0] !== 'donor_managers') {
            $state.go('app.transform.applications');
        }

        vm.filters = [
            'bib',
            'hbf',
            'attendance',
            'program_week',
            'savings_group',
            'prevail'
        ];

        vm.bibFilters = [];
        vm.hbfFilters = [];

        vm.checkBoxItems = [
            {
                label: 'Attendance',
                key: 'attendance'
            },
            {
                label: 'Program Week',
                key: 'program_week'
            },
            {
                label: 'Savings Group Overview',
                key: 'savings_group'
            },
            {
                label: 'Savings Group Journey in Prevail',
                key: 'prevail'
            }
        ];

        //Methods
        vm.goToDonors = goToDonors;
        vm.isSelected = isSelected;
        vm.toggleCheckBox = toggleCheckBox;
        vm.filterPdf = filterPdf;

        activate();

        function activate() {
            getCommunity();
            getHbfs();
            getBibs();
        }

        function getCommunity() {
            CommunityService.getCommunity($stateParams.id, {with: 'application.pastor,application.program,application.base,donor'})
                .then(function (community) {
                    vm.community = community;
                });
        }

        function filterPdf() {
            vm.saving = true;
            var csvUrl;
            var tempcsvobj = {
                'reports[]': vm.filters,
                'bib_ids[]': vm.bibFilters,
                'hbf_ids[]': vm.hbfFilters,
                'token': $localStorage.currentUser.token
            };

            csvUrl = $httpParamSerializer(tempcsvobj);

            $state.go('app.donorspdf', { id: $stateParams.id, reportData: csvUrl });
            vm.saving = false;
            closeDialog();
        }

        /*
        Function used to check if a furniture, appliances, and transporation is in the
        array
         */
        function isSelected(item, mode) {
            if (mode === 'selectHbf') {
                return vm.hbfFilters.indexOf(item) > -1;
            } else if (mode === 'selectBib') {
                return vm.bibFilters.indexOf(item) > -1;
            } else {
                return vm.filters.indexOf(item) > -1;
            }
        }

        /*
        Function used to check if a furniture, appliance, or transportation is already
        selected. If selected, push. Otherwise, splice.
         */
        function toggleCheckBox(item, mode) {
            if (mode === 'selectHbf') {
                var index = vm.hbfFilters.indexOf(item);
                if (index > -1) {
                    vm.hbfFilters.splice(index, 1);
                } else {
                    vm.hbfFilters.push(item);
                }

                if (!vm.hbfFilters.length) {
                    toggleCheckBox('hbf');
                }
            } else if (mode === 'selectBib') {
                var index = vm.bibFilters.indexOf(item);
                if (index > -1) {
                    vm.bibFilters.splice(index, 1);
                } else {
                    vm.bibFilters.push(item);
                }

                if (!vm.bibFilters.length) {
                    toggleCheckBox('bib');
                }
            } else {
                var index = vm.filters.indexOf(item);
                if (index > -1) {
                    vm.filters.splice(index, 1);

                    if (item === 'bib') {
                        vm.bibFilters = [];
                    } else if (item === 'hbf') {
                        vm.hbfFilters = [];
                    }

                } else {
                    vm.filters.push(item);

                    if (item === 'bib') {
                        vm.bibFilters = [];
                        vm.bibs.forEach(function(item) {
                            vm.bibFilters.push(item.id);
                        });
                    } else if (item === 'hbf') {
                        vm.hbfFilters = [];
                        vm.hbfs.forEach(function(item) {
                            vm.hbfFilters.push(item.id);
                        });
                    }
                }
            }
        }

        /*
        Function to get hbfs
         */
        function getHbfs() {
            var params = {
                nopage: true,
                community_id: $stateParams.id,
                sort: 'created_at:asc'
            };

            HbfService.getHbfs(params).then(function (response) {
                vm.hbfs = response;

                response.forEach(function(item) {
                    vm.hbfFilters.push(item.id);
                });
            });
        }

        /*
        Function to get bibs
         */
        function getBibs() {
            var params = {};
            params.nopage = true;
            params.community_id = $stateParams.id;
            params.with = 'community,product';

            BibService.getBibs(params).then(function (response) {
                vm.bibs = response;

                response.forEach(function(item) {
                    vm.bibFilters.push(item.id);
                });
            });
        }

        /*
        Function used to back to donors page
         */
        function goToDonors() {
            $state.go('app.reports_donors');
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.donorspdf', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider
            .state('app.donorspdf', {
                url: '/donors/{id}/pdf',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/donors-pdf/donors-pdf.html',
                        controller: 'DonorsPdfController as vm'
                    }
                },
                params: {
                    reportData: {}
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.donorspdf')
        .controller('DonorsPdfController', DonorsPdfController);

    /** @ngInject */
    function DonorsPdfController($state,
                                 $stateParams,
                                 $sce,
                                 $scope,
                                 api,
                                 Auth) {
        var vm = this;

        var currentUser = Auth.getUser();

        if(currentUser.roles[0] !== 'admin' && currentUser.roles[0] !== 'donor_services' && currentUser.roles[0] !== 'donor_managers') {
            $state.go('app.transform.applications');
        }

        //Methods
        vm.goToDonors = goToDonors;
        vm.trustSrc = trustSrc;

        vm.api = api;

        //store csvUrl to local storage
        vm.csvUrl = $stateParams.reportData;
        if(!localStorage.getItem('csvUrl')) {
            localStorage.setItem('csvUrl', vm.csvUrl);
        } else {
            vm.csvUrl = localStorage.getItem('csvUrl');
        }
        vm.communityId = $stateParams.id;

        $scope.$on('$stateChangeStart', function (event) {
            localStorage.removeItem('csvUrl');
        });

        activate();

        /*
        Function used to get all community information
         */
        function activate() {
        }

        function trustSrc(src) {
            return $sce.trustAsResourceUrl(src);
        }

        /*
        Function used to back to donors page
         */
        function goToDonors() {
            $state.go('app.donorsfilter', {id: $stateParams.id});
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.dashboard2', [])
        .config(config);


    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.dashboard2', {
                url: '/dashboard2',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/dashboard2/dashboard2.html',
                        controller: 'Dashboard2Controller as vm'
                    }
                }
            })
            .state('app.dashboard2.reports', {
                url: '/reports',
                views: {
                    'dashboard2@reports': {
                    }
                }
            })

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/dashboard2');

        // Api
        msApiProvider.register('transform', ['app/data/dashboard2/dashboard2.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('fuse', {
            title: '',
            group: true,
            weight: 1
        });
        // msNavigationServiceProvider.saveItem('fuse.dashboard2', {
        //     title: 'dashboard2',
        //     icon: 'icon-home',
        //     state: 'app.dashboard2.reports',
        //     translate: 'DASHBOARD2.DASHBOARD2_NAV',
        //     weight: 1,
        //     regex: function (state) {
        //         return /^app\.(savings-group-community|dashboard).*/.test(state);
        //     },
        //     lid: "stlink"
        // });
    }
})();

(function () {
  'use strict';

  angular
    .module('app.dashboard2')
    .controller('Dashboard2Controller', Dashboard2Controller)
    .controller('ImgCtrl', function ($scope) {
      $scope.image = [{ src: './grapg.png' }];
    })
    .controller('searchCtrl', function ($scope) {
      var ctrl = this;
      ctrl.search = null;
      ctrl.showPreSearchBar = function () {
        return ctrl.search == null;
      };
      ctrl.initiateSearch = function () {
        ctrl.search = '';
      };
      ctrl.showSearchBar = function () {
        return ctrl.search != null
      };
      ctrl.endSearch = function () {
        return ctrl.search = null;
      };
      ctrl.submit = function () {
        console.error('Search function not yet implemented');
      }

      // to focus on input element after it appears
      $scope.$watch(function () {
        return document.querySelector('#search-bar:not(.ng-hide)');
      }, function () {
        // document.getElementById('search-input').focus();
      });
    })
    .controller('TabController', ['$scope', function ($scope) {
      $scope.tab = 1;

      $scope.setTab = function (newTab) {
        $scope.tab = newTab;
      };

      $scope.isSet = function (tabNum) {
        return $scope.tab === tabNum;
      };
    }]);

  /** @ngInject */
  function Dashboard2Controller($rootScope, $state,
    $scope,
    $mdDialog,
    $document,
    $mdBottomSheet,
    BaseService,
    SavingsGroupService,
    ApplicationService,
    PastorService,
    DistrictService,
    ChurchService,
    Auth) {
    var vm = this;
    var currentUser = Auth.getUser();
    vm.$state = $state;

    //Methods
    vm.getApplicationsData = getApplicationsData;
    // vm.selectSearch = selectSearch;
    // vm.addApplication = addApplication;

    vm.isLoading1 = false;
    vm.isLoading2 = false;
    vm.isLoading3 = false;
    vm.applications = [];
    vm.totalValues = {};
    vm.currentPage = 1;
    var _parent = $scope;
    _parent.$parent.vm.currentTab = 0;
    getApplicationsData();
    getTotals();
    getPastors();
    getTotalDistricts();
    getTotalChurches();


    /*
   Function that get applications total value 
    */
    function getApplicationsData(data) {
      // vm.applications = [];
      var data = data || {};
      var params = {};
      params.limit = 1;
      vm.isLoading1 = true;
      ApplicationService.queryApplications(params).then(function (data) {
        vm.isLoading1 = false;
        vm.applications = data;
      });
    }

    /*
   Function that get the totals 
     */
    function getTotals() {
      var params = {};
      SavingsGroupService.getTotals(params).then(function (response) {
        vm.totalvalues = response;
      })
    }
    /*
      Function that get total paster
        */
    function getPastors() {
      var params = {};
      params.limit = 1;
      PastorService.getPastors(params).then(function (pastors) {
        vm.pastors = pastors;
      });
    }

    /* Function that get total District */

    function getTotalDistricts() {
      vm.districts = [];
      var data = data || {};
      var params = {};
      vm.isLoading1 = true;
      DistrictService.getDistricts(params).then(function (data) {
        vm.isLoading1 = false;
        vm.districts = data;
      });
    }

    /*  Function that populates church total value  */
    function getTotalChurches() {
      var params = {};
      vm.isLoading = true;
      ChurchService.getChurches(params)
        .then(function (churches) {
          vm.isLoading = false;
          vm.churches = churches;
        });
    }



  }
})();


(function () {
    'use strict';

    angular
        .module('app.savings-group-community')
        .controller('CommunitySavingsGroupController', CommunitySavingsGroupController);

    /** @ngInject */
    function CommunitySavingsGroupController($rootScope,
        $stateParams,
        $state,
        $document,
        $mdDialog,
        SavingsGroupService) {
        var vm = this;

        vm.getSavingsGroup = getSavingsGroup;
        vm.joinExistingGroup = joinExistingGroup;

        //Methods
        vm.goToPrevail = goToPrevail;

        // default tab
        $rootScope.currentTab = 0;

        getSavingsGroup();

        // change tab on state change
        $rootScope.$on('$stateChangeSuccess', function (event, toState) {
            if (typeof toState.data !== "undefined") {
                $rootScope.currentTab = toState.data.selectedTab || 0;
            }
        });

        $rootScope.$on('updateSGData', function () {
            getSavingsGroup();
        });

        /*
        Function used to go back to Prevail SG List
         */
        function goToPrevail() {
            $state.go('app.prevail.savings-groups');
        }

        /*
        Function used to get Savings Group data
         */
        function getSavingsGroup() {
            SavingsGroupService.getSavingsGroup($stateParams, { with: 'batch,cluster' })
                .then(function (savings) {
                    vm.savings = savings;
                })
        }

        /*
         Function used to open join existing group modal
        */
        function joinExistingGroup(sg) {
            $mdDialog.show({
                controller: 'JoinExistingGroupController',
                controllerAs: 'vm',
                templateUrl: 'app/main/community/tabs/savings/dialogs' +
                    '/join-existing-group/join-existing-group-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    community: sg,
                    fromPrevail: true,
                    callback: function () {
                        getSavingsGroup();
                    }
                },
                clickOutsideToClose: true
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .service('APIInterceptor', APIInterceptor);

    /** @ngInject */
    function APIInterceptor($q) {

        var service = {
            request: request,
            responseError: responseError
        };

        function request(config) {
            var deferred = $q.defer();
            return config;

        }

        function responseError(response) {
            return response;
        }


        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('capitalize', capitalize)

    /** @ngInject */
    function capitalize() {
        return function (input) {
            if (input.indexOf(' ') !== -1) {
                var inputPieces,
                    i;

                input = input.toLowerCase();
                inputPieces = input.split(' ');

                for (i = 0; i < inputPieces.length; i++) {
                    inputPieces[i] = capitalizeString(inputPieces[i]);
                }

                return inputPieces.toString().replace(/,/g, ' ');
            }
            else {
                input = input.toLowerCase();
                return capitalizeString(input);
            }

            function capitalizeString(inputString) {
                return inputString.substring(0, 1).toUpperCase() + inputString.substring(1);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            if (!value || !moment(value).isValid()) return '';

            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).format('MMM d, YYYY');
            }

        };
    }

})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.common', [])
        .config(config);

    /** @ngInject */
    function config()
    {

    }

})();

(function () {
    'use strict';

    angular.module('app.common')
        .controller('PasswordConfirmationDialogController',
            PasswordConfirmationDialogController);

    /** @ngInject */
    function PasswordConfirmationDialogController(
        $mdDialog,
        api,
        $http,
        deleteCallback,
        callback
    ) {
        var vm = this;

        vm.dialogTitle = 'Confirmation Required';
        vm.participant = {};
        vm.isDeleting = false;
        //Methods
        vm.closeDialog = closeDialog;
        vm.confirmationPassword = confirmationPassword;
        vm.handlePassword = handlePassword;
        activate();

        /*
        Function used to get phone number and kid saver details of the selected participant
         */
        function activate() {
        }

        /*
        Function used to close modal
         */
        function closeDialog() {
            $mdDialog.hide();
        }
        /*
        Function used to handle change password
         */
        function handlePassword() {
            if (vm.errorPassword) vm.errorPassword = null;
        }

        /*
        Function used to password confirmation
         */
        function confirmationPassword(password) {
            var apiUrl = api.baseUrl + 'users/passwordmatch';
            $http.post(apiUrl, password)
                .then(function (response) {
                    deleteCallback();
                    vm.closeDialog();
                })
                .catch(function (error) {
                    vm.errorPassword = error.data.message || error.message;
                });
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('app.common')
    .filter('filterDistrictByBranch', filterDistrictByBranch);

  /** @ngInject */
  function filterDistrictByBranch() {
    return function (districts, branchId) {
      if (!districts) return [];

      if (!branchId) return districts;

      return districts.filter(function (district) {
        return district.branch_id === branchId;
      });
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $q, $state, Auth, $timeout, $mdSidenav, $translate, $mdToast, $mdDialog, $document, msNavigationService, $http, $localStorage) {
        var vm = this;

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon': 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon': 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon': 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            en: {
                'title': 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code': 'en',
                'flag': 'us'
            },
            es: {
                'title': 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code': 'es',
                'flag': 'es'
            },
            tr: {
                'title': 'Turkish',
                'translation': 'TOOLBAR.TURKISH',
                'code': 'tr',
                'flag': 'tr'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;
        vm.changePassword = changePassword;
        vm.checkState = checkState;

        //////////

        var currentUser = Auth.getUser();

        // Navigation

        msNavigationService.saveItem('reports', {
            // title: 'Reports (version: 73231900)',
            title: 'Reports ',
            group: true,
            weight: 3
        });

        msNavigationService.saveItem('reports.donors', {
            title: 'Donors',
            icon: 'icon-gift',
            state: 'app.reports_donors',
            hidden: function () {
                return !currentUser.$roles.has(['admin', 'donor_services', 'donor_managers']);
            },
            regex: function (state) {
                return /^app\.(donors).*/.test(state);
            }
        });

        // msNavigationService.saveItem('reports.base', {
        //     title: 'Base Report',
        //     icon : 'icon-file-image-box',
        //     state: 'app.reports_base.thrive',
        //     regex: function (state) {
        //         return /^app\.(reports_base).*/.test(state);
        //     }
        // });

        // msNavigationService.saveItem('reports.branch', {
        //     title: 'Branch Report',
        //     icon : 'icon-format-size',
        //     state: 'app.reports_branch.thrive',
        //     regex: function (state) {
        //         return /^app\.(reports_branch).*/.test(state);
        //     }
        // });

        init();

        /**
         * Initialize
         */
        function init() {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }

        $rootScope.updateDisplayName = function (userData) {
            vm.displayName = userData.firstname + ' ' + userData.lastname;
        };

        /**
         * Opens change password modal
         */
        function changePassword(e) {
            $mdDialog.show({
                controller: 'ChangePasswordDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/toolbar/dialogs/change-password/change-password-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                locals: {
                    required: false
                },
                clickOutsideToClose: true
            });
        }

        function checkState(state) {
            return $state.includes(state);
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status) {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout() {
            // Do logout here..
            localStorage.clear();
            Auth.logout();
        }

        /**
         * Change Language
         */
        function changeLanguage(lang) {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if (lang.code !== 'en') {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position: 'top right',
                    parent: '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded() {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query) {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for (var x = 0; x < flatNavigation.length; x++) {
                if (flatNavigation[x].uisref) {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if (query) {
                navigation = navigation.filter(function (item) {
                    if (angular.lowercase(item.title).search(angular.lowercase(query)) > -1) {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function () {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item) {
            // If item has a link
            if (item.uisref) {
                // If there are state params,
                // use them...
                if (item.stateParams) {
                    $state.go(item.state, item.stateParams);
                }
                else {
                    $state.go(item.state);
                }
            }
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function () {
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [

            // Core
            'app.core',
            'app.common',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Quick Panel
            'app.quick-panel',

            'app.login',
            'app.dashboard2',
            'app.transform',
            'app.prevail',
            'app.thrive',
            'app.flourish',
            'app.settings',
            'app.thrivesettings',
            'app.prevailsettings',
            'app.changelogs',
            'app.community',
            'app.reports',
            'app.donorspdf',
            'app.donorsfilter',
            'app.savings-group-community',
            'ngStorage',
            'ui.bootstrap',
            'angular-jwt',
            'ngIdle',
            'chart.js',
            'ngFileUpload',
            'nvd3',
            'angular-toArrayFilter'
        ]);
})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope) {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event) {
            if (event.targetScope.$id === $scope.$id) {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('xhrQueue', XhrQueueFactory);

    /** @ngInject */
    function XhrQueueFactory($q, $http)
    {
        var queue = {};

        var execNext = function(uid) {
            var task = queue[uid][0];

            $http(task.data).then(function(data) {
                queue[uid].shift();
                task.promise.resolve(data);

                if (queue[uid].length>0){
                    execNext(uid);
                }
            }, function(err) {
                queue[uid].shift();
                task.promise.reject(err);

                if (queue[uid].length>0){
                    execNext(uid);
                }
            });
        }; 

        return function(uid, config) {
            var promise = $q.defer();

            if (typeof queue[uid] === "undefined") {
                queue[uid] = [];
            }

            queue[uid].push({
                data    : config,
                promise :promise
            });

            if (queue[uid].length===1) {
                execNext(uid);            
            }

            return promise.promise;
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('httpInterceptor', HttpInterceptorFactory);

    /** @ngInject */
    /**
     * HTTP Interceptor
     *
     * Intercepts the HTTP queries. Attach the Authorization headers and catch and broadcast
     * HTTP errors.
     */
    function HttpInterceptorFactory($q, $localStorage, $rootScope)
    {
        return {
            // Attach the JWT token in the Authorization header for each HTTP requests
            request : function(config) {
                if ($localStorage.currentUser) {
                    config.headers['Authorization'] = 'Bearer ' + $localStorage.currentUser.token;
                }

                return config;
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('helpers', HelpersFactory);

    /** @ngInject */
    function HelpersFactory()
    {
        var helpers = {
            catchInvalidRequests: catchInvalidRequests
        };

        return helpers;

        /**
         * Catch invalid requests.
         *
         * @param {object} error
         */
        function catchInvalidRequests(error) {
            if (error.status !== 404 && error.status !== 422 && error.status !== 500) {
                alert("Oops. Unable to connect to the web server. Please check your internet connection and restart the page.");
            }

            throw error;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('enumFields', EnumFieldsFactory);

    /** @ngInject */
    function EnumFieldsFactory($q, FormFieldService)
    {
        return function(fields, force, forceEmpty) {
            var fields     = fields || [];
            var force      = force || false;
            var cached     = true;

            if (typeof forceEmpty === "undefined") {
                forceEmpty = true;
            }

            for (var i in fields) {
                if (!localStorage.getItem(fields[i])) {
                    cached = false;
                    break;
                } else if (forceEmpty) {
                    var val = JSON.parse(localStorage.getItem(fields[i]));

                    if (!val || !val.length) {
                        cached = false;
                        break;
                    }
                }
            }

            if (!force && cached) {
                var promise = new Promise(function(resolve, reject) {
                    var values = {};

                    try {
                        for (var i in fields) {
                            var field     = fields[i];

                            values[field] = JSON.parse(localStorage.getItem(field));
                        }

                        resolve(values);
                    } catch(e) {
                        reject(e);
                    }
                });
            } else {
                var promise = FormFieldService.getFields()
                    .then(function(response) {
                        var values = {};

                        for (var i in fields) {
                            var field     = fields[i];
                            values[field] = [];

                            if (typeof response[field] !== "undefined") {
                                angular.forEach(response[field].definition, function (item) {
                                    values[field].push({
                                        label: item.label,
                                        value: item.value,
                                        order: item.order,
                                        extras: item.extras
                                    });
                                });
                            }

                            localStorage.setItem(field, JSON.stringify(values[field]));
                        }

                        return values;
                    });
            }

            return promise;
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function()
{

	'use strict';

	angular
		.module('app.core')
		.factory('User', UserFactory);

	/* @ngInject */
	function UserFactory(){
		return function(data) {
			return new User(data);
		}
	}

	function User(data) {
		// pass the data to this object
		angular.extend(this, data);

		this.$roles = new UserRoles(data.roles || []);
	}

	function UserRoles(roles) {
        this.roles = roles || [];
    }

    UserRoles.prototype = {
        /**
         * Returns all the user roles.
         *
         * @return  array
         */
        all : function() {
            return this.roles;
        },

        /**
         * Checks if the user has the given role.
         *
         * @param   string   role
         * @return  boolean
         */
        has : function(role) {
            return (this.roles.filter(function(val) {
            	if (role.constructor === Array) {
            		for (var i in role) {
            			if (val == role[i]) {
            				return true;
            			}
            		}
            	} else {
	                return val == role;
            	}
            })).length > 0;
        },

        /**
         * Returns the first user role.
         *
         * @return  string
         */
        first : function() {
            return this.roles.length > 0 ? this.roles[0] : null;
        },

        /**
         * Returns the last user role.
         *
         * @return  string
         */
        last : function() {
            if (isArray(this.roles) && typeof this.roles.slice === "function") {
                return this.roles.length > 0 ? this.roles.slice(-1)[0] : null;
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .service('jwtChecker', JwtChecker);

    /** @ngInject */
    function JwtChecker($interval, $rootScope, Auth, $state) {
        this.rootScope = $rootScope;
        this.interval = $interval;
        this.promise = null;
        this.auth = Auth;
        this.state = $state;
    }


    /**
     * Checks if the JWT token has expired.
     *
     * @return  boolean
     */
    JwtChecker.prototype.hasExpired = function () {
        if(this.state.current.name !== 'app.login')
            return !this.auth.jwtData || this.auth.jwtData.exp < Date.now() / 1000;
        else
            return false;
    }

    /**
     * Expire and broadcast the JWT token.
     *
     * @return  void
     */
    JwtChecker.prototype.expire = function () {
        this.rootScope.$broadcast("auth:session-expired", {status: 2003});
        this.interval.cancel(this.promise);
        this.promise = null;
    }

    /**
     * Run the JWT token checker.
     *
     * @return  void.
     */
    JwtChecker.prototype.run = function () {
        if (!this.hasExpired() && !this.promise) {
            // if ther JWT checker is not running, run the checker
            this.promise = this.interval(check.bind(this), 1000);
        }

        function check() {
            if (this.hasExpired()) {
                // if the token has expired, stop the checker
                this.expire();
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('Auth', AuthService);

	/* @ngInject */
	function AuthService($http, $location, $rootScope, $timeout, $q, api, $state, $localStorage, User) {
		this.q            = $q;
        this.api          = api;
        this.http         = $http;
        this.state        = $state;
        this.timeout      = $timeout;
        this.location     = $location;
        this.rootScope    = $rootScope;
        this.userFactory  = User;
        this.localStorage = $localStorage;
        this.jwtData      = null;
	}

	AuthService.prototype.getCurrentUserProfile = function() {
		return this.http(this.api.user.me());
	}

	AuthService.prototype.initCurrentUser = function() {
		this.getCurrentUserProfile()
			.then(initCurrentUserSuccessHandler.bind(this))
	}

    AuthService.prototype.updateCurrentUserData = function(userData) {
        this.rootScope.userData = userData;
        this.rootScope.updateDisplayName(userData);
    }

    AuthService.prototype.finishLoading = function() {
        this.timeout(function () {
            this.rootScope.loadingProgress = false;
        }.bind(this));
    }

    AuthService.prototype.toLoginPage = function() {
        this.state.go('app.login');
    }

    AuthService.prototype.logout = function() {
        // clear the jwtData
        this.jwtData = null;

        // remove from local storage
        delete this.localStorage.currentUser;

        // remove filers
        localStorage.removeItem('approved');
        localStorage.removeItem('community');

        // remove http headers
        this.http.defaults.headers.common.Authorization = '';

        // go to login page
        if (this.location.path() !== "/login") {
            this.toLoginPage();
        }
    }

    AuthService.prototype.getUser = function() {
        this.parseJwtToken();

        return this.jwtData.user || null;
    }

    AuthService.prototype.parseJwtToken = function() {
        var token;

        if (typeof this.localStorage.currentUser !== "undefined" &&
            typeof this.localStorage.currentUser.token !== "undefined") {
            token = this.localStorage.currentUser.token || null;
        }

        if (token) {
            try {
                if (this.jwtData) {
                    return this.jwtData.user;
                }

                // parse the JWT token
                var base64Url = token.split('.')[1];
                var base64    = base64Url.replace('-', '+').replace('_', '/');
                var data      = JSON.parse(window.atob(base64));

                // logout if the base_id is not defined
                if (typeof data.user.base_id == "undefined" || !data.user.username) {
                    this.logout();
                }

                this.jwtData       = data;
                this.jwtData.user = this.userFactory(data.user);

                return this.jwtData.user;
            } catch (e) {
                this.logout();
            }
        } else {
            this.logout();
        }
    }

    function initCurrentUserSuccessHandler(response) {
        var userData = response.data;

        this.rootScope.currentUser = this.getUser();

        if (this.location.path() != '/login') {
            this.updateCurrentUserData(userData);
            this.finishLoading();

            // if the user should change their password
            if (userData.should_change_password) {
                this.rootScope.$broadcast("auth:change-password");
            }
        } else {
            this.rootScope.$broadcast("auth:dashboard");
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, $location, Auth, jwtChecker, $localStorage, $http, api, $mdDialog, $document) {
        // Activate loading indicator

        // var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function () {
        //     $rootScope.loadingProgress = true;
        // });
        // De-activate loading indicator
        //
        // });
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function () {
            Auth.initCurrentUser();
            jwtChecker.run();
        });

        $rootScope.$on("auth:change-password", function () {
            $mdDialog.show({
                controller: 'ChangePasswordDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/toolbar/dialogs/change-password/change-password-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    required: true
                },
                clickOutsideToClose: false
            });
        });

        $rootScope.$on("auth:dashboard", function () {
            $state.go('app.transform.applications');
        });

        $rootScope.$on("auth:session-expired", expiredSession);
        $rootScope.$on("auth:invalid", function () {
            Auth.logout();
        });
        function expiredSession() {
            $mdDialog.show({
                controller: 'SessionExpiredController',
                controllerAs: 'vm',
                templateUrl: 'app/toolbar/dialogs/session-expired/session-expired-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    required: true
                },
                clickOutsideToClose: true
            });

            Auth.logout();
        }

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function () {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {
        $locationProvider.html5Mode(false);

        $urlRouterProvider.otherwise('/login');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies) {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = 'verticalNavigationFullwidthToolbar2';

        var layouts = {
            verticalNavigation: {
                main: 'app/core/layouts/vertical-navigation.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar: {
                main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2: {
                main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main: 'app/core/layouts/horizontal-navigation.html',
                toolbar: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly: {
                main: 'app/core/layouts/content-only.html',
                toolbar: '',
                navigation: ''
            },
            contentWithToolbar: {
                main: 'app/core/layouts/content-with-toolbar.html',
                toolbar: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views: {
                    'main@': {
                        templateUrl: layouts[layoutStyle].main,
                        controller: 'MainController as vm'
                    },
                    'toolbar@app': {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller: 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller: 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller: 'QuickPanelController as vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .filter('capitalize', capitalize)
        .filter('formatDate', formatDate)
        .filter('range', range)
        .filter('ifEmpty', ifEmpty)
        .filter('dateToISO', dateToISO);

    function dateToISO() {
        return function (input) {
            try {
                input = new Date(input).toISOString();
            } catch (e) {
            }

            return input;
        }
    }

    function range() {
        return function (input, total) {
            total = parseInt(total);

            for (var i = 0; i < total; i++) {
                input.push(i);
            }

            return input;
        }
    }

    function capitalize() {
        return function (input) {
            return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
        }
    }

    function formatDate() {
        return function (input) {
            return input.substring(0, input.search(' '));
        }
    }

    function ifEmpty() {
        return function(input, defaultValue) {
            if (angular.isUndefined(input) || input === null || input === '') {
                return defaultValue;
            }

            return input;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming, $scope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        msNavigationService.saveItem('fuse.dashboard2', {
            hidden: function () {
                return localStorage.getItem('userRole') === 'health_mentor';
            }
        });

        msNavigationService.saveItem('fuse.prevail', {
            hidden: function () {
                return localStorage.getItem('userRole') === 'health_mentor';
            }
        });

        msNavigationService.saveItem('fuse.thrive', {
            hidden: function () {
                return localStorage.getItem('userRole') === 'health_mentor';
            }
        });

        msNavigationService.saveItem('fuse.flourish', {
            hidden: function () {
                return localStorage.getItem('userRole') === 'health_mentor';
            }
        });

        msNavigationService.saveItem('reports', {
            hidden: function () {
                return localStorage.getItem('userRole') === 'health_mentor';
            }
        });

        msNavigationService.saveItem('reports.monthly', {
            hidden: function () {
                return localStorage.getItem('userRole') === 'health_mentor';
            }
        });

        // $scope.$on('IdleTimeout', function() {
        //     // the user has timed out (meaning idleDuration + timeout has passed without any activity)
        //     // this is where you'd log them
        //     $state.go('app.login');
        // });

        //////////
    }
})();

(function () {
    'use strict';

    angular
        .module('fuse');
})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($translateProvider,
                    $httpProvider,
                    $mdDateLocaleProvider) {
        $httpProvider.interceptors.push('httpInterceptor');

        // Put your common app configurations here
        // $httpProvider.interceptors.push( function () {
        //     return {
        //         response: function( response ) {
        //             return response;
        //         }
        //     }
        // });

        // IdleProvider.idle(5);
        // IdleProvider.timeout(5);

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        $mdDateLocaleProvider.formatDate = function (date) {
            return date ? moment(date).format('YYYY-MM-DD') : '';
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($rootScope) {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        // api.baseUrl = 'http://13.232.163.130:8000' + '/';  // For Arbutus Server
        // api.baseUrl = 'https://staging-data-api.caremin.com' + '/'; // For client staging server`
         api.baseUrl = 'https://rc-data-api.caremin.com' + '/'; // For RC Server
        // api.baseUrl = 'https://data-api.caremin.com' + '/'; // For Production Server

        api.user = {
            login: function (username, password) {
                var promise = {
                    method: 'POST',
                    url: api.baseUrl + 'users/login?',
                    data: {
                        username: username,
                        password: password
                    }
                };

                return promise;
            },
            me: function () {
                var promise = {
                    method: 'GET',
                    url: api.baseUrl + 'users/me'
                };

                return promise;
            },
            refreshToken: function () {
                var promise = {
                    method: 'POST',
                    url: api.baseUrl + 'users/me/refresh-token'
                };

                return promise;
            }
        };

        // api.sample = $resource(api.baseUrl + 'sample/sample.json');

        return api;
    }

})();

(function () {
    'use strict';

    angular
        .module('app.reports', [
            'app.reports.donors-report',
            'app.reports.base-report',
            'app.reports.monthly-report',
            'app.reports.branch-report'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider) {
        // Navigation
        msNavigationServiceProvider.saveItem('reports', {
            title: 'Reports',
            group: true,
            weight: 3
        });

        msNavigationServiceProvider.saveItem('reports.monthly', {
            title: 'Monthly Report',
            icon: 'icon-file-image-box',
            state: 'app.reports_monthly_report',
            regex: function (state) {
                return /^app\.(reports_monthly_report).*/.test(state);
            }
        });

        // msNavigationServiceProvider.saveItem('reports.base', {
        //     title: 'Base Report',
        //     icon : 'icon-file-image-box',
        //     state: 'app.reports_base.transform',
        //     regex: function (state) {
        //         return /^app\.(reports_base).*/.test(state);
        //     }
        // });
        //
        // msNavigationServiceProvider.saveItem('reports.branch', {
        //     title: 'Branch Report',
        //     icon : 'icon-format-size',
        //     state: 'app.reports_branch.transform',
        //     regex: function (state) {
        //         return /^app\.(reports_branch).*/.test(state);
        //     }
        // });
    }
})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"QUICKPANEL.CHAT\">CHAT</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\">version: 1.0.0.1\n</md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/common/password-confirmation-dialog/password-confirmation-dialog.html","<md-dialog class=\"password-confirmation-dialog transform-dialog\" aria-label=\"New Message\"><form \nname=\"PasswordConfirmationForm\" class=\"md-inline-form\" ng-submit=\"vm.confirmationPassword(vm.participant)\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout-gt-xs=\"row\" style=\"margin-bottom: 1rem; font-weight: bold\"><span>Password Confirmation Required for Deletion\n</span></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block mb-0\" flex=\"70\"><input name=\"password\" \ntype=\"password\" id=\"password\" ng-model=\"vm.participant.password\" placeholder=\"Password\" required md-autofocus \nstyle=\"font-size: 2rem; margin-bottom: 10px\" ng-change=\"vm.handlePassword()\"><div \nng-messages=\"PasswordConfirmationForm.password.$error\" \nng-show=\"vm.errorPhone || PasswordConfirmationForm.password.$touched\r\n                         || PasswordConfirmationForm.$submitted\" \nrole=\"alert\"><div ng-message=\"required\">Required.</div><div ng-bind=\"vm.errorPassword\" \nstyle=\"opacity: 1;\r\n                        margin-top: 3px;\r\n                        font-weight: bold;\r\n                        font-size: 13px\">\n</div></div></md-input-container></div></md-dialog-content><md-dialog-actions><md-button md-no-ink \nclass=\"md-primary pull-left\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button \ntype=\"submit\" class=\"md-accent md-raised pull-right\" ng-disabled=\"PasswordConfirmationForm.$invalid || vm.isDeleting\">\n<md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.isDeleting\" md-diameter=\"10px\"></md-progress-circular>Delete\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/community/community.html","<md-toolbar class=\"transform-bar\" id=\"content-heading-bar\"><div id=\"batch-heading\" class=\"content-heading-bar-inner\">\n<div class=\"row\"><div class=\"col-md-1 col-sm-1 col-xs-1\" ng-click=\"vm.goToCommunity()\"><i id=\"btn-icon-back\" \nclass=\"icon icon-arrow-left\"></i></div><div class=\"col-md-7 col-sm-7 col-xs-7\"><div \nclass=\"col-md-6 col-sm-6 col-xs-6 col-lg-3\"><hgroup class=\"ht\"><h5>Pastor</h5><h2>\n{{vm.community.application.pastor.firstname}} {{vm.community.application.pastor.lastname}}</h2></hgroup></div><div \nclass=\"col-md-6 col-sm-6 col-xs-6 col-lg-3\"><hgroup class=\"ht\"><h5>Location</h5><h2>\n{{vm.community.application.base ? vm.community.application.base.name : \'\'}}</h2></hgroup></div><div \nclass=\"col-md-6 col-sm-6 col-xs-6 col-lg-3\"><hgroup class=\"ht\"><h5>Municipality</h5><h2>\n{{vm.community.application.community_city}}</h2></hgroup></div><div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-3\"><hgroup\n class=\"ht\"><h5>Barangay</h5><h2>{{vm.community.application.community_barangay}}</h2></hgroup></div></div><div \nclass=\"col-md-4 col-sm-4 col-xs-4 pull-right\"><div class=\"row\"><div class=\"col-md-4 col-sm-4 col-xs-4\"><hgroup \nclass=\"ht\"><h5>ID</h5><h2>{{vm.community.community_no}}</h2></hgroup></div><div class=\"col-md-4 col-sm-4 col-xs-4\">\n<hgroup class=\"ht\"><h5>Batch</h5><h2>{{vm.community.batch.short_name}}</h2></hgroup></div><div \nclass=\"col-md-4 col-sm-4 col-xs-4\"><hgroup class=\"ht\"><h5 class=\"space-margin-5\">&nbsp;</h5><h2 \nng-click=\"vm.showCommunityDetails()\"><i class=\"icon icon-information-outline\"></i> <span class=\"details\">Details</span>\n</h2></hgroup></div></div></div></div></div></md-toolbar><div id=\"community-content-wrapper\" \nclass=\"transform-white-holder content-white-holder\"><div class=\"transform-white\"><md-tabs id=\"community-details-tabs\" \nmd-selected=\"$root.currentTab\" md-dynamic-height md-border-bottom><md-tab id=\"community-tab\" \nui-sref=\"app.community.attendance\"><md-tab-label>People &amp; Attendance</md-tab-label><md-tab-body \nclass=\"tab-content\"><div ui-view=\"community@attendance\"></div></md-tab-body></md-tab><md-tab id=\"weekly-tab\" \nui-sref=\"app.community.weekly\"><md-tab-label>Misc. {{$root.unselect}}</md-tab-label><md-tab-body class=\"tab-content\">\n<div class=\"md-content\"><div ui-view=\"community@weekly\"></div></div></md-tab-body></md-tab><md-tab id=\"bib-tab\" \nui-sref=\"app.community.bib\"><md-tab-label>Livelihood</md-tab-label><md-tab-body class=\"tab-content bib-md-tab\"><div \nclass=\"md-content\"><div ui-view=\"community@bib\"></div></div></md-tab-body></md-tab><md-tab id=\"hbf-tab\" \nui-sref=\"app.community.hbf\"><md-tab-label>HBF</md-tab-label><md-tab-body class=\"tab-content\"><div class=\"md-content\">\n<div ui-view=\"community@hbf\"></div></div></md-tab-body></md-tab><md-tab id=\"savingsgroup-tab\" \nui-sref=\"app.community.savings\"><md-tab-label>Savings</md-tab-label><md-tab-body class=\"tab-content\"><div \nclass=\"md-content\"><div ui-view=\"community@savings\"></div></div></md-tab-body></md-tab><md-tab id=\"business-loans-tab\" \nui-sref=\"app.community.business-loans\"><md-tab-label>Business Loans</md-tab-label><md-tab-body class=\"tab-content\"><div\n class=\"md-content\"><div ui-view=\"community@business-loans\"></div></div></md-tab-body></md-tab></md-tabs><div \nui-view=\"bib@participants\"></div><div ui-view=\"hbf@details\"></div><div ui-view=\"gib@participants\"></div></div></div>");
$templateCache.put("app/main/community-savings-group/community-savings-group.html","<style>\n#community-content-wrapper .join-existing-sg {\r\n        position: absolute;\r\n        top: 15px;\r\n        z-index: 1;\r\n        right: 20px;\r\n        cursor: pointer;\r\n        font-weight: bold;\r\n        color: #386BBA;\r\n    }\r\n\r\n    #community-content-wrapper .join-existing-sg:hover {\r\n        color: #039be5;\r\n    }\n</style><md-toolbar class=\"transform-bar\" id=\"content-heading-bar\"><div id=\"batch-heading\" \nclass=\"content-heading-bar-inner\"><div class=\"row\"><div class=\"col-md-1 col-sm-1 col-xs-1\" ng-click=\"vm.goToPrevail()\">\n<i id=\"btn-icon-back\" class=\"icon icon-arrow-left\"></i></div><div class=\"col-md-9 col-sm-9 col-xs-9\"><div \nclass=\"col-md-6 col-sm-6 col-xs-6 col-lg-4\"><hgroup class=\"ht\"><h5>Savings Group Name</h5><h2>{{vm.savings.name}}</h2>\n</hgroup></div><div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-4\"><hgroup class=\"ht\"><h5>Status</h5><h2>\n{{vm.savings.status}}</h2></hgroup></div><div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-4\"><hgroup class=\"ht\"><h5>\nCluster</h5><h2>{{vm.savings.cluster.name}}</h2></hgroup></div></div></div></div></md-toolbar><div \nid=\"community-content-wrapper\" class=\"transform-white-holder content-white-holder\"><div class=\"transform-white\"><span \nclass=\"join-existing-sg\" ng-click=\"vm.joinExistingGroup(vm.savings)\">Join Existing Savings Group</span><md-tabs \nid=\"community-details-tabs\" md-selected=\"currentTab\" md-dynamic-height md-border-bottom><md-tab \nid=\"savings-group-data-tab\" ui-sref=\"app.savings-group-community.savings-group-data\"><md-tab-label>Savings Group Data\n</md-tab-label><md-tab-body class=\"tab-content\"><div class=\"md-content\"><div \nui-view=\"savings-group-community@savings-group-data\"></div></div></md-tab-body></md-tab><md-tab id=\"members-tab\" \nng-disabled=\"currentUser.$roles.has([\'health_coordinator\', \'health_trainer\', \'livelihood_trainer\', \'health_mentor\'])\" \nui-sref=\"app.savings-group-community.members\"><md-tab-label>Members</md-tab-label><md-tab-body class=\"tab-content\"><div\n class=\"md-content\"><div ui-view=\"savings-group-community@members\"></div></div></md-tab-body></md-tab></md-tabs></div>\n</div>");
$templateCache.put("app/main/dashboard2/dashboard2.html","<md-toolbar class=\"transform-bar\"></md-toolbar><div id=\"transform-content-wrapper\" \nclass=\"transform-white-holder content-white-holder\" style=\"height: auto\"><div class=\"transform-white\"><div \nlayout=\"row\"><div ng-controller=\"searchCtrl as ctrl\" flex=\"100\"><md-toolbar><div id=\"search-bar\" \nng-show=\"ctrl.showPreSearchBar()\" class=\"md-toolbar-tools\"><h2>Dashboard</h2><span flex></span><md-button \nng-click=\"ctrl.initiateSearch()\"><md-icon></md-icon><span>Search</span></md-button></div><div \nng-show=\"ctrl.showSearchBar()\" class=\"md-toolbar-tools search-bar\" \nstyle=\"display: flex;justify-content: space-between\"><md-button class=\"md-icon-button\" ng-click=\"ctrl.submit()\">\n<md-icon class=\"icon-close\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"ctrl.endSearch()\">\n<md-icon class=\"icon-close\"></md-icon></md-button></div></md-toolbar></div></div><div layout=\"row\" \nlayout-align=\"center\"><div flex \nstyle=\"min-height: 150px;padding: 15px; background: white; margin:15px; border-radius:10px;text-align: center\" \nui-sref=\"app.transform.applications\"><h2 style=\"text-align:center\">Transform</h2><div layout=\"column\"><span \nstyle=\"font-size: 40px;color:blue\">{{vm.applications.total}}</span><label for=\"\" style=\"color: blue;font-weight:200\">\nTotal Applications</label></div></div><div flex \nstyle=\"min-height: 150px;padding: 15px; background: white; margin:15px;text-align:center; border-radius:10px\" \nui-sref=\"app.prevail.savings-groups\"><h2 style=\"text-align:center\">Prevail</h2><div layout=\"row\" layout-align=\"center\">\n<div flex><div layout=\"column\"><label for=\"\" style=\"color: goldenrod;font-weight:200;font-size: 20px\">Gold</label><span\n style=\"color:goldenrod; font-size: 20px\">{{vm.totalvalues.total_gold}}</span></div></div><div flex><div \nlayout=\"column\"><label for=\"\" style=\"color: silver;font-weight:200;font-size: 20px\">Silver</label><span \nstyle=\"color:silver; font-size: 20px\">{{vm.totalvalues.total_silver}}</span></div></div><div flex><div layout=\"column\">\n<label for=\"\" style=\"color: red;font-weight:200;font-size: 20px\">Inactive</label><span \nstyle=\"color:red; font-size: 20px\">{{vm.totalvalues.total_inactive}}</span></div></div></div></div><div flex \nstyle=\"min-height: 150px;padding: 15px; background: white; margin:15px;text-align:center; border-radius:10px\"><h2 \nstyle=\"text-align:center\">Thrive</h2><div layout=\"row\" layout-align=\"center\"><div flex><div layout=\"column\" \nui-sref=\"app.thrive.districts\"><label for=\"\" style=\"color:blue;font-weight:200;font-size: 18px\">Total Districts</label>\n<span style=\"color:blue;font-size: 20px\">{{vm.districts.total}}</span></div></div><div flex><div layout=\"column\" \nui-sref=\"app.thrive.pastors\"><label for=\"\" style=\"color:#36cc33;font-weight:200;font-size: 18px\">Total Pastors</label>\n<span style=\"color:#36cc33; font-size: 20px\">{{vm.pastors.total}}</span></div></div><div flex><div layout=\"column\" \nui-sref=\"app.thrive.churches\"><label for=\"\" style=\"color:lightslategray;font-weight:200;font-size: 18px\">Total Churches\n</label><span style=\"color:lightslategray; font-size: 20px\">{{vm.churches.total}}</span></div></div></div></div><div \nflex style=\"min-height: 150px;padding: 15px; background: white; margin:15px;text-align:center; border-radius:10px\"><h2>\nTotal Reports</h2><div layout=\"column\"><span style=\"color:lightslategray; font-size: 50px\">123</span><label \nstyle=\"color:lightgray\"></label></div></div></div><div layout=\"row\" layout-wrap><div \nstyle=\"background: white; height:400px;margin-left: 15px; padding: 15px;border-radius: 10px;width: 73%\"><h2 \nstyle=\"text-align:center\">Monthly Report</h2><md-datepicker ng-model=\"ctrl.myDate\" md-placeholder=\"Enter date\">\n</md-datepicker></div><div \nstyle=\"background: white; height:400px;margin-left: 30px;margin-right: 15px; padding: 15px;border-radius: 10px;width: 23%\">\n<h2 style=\"text-align: center\">Users Activity</h2><md-content flex layout-padding><ul><li>\nLorem ipsum dolor sit amet, ne quod novum mei.</li><li>\nLorem ipsum dolor sit amet, ne quod novum mei. Sea omnium invenire mediocrem at.</li><li>\nLorem ipsum dolor sit amet, ne quod novum mei.</li><li>Lorem ipsum dolor sit amet, ne quod novum mei.</li><li>\nLorem ipsum dolor sit amet, ne quod novum mei. Sea omnium invenire mediocrem at.</li></ul></md-content></div></div><div\n layout=\"column\" style=\"height: 350px;background:white;padding: 15px;margin: 15px;border-radius: 10px\" \nclass=\"container-fluid\"><h2 style=\"margin-bottom: 30px\">Users List</h2><div flex><div class=\"row\" \nng-controller=\"TabController\"><div class=\"col-md-2\"><ul class=\"nav nav-pills nav-stacked\"><li \nng-class=\"{ active: isSet(1) }\"><a href ng-click=\"setTab(1)\">Monthly Reports</a></li><li \nng-class=\"{ active: isSet(2) }\"><a href ng-click=\"setTab(2)\">Donors</a></li></ul></div><div class=\"col-md-8\"><div \nclass=\"jumbotron\"><div ng-show=\"isSet(1)\"><h2>Base</h2><p>217</p></div><div ng-show=\"isSet(2)\"><h2>Donors</h2><p>541\n</p></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/donors-filter/donors-filter.html","<div class=\"donors-filter-page-content\"><md-toolbar class=\"transform-bar\" id=\"content-heading-bar\"><div class=\"row\">\n<div class=\"col-md-1 mt-10 col-sm-1 col-xs-1\" ng-click=\"vm.goToDonors()\"><i id=\"btn-icon-back\" \nclass=\"icon icon-arrow-left\"></i></div><div class=\"col-md-11 col-sm-11 col-xs-11\"><div \nclass=\"col-md-6 col-sm-6 col-xs-6 col-lg-3\"><hgroup class=\"ht\"><h5>Community ID</h5><h2>{{vm.community.community_no}}\n</h2></hgroup></div><div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-3\"><hgroup class=\"ht\"><h5>Donor</h5><h2>\n{{vm.community.donor ? vm.community.donor.name : \'&nbsp;\'}}</h2></hgroup></div><div \nclass=\"col-md-6 col-sm-6 col-xs-6 col-lg-3\"><hgroup class=\"ht\"><h5>Location</h5><h2>\n{{vm.community.application.base ? vm.community.application.base.name : \'\'}}</h2></hgroup></div><div \nclass=\"col-md-6 col-sm-6 col-xs-6 col-lg-3\"><hgroup class=\"ht\"><h5>Pastor</h5><h2>\n{{vm.community.application.pastor.firstname}}</h2></hgroup></div></div></div></md-toolbar><div \nid=\"transform-content-wrapper\" class=\"transform-white-holder donors-filter-content-wrapper content-white-holder\"><div \nclass=\"transform-white\"><div class=\"filter-container\"><div layout=\"row\"><div flex=\"33\"><fieldset class=\"standard\"><div \nlayout=\"column\" layout-wrap flex><div flex=\"33\" ng-repeat=\"item in vm.checkBoxItems\"><md-checkbox \nng-checked=\"vm.isSelected(item.key)\" ng-click=\"vm.toggleCheckBox(item.key)\">{{ item.label }}</md-checkbox></div></div>\n</fieldset></div><div flex=\"33\"><fieldset class=\"standard\"><div layout=\"column\" layout-wrap flex><div flex=\"33\">\n<md-checkbox ng-disabled=\"!vm.bibs.length\" ng-checked=\"vm.isSelected(\'bib\')\" ng-click=\"vm.toggleCheckBox(\'bib\')\">\nLivelihood Training</md-checkbox><div flex=\"100\" ng-show=\"vm.isSelected(\'bib\')\" class=\"pl-20\" flex-gt-sm=\"100\" \nlayout=\"column\"><div><fieldset class=\"standard\"><div layout=\"row\" layout-wrap flex><div flex=\"100\" \nng-repeat=\"bib in vm.bibs\"><md-checkbox ng-checked=\"vm.isSelected(bib.id, \'selectBib\')\" \nng-click=\"vm.toggleCheckBox(bib.id, \'selectBib\')\">Week {{ bib.week }}, {{bib.product.name}}</md-checkbox></div></div>\n</fieldset></div></div></div></div></fieldset></div><div flex=\"33\"><fieldset class=\"standard\"><div layout=\"column\" \nlayout-wrap flex><div flex=\"33\"><md-checkbox ng-disabled=\"!vm.hbfs.length\" ng-checked=\"vm.isSelected(\'hbf\')\" \nng-click=\"vm.toggleCheckBox(\'hbf\')\">Home Based Feeding Program</md-checkbox><div flex=\"100\" \nng-show=\"vm.isSelected(\'hbf\')\" class=\"pl-20\" flex-gt-sm=\"100\" layout=\"column\"><div><fieldset class=\"standard\"><div \nlayout=\"row\" layout-wrap flex><div flex=\"100\" ng-repeat=\"hbf in vm.hbfs\"><md-checkbox \nng-checked=\"vm.isSelected(hbf.id, \'selectHbf\')\" ng-click=\"vm.toggleCheckBox(hbf.id, \'selectHbf\')\">\n{{ hbf.child_firstname }}</md-checkbox></div></div></fieldset></div></div></div></div></fieldset></div></div><md-button\n class=\"md-accent md-raised\" ng-click=\"vm.filterPdf()\">Show PDF</md-button></div></div></div></div>");
$templateCache.put("app/main/flourish/flourish.html","<md-toolbar class=\"transform-bar\"></md-toolbar><div id=\"transform-content-wrapper\" \nclass=\"transform-white-holder content-white-holder\"><div class=\"transform-white\"><md-tabs md-selected=\"vm.currentTab\" \nmd-dynamic-height md-border-bottom><md-tab id=\"datacard-tab\" label=\"Data Card\" \nng-disabled=\"currentUser.$roles.has([\'health_coordinator\',\r\n                    \'livelihood_coordinator\', \'health_trainer\', \'livelihood_trainer\', \'donor_managers\', \'donor_services\', \'health_mentor\'])\" \nui-sref=\"app.flourish.datacard\"><md-content class=\"tab-content content\"><div ui-view=\"flourish@datacard\"></div>\n</md-content></md-tab><md-tab id=\"districts-tab\" label=\"Cluster\" ui-sref=\"app.flourish.cluster\"><md-content \nclass=\"tab-content content\" ms-scroll><div ui-view=\"flourish@cluster\"></div></md-content></md-tab><md-tab \nid=\"pastors-lists-tab\" label=\"CHC\" ui-sref=\"app.flourish.chc\"><md-content class=\"tab-content content\" ms-scroll><div \nui-view=\"flourish@chc\"></div></md-content></md-tab><md-tab id=\"churches-lists-tab\" label=\"Ongoing Cases / MCP\" \nui-sref=\"app.flourish.mcp\"><md-content class=\"tab-content content\" ms-scroll><div ui-view=\"flourish@mcp\"></div>\n</md-content></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/donors-pdf/donors-pdf.html","<div class=\"donors-pdf-page-content\"><md-toolbar class=\"transform-bar donor-search-bar\" id=\"content-heading-bar\"><div \nclass=\"row\"><div class=\"col-md-1 col-sm-1 col-xs-1\" ng-click=\"vm.goToDonors()\"><i id=\"btn-icon-back\" \nclass=\"icon icon-arrow-left\"></i></div><a \nng-href=\"{{vm.api.baseUrl + \'communities/\' + vm.communityId + \'/summary?\' + vm.csvUrl}}\" class=\"pull-right xls\" \ntarget=\"_blank\"><i class=\"icon icon-download\"></i> <span>Download PDF</span></a></div></md-toolbar><div \nid=\"transform-content-wrapper\" class=\"widget-group content-white-holder\"><div class=\"iframe-wrapper\"><iframe \ntype=\"application/pdf\" width=\"100%\" height=\"100%\" \nng-src=\"{{vm.trustSrc(vm.api.baseUrl + \'communities/\' + vm.communityId + \'/summary?\' + vm.csvUrl)}}\"></iframe></div>\n</div></div>");
$templateCache.put("app/main/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>T\n</span></div><div class=\"title\" translate=\"LOGIN.TITLE\">Log in to your account</div><form name=\"loginForm\" novalidate>\n<md-input-container class=\"md-block\" md-no-float><input name=\"email\" ng-model=\"vm.form.email\" translate \ntranslate-attr-placeholder=\"LOGIN.EMAIL_USERNAME\" required><div ng-messages=\"loginForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span translate=\"LOGIN.ERRORS.EMAIL_USERNAME_REQUIRED\">\nEmail field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input \ntype=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"LOGIN.PASSWORD\" required><div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\" ng-click=\"vm.login(vm.form.email, vm.form.password)\" \ntranslate=\"LOGIN.LOG_IN\" translate-attr-aria-label=\"LOGIN.LOG_IN\">LOG IN</md-button><div class=\"error-message\">\n{{vm.errorLogin}}</div></form></div></div></div>");
$templateCache.put("app/main/prevail/prevail.html","<md-toolbar class=\"transform-bar\"></md-toolbar><div id=\"transform-content-wrapper\" \nclass=\"transform-white-holder content-white-holder\"><div class=\"transform-white\"><md-tabs md-selected=\"vm.currentTab\" \nmd-dynamic-height md-border-bottom><md-tab id=\"savings-groups-tab\" label=\"Savings Groups\" \nui-sref=\"app.prevail.savings-groups\"><md-content class=\"tab-content content\"><div ui-view=\"prevail@savings-groups\">\n</div></md-content></md-tab><md-tab id=\"prevail-reports-tab\" label=\"Raw Data Reports\" ui-sref=\"app.prevail.reports\">\n<md-content class=\"tab-content report-tab-content content\"><div ui-view=\"prevail@reports\"></div></md-content></md-tab>\n</md-tabs></div></div>");
$templateCache.put("app/main/thrive/thrive.html","<md-toolbar class=\"transform-bar\"></md-toolbar><div id=\"transform-content-wrapper\" \nclass=\"transform-white-holder content-white-holder\"><div class=\"transform-white\"><md-tabs md-selected=\"vm.currentTab\" \nmd-dynamic-height md-border-bottom><md-tab id=\"datacard-tab\" label=\"Data Card\" \nng-disabled=\"currentUser.$roles.has([\'health_coordinator\',\r\n                    \'livelihood_coordinator\', \'health_trainer\', \'livelihood_trainer\', \'donor_managers\', \'donor_services\', \'health_mentor\']) || (currentUser.$roles.has([\'pastor_coordinator\']) && !userData.permission)\" \nui-sref=\"app.thrive.datacard\"><md-content class=\"tab-content content\"><div ui-view=\"thrive@datacard\"></div>\n</md-content></md-tab><md-tab id=\"districts-tab\" label=\"Districts\" ui-sref=\"app.thrive.districts\"><md-content \nclass=\"tab-content content\" ms-scroll><div ui-view=\"thrive@districts\"></div></md-content></md-tab><md-tab \nid=\"pastors-lists-tab\" label=\"Pastors\" ui-sref=\"app.thrive.pastors\"><md-content class=\"tab-content content\" ms-scroll>\n<div ui-view=\"thrive@pastors\"></div></md-content></md-tab><md-tab id=\"churches-lists-tab\" label=\"Churches\" \nui-sref=\"app.thrive.churches\"><md-content class=\"tab-content content\" ms-scroll><div ui-view=\"thrive@churches\"></div>\n</md-content></md-tab><md-tab label=\"Raw Data Reports\" id=\"reports-tab\" ui-sref=\"app.thrive.reports\"><md-content \nclass=\"tab-content report-tab-content content\" ms-scroll><div ui-view=\"thrive@reports\"></div></md-content></md-tab>\n</md-tabs></div></div>");
$templateCache.put("app/main/transform/transform.html","<md-toolbar class=\"transform-bar\"></md-toolbar><div id=\"transform-content-wrapper\" \nclass=\"transform-white-holder content-white-holder\"><div class=\"transform-white\"><md-tabs md-selected=\"vm.currentTab\" \nmd-dynamic-height md-border-bottom><md-tab id=\"applications-tab\" label=\"Applications\" \nui-sref=\"app.transform.applications\" \nng-disabled=\"currentUser.$roles.has([\'health_coordinator\',\r\n                    \'livelihood_coordinator\', \'health_trainer\',\r\n                    \'livelihood_trainer\'])\">\n<md-content class=\"tab-content content\"><div ui-view=\"transform@applications\"></div></md-content></md-tab><md-tab \nid=\"approval-lists-tab\" label=\"Approval List\" ui-sref=\"app.transform.approval-lists\" \nng-disabled=\"currentUser.$roles.has([\'health_coordinator\',\r\n                    \'livelihood_coordinator\', \'health_trainer\',\r\n                    \'livelihood_trainer\'])\">\n<md-content class=\"tab-content content\"><div ui-view=\"transform@approval-list\"></div></md-content></md-tab><md-tab \nid=\"community-lists-tab\" label=\"Community List\" ui-sref=\"app.transform.community-lists\"><md-content \nclass=\"tab-content content\"><div ui-view=\"transform@community-lists\"></div></md-content></md-tab><md-tab \nlabel=\"Raw Data Reports\" id=\"reports-tab\" ui-sref=\"app.transform.reports\"><md-content \nclass=\"tab-content report-tab-content content\"><div ui-view=\"transform@reports\"></div></md-content></md-tab></md-tabs>\n<div ui-view=\"transform@application-participants\"></div><div ui-view=\"transform@deleted-applications\"></div></div>\n</div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/pagination/pagination.html","<ul ng-show=\"items.total > 10\" ng-change=\"callback()\" uib-pagination class=\"uib-pagination\" total-items=\"items.total\" \nng-model=\"items.current_page\" max-size=\"5\" class=\"pagination-sm\" boundary-link-numbers=\"true\" rotate=\"false\"></ul>");
$templateCache.put("app/common/templates/delete-dialog/delete-dialog.html","<md-dialog class=\"delete-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll>{{vm.message}}\n</md-dialog-content><md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" ng-disabled=\"vm.saving\" \nng-click=\"vm.passwordConfirmation? vm.passwordConfirmation() : vm.deleteCallback()\"><span ng-show=\"!vm.saving\">Delete\n</span> <span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\">\n</md-progress-circular>Submitting</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/common/templates/drop-dialog/drop-dialog.html","<md-dialog class=\"common-drop-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll>{{vm.message}}\n</md-dialog-content><md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" ng-disabled=\"vm.saving\" \nng-click=\"vm.dropCallback()\"><span ng-show=\"!vm.saving\">OK</span> <span ng-show=\"vm.saving\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting</span></md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/reports/base-report/base-report.html","<md-toolbar class=\"transform-bar\"></md-toolbar><div id=\"transform-content-wrapper\" \nclass=\"transform-white-holder content-white-holder\"><div class=\"transform-white\"><md-tabs md-selected=\"vm.currentTab\" \nmd-dynamic-height md-border-bottom><md-tab id=\"base-report-dashboard-tab\" label=\"Dashboard\" \nui-sref=\"app.reports_base.dashboard\"><md-content class=\"tab-content content\"><div ui-view=\"base-report@dashboard\">\n</div></md-content></md-tab><md-tab id=\"base-report-transform-tab\" label=\"Transform\" \nui-sref=\"app.reports_base.transform\"><md-content class=\"tab-content content\"><div ui-view=\"base-report@transform\">\n</div></md-content></md-tab><md-tab id=\"base-report-prevail-tab\" label=\"Prevail\" ui-sref=\"app.reports_base.prevail\">\n<md-content class=\"tab-content content\"><div ui-view=\"base-report@prevail\"></div></md-content></md-tab><md-tab \nid=\"base-report-thrive-tab\" label=\"Thrive\" ui-sref=\"app.reports_base.thrive\"><md-content class=\"tab-content content\">\n<div ui-view=\"base-report@thrive\"></div></md-content></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/reports/branch-report/branch-report.html","<md-toolbar class=\"transform-bar\"></md-toolbar><div id=\"transform-content-wrapper\" \nclass=\"transform-white-holder content-white-holder\"><div class=\"transform-white\"><md-tabs md-selected=\"vm.currentTab\" \nmd-dynamic-height md-border-bottom><md-tab id=\"branch-report-transform-tab\" label=\"Transform\" \nui-sref=\"app.reports_branch.transform\"><md-content class=\"tab-content content\"><div ui-view=\"branch-report@transform\">\n</div></md-content></md-tab><md-tab id=\"branch-report-prevail-tab\" label=\"Prevail\" \nui-sref=\"app.reports_branch.prevail\"><md-content class=\"tab-content content\"><div ui-view=\"branch-report@prevail\">\n</div></md-content></md-tab><md-tab id=\"branch-report-thrive-tab\" label=\"Thrive\" ui-sref=\"app.reports_branch.thrive\">\n<md-content class=\"tab-content content\"><div ui-view=\"branch-report@thrive\"></div></md-content></md-tab></md-tabs>\n</div></div>");
$templateCache.put("app/main/reports/donors-report/donors-report.html","<div class=\"donors-page-content\"><md-toolbar class=\"transform-bar donor-search-bar\" id=\"content-heading-bar\" \nng-class=\"{\'full-height\': !vm.communities.length && !vm.communities.data.length}\"><div class=\"search\" layout=\"row\" \nlayout-align=\"center\" flex><input id=\"e-commerce-products-search\" ng-model=\"vm.filters.search_donor\" \nclass=\"search-input\" ng-keyup=\"vm.searchCommunities(vm.filters)\" \nplaceholder=\"Please enter a donor name or community ID\" type=\"text\" flex><md-icon md-font-icon=\"icon-magnify\" \nng-click=\"vm.getCommunityList(vm.filters)\" class=\"white-text icon search-icon\"></md-icon></div><div \nclass=\"no-match-records\" ng-show=\"vm.communities.data.length < 1\">No matching records</div></md-toolbar><div \nid=\"transform-content-wrapper\" ng-show=\"vm.communities.data.length > 0\" \nclass=\"transform-white-holder content-white-holder\"><div class=\"transform-white\"><table class=\"table donors-table\">\n<thead><tr><th class=\"padleft-30\">Community ID</th><th>Donor</th><th>Location</th><th>Municipality</th><th>Barangay\n</th><th>Pastor</th><th>Batch</th><th>Prevail Status</th></tr></thead><tbody><tr \nng-repeat=\"community in vm.communities.data\" ng-mouseover=\"community.selected = true\" \nng-mouseleave=\"community.selected = false\" ng-class=\"{backgroundWhite: community.selected}\" \nng-click=\"vm.goToFilter(community.id)\"><td class=\"padleft-30\">{{community.community_no}}</td><td>\n{{community.donor.name}}</td><td>{{community.application.base.name}}</td><td>{{community.application.community_city}}\n</td><td>{{community.application.community_barangay}}</td><td>{{community.application.pastor.firstname}}</td><td>\n{{community.batch.short_name}}</td><td>{{community.savings_group.status}}</td></tr></tbody></table><div \nclass=\"donor-pagination-container\" ng-show=\"!vm.isLoading3\"><pagination items=\"vm.communities\" \ncallback=\"vm.communityPageChange(vm.communities.current_page, vm.filters)\"></pagination></div></div></div></div>");
$templateCache.put("app/main/reports/monthly-report/monthly-report.html","<md-toolbar class=\"transform-bar\"></md-toolbar><div id=\"transform-content-wrapper\" \nclass=\"transform-white-holder content-white-holder\"><div class=\"transform-white\"><md-content \nclass=\"monthly-report-container\"><div layout=\"row\"><md-input-container class=\"md-block select-container\" flex=\"30\">\n<label>Base</label><md-select ng-model=\"vm.filters.base\" ng-model-options=\"{ trackBy: \'$value.id\' }\" \nng-change=\"vm.selectBase(vm.filters.base)\" ng-disabled=\"vm.currentUser.base_id\"><md-option ng-value=\"base\" \nng-repeat=\"base in vm.bases\">{{base.name}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block select-container\" flex=\"30\"><label>Branch</label><md-select \nng-disabled=\"!vm.filters.base.branches.length || vm.currentUser.branch_id\" ng-model=\"vm.filters.branch\" \nng-model-options=\"{ trackBy: \'$value.id\' }\" placeholder=\"Branch\"><md-option ng-value=\"all\" selected=\"selected\">\nAll Branches</md-option><md-option ng-value=\"branch\" ng-repeat=\"branch in vm.filters.base.branches\">{{ branch.name }}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block select-container\" flex=\"30\"><label>\nType</label><md-select ng-model=\"vm.filters.program\" ng-change=\"vm.selectProgram(vm.filters)\"><md-option \nng-value=\"null\">All</md-option><md-option value=\"prevail\" selected=\"selected\">Prevail</md-option><md-option \nvalue=\"thrive\">Thrive</md-option><md-option ng-value=\"program\" ng-repeat=\"program in vm.programs\">{{program.name}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"30\"><label>Batch</label>\n<md-select ng-model=\"vm.filters.batch\" ng-model-options=\"{ trackBy: \'$value.id\' }\" placeholder=\"Batch\"><md-option \nvalue=\"all\">All Batches</md-option><md-option ng-value=\"batch\" ng-repeat=\"batch in vm.batches\">{{ batch.short_name }}\n</md-option></md-select></md-input-container><div flex=\"30\" class=\"base-report-thrive mt-20 ml-15\"><span \nclass=\"preview\" ng-disabled=\"vm.isLoading\" ng-click=\"vm.getReport(vm.filters)\">Get Report</span></div></div><div \nclass=\"reports-filter-container clearfix\" ng-show=\"vm.reports.selectedReport\"><md-input-container \nclass=\"md-block pull-left select-container\"><label>Select a Report</label><md-select \nng-model=\"vm.reports.selectedReport\"><md-option ng-value=\"key\" ng-repeat=\"(key, value) in vm.reports.navs\">{{value}}\n</md-option></md-select></md-input-container><div class=\"pull-right right-section\"><span class=\"download\">Download\n</span> <span class=\"download-xls-csv\"><a ng-href=\"{{vm.api.baseUrl + \'reports/xls?\' + vm.downloadParams}}\" \nclass=\"xls\" target=\"_blank\">XLS</a> <span class=\"divider\">| </span><a \nng-href=\"{{vm.api.baseUrl + \'reports/csv?\' + vm.downloadParams}}\" target=\"_blank\" class=\"csv\">CSV</a> <span \nclass=\"divider\">| </span><a ng-href=\"{{vm.api.baseUrl + \'reports/compiled-pdf?\' + vm.downloadParams}}\" target=\"_blank\" \nclass=\"csv\">PDF</a></span></div></div><div class=\"report-container\" ng-show=\"vm.reports.selectedReport\"><div \nclass=\"report-table\" ng-bind-html=\"vm.reports.tables[vm.reports.selectedReport]\"></div></div><div layout=\"row\"><h4 \nng-show=\"!vm.isLoading && !vm.reports.selectedReport\"><em>No Data to Show</em></h4><h4 ng-show=\"vm.isLoading\"><em>\nLoading</em></h4></div></md-content></div></div>");
$templateCache.put("app/main/settings/changelogs/changelogs-settings.html","<md-toolbar class=\"transform-bar\"></md-toolbar><div id=\"changelogs-content-wrapper\" class=\"transform-white-holder\"><div\n class=\"transform-white\"><md-tabs id=\"settings-tabs\" md-selected=\"currentTab\" md-dynamic-height md-border-bottom>\n<md-tab id=\"icon-tab\" ng-disabled=\"true\"><md-tab-label><i class=\"icon icon-cog\"></i></md-tab-label><md-tab-body \nclass=\"tab-content\"></md-tab-body></md-tab><md-tab id=\"changelogs-tab\" ui-sref=\"app.changelogs.changelogs\">\n<md-tab-label><span>Changelogs</span></md-tab-label><md-tab-body class=\"tab-content\"><div \nui-view=\"settings@changelogs\"></div></md-tab-body></md-tab><md-tab id=\"apiErrors-tab\" \nui-sref=\"app.changelogs.apiErrors\"><md-tab-label><span>Data Conflicts</span></md-tab-label><md-tab-body \nclass=\"tab-content\"><div ui-view=\"settings@apiErrors\"></div></md-tab-body></md-tab><md-tab id=\"activeusers-tab\" \nui-sref=\"app.changelogs.activeusers\"><md-tab-label><span>Mobile Users</span></md-tab-label><md-tab-body \nclass=\"tab-content\"><div ui-view=\"settings@activeusers\"></div></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/settings/thrive/thrivesettings.html","<md-toolbar class=\"transform-bar\"></md-toolbar><div class=\"transform-white-holder\"><div class=\"transform-white\">\n<md-tabs id=\"settings-tabs\" md-selected=\"currentTab\" md-dynamic-height md-border-bottom><md-tab id=\"icon-tab\" \nng-disabled=\"true\"><md-tab-label><i class=\"icon icon-cog\"></i></md-tab-label><md-tab-body class=\"tab-content\">\n</md-tab-body></md-tab><md-tab id=\"bases-tab\" ui-sref=\"app.thrive.settings.bases\"><md-tab-label><span>Bases</span>\n</md-tab-label><md-tab-body class=\"tab-content\"><div ui-view=\"settings@bases\"></div></md-tab-body></md-tab><md-tab \nid=\"affiliations-tab\" ui-sref=\"app.thrive.settings.affiliations\"><md-tab-label><span>Church Affiliations</span>\n</md-tab-label><md-tab-body class=\"tab-content\"><div ui-view=\"settings@affiliations\"></div></md-tab-body></md-tab>\n<md-tab id=\"mayors-tab\" ui-sref=\"app.thrive.settings.mayors\"><md-tab-label><span>Mayors</span></md-tab-label>\n<md-tab-body class=\"tab-content\"><div ui-view=\"settings@mayors\"></div></md-tab-body></md-tab><md-tab id=\"datacard-tab\" \nui-sref=\"app.thrive.settings.datacard\"><md-tab-label><span>Data Card</span></md-tab-label><md-tab-body \nclass=\"tab-content\"><div ui-view=\"settings@datacard\"></div></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/settings/prevail/prevailsettings.html","<md-toolbar class=\"transform-bar\"></md-toolbar><div class=\"transform-white-holder\"><div class=\"transform-white\">\n<md-tabs id=\"settings-tabs\" md-selected=\"currentTab\" md-dynamic-height md-border-bottom><md-tab id=\"icon-tab\" \nng-disabled=\"true\"><md-tab-label><i class=\"icon icon-cog\"></i></md-tab-label><md-tab-body class=\"tab-content\">\n</md-tab-body></md-tab><md-tab id=\"partners-tab\" ui-sref=\"app.prevail.settings.partners\"><md-tab-label><span>Partner\n</span></md-tab-label><md-tab-body class=\"tab-content\"><div ui-view=\"settings@partners\"></div></md-tab-body></md-tab>\n<md-tab id=\"clusters-tab\" ui-sref=\"app.prevail.settings.clusters\"><md-tab-label><span>Clusters</span></md-tab-label>\n<md-tab-body class=\"tab-content\"><div ui-view=\"settings@clusters\"></div></md-tab-body></md-tab><md-tab \nid=\"small-groups-tab\" ui-sref=\"app.prevail.settings.smallGroups\"><md-tab-label><span>Small Groups</span></md-tab-label>\n<md-tab-body class=\"tab-content\"><div ui-view=\"settings@smallGroups\"></div></md-tab-body></md-tab></md-tabs></div>\n</div>");
$templateCache.put("app/main/settings/transform/settings.html","<md-toolbar class=\"transform-bar\"></md-toolbar><div id=\"transform-content-wrapper\"><div class=\"transform-white-holder\">\n<div class=\"transform-white\"><md-tabs id=\"settings-tabs\" md-selected=\"currentTab\" md-dynamic-height md-border-bottom>\n<md-tab id=\"icon-tab\" ng-disabled=\"true\"><md-tab-label><i class=\"icon icon-cog\"></i></md-tab-label><md-tab-body \nclass=\"tab-content\"></md-tab-body></md-tab><md-tab id=\"users-tab\" ui-sref=\"app.transform.settings.users\"><md-tab-label>\n<span>Users</span></md-tab-label><md-tab-body class=\"tab-content\"><div ui-view=\"settings@users\"></div></md-tab-body>\n</md-tab><md-tab id=\"programs-tab\" ui-sref=\"app.transform.settings.programs\"><md-tab-label><span>Programs</span>\n</md-tab-label><md-tab-body class=\"tab-content\"><div ui-view=\"settings@programs\"></div></md-tab-body></md-tab><md-tab \nid=\"batches-tab\" ui-sref=\"app.transform.settings.batches\"><md-tab-label><span>Batch Schedule</span></md-tab-label>\n<md-tab-body class=\"tab-content\"><div ui-view=\"settings@batches\"></div></md-tab-body></md-tab><md-tab \nid=\"products-tab\" ui-sref=\"app.transform.settings.products\"><md-tab-label><span>Products</span></md-tab-label>\n<md-tab-body class=\"tab-content\"><div ui-view=\"settings@products\"></div></md-tab-body></md-tab><md-tab id=\"donors-tab\" \nui-sref=\"app.transform.settings.donors\"><md-tab-label><span>Donors</span></md-tab-label><md-tab-body \nclass=\"tab-content\"><div ui-view=\"settings@donors\"></div></md-tab-body></md-tab></md-tabs></div></div></div>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\" class=\"s16\"></md-icon>\n</md-button></form></div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>\n{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>\n{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\">\n<span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 \ntranslate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" \naria-label=\"Notifications\" translate translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\">\n</md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch \nclass=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/toolbar/dialogs/session-expired/session-expired-dialog.html","<md-dialog class=\"new-user-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.dialogTitle}}</span><md-button ng-show=\"!vm.required\" class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll>\nSession has expired. Please log in again.</md-dialog-content><md-dialog-actions><md-button class=\"md-accent md-raised\" \nng-click=\"vm.closeDialog()\">Ok</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/toolbar/dialogs/change-password/change-password-dialog.html","<md-dialog class=\"new-user-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.changePassword(vm.user.newPassword, vm.user.confirmPassword)\"><md-toolbar class=\"md-accent md-hue-2\"><div\n class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}\n</span><md-button ng-show=\"!vm.required\" class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block\"><label>New Password</label><input \nminlength=\"5\" name=\"newPassword\" type=\"password\" ng-model=\"vm.user.newPassword\" required><div \nng-messages=\"eventForm.newPassword.$error\" ng-show=\"eventForm.newPassword.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-message=\"minlength\">Should have minimum of 5 characters</div>\n</div></md-input-container><md-input-container class=\"md-block\" style=\"margin-bottom: 0\"><label>Confirm new password\n</label><input name=\"confirmPassword\" type=\"password\" ng-pattern=\"{{vm.user.newPassword}}\" \nng-model=\"vm.user.confirmPassword\" required><div ng-messages=\"eventForm.confirmPassword.$error\" \nng-show=\"eventForm.confirmPassword.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span>Not equal</span></div><div \nng-message=\"required\"><span>Required</span></div></div></md-input-container></md-dialog-content><md-dialog-actions>\n<md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-show=\"!vm.required\" \nng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"eventForm.$invalid || eventForm.$pristine\" type=\"submit\">Save</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular>\n<ms-shortcuts></ms-shortcuts><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-shortcuts></ms-shortcuts><div \nclass=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide \nshow-gt-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div>\n</md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\" ui-sref=\"app.transform\"><img src=\"/assets/images/logos/icmlogo.png\" \nclass=\"image-logo\"> <span class=\"logo-text\" layout-align=\"center\">Database</span></div><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"toolbar-separator\"></div><md-button \nclass=\"md-icon-button navigation-fold-toggle\" show-gt-sm aria-label=\"Toggle navigation fold\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" ng-click=\"vm.toggleMsNavigationFolded()\"><md-icon \nclass=\"s18\" style=\"color: #fff\" md-font-icon=\"icon-backburger\"></md-icon></md-button></div><div layout=\"row\" \nlayout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu \nid=\"profile-menu\" md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"username\">{{vm.displayName}}</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item \nclass=\"md-indent\" ng-click=\"vm.changePassword($event)\"><md-icon md-font-icon=\"icon-key-change\" class=\"icon\"></md-icon>\n<md-button>Change password</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.login\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu><md-menu id=\"sep-menu\" \nmd-position-mode=\"left bottom\" ng-if=\"!currentUser.$roles.has([\'admin\'])\"><md-button class=\"sep-button\" ng-click=\"\">\n</md-button><md-menu-content width=\"1\"></md-menu-content></md-menu><md-menu id=\"settings-menu\" \nmd-position-mode=\"left bottom\" ng-show=\"currentUser.$roles.has([\'admin\'])\"><md-button class=\"settings-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"settings-menu-icon\"><i class=\"icon icon-cog\"></i></span>\n<md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\"></md-icon></div></md-button><md-menu-content width=\"1\">\n<md-menu-item class=\"md-indent\" ui-sref=\"app.transform.settings.users\"><md-icon md-font-icon=\"icon-tile-four\" \nclass=\"icon\"></md-icon><md-button ng-disabled=\"vm.checkState(\'app.transform.settings\')\">Transform Settings</md-button>\n</md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.prevail.settings.partners\"><md-icon \nmd-font-icon=\"icon-bank\" class=\"icon\"></md-icon><md-button ng-disabled=\"vm.checkState(\'app.prevail.settings\')\">\nPrevail Settings</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.thrive.settings.bases\"><md-icon\n md-font-icon=\"icon-people\" class=\"icon\"></md-icon><md-button ng-disabled=\"vm.checkState(\'app.thrive.settings\')\">\nThrive Settings</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.changelogs.changelogs\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon><md-button \nng-disabled=\"vm.checkState(\'app.changelogs\')\">Changelogs</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div  class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\r\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <!-- <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\r\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\r\n    </ul> -->\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div id=\"{{node.lid}}\" ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-button ng-class:{\'regactive\' : vm.hasMatchedRegex()}\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n \r\n            <!-- <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span> -->\r\n            <!-- <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i> -->\r\n        </a>\r\n        \r\n    </div>    \r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\r\n        ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/main/community/dialogs/add-bib-participant/add-bib-participant-dialog.html","<md-dialog class=\"delete-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"bibParticipantForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.addParticipant(vm.participant, vm.bib, bibParticipantForm)\" novalidate><md-toolbar\n class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll class=\"text-center\">\n<div layout-gt-xs=\"row\"><md-input-container flex=\"70\"><label>Participant Name</label><md-select \nng-model=\"vm.participant.participant_id\" . placeholder=\"Participant Name\" required><md-option \nng-value=\"participant.id\" ng-repeat=\"participant in vm.participants\">{{participant.fullname}}</md-option></md-select>\n<div ng-messages=\"bibParticipantForm.participant_id.$error\" \nng-show=\"bibParticipantForm.participant_id.$touched\r\n                         || vm.apiErrors.participant_id\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div class=\"error\" \nng-show=\"vm.apiErrors.participant_id\">{{vm.apiErrors.participant_id}}</div></div></md-input-container>\n<md-input-container flex=\"30\"><label>Type</label><md-select ng-model=\"vm.participant.type\" . placeholder=\"Type\" \nrequired><md-option ng-value=\"type.value\" ng-repeat=\"type in vm.types\">{{type.label}}</md-option></md-select><div \nng-messages=\"bibParticipantForm.type.$error\" \nng-show=\"bibParticipantForm.type.$touched\r\n                         || vm.apiErrors.type\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.type\"></div></div></md-input-container>\n</div><div layout-gt-xs=\"row\"><md-input-container flex=\"50\"><input name=\"base_capital\" \nng-model=\"vm.participant.base_capital\" placeholder=\"Capital\" required><div \nng-messages=\"bibParticipantForm.base_capital.$error\" \nng-show=\"bibParticipantForm.base_capital.$touched\r\n                         || vm.apiErrors.base_capital\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.base_capital\"></div></div>\n</md-input-container><span class=\"php\">PHP</span><md-input-container flex=\"30\" class=\"ml-20\"><input name=\"kits\" \nng-model=\"vm.participant.kits\" placeholder=\"Kits Given\" type=\"number\" min=\"0\" required><div \nng-messages=\"bibParticipantForm.kits.$error\" ng-show=\"bibParticipantForm.kits.$touched || vm.apiErrors.kits\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-message=\"min\"><span>Invalid input</span>\n</div><div ng-message=\"number\"><span>Invalid input</span></div><div ng-bind=\"vm.apiErrors.kits\"></div></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions><md-button md-no-ink \nclass=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">CANCEL</md-button><md-button \nclass=\"md-accent md-raised\" \nng-disabled=\"bibParticipantForm.$invalid\r\n                       || bibParticipantForm.$pristine || vm.saving\" \ntype=\"submit\"><span ng-show=\"!vm.saving\">SAVE</span> <span ng-show=\"vm.saving\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting</span></md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/community/dialogs/add-bib-visitor/add-bib-visitor-dialog.html","<md-dialog class=\"delete-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"bibVisitorForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.addVisitor(vm.visitor,\r\n          vm.bib, bibVisitorForm)\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll class=\"text-center\">\n<div layout-gt-xs=\"row\"><md-input-container flex=\"70\"><label>Visitor Name</label><md-select \nng-model=\"vm.visitor.participant_id\" . placeholder=\"Visitor Name\" required><md-option ng-value=\"visitor.id\" \nng-repeat=\"visitor in vm.visitors\">{{visitor.fullname}}</md-option></md-select><div \nng-messages=\"bibVisitorForm.participant_id.$error\" \nng-show=\"bibVisitorForm.participant_id.$touched || vm.apiErrors.participant_id\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.participant_id\"></div></div>\n</md-input-container><md-input-container flex=\"30\"><label>Type</label><md-select ng-model=\"vm.visitor.type\" . \nplaceholder=\"Type\" required><md-option ng-value=\"type.value\" ng-repeat=\"type in vm.types\">{{type.label}}</md-option>\n</md-select><div ng-messages=\"bibVisitorForm.type.$error\" ng-show=\"bibVisitorForm.type.$touched || vm.apiErrors.type\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.type\"></div></div>\n</md-input-container></div><div layout-gt-xs=\"row\"><md-input-container flex=\"50\"><input name=\"base_capital\" \nng-model=\"vm.visitor.base_capital\" placeholder=\"Capital\" required><div \nng-messages=\"bibVisitorForm.base_capital.$error\" \nng-show=\"bibVisitorForm.base_capital.$touched || vm.apiErrors.base_capital\" role=\"alert\"><div ng-message=\"required\">\n<span>Required</span></div><div ng-bind=\"vm.apiErrors.base_capital\"></div></div></md-input-container><span class=\"php\">\nPHP</span><md-input-container flex=\"30\" class=\"ml-20\"><input name=\"kits\" ng-model=\"vm.visitor.kits\" \nplaceholder=\"Kits Given\" type=\"number\" min=\"0\" required><div ng-messages=\"bibVisitorForm.kits.$error\" \nng-show=\"bibVisitorForm.kits.$touched || vm.apiErrors.kits\" role=\"alert\"><div ng-message=\"required\"><span>Required\n</span></div><div ng-message=\"min\"><span>Invalid input</span></div><div ng-message=\"number\"><span>Invalid input</span>\n</div><div ng-bind=\"vm.apiErrors.kits\"></div></div></md-input-container></div></md-dialog-content><md-dialog-actions>\n<md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">CANCEL\n</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"bibVisitorForm.$invalid || bibVisitorForm.$pristine || vm.saving\" type=\"submit\"><span \nng-show=\"!vm.saving\">SAVE</span> <span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"20px\"></md-progress-circular>Submitting</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/community/dialogs/add-bib-payment/add-bib-payment-dialog.html","<md-dialog id=\"add-bib-payment-dialog\" class=\"transform-dialog\" aria-label=\"New Message\"><form name=\"paymentForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nclass=\"text-center pb-25\"><div layout-gt-xs=\"row\"><md-input-container class=\"col-md-7 is-static\" \nng-show=\"vm.participant.participant\"><label>Participant Name</label><input \nng-model=\"vm.participant.participant.fullname\" class=\"input-static\" disabled=\"disabled\"></md-input-container>\n<md-input-container class=\"col-md-7 is-static\" ng-show=\"!vm.participant.participant && vm.participant.pastor_id\">\n<label>Participant Name</label><input ng-model=\"vm.pastor.fullname\" class=\"input-static\" disabled=\"disabled\">\n</md-input-container><md-input-container class=\"col-md-7 is-static\" \nng-show=\"!vm.participant.participant && !vm.participant.pastor_id\"><label>Participant Name</label><input value=\"--\" \nclass=\"input-static\" disabled=\"disabled\"></md-input-container><md-input-container class=\"col-md-3 mb-0\"><label \nclass=\"pl-20\">Week</label><md-select ng-model=\"vm.payment.week\" required name=\"week\" placeholder=\"Week\"><md-option \nng-value=\"week\" ng-repeat=\"week in vm.weeks\">{{week}}</md-option></md-select><div \nng-messages=\"paymentForm.week.$error\" ng-show=\"paymentForm.week.$touched || vm.paymentErrors.week\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-show=\"vm.paymentErrors.week\"><span>{{vm.paymentErrors.week}}\n</span></div></div></md-input-container><md-input-container class=\"col-md-2 text-right\"><md-checkbox class=\"cb-sale\" \nng-model=\"vm.payment.sale\">Sale</md-checkbox><div ng-messages=\"paymentForm.sale.$error\" \nng-show=\"paymentForm.sale.$touched || vm.paymentErrors.sale\" role=\"alert\"><div ng-show=\"vm.paymentErrors.sale\"><span>\n{{vm.paymentErrors.sale}}</span></div></div></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container \nclass=\"col-md-6 pl-0 mb-0 mt-0 input-group-container\"><div layout-gt-xs=\"row\"><div flex><label>Cash Payment</label>\n<input type=\"number\" ng-model=\"vm.payment.cash\" name=\"cash\" ng-required=\"!vm.payment.non_cash\"></div><div flex=\"10\" \nclass=\"input-append-label\"><span>PHP</span></div></div><div ng-messages=\"paymentForm.cash.$error\" \nng-show=\"paymentForm.cash.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div \nng-message=\"number\"><span>Invalid number</span></div></div></md-input-container><md-input-container \nclass=\"col-md-6 pl-0 mb-0 mt-0 input-group-container\"><div layout-gt-xs=\"row\"><div flex><label>Non-Cash Payment</label>\n<input type=\"number\" ng-model=\"vm.payment.non_cash\" name=\"non_cash\" ng-required=\"!vm.payment.cash\"></div><div \nflex=\"10\" class=\"input-append-label\"><span>PHP</span></div></div><div ng-messages=\"paymentForm.non_cash.$error\" \nng-show=\"paymentForm.non_cash.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div \nng-message=\"number\"><span>Invalid number</span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">CANCEL</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"paymentForm.$invalid || paymentForm.$pristine || vm.saving\" \nng-click=\"vm.addPayment(vm.payment, vm.participant)\">ADD</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/community/dialogs/community-details/community-details-dialog.html","<style>\n.input-margin {\r\n        margin-top: 0;\r\n        margin-bottom: 0;\r\n    }\r\n\r\n    .icon-button-margin {\r\n        margin-bottom: 25px !important;\r\n    }\r\n\r\n    .location md-input-container {\r\n        margin-top: 0 !important;\r\n    }\n</style><md-dialog class=\"community-details-dialog transform-dialog\" aria-label=\"New Message\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><form \nname=\"communityDetailsForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.editCommunity(vm.batch, vm.searchDonor, vm.selectedPastor, vm.community)\"><div layout-gt-xs=\"row\" \nng-hide=\"vm.currentUser.$roles.has([\'health_coordinator\', \'livelihood_coordinator\', \'health_trainer\', \'livelihood_trainer\', \'health_mentor\'])\">\n<md-autocomplete flex=\"40\" md-input-name=\"pastor\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedPastor\" \nmd-selected-item-change=\"vm.selectPastor(pastor)\" md-search-text=\"vm.searchPastorName\" \nmd-search-text-change=\"vm.searchPastorChange(vm.searchPastorName)\" \nmd-items=\"pastor in vm.searchPastors(vm.searchPastorName)\" \nmd-item-text=\"pastor.firstname+\' \'+pastor.lastname+ \' (\' +pastor.id+ \')\'\" md-require-match md-autofocus \nng-disabled=\"!vm.currentUser.$roles.has([\'admin\', \'metrics\', \'pastor_coordinator\', \'branch_head\', \'donor_services\', \'donor_managers\'])\" \nmd-floating-label=\"Pastor Name or ID\"><md-item-template><table><td width=\"100px\">{{pastor.id}}</td><td width=\"100px\">\n{{pastor.is_active ? \'Active\' : \'Inactive\'}}</td><td width=\"170px\">{{pastor.firstname}} {{pastor.lastname}}</td>\n</table></md-item-template></md-autocomplete><md-autocomplete flex=\"40\" \nng-show=\"vm.currentUser.$roles.has([\'admin\', \'donor_services\', \'donor_managers\'])\" md-input-name=\"donor\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedDonor\" md-selected-item-change=\"vm.selectDonor(donor)\" \nmd-search-text=\"vm.searchDonor\" md-items=\"donor in vm.searchDonors(vm.searchDonor)\" md-item-text=\"donor.name\" \nng-disabled=\"vm.currentUser.$roles.has([\'donor_managers\'])\" md-floating-label=\"Donor\"><md-item-template><span \nmd-highlight-text=\"vm.searchDonor\">{{donor.name}}</span></md-item-template></md-autocomplete><span flex></span><div>\n<md-button md-no-ink type=\"submit\" class=\"md-primary cancel-button add-pastor\" \nng-disabled=\"communityDetailsForm.$invalid\r\n                               || communityDetailsForm.$pristine\r\n                               && !vm.addedPastor\" \naria-label=\"Drop Application\" \nng-show=\"vm.currentUser.$roles.has([\'admin\', \'metrics\', \'pastor_coordinator\', \'branch_head\', \'donor_services\', \'donor_managers\'])\">\nSAVE</md-button></div></div><div layout-gt-xs=\"row\" class=\"donor\" \nng-show=\"vm.currentUser.$roles.has([\'admin\', \'metrics\', \'pastor_coordinator\', \'branch_head\'])\"><md-button md-no-ink \nclass=\"md-primary add-new-pastor add-pastor\" ng-click=\"vm.showNewPastorDialog()\">ADD NEW PASTOR</md-button></div><div \nlayout-gt-xs=\"row\" ng-show=\"vm.currentUser.$roles.has([\'admin\', \'metrics\', \'pastor_coordinator\', \'branch_head\'])\">\n<md-input-container class=\"md-block\" flex><label>Batch</label><md-select ng-model=\"vm.batch\" \nng-disabled=\"!vm.currentUser.$roles.has([\'admin\', \'metrics\', \'pastor_coordinator\', \'branch_head\']) || !vm.bases.length || vm.currentUser.base_id\" \nplaceholder=\"Select a year\"><md-option ng-value=\"batch.id\" ng-repeat=\"batch in vm.batches\">{{ batch.short_name }}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex><label>Base</label><md-select \nname=\"communitybase\" ng-model=\"vm.community.application.base_id\" placeholder=\"Base\" \nng-disabled=\"!vm.currentUser.$roles.has([\'admin\', \'metrics\', \'pastor_coordinator\', \'branch_head\']) || !vm.bases.length || vm.currentUser.base_id\">\n<md-option ng-value=\"base.id\" ng-click=\"vm.updateCommunityBase(base)\" ng-repeat=\"base in vm.bases\">{{ base.name }}\n</md-option></md-select><div class=\"errors\" ng-messages=\"communityDetailsForm.communitybase.$error\" \nng-if=\"communityDetailsForm.communitybase.$touched\r\n                         || communityDetailsForm.$submitted\"><div \nng-message=\"required\">Required.</div></div></md-input-container><md-input-container class=\"md-block\" flex><label>Branch\n</label><md-select name=\"branch\" ng-model=\"vm.community.application.base_branch_id\" placeholder=\"Branch\" \nng-disabled=\"!vm.currentUser.$roles.has([\'admin\', \'metrics\', \'pastor_coordinator\', \'branch_head\']) || !vm.selectedBase.branches.length || vm.currentUser.base_id\">\n<md-option ng-value=\"branch.id\" ng-repeat=\"branch in vm.selectedBase.branches\">{{ branch.name }}</md-option>\n</md-select><div class=\"errors\" ng-messages=\"communityDetailsForm.branch.$error\" \nng-if=\"communityDetailsForm.branch.$touched\r\n                         || communityDetailsForm.$submitted\"><div \nng-message=\"required\">Required.</div></div></md-input-container></div><div layout-gt-xs=\"row\" \nlayout-align=\"space-between start\"><md-input-container class=\"select-health-trainers\" flex=\"50\" \nng-if=\"vm.healthTrainers.length\"><label>Health Trainer</label><md-select name=\"healthTrainer\" \nng-model=\"vm.community.health_trainer\" ng-model-options=\"{ trackBy: \'$value.id\' }\"><md-option \nng-repeat=\"user in vm.healthTrainers\" ng-value=\"user\">{{ user.firstname }} {{ user.lastname }}</md-option></md-select>\n</md-input-container><md-input-container class=\"select-livelihood-trainers\" flex=\"50\" \nng-if=\"vm.livelihoodTrainers.length\"><label>Livelihood Trainer</label><md-select name=\"livelihoodTrainer\" \nng-model=\"vm.community.livelihood_trainer\" ng-model-options=\"{ trackBy: \'$value.id\' }\"><md-option \nng-repeat=\"user in vm.livelihoodTrainers\" ng-value=\"user\">{{ user.firstname }} {{ user.lastname }}</md-option>\n</md-select></md-input-container><md-input-container class=\"select-helath-mentors\" flex=\"50\" \nng-if=\"vm.healthMentors.length\"><label>HL Mentor</label><md-select name=\"healthMentor\" \nng-model=\"vm.community.health_mentor\" ng-model-options=\"{ trackBy: \'$value.id\' }\"><md-option \nng-repeat=\"user in vm.healthMentors\" ng-value=\"user\">{{ user.firstname }} {{ user.lastname }}</md-option></md-select>\n</md-input-container></div><div layout-gt-xs=\"row\" class=\"images-container\" \nng-show=\"vm.currentUser.$roles.has([\'admin\', \'metrics\', \'pastor_coordinator\', \'branch_head\'])\"><div \nclass=\"photos text-center\"><md-input-container class=\"photo-container md-block\"><p class=\"start-photo\">Community Banner\n</p><div class=\"photo-thumb\" \nstyle=\"background-image: url({{vm.community.banner_photo_url || \'http://via.placeholder.com/200x200/ffffff/4575BE?text=UPLOAD\'}})\" \nng-model=\"vm.community.banner_photo\" ngf-select=\"vm.uploadPhoto(\'banner\', vm.community.banner_photo, vm.community)\" \naccept=\"image/*\" ng-mouseenter=\"vm.community.banner_photo_hover = true\" \nng-mouseleave=\"vm.community.banner_photo_hover = false\"><md-menu class=\"photo-actions\" \nng-show=\"vm.community.banner_photo && vm.community.banner_photo_hover\" \nng-mouseenter=\"vm.community.banner_photo_hover = true\" ng-mouseleave=\"vm.community.banner_photo_hover = false\">\n<md-button class=\"md-icon-button\" ng-mouseenter=\"$mdMenu.open()\"><i class=\"icon icon-dots-vertical s20\"></i>\n</md-button><md-menu-content width=\"2\" ng-mouseleave=\"$mdMenu.close()\"><md-menu-item><md-button \nng-click=\"vm.removePhoto(\'banner\', vm.community, $event)\">Delete</md-button></md-menu-item></md-menu-content></md-menu>\n</div></md-input-container></div><div class=\"photos text-center\" flex=\"20\"><md-input-container \nclass=\"photo-container md-block\"><p class=\"start-photo\">Graduation Shot</p><div class=\"photo-thumb\" \nstyle=\"background-image: url({{vm.community.graduation_photo_url || \'http://via.placeholder.com/200x200/ffffff/4575BE?text=UPLOAD\'}})\" \nng-model=\"vm.community.graduation_photo\" \nngf-select=\"vm.uploadPhoto(\'graduation\', vm.community.graduation_photo, vm.community)\" accept=\"image/*\" \nng-mouseenter=\"vm.community.graduation_photo_hover = true\" ng-mouseleave=\"vm.community.graduation_photo_hover = false\">\n<md-menu class=\"photo-actions\" ng-show=\"vm.community.graduation_photo && vm.community.graduation_photo_hover\" \nng-mouseenter=\"vm.community.graduation_photo_hover = true\" ng-mouseleave=\"vm.community.graduation_photo_hover = false\">\n<md-button class=\"md-icon-button\" ng-mouseenter=\"$mdMenu.open()\"><i class=\"icon icon-dots-vertical s20\"></i>\n</md-button><md-menu-content width=\"2\" ng-mouseleave=\"$mdMenu.close()\"><md-menu-item><md-button \nng-click=\"vm.removePhoto(\'graduation\', vm.community, $event)\">Delete</md-button></md-menu-item></md-menu-content>\n</md-menu></div></md-input-container></div><div class=\"field-container\" flex><md-input-container \nclass=\"md-block mt-40 mb-30\"><label>Schedule</label><md-select name=\"schedule\" ng-model=\"vm.community.schedule\">\n<md-option ng-value=\"schedule\" ng-repeat=\"schedule in vm.schedules\">{{ schedule }}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block location-input input-margin\"><input type=\"text\" \nng-model=\"vm.community.map\" placeholder=\"Community Location (Google Maps Embed Code)\"></md-input-container><div \nlayout=\"row\" layout-align=\"start center\" layout-wrap><md-autocomplete class=\"md-block location\" \nmd-input-name=\"location\" md-no-cache=\"true\" flex ng-show=\"vm.showSearchLocation\" \nmd-selected-item=\"vm.selectedLocation\" md-selected-item-change=\"vm.selectLocation(location)\" \nmd-search-text=\"vm.searchLocation\" md-search-text-change=\"vm.searchLocationChange(vm.searchLocation)\" \nmd-items=\"location in vm.searchLocations(vm.searchLocation)\" md-item-text=\"location.display_name\" \nmd-floating-label=\"Search Location\"><md-item-template><span>{{location.display_name}}</span></md-item-template>\n</md-autocomplete><md-button class=\"md-icon-button icon-button-margin\" aria-label=\"Hide location search\" \nng-show=\"vm.showSearchLocation\" ng-click=\"vm.showSearchLocation = false\"><md-icon>close</md-icon></md-button><div \nflex=\"100\"></div><md-input-container class=\"md-block input-margin\" flex><input type=\"number\" \nng-model=\"vm.community.latitude\" placeholder=\"Latitude\"></md-input-container><md-input-container \nclass=\"md-block input-margin\" flex><input type=\"number\" ng-model=\"vm.community.longitude\" placeholder=\"Longitude\">\n</md-input-container><md-button class=\"md-icon-button icon-button-margin\" aria-label=\"Search location\" \nng-click=\"vm.showSearchLocation = !vm.showSearchLocation\"><md-icon class=\"material-icons\">place</md-icon></md-button>\n</div></div></div><div class=\"graph-part\"><div class=\"col-md-12 col-sm-12 col-xs-12 graph-part-container\"><div \nclass=\"col-md-3 col-sm-3 col-xs-3\"><label>Application Id</label><p>{{vm.community.application.application_id}}</p>\n</div><div class=\"col-md-3 col-sm-3 col-xs-3\"><label>Application Date</label><p>\n{{vm.community.application.applied_at | date}}</p></div><div class=\"col-md-3 col-sm-3 col-xs-3\"><label>Last Updated\n</label><p>{{vm.community.updated_at | date}}</p></div><div class=\"col-md-3 col-sm-3 col-xs-3\"><label>Last Updated By\n</label><p>{{vm.community.updatedby && vm.community.updatedby.username}}</p></div></div><div \nclass=\"col-md-12 col-sm-12 col-xs-12 graph-part-container\"><div class=\"col-md-6 col-sm-6 col-xs-6 pt-5\"><label>Location\n</label><p>Brgy. {{vm.community.application.community_barangay}}, {{vm.community.application.community_city}}</p></div>\n<div class=\"col-md-3 col-sm-3 col-xs-3 pt-5\"><label>Participants</label><p>\n{{vm.totalGraduates}}/{{vm.totalParticipants}}</p></div><div class=\"col-md-3 col-sm-3 col-xs-3 pt-5\"><label>Counselors\n</label><p>{{vm.totalCounselors}}</p></div></div><div class=\"col-md-12 col-sm-12 col-xs-12 pl-15 pr-15\"><label>\nAttendance chart</label><div ng-show=\"vm.data.length\"><canvas id=\"line\" class=\"chart chart-line\" chart-data=\"vm.data\" \nchart-labels=\"vm.labels\" chart-options=\"vm.options\"></canvas></div><div class=\"loading-chart\" \nng-show=\"!vm.data.length\">Loading chart</div></div></div></form></md-dialog-content><md-dialog-actions><md-button \nmd-no-ink class=\"md-warn cancel-button pull-right drop-commmunity\" ng-show=\"vm.currentUser.$roles.has([\'admin\'])\" \nng-click=\"vm.dropApplication()\">DROP COMMUNITY</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/community/dialogs/delete-bib-participant/delete-bib-participant-dialog.html","<md-dialog class=\"delete-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nclass=\"text-center\"><p class=\"text-muted text-reminder\"><em>\nDeleting this participant will also remove all his/her transactions.</em></p><hr><p>\nAre you sure to delete this participant?</p></md-dialog-content><md-dialog-actions><md-button md-no-ink \nclass=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"vm.saving\" ng-click=\"vm.passwordConfirmation()\"><span ng-show=\"!vm.saving\">\nDelete</span> <span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\">\n</md-progress-circular>Submitting</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/community/dialogs/add-visitor/add-visitor-dialog.html","<md-dialog class=\"add-visitor-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"addVisitorForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.addVisitor(vm.visitor, addVisitorForm)\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll class=\"text-center\">\n<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-xs><input name=\"firstname\" \nng-model=\"vm.visitor.firstname\" placeholder=\"First Name\" maxlength=\"30\" md-autofocus ng-disabled=\"vm.useExisting\" \nrequired><div ng-messages=\"addVisitorForm.firstname.$error\" ng-show=\"addVisitorForm.firstname.$touched\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-xs><input name=\"lastname\" ng-model=\"vm.visitor.lastname\" maxlength=\"30\" ng-disabled=\"vm.useExisting\" \nplaceholder=\"Last Name\" required><div ng-messages=\"addVisitorForm.lastname.$error\" \nng-show=\"addVisitorForm.lastname.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Required</span></div></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions><md-button md-no-ink \nclass=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">CANCEL</md-button><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"addVisitorForm.$invalid\r\n                       || addVisitorForm.$pristine\" \ntype=\"submit\">ADD</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/community/dialogs/edit-bib-participant/edit-bib-participant-dialog.html","<md-dialog class=\"edit-bib-participant-dialog\" \nclass=\"transform-dialog ng-class:{\'is-saving\': !vm.saving, \'is-loading\' : vm.loading}\" aria-label=\"New Message\"><form \nname=\"bibParticipantForm\" class=\"md-inline-form\" ng-submit=\"vm.editBibParticipant(vm.participant, bibParticipantForm)\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nclass=\"text-center\" ng-show=\"!vm.loading\"><div layout-gt-xs=\"row\"><md-input-container class=\"col-md-3 is-static mb-0\">\n<label>Business-In-A-Box Kit</label><input ng-model=\"vm.participant.bib.product.name\" class=\"input-static\" \ndisabled=\"disabled\"></md-input-container><md-input-container class=\"col-md-9 is-static mb-0\"><label>\nCommunity Capital Rate</label><input ng-model=\"vm.participant.bib.capital\" class=\"input-static\" disabled=\"disabled\">\n</md-input-container></div><div layout-gt-xs=\"row\"><md-input-container class=\"is-static col-md-3 mb-0\" \nng-show=\"vm.participant.participant\"><label>Participant Name</label><input \nng-model=\"vm.participant.participant.fullname\" class=\"input-static\" disabled=\"disabled\"></md-input-container>\n<md-input-container class=\"is-static col-md-3 mb-0\" ng-show=\"!vm.participant.participant && vm.participant.pastor_id\">\n<label>Participant Name</label><input ng-model=\"vm.pastor.fullname\" class=\"input-static\" disabled=\"disabled\">\n</md-input-container><md-input-container class=\"is-static col-md-3 mb-0\" \nng-show=\"!vm.participant.participant && !vm.participant.pastor_id\"><label>Participant Name</label><input value=\"--\" \nclass=\"input-static\" disabled=\"disabled\"></md-input-container><div class=\"col-md-9\"><div class=\"row\">\n<md-input-container class=\"col-md-2 pl-0 mb-0\"><label>Type</label><md-select ng-model=\"vm.participant.type\" \nplaceholder=\"Type\" ng-disabled=\"vm.saving\" required><md-option ng-value=\"type.value\" ng-repeat=\"type in vm.types\">\n{{type.label}}</md-option></md-select><div ng-messages=\"bibParticipantForm.type.$error\" \nng-show=\"bibParticipantForm.type.$touched\r\n                                 || vm.apiErrors.type\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.type\"></div></div></md-input-container>\n<md-input-container class=\"col-md-2 pl-0 input-group-container mb-0\"><div layout-gt-xs=\"row\"><div flex=\"70\"><input \nname=\"base_capital\" type=\"number\" ng-disabled=\"vm.saving\" required min=\"0\" placeholder=\"Cash Payment\" \nng-model=\"vm.participant.base_capital\"></div><div class=\"input-append-label\"><span class=\"span-font\">PHP</span></div>\n</div><div ng-messages=\"bibParticipantForm.base_capital.$error\" ng-show=\"bibParticipantForm.base_capital.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-message=\"min\"><span>Invalid number</span>\n</div><div ng-message=\"number\"><span>Invalid number</span></div></div></md-input-container><md-input-container \nclass=\"col-md-2 mb-0\"><input name=\"kitss\" type=\"number\" ng-model=\"vm.participant.kits\" placeholder=\"Kits Given\" \nmin=\"0\" ng-disabled=\"vm.saving\" required><div ng-messages=\"bibParticipantForm.kitss.$error\" \nng-show=\"bibParticipantForm.kitss.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div \nng-message=\"number\"><span>Invalid number</span></div><div ng-message=\"min\"><span>Invalid number</span></div></div>\n</md-input-container><md-input-container class=\"col-md-2 mb-0\"><div flex=\"70\"><input name=\"kits\" type=\"number\" \nng-model=\"vm.participant.total_capital\" placeholder=\"Total Capital\" disabled=\"disabled\" required></div><div \nclass=\"input-append-label\"><span class=\"span-font\">PHP</span></div></md-input-container><md-input-container \nclass=\"col-md-2 mb-0\"><div flex=\"70\"><input name=\"kits\" type=\"number\" ng-model=\"vm.participant.total_payments\" \nplaceholder=\"Total Payments\" disabled=\"disabled\" required></div><div class=\"input-append-label\"><span \nclass=\"span-font\">PHP</span></div></md-input-container><md-input-container class=\"col-md-2 mb-0\"><div flex=\"70\"><input \nname=\"kits\" type=\"number\" ng-model=\"vm.participant.balance\" placeholder=\"Balance\" disabled=\"disabled\" required></div>\n<div class=\"input-append-label\"><span class=\"span-font\">PHP</span></div></md-input-container></div></div></div><h2 \nclass=\"mt-0\">Transactions</h2><table id=\"participant-transactions-table\"><thead><tr><th>Transaction ID</th><th>Week\n</th><th>Sale</th><th width=\"100\">Cash Payment</th><th width=\"100\">Non-Cash</th><th width=\"50\">&nbsp;</th></tr></thead>\n<tbody><tr ng-show=\"!vm.participant.payments.length\"><td colspan=\"6\">No Transactions yet.</td></tr><tr \nng-repeat=\"payment in vm.participant.payments\"><td>{{(\"00000000\" + payment.id).slice(-8)}}</td><td><md-select \nng-model=\"payment.week\" required name=\"week\" placeholder=\"Week\"><md-option ng-value=\"week\" \nng-repeat=\"week in vm.weeks\" ng-disabled=\"vm.isParticipantPaymentWeekDisabled(week, payment.week)\">{{week}}</md-option>\n</md-select></td><td ng-class=\"{\'text-success\': payment.sale, \'text-danger\' : !payment.sale}\"><md-select \nng-model=\"payment.sale\" required name=\"sale\" placeholder=\"Sale\"><md-option ng-value=\"$index ? true : false\" \nng-repeat=\"sale in vm.sales\">{{sale}}</md-option></md-select></td><td><input type=\"number\" ng-disabled=\"vm.saving\" \nng-model=\"vm.participant.payments[$index].cash\" required></td><td><input type=\"number\" ng-disabled=\"vm.saving\" \nng-model=\"vm.participant.payments[$index].non_cash\" required></td><td><i class=\"icon-trash icon\" \nng-disabled=\"vm.saving\" ng-click=\"vm.deletePayment(vm, $index)\"><md-tooltip md-direction=\"left\">Delete Transaction\n</md-tooltip></i></td></tr></tbody></table><div class=\"modal-footnote\"><p class=\"mb-0\"><span class=\"footnote-label\">\nLast Updated By:</span> <span class=\"footnote-value\">\n{{vm.participant.updated_by && vm.participant.updated_by.username}}</span></p><p class=\"mb-0\"><span \nclass=\"footnote-label\">Last Updated At:</span> <span class=\"footnote-value\">{{vm.participant.updated_at}}</span></p>\n</div></md-dialog-content><md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">Cancel</md-button><md-button type=\"submit\" class=\"md-accent md-raised\" \nng-disabled=\"vm.saving\"><span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\">\n</md-progress-circular>Saving.. </span><span ng-show=\"!vm.saving\">Save</span></md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/community/dialogs/participant-notes/participant-notes-dialog.html","<md-dialog class=\"participant-notes-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"participantNoteForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.addNote(vm.note)\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><label class=\"participant-name-label\">Participant Name</label><div>\n{{vm.participant.participant.lastname}}, {{vm.participant.participant.firstname}}</div><md-content \nclass=\"notes-container\"><div class=\"note-item\" ng-repeat=\"note in vm.notes\" ng-show=\"vm.notes.length > 0\"><div \nclass=\"note-header\"><span>{{note.updated_at | formatDate}}</span> | <span>{{note.updated_by.username}}</span> <span \nclass=\"pull-right\"><i class=\"icon-trash\" \nng-show=\"vm.currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_coordinator\', \'livelihood_trainer\', \'health_trainer\', \'branch_head\', \'health_mentor\'])\" \nng-click=\"vm.deleteNote(note)\"></i></span></div><div class=\"note-body\" ng-show=\"!note.editing \" \nng-click=\"vm.activateEditNote(note)\">{{note.notes}}</div><div layout-gt-xs=\"row\" ng-show=\"note.editing\">\n<md-input-container flex class=\"mb-0 mt-0\"><textarea md-no-autogrow ng-model=\"note.notes\" ng-blur=\"vm.editNote(note)\">\n</textarea></md-input-container></div></div><div class=\"empty-view\" ng-show=\"vm.notes.length < 1\">No Notes</div>\n</md-content><div layout-gt-xs=\"row\" \nng-show=\"vm.currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_coordinator\', \'livelihood_trainer\', \'health_trainer\', \'branch_head\', \'health_mentor\'])\">\n<md-input-container flex class=\"mb-0 mt-0\"><label>Notes</label><textarea md-autofocus ng-model=\"vm.note\"></textarea>\n</md-input-container></div></md-dialog-content><md-dialog-actions><md-button md-no-ink \nclass=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button \nclass=\"md-accent md-raised\" \nng-disabled=\"editParticipantForm.$invalid\r\n                       || editParticipantForm.$pristine\" \nng-show=\"vm.currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_coordinator\', \'livelihood_trainer\', \'health_trainer\', \'branch_head\', \'health_mentor\'])\" \ntype=\"submit\">ADD NOTE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/community/tabs/attendance/attendance.html","<style>\n.vertical-rl {\r\n        transform: rotate(180deg);\r\n        white-space: nowrap;\r\n        writing-mode: vertical-rl;\r\n        padding: 0 !important;\r\n        height: 14rem !important;\r\n        font-size: 11px;\r\n        text-wrap: pretty;\r\n        letter-spacing: 1.2px;\r\n    }\r\n\r\n    .buld-delete-checkbox {\r\n        margin-right: 8px !important;\r\n    }\r\n\r\n    .delete-button {\r\n        background-color: #C1272D !important;\r\n        color: #fff !important;\r\n    }\n</style><div id=\"community-tab-content\" class=\"md-content\"><div class=\"community-tab-content-container\"><table \nclass=\"attendance-table mb-25\"><thead><tr><th rowspan=\"2\" \nng-class=\"{\'participant-text-container\': !currentUser.$roles.has([\'admin\', \'metrics\', \'pastor_coordinator\', \'branch_head\', \'health_mentor\'])}\" \nclass=\"tl button-container\"><md-button class=\"md-raised new-application\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'pastor_coordinator\', \'branch_head\', \'health_mentor\', \'health_trainer\', \'livelihood_trainer\'])\" \nng-click=\"vm.addParticipant(1)\">Add Participant</md-button><span \nng-show=\"!currentUser.$roles.has([\'admin\', \'metrics\', \'pastor_coordinator\', \'branch_head\', \'health_mentor\'])\">\nParticipants</span><md-button class=\"md-raised new-application pull-right\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'pastor_coordinator\', \'branch_head\'])\" \nng-href=\"{{ vm.api.baseUrl + \'reports/doc?programs[]=participants&application_id=\' + vm.community.application_id }}\" \ntarget=\"_blank\">Export</md-button><md-button class=\"md-raised new-application md-accent pull-right\" \nng-class=\"{\r\n                            \'disabled\': vm.bulkDeleteIDs.length===0,\r\n                            \'delete-button\': vm.bulkDeleteIDs.length,\r\n                        }\" \nng-disabled=\"vm.bulkDeleteIDs.length===0\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'pastor_coordinator\', \'branch_head\', \'health_mentor\'])\" \nng-click=\"vm.softDeleteParticipant(vm.bulkDeleteIDs)\"><span>Delete Participant</span></md-button><md-button \nclass=\"md-raised new-application md-accent pull-right\" \nng-class=\"{\'disabled\': vm.saving || !(vm.participantHasEdit || vm.pastorHasEdit)}\" \nng-disabled=\"vm.saving || !(vm.participantHasEdit || vm.pastorHasEdit)\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'health_trainer\', \'livelihood_trainer\', \'branch_head\', \'health_mentor\', \'livelihood_coordinator\'])\" \nng-click=\"vm.saveAttendance()\"><span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"20px\"></md-progress-circular>Saving.. </span><span ng-show=\"!vm.saving\">Save Attendance</span></md-button>\n</th><th rowspan=\"2\" class=\"tl\"><span>BCR<md-tooltip md-direction=\"top\">Birth Certificate Requirement</md-tooltip>\n</span></th><th rowspan=\"2\" class=\"tl\"><span>BIB/<br>GIB<md-tooltip md-direction=\"top\">BIB or GIB</md-tooltip></span>\n</th><th rowspan=\"2\" class=\"tl hide\"><span>MCR<md-tooltip md-direction=\"top\">Marriage Certificate Requirement\n</md-tooltip></span></th><th colspan=\"2\" class=\"tl headers\"><span>PG<md-tooltip md-direction=\"top\">Personal Garden\n</md-tooltip></span></th><th rowspan=\"2\" class=\"tl vertical-rl\"><span>Existing Pastor Church Member<md-tooltip \nmd-direction=\"top\">Existing Pastor Church Member</md-tooltip></span></th><th colspan=\"4\" class=\"tl headers\"><span>H2H\n<md-tooltip md-direction=\"top\">House-to-House</md-tooltip></span></th><th colspan=\"{{ vm.has_16_weeks ? 19 : 18 }}\" \nclass=\"tl headers\">Program Week</th><th rowspan=\"2\" class=\"tl graduate-header\"><i class=\"icon icon-school\"><md-tooltip \nmd-direction=\"top\">Graduate</md-tooltip></i></th></tr><tr><th>W1</th><th>W14</th><th class=\"tl\">1-4</th><th>5-8</th>\n<th>9-12</th><th>13-15</th><th class=\"tl\">1</th><th>2</th><th>3</th><th>4</th><th>5</th><th>6</th><th>7</th><th>8</th>\n<th>9</th><th>10</th><th>11</th><th>12</th><th>13</th><th>14</th><th>15</th><th ng-if=\"vm.has_16_weeks\">16</th><th \nclass=\"vertical-rl\">Attend Church (Sunday Service)</th><th class=\"vertical-rl\">Attend any other religious meetings\n<md-tooltip md-direction=\"top\">Small groups, bible study, choir, etc.</md-tooltip></th><th class=\"vertical-rl\">\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Became &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Church Member</th></tr></thead><tbody><tr \nng-show=\"vm.pastor.id\"><td class=\"name-td\"><span><img src=\"assets/icons/png/icon_pastor.png\"><md-tooltip \nmd-direction=\"top\">Pastor</md-tooltip></span><i class=\"icon icon-gender-male icon-gender\" \nng-show=\"vm.pastor.gender === \'male\'\"><md-tooltip md-direction=\"top\">Male</md-tooltip></i><i \nclass=\"icon icon-gender-female icon-gender\" ng-show=\"vm.pastor.gender === \'female\'\"><md-tooltip md-direction=\"top\">\nFemale</md-tooltip></i>{{vm.pastor.lastname}}, {{vm.pastor.firstname}}</td><td class=\"tl bcr-mcr-td\" \nng-class=\"{cursorNormal: !currentUser.$roles.has([\'admin\', \'metrics\', \'health_trainer\', \'livelihood_trainer\', \'branch_head\', \'health_mentor\'])}\">\n<md-tooltip md-direction=\"top\">{{vm.pastor.lastname}}, {{vm.pastor.firstname}} &nbsp;|&nbsp; BCR</md-tooltip><md-menu \nmd-position-mode=\"target-right target\"><div \nng-class=\"{cursorNormal: !currentUser.$roles.has([\'admin\', \'metrics\', \'health_trainer\', \'livelihood_trainer\', \'branch_head\', \'health_mentor\'])}\" \nng-click=\"vm.openMenu($mdMenu, $event)\"><i class=\"icon icon-check text-danger invisible\" \nng-show=\"!vm.pastor.attendance\r\n                                   || !vm.pastor.attendance.bcr\"></i> <i \nclass=\"icon icon-close text-danger invisible\" \nng-show=\"vm.pastor.attendance\r\n                                   && vm.pastor.attendance.bcr===\'not required\'\"></i> <i\n class=\"icon icon-check icon-selection\" \nng-show=\"vm.pastor.attendance\r\n                                   && vm.pastor.attendance.bcr===\'required\'\"></i> <i \nclass=\"icon icon-check-all icon-selection\" \nng-show=\"vm.pastor.attendance\r\n                                   && vm.pastor.attendance.bcr===\'obtained\'\"></i></div>\n<md-menu-content><md-menu-item><md-button ng-click=\"vm.pastorMenuItemClick(\'bcr\', vm.pastor, \'not required\')\"><i \nclass=\"icon-check invisible\"></i>Not Required</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.pastorMenuItemClick(\'bcr\', vm.pastor, \'required\')\"><i class=\"icon-check bcr-required\"></i>Required\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.pastorMenuItemClick(\'bcr\', vm.pastor, \'obtained\')\"><i \nclass=\"icon-check-all bcr-required\"></i>Obtained</md-button></md-menu-item></md-menu-content></md-menu></td><td \nclass=\"tl\"><i class=\"icon icon-show icon-check\" ng-if=\"vm.pastor.attendance.bib_gib\"></i></td><td \nclass=\"tl hide bcr-mcr-td\" \nng-class=\"{cursorNormal: !currentUser.$roles.has([\'admin\', \'metrics\', \'health_trainer\', \'livelihood_trainer\', \'branch_head\', \'health_mentor\'])}\">\n<md-tooltip md-direction=\"top\">{{vm.pastor.lastname}}, {{vm.pastor.firstname}} &nbsp;|&nbsp; MCR</md-tooltip><md-menu \nmd-position-mode=\"target-right target\"><div \nng-class=\"{cursorNormal: !currentUser.$roles.has([\'admin\', \'metrics\', \'health_trainer\', \'livelihood_trainer\', \'branch_head\', \'health_mentor\'])}\" \nng-click=\"vm.openMenu($mdMenu, $event)\"><i class=\"icon icon-check text-danger invisible\" \nng-show=\"!vm.pastor.attendance\r\n                               || !vm.pastor.attendance.mcr\"></i> <i \nclass=\"icon icon-close text-danger invisible\" \nng-show=\"vm.pastor.attendance\r\n                               && vm.pastor.attendance.mcr===\'not required\'\"></i> <i \nclass=\"icon icon-check icon-selection\" \nng-show=\"vm.pastor.attendance\r\n                               && vm.pastor.attendance.mcr===\'required\'\"></i> <i \nclass=\"icon icon-check-all icon-selection\" \nng-show=\"vm.pastor.attendance\r\n                               && vm.pastor.attendance.mcr===\'obtained\'\"></i></div>\n<md-menu-content><md-menu-item><md-button ng-click=\"vm.pastorMenuItemClick(\'mcr\', vm.pastor, \'not required\')\"><i \nclass=\"icon-check invisible\"></i>Not Required</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.pastorMenuItemClick(\'mcr\', vm.pastor, \'required\')\"><i class=\"icon-check bcr-required\"></i>Required\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.pastorMenuItemClick(\'mcr\', vm.pastor, \'obtained\')\"><i \nclass=\"icon-check-all bcr-required\"></i>Obtained</md-button></md-menu-item></md-menu-content></md-menu></td><td \nng-repeat=\"week in vm.weeks\" ng-click=\"vm.addPastorAttendance(vm.pastor, week, vm)\" \nng-class=\"{tl: $index == 0 || $index == 2 || $index == 3\r\n                    || $index == 7, cursorNormal: !currentUser.$roles.has([\'admin\', \'metrics\', \'health_trainer\', \'livelihood_trainer\', \'branch_head\', \'health_mentor\']),\r\n                    greenbg: vm.pastor.attendance2[week]}\">\n<md-tooltip md-direction=\"top\">\n{{vm.pastor.lastname}}, {{vm.pastor.firstname}} &nbsp;|&nbsp; {{ ( week===\"week_existing_pastor_church_member\"? \"Became Church Member\" : week===\"week_attend_church\"? \"Attend Church (Sunday Service)\" : week===\"week_religious_meeting\"? \"Attend any other religious meetings\" : week===\"week_became_church_member\"? \"Became Church Member\":week ) | uppercase }}\n</md-tooltip><i class=\"icon\" \nng-class=\"{ \'icon-show\': vm.pastor.attendance[week], \'icon-check\': !vm.pastor.attendance[week + \'_proxy\'], \'icon-check-all\': vm.pastor.attendance[week + \'_proxy\'] }\" \nng-if=\"vm.pastor.attendance\"></td><td class=\"tl\"><i class=\"icon icon-check\" \nng-class=\"{ \'icon-show\': vm.pastor.attendance && vm.pastor.attendance.graduate }\"></td></tr><tr ng-show=\"vm.isLoading\">\n<td colspan=\"24\" class=\"loading-area\"><span class=\"loading-text\">Loading participants..</span><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"13px\"></md-progress-circular></td></tr><tr ng-hide=\"vm.isLoading\" \nng-repeat=\"participant in vm.participants | toArray:false\"><td class=\"name-td\" \nng-click=\"vm.editParticipant(participant)\"><span style=\"grid-template-columns: 3fr 1fr 1fr; display: grid\"><span><span \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'pastor_coordinator\', \'branch_head\', \'health_mentor\'])\"><input \nclass=\"buld-delete-checkbox\" type=\"checkbox\" ng-model=\"vm.isChecked[participant.id]\" \nng-click=\"$event.stopPropagation();\" ng-change=\"vm.bulkDelete(participant); $event.stopPropagation();\" \nng-disabled=\"vm.hasAttendance(participant.attendance)\" ng-checked=\"vm.isChecked(participant)\"><md-tooltip \nmd-direction=\"bottom\">Select Participant</md-tooltip></span><span class=\"participant-id\">{{participant.participant_id}}\n</span> <span><img ng-show=\"participant.is_visitor\" src=\"assets/icons/png/icon_visitor.png\"><md-tooltip \nmd-direction=\"top\">Visitor</md-tooltip></span><span ng-hide=\"participant.is_visitor\"><span><img \nng-show=\"participant.type == \'counselor\'\" src=\"assets/icons/png/icon_counselor.png\"><md-tooltip md-direction=\"top\">\nOriginal Counselor</md-tooltip></span><span><img ng-show=\"participant.type == \'original\'\" \nsrc=\"assets/icons/png/icon_participant.png\"><md-tooltip md-direction=\"top\">Original Participant</md-tooltip></span>\n<span><img ng-show=\"participant.type == \'original_replacement\'\" src=\"assets/icons/png/icon_replace_participant.png\">\n<md-tooltip md-direction=\"top\">Replacement Participant</md-tooltip></span><span><img \nng-show=\"participant.type == \'counselor_replacement\'\" src=\"assets/icons/png/icon_replace_counselor.png\"><md-tooltip \nmd-direction=\"top\">Replacement Counselor</md-tooltip></span></span><i class=\"icon icon-gender-male icon-gender\" \nng-show=\"participant.gender === \'male\'\"><md-tooltip md-direction=\"top\">Male</md-tooltip></i><i \nclass=\"icon icon-gender-female icon-gender\" ng-show=\"participant.gender === \'female\'\"><md-tooltip md-direction=\"top\">\nFemale</md-tooltip></i>{{participant.lastname}}, {{participant.firstname}} <span class=\"material-icons Issues_icon\" \nng-show=\"participant.icon_display==1?true:false\" \nng-click=\"vm.issuesDialog(participant, vm.application.pastor);  $event.stopPropagation();\">error_outline </span></span>\n<span>{{participant.suffix}} </span><span \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'pastor_coordinator\', \'branch_head\', \'health_mentor\', \'health_trainer\', \'livelihood_trainer\'])\">\n<i class=\"icon-trash pull-right\" ng-click=\"vm.softDeleteParticipant(participant); $event.stopPropagation();\" \nng-style=\"{\'color\': vm.bulkDeleteIDs.length ? \'#878787\' : \'#C1272D\'}\" \nng-if=\"!vm.hasAttendance(participant.attendance)\"><md-tooltip md-direction=\"left\">Drop Participant</md-tooltip></i>\n</span></span></td><td class=\"tl hide bcr-mcr-td\" \nng-class=\"{cursorNormal: !currentUser.$roles.has([\'admin\', \'metrics\', \'health_trainer\', \'livelihood_trainer\', \'branch_head\', \'health_mentor\'])}\">\n<md-tooltip md-direction=\"top\">{{participant.lastname}}, {{participant.firstname}} &nbsp;|&nbsp; BCR</md-tooltip>\n<md-menu md-position-mode=\"target-right target\"><div \nng-class=\"{cursorNormal: !currentUser.$roles.has([\'admin\', \'metrics\', \'health_trainer\', \'livelihood_trainer\', \'branch_head\', \'health_mentor\'])}\" \nng-click=\"vm.openMenu($mdMenu, $event)\"><i class=\"icon icon-check text-danger invisible\" \nng-show=\"!participant.attendance\r\n                               || !participant.attendance.bcr\"></i> <i \nclass=\"icon icon-close text-danger invisible\" \nng-show=\"participant.attendance\r\n                               && participant.attendance.bcr===\'not required\'\"></i> <i\n class=\"icon icon-check icon-selection\" \nng-show=\"participant.attendance\r\n                               && participant.attendance.bcr===\'required\'\"></i> <i \nclass=\"icon icon-check-all icon-selection\" \nng-show=\"participant.attendance\r\n                               && participant.attendance.bcr===\'obtained\'\"></i></div>\n<md-menu-content><md-menu-item><md-button ng-click=\"vm.menuItemClick(\'bcr\', participant, \'not required\')\"><i \nclass=\"icon-check invisible\"></i>Not Required</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.menuItemClick(\'bcr\', participant, \'required\')\"><i class=\"icon-check bcr-required\"></i>Required</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.menuItemClick(\'bcr\', participant, \'obtained\')\"><i \nclass=\"icon-check-all bcr-required\"></i>Obtained</md-button></md-menu-item></md-menu-content></md-menu></td><td \nclass=\"tl bcr-mcr-td\" \nng-class=\"{cursorNormal: !currentUser.$roles.has([\'admin\', \'metrics\', \'health_trainer\', \'livelihood_trainer\', \'branch_head\', \'health_mentor\'])}\">\n<md-tooltip md-direction=\"top\">{{participant.lastname}}, {{participant.firstname}} &nbsp;|&nbsp; BCR</md-tooltip>\n<md-menu md-position-mode=\"target-right target\"><div \nng-class=\"{cursorNormal: !currentUser.$roles.has([\'admin\', \'metrics\', \'health_trainer\', \'livelihood_trainer\', \'branch_head\', \'health_mentor\'])}\" \nng-click=\"vm.openMenu($mdMenu, $event)\"><i class=\"icon icon-check text-danger invisible\" \nng-show=\"!participant.attendance\r\n                                   || !participant.attendance.bcr\"></i> <i \nclass=\"icon icon-close text-danger invisible\" \nng-show=\"participant.attendance\r\n                                   && participant.attendance.bcr===\'not required\'\">\n</i> <i class=\"icon icon-check icon-selection\" \nng-show=\"participant.attendance\r\n                                   && participant.attendance.bcr===\'required\'\"></i> <i\n class=\"icon icon-check-all icon-selection\" \nng-show=\"participant.attendance\r\n                                   && participant.attendance.bcr===\'obtained\'\"></i>\n</div><md-menu-content><md-menu-item><md-button ng-click=\"vm.menuItemClick(\'bcr\', participant, \'not required\')\"><i \nclass=\"icon-check invisible\"></i>Not Required</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.menuItemClick(\'bcr\', participant, \'required\')\"><i class=\"icon-check bcr-required\"></i>Required</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.menuItemClick(\'bcr\', participant, \'obtained\')\"><i \nclass=\"icon-check-all bcr-required\"></i>Obtained</md-button></md-menu-item></md-menu-content></md-menu></td><td \nclass=\"tl\"><i class=\"icon icon-show icon-check\" ng-if=\"participant.attendance.bib_gib\"></i></td><td \nng-repeat=\"week in vm.weeks\" ng-init=\"participant.attendance2 = {}; vm.pastor.attendance2 = {}\" \nng-click=\"vm.addParticipantAttendance(participant, week, vm);\" \nng-class=\"{tl: $index == 0 || $index == 2 || $index == 3\r\n                    || $index == 7,\r\n                    cursorNormal: !currentUser.$roles.has([\'admin\', \'metrics\', \'health_trainer\', \'livelihood_trainer\', \'branch_head\', \'health_mentor\']),\r\n                    greenbg: participant.attendance2[week]}\">\n<md-tooltip md-direction=\"top\">\n{{participant.lastname}}, {{participant.firstname}} &nbsp;|&nbsp; {{ ( week===\"week_existing_pastor_church_member\"? \"Became Church Member\" : week===\"week_attend_church\"? \"Attend Church (Sunday Service)\" : week===\"week_religious_meeting\"? \"Attend any other religious meetings\" : week===\"week_became_church_member\"? \"Became Church Member\":week ) | uppercase }}\n</md-tooltip>{{participant.week}} <i class=\"icon\" \nng-class=\"{ \'icon-show\': participant.attendance[week], \'icon-check\': !participant.attendance[week + \'_proxy\'], \'icon-check-all\': participant.attendance[week + \'_proxy\'] }\" \nng-if=\"participant.attendance\"></td><td class=\"tl\"><i class=\"icon icon-check\" \nng-class=\"{\'icon-show\': participant.attendance\r\n                                  && participant.attendance.graduate}\">\n</i></td></tr></tbody></table></div><div layout=\"row\" class=\"attendance-links-container\"><span \nclass=\"attendance-links\" flex=\"33\" ng-click=\"vm.showDisqualifiedParticipants()\">Disqualified Participants List </span>\n<span class=\"attendance-links\" flex=\"30\" ng-click=\"vm.showDroppedParticipants()\">Dropped Participants List</span></div>\n<div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" class=\"pt-24\"></div></div>");
$templateCache.put("app/main/community/dialogs/soft-delete-participant/soft-delete-participant-dialog.html","<md-dialog class=\"soft-delete-participant-dialog transform-dialog\" aria-label=\"New Message\"><form \nname=\"softDeleteParticipantForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.passwordConfirmation(vm.participant)\">\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block mb-0\" flex-gt-xs><label>Reason for Dropping</label><md-select \nname=\"reason\" ng-model=\"vm.participant.reason_for_dropping\" required><md-option ng-value=\"reason\" \nng-repeat=\"reason in vm.reasons\">{{ reason }}</md-option></md-select><div \nng-messages=\"softDeleteParticipantForm.reason.$error\" ng-show=\"softDeleteParticipantForm.reason.$touched\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"softDeleteParticipantForm.$invalid\r\n                       || softDeleteParticipantForm.$pristine\" \ntype=\"submit\">Submit</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/community/tabs/bib/bib.html","<style>\n.disabled {\r\n        background-color: rgba(0, 0, 0, 0.12) !important;\r\n        color: rgba(0, 0, 0, 0.38) !important;\r\n    }\r\n\r\n    .delete-button {\r\n        background-color: #C1272D !important;\r\n        color: #fff !important;\r\n    }\r\n\r\n    .delete-checkbox {\r\n        margin: 0px 4px 0 0 !important;\r\n        cursor: pointer;\r\n    }\n</style><div id=\"bib-tab-content\" class=\"bib-tab-content\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-align=\"end center\"><md-button class=\"md-raised new-application\" \nstyle=\"font-weight: bolder; text-transform: none\" \nng-class=\"{\r\n            \'disabled\': vm.bulkDeleteIDs.length===0,\r\n            \'delete-button\': vm.bulkDeleteIDs.length,\r\n        }\" \nng-disabled=\"vm.bulkDeleteIDs.length===0\" aria-label=\"Drop Application\" ng-if=\"vm.bibs.length\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_trainer\', \'health_trainer\', \'livelihood_coordinator\', \'branch_head\', \'health_mentor\'])\" \nng-click=\" vm.passwordConfirmation(vm.bulkDeleteIDs)\"><span>Delete BIB</span></md-button></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"33\" ng-repeat=\"bib in vm.bibs\"><ms-widget-front class=\"white-bg widget-container\"><form name=\"bibForm\" \nclass=\"md-inline-form\" novalidate><div class=\"widget-header\"><center><span class=\"week pull-left\">Week {{bib.week}}\n</span><span class=\"repayment\" ng-if=\"!bib.repayment\">Repayment Rate ( wk. {{bib.community.current_week}} ) </span>\n<span class=\"repayment\" ng-if=\"bib.repayment\">&nbsp </span><span class=\"pull-right md-headline\">\n{{bib.payment_percentage | number:2}}%</span></center></div><div class=\"widget-body\"><div layout-gt-xs=\"row \">\n<md-input-container class=\"md-block\" flex=\"65\"><label>Product</label><md-select name=\"product\" \nng-model=\"bib.product.id\" \nng-disabled=\"currentUser.$roles.has([\r\n                                           \'health_coordinator\', \'health_trainer\',\r\n                                           \'pastor_coordinator\', \'donor_services\',\r\n                                           \'donor_managers\', \'view_only\', \'area_head\',\r\n                                           \'national\'])\" \nng-change=\"vm.updateBib(bib, bib.product.id, \'product\')\" required><md-option ng-value=\"product.id\" \nng-repeat=\"product in vm.products\">{{product.name}}</md-option></md-select><div class=\"errors\" \nng-messages=\"bibForm.product.$error\"><div ng-message=\"required\">Required</div></div></md-input-container>\n<md-input-container class=\"md-block\" flex=\"35\"><input name=\"capital\" type=\"number\" min=\"0\" \nng-blur=\"vm.updateBib(bib, bib.capital, \'capital\')\" ng-model=\"bib.capital\" placeholder=\"Capital\" \nng-disabled=\"currentUser.$roles.has([\r\n                                       \'health_coordinator\', \'health_trainer\',\r\n                                       \'pastor_coordinator\', \'donor_services\',\r\n                                       \'donor_managers\', \'view_only\', \'area_head\',\r\n                                       \'national\'])\" \nrequired><div ng-messages=\"bibForm.capital.$error\" ng-show=\"bibForm.capital.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-message=\"number\"><span>Invalid number</span></div></div>\n</md-input-container><span class=\"pull-right php-capital\">PHP</span></div><center><div><div class=\"pull-left\"><div \nclass=\"units-label\">Kits Given</div><div class=\"pull-left\">{{bib.total_kits}}</div></div><div class=\"total-repaid\" \nng-if=\"!bib.repayment\"><div class=\"units-label\">Total Repaid</div><div><span class=\"total-payments\">\n{{bib.total_payments }} </span><span class=\"php-total-capital\">PHP</span></div></div><div class=\"total-repaid\" \nng-if=\"bib.repayment\">&nbsp<div><span class=\"total-payments\">&nbsp</span> <span class=\"php-total-capital\">&nbsp</span>\n</div></div><div class=\"pull-right\"><div class=\"units-label\">Total Capital</div><div><span class=\"total-payments\">\n{{bib.total_capital}}</span> <span class=\"php-total-capital\">PHP</span></div></div></div></center><div \nlayout-gt-xs=\"row \"><md-checkbox ng-model=\"bib.repayment\" \nng-change=\"vm.handleRepayment(bib, bib.repayment, \'repayment\')\" productclass=\"mb-0 mt-0\">Repayment Not Required\n</md-checkbox></div></div><div class=\"widget-footer\"><md-checkbox class=\"pull-left drop-application\" \nng-model=\"vm.isChecked[bib.id]\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_trainer\', \'health_trainer\', \'livelihood_coordinator\', \'branch_head\', \'health_mentor\'])\" \nng-change=\"vm.bulkDelete(bib)\" productclass=\"mb-0 mt-0\">DELETE</md-checkbox><md-button md-no-ink \nng-click=\"vm.showBibParticipants(bib)\" class=\"pull-right details\" aria-label=\"DETAILS\">DETAILS</md-button></div></form>\n</ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\" \nng-repeat=\"card in vm.toAddCards\"><ms-widget-front class=\"add-week-yellow widget-container\"><form name=\"bibForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.addBib(card)\" novalidate><div class=\"widget-header\"><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block select-week\" flex=\"65\"><label>Select week</label><md-select name=\"week\" \nng-model=\"card.week\" required><md-option ng-value=\"week.value\" ng-repeat=\"week in vm.weeks\">{{week.label}}</md-option>\n</md-select><div ng-messages=\"bibForm.week.$error\" role=\"alert\"><div ng-message=\"required\"><span>Required</span></div>\n</div></md-input-container></div></div><div class=\"widget-body\"><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex=\"65\"><label>Product</label><md-select name=\"product\" ng-model=\"card.product\" required><md-option \nng-value=\"product.id\" ng-repeat=\"product in vm.products\">{{product.name}}</md-option></md-select><div \nng-messages=\"bibForm.product.$error\" role=\"alert\"><div ng-message=\"required\"><span>Required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex=\"35\"><input name=\"capital\" type=\"number\" min=\"0\" \nng-model=\"card.capital\" placeholder=\"Capital\" required><div ng-messages=\"bibForm.capital.$error\" \nng-show=\"bibForm.capital.$touched\r\n                                     || bibForm.capital.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-message=\"number\"><span>Invalid number</span></div></div>\n</md-input-container><span class=\"pull-right php-capital\">PHP</span></div><div class=\"append\"></div><div \nlayout-gt-xs=\"row \"><md-checkbox ng-model=\"card.repayment\" productclass=\"mb-0 mt-0\">Repayment Not Required\n</md-checkbox></div></div><div class=\"widget-footer\"><md-button md-no-ink class=\"pull-left drop-application\" \naria-label=\"Drop Application\" ng-click=\"vm.cancelCard(card)\">CANCEL</md-button><md-button md-no-ink \nclass=\"pull-right details\" type=\"submit\" aria-label=\"ADD BIB\">ADD BIB</md-button></div></form></ms-widget-front>\n</ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\" ng-click=\"vm.addCard(vm.products)\" \nng-show=\"!vm.isLoadingBibs && currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_coordinator\', \'livelihood_trainer\', \'health_trainer\', \'branch_head\', \'health_mentor\'])\">\n<ms-widget-front class=\"add-week\"><div class=\"text-center\"><i class=\"icon icon-plus\"></i> <span>ADD BIB</span></div>\n</ms-widget-front></ms-widget></div><div class=\"widget-group trashed-widget-group\" layout=\"row\" flex=\"100\" layout-wrap \nng-show=\"vm.trashedBibs.length\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-align=\"space-between center\">\n<h3 class=\"dropped-text\">Dropped</h3><md-button class=\"md-raised new-application\" \nstyle=\"font-weight: bolder; text-transform: none\" \nng-class=\"{\r\n                \'disabled\': vm.bulkTrashedIDs.length===0,\r\n                \'delete-button\': vm.bulkTrashedIDs.length,\r\n            }\" \nng-disabled=\"vm.bulkTrashedIDs.length===0\" aria-label=\"Drop Application Permanently\" ng-if=\"vm.trashedBibs.length\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_trainer\', \'health_trainer\', \'livelihood_coordinator\', \'branch_head\', \'health_mentor\'])\" \nng-click=\" vm.passwordConfirmation(vm.bulkTrashedIDs, 1)\"><span>Delete BIB Permanently</span></md-button></div>\n<ms-widget layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\" ng-repeat=\"bib in vm.trashedBibs\">\n<ms-widget-front class=\"gray-bg widget-container\"><div class=\"widget-header\"><center><span \nclass=\"week pull-left week-label\">Week {{bib.week}} </span><span class=\"repayment\">\nRepayment Rate ( wk. {{bib.community.current_week}} ) </span><span class=\"percent pull-right md-headline week-label\">\n{{bib.payment_percentage | number: 2}}%</span></center></div><div class=\"widget-body\"><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex=\"65\"><label>Product</label><md-select ng-disabled=\"true\" name=\"product\" \nng-model=\"bib.product.id\" required><md-option ng-value=\"product.id\" ng-repeat=\"product in vm.products\">{{product.name}}\n</md-option></md-select><div class=\"errors\" ng-messages=\"bibForm.product.$error\"><div ng-message=\"required\">Required\n</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"35\"><input ng-disabled=\"true\" \nname=\"capital\" type=\"number\" min=\"0\" ng-model=\"bib.capital\" placeholder=\"Capital\" required><div \nng-messages=\"bibForm.capital.$error\" ng-show=\"bibForm.capital.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\nRequired</span></div></div></md-input-container><span class=\"pull-right php-capital\">PHP</span></div><center><div><div \nclass=\"pull-left\"><div class=\"units-label\">Kits Given</div><div>{{bib.total_kits}}</div></div><div \nclass=\"total-repaid\"><div class=\"units-label\">Total Repaid</div><div><span class=\"pull-left\">{{bib.total_payments}} \n</span><span class=\"php-repaid\">PHP</span></div></div><div class=\"pull-right\"><div class=\"units-label\">Total Capital\n</div><div><span class=\"pull-left\">{{bib.total_capital}} </span><span class=\"php-total-capital\">PHP</span></div></div>\n</div></center><div layout-gt-xs=\"row \"><md-checkbox ng-model=\"bib.repayment\" ng-disabled=\"true\" \nproductclass=\"mb-0 mt-0\">Repayment Not Required</md-checkbox></div></div><div class=\"widget-footer\"><md-checkbox \nclass=\"pull-left drop-application\" ng-model=\"vm.isCheckedTrashed[bib.id]\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_trainer\', \'health_trainer\', \'livelihood_coordinator\', \'branch_head\', \'health_mentor\'])\" \nng-change=\"vm.bulkTrashed(bib, 1)\" productclass=\"mb-0 mt-0\">DELETE PERMANENTLY</md-checkbox><md-button md-no-ink \nclass=\"pull-right restore-application\" ng-click=\"vm.restoreBib(bib)\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_trainer\', \'health_trainer\', \'livelihood_coordinator\', \'branch_head\', \'health_mentor\'])\" \naria-label=\"DETAILS\">RESTORE</md-button></div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/community/tabs/business-loans/business-loans.html","<style>\n.business-loans-tab-content table {\r\n        width: 100%;\r\n        max-width: 100%;\r\n        margin-bottom: 20px;\r\n        border-spacing: 0;\r\n        border-collapse: collapse;\r\n        background-color: transparent;\r\n    }\r\n\r\n    .business-loans-tab-content table th {\r\n        border-top: 0;\r\n        border-bottom: 0 !important;\r\n        color: #386BBA;\r\n        vertical-align: bottom;\r\n        padding: 8px;\r\n        line-height: 1.42857143;\r\n    }\r\n\r\n    .business-loans-tab-content table td {\r\n        border-top: 0 !important;\r\n        padding: 8px;\r\n        line-height: 1.42857143;\r\n        vertical-align: middle;\r\n        border-bottom: 1px solid #ddd;\r\n        display: table-cell;\r\n    }\r\n\r\n    .business-loans-tab-content .icon-trash {\r\n        cursor: pointer;\r\n        font-size: 17px;\r\n        color: #C1272D;\r\n        padding: 4%;\r\n    }\r\n\r\n    .business-loans-tab-content .icon-trash:hover {\r\n        color: #e74c3c;\r\n    }\r\n\r\n    .business-loans-tab-content .loan-amount-input {\r\n        border: 1px solid #C1272D;\r\n        border-radius: 3px;\r\n        padding: 4px 8px;\r\n        width: 130px;\r\n        font-size: 13px;\r\n        text-align: center;\r\n        outline: none;\r\n    }\r\n\r\n    .business-loans-tab-content .loan-amount-input:focus {\r\n        border-color: #386BBA;\r\n    }\n</style><div class=\"business-loans-tab-content\"><div class=\"filters-container\" layout-gt-xs=\"row\"><md-button \nclass=\"md-raised\" \nstyle=\"text-transform: none; color: white; background-color: #376BBA !important; margin-right: 4px; padding: 2px; font-size: 14px; line-height: 36px; font-weight: 900\" \nng-click=\"vm.addLoan()\" aria-label=\"Add Loan\" ng-if=\"currentUser.$roles.has([\'admin\'])\" ng-disabled=\"vm.isLoading\">\nAdd Loan</md-button></div><div class=\"all-loans\"><table class=\"table\"><thead><tr><th>Product Name</th><th># of Loans\n</th><th></th></tr></thead><tbody><tr ng-if=\"!vm.loans.length && !vm.isLoading\"><td colspan=\"3\"><div \nclass=\"text-center\">No business loans found.</div></td></tr><tr ng-if=\"vm.isLoading\"><td colspan=\"3\"><div \nclass=\"text-center\">Loading...</div></td></tr><tr ng-repeat=\"loan in vm.loans\" ng-if=\"!vm.isLoading\" \nng-mouseover=\"loan.selected = true\" ng-mouseleave=\"loan.selected = false\" ng-class=\"{backgroundWhite: loan.selected}\">\n<td>{{loan.product.name}}</td><td><input type=\"number\" min=\"0\" class=\"loan-amount-input\" ng-model=\"loan.loan_amount\" \nng-focus=\"loan._originalAmount = loan.loan_amount\" \nng-blur=\"loan.loan_amount !== loan._originalAmount && vm.updateLoanAmount(loan)\" aria-label=\"Loan amount\"></td><td><i \nclass=\"icon-trash\" ng-if=\"loan.id && currentUser.$roles.has([\'admin\'])\" \nng-click=\"vm.deleteLoan(loan); $event.stopPropagation();\"><md-tooltip md-direction=\"left\">Delete Loan</md-tooltip></i>\n</td></tr></tbody></table></div></div>");
$templateCache.put("app/main/community/tabs/hbf/hbf.html","<div id=\"hbf-tab-content\" class=\"hbf-tab-content\"><div class=\"widget-group row mt-10\"><div class=\"clearfix\"><ms-widget \nclass=\"col-lg-4 col-md-4 col-sm-6\" ng-repeat=\"card in vm.toAddCards\"><ms-widget-front \nclass=\"input-container widget-container\"><form name=\"hbfForm\" class=\"md-inline-form\" \nng-submit=\"vm.addHbf(hbfForm, card)\" novalidate><div class=\"widget-header\"></div><div class=\"widget-body\"><div \nlayout-gt-xs=\"row\"><div flex class=\"pr-8\"><md-input-container \nclass=\"md-block input-child-name-container input-week-no-container\"><label>Start Week:</label><md-select \nng-model=\"card.week_no\"><md-option ng-value=\"week.value\" ng-repeat=\"week in vm.weeks\">{{ week.label }}</md-option>\n</md-select><div \nng-messages=\"card.apiErrors.week_no\r\n                                        || hbfForm.week_no.$error\" \nng-show=\"hbfForm.week_no.$touched\r\n                                             || hbfForm.week_no.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"card.apiErrors.week_no\"></div></div>\n</md-input-container><md-autocomplete required md-input-name=\"guardian\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"card.selectedGuardian\" md-selected-item-change=\"card.selectGuardian(guardian)\" \nmd-search-text=\"card.searchGuardian\" md-items=\"guardian in vm.searchGuardians(vm.communityId, card.searchGuardian)\" \nmd-item-text=\"guardian.fullname\" md-floating-label=\"Guardian\'s Name\"><md-item-template><span \nmd-highlight-text=\"card.searchGuardian\">{{guardian.fullname}}</span></md-item-template><div class=\"errors\" \nng-messages=\"card.apiErrors.participant_id\r\n                                             || card.apiErrors.guardian_name\r\n                                             || hbfForm.guardian.$error\" \nng-show=\"hbfForm.guardian.$touched\r\n                                             || hbfForm.guardian.$error\"><div \nng-message=\"required\">Required</div><div ng-bind=\"card.apiErrors.participant_id\"></div><div \nng-bind=\"card.apiErrors.guardian_name\"></div></div></md-autocomplete></div><md-input-container flex=\"30\"><p \nclass=\"start-photo\">Start Photo</p><img src=\"http://via.placeholder.com/200x200?text=Upload\" class=\"ngf-image-select\" \nngf-select ng-if=\"!card.photo\" ng-model=\"card.photo\" ngf-multiple=\"false\" \nngf-model-options=\"{updateOn: \'change\', debounce: 100}\" accept=\"image/*\"> <img class=\"ngf-image-select\" ngf-select \nng-if=\"card.photo\" ngf-multiple=\"false\" ngf-model-options=\"{updateOn: \'change\', debounce: 100}\" \nngf-thumbnail=\"card.photo\" ng-model=\"card.photo\" accept=\"image/*\"></md-input-container></div><div layout=\"row\">\n<md-input-container flex class=\"md-block input-child-name-container\"><input name=\"child_first_name\" \nng-model=\"card.child_firstname\" placeholder=\"Child\'s First Name\" required><div \nng-messages=\"card.apiErrors.child_firstname\r\n                                        || hbfForm.child_first_name.$error\" \nng-show=\"hbfForm.child_first_name.$touched\r\n                                             || hbfForm.child_first_name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"card.apiErrors.child_firstname\"></div>\n</div></md-input-container><md-input-container flex class=\"md-block input-child-name-container\"><input \nname=\"child_last_name\" ng-model=\"card.child_lastname\" placeholder=\"Child\'s Last Name\" required><div \nng-messages=\"card.apiErrors.child_lastname\r\n                                        || hbfForm.child_last_name.$error\" \nng-show=\"hbfForm.child_last_name.$touched\r\n                                             || hbfForm.child_last_name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"card.apiErrors.child_lastname\"></div>\n</div></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex=\"50\" \nng-show=\"card.relationship !== \'Other\'\"><label>Relationship</label><md-select name=\"relationship\" \nng-model=\"card.relationship\" required><md-option ng-value=\"relationship.value\" \nng-repeat=\"relationship in vm.childRelationships\">{{relationship.label}}</md-option></md-select><div \nng-messages=\"card.apiErrors.relationship\r\n                                    || hbfForm.relationship.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"card.apiErrors.relationship\"></div>\n</div></md-input-container><md-input-container class=\"md-block\" flex=\"40\" ng-show=\"card.relationship === \'Other\'\">\n<input name=\"relationshipname\" required placeholder=\"Relationship\" ng-model=\"card.other\"><div \nng-messages=\"card.apiErrors.relationship\r\n                                    || hbfForm.relationshipname.$error\" \nng-show=\"hbfForm.relationshipname.$touched\r\n                                         || hbfForm.relationshipname.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"card.apiErrors.relationship\"></div>\n</div></md-input-container><span ng-show=\"card.relationship === \'Other\'\" flex=\"10\" class=\"mt-24\" \nng-click=\"card.relationship=\'\'\"><i class=\"icon-close other-close\"><md-tooltip md-direction=\"right\">Cancel</md-tooltip>\n</i></span><md-input-container class=\"md-block\" flex=\"50\"><input name=\"contact_no\" ng-model=\"card.contact_no\" \nplaceholder=\"Contact No\"><div \nng-messages=\"card.apiErrors.contact_no\r\n                                    || hbfForm.contact_no.$error\" \nng-show=\"hbfForm.contact_no.$touched\r\n                                         || hbfForm.contact_no.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"card.apiErrors.contact_no\"></div>\n</div></md-input-container></div><div layout-gt-xs=\"row\"><div flex=\"65\"><md-input-container \nclass=\"md-block datepicker birthdate-datepicker\"><label>Date of Birth</label><md-datepicker ng-model=\"card.birthdate\" \nname=\"birthdate\" md-open-on-focus md-placeholder=\"Enter Date\" md-input-name=\"birthdate\" \nng-change=\"vm.calculateAge(card)\" required></md-datepicker><div class=\"errors\" \nng-messages=\"card.apiErrors.birthdate\r\n                                             || hbfForm.birthdate.$error\"><div \nng-message=\"valid\" class=\"date-error\">The entered value is not a date!</div><div ng-message=\"required\" \nclass=\"date-error\">This date is required!</div><div ng-bind=\"card.apiErrors.birthdate\"></div></div>\n</md-input-container><md-input-container class=\"md-block datepicker\"><label>Weighing Date</label><md-datepicker \nng-model=\"card.weight_at\" name=\"weight_at\" md-open-on-focus md-placeholder=\"Enter Date\" md-input-name=\"weight_at\" \nrequired></md-datepicker><div class=\"errors\" \nng-messages=\"card.apiErrors.weight_at\r\n                                             || hbfForm.weight_at.$error\"><div \nng-message=\"valid\" class=\"date-error\">The entered value is not a date!</div><div ng-message=\"required\" \nclass=\"date-error\">This date is required!</div><div ng-bind=\"card.apiErrors.weight_at\"></div></div>\n</md-input-container></div><div flex=\"35\" class=\"gender-row\"><p class=\"widget-clabel radio-label\">Gender</p>\n<md-input-container class=\"md-block\"><md-radio-group ng-model=\"card.gender\"><md-radio-button \nng-repeat=\"gender in vm.genders\" ng-value=\"gender.value\" class=\"md-primary\">{{gender.label}}</md-radio-button>\n</md-radio-group><div class=\"errors\" ng-messages=\"card.apiErrors.gender || hbfForm.gender.$error\"><div \nng-bind=\"card.apiErrors.gender\"></div></div></md-input-container></div></div><div layout-gt-xs=\"row\"><div flex=\"60\">\n<div layout-gt-xs=\"row\"><div flex=\"50\"><md-input-container class=\"md-block\"><input name=\"weight_kg\" type=\"number\" \nmin=\"1\" ng-model=\"card.weight_kg\" placeholder=\"Weight (kg)\" required><div \nng-messages=\"card.apiErrors.weight_kg\r\n                                                || hbfForm.weight_kg.$error\" \nng-show=\"hbfForm.weight_kg.$touched\r\n                                                     || hbfForm.weight_kg.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-message=\"number\"><span>Invalid number</span>\n</div><div ng-message=\"min\"><span>Should not be zero (0)</span></div><div ng-bind=\"card.apiErrors.weight_kg\"></div>\n</div></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><input name=\"height_cm\" \ntype=\"number\" min=\"1\" ng-model=\"card.height_cm\" placeholder=\"Height (cm)\" required><div \nng-messages=\"card.apiErrors.height_cm\r\n                                                || hbfForm.height_cm.$error\" \nng-show=\"hbfForm.height_cm.$touched\r\n                                                     || hbfForm.height_cm.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-message=\"number\"><span>Invalid number</span>\n</div><div ng-message=\"min\"><span>Should not be zero (0)</span></div><div ng-bind=\"card.apiErrors.height_cm\"></div>\n</div></md-input-container></div></div><md-input-container class=\"md-block\"><input name=\"target_weight\" \nng-model=\"card.target_weight | number : 1\" placeholder=\"Target Weight (kg)\" readonly=\"readonly\"><div \nng-messages=\"card.apiErrors.target_weight\r\n                                        || hbfForm.target_weight.$error\" \nng-show=\"hbfForm.target_weight.$touched\r\n                                             || hbfForm.target_weight.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"card.apiErrors.target_weight\"></div>\n</div></md-input-container></div><div flex=\"40\"><div class=\"col-md-12\"><label class=\"widget-clabel text-center\">\nWasting Score</label><div class=\"clearfix\"><div class=\"pull-left mr-16 calc-score\" ng-show=\"card.calculatedScore\"><p \nclass=\"widget-hlabel calc-score {{card.calculatedScore.color}}\">{{ card.calculatedScore.score | number : 1}}</p><p \nclass=\"widget-vlabel calc-code {{card.calculatedScore.color}}\">\n{{card.calculatedScore.code === \'CURED\' ? \'NORMAL\' : card.calculatedScore.code}}</p></div><md-button \nclass=\"md-accent pull-left md-raised btn-calculate\" ng-click=\"vm.calculateScore(hbfForm, card)\"><span \nng-show=\"!card.calculatedScore\">CALCULATE</span> <span ng-show=\"card.calculatedScore\" class=\"icon icon-refresh\"></span>\n</md-button></div></div></div></div><div ng-hide=\"true\" layout=\"row\" layout-wrap flex><md-checkbox value=\"1\" flex=\"50\" \nclass=\"options\" ng-model=\"card.breastfeeding\" ng-show=\"card.age && card.age.months <= 24\">Breastfeeding?</md-checkbox>\n<md-checkbox value=\"1\" flex=\"50\" class=\"options\" ng-model=\"card.abcdef_test\">ABCDEF Test?</md-checkbox><md-checkbox \nvalue=\"1\" flex=\"50\" class=\"options\" ng-model=\"card.appetite_test\">Appetite Test?</md-checkbox></div></div><div \nclass=\"widget-footer\"><md-button md-no-ink class=\"pull-left btn-secondary\" ng-click=\"vm.cancelCard(card)\">CANCEL\n</md-button><md-button type=\"submit\" md-no-ink class=\"pull-right text-center\" aria-label=\"ADD WEEK\" \nng-disabled=\"vm.addCardSaving\"><span ng-show=\"!vm.addCardSaving\">SAVE</span><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.addCardSaving\"></md-progress-circular></md-button></div></form>\n</ms-widget-front></ms-widget><ms-widget class=\"col-lg-4 col-md-4 col-sm-6\" ng-click=\"vm.addCard()\" \nng-show=\"!vm.isLoadingHbfs && currentUser.$roles.has([\'admin\', \'metrics\', \'health_coordinator\', \'livelihood_trainer\', \'health_trainer\', \'branch_head\', \'health_mentor\'])\">\n<ms-widget-front class=\"add-week\"><div class=\"text-center\"><i class=\"icon icon-plus\"></i> <span>ADD CHILD</span></div>\n</ms-widget-front></ms-widget></div><div class=\"clearfix bt pb-15 mt-15\" ng-show=\"vm[type].length\" \nng-repeat=\"type in [\'samHbfs\', \'mamHbfs\', \'normalHbfs\', \'curedHbfs\']\"><ms-widget layout=\"column\" \nclass=\"col-lg-4 col-md-4 col-sm-6\" ng-repeat=\"hbf in vm[type]\"><ms-widget-front class=\"white-bg widget-container\"><form\n name=\"hbfForm\" class=\"md-inline-form\" novalidate><div class=\"widget-header\"><div class=\"row text-center\"><div \nclass=\"photos text-center\"><md-input-container class=\"photo-container md-block\"><p class=\"start-photo\">Start Photo</p>\n<div class=\"photo-thumb\" ng-mouseenter=\"hbf.before_photo_hover = true\" ng-mouseleave=\"hbf.before_photo_hover = false\" \nng-click=\"hbf.before_photo ? vm.showLightBox(hbf.before_photo_url, $event) : vm.replacePhoto(hbf, \'before\')\"><img \nng-src=\"{{vm.bustCache(hbf.before_photo_thumb_url, hbf.updated_at)}}\" alt=\"Start photo\" \nstyle=\"width: 100%; height: 100%\" ng-show=\"hbf.before_photo\"><md-menu class=\"photo-actions\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'health_coordinator\', \'health_trainer\', \'branch_head\', \'health_mentor\']) && hbf.before_photo && hbf.before_photo_hover\" \nng-mouseenter=\"hbf.before_photo_hover = true\" ng-mouseleave=\"hbf.before_photo_hover = false\"><md-button \nclass=\"md-icon-button\" ng-mouseenter=\"$mdMenu.open()\"><i class=\"icon icon-dots-vertical s20\"></i></md-button>\n<md-menu-content width=\"2\" ng-mouseleave=\"$mdMenu.close()\"><md-menu-item><md-button \nng-click=\"vm.replacePhoto(hbf, \'before\')\">Replace</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.removePhoto(hbf, \'before\', $event)\">Delete</md-button></md-menu-item></md-menu-content></md-menu></div>\n</md-input-container></div><div class=\"photos text-center\"><md-input-container class=\"photo-container md-block\"><p \nclass=\"start-photo\">End Photo</p><div class=\"photo-thumb\" ng-mouseenter=\"hbf.after_photo_hover = true\" \nng-mouseleave=\"hbf.after_photo_hover = false\" \nng-click=\"hbf.after_photo ? vm.showLightBox(hbf.after_photo_url, $event) : vm.replacePhoto(hbf, \'after\')\"><img \nng-src=\"{{vm.bustCache(hbf.after_photo_thumb_url, hbf.updated_at)}}\" alt=\"Start photo\" \nstyle=\"width: 100%; height: 100%\" ng-show=\"hbf.after_photo\"><md-menu class=\"photo-actions\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'health_coordinator\', \'health_trainer\', \'branch_head\', \'health_mentor\']) && hbf.after_photo && hbf.after_photo_hover\" \nng-mouseenter=\"hbf.after_photo_hover = true\" ng-mouseleave=\"hbf.after_photo_hover = false\"><md-button \nclass=\"md-icon-button\" ng-mouseenter=\"$mdMenu.open()\"><i class=\"icon icon-dots-vertical s20\"></i></md-button>\n<md-menu-content width=\"2\" ng-mouseleave=\"$mdMenu.close()\"><md-menu-item><md-button \nng-click=\"vm.replacePhoto(hbf, \'after\')\">Replace</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.removePhoto(hbf, \'after\', $event)\">Delete</md-button></md-menu-item></md-menu-content></md-menu></div>\n</md-input-container></div></div><div class=\"row mt-16\"><div class=\"col-md-6 col-sm-6 col-xs-6\"><div \nclass=\"widget-clabel\">Child\'s Name<div class=\"contentover\" contentover><span class=\"icon icon-information ml-10\">\n</span><div class=\"co contentover-guardian-info\"><div class=\"ctgcol\"><p class=\"widget-clabel\">Guardian</p><p \nclass=\"widget-vlabel\">\n{{hbf.participant ? hbf.participant.fullname : hbf.guest_name}} - {{hbf.relationship | capitalize}}</p></div><div \nclass=\"ctgcol\"><p class=\"widget-clabel\">Contact No</p><p class=\"widget-vlabel\">{{hbf.contact_no || \'--\'}}</p></div>\n</div></div></div><p class=\"widget-vlabel\">{{hbf.child_firstname}} {{hbf.child_lastname}}</p></div><div \nclass=\"col-md-6 col-sm-6 col-xs-6\"><p class=\"widget-clabel\">Gender</p><p class=\"widget-vlabel\">{{ hbf.gender }}</p>\n</div></div><div class=\"row\"><div class=\"col-md-6 col-sm-6 col-xs-6\"><p class=\"widget-clabel\">Age</p><p \nclass=\"widget-vlabel\">{{ hbf.age }}</p></div><div class=\"col-md-6 col-sm-6 col-xs-6\"><p class=\"widget-clabel\">\nDate of Weighing</p><p class=\"widget-vlabel mb-0\">Week {{ hbf.initial_weight_log.week_no }}</p></div></div></div><div \nclass=\"widget-body\"><p class=\"widget-hrlabel\"><span>Status Overview</span></p><div layout-gt-xs=\"row\" \nclass=\"widget-shlabels\"><div flex><p class=\"widget-clabel\">Initial</p></div><div flex><p class=\"widget-clabel\">Current\n</p></div><div flex><p class=\"widget-clabel\">Target</p></div></div><div layout-gt-xs=\"row\"><div flex \nclass=\"text-center\"><div class=\"flexin\"><p class=\"widget-hlabel\">{{hbf.initial_weight_log.weight_kg | number : 1}} kg\n</p><p class=\"widget-clabel\">{{hbf.initial_weight_log.wasting_score | number : 1}}</p><p class=\"ws-label wsnobg\">\n{{ hbf.initial_weight_log.code }}</p></div></div><div flex class=\"text-center\"><div class=\"flexin\"><p \nclass=\"widget-hlabel\">{{ hbf.current_weight_log.weight_kg | number : 1}} kg</p><p class=\"widget-clabel\">\n{{hbf.current_weight_log.wasting_score | number : 1}}</p><p class=\"ws-label {{ hbf.condition.color }}\">\n{{ hbf.condition.code }} {{hbf.current_weight_log.status_name ? \"- \" + hbf.current_weight_log.status_name : \'\'}}</p>\n</div></div><div flex class=\"text-center\"><div class=\"flexin\"><p \nclass=\"widget-hlabel {{ hbf.current_wasting_score_diff >= 0 ? \'green\' : \'red\' }}\"><span \nng-show=\"hbf.current_weight_log.target_weight >= 0\"></span> {{hbf.current_weight_log.target_weight | number : 1}} kg\n</p><p class=\"widget-vlabel {{ hbf.current_wasting_score_diff >= 0 ? \'green\' : \'red\' }}\"><span \nng-show=\"hbf.current_wasting_score_diff >= 0\">+</span> {{ hbf.current_wasting_score_diff | number : 1 }}</p><p \nclass=\"ws-flagged\" \nng-show=\"!hbf.is_discharged && !hbf.has_weight_increase && (hbf.has_missing_data || !hbf.has_nutripacks)\"><i \nclass=\"icon-flag-variant\"></i></p></div></div></div></div><div class=\"widget-footer text-center\"><md-button md-no-ink \nclass=\"btn-secondary pull-left\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'health_coordinator\', \'livelihood_trainer\', \'health_trainer\', \'branch_head\', \'health_mentor\', \'health_mentor\'])\" \nng-click=\"vm.hardDeleteHbf(hbf)\">DELETE</md-button><md-button md-no-ink ng-click=\"vm.showHbfDetails(hbf)\">DETAILS\n</md-button><md-button md-no-ink class=\"pull-right\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'health_coordinator\', \'livelihood_trainer\', \'health_trainer\', \'branch_head\', \'health_mentor\', \'health_mentor\'])\" \nng-disabled=\"vm.disableLogWeight(hbf)\" ng-click=\"vm.logWeight(hbf)\">LOG WEIGHT</md-button></div></form>\n</ms-widget-front></ms-widget></div></div><div class=\"widget-group trashed-hbfs\" layout=\"row\" flex=\"100\" layout-wrap \nng-show=\"vm.trashedHbfs.length\"><ms-widget layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\" \nng-repeat=\"hbf in vm.trashedHbfs\"><ms-widget-front class=\"gray-bg widget-container\"><form name=\"hbfForm\" \nclass=\"md-inline-form\" novalidate><div class=\"widget-header\"><div class=\"row text-center\"><div \nclass=\"photos text-center\"><md-input-container class=\"photo-container md-block\"><p class=\"start-photo\">Start Photo</p>\n<div class=\"photo-thumb\" \nstyle=\"opacity: .5; background-image: url({{hbf.before_photo_thumb_url || \'http://via.placeholder.com/200x200/ffffff/4575BE?text=UPLOAD\'}})\">\n</div></md-input-container></div><div class=\"photos text-center\"><md-input-container class=\"photo-container md-block\">\n<p class=\"start-photo\">End Photo</p><div class=\"photo-thumb\" \nstyle=\"opacity: .5; background-image: url({{hbf.after_photo_thumb_url || \'http://via.placeholder.com/200x200/ffffff/4575BE?text=UPLOAD\'}})\">\n</div></md-input-container></div></div><div class=\"row mt-16\"><div class=\"col-md-6 col-sm-6 col-xs-6\"><div \nclass=\"widget-clabel\">Child\'s Name<div class=\"contentover\" contentover><span class=\"icon icon-information ml-10\">\n</span><div class=\"co contentover-guardian-info\"><div class=\"ctgcol\"><p class=\"widget-clabel\">Guardian</p><p \nclass=\"widget-vlabel-deleted\">\n{{hbf.participant ? hbf.participant.fullname : hbf.guest_name}} - {{hbf.relationship | capitalize}}</p></div><div \nclass=\"ctgcol\"><p class=\"widget-clabel\">Contact No</p><p class=\"widget-vlabel-deleted\">{{hbf.contact_no || \'--\'}}</p>\n</div></div></div></div><p class=\"widget-vlabel-deleted\">{{hbf.child_firstname}} {{hbf.child_lastname}}</p></div><div \nclass=\"col-md-6 col-sm-6 col-xs-6\"><p class=\"widget-clabel\">Gender</p><p class=\"widget-vlabel-deleted\">{{ hbf.gender }}\n</p></div></div><div class=\"row\"><div class=\"col-md-6 col-sm-6 col-xs-6\"><p class=\"widget-clabel\">Age</p><p \nclass=\"widget-vlabel-deleted\">{{ hbf.age }}</p></div><div class=\"col-md-6 col-sm-6 col-xs-6\"><p class=\"widget-clabel\">\nDate of Weighing</p><p class=\"widget-vlabel-deleted mb-0\">Week {{ hbf.initial_weight_log.week_no }}</p></div></div>\n</div><div class=\"widget-body\"><p class=\"widget-hrlabel-deleted\"><span>Status Overview</span></p><div \nlayout-gt-xs=\"row\" class=\"widget-shlabels\"><div flex><p class=\"widget-clabel\">Initial</p></div><div flex><p \nclass=\"widget-clabel\">Current</p></div><div flex><p class=\"widget-clabel\">Target</p></div></div><div \nlayout-gt-xs=\"row\"><div flex class=\"text-center\"><div class=\"flexin\"><p class=\"widget-hlabel\">\n{{hbf.initial_weight_log.weight_kg | number : 1}} kg</p><p class=\"widget-clabel\">\n{{hbf.initial_weight_log.wasting_score | number : 1}}</p><p class=\"ws-label wsnobg\">{{ hbf.initial_weight_log.code }}\n</p></div></div><div flex class=\"text-center\"><div class=\"flexin\"><p class=\"widget-hlabel\">\n{{ hbf.current_weight_log.weight_kg | number : 1}} kg</p><p class=\"widget-clabel\">\n{{hbf.current_weight_log.wasting_score | number : 1}}</p><p class=\"ws-label {{ hbf.condition.color }}\">\n{{ hbf.condition.code }} {{hbf.current_weight_log.status_name ? \"- \" + hbf.current_weight_log.status_name : \'\'}}</p>\n</div></div><div flex class=\"text-center\"><div class=\"flexin\"><p \nclass=\"widget-hlabel {{ hbf.current_wasting_score_diff >= 0 ? \'green\' : \'red\' }}\"><span \nng-show=\"hbf.current_weight_log.target_weight >= 0\"></span> {{ hbf.current_weight_log.target_weight | number : 1}} kg\n</p><p class=\"widget-vlabel {{ hbf.current_wasting_score_diff >= 0 ? \'green\' : \'red\' }}\"><span \nng-show=\"hbf.current_wasting_score_diff >= 0\">+</span> {{ hbf.current_wasting_score_diff | number : 1 }}</p><p \nclass=\"ws-flagged\" \nng-show=\"!hbf.is_discharged && !hbf.has_weight_increase && (hbf.has_missing_data || !hbf.has_nutripacks)\"><i \nclass=\"icon-flag-variant\"></i></p></div></div></div></div><div class=\"widget-footer\"><md-button md-no-ink \nclass=\"btn-secondary\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'health_coordinator\', \'health_trainer\', \'branch_head\'])\" \nng-click=\"vm.hardDeleteHbf(hbf)\">DELETE PERMANENTLY</md-button><md-button md-no-ink class=\"pull-right restore\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'health_coordinator\', \'health_trainer\', \'branch_head\', \'health_mentor\'])\" \nng-click=\"vm.restoreHbf(hbf)\">RESTORE</md-button></div></form></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/community/tabs/savings/savings.html","<div id=\"savings-tab-content\" class=\"savings-tab-content\"><form name=\"savingsGroupForm\" class=\"md-inline-form\" \nnovalidate ng-submit=\"vm.addNewApplication(vm.savings)\"><div layout-gt-xs=\"row\"><md-button \nclass=\"md-raised participant-btn\" \nng-show=\"!vm.community.savings_group && currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_coordinator\', \'livelihood_trainer\', \'health_trainer\', \'branch_head\', \'health_mentor\'])\" \nng-click=\"vm.addNonIcmParticipant()\">Add Non-ICM Participant</md-button><div class=\"right savings-btn\" \nng-show=\"!vm.community.savings_group\"><span \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_coordinator\', \'livelihood_trainer\', \'health_trainer\', \'branch_head\', \'health_mentor\'])\" \nng-click=\"vm.joinExistingGroup(vm.community)\">Join Existing Savings Group</span> <span class=\"group-details\" \nng-click=\"vm.openSavingsDetails(vm.community)\">Savings Group Details</span></div></div><div class=\"all-applications\">\n<h3 class=\"dropped-text\">Pastor</h3><table class=\"table mb-4\"><thead><tr><th>ID</th><th>Name</th><th>Role</th><th>\nSG Member Category</th></tr></thead><tbody><tr class=\"pastor\" ng-show=\"!vm.pastor.length && !vm.isLoading1\"><td \ncolspan=\"5\"><div class=\"text-center\">No pastors found.</div></td></tr><tr \nng-show=\"vm.isLoading1 && vm.pastor.length < 1\"><td colspan=\"5\"><div class=\"text-center\">Loading pastors list.</div>\n</td></tr><tr ng-repeat=\"pastor in vm.pastor\"><td>{{pastor.id}}</td><td>{{pastor.fullname}}</td><td>Pastor</td><td>\nICM Member</td></tr></tbody></table><h3 class=\"dropped-text\">Participant</h3><table class=\"table\"><thead><tr><th \nclass=\"participant-id\">Participant ID</th><th class=\"participant-name\">Name</th><th>DreamSave ID</th><th>Role</th><th>\nSG Member Category</th><th>Is Kid Saver?</th><th>Contact No.</th><th \nng-show=\"!vm.community.savings_group && currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_coordinator\', \'livelihood_trainer\', \'branch_head\', \'health_mentor\'])\">\n</th></tr></thead><tbody><tr ng-show=\"!vm.participants.length && !vm.isLoading\"><td colspan=\"6\"><div \nclass=\"text-center\">No participants.</div></td></tr><tr ng-show=\"vm.isLoading && vm.participants.length < 1\"><td \ncolspan=\"6\"><div class=\"text-center\">Loading participants.</div></td></tr><tr \nng-repeat=\"participant in vm.participants\" ng-show=\"!vm.isLoading\" ng-mouseover=\"participant.selected = true\" \nng-mouseleave=\"participant.selected = false\" \nng-class=\"{backgroundWhite: participant.selected, cursorNormal: !currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_coordinator\', \'livelihood_trainer\', \'branch_head\', \'health_mentor\'])}\">\n<td ng-click=\"vm.editContact(participant)\">{{participant.participant_id}}</td><td \nng-click=\"vm.editContact(participant)\"><i class=\"icon icon-gender-male\" ng-show=\"participant.gender === \'male\'\"></i> <i\n class=\"icon icon-gender-female\" ng-show=\"participant.gender === \'female\'\"></i> <i \nclass=\"icon icon-gender-male invisible\" ng-show=\"!participant.gender\"></i>\n {{participant.lastname}}, {{participant.firstname}}</td><td \nng-class=\"{cursorNormal: !currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_coordinator\', \'livelihood_trainer\', \'branch_head\', \'health_mentor\'])}\" \nng-click=\"vm.editDreamSaveID(participant)\">{{vm.formatNumber(participant.dreamsave)}}</td><td \nng-class=\"{\'orange-text\':\r\n                            participant.sg_role == \'leader\' ||\r\n                            participant.sg_role == \'secretary\' ||\r\n                            participant.sg_role == \'treasurer\' ||\r\n                            participant.sg_role == \'auditor\'}\" \nng-click=\"vm.editContact(participant)\">\n{{participant.sg_role === \'leader\' ? \'SG\' : \'\'}} {{participant.sg_role | capitalize}}</td><td><span \nng-show=\"participant.is_visitor || participant.is_non_icm_participant\">Non-ICM Member </span><span \nng-hide=\"participant.is_visitor || participant.is_non_icm_participant\"><span \nng-if=\"[\'counselor\', \'original\', \'original_replacement\', \'counselor_replacement\'].includes(participant.type)\">\nICM Member</span></span></td><td><i class=\"icon icon-check\" ng-show=\"participant.is_kid_saver\" style=\"color: #23A567\">\n</i></td><td class=\"pastor-click\" \nng-class=\"{cursorNormal: !currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_coordinator\', \'livelihood_trainer\', \'branch_head\', \'health_mentor\'])}\" \nng-click=\"vm.editContact(participant)\">{{participant.phone_number}}</td><td class=\"icons-container\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_coordinator\', \'livelihood_trainer\', \'branch_head\', \'health_mentor\']) && !vm.community.savings_group\">\n<md-menu md-position-mode=\"target-right target\"><i class=\"icon-account\" \nng-click=\"vm.openMenu($mdMenu, $event);\r\n                   $event.stopPropagation();\"><md-tooltip md-direction=\"left\">\nEdit Role</md-tooltip></i><md-menu-content width=\"3\"><md-menu-item ng-repeat=\"role in vm.roles\"><md-button \nng-click=\"vm.changeRole(participant, role)\">{{role.label}}</md-button></md-menu-item></md-menu-content></md-menu><i \nclass=\"icon-logout icon-red\" ng-click=\"vm.openLeaveSavingsGroupDialog(participant)\"><md-tooltip md-direction=\"left\">\nLeave the Savings Group</md-tooltip></i><i class=\"icon-trash\" \nng-click=\"vm.passwordConfirmation(participant);\r\n                   $event.stopPropagation();\"><md-tooltip \nmd-direction=\"left\">Drop Participant</md-tooltip></i></td></tr></tbody></table></div><h3 class=\"dropped-text\">Dropped\n</h3><div class=\"dropped-applications\"><div class=\"all-applications table-div\"><table class=\"table\"><thead><tr><th \nclass=\"participant-id\">Participant ID</th><th class=\"participant-name\">Name</th><th class=\"participant-reason\">\nReason for leaving</th><th class=\"participant-date\">Date Left</th><th class=\"participant-actions\"></th></tr></thead>\n<tbody><tr ng-show=\"!vm.trashedParticipants.length && !vm.isLoading2\"><td colspan=\"5\"><div class=\"text-center\">\nNo participants.</div></td></tr><tr ng-show=\"vm.isLoading2 && vm.trashedParticipants.length < 1\"><td colspan=\"5\"><div \nclass=\"text-center\">Loading participants.</div></td></tr><tr ng-repeat=\"participant in vm.trashedParticipants\" \nng-show=\"!vm.isLoading2\" ng-mouseover=\"participant.selected = true\" ng-mouseleave=\"participant.selected = false\" \nng-class=\"{backgroundWhite: participant.selected}\"><td>{{participant.participant_id}}</td><td><i \nclass=\"icon icon-gender-male\" ng-show=\"participant.gender === \'male\'\"></i> <i class=\"icon icon-gender-female\" \nng-show=\"participant.gender === \'female\'\"></i> <i class=\"icon icon-gender-male invisible\" \nng-show=\"!participant.gender\"></i> {{participant.lastname}}, {{participant.firstname}}</td><td>\n{{participant.reasons_for_leaving}}</td><td>{{participant.date_left | altDate}}</td><td><i \nclass=\"icon-refresh pull-right\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_coordinator\', \'livelihood_trainer\', \'branch_head\', \'health_mentor\'])\" \nng-click=\"vm.restoreParticipant(participant)\"><md-tooltip md-direction=\"left\">Restore Participant</md-tooltip></i></td>\n</tr></tbody></table></div></div></form></div>");
$templateCache.put("app/main/community/tabs/weekly/weekly.html","<div class=\"weekly-tab-content\"><div class=\"weekly-header\">Program Week</div><div class=\"weekly-table\"><table \nclass=\"table table-responsive\"><thead><tr class=\"t-head\"><th></th><th>1</th><th>2</th><th>3</th><th>4</th><th>5</th>\n<th>6</th><th>7</th><th>8</th><th>9</th><th>10</th><th>11</th><th>12</th><th>13</th><th>14</th><th>15</th><th>16</th>\n</tr></thead><tbody><tr ng-repeat=\"label in vm.labels\"><td class=\"label-count\">{{label.label}}</td><td class=\"weeks\" \nng-repeat=\"week in vm.weeks\"><div ng-if=\"label.type === \'text\' && label.excludes.indexOf($index + 1) === -1\"><input \nng-change=\"vm.updateWeeklyStats(label, week, label.data[week], vm)\" class=\"text-center\" type=\"number\" min=\"0\" \nng-show=\"!currentUser.$roles.has([\r\n                                   \'health_coordinator\', \'pastor_coordinator\',\r\n                                   \'livelihood_coordinator\', \'donor_services\',\r\n                                   \'donor_managers\', \'view_only\', \'area_head\',\r\n                                   \'national\'])\" \nng-model=\"label.data[week]\"> <span \nng-show=\"currentUser.$roles.has([\'health_coordinator\',\r\n                            \'pastor_coordinator\', \'livelihood_coordinator\',\r\n                            \'donor_services\', \'donor_managers\', \'view_only\',\r\n                            \'area_head\', \'national\'])\">\n{{label.data[week]}}</span></div><div ng-if=\"label.type === \'checkbox\' && label.excludes.indexOf($index + 1) === -1\">\n<div ng-show=\"!vm.weeklyObj[label.key][week]\" class=\"double-lesson\" \nng-class=\"{cursorNormal: currentUser.$roles.has([\r\n                                 \'health_coordinator\', \'pastor_coordinator\',\r\n                                 \'livelihood_coordinator\', \'donor_services\',\r\n                                 \'donor_managers\', \'view_only\', \'area_head\',\r\n                                 \'national\'])}\" \nng-click=\"vm.updateWeeklyStats(label, week, 1, vm)\"><i class=\"icon icon-check unchecked\"></i></div><div \nng-show=\"vm.weeklyObj[label.key][week]\" \nng-class=\"{cursorNormal: currentUser.$roles.has([\r\n                                 \'health_coordinator\', \'pastor_coordinator\',\r\n                                 \'livelihood_coordinator\', \'donor_services\',\r\n                                 \'donor_managers\', \'view_only\', \'area_head\',\r\n                                 \'national\'])}\" \nng-click=\"vm.updateWeeklyStats(label, week, 0, vm)\"><i class=\"icon icon-check checked\"></i></div></div></td></tr>\n</tbody></table></div><div class=\"graduates-num\"><span flex=\"30\">Graduates: <span class=\"total-graduates\">\n{{vm.weeklyAttendance.total_graduates}}</span></span> <span class=\"save-weekly\"><md-button type=\"submit\" \nclass=\"md-accent md-raised\" \nng-show=\"!currentUser.$roles.has([\r\n                         \'health_coordinator\', \'pastor_coordinator\',\r\n                         \'livelihood_coordinator\', \'donor_services\',\r\n                         \'donor_managers\', \'view_only\', \'area_head\',\r\n                         \'national\'])\" \nng-click=\"vm.saveWeeklyStats()\" ng-disabled=\"vm.saving || !vm.hasEdited\"><span ng-show=\"vm.saving\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Saving.. </span><span \nng-show=\"!vm.saving\">Save</span></md-button></span></div></div>");
$templateCache.put("app/main/community-savings-group/tabs/members/members.html","<style>\n.head-text {\r\n        font-weight: bold;\r\n        color: #454545;\r\n        margin-bottom: 20px;\r\n        margin-left: 16px;\r\n    }\n</style><div class=\"savings-tab-content\"><md-button class=\"md-raised participant-btn\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_coordinator\'])\" ng-click=\"vm.addNonIcmParticipant()\">\nAdd Non-ICM Participant</md-button><div class=\"all-applications\"><h3 class=\"head-text\">Pastor</h3><table \nclass=\"table mb-4\"><thead><tr><th>ID</th><th>Name</th><th>Role</th><th>SG Member Category</th></tr></thead><tbody><tr \nclass=\"pastor\" ng-show=\"!vm.pastor.length && !vm.isLoading1\"><td colspan=\"5\"><div class=\"text-center\">No pastors found.\n</div></td></tr><tr ng-show=\"vm.isLoading1 && vm.pastor.length < 1\"><td colspan=\"5\"><div class=\"text-center\">\nLoading pastors list.</div></td></tr><tr ng-repeat=\"pastor in vm.pastor\"><td>{{pastor.id}}</td><td>{{pastor.fullname}}\n</td><td>Pastor</td><td>ICM Member</td></tr></tbody></table><h3 class=\"dropped-text\">Participant</h3><table \nclass=\"table\"><thead><tr><th class=\"width-15-percent\">Community ID</th><th class=\"width-15-percent\">Participant ID</th>\n<th class=\"pl-35\">Name</th><th class=\"pl-35\">DreamSave ID</th><th>Role</th><th>SG Member Category</th><th>Is Kid Saver?\n</th><th>Contact No.</th><th></th></tr></thead><tbody><tr ng-show=\"!vm.participants.length && !vm.isLoading\"><td \ncolspan=\"6\"><div class=\"text-center\">No participants.</div></td></tr><tr \nng-show=\"vm.isLoading && vm.participants.length < 1\"><td colspan=\"6\"><div class=\"text-center\">Loading participants.\n</div></td></tr><tr ng-repeat=\"participant in vm.participants\" ng-show=\"!vm.isLoading\" \nng-mouseover=\"participant.selected = true\" ng-mouseleave=\"participant.selected = false\" \nng-class=\"{backgroundWhite: participant.selected}\"><td ng-click=\"vm.editContact(participant)\">\n{{participant.community.community_id}}</td><td ng-click=\"vm.editContact(participant)\">{{participant.participant_id}}\n</td><td ng-click=\"vm.editContact(participant)\"><i class=\"icon icon-gender-male members-male\" \nng-show=\"participant.gender === \'male\'\"></i> <i class=\"icon icon-gender-female members-female\" \nng-show=\"participant.gender === \'female\'\"></i> <i class=\"icon icon-gender-male invisible\" \nng-show=\"!participant.gender\"></i> {{participant.lastname}}, {{participant.firstname}}</td><td \nng-click=\"vm.editDreamSaveID(participant)\">{{vm.formatNumber(participant.dreamsave)}}</td><td \nng-class=\"{\'orange-text\':\r\n                    participant.sg_role == \'leader\' ||\r\n                    participant.sg_role == \'secretary\' ||\r\n                    participant.sg_role == \'treasurer\' ||\r\n                    participant.sg_role == \'auditor\'}\" \nng-click=\"vm.editContact(participant)\">\n{{participant.sg_role === \'leader\' ? \'SG\' : \'\'}} {{participant.sg_role | capitalize}}</td><td><span \nng-show=\"participant.is_visitor || participant.is_non_icm_participant\">Non-ICM Member </span><span \nng-hide=\"participant.is_visitor || participant.is_non_icm_participant\"><span \nng-if=\"[\'counselor\', \'original\', \'original_replacement\', \'counselor_replacement\'].includes(participant.type)\">\nICM Member</span></span></td><td><i class=\"icon icon-check\" ng-show=\"participant.is_kid_saver\" style=\"color: #23A567\">\n</i></td><td class=\"pastor-click\" ng-click=\"vm.editContact(participant)\">{{participant.phone_number}}</td><td \nclass=\"icons-container\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\',\r\n                \'livelihood_coordinator\'])\"><md-menu \nmd-position-mode=\"target-right target\"><i class=\"icon-account\" \nng-click=\"vm.openMenu($mdMenu, $event);\r\n                   $event.stopPropagation();\"><md-tooltip md-direction=\"left\">\nEdit Role</md-tooltip></i><md-menu-content width=\"3\"><md-menu-item ng-repeat=\"role in vm.roles\"><md-button \nng-click=\"vm.changeRole(participant, role)\">{{role.label}}</md-button></md-menu-item></md-menu-content></md-menu><i \nclass=\"icon-logout icon-red\" ng-click=\"vm.openLeaveSavingsGroupDialog(participant)\"><md-tooltip md-directoin=\"left\">\nLeave the Savings Group</md-tooltip></i><i class=\"icon-trash\" \nng-click=\"vm.passwordConfirmation(participant);\r\n                   $event.stopPropagation();\"><md-tooltip \nmd-direction=\"left\">Drop Participant</md-tooltip></i></td></tr></tbody></table></div><h3 class=\"dropped-text\">Dropped\n</h3><div class=\"dropped-applications\"><div class=\"all-applications table-div\"><table class=\"table\"><thead><tr><th \nclass=\"width-15-percent\">Community ID</th><th class=\"width-15-percent\">Participant ID</th><th class=\"pl-35\">Name</th>\n<th>Reason for Leaving</th><th>Date Left</th><th>&nbsp;</th></tr></thead><tbody><tr \nng-show=\"!vm.trashedParticipants.length && !vm.isLoading2\"><td colspan=\"6\"><div class=\"text-center\">No participants.\n</div></td></tr><tr ng-show=\"vm.isLoading2 && vm.trashedParticipants.length < 1\"><td colspan=\"6\"><div \nclass=\"text-center\">Loading participants.</div></td></tr><tr ng-repeat=\"participant in vm.trashedParticipants\" \nng-show=\"!vm.isLoading2\" ng-mouseover=\"participant.selected = true\" ng-mouseleave=\"participant.selected = false\" \nng-class=\"{backgroundWhite: participant.selected}\"><td>{{participant.community.community_id}}</td><td>\n{{participant.participant_id}}</td><td><i class=\"icon icon-gender-male members-male\" \nng-show=\"participant.gender === \'male\'\"></i> <i class=\"icon icon-gender-female members-female\" \nng-show=\"participant.gender === \'female\'\"></i> <i class=\"icon icon-gender-male invisible\" \nng-show=\"!participant.gender\"></i> {{participant.lastname}}, {{participant.firstname}}</td><td>\n{{participant.reasons_for_leaving}}</td><td>{{participant.date_left | altDate}}</td><td><i \nclass=\"icon-refresh pull-right members-refresh\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_coordinator\'])\" \nng-click=\"vm.restoreParticipant(participant)\"><md-tooltip md-direction=\"left\">Restore Participant</md-tooltip></i></td>\n</tr></tbody></table></div></div></div>");
$templateCache.put("app/main/community-savings-group/tabs/savings-group-data/savings-group-data.html","<div><div layout-gt-xs=\"row\"><div class=\"transform-white\"><md-tabs id=\"community-details-tabs\" \nmd-selected=\"currentTab\" md-dynamic-height md-border-bottom><md-tab \nui-sref=\"app.savings-group-community.savings-group-data\" ng-repeat=\"year in vm.tab_datas\" \nng-click=\"vm.filterSavingsGroupData(year)\"><md-tab-label>{{year}}</md-tab-label></md-tab></md-tabs></div></div><div \nlayout-gt-xs=\"row\"><table class=\"savings-group-data-table-labels mb-25\"><thead><tr><th rowspan=\"2\" \nclass=\"table-header-button-container labels\"><md-button class=\"md-raised new-application\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_coordinator\', \'branch_head\'])\" \nng-click=\"vm.addSGData()\">New SG Data</md-button></th></tr></thead><tbody><tr><td class=\"labels\">Attendance</td></tr>\n<tr><td class=\"labels\">Engagement</td></tr><tr><td class=\"labels\"><span class=\"head-title\">SG Membership</span></td>\n</tr><tr><td class=\"labels\"><span class=\"sub-title\">ICM Participant</span></td></tr><tr><td class=\"labels\"><span \nclass=\"sub-title\">Non-ICM Participant</span></td></tr><tr><td class=\"labels\"><span class=\"sub-title\">Male</span></td>\n</tr><tr><td class=\"labels\"><span class=\"sub-title\">Female</span></td></tr><tr ng-repeat=\"amount in vm.amounts\"><td \nclass=\"labels\">{{amount.label}}</td></tr><tr><td class=\"labels\"><span class=\"head-title\">Partnerships</span></td></tr>\n<tr ng-repeat=\"partner in vm.savings.partners\"><td class=\"labels\"><span class=\"sub-title\">{{partner.name}}</span></td>\n</tr></tbody></table><table class=\"savings-group-data-table-values mb-25\" ms-scroll><thead><tr><th rowspan=\"2\" \nclass=\"text-center pl-5 pr-5\" \nng-class=\"{\'nocursor\': vm.currentUser.$roles.has([\'health_coordinator\', \'health_trainer\', \'livelihood_trainer\', \'health_mentor\'])}\" \nng-click=\"vm.editSGData(data)\" ng-repeat=\"data in vm.datas\"><div>{{data.month | uppercase}}</div><div>{{data.year}}\n</div></th></tr></thead><tbody><tr><td class=\"sg-data attendance-data text-center\" ng-click=\"vm.checkAttendance(data)\" \nng-class=\"{\'nocursor\': vm.currentUser.$roles.has([\'health_coordinator\', \'health_trainer\', \'livelihood_trainer\', \'health_mentor\'])}\" \nng-repeat=\"data in vm.datas\"><i class=\"icon icon-check\" ng-class=\"{\'icon-show\': data.attended}\"></i></td></tr><tr><td \nclass=\"sg-data text-center\" ng-repeat=\"data in vm.datas\">{{data.type_of_attendance}}</td></tr><tr><td \nclass=\"sg-data text-center\" ng-repeat=\"data in vm.datas\"></td></tr><tr><td class=\"sg-data text-center\" \nng-repeat=\"data in vm.datas\">{{data.total_icm_participants || 0}}</td></tr><tr><td class=\"sg-data text-center\" \nng-repeat=\"data in vm.datas\">{{data.total_non_icm_participants || 0}}</td></tr><tr><td class=\"sg-data text-center\" \nng-repeat=\"data in vm.datas\">{{data.total_male_participants || 0}}</td></tr><tr><td class=\"sg-data text-center\" \nng-repeat=\"data in vm.datas\">{{data.total_female_participants || 0}}</td></tr><tr ng-repeat=\"amount in vm.amounts\"><td \nclass=\"sg-data text-center\" ng-repeat=\"data in vm.datas\">\n{{amount.label === \'Number of Kid Savers\' ? data.total_kid_saver_participants || 0 : data[amount.key] || 0}}</td></tr>\n<tr><td ng-repeat=\"data in vm.datas\"></td></tr><tr ng-repeat=\"partner in vm.savings.partners\"><td \nng-repeat=\"data in vm.datas\" ng-class=\"{\'green-background\': $index < partner.no_of_months}\"></td></tr></tbody></table>\n</div></div>");
$templateCache.put("app/main/flourish/tabs/chc/chc.html","<div layout=\"row\" class=\"filters-container\"><md-button class=\"md-raised new-application\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'pastor_coordinator\', \'branch_head\'])\" ng-click=\"vm.addNewChc()\">\nNew CHC</md-button><md-input-container class=\"md-block select-container disabled-input\" flex=\"10\"><label>Total Gold\n</label><input ng-model=\"vm.total_gold\" disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-block select-container disabled-input\" flex=\"10\"><label>Total Silver</label><input \nng-model=\"vm.total_silver\" disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-block select-container disabled-input\" flex=\"10\"><label>Total Bronze</label><input \nng-model=\"vm.total_bronze\" disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-block select-container disabled-input\" flex=\"10\"><label>Total Inactive</label><input \nng-model=\"vm.total_inactive\" disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-block select-container disabled-input\" flex=\"10\"><label>Total Pastors</label><input \nng-model=\"vm.total_pastors\" disabled=\"disabled\"></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block mb-0\" flex=\"20\"><input name=\"search\" ng-model=\"vm.filters.search\" \nng-change=\"vm.selectSearch(vm.filters)\" ng-model-options=\"{debounce: 300}\" placeholder=\"Search Pastor’s Name or ID\" \ntype=\"text\"></md-input-container><md-input-container class=\"md-block select-container mb-0\" flex=\"20\"><label>Base\n</label><md-select ng-model=\"vm.filters.base\" ng-model-options=\"{ trackBy: \'$value.id\' }\" class=\"fs-16\" \nng-change=\"vm.selectBase(vm.filters)\" ng-disabled=\"currentUser.base_id || vm.isLoading\"><md-option value=\"all\">\nAll Bases</md-option><md-option ng-value=\"base\" ng-repeat=\"base in vm.bases\">{{base.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block select-container mb-0\" flex=\"20\"><label>Branch</label>\n<md-select ng-disabled=\"!vm.filters.base.branches.length || currentUser.branch_id || vm.isLoading\" \nng-model=\"vm.filters.branch\" ng-model-options=\"{ trackBy: \'$value.id\' }\" class=\"fs-16\" \nng-change=\"vm.selectBranch(vm.filters)\" placeholder=\"Branch\"><md-option value=\"all\">All Branches</md-option><md-option \nng-value=\"branch\" ng-repeat=\"branch in vm.filters.base.branches\">{{ branch.name }}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block margin-right-15 mb-0\" flex=\"20\"><label>District</label>\n<md-select class=\"fs-16\" ng-disabled=\"!vm.districts.length || vm.isLoading\" ng-model=\"vm.filters.district\" \nng-change=\"vm.selectDistrict(vm.filters)\" placeholder=\"All Districts\"><md-option value=\"all\">All Districts</md-option>\n<md-option ng-value=\"district.id\" ng-repeat=\"district in vm.districts\">{{district.base.name}} - {{ district.name }}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block margin-right-15\" flex=\"20\"><md-button \nclass=\"md-raised new-application\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'pastor_coordinator\', \'branch_head\'])\" \nng-click=\"vm.resetFilters()\">Reset</md-button></md-input-container></div><div class=\"all-applications pastors-table\">\n<table class=\"table\"><thead><tr><th>ID</th><th>Name</th><th>District</th><th>Status</th><th>&nbsp;</th></tr></thead>\n<tbody><tr class=\"pastor\" ng-show=\"!vm.pastorsList.data.length && !vm.isLoading1\"><td colspan=\"5\"><div \nclass=\"text-center\">No pastors found.</div></td></tr><tr ng-show=\"vm.isLoading1 && vm.pastorsList.length < 1\"><td \ncolspan=\"5\"><div class=\"text-center\">Loading pastors list.</div></td></tr><tr \nng-repeat=\"pastor in vm.pastorsList.data\" ng-mouseover=\"pastor.selected = true\" \nng-mouseleave=\"pastor.selected = false\" ng-class=\"{backgroundWhite: pastor.selected}\"><td>11655</td><td>Dwight ariston\n</td><td>Cebu - Area - 7</td><td>Active - Bronze</td><td class=\"icons-container\"><i class=\"icon-menu\" \nng-click=\"vm.showPastorDetails(pastor);\r\n                   $event.stopPropagation();\"><md-tooltip md-direction=\"left\">\nView Pastor Details</md-tooltip></i><i class=\"icon-pencil\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'pastor_coordinator\', \'branch_head\'])\" \nng-click=\"vm.editPastor(pastor); $event.stopPropagation();\"><md-tooltip md-direction=\"left\">Edit CHC</md-tooltip></i><i\n class=\"icon-trash\" ng-show=\"currentUser.$roles.has([\'admin\'])\" \nng-click=\"vm.deletePastor(pastor); $event.stopPropagation();\"><md-tooltip md-direction=\"left\">Drop Pastor</md-tooltip>\n</i></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!vm.isLoading1\"><pagination \nitems=\"vm.pastorsList\" callback=\"vm.pageChange(vm.pastorsList.current_page, vm.filters)\"></pagination></div></div>");
$templateCache.put("app/main/flourish/tabs/cluster/cluster.html","<h1>Cluster</h1>");
$templateCache.put("app/main/flourish/tabs/datacard/datacard.html","<div class=\"datacard-tab-content\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflex-gt-md=\"50\" flex-gt-sm=\"50\" flex-gt-xs=\"100\"><ms-widget-front class=\"padding-16 ,d-white-bg\"><form \nname=\"flourishForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.addNewflourishCard(vm.flourish, flourishForm)\"><h2 \nclass=\"datacard-title\">Flourish Data Card</h2><md-input-container class=\"md-block datepicker mt-0 mb-0\"><h6>\nFlourish Date</h6><md-datepicker ng-model=\"vm.flourish.attended_at\" name=\"flourishdate\" md-open-on-focus required \nmd-placeholder=\"Enter date\" md-input-name=\"flourishdate\" \nng-disabled=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\"></md-datepicker><div class=\"errors\" \nng-messages=\"flourishForm.flourishdate.$error || vm.apiErrors.attended_at\" \nng-hide=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\"><div ng-message=\"valid\" class=\"date-error\">\nThe entered value is not a date!</div><div ng-message=\"required\" class=\"date-error\">This date is required!</div><div \nng-bind=\"vm.apiErrors.attended_at\"></div></div></md-input-container><div layout-gt-xs=\"row\"><md-autocomplete flex \nrequired md-input-name=\"pastor\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedPastor\" \nmd-selected-item-change=\"vm.selectPastor(pastor)\" md-search-text=\"vm.searchPastorName\" \nmd-search-text-change=\"vm.searchPastorChange(vm.searchPastorName)\" \nmd-items=\"pastor in vm.searchPastors(vm.searchPastorName)\" \nmd-item-text=\"pastor.firstname+\' \'+pastor.lastname+ \' (\' +pastor.id+ \')\'\" md-require-match \nmd-floating-label=\"Pastor Name or ID\" ng-disabled=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\">\n<md-item-template><table><td width=\"100px\">{{pastor.id}}</td><td width=\"100px\">\n{{pastor.is_active ? \'Active\' : \'Inactive\'}} {{pastor.member_status ? \' - \' + pastor.member_status : \'\'}}</td><td \nwidth=\"170px\">{{pastor.firstname}} {{pastor.lastname}}</td></table></md-item-template><div class=\"errors\" \nng-messages=\"flourishForm.pastor.$error\" ng-if=\"flourishForm.pastor.$touched  || flourishForm.$submitted\" \nng-hide=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\"><div ng-message=\"md-require-match\">\nPlease select an existing pastor.</div><div ng-message=\"required\">Required</div></div></md-autocomplete>\n<md-input-container class=\"md-block\" flex-gt-xs><input name=\"base\" ng-model=\"vm.flourish.base\" ng-disabled=\"true\" \nplaceholder=\"Base - District\"></md-input-container></div><h6 style=\"margin:0px\">Group Assignment</h6><div \nlayout-gt-xs=\"row\"><md-select class=\"\" flex=\"50\" ng-model=\"vm.thrive.group_leader_id\" ng-disabled=\"\" \nstyle=\"font-size:12px;margin-top: 10px\" placeholder=\"Select Group Assignment\" disableoptioncentering><md-optgroup \nlabel=\" Select Group Assignment\"><md-option value=\"0\" ng-style=\"!vm.pastor.group_leader && {\'font-weight\':\'700\'}\">\nUnassign</md-option><md-option value=\"1\" \nng-style=\"vm.pastor.group_leader && !vm.pastor.data_card_member  && { \'font-weight\':\'700\'} \">Group Facilitator\n</md-option><md-option ng-if=\"vm.selectedBaseNames.length > 0\" \nng-style=\"vm.pastor.group_leader && vm.pastor.data_card_member && { \'font-weight\':\'700\'} \" \nng-repeat=\"member in vm.selectedBaseNames\" value=\"member\">\nMember - {{member.firstname + \' \' + member.lastname }} ({{member.id}})</md-option></md-optgroup></md-select></div><div>\n<table class=\"table mb-0\"><tr><td style=\"border-top: none\" class=\"v-middle\">Attendance:</td><td \nstyle=\"border-top: none\"><md-input-container class=\"md-block mb-0 mt-0\"><md-radio-group layout=\"row\" required \nname=\"attendance\" ng-disabled=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\"><md-checkbox \nng-model=\"vm.flourish.is_meeting\" class=\"ml-16\">Meeting</md-checkbox><md-checkbox ng-model=\"vm.flourish.is_training\" \nclass=\"ml-16\">Training</md-checkbox></md-radio-group><div ng-messages=\"flourishForm.attendance.$error\" \nng-show=\"flourishForm.attendance.$touched || flourishForm.$submitted\" role=\"alert\"><div ng-message=\"required\" \nng-hide=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\"><span>Required</span></div></div>\n</md-input-container></td></tr><tr><td class=\"v-middle\">How many Lay Leaders did you bring?</td><td><md-input-container\n class=\"md-block mb-0\"><input name=\"timothys\" ng-model=\"vm.flourish.no_of_timothy\" type=\"number\" min=\"0\" \nng-disabled=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\"><div \nng-messages=\"flourishForm.timothys.$error\" \nng-show=\"flourishForm.timothys.$touched\r\n                                             || flourishForm.$submitted\" \nrole=\"alert\" ng-hide=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\"><div ng-message=\"required\">\n<span>Required</span></div><div ng-message=\"number\"><span>Invalid number</span></div><div ng-message=\"min\">\nInvalid number</div></div></md-input-container></td></tr><tr><td class=\"v-middle\">How many adults attended last Sunday?\n</td><td><md-input-container class=\"md-block mb-0\"><input name=\"adults\" ng-model=\"vm.flourish.adults_last_sunday\" \ntype=\"number\" min=\"0\" ng-disabled=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\"><div \nng-messages=\"flourishForm.adults.$error\" \nng-show=\"flourishForm.adults.$touched\r\n                                             || flourishForm.$submitted\" \nrole=\"alert\" ng-hide=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\"><div ng-message=\"required\">\n<span>Required</span></div><div ng-message=\"number\"><span>Invalid number</span></div><div ng-message=\"min\">\nInvalid number</div></div></md-input-container></td></tr><tr><td class=\"v-middle\">\nHow many kids(13 and under) attended last Sunday?</td><td><md-input-container class=\"md-block mb-0\"><input name=\"kids\" \nng-model=\"vm.flourish.kids_last_sunday\" type=\"number\" min=\"0\" \nng-disabled=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\"><div \nng-messages=\"flourishForm.kids.$error\" \nng-show=\"flourishForm.kids.$touched\r\n                                             || flourishForm.$submitted\" \nng-hide=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\" role=\"alert\"><div ng-message=\"required\">\n<span>Required</span></div><div ng-message=\"number\"><span>Invalid number</span></div><div ng-message=\"min\">\nInvalid number</div></div></md-input-container></td></tr><tr><td class=\"v-middle\">\nWhat was the total offering last Sunday?</td><td><md-input-container class=\"md-block mb-0\"><input name=\"offering\" \nng-model=\"vm.flourish.offerings_last_sunday\" type=\"number\" min=\"0\" \nng-disabled=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\" maxlength=\"8\"><div \nng-messages=\"flourishForm.offering.$error\" \nng-show=\"flourishForm.offering.$touched\r\n                                             || flourishForm.$submitted\" \nng-hide=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\" role=\"alert\"><div ng-message=\"required\">\n<span>Required</span></div><div ng-message=\"number\"><span>Invalid number</span></div><div ng-message=\"min\">\nInvalid number</div><div ng-message=\"maxlength\">Exceeds limit</div></div></md-input-container></td></tr><tr><td \nclass=\"v-middle\">Attended flourish Health Check</td><td><md-checkbox class=\"ml-16\" ng-model=\"vm.flourish.health_check\">\n</md-checkbox></td></tr></table></div><div class=\"mt-10\"><md-button md-no-ink type=\"reset\" \nng-click=\"vm.resetForm(flourishForm, vm)\" \nng-disabled=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\" class=\"md-primary cancel-button\" \naria-label=\"CLEAR\">CLEAR</md-button><md-button type=\"submit\" \nng-disabled=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\']) || flourishForm.$invalid\r\n                                   || flourishForm.$pristine || vm.saving || (!vm.flourish.is_meeting && !vm.flourish.is_training)\" \nclass=\"md-accent md-raised pull-right\"><span ng-show=\"!vm.saving\">SAVE</span> <span ng-show=\"vm.saving\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting</span></md-button>\n</div></form></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/flourish/tabs/mcp/mcp.html","<div layout=\"row\" class=\"filters-container\"><md-button class=\"md-raised new-application\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'pastor_coordinator\', \'branch_head\'])\" ng-click=\"vm.addNewCase()\">\nNew Case</md-button><md-input-container class=\"md-block select-container disabled-input\" flex=\"10\"><label>Total Gold\n</label><input ng-model=\"vm.total_gold\" disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-block select-container disabled-input\" flex=\"10\"><label>Total Silver</label><input \nng-model=\"vm.total_silver\" disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-block select-container disabled-input\" flex=\"10\"><label>Total Bronze</label><input \nng-model=\"vm.total_bronze\" disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-block select-container disabled-input\" flex=\"10\"><label>Total Inactive</label><input \nng-model=\"vm.total_inactive\" disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-block select-container disabled-input\" flex=\"10\"><label>Total Pastors</label><input \nng-model=\"vm.total_pastors\" disabled=\"disabled\"></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block mb-0\" flex=\"20\"><input name=\"search\" ng-model=\"vm.filters.search\" \nng-change=\"vm.selectSearch(vm.filters)\" ng-model-options=\"{debounce: 300}\" placeholder=\"Search Pastor’s Name or ID\" \ntype=\"text\"></md-input-container><md-input-container class=\"md-block select-container mb-0\" flex=\"20\"><label>Base\n</label><md-select ng-model=\"vm.filters.base\" ng-model-options=\"{ trackBy: \'$value.id\' }\" class=\"fs-16\" \nng-change=\"vm.selectBase(vm.filters)\" ng-disabled=\"currentUser.base_id || vm.isLoading\"><md-option value=\"all\">\nAll Bases</md-option><md-option ng-value=\"base\" ng-repeat=\"base in vm.bases\">{{base.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block select-container mb-0\" flex=\"20\"><label>Branch</label>\n<md-select ng-disabled=\"!vm.filters.base.branches.length || currentUser.branch_id || vm.isLoading\" \nng-model=\"vm.filters.branch\" ng-model-options=\"{ trackBy: \'$value.id\' }\" class=\"fs-16\" \nng-change=\"vm.selectBranch(vm.filters)\" placeholder=\"Branch\"><md-option value=\"all\">All Branches</md-option><md-option \nng-value=\"branch\" ng-repeat=\"branch in vm.filters.base.branches\">{{ branch.name }}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block margin-right-15 mb-0\" flex=\"20\"><label>District</label>\n<md-select class=\"fs-16\" ng-disabled=\"!vm.districts.length || vm.isLoading\" ng-model=\"vm.filters.district\" \nng-change=\"vm.selectDistrict(vm.filters)\" placeholder=\"All Districts\"><md-option value=\"all\">All Districts</md-option>\n<md-option ng-value=\"district.id\" ng-repeat=\"district in vm.districts\">{{district.base.name}} - {{ district.name }}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block margin-right-15\" flex=\"20\"><md-button \nclass=\"md-raised new-application\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'pastor_coordinator\', \'branch_head\'])\" \nng-click=\"vm.resetFilters()\">Reset</md-button></md-input-container></div><div class=\"clearfix bt pb-15 mt-15\">\n<ms-widget layout=\"column\" class=\"col-lg-4 col-md-4 col-sm-6\"><ms-widget-front class=\"white-bg widget-container\"><form \nname=\"hbfForm\" class=\"md-inline-form\" novalidate><div class=\"widget-header\"><div class=\"row text-center\"><div \nclass=\"photos text-center\" style=\"display: inline-block\"><md-input-container class=\"photo-container md-block\" \nstyle=\"display: inline-block\"><p class=\"start-photo\" \nstyle=\"color: #aaa;\r\n                                font-size: 11px;\r\n                                margin-bottom: 0px;\r\n                                margin-top: 0\">\nStart Photo</p><div class=\"photo-thumb\" \nstyle=\"background-image: url(\'http://via.placeholder.com/200x200/ffffff/4575BE?text=UPLOAD\'); width: 100px;\r\n                                height: 100px;\r\n                                border: 1px solid #C2C2C2;\r\n                                background-size: cover;\r\n                                background-position: center center;\r\n                                position: relative\" \nng-mouseenter=\"hbf.before_photo_hover = true\" ng-mouseleave=\"hbf.before_photo_hover = false\" \nng-click=\"hbf.before_photo ? vm.showLightBox(hbf.before_photo_url, $event) : vm.replacePhoto(hbf, \'before\')\"><md-menu \nclass=\"photo-actions\" \nstyle=\"position: absolute;\r\n                                    bottom: 0;\r\n                                    right: 0;\r\n                                    background-color: white;\r\n                                    padding: 3px 5px\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'health_coordinator\', \'health_trainer\', \'branch_head\']) && hbf.before_photo && hbf.before_photo_hover\" \nng-mouseenter=\"hbf.before_photo_hover = true\" ng-mouseleave=\"hbf.before_photo_hover = false\"><md-button \nclass=\"md-icon-button\" ng-mouseenter=\"$mdMenu.open()\"><i class=\"icon icon-dots-vertical s20\"></i></md-button>\n<md-menu-content width=\"2\" ng-mouseleave=\"$mdMenu.close()\"><md-menu-item><md-button \nng-click=\"vm.replacePhoto(hbf, \'before\')\">Replace</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.removePhoto(hbf, \'before\', $event)\">Delete</md-button></md-menu-item></md-menu-content></md-menu></div>\n</md-input-container></div><div class=\"photos text-center\" style=\"display: inline-block\"><md-input-container \nclass=\"photo-container md-block\" style=\"display: inline-block\"><p class=\"start-photo\" \nstyle=\"color: #aaa;\r\n                                font-size: 11px;\r\n                                margin-bottom: 0;\r\n                                margin-top: 0\">\nEnd Photo</p><div class=\"photo-thumb\" \nstyle=\"background-image: url(\'http://via.placeholder.com/200x200/ffffff/4575BE?text=UPLOAD\'); width: 100px;\r\n                                height: 100px;\r\n                                border: 1px solid #C2C2C2;\r\n                                background-size: cover;\r\n                                background-position: center center; \r\n                                position: relative\" \nng-mouseenter=\"hbf.after_photo_hover = true\" ng-mouseleave=\"hbf.after_photo_hover = false\" \nng-click=\"hbf.after_photo ? vm.showLightBox(hbf.after_photo_url, $event) : vm.replacePhoto(hbf, \'after\')\"><md-menu \nclass=\"photo-actions\" \nstyle=\"position: absolute;\r\n                                    bottom: 0;\r\n                                    right: 0;\r\n                                    background-color: white;\r\n                                    padding: 3px 5px\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'health_coordinator\', \'health_trainer\', \'branch_head\']) && hbf.after_photo && hbf.after_photo_hover\" \nng-mouseenter=\"hbf.after_photo_hover = true\" ng-mouseleave=\"hbf.after_photo_hover = false\"><md-button \nclass=\"md-icon-button\" ng-mouseenter=\"$mdMenu.open()\"><i class=\"icon icon-dots-vertical s20\"></i></md-button>\n<md-menu-content width=\"2\" ng-mouseleave=\"$mdMenu.close()\"><md-menu-item><md-button \nng-click=\"vm.replacePhoto(hbf, \'after\')\">Replace</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.removePhoto(hbf, \'after\', $event)\">Delete</md-button></md-menu-item></md-menu-content></md-menu></div>\n</md-input-container></div></div><div class=\"row mt-16\"><div class=\"col-md-6 col-sm-6 col-xs-6\" \nstyle=\"padding-left: 25px\"><div class=\"widget-clabel\" \nstyle=\"font-size: 11px;\r\n                            color: gray;\r\n                            margin-bottom: 0\">\nChild\'s Name<div class=\"contentover\" contentover style=\"display: inline-block\"><span \nclass=\"icon icon-information ml-10\" \nstyle=\"font-size: 13px;\r\n                                    color: #386BBA;\r\n                                    icon: pointer\">\n</span><div class=\"co contentover-guardian-info\" \nstyle=\"width: 210px;\r\n                                    border: 1px solid #ccc;;\r\n                                    padding: 10px\">\n<div class=\"ctgcol\"><p class=\"widget-clabel\" \nstyle=\"font-size: 11px;\r\n                                            color: gray;\r\n                                            margin-bottom: 0;\r\n                                            text-align: left\">\nGuardian</p><p class=\"widget-vlabel\" \nstyle=\"text-transform: capitalize;\r\n                                            font-size: 13px;\r\n                                            color: #000;\r\n                                            text-align: left\">\n{{hbf.participant ? hbf.participant.fullname : hbf.guest_name}} - {{hbf.relationship | capitalize}}</p></div><div \nclass=\"ctgcol\"><p class=\"widget-clabel\" \nstyle=\"font-size: 11px;\r\n                                            color: gray;\r\n                                            margin-bottom: 0;\r\n                                            text-align: left\">\nContact No</p><p class=\"widget-vlabel\" \nstyle=\"text-transform: capitalize;\r\n                                            font-size: 13px;\r\n                                            color: #000;\r\n                                            text-align: left\">\n{{hbf.contact_no || \'--\'}}</p></div></div></div></div><p class=\"widget-vlabel\" \nstyle=\"text-transform: capitalize;\r\n                            font-size: 13px;\r\n                            color: #000\">\n{{hbf.child_firstname}} {{hbf.child_lastname}}</p></div><div class=\"col-md-6 col-sm-6 col-xs-6\"><p \nclass=\"widget-clabel\" \nstyle=\"font-size: 11px;\r\n                                            color: gray;\r\n                                            margin-bottom: 0\">\nGender</p><p class=\"widget-vlabel\" \nstyle=\"text-transform: capitalize;\r\n                            font-size: 13px;\r\n                            color: #000\">\n{{ hbf.gender }}</p></div></div><div class=\"row\"><div class=\"col-md-6 col-sm-6 col-xs-6\" style=\"padding-left: 25px\"><p \nclass=\"widget-clabel\" \nstyle=\"font-size: 11px;\r\n                                            color:gray;\r\n                                            margin-bottom: 0\">\nAge</p><p class=\"widget-vlabel\" \nstyle=\"text-transform: capitalize;\r\n                            font-size: 13px;\r\n                            color: #000\">\n{{ hbf.age }}</p></div><div class=\"col-md-6 col-sm-6 col-xs-6\"><p class=\"widget-clabel\" \nstyle=\"font-size: 11px;\r\n                                            color: gray;\r\n                                            margin-bottom: 0\">\nDate of Weighing</p><p class=\"widget-vlabel mb-0\" \nstyle=\"text-transform: capitalize;\r\n                            font-size: 13px;\r\n                            color: #000\">\n</p></div></div></div><div class=\"widget-body\" \nstyle=\"margin-top:5px;\r\n                font-size: 19px;\r\n                color:rgb(99, 96, 96)\"><p \nclass=\"widget-hrlabel\" \nstyle=\"border-bottom: 1px solid rgb(63, 56, 56);\r\n                    text-align: center;\r\n                    height: 10px;\r\n                    margin-top: 10px;\r\n                    font-size: 12px;\r\n                    font-weight: bold;\r\n                    margin-bottom: 15px\">\n<span style=\"background: white;\r\n        padding: 0 5px;\r\n        color: #000\">Status Overview</span></p><div \nlayout-gt-xs=\"row\" class=\"widget-shlabels\" style=\"text-align: center\"><div flex><p class=\"widget-clabel\" \nstyle=\"font-size: 11px;\r\n                                            color: gray;\r\n                                            margin-bottom: 0\">\nInitial</p></div><div flex><p class=\"widget-clabel\" \nstyle=\"font-size: 11px;\r\n                                            color: gray;\r\n                                            margin-bottom: 0\">\nCurrent</p></div><div flex><p class=\"widget-clabel\" \nstyle=\"font-size: 11px;\r\n                                            color: gray;\r\n                                            margin-bottom: 0\">\nTarget</p></div></div><div layout-gt-xs=\"row\"><div flex class=\"text-center\"><div class=\"flexin\" \nstyle=\"padding-right: 10px\"><p class=\"widget-hlabel\">{{hbf.initial_weight_log.weight_kg | number : 1}} kg</p><p \nclass=\"widget-clabel\" \nstyle=\"font-size: 11px;\r\n                                            color: gray;\r\n                                            margin-bottom: 0\">\n{{hbf.initial_weight_log.wasting_score | number : 1}}</p><p class=\"ws-label wsnobg\" \nstyle=\"display: inline-block;\r\n                                color: white;\r\n                                color: #808080;\r\n                                padding: 5px 10px;\r\n                                margin: 10px;\r\n                                border-radius: 5px;\r\n                                font-weight: bold\">\n{{ hbf.initial_weight_log.code }}</p></div></div><div flex class=\"text-center\"><div class=\"flexin\" \nstyle=\"padding-right: 10px\"><p class=\"widget-hlabel\" \nstyle=\"font-size: 11px;\r\n                                            color: gray;\r\n                                            margin-bottom: 0\">\n{{ hbf.current_weight_log.weight_kg | number : 1}} kg</p><p class=\"widget-clabel\" \nstyle=\"font-size: 11px;\r\n                                            color: gray;\r\n                                            margin-bottom: 0\">\n{{hbf.current_weight_log.wasting_score | number : 1}}</p><p class=\"ws-label {{ hbf.condition.color }}\" \nstyle=\"display: inline-block;\r\n                                color: white;\r\n                                padding: 5px 10px;\r\n                                margin: 10px;\r\n                                border-radius: 5px;\r\n                                font-weight: bold\">\n{{ hbf.condition.code }} {{hbf.current_weight_log.status_name ? \"- \" + hbf.current_weight_log.status_name : \'\'}}</p>\n</div></div><div flex class=\"text-center\"><div class=\"flexin\" style=\"padding-right: 10px\"><p \nclass=\"widget-hlabel {{ hbf.current_wasting_score_diff >= 0 ? \'green\' : \'red\' }}\"><span \nng-show=\"hbf.initial_weight_log.target_weight >= 0\"></span> {{hbf.initial_weight_log.target_weight | number : 1}} kg\n</p><p class=\"widget-vlabel {{ hbf.current_wasting_score_diff >= 0 ? \'green\' : \'red\' }}\" \nstyle=\"text-transform: capitalize;\r\n                                    font-size: 13px;\r\n                                    color: #000\">\n<span ng-show=\"hbf.current_wasting_score_diff >= 0\">+</span> {{ hbf.current_wasting_score_diff | number : 1 }}</p><p \nclass=\"ws-flagged\" style=\"color: #C1272D\" \nng-show=\"!hbf.is_discharged && !hbf.has_weight_increase && (hbf.has_missing_data || !hbf.has_nutripacks)\"><i \nclass=\"icon-flag-variant\"></i></p></div></div></div></div><div class=\"widget-footer text-center\" \nstyle=\"font-weight: 600;\r\n                color:#386BBA\"><md-button md-no-ink class=\"btn-secondary pull-left\" \nstyle=\"color: #B3B3B3\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'health_coordinator\', \'health_trainer\', \'branch_head\'])\" \nng-click=\"vm.hardDeleteHbf(hbf)\">DELETE</md-button><md-button md-no-ink ng-click=\"vm.showHbfDetails(hbf)\">DETAILS\n</md-button><md-button md-no-ink class=\"pull-right\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'health_coordinator\', \'health_trainer\', \'branch_head\'])\" \nng-disabled=\"vm.disableLogWeight(hbf)\" ng-click=\"vm.logWeight(hbf)\">LOG WEIGHT</md-button></div></form>\n</ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/prevail/tabs/reports/reports.html","<div class=\"reports-flex\"><div class=\"saved-reports\"><md-list class=\"pt-0\"><md-list-item \nng-click=\"vm.newReport = true; vm.template = {};\r\n                    vm.templateSelected = false;\" \nng-class=\"{selected: vm.newReport}\"><span><i class=\"icon-plus\"></i></span> <span>New Report</span></md-list-item>\n<md-list-item ng-repeat=\"template in vm.templates\" ng-class=\"{selected: !vm.newReport && template.selected}\" \nng-click=\"vm.showTemplate(template)\">{{template.name}}</md-list-item></md-list></div><div class=\"saved-template\" \nng-show=\"!vm.newReport\"><form name=\"savedReportForm\" class=\"md-inline-form\" novalidate><div layout-gt-xs=\"row\" \nclass=\"negative-mt-15\"><md-input-container class=\"md-block\"><md-datepicker name=\"start_date\" md-open-on-focus \nng-model=\"vm.template.filters.start_date\" md-placeholder=\"Start Date\" md-max-date=\"vm.template.filters.end_date\" \nng-change=\"vm.presetUpdateFilters(vm.template)\" required></md-datepicker><div class=\"report-error\">\n{{vm.template.dateRangeError}}</div></md-input-container><md-input-container class=\"md-block\"><md-datepicker \nname=\"end_date\" md-open-on-focus ng-model=\"vm.template.filters.end_date\" md-placeholder=\"End Date\" \nng-change=\"vm.presetUpdateFilters(vm.template)\" md-min-date=\"vm.template.filters.start_date\"></md-datepicker>\n</md-input-container></div><div layout-gt-xs=\"row\" class=\"pl-18\"><md-input-container class=\"md-block mb-10\" flex=\"25\">\n<label>Base</label><md-select name=\"base\" ng-disabled=\"!vm.bases.length || vm.currentUser.base_id\" \nng-model=\"vm.template.filters.base\" ng-change=\"vm.presetSelectBase(vm.template)\" placeholder=\"Base\"><md-option \nvalue=\"all\" ng-selected=\"true\">All Bases</md-option><md-option ng-value=\"base\" ng-repeat=\"base in vm.bases\">\n{{ base.name }}</md-option></md-select></md-input-container><md-input-container class=\"md-block mb-10\" flex=\"25\">\n<label>Branch</label><md-select name=\"branch\" ng-disabled=\"!vm.branches.length\" ng-model=\"vm.template.filters.branch\" \nng-change=\"vm.presetSelectBranch(vm.template)\" placeholder=\"Branch\"><md-option value=\"all\" ng-selected=\"true\">\nAll Branches</md-option><md-option ng-value=\"branch\" ng-repeat=\"branch in vm.branches\">{{ branch.name }}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block mb-10\" flex=\"25\"><label>Cluster</label><md-select \nname=\"cluster\" ng-disabled=\"!vm.clusters.length\" ng-model=\"vm.template.filters.cluster\" \nng-change=\"vm.presetSelectCluster(vm.template)\" placeholder=\"Cluster\"><md-option value=\"all\" ng-selected=\"true\">\nAll Clusters</md-option><md-option ng-value=\"cluster\" ng-repeat=\"cluster in vm.clusters\">{{ cluster.name }}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block mb-10\" flex=\"25\"><label>Stream</label><md-select \nname=\"stream\" ng-disabled=\"!vm.streams.length\" ng-model=\"vm.template.filters.stream\" \nng-change=\"vm.presetSelectStream(vm.template)\" placeholder=\"Stream\"><md-option value=\"all\" ng-selected=\"true\">\nAll Streams</md-option><md-option ng-value=\"stream\" ng-repeat=\"stream in vm.streams\">{{ stream.stream_name }}\n</md-option></md-select></md-input-container></div></form><div class=\"reports-container pl-18\"><div class=\"filters\">\nFilters</div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" \nflex-gt-sm=\"33\" flex-gt-xs=\"33\" flex-gt-md=\"33\"><span class=\"widget-label\">Data</span><ms-widget-front \nclass=\"white-bg widget-container\"><md-checkbox ng-checked=\"vm.presetIsSelectedAll()\" ng-click=\"vm.presetSelectAll()\">\nSelect all</md-checkbox><div class=\"report-error\">{{vm.template.dataMessage}}</div><div class=\"options-container\"><div \nng-repeat=\"program in vm.programs\"><md-checkbox flex=\"100\" flex-gt-md=\"100\" \nng-checked=\"vm.presetIsSelected(program.id)\" ng-click=\"vm.presetSelectFilter(program.id)\">{{program.name}}\n</md-checkbox></div></div></ms-widget-front></ms-widget></div><div class=\"reports-footer\" layout=\"row\" flex=\"99\" \nlayout-wrap><span class=\"preview\" ng-click=\"vm.presetShowPreview()\">Preview</span> <span \nclass=\"save-template pull-right\" ng-click=\"vm.editTemplate()\">Update Template</span> <span \nclass=\"save-template pull-right\" ng-click=\"vm.deleteTemplate()\">Delete Template</span></div></div></div><div \nclass=\"new-template\" ng-show=\"vm.newReport\"><form name=\"reportsForms\" class=\"md-inline-form\" novalidate><div \nlayout-gt-xs=\"row\" class=\"negative-mt-15\"><md-input-container class=\"md-block\"><md-datepicker name=\"start_date\" \nmd-open-on-focus ng-model=\"vm.report.start_date\" md-placeholder=\"Start Date\" ng-change=\"vm.updateFilters(vm.report)\" \nmd-max-date=\"vm.report.end_date\"></md-datepicker></md-input-container><md-input-container class=\"md-block\">\n<md-datepicker name=\"end_date\" md-open-on-focus ng-model=\"vm.report.end_date\" md-placeholder=\"End Date\" \nng-change=\"vm.updateFilters(vm.report)\" md-min-date=\"vm.report.start_date\"></md-datepicker></md-input-container></div>\n<div layout-gt-xs=\"row\" class=\"pl-18\"><md-input-container class=\"md-block mb-10\" flex=\"25\"><label>Base</label>\n<md-select name=\"base\" ng-disabled=\"!vm.bases.length || vm.currentUser.base_id\" ng-model=\"vm.report.base\" \nng-change=\"vm.selectBase(vm.report)\" placeholder=\"Base\"><md-option value=\"all\" ng-selected=\"true\">All Bases</md-option>\n<md-option ng-value=\"base\" ng-repeat=\"base in vm.bases\">{{ base.name }}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block mb-10\" flex=\"25\"><label>Branch</label><md-select name=\"branch\" \nng-disabled=\"!vm.branches.length || vm.currentUser.branch_id\" ng-model=\"vm.report.branch\" \nng-change=\"vm.selectBranch(vm.report)\" placeholder=\"Branch\"><md-option value=\"all\" ng-selected=\"true\">All Branches\n</md-option><md-option ng-value=\"branch\" ng-repeat=\"branch in vm.branches\">{{ branch.name }}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block mb-10\" flex=\"25\"><label>Cluster</label><md-select \nname=\"cluster\" ng-disabled=\"!vm.clusters.length\" ng-model=\"vm.report.cluster\" ng-change=\"vm.selectCluster(vm.report)\" \nplaceholder=\"Cluster\"><md-option value=\"all\" ng-selected=\"true\">All Clusters</md-option><md-option ng-value=\"cluster\" \nng-repeat=\"cluster in vm.clusters\">{{ cluster.name }}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block mb-10\" flex=\"25\"><label>Stream</label><md-select name=\"stream\" ng-disabled=\"!vm.streams.length\" \nng-model=\"vm.report.stream\" ng-change=\"vm.selectStream(vm.report)\" placeholder=\"Stream\"><md-option value=\"all\" \nng-selected=\"true\">All Streams</md-option><md-option ng-value=\"stream\" ng-repeat=\"stream in vm.streams\">\n{{ stream.stream_name }}</md-option></md-select></md-input-container></div></form><div class=\"reports-container pl-18\">\n<div class=\"filters\">Filters</div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"33\" flex-gt-xs=\"33\" flex-gt-md=\"33\"><span class=\"widget-label\">Data</span>\n<ms-widget-front class=\"white-bg widget-container\"><md-checkbox ng-checked=\"vm.isSelectedAll()\" \nng-click=\"vm.selectAll()\">Select all</md-checkbox><div class=\"report-error\">{{vm.dataMessage}}</div><div \nclass=\"options-container\"><div ng-repeat=\"program in vm.programs\"><md-checkbox flex=\"100\" flex-gt-md=\"100\" \nng-checked=\"vm.isSelected(program.id)\" ng-click=\"vm.selectFilter(program.id)\">{{program.name}}</md-checkbox></div>\n</div></ms-widget-front></ms-widget></div><div class=\"reports-footer\" layout=\"row\" flex=\"99\" layout-wrap><span \nclass=\"preview\" ng-click=\"vm.showPreview()\">Preview</span> <span class=\"save-template pull-right\" \nng-click=\"vm.saveTemplate(vm.report)\">Save As Template</span></div></div></div></div>");
$templateCache.put("app/main/prevail/tabs/savings-groups/savings-groups.html","<form name=\"baseForm\" class=\"md-inline-form\" novalidate><div layout-gt-xs=\"row\" class=\"approval-list\">\n<md-input-container class=\"md-block select-container mb-0\" flex=\"40\"><label>Base</label><md-select \nng-model=\"vm.filters.base\" ng-model-options=\"{ trackBy: \'$value.id\' }\" class=\"fs-16\" \nng-change=\"vm.selectBase(vm.filters)\" ng-disabled=\"currentUser.base_id || vm.isLoading2\"><md-option value=\"all\">\nAll Bases</md-option><md-option ng-value=\"base\" ng-repeat=\"base in vm.bases\">{{base.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block select-container mb-0\" flex=\"40\"><label>Branch</label>\n<md-select ng-disabled=\"!vm.filters.base.branches.length || currentUser.branch_id || vm.isLoading2\" \nng-model=\"vm.filters.branch\" ng-model-options=\"{ trackBy: \'$value.id\' }\" class=\"fs-16\" \nng-change=\"vm.selectBranch(vm.filters)\" placeholder=\"Branch\"><md-option value=\"all\">All Branches</md-option><md-option \nng-value=\"branch\" ng-repeat=\"branch in vm.filters.base.branches\">{{ branch.name }}</md-option></md-select>\n</md-input-container><md-button \nstyle=\"background-color: #2657a0 ;text-transform: none; font-size: 14px; font-weight: bolder; color:#fff!important;letter-spacing: .010em ;text-shadow: 0.45px 0.45px #fff\" \nclass=\"md-raised new-application h-43\" ng-show=\"currentUser.$roles.has([\'admin\'])\" ng-click=\"vm.addSavingsGroup()\">\nNew SG</md-button></div><div layout-gt-xs=\"row\" class=\"approval-list\"><md-input-container \nclass=\"md-block select-container mb-0\" flex=\"40\"><label>Cluster</label><md-select ng-model=\"vm.filters.cluster\" \nng-disabled=\"vm.filters.base === \'all\' || vm.clusters.length < 1 || vm.isLoading2\" \nng-model-options=\"{ trackBy: \'$value.id\' }\" ng-change=\"vm.selectCluster(vm.filters)\"><md-option value=\"all\">\nAll Clusters</md-option><md-option ng-value=\"cluster\" ng-repeat=\"cluster in vm.clusters\">{{cluster.name}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block mt-15 mb-0\" flex=\"40\"><input name=\"search\" \nng-model=\"vm.filters.search\" ng-change=\"vm.selectSearch(vm.filters)\" \nng-model-options=\"{\'*\': \'$inherit\', \'debounce\': 500}\" placeholder=\"Search Savings Group Name or Pastor’s Name\" \ntype=\"text\"></md-input-container></div><div layout=\"row\"><div flex=\"20\" class=\"ml-5 mt-10\">Total Status:</div>\n<md-input-container class=\"md-block select-container disabled-input mt-0\" flex=\"20\"><label>Gold</label><input \nng-model=\"vm.totals.gold\" disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-block select-container disabled-input mt-0\" flex=\"20\"><label>Silver</label><input \nng-model=\"vm.totals.silver\" disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-block select-container disabled-input mt-0\" flex=\"20\"><label>Inactive</label><input \nng-model=\"vm.totals.inactive\" disabled=\"disabled\"></md-input-container></div></form><div \nclass=\"all-applications savings-groups-table\"><table class=\"table\"><thead><tr><th>SG ID</th><th>Base</th><th>Cluster\n</th><th>Savings Group Name</th><th>Small Group</th><th>No. of SG Merged</th><th>Stream</th><th>Status</th><th>Pastor\n</th><th></th></tr></thead><tbody><tr ng-show=\"!vm.savingsGroups.data.length && !vm.isLoading1\"><td colspan=\"9\"><div \nclass=\"text-center\">No savings groups.</div></td></tr><tr ng-show=\"vm.isLoading1 && vm.savingsGroups.length < 1\"><td \ncolspan=\"9\"><div class=\"text-center\">Loading savings groups.</div></td></tr><tr \nng-repeat=\"savings in vm.savingsGroups.data\" ng-mouseover=\"savings.selected = true\" \nng-click=\"vm.goToSavingsGroup(savings.id)\" ng-mouseleave=\"savings.selected = false\" \nng-class=\"{backgroundWhite: savings.selected}\"><td>{{savings.savings_group_id}}</td><td class=\"fixed-small-width\">\n{{savings.base.name}}</td><td class=\"fixed-small-width\">{{savings.cluster.name}}</td><td>{{savings.name}}</td><td>\n{{savings.smallgroup.name}}</td><td>{{ savings.communities.length }}</td><td>{{savings.batch.stream_name}}</td><td>\n{{savings.status}}</td><td class=\"pastor-click\" \nng-click=\"vm.callPastorInformation(savings.pastor);\r\n                $event.stopPropagation();\">\n{{savings.pastor.firstname}} {{savings.pastor.lastname}}</td><td class=\"icons-container fixed-small-width\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\'\r\n        , \'livelihood_coordinator\', \'branch_head\'])\"><i \nclass=\"icon-pencil\" ng-click=\"vm.addSavingsGroup(savings);\r\n                   $event.stopPropagation();\"><md-tooltip \nmd-direction=\"left\">Edit Savings Group</md-tooltip></i><i class=\"icon-menu\" \nng-click=\"vm.goToSavingsGroup(savings.id); $event.stopPropagation();\"><md-tooltip md-direction=\"left\">\nView Savings Group Details</md-tooltip></i><i class=\"icon-trash\" \nng-click=\"vm.dropSavingsGroup(savings);\r\n                   $event.stopPropagation();\" \nng-show=\"currentUser.$roles.has([\'admin\'])\"><md-tooltip md-direction=\"left\">Drop Savings Group</md-tooltip></i></td>\n</tr></tbody></table><div class=\"pagination-container\" ng-show=\"!vm.isLoading1\"><pagination items=\"vm.savingsGroups\" \ncallback=\"vm.savingsPageChange(vm.savingsGroups.current_page, vm.filters)\"></pagination></div><h3 class=\"dropped-text\">\nDropped</h3><table class=\"table\"><thead><tr><th>SG ID</th><th>Base</th><th>Cluster</th><th>Savings Group Name</th><th>\nSmall Group</th><th>No. of SG Merged</th><th>Stream</th><th>Reason for dropping</th><th>Date dropped</th><th \nng-show=\"currentUser.$roles.has([\'admin\'])\"></th></tr></thead><tbody><tr \nng-show=\"!vm.droppedSavingsGroups.data.length && !vm.isLoading2\"><td colspan=\"9\"><div class=\"text-center\">\nNo savings groups.</div></td></tr><tr ng-show=\"vm.isLoading2 && vm.droppedSavingsGroups.length < 1\"><td colspan=\"9\">\n<div class=\"text-center\">Loading savings groups.</div></td></tr><tr \nng-repeat=\"savings in vm.droppedSavingsGroups.data\" ng-mouseover=\"savings.selected = true\" \nng-mouseleave=\"savings.selected = false\" ng-class=\"{backgroundWhite: savings.selected}\"><td>\n{{savings.savings_group_id}}</td><td class=\"fixed-small-width\">{{savings.base.name}}</td><td class=\"fixed-small-width\">\n{{savings.cluster.name}}</td><td>{{savings.name}}</td><td>{{savings.smallgroup.name}}</td><td>\n{{ savings.communities.length }}</td><td>{{savings.batch.stream_no}}</td><td>{{savings.reason_for_dropping}}</td><td>\n{{ savings.deleted_at | date }}</td><td class=\"icons-container fixed-small-width\" \nng-show=\"currentUser.$roles.has([\'admin\'])\"><i class=\"icon-refresh\" \nng-click=\"vm.restoreSavingsGroup(savings); $event.stopPropagation();\"><md-tooltip md-direction=\"left\">\nRestore Savings Group</md-tooltip></i><i class=\"icon-trash\" \nng-click=\"vm.deleteSavingsGroup(savings);\r\n                   $event.stopPropagation();\"><md-tooltip \nmd-direction=\"left\">Delete Savings Group</md-tooltip></i></td></tr></tbody></table><div class=\"pagination-container\" \nng-show=\"!vm.isLoading1\"><pagination items=\"vm.droppedSavingsGroups\" \ncallback=\"vm.droppedSavingsPageChange(vm.droppedSavingsGroups.current_page, vm.filters)\"></pagination></div></div>");
$templateCache.put("app/main/thrive/tabs/churches/churches.html","<style>\n.disabled {\r\n        background-color: rgba(0, 0, 0, 0.12) !important;\r\n        color: rgba(0, 0, 0, 0.38) !important;\r\n    }\r\n\r\n    .delete-button {\r\n        background-color: #C1272D !important;\r\n        color: #fff !important;\r\n    }\r\n\r\n    .delete-checkbox {\r\n        margin-right: 4px !important;\r\n        cursor: pointer;\r\n    }\n</style><div layout=\"row\" class=\"filters-container\"><md-button class=\"md-raised new-application\" \nng-show=\"currentUser.$roles.has([\'admin\']) || vm.userCountry !== \'PH\'\" ng-click=\"vm.addNewChurch()\" \nstyle=\"background-color: #2657a0 ;text-transform: none; font-size: 14px; font-weight: bolder; color:#fff!important;letter-spacing: .010em ;text-shadow: 0.45px 0.45px #fff\" \nclass=\"md-raised new-application h-43\">New Church</md-button><md-input-container \nclass=\"md-block select-container disabled-input\" flex=\"20\"><label>Total Churches</label><input \nng-model=\"vm.churches.total\" disabled=\"disabled\"></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container\n class=\"md-block margin-right-15\"><input name=\"search\" ng-model=\"vm.filters.search\" ng-model-options=\"{debounce: 300}\" \nng-change=\"vm.selectSearch(vm.filters)\" placeholder=\"Search Church’s Name or ID\" type=\"text\"></md-input-container>\n<md-input-container class=\"md-block select-container mb-0\" flex=\"20\"><label>Base</label><md-select \nng-model=\"vm.filters.base\" ng-model-options=\"{ trackBy: \'$value.id\' }\" class=\"fs-16\" \nng-change=\"vm.selectBase(vm.filters)\"><md-option value=\"all\" \nng-disabled=\"!currentUser.$roles.has([\'admin\']) && currentUser.base_id\">All Bases</md-option><md-option \nng-value=\"base\" ng-repeat=\"base in vm.bases\">{{base.name}}</md-option></md-select></md-input-container><md-autocomplete\n flex class=\"autocomplete-no-bottom-and-top margin-right-15\" ng-disabled=\"!vm.filters.base_id ||vm.isLoading\" \nmd-input-name=\"province\" md-selected-item=\"vm.selectedProvince\" md-selected-item-change=\"vm.selectProvince(province)\" \nmd-search-text=\"vm.searchProvince\" md-items=\"province in vm.searchProvinces(vm.searchProvince)\" \nmd-item-text=\"province.name\" md-no-cache=\"1\" md-floating-label=\"Province\"><md-item-template><span \nmd-highlight-text=\"vm.searchProvince\">{{province.name}}</span></md-item-template></md-autocomplete><md-autocomplete \nflex class=\"autocomplete-no-bottom-and-top margin-right-15\" md-input-name=\"city\" md-selected-item=\"vm.selectedCity\" \nmd-selected-item-change=\"vm.selectCity(city)\" md-search-text=\"vm.searchCity\" \nmd-items=\"city in vm.searchCities(vm.searchCity)\" md-item-text=\"city.name\" md-no-cache=\"1\" md-floating-label=\"City\" \nng-disabled=\"!vm.church.province_id || vm.isLoading\"><md-item-template><span md-highlight-text=\"vm.searchCity\">\n{{city.name}}</span></md-item-template></md-autocomplete><md-autocomplete flex \nclass=\"autocomplete-no-bottom-and-top margin-right-15 mb-0 mt-0\" md-input-name=\"barangay\" \nmd-selected-item=\"vm.selectedBarangay\" md-selected-item-change=\"vm.selectBarangay(barangay)\" \nmd-search-text=\"vm.searchBarangay\" md-items=\"barangay in vm.searchBarangays(vm.searchBarangay)\" \nmd-item-text=\"barangay.name\" md-no-cache=\"1\" md-floating-label=\"Barangay\" \nng-disabled=\"!vm.church.city_id || vm.isLoading\"><md-item-template><span md-highlight-text=\"vm.searchBarangay\">\n{{barangay.name}}</span></md-item-template></md-autocomplete><md-input-container class=\"md-block\" flex=\"20\"><md-button \nstyle=\"background-color: #2657a0 ;text-transform: none; font-size: 14px; height: 30px;font-weight: bolder; color:#fff!important;letter-spacing: .010em ;text-shadow: 0.45px 0.45px #fff;width: 88px\" \nclass=\"md-raised new-application h-43\" class=\"md-raised new-application clear-filter\" ng-click=\"vm.resetFilters()\">\nClear</md-button><md-button class=\"md-raised new-application\" style=\"font-weight: bolder; text-transform: none\" \nng-class=\"{\r\n                    \'disabled\': vm.bulkDeleteIDs.length===0,\r\n                    \'delete-button\': vm.bulkDeleteIDs.length,\r\n                }\" \nng-disabled=\"vm.bulkDeleteIDs.length===0\" ng-show=\"currentUser.$roles.has([\'admin\'])\" \nng-click=\"vm.deleteChurch(vm.bulkDeleteIDs)\"><span>Delete Church</span></md-button></md-input-container></div><div \nclass=\"all-applications churches-table\"><table class=\"table\"><thead><tr><th>ID</th><th>Old Id</th><th>Name</th><th>\nPastors</th><th>Lay Leaders</th><th ng-show=\"currentUser.$roles.has([\'admin\'])\">&nbsp;</th></tr></thead><tbody><tr \nclass=\"church\" ng-if=\"!vm.churches.data.length\"><td colspan=\"6\"><center>No churches found.</center></td></tr><tr \nclass=\"church\" ng-repeat=\"church in vm.churches.data\" ng-mouseover=\"church.selected = true\" \nng-mouseleave=\"church.selected = false\" ng-class=\"{backgroundWhite: church.selected}\" \nng-click=\"vm.showChurchDetails(church)\"><td><input type=\"checkbox\" class=\"delete-checkbox\" \nng-model=\"vm.isChecked[church.id]\" ng-click=\"$event.stopPropagation();\" \nng-change=\"vm.bulkDelete(church); $event.stopPropagation();\" ng-checked=\"vm.isChecked(church)\" \nng-show=\"currentUser.$roles.has([\'admin\'])\"> {{church.id}}</td><td>{{church.old_church_id}}</td><td>{{church.name}}\n</td><td>{{church.pastor_count}}</td><td>{{church.participants.length}}</td><td class=\"icons-container\" \nng-show=\"currentUser.$roles.has([\'admin\'])\"><i class=\"icon-menu\" \nng-click=\"vm.showChurchDetails(church);\r\n                   $event.stopPropagation();\"><md-tooltip md-direction=\"left\">\nView Church Details</md-tooltip></i><i class=\"icon-pencil\" ng-click=\"vm.editChurch(church); $event.stopPropagation();\">\n<md-tooltip md-direction=\"left\">Edit Church</md-tooltip></i><i class=\"icon-trash\" \nng-click=\"vm.deleteChurch(church); $event.stopPropagation();\" \nng-style=\"{\'color\': vm.bulkDeleteIDs.length ? \'#878787\' : \'#C1272D\'}\"><md-tooltip md-direction=\"left\">Delete Church\n</md-tooltip></i></td></tr></tbody></table><div class=\"pagination-container\"><pagination items=\"vm.churches\" \ncallback=\"vm.pageChange(vm.churches.current_page, vm.filters)\"></pagination></div><h3 class=\"dropped-text\">Dropped</h3>\n<table class=\"table\"><thead><tr><th>ID</th><th>Old Id</th><th>Name</th><th>Pastors</th><th>Lay Leaders</th><th>\nReason for dropping</th><th>Date Dropped</th><th ng-show=\"currentUser.$roles.has([\'admin\'])\">&nbsp;</th></tr></thead>\n<tbody><tr class=\"church\" ng-if=\"!vm.dropedChurches.data.length\"><td colspan=\"8\"><center>No churches found.</center>\n</td></tr><tr class=\"church\" ng-repeat=\"church in vm.dropedChurches.data\" ng-mouseover=\"church.selected = true\" \nng-mouseleave=\"church.selected = false\" ng-class=\"{backgroundWhite: church.selected}\"><td>{{church.id}}</td><td>\n{{church.old_church_id}}</td><td>{{church.name}}</td><td>{{church.pastor_count}}</td><td>{{church.participants.length}}\n</td><td>{{church.reason_for_dropping}}</td><td>{{church.deleted_at | date}}</td><td \nclass=\"icons-container fixed-small-width\" ng-show=\"currentUser.$roles.has([\'admin\'])\"><i class=\"icon-refresh\" \nng-click=\"vm.restoreChurch(church);\r\n                               $event.stopPropagation();\"><md-tooltip \nmd-direction=\"left\">Restore Church</md-tooltip></i><i class=\"icon-trash\" \nng-click=\"vm.permanentDeleteChurch(church); $event.stopPropagation();\"><md-tooltip md-direction=\"left\">Delete Church\n</md-tooltip></i></td></tr></tbody></table><div class=\"pagination-container\"><pagination items=\"vm.dropedChurches\" \ncallback=\"vm.droppedChurchesPageChange(vm.dropedChurches.current_page, vm.filters)\"></pagination></div></div>");
$templateCache.put("app/main/thrive/tabs/datacard/datacard.html","<div class=\"datacard-tab-content\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflex-gt-md=\"50\" flex-gt-sm=\"50\" flex-gt-xs=\"100\"><ms-widget-front class=\"padding-16 ,d-white-bg\"><form \nname=\"thriveForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.addNewThriveCard(vm.thrive, thriveForm)\"><h2 \nclass=\"datacard-title\">Thrive Data Card</h2><md-input-container class=\"md-block datepicker mt-0 mb-0\"><h6>Thrive Date\n</h6><md-datepicker ng-model=\"vm.thrive.attended_at\" name=\"thrivedate\" md-open-on-focus required \nmd-placeholder=\"Enter date\" md-input-name=\"thrivedate\" \nng-disabled=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\"></md-datepicker><div class=\"errors\" \nng-messages=\"thriveForm.thrivedate.$error || vm.apiErrors.attended_at\" \nng-hide=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\"><div ng-message=\"valid\" class=\"date-error\">\nThe entered value is not a date!<div ng-message=\"required\" class=\"date-error\">This date is required!</div><div \nng-bind=\"vm.apiErrors.attended_at\"></div></div></div></md-input-container><div layout-gt-xs=\"row\"><md-autocomplete \nflex required md-input-name=\"pastor\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedPastor\" \nmd-selected-item-change=\"vm.selectPastor(pastor)\" md-search-text=\"vm.searchPastorName\" \nmd-search-text-change=\"vm.searchPastorChange(vm.searchPastorName)\" \nmd-items=\"pastor in vm.searchPastors(vm.searchPastorName)\" \nmd-item-text=\"pastor.firstname+\' \'+pastor.lastname+ \' (\' +pastor.id+ \')\'\" md-require-match \nmd-floating-label=\"Pastor Name or ID\" ng-disabled=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\">\n<md-item-template><table><td width=\"100px\">{{pastor.id}}</td><td width=\"100px\">\n{{pastor.is_active ? \'Active\' : \'Inactive\'}} {{pastor.member_status ? \' - \' + pastor.member_status : \'\'}}</td><td \nwidth=\"170px\">{{pastor.firstname}} {{pastor.lastname}}</td></table></md-item-template><div class=\"errors\" \nng-messages=\"thriveForm.pastor.$error\" ng-if=\"thriveForm.pastor.$touched  || thriveForm.$submitted\" \nng-hide=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\"><div ng-message=\"md-require-match\">\nPlease select an existing pastor.</div><div ng-message=\"required\">Required</div></div></md-autocomplete>\n<md-input-container class=\"md-block\" flex-gt-xs><input name=\"base\" ng-model=\"vm.thrive.base\" ng-disabled=\"true\" \nplaceholder=\"Base - District\"></md-input-container></div><h6 style=\"margin: 0px\">Group Assignment</h6><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-xs><md-select flex=\"50\" \nng-model=\"vm.thrive.group_leader_id\" ng-disabled=\"!vm.selectedBaseName\" style=\"font-size:12px;margin-top: 10px\" \nplaceholder=\"Select Group Assignment\" disableoptioncentering><md-optgroup label=\" Select Group Assignment\"><md-option \nvalue=\"0\" ng-style=\"!vm.pastor.group_leader && {\'font-weight\':\'700\'}\">Unassign</md-option><md-option value=\"1\" \nng-style=\"vm.pastor.group_leader && !vm.pastor.data_card_member  && { \'font-weight\':\'700\'} \">Group Facilitator\n</md-option><md-option ng-if=\"vm.selectedBaseNames.length > 0\" \nng-style=\"vm.pastor.group_leader && vm.pastor.data_card_member && { \'font-weight\':\'700\'} \" \nng-repeat=\"member in vm.selectedBaseNames\" value=\"member\">\nMember - {{member.firstname + \' \' + member.lastname }} ({{member.id}})</md-option></md-optgroup></md-select>\n</md-input-container></div><div><table class=\"table mb-0\"><tr><td style=\"border-top: none\" class=\"v-middle\">Attendance:\n</td><td style=\"border-top: none\"><md-input-container class=\"md-block mb-0 mt-0\"><md-radio-group layout=\"row\" required \nname=\"attendance\" ng-disabled=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\"><md-checkbox \nng-model=\"vm.thrive.is_meeting\" class=\"ml-16\">Meeting</md-checkbox><md-checkbox ng-model=\"vm.thrive.is_training\" \nclass=\"ml-16\">Training</md-checkbox></md-radio-group><div ng-messages=\"thriveForm.attendance.$error\" \nng-show=\"thriveForm.attendance.$touched || thriveForm.$submitted\" role=\"alert\"><div ng-message=\"required\" \nng-hide=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\"><span>Required</span></div></div>\n</md-input-container></td></tr><tr><td class=\"v-middle\">How many Lay Leaders did you bring?</td><td><md-input-container\n class=\"md-block mb-0\"><input name=\"timothys\" ng-model=\"vm.thrive.no_of_timothy\" type=\"number\" min=\"0\" \nng-disabled=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\"><div \nng-messages=\"thriveForm.timothys.$error\" \nng-show=\"thriveForm.timothys.$touched\r\n                                             || thriveForm.$submitted\" \nrole=\"alert\" ng-hide=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\"><div ng-message=\"required\">\n<span>Required</span></div><div ng-message=\"number\"><span>Invalid number</span></div><div ng-message=\"min\">\nInvalid number</div></div></md-input-container></td></tr><tr><td class=\"v-middle\">How many adults attended last Sunday?\n</td><td><md-input-container class=\"md-block mb-0\"><input name=\"adults\" ng-model=\"vm.thrive.adults_last_sunday\" \ntype=\"number\" min=\"0\" ng-disabled=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\"><div \nng-messages=\"thriveForm.adults.$error\" \nng-show=\"thriveForm.adults.$touched\r\n                                             || thriveForm.$submitted\" \nrole=\"alert\" ng-hide=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\"><div ng-message=\"required\">\n<span>Required</span></div><div ng-message=\"number\"><span>Invalid number</span></div><div ng-message=\"min\">\nInvalid number</div></div></md-input-container></td></tr><tr><td class=\"v-middle\">\nHow many kids(13 and under) attended last Sunday?</td><td><md-input-container class=\"md-block mb-0\"><input name=\"kids\" \nng-model=\"vm.thrive.kids_last_sunday\" type=\"number\" min=\"0\" \nng-disabled=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\"><div \nng-messages=\"thriveForm.kids.$error\" \nng-show=\"thriveForm.kids.$touched\r\n                                             || thriveForm.$submitted\" \nng-hide=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\" role=\"alert\"><div ng-message=\"required\">\n<span>Required</span></div><div ng-message=\"number\"><span>Invalid number</span></div><div ng-message=\"min\">\nInvalid number</div></div></md-input-container></td></tr><tr><td class=\"v-middle\">\nWhat was the total offering last Sunday?</td><td><md-input-container class=\"md-block mb-0\"><input name=\"offering\" \nng-model=\"vm.thrive.offerings_last_sunday\" type=\"number\" min=\"0\" \nng-disabled=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\" maxlength=\"8\"><div \nng-messages=\"thriveForm.offering.$error\" \nng-show=\"thriveForm.offering.$touched\r\n                                             || thriveForm.$submitted\" \nng-hide=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\" role=\"alert\"><div ng-message=\"required\">\n<span>Required</span></div><div ng-message=\"number\"><span>Invalid number</span></div><div ng-message=\"min\">\nInvalid number</div><div ng-message=\"maxlength\">Exceeds limit</div></div></md-input-container></td></tr><tr><td \nclass=\"v-middle\">Attended Thrive Health Check</td><td><md-checkbox class=\"ml-16\" ng-model=\"vm.thrive.health_check\">\n</md-checkbox></td></tr></table></div><div class=\"mt-10\"><md-button md-no-ink type=\"reset\" \nng-click=\"vm.resetForm(thriveForm, vm)\" \nng-disabled=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\" class=\"md-primary cancel-button\" \naria-label=\"CLEAR\">CLEAR</md-button><md-button type=\"submit\" \nng-disabled=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\']) || thriveForm.$invalid\r\n                                   || thriveForm.$pristine || vm.saving || (!vm.thrive.is_meeting && !vm.thrive.is_training)\" \nclass=\"md-accent md-raised pull-right\"><span ng-show=\"!vm.saving\">SAVE</span> <span ng-show=\"vm.saving\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting</span></md-button>\n</div></form></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/thrive/tabs/districts/districts.html","<form name=\"baseForm\" class=\"md-inline-form\" novalidate><div layout-gt-xs=\"row\" class=\"district-filters\">\n<md-input-container class=\"md-block\" flex=\"20\" layout-align=\"center\"><label>Base</label><md-select \nng-model-options=\"{ trackBy: \'$value.id\' }\" ng-model=\"vm.filters.base\" ng-change=\"vm.filterByBase(vm.filters)\" \nng-disabled=\"currentUser.base_id || vm.isLoading1\"><md-option value=\"all\">All Bases</md-option><md-option \nng-value=\"base\" ng-repeat=\"base in vm.bases\">{{base.name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex=\"20\"><label>Branch</label><md-select \nng-disabled=\"!vm.filters.base.branches.length || currentUser.branch_id || vm.isLoading1\" ng-model=\"vm.filters.branch\" \nng-model-options=\"{ trackBy: \'$value.id\' }\" ng-change=\"vm.filterByBranch(vm.filters)\" placeholder=\"Branch\"><md-option \nvalue=\"all\">All Branches</md-option><md-option ng-value=\"branch\" ng-repeat=\"branch in vm.filters.base.branches\">\n{{ branch.name }}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block select-container disabled-input\" flex=\"20\"><label>Total Districts</label><input \nng-model=\"vm.districts.total\" disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-block select-container disabled-input\" flex=\"20\"><label>Total Pastors</label><input \nng-model=\"vm.pastors.total\" disabled=\"disabled\"></md-input-container><md-button \nclass=\"md-raised new-application new-district\" \nstyle=\"background-color: #2657a0 ;text-transform: none; font-size: 14px; font-weight: bolder; color:#fff!important;letter-spacing: .010em ;text-shadow: 0.45px 0.45px #fff\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\',\r\n                   \'pastor_coordinator\', \'branch_head\'])\" \nng-click=\"vm.addDistrict()\">New District</md-button></div></form><div class=\"all-applications districts-table\"><table \nclass=\"table\"><thead><tr><th>Base</th><th>District</th><th>Branch</th><th>Pastors</th><th>Gold</th><th>Silver</th><th>\nBronze</th><th>Inactive</th><th \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\',\r\n            \'pastor_coordinator\', \'branch_head\'])\">&nbsp;</th>\n</tr></thead><tbody><tr ng-show=\"!vm.districts.data.length && !vm.isLoading1\"><td colspan=\"10\"><div \nclass=\"text-center\">No districts.</div></td></tr><tr ng-show=\"vm.isLoading1 && vm.districts.length < 1\"><td \ncolspan=\"10\"><div class=\"text-center\">Loading districts.</div></td></tr><tr ng-repeat=\"district in vm.districts.data\" \nng-mouseover=\"district.selected = true\" ng-mouseleave=\"district.selected = false\" \nng-class=\"{backgroundWhite: district.selected}\" ng-show=\"!vm.isLoading1\" ng-click=\"vm.goToPastors(district)\"><td>\n{{district.base.name}}</td><td>{{district.name}}</td><td>{{district.branch.name}}</td><td>{{district.population}}</td>\n<td>{{district.total_gold}}</td><td>{{district.total_silver}}</td><td>{{district.total_bronze}}</td><td>\n{{district.total_inactive}}</td><td class=\"icons-container\"><i class=\"icon-pencil\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'pastor_coordinator\', \'branch_head\'])\" \nng-click=\"vm.editDistrict(district); $event.stopPropagation();\"><md-tooltip md-direction=\"left\">Edit District\n</md-tooltip></i><i class=\"icon-trash\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'pastor_coordinator\', \'branch_head\'])\" \nng-click=\"vm.deleteDistrict(district); $event.stopPropagation();\"><md-tooltip md-direction=\"left\">Delete District\n</md-tooltip></i></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!vm.isLoading1\"><pagination \nitems=\"vm.districts\" callback=\"vm.pageChange(vm.districts.current_page, vm.filters)\"></pagination></div></div>");
$templateCache.put("app/main/thrive/tabs/pastors/pastors.html","<style>\n.disabled {\r\n        background-color: rgba(0, 0, 0, 0.12) !important;\r\n        color: rgba(0, 0, 0, 0.38) !important;\r\n    }\r\n\r\n    .delete-button {\r\n        background-color: #C1272D !important;\r\n        color: #fff !important;\r\n    }\r\n\r\n    .delete-checkbox {\r\n        margin: 0px 4px 0 0 !important;\r\n        cursor: pointer;\r\n    }\n</style><div layout=\"row\" class=\"filters-container\"><md-button class=\"md-raised new-application\" \nstyle=\"text-transform: none; font-size: 14px; font-weight: bolder; color:#fff!important;letter-spacing: .010em ;text-shadow: 0.45px 0.45px #fff\" \nng-show=\"currentUser.$roles.has([\'admin\']) || vm.userCountry !== \'PH\'\" ng-click=\"vm.addNewPastor()\">New Pastor\n</md-button><md-input-container class=\"md-block select-container disabled-input\" flex=\"10\"><label>Total Gold</label>\n<input ng-model=\"vm.total_gold\" disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-block select-container disabled-input\" flex=\"10\"><label>Total Silver</label><input \nng-model=\"vm.total_silver\" disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-block select-container disabled-input\" flex=\"10\"><label>Total Bronze</label><input \nng-model=\"vm.total_bronze\" disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-block select-container disabled-input\" flex=\"10\"><label>Total Inactive</label><input \nng-model=\"vm.total_inactive\" disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-block select-container disabled-input\" flex=\"10\"><label>Total Pastors</label><input \nng-model=\"vm.total_pastors\" disabled=\"disabled\"></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block mb-0\" flex=\"20\"><input name=\"search\" ng-model=\"vm.filters.search\" \nng-change=\"vm.selectSearch(vm.filters)\" ng-model-options=\"{debounce: 700}\" placeholder=\"Search Pastor’s Name or ID\" \ntype=\"text\"></md-input-container><md-input-container class=\"md-block select-container mb-0\" flex=\"20\"><label>Base\n</label><md-select ng-model=\"vm.filters.base\" ng-model-options=\"{ trackBy: \'$value.id\' }\" class=\"fs-16\" \nng-change=\"vm.selectBase(vm.filters)\"><md-option value=\"all\" \nng-disabled=\"!currentUser.$roles.has([\'admin\']) && currentUser.base_id\">All Bases</md-option><md-option \nng-value=\"base\" ng-repeat=\"base in vm.bases\">{{base.name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block select-container mb-0\" flex=\"20\"><label>Branch</label><md-select \nng-disabled=\"!vm.filters.base.branches.length\" ng-model=\"vm.filters.branch\" \nng-model-options=\"{ trackBy: \'$value.id\' }\" class=\"fs-16\" ng-change=\"vm.selectBranch(vm.filters)\" placeholder=\"Branch\">\n<md-option value=\"all\" ng-disabled=\"!currentUser.$roles.has([\'admin\']) && currentUser.branch_id \">All Branches\n</md-option><md-option ng-value=\"branch\" ng-repeat=\"branch in vm.filters.base.branches\">{{ branch.name }}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block margin-right-15 mb-0\" flex=\"20\"><label>District\n</label><md-select class=\"fs-16\" ng-model=\"vm.filters.district\" ng-change=\"vm.selectDistrict(vm.filters)\" \nplaceholder=\"All Districts\"><md-option value=\"all\">All Districts</md-option><md-option ng-value=\"district.id\" \nng-repeat=\"district in vm.districts\">{{district.base.name}} - {{ district.name }}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block margin-right-15\" flex=\"20\"><md-button \nclass=\"md-raised new-application\" \nstyle=\"background-color: #2657a0 ;text-transform: none; font-size: 14px; font-weight: bolder; color:#fff!important;letter-spacing: .010em ;text-shadow: 0.45px 0.45px #fff\" \nclass=\"md-raised new-application h-43\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'pastor_coordinator\', \'branch_head\'])\" \nng-click=\"vm.resetFilters()\">Reset</md-button><md-button class=\"md-raised new-application\" \nstyle=\"font-weight: bolder; text-transform: none\" \nng-class=\"{\r\n            \'disabled\': vm.bulkDeleteIDs.length===0,\r\n            \'delete-button\': vm.bulkDeleteIDs.length,\r\n        }\" \nng-disabled=\"vm.bulkDeleteIDs.length===0\" ng-show=\"currentUser.$roles.has([\'admin\'])\" \nng-click=\"vm.deletePastor(vm.bulkDeleteIDs)\"><span>Delete Pastor</span></md-button></md-input-container></div><div \nclass=\"all-applications pastors-table\"><table class=\"table\"><thead><tr><th>ID</th><th>Old Id</th><th>Name</th><th>\nDistrict</th><th>Member</th><th>Group Assignment</th><th>Status</th><th>&nbsp;</th></tr></thead><tbody><tr \nclass=\"pastor\" ng-show=\"!vm.pastorsList.data.length && !vm.isLoading1\"><td colspan=\"8\"><div class=\"text-center\">\nNo pastors found.</div></td></tr><tr ng-show=\"vm.isLoading1 && vm.pastorsList.length < 1\"><td colspan=\"8\"><div \nclass=\"text-center\">Loading pastors list.</div></td></tr><tr ng-repeat=\"pastor in vm.pastorsList.data\" \nng-mouseover=\"pastor.selected = true\" ng-mouseleave=\"pastor.selected = false\" \nng-class=\"{backgroundWhite: pastor.selected}\" ng-click=\"vm.showPastorDetails(pastor)\" \nng-style=\"pastor.group_leader && pastor.data_card_member && { \'background-color\':\'rgb(255 158 27 / 50%)\'} || pastor.group_leader > 0 && { \'background-color\': \'rgb(86 176 147 / 50%)\' } \">\n<td><input type=\"checkbox\" class=\"delete-checkbox\" ng-model=\"vm.isChecked[pastor.id]\" \nng-click=\"$event.stopPropagation();\" ng-change=\"vm.bulkDelete(pastor); $event.stopPropagation();\" \nng-checked=\"vm.isChecked(pastor)\" ng-show=\"currentUser.$roles.has([\'admin\'])\"> {{pastor.id}}</td><td>{{pastor.old_id}}\n</td><td \nng-style=\"{ \'display\': (pastor.icon_display==1 && pastor.duplicatePastors.length) ? \'flex\' : \'table-cell\', \'gap\': \'5px\'  }\">\n{{pastor.fullname}} <i class=\"material-icons Issues_icon pt-3\" \nng-show=\"(pastor.icon_display==1 && pastor.duplicatePastors.length)?true:false\" \nng-click=\"vm.issuesDialog(pastor);  $event.stopPropagation();\" ng-style=\"{\'color\': pastor.remark ? \'#49c749\' : \'red\'}\">\nerror_outline</i></td><td>\n{{pastor.district_id ? pastor.district.base.name : null}} - {{pastor.district_id ? pastor.district.name : null}}</td>\n<td>{{pastor.total_data_cards > 2 ? \'Yes\' : \'No\'}}</td><td>\n{{pastor.group_leader ? pastor.group_leader && pastor.data_card_member ? \"Member -\": \"Group-Facilitator\" : \"Unassigned\"}} \n<span ng-if=\"pastor.group_leader && pastor.data_card_member\">{{pastor.middlename }}</span></td><td>\n{{pastor.is_active ? \'Active\' : \'Inactive\'}} {{pastor.member_status ? \' - \' + pastor.member_status : \'\'}}</td><td \nclass=\"icons-container\"><i class=\"icon-menu\" \nng-click=\"vm.showPastorDetails(pastor);\r\n                   $event.stopPropagation();\"><md-tooltip md-direction=\"left\">\nView Pastor Details</md-tooltip></i><i class=\"icon-pencil\" \nng-show=\"currentUser.$roles.has([\'admin\']) || vm.userCountry !== \'PH\'\" \nng-click=\"vm.editPastor(pastor); $event.stopPropagation();\"><md-tooltip md-direction=\"left\">Edit Pastor</md-tooltip>\n</i><i class=\"icon-trash\" ng-show=\"currentUser.$roles.has([\'admin\'])\" \nng-click=\"vm.deletePastor(pastor); $event.stopPropagation();\" \nng-style=\"{\'color\': vm.bulkDeleteIDs.length ? \'#878787\' : \'#C1272D\'}\"><md-tooltip md-direction=\"left\">Drop Pastor\n</md-tooltip></i></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!vm.isLoading1\"><pagination \nitems=\"vm.pastorsList\" callback=\"vm.pageChange(vm.pastorsList.current_page, vm.filters)\"></pagination></div><h3 \nclass=\"dropped-text\">Dropped</h3>{{pastor | json}}<table class=\"table\"><thead><tr><th>ID</th><th>Old Id</th><th>Name\n</th><th>District</th><th>Reason for dropping</th><th>Date Dropped</th><th></th></tr></thead><tbody><tr \nng-show=\"!vm.droppedPastorsDetails.data.length && !vm.isLoading2\"><td colspan=\"7\"><div class=\"text-center\">No pastors.\n</div></td></tr><tr ng-show=\"vm.isLoading2 && vm.droppedPastorsDetails.length < 1\"><td colspan=\"7\"><div \nclass=\"text-center\">Loading Pastors.</div></td></tr><tr ng-repeat=\"pastor in vm.droppedPastorsDetails.data\" \nng-mouseover=\"pastor.selected = true\" ng-mouseleave=\"pastor.selected = false\" \nng-class=\"{backgroundWhite: pastor.selected}\"><td class=\"fixed-small-width\">{{pastor.id}}</td><td \nclass=\"fixed-small-width\">{{pastor.old_id}}</td><td class=\"fixed-small-width\">{{pastor.fullname}}</td><td>\n{{pastor.district_id ? pastor.district.base.name : null}} - {{pastor.district_id ? pastor.district.name : null}}</td>\n<td>{{pastor.reason_for_dropping}}</td><td>{{pastor.deleted_at | date}}</td><td \nclass=\"icons-container fixed-small-width\"><i class=\"icon-refresh\" \nng-show=\"currentUser.$roles.has([\'admin\']) || vm.userCountry !== \'PH\'\" \nng-click=\"vm.restorePastor(pastor);\r\n                               $event.stopPropagation();\"><md-tooltip \nmd-direction=\"left\">Restore Pastor</md-tooltip></i></td></tr></tbody></table><div class=\"pagination-container\" \nng-show=\"!vm.isLoading1\"><pagination items=\"vm.droppedPastorsDetails\" \ncallback=\"vm.droppedPastorsPageChange(vm.droppedPastorsDetails.current_page, vm.filters)\"></pagination></div></div>");
$templateCache.put("app/main/thrive/tabs/reports/reports.html","<div class=\"reports-flex\"><div class=\"saved-reports\"><md-list class=\"pt-0\"><md-list-item \nng-click=\"vm.newReport = true; vm.template = {};\" ng-class=\"{selected: vm.newReport}\"><span><i \nclass=\"icon-plus new-report-plus\"></i></span> <span>New Report</span></md-list-item><md-list-item \nng-repeat=\"template in vm.templates\" \nng-class=\"{selected: !vm.newReport\r\n                          && template.selected}\" \nng-click=\"vm.showTemplate(template)\">{{template.name}}</md-list-item></md-list></div><div class=\"saved-template\" \nng-show=\"!vm.newReport\"><form name=\"savedReportForms\" class=\"md-inline-form\" novalidate><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\"><md-datepicker name=\"start_date\" md-open-on-focus \nng-model=\"vm.template.filters.start_date\" md-placeholder=\"Start Date\" md-max-date=\"vm.template.filters.end_date\" \nng-change=\"vm.presetUpdateFilters(vm.template)\" required></md-datepicker><div class=\"report-error\">\n{{vm.template.dateRangeError}}</div></md-input-container><md-input-container class=\"md-block\"><md-datepicker \nname=\"end_date\" md-open-on-focus ng-model=\"vm.template.filters.end_date\" md-placeholder=\"End Date\" \nng-change=\"vm.presetUpdateFilters(vm.template)\" md-min-date=\"vm.template.filters.start_date\"></md-datepicker>\n</md-input-container></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block mb-10\" flex=\"35\"><label>Base\n</label><md-select name=\"base\" ng-disabled=\"!vm.bases.length || vm.currentUser.base_id\" \nng-model=\"vm.template.filters.base\" ng-change=\"vm.presetSelectBase(vm.template)\" placeholder=\"Base\"><md-option \nvalue=\"all\" ng-selected=\"true\">All Bases</md-option><md-option ng-value=\"base\" ng-repeat=\"base in vm.bases\">\n{{ base.name }}</md-option></md-select></md-input-container><md-input-container class=\"md-block mb-10\" flex=\"35\">\n<label>Branch</label><md-select name=\"branch\" \nng-disabled=\"!vm.presetSelectedBase.branches.length || vm.currentUser.branch_id\" ng-model=\"vm.template.filters.branch\" \nng-change=\"vm.presetSelectLocation(vm.template)\" placeholder=\"Branch\"><md-option value=\"all\" ng-selected=\"true\">\nAll Branches</md-option><md-option ng-value=\"branch\" ng-repeat=\"branch in vm.presetSelectedBase.branches\">\n{{ branch.name }}</md-option></md-select></md-input-container><md-input-container class=\"md-block mb-10\" flex=\"35\">\n<label>District</label><md-select name=\"district\" ng-disabled=\"!vm.presetSelectedBase.districts.length\" \nng-model=\"vm.template.filters.district\" ng-change=\"vm.presetSelectLocation(vm.template)\" placeholder=\"District\">\n<md-option value=\"all\" ng-selected=\"true\">All Districts</md-option><md-option ng-value=\"district\" \nng-repeat=\"district in vm.presetSelectedBase.districts | filterDistrictByBranch:vm.template.filters.branch.id | orderBy:\'+name\' | orderBy:\'+name.length\'\">\n{{ district.name }}</md-option></md-select></md-input-container></div></form><div class=\"reports-container\"><div \nclass=\"filters\">Filters</div><div class=\"widget-group widget-group-container\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"33\" flex-gt-xs=\"33\" flex-gt-md=\"33\"><span class=\"widget-label\">\nPrograms</span><ms-widget-front class=\"white-bg widget-container\"><md-checkbox \nng-checked=\"vm.presetIsSelectedAll(vm.template)\" ng-click=\"vm.presetSelectAll(vm.template)\">Select all</md-checkbox>\n<div class=\"report-error\">{{vm.template.programMessage}}</div><div class=\"options-container\"><div \nng-repeat=\"program in vm.programs\"><md-checkbox flex=\"100\" flex-gt-md=\"100\" \nng-checked=\"vm.presetIsSelected(program.id)\" ng-click=\"vm.presetSelectFilter(program.id, vm.template)\">{{program.name}}\n</md-checkbox></div></div></ms-widget-front></ms-widget></div><div class=\"reports-footer\" layout=\"row\" flex=\"99\" \nlayout-wrap><span class=\"preview\" ng-click=\"vm.presetShowPreview(vm.template)\">Preview</span> <span \nclass=\"save-template pull-right\" ng-click=\"vm.editTemplate(vm.template)\">Update Template</span> <span \nclass=\"save-template pull-right\" ng-click=\"vm.deleteTemplate(vm.template)\">Delete Template</span></div></div></div><div\n class=\"new-template\" ng-show=\"vm.newReport\"><form name=\"reportsFormss\" class=\"md-inline-form\" novalidate><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\"><md-datepicker name=\"start_date\" md-open-on-focus \nng-model=\"vm.report.start_date\" md-placeholder=\"Start Date\" ng-change=\"vm.updateFilters(vm.report)\" \nmd-max-date=\"vm.report.end_date\"></md-datepicker></md-input-container><md-input-container class=\"md-block\">\n<md-datepicker name=\"end_date\" md-open-on-focus ng-model=\"vm.report.end_date\" md-placeholder=\"End Date\" \nng-change=\"vm.updateFilters(vm.report)\" md-min-date=\"vm.report.start_date\"></md-datepicker></md-input-container></div>\n<div layout-gt-xs=\"row\"><md-input-container class=\"md-block mb-10\" flex=\"35\"><label>Base</label><md-select name=\"base\" \nng-disabled=\"!vm.bases.length || vm.currentUser.base_id\" ng-model=\"vm.report.base\" \nng-change=\"vm.selectBase(vm.report)\" placeholder=\"Base\"><md-option value=\"all\" ng-selected=\"true\">All Bases</md-option>\n<md-option ng-value=\"base\" ng-repeat=\"base in vm.bases\">{{ base.name }}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block mb-10\" flex=\"35\"><label>Branch</label><md-select name=\"branch\" \nng-disabled=\"!vm.selectedBase.branches.length || vm.currentUser.branch_id\" ng-model=\"vm.report.branch\" \nng-change=\"vm.selectLocation(vm.report)\" placeholder=\"Branch\"><md-option value=\"all\" ng-selected=\"true\">All Branches\n</md-option><md-option ng-value=\"branch\" ng-repeat=\"branch in vm.selectedBase.branches\">{{ branch.name }}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block mb-10\" flex=\"35\"><label>District</label><md-select\n name=\"district\" ng-disabled=\"!vm.selectedBase.districts.length\" ng-model=\"vm.report.district\" \nng-change=\"vm.selectLocation(vm.report)\" placeholder=\"District\"><md-option value=\"all\" ng-selected=\"true\">All Districts\n</md-option><md-option ng-value=\"district\" \nng-repeat=\"district in vm.selectedBase.districts | filterDistrictByBranch:vm.report.branch.id | orderBy:\'+name\' | orderBy:\'+name.length\'\">\n{{ district.name }}</md-option></md-select></md-input-container></div></form><div class=\"reports-container\"><div \nclass=\"filters\">Filters</div><div class=\"widget-group widget-group-container\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"33\" flex-gt-xs=\"33\" flex-gt-md=\"33\"><span class=\"widget-label\">\nPrograms</span><ms-widget-front class=\"white-bg widget-container\"><md-checkbox ng-checked=\"vm.isSelectedAll()\" \nng-click=\"vm.selectAll(vm.report)\">Select all</md-checkbox><div class=\"report-error\">{{vm.programMessage}}</div><div \nclass=\"options-container\"><div ng-repeat=\"program in vm.programs\"><md-checkbox flex=\"100\" flex-gt-md=\"100\" \nng-checked=\"vm.isSelected(program.id)\" ng-click=\"vm.selectFilter(program.id, vm.report)\">{{program.name}}</md-checkbox>\n</div></div></ms-widget-front></ms-widget></div><div class=\"reports-footer\" layout=\"row\" flex=\"99\" layout-wrap><span \nclass=\"preview\" ng-click=\"vm.showPreview(vm.report)\">Preview</span> <span class=\"save-template pull-right\" \nng-click=\"vm.saveTemplate(vm.report)\">Save As Template</span></div></div></div></div>");
$templateCache.put("app/main/transform/tabs/applications/applications.html","<div layout-gt-xs=\"row\" class=\"filters-container\"><md-button class=\"md-raised\" \nstyle=\"text-transform: none; color: white; background-color: #376BBA !important;width: 135px ;margin-right: 4px; padding: 2px; font-size: 14px; line-height: 36px;font-weight: 900;text-shadow: 0.45px 0.45px #fff\" \nng-class=\"{\'new-application\': currentUser.$roles.has([\'admin\',\r\n               \'branch_head\', \'metrics\', \'pastor_coordinator\'])}\" \nng-disabled=\"!currentUser.$roles.has([\'admin\',\r\n               \'branch_head\', \'metrics\', \'pastor_coordinator\', \'health_mentor\' ])\" \nng-click=\"vm.addApplication()\">New Application</md-button><md-input-container \nclass=\"md-block select-container disabled-input\" flex=\"20\"><label>Total Applications</label><input \nng-model=\"vm.applications.total\" disabled=\"disabled\"></md-input-container><div class=\"deleted-applications\" \nng-click=\"vm.openDeletedApplications()\">Deleted Applications</div></div><div layout=\"row\" \nclass=\"filters-container mt-15 pl-10\"><md-input-container class=\"md-block select-container\" flex=\"20\"><label>Base\n</label><md-select ng-model=\"vm.filters.base\" ng-model-options=\"{ trackBy: \'$value.id\' }\" \nng-change=\"vm.selectBase(vm.filters)\" ng-disabled=\"currentUser.base_id || vm.isLoading1\"><md-option value=\"all\">\nAll Bases</md-option><md-option ng-value=\"base\" ng-repeat=\"base in vm.bases\">{{base.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block select-container\" flex=\"20\"><label>Branch</label><md-select \nng-disabled=\"!vm.filters.base.branches.length || currentUser.branch_id || vm.isLoading1\" ng-model=\"vm.filters.branch\" \nng-model-options=\"{ trackBy: \'$value.id\' }\" ng-change=\"vm.selectBranch(vm.filters)\" placeholder=\"Branch\"><md-option \nvalue=\"all\">All Branches</md-option><md-option ng-value=\"branch\" ng-repeat=\"branch in vm.filters.base.branches\">\n{{ branch.name }}</md-option></md-select></md-input-container><form name=\"autocompleteForm\" flex=\"20\"><md-autocomplete \nflex ng-disabled=\"vm.isLoading1\" md-input-name=\"pastor\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedPastor\" \nmd-selected-item-change=\"vm.selectPastor(pastor)\" md-search-text=\"vm.searchPastorName\" \nmd-items=\"pastor in vm.searchPastors(vm.searchPastorName)\" \nmd-item-text=\"pastor.firstname+\' \'+pastor.lastname+ \' (\' +pastor.id+ \')\'\" md-require-match \nmd-floating-label=\"Search Pastor’s Name or ID\"><md-item-template><table><td width=\"170px\">\n{{pastor.firstname}} {{pastor.lastname}}</td></table></md-item-template><div class=\"errors\" \nng-messages=\"autocompleteForm.pastor.$error\" \nng-if=\"autocompleteForm.pastor.$touched\r\n                                 || autocompleteForm.$submitted\"><div \nng-message=\"md-require-match\">Please select an existing pastor.</div></div></md-autocomplete></form></div><div \nclass=\"all-applications\"><table class=\"table\"><thead><tr><th>ID</th><th>Base</th><th>Branch</th><th>Application Date\n</th><th>Pastor</th><th>Pastor Status</th></tr></thead><tbody><tr \nng-show=\"!vm.applications.data.length && !vm.isLoading1\"><td colspan=\"6\"><div class=\"text-center\">No applications.\n</div></td></tr><tr ng-show=\"vm.isLoading1 && vm.applications.length < 1\"><td colspan=\"6\"><div class=\"text-center\">\nLoading applications.</div></td></tr><tr ng-repeat=\"application in vm.applications.data\" ng-show=\"!vm.isLoading1\" \nng-mouseover=\"application.selected = true\" ng-mouseleave=\"application.selected = false\" \nng-class=\"{backgroundWhite: application.selected}\" ng-click=\"vm.editApplication(application)\"><td>\n{{application.application_id}}</td><td>{{application.base.name}}</td><td>{{application.branch.name}}</td><td>\n{{application.applied_at | date}}</td><td class=\"pastor-click\" \nng-click=\"vm.callPastorInformation(application.pastor, application.church);\r\n                $event.stopPropagation();\">\n{{application.pastor.firstname}} {{application.pastor.lastname}}</td><td>\n{{application.pastor.is_active ? \'Active\' : \'Inactive\'}} {{application.pastor.member_status ? \' - \' + application.pastor.member_status : \'\'}}\n</td><td class=\"icons-container\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\',\r\n                \'pastor_coordinator\', \'branch_head\', \'health_mentor\'])\">\n<i class=\"icon-pencil\" ng-click=\"vm.editApplication(application);\r\n                   $event.stopPropagation();\">\n<md-tooltip md-direction=\"left\">Edit Application</md-tooltip></i><i class=\"icon-check\" \nng-click=\"vm.approveApplication(application);\r\n                   $event.stopPropagation();\"><md-tooltip \nmd-direction=\"left\">Approve Application</md-tooltip></i><i class=\"icon-trash\" \nng-click=\"vm.deleteApplication(application);\r\n                   $event.stopPropagation();\"><md-tooltip \nmd-direction=\"left\">Delete Application</md-tooltip></i></td></tr></tbody></table><div class=\"pagination-container\" \nng-show=\"!vm.isLoading1\"><pagination items=\"vm.applications\" \ncallback=\"vm.pageChange(vm.applications.current_page, vm.filters)\"></pagination></div></div>");
$templateCache.put("app/main/transform/tabs/community-lists/community-lists.html","<form name=\"baseCommunityForm\" class=\"md-inline-form\" ng-model-options=\"{ debounce: 300 }\" novalidate><div \nlayout-gt-xs=\"row\" class=\"community-list\"><md-input-container class=\"md-block select-container mb-0\" flex=\"25\"><label>\nBatch</label><md-select ng-model=\"vm.filters.batch\" ng-model-options=\"{ trackBy: \'$value.id\' }\" placeholder=\"Batch\" \nng-disabled=\"vm.isLoading3\" ng-change=\"vm.selectBatch(vm.filters)\"><md-option value=\"all\">All Batches</md-option>\n<md-option ng-value=\"batch\" ng-repeat=\"batch in vm.batches\">{{ batch.short_name }}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block select-container mb-0\" flex=\"25\"><label>Base</label><md-select\n name=\"role\" ng-model-options=\"{ trackBy: \'$value.id\' }\" ng-model=\"vm.filters.base\" \nng-change=\"vm.selectBase(vm.filters)\" ng-disabled=\"currentUser.base_id || vm.isLoading3\"><md-option value=\"all\">\nAll Bases</md-option><md-option ng-value=\"base\" ng-repeat=\"base in vm.bases\">{{base.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block select-container mb-0\" flex=\"25\"><label>Branch</label>\n<md-select ng-disabled=\"!vm.filters.base.branches.length || currentUser.branch_id || vm.isLoading3\" \nng-model=\"vm.filters.branch\" ng-model-options=\"{ trackBy: \'$value.id\' }\" ng-change=\"vm.selectBranch(vm.filters)\" \nplaceholder=\"Branch\"><md-option value=\"all\">All Branches</md-option><md-option ng-value=\"branch\" \nng-repeat=\"branch in vm.filters.base.branches\">{{ branch.name }}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block select-container mb-0\" flex=\"25\"><label>Program</label><md-select \nng-model=\"vm.filters.program\" ng-disabled=\"vm.isLoading3\" ng-model-options=\"{ trackBy: \'$value.id\' }\" \nng-change=\"vm.selectProgram(vm.filters)\"><md-option value=\"all\">All Programs</md-option><md-option ng-value=\"program\" \nng-repeat=\"program in vm.programs\">{{program.name}}</md-option></md-select></md-input-container></div><div \nlayout=\"row\" class=\"mt-0\"><md-input-container class=\"md-block select-container mb-0 disabled-input\" flex=\"33\"><label>\nTotal Communities</label><input ng-model=\"vm.communities.total\" disabled=\"disabled\"></md-input-container>\n<md-input-container class=\"md-block select-container mb-0 disabled-input\" flex=\"33\"><label>Total Participant Override\n</label><input ng-model=\"vm.totalParticipants\" disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-block select-container mb-0 disabled-input\" flex=\"33\"><label>Total Children</label><input \nng-model=\"vm.totalChildren\" disabled=\"disabled\"></md-input-container></div><div layout=\"row\" class=\"mt-0\">\n<md-input-container class=\"md-block\" flex=\"40\"><label>Search Community ID or Pastor Name</label><input \nng-model=\"vm.filters.search\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"vm.selectCommunityId(vm.filters)\">\n</md-input-container></div></form><div class=\"all-applications approval-list\"><table class=\"table\"><thead><tr><th>\nOriginal Community ID</th><th>Program</th><th>Location</th><th>{{vm.municipalityLebel}}</th><th>{{vm.barangayLebel}}\n</th><th>Pastor</th></tr></thead><tbody><tr ng-show=\"!vm.communities.data.length && !vm.isLoading3\"><td colspan=\"6\">\n<div class=\"text-center\">No applications.</div></td></tr><tr ng-show=\"vm.isLoading3 && vm.communities.length < 1\"><td \ncolspan=\"6\"><div class=\"text-center\">Loading applications.</div></td></tr><tr \nng-repeat=\"community in vm.communities.data\" ng-mouseover=\"community.selected = true\" \nng-mouseleave=\"community.selected = false\" ng-class=\"{backgroundWhite: community.selected}\" \nng-click=\"vm.goToCommunity(community.id)\"><td>{{community.community_no}}</td><td>{{community.application.program.name}}\n</td><td>{{community.application.base.name}}</td><td>{{community.application.community_city}}</td><td>\n{{community.application.community_barangay}}</td><td class=\"pastor-click\" \nng-click=\"vm.callPastorInformation(community.application.pastor, community.application.church);\r\n                $event.stopPropagation();\">\n{{community.application.pastor.firstname}} {{community.application.pastor.lastname}}</td><td><span \nclass=\"material-icons Issues_icon\" ng-show=\"community.icon_display==1?true:false\">error_outline</span></td><td \nclass=\"icons-container\"><i class=\"icon-pencil\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\'\r\n                  , \'pastor_coordinator\', \'branch_head\'])\" \nng-click=\"vm.editCommunity(community.application);\r\n                   $event.stopPropagation();\"><md-tooltip \nmd-direction=\"left\">Edit Application</md-tooltip></i><i class=\"icon-menu\" ng-click=\"vm.goToCommunity(community.id)\">\n<md-tooltip md-direction=\"left\">View Community Details</md-tooltip></i><i class=\"icon-trash\" \nng-click=\"vm.dropApplication(community, \'community\');\r\n                   $event.stopPropagation();\" \nng-show=\"currentUser.$roles.has([\'admin\'])\"><md-tooltip md-direction=\"left\">Remove community</md-tooltip></i></td></tr>\n</tbody></table><div class=\"pagination-container\" ng-show=\"!vm.isLoading3\"><pagination items=\"vm.communities\" \ncallback=\"vm.communityPageChange(vm.communities.current_page, vm.filters)\"></pagination></div></div>");
$templateCache.put("app/main/transform/tabs/reports/reports.html","<div class=\"reports-flex\"><div class=\"saved-reports\"><md-list><md-list-item \nng-click=\"vm.newReport = true; vm.template = {};\r\n                    vm.templateSelected = false;\" \nng-class=\"{selected: vm.newReport}\"><span><i class=\"icon-plus\"></i></span> <span>New Reports</span></md-list-item>\n<md-list-item ng-repeat=\"template in vm.templates\" ng-class=\"{selected: !vm.newReport && template.selected}\" \nng-click=\"vm.showTemplate(template)\">{{template.name}}</md-list-item></md-list></div><div class=\"saved-template\" \nng-show=\"!vm.newReport\"><form name=\"savedReportForm\" class=\"md-inline-form\" novalidate><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block select\" flex><label>Program</label><md-select name=\"program_types\" \nng-change=\"vm.presetSelectProgram(vm.template)\" ng-model=\"vm.template.filters.program_type\"><md-option value=\"all\" \nng-selected=\"true\">All Program Types</md-option><md-option ng-value=\"program.id\" \nng-repeat=\"program in vm.programTypes\">\n{{program.name}} &nbsp;&nbsp;-&nbsp;&nbsp; {{program.active ? \'Active\' : \'Inactive\'}}</md-option></md-select>\n</md-input-container><md-autocomplete md-input-name=\"donor\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.template.selectedDonor\" md-selected-item-change=\"vm.presetSelectDonor(donor)\" \nmd-search-text=\"vm.searchDonor\" md-items=\"donor in vm.searchDonors(vm.searchDonor)\" md-item-text=\"donor.name\" \nmd-require-match flex=\"70\" class=\"donor-autocomplete\" md-floating-label=\"Donor (optional)\"><md-item-template><span \nmd-highlight-text=\"vm.searchDonor\">{{donor.name}}</span></md-item-template><div class=\"errors\" \nng-messages=\"reportForm.donor.$error\" ng-if=\"reportForm.donor.$touched || reportForm.$submitted\"><div \nng-message=\"md-require-match\">Please select an existing donor.</div></div></md-autocomplete></div><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block mb-10 select-location\" flex=\"30\"><label>Batch</label><md-select \nname=\"batch\" ng-disabled=\"!vm.batches.length\" ng-model=\"vm.template.filters.batch\" \nng-change=\"vm.presetSelectBatch(vm.template)\" placeholder=\"Batch\"><md-option ng-value=\"batch\" \nng-repeat=\"batch in vm.batches\">{{ batch.short_name }}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block mb-10 select-location\" flex=\"30\"><label>Base</label><md-select name=\"base\" \nng-disabled=\"!vm.bases.length || vm.currentUser.base_id\" ng-model=\"vm.template.filters.base\" \nng-change=\"vm.presetSelectBase(vm.template)\" placeholder=\"Base\"><md-option value=\"all\" ng-selected=\"true\">All Bases\n</md-option><md-option ng-value=\"base\" ng-repeat=\"base in vm.bases\">{{ base.name }}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block mb-10 select-location\" flex=\"30\"><label>Branch</label>\n<md-select name=\"branch\" ng-disabled=\"!vm.presetSelectedBase.branches.length || vm.currentUser.branch_id\" \nng-model=\"vm.template.filters.branch\" ng-change=\"vm.presetSelectBranch(vm.template)\" placeholder=\"Branch\"><md-option \nvalue=\"all\" ng-selected=\"true\">All Branches</md-option><md-option ng-value=\"branch\" \nng-repeat=\"branch in vm.presetSelectedBase.branches\">{{ branch.name }}</md-option></md-select></md-input-container>\n</div></form><div class=\"reports-container\"><div class=\"filters\">Filters</div><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"33\" flex-gt-xs=\"33\" flex-gt-md=\"33\"><span \nclass=\"widget-label\">Indicators</span><ms-widget-front class=\"white-bg widget-container auto-height\"><div \nclass=\"report-error\">{{vm.template.programMessage}}</div><div class=\"options-container\"><div \nng-repeat=\"program in vm.programs\"><md-checkbox flex=\"100\" flex-gt-md=\"100\" \nng-checked=\"vm.presetIsSelected(program.id)\" ng-click=\"vm.presetSelectFilter(program.id)\">{{program.name}}\n</md-checkbox></div></div></ms-widget-front></ms-widget></div><div class=\"reports-footer\" layout=\"row\" flex=\"99\" \nlayout-wrap><span class=\"preview\" ng-click=\"vm.presetShowPreview()\">Preview</span> <span \nclass=\"save-template pull-right\" ng-click=\"vm.editTemplate()\">Update Template</span> <span \nclass=\"save-template pull-right\" ng-click=\"vm.deleteTemplate()\">Delete Template</span></div></div></div><div \nclass=\"new-template\" ng-show=\"vm.newReport\"><form name=\"reportsForms\" class=\"md-inline-form\" novalidate><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block select\" flex><label>Program</label><md-select \nname=\"program_types\" ng-change=\"vm.selectProgram(vm.report)\" ng-model=\"vm.report.program_type\"><md-option value=\"all\" \nng-selected=\"true\">All Program Types</md-option><md-option ng-value=\"program.id\" \nng-repeat=\"program in vm.programTypes\">\n{{program.name}} &nbsp;&nbsp;-&nbsp;&nbsp; {{program.active ? \'Active\' : \'Inactive\'}}</md-option></md-select>\n</md-input-container><md-autocomplete md-input-name=\"donor\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedDonor\" md-selected-item-change=\"vm.selectDonorInNew(donor)\" \nmd-search-text=\"vm.searchDonor\" md-items=\"donor in vm.searchDonors(vm.searchDonor)\" md-item-text=\"donor.name\" \nmd-require-match flex=\"70\" class=\"donor-autocomplete\" md-floating-label=\"Donor (optional)\"><md-item-template><span \nmd-highlight-text=\"vm.searchDonor\">{{donor.name}}</span></md-item-template><div class=\"errors\" \nng-messages=\"reportsForms.donor.$error\" \nng-if=\"reportsForms.donor.$touched\r\n                         || reportsForms.$submitted\"><div \nng-message=\"md-require-match\">Please select an existing donor.</div></div></md-autocomplete></div><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block mb-10 select-location\" flex=\"30\"><label>Batch</label><md-select \nname=\"batch\" ng-disabled=\"!vm.batches.length\" ng-model=\"vm.report.batch\" ng-change=\"vm.selectBatch(vm.report)\" \nplaceholder=\"Batch\"><md-option ng-value=\"batch\" ng-repeat=\"batch in vm.batches\">{{ batch.short_name }}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block mb-10 select-location\" flex><label>Base</label>\n<md-select name=\"base\" ng-disabled=\"!vm.bases.length || vm.currentUser.base_id\" ng-model=\"vm.report.base\" \nng-change=\"vm.selectBase(vm.report)\" placeholder=\"Base\"><md-option value=\"all\" ng-selected=\"true\">All Bases</md-option>\n<md-option ng-value=\"base\" ng-repeat=\"base in vm.bases\">{{ base.name }}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block select-location\" flex><label>Branch</label><md-select name=\"branch\" \nng-disabled=\"!vm.selectedBase.branches.length || vm.currentUser.branch_id\" ng-model=\"vm.report.branch\" \nng-change=\"vm.selectBranch(vm.report)\" placeholder=\"Branch\"><md-option value=\"all\" ng-selected=\"true\">All Branches\n</md-option><md-option ng-value=\"branch\" ng-repeat=\"branch in vm.selectedBase.branches\">{{ branch.name }}</md-option>\n</md-select></md-input-container></div></form><div class=\"reports-container\"><div class=\"filters\">Filters</div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"33\" \nflex-gt-xs=\"33\" flex-gt-md=\"33\"><span class=\"widget-label\">Indicators</span><ms-widget-front \nclass=\"white-bg widget-container auto-height\"><div class=\"report-error\">{{vm.programMessage}}</div><div \nclass=\"options-container\"><div ng-repeat=\"program in vm.programs\"><md-checkbox flex=\"100\" flex-gt-md=\"100\" \nng-checked=\"vm.isSelected(program.id)\" ng-click=\"vm.selectFilter(program.id)\">{{program.name}}</md-checkbox></div>\n</div></ms-widget-front></ms-widget></div><div class=\"reports-footer\" layout=\"row\" flex=\"99\" layout-wrap><span \nclass=\"preview\" ng-click=\"vm.showPreview()\">Preview</span> <span class=\"save-template pull-right\" \nng-click=\"vm.saveTemplate()\">Save As Template</span></div></div></div></div>");
$templateCache.put("app/main/transform/dialogs/add-participant/add-participant-dialog.html","<style>\nmd-dialog.add-participant-dialog md-dialog-content label {\r\n        font-weight: unset !important;\r\n    }\r\n\r\n    md-input-container .md-placeholder,\r\n    md-input-container label:not(.md-no-float):not(.md-container-ignore) {\r\n        color: black !important;\r\n        opacity: 1 !important;\r\n        font-weight: 100% !important;\r\n    }\r\n\r\n    input::placeholder {\r\n        color: black !important;\r\n        opacity: 1 !important;\r\n        font-weight: unset !important;\r\n    }\r\n\r\n    md-select.md-default-theme .md-select-value.md-select-placeholder,\r\n    md-select .md-select-value.md-select-placeholder {\r\n        color: black !important;\r\n    }\r\n\r\n    .table_sec1,\r\n    .table_sec1 th,\r\n    .table_sec1 td {\r\n        border: 2px solid black;\r\n        border-collapse: collapse;\r\n    }\r\n\r\n    .table_sec1 td {\r\n        padding: 18px 10px !important;\r\n    }\r\n\r\n    .td_w50 td {\r\n        width: 50%;\r\n    }\r\n\r\n    .table_sec2_radio md-radio-button .md-label {\r\n        margin-left: 15px !important;\r\n    }\r\n\r\n    .table_sec1 th {\r\n        text-align: center;\r\n        font-weight: bolder !important;\r\n        color: #000 !important;\r\n        padding: 18px 10px !important;\r\n    }\r\n\r\n    .spacebw {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n    }\r\n\r\n    .center_item {\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n\r\n    .center {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n\r\n    .dropdownItems md-radio-button .md-label {\r\n        margin-left: 14px !important;\r\n    }\r\n\r\n    .margin_b {\r\n        margin-bottom: 15px;\r\n    }\r\n\r\n    .t_head {\r\n        background: #cfcfcf;\r\n    }\n</style><md-dialog class=\"add-participant-dialog transform-dialog\" aria-label=\"New Message\"><form \nname=\"editParticipantForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.addParticipant(vm.participant)\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div><md-switch \nng-true-value=\"1\" ng-false-value=\"0\" class=\"mb-0 mt-0\" layout-align=\"center center\" ng-model=\"vm.participant.toggle\" \naria-label=\"Switch 1\"><h6 class=\"black\">Use Poverty Score Card</h6></md-switch></div><div layout-gt-xs=\"row\" \nclass=\"partner-pastor\">Partner Pastor: &nbsp; <span>{{vm.pastor.firstname}} {{vm.pastor.lastname}}</span></div><div \nlayout-gt-xs=\"row\" class=\"checkbox-row\"><div flex-gt-xs><div layout-gt-xs=\"row\"><div><h5 class=\"mb-0 mt-10\">Category:\n</h5></div><div class=\"selection\"><md-input-container class=\"md-block mb-0 mt-0\"><md-radio-group \nng-model=\"vm.participant.isCounselor\" layout=\"row\" ng-change=\"vm.onParticipantTypeChange()\" required name=\"counselors\">\n<md-radio-button class=\"md-primary\" ng-value=\"1\">Counselor</md-radio-button><md-radio-button class=\"md-primary\" \nng-value=\"0\">Participant</md-radio-button><md-radio-button class=\"md-primary\" ng-value=\"-1\">Visitor</md-radio-button>\n<md-checkbox ng-show=\"vm.participant.isCounselor !== -1\" \nng-checked=\"vm.isReplacement && vm.participant.isCounselor !== -1\" \nng-click=\"vm.isReplacement = !vm.isReplacement;\r\n                                            vm.checked = true;\">\nIs replacement?</md-checkbox></md-radio-group><div ng-messages=\"editParticipantForm.counselors.$error\" \nng-show=\"editParticipantForm.counselors.$touched\r\n                                     || editParticipantForm.$submitted\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div></div></md-input-container></div></div></div></div>\n<div layout-gt-xs=\"row\" class=\"use-existing-select-row\" ng-show=\"vm.participant.isCounselor.is_counselor === 1\">\n<md-checkbox ng-checked=\"vm.useExisting\" ng-click=\"vm.clickUseExisting()\">Use existing counselor?</md-checkbox></div>\n<div layout-gt-xs=\"row\" ng-show=\"vm.useExisting && vm.participant.isCounselor.is_counselor === 1\" \nclass=\"use-existing-row\"><md-autocomplete flex md-input-name=\"counselor\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedCounselor\" md-selected-item-change=\"vm.selectCounselor(counselor)\" \nmd-search-text=\"vm.searchCounselor\" md-items=\"counselor in vm.searchCounselors(vm.searchCounselor)\" \nmd-item-text=\"counselor.firstname + \' \' + counselor.lastname\" md-require-match ng-required=\"vm.useExisting\" \nmd-floating-label=\"Counselor\"><md-item-template><span md-highlight-text=\"vm.searchCounselor\">\n{{counselor.firstname}} {{counselor.lastname}}</span></md-item-template><div class=\"errors\" \nng-messages=\"editParticipantForm.counselor.$error\" \nng-if=\"editParticipantForm.counselor.$touched\r\n                         || editParticipantForm.$submitted\"><div \nng-message=\"md-require-match\">Please select an existing counselor.</div></div></md-autocomplete></div><div \nlayout-gt-xs=\"row\" class=\"firstname-row\"><md-input-container class=\"md-block\" flex-gt-xs><input name=\"firstname\" \nng-model=\"vm.participant.firstName\" placeholder=\"First Name\" maxlength=\"30\" ng-disabled=\"vm.useExisting\" required><div \nng-messages=\"editParticipantForm.firstname.$error\" ng-show=\"editParticipantForm.firstname.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-xs><input name=\"middlename\" ng-model=\"vm.participant.middleName\" maxlength=\"30\" style=\"color:black\" \nng-disabled=\"vm.useExisting\" placeholder=\"Middle Name\"></md-input-container></div><div layout-gt-xs=\"row\" class=\"mb-0\">\n<md-input-container class=\"md-block\" flex-gt-xs><input name=\"lastname\" ng-model=\"vm.participant.lastName\" \nmaxlength=\"30\" ng-disabled=\"vm.useExisting\" placeholder=\"Last Name\" required><div \nng-messages=\"editParticipantForm.lastname.$error\" ng-show=\"editParticipantForm.lastname.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-xs><input name=\"suffix\" ng-model=\"vm.participant.suffix\" maxlength=\"20\" ng-disabled=\"vm.useExisting\" \nclass=\"custom-input\" placeholder=\"Nickname\"></md-input-container></div><div layout-gt-xs=\"row\" \nclass=\"mt-10 gender-row\"><div flex-gt-xs><div layout-gt-xs=\"row\"><div><h5 class=\"mt-0 mb-0 gender-text\">\nGender of Participant</h5></div></div><div layout-gt-xs=\"row\" class=\"black\"><div><md-radio-group \nng-model=\"vm.participant.gender\" required ng-disabled=\"vm.useExisting\" layout=\"row\"><md-radio-button \nng-repeat=\"gender in vm.genders\" class=\"md-primary\" flex-gt-xs ng-value=\"gender.value\">{{gender.label}}\n</md-radio-button></md-radio-group></div></div></div><div flex-gt-xs><md-input-container \nclass=\"md-block datepicker mb-0\"><md-datepicker ng-model=\"vm.participant.birthdate\" name=\"participantbdate\" \nmd-open-on-focus ng-disabled=\"vm.useExisting\" md-input-name=\"participantbdate\" md-placeholder=\"Date of Birth\" \nmd-max-date=\"vm.maxDate\"></md-datepicker><div class=\"errors\" ng-messages=\"editParticipantForm.participantbdate.$error\">\n<div ng-message=\"valid\" class=\"date-error\">The entered value is not a date!</div><div ng-message=\"max\" \nclass=\"date-error\">You must be at least 13 years old!</div></div></md-input-container></div></div><h5 \nclass=\"label-sep\">Following data is required for participants and counselors only.</h5><div layout-gt-xs=\"row\" \nstyle=\"width: 50%\"><md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"phonenumber\" type=\"tel\" \nng-disabled=\"vm.useExisting\" ng-model=\"vm.participant.phoneNumber\" placeholder=\"Phone Number\"><div \nng-messages=\"editParticipantForm.phonenumber.$error\" \nng-show=\"editParticipantForm.phonenumber.$touched\r\n                         || editParticipantForm.$submitted || vm.errorPhone\" \nrole=\"alert\"><div ng-bind=\"vm.errorPhone\"></div></div></md-input-container></div><div class=\"toggle-on\"><table \nclass=\"table mb-0\"><tr><td class=\"radio-container privacy-member\">PhilHealth Member?</td><td \nclass=\"radio-data privacy-data\"><md-radio-group ng-model=\"vm.participant.philhealth_member\" layout=\"row\" \nname=\"philhealth_member\"><md-radio-button class=\"md-primary\" ng-value=\"1\">Yes</md-radio-button><md-radio-button \nclass=\"md-primary\" ng-value=\"0\">No</md-radio-button></md-radio-group></td></tr><tr><td class=\"radio-container\">\n4P\'s member?</td><td class=\"radio-data\"><md-radio-group ng-model=\"vm.participant.p4\" layout=\"row\" name=\"p4\">\n<md-radio-button class=\"md-primary\" ng-value=\"1\">Yes</md-radio-button><md-radio-button class=\"md-primary\" ng-value=\"0\">\nNo</md-radio-button></md-radio-group><div class=\"error-message\">{{vm.has4psError}}</div></td></tr><tr><td \nclass=\"radio-container\">Are there any household members without birth registration?</td><td class=\"radio-data\">\n<md-radio-group ng-model=\"vm.participant.householdMembers\" layout=\"row\" name=\"householdmembers\"><md-radio-button \nclass=\"md-primary\" ng-value=\"1\">Yes</md-radio-button><md-radio-button class=\"md-primary\" ng-value=\"0\">No\n</md-radio-button></md-radio-group><div class=\"error-message\">{{vm.hasNoBirthRegError}}</div></td></tr><tr><td \nclass=\"radio-container\">Civil Status</td><td class=\"radio-data\"><md-input-container class=\"md-block\"><md-select \nname=\"civil_status\" placeholder=\"Please select\" ng-model=\"vm.participant.civil_status\" \nng-required=\"!vm.participant.is_visitor\"><md-option ng-repeat=\"item in vm.civilStatuses\" ng-value=\"item.value\">\n{{item.label}}</md-option></md-select><div class=\"errors\" ng-messages=\"editParticipantForm.civil_status.$error\"><div \nng-message=\"required\">Required</div></div></md-input-container></td></tr><tr \nng-show=\"vm.participant.civil_status == \'live_in\'\"><td class=\"radio-container\">Do you want to process CENOMAR?</td><td \nclass=\"radio-data\"><md-radio-group ng-model=\"vm.participant.certificate\" layout=\"row\" name=\"certificate\" \nng-required=\"vm.participant.married === 1\"><md-radio-button class=\"md-primary\" ng-value=\"1\">Yes</md-radio-button>\n<md-radio-button class=\"md-primary\" ng-value=\"0\">No</md-radio-button></md-radio-group><div class=\"error-message\">\n{{vm.errorCertificate}}</div></td></tr><tr><td class=\"radio-container\">\nHow many people usually live in your house and share food and income?</td><td><md-input-container \nclass=\"md-block mb-0\"><input name=\"peoplelive\" ng-model=\"vm.participant.peopleLive\" type=\"number\" min=\"1\" max=\"30\" \nmaxlength=\"3\" ng-required=\"vm.participant.toggle === 1\"><div ng-messages=\"editParticipantForm.peoplelive.$error\" \nng-show=\"editParticipantForm.peoplelive.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Required</span></div>\n<div ng-message=\"number\"><span>Invalid number</span></div><div ng-message=\"min\">Invalid number</div><div \nng-message=\"max\">Invalid number</div><div ng-message=\"maxlength\">Exceeds limit</div></div></md-input-container></td>\n</tr></table><h4 \nng-show=\"vm.toAddChildren.length > 0 && vm.community.application.program.name === \'Transform with FA\'\" \nclass=\"black mt-10 fw-bold\">Children</h4><div ng-repeat=\"child in vm.toAddChildren\" \nng-show=\"vm.community.application.program.name === \'Transform with FA\'\"><ng-form name=\"childFieldForm\"><div \nlayout=\"row\"><md-input-container class=\"md-block\" flex=\"30\"><input name=\"firstname\" ng-model=\"child.firstname\" \nplaceholder=\"First Name\" maxlength=\"30\" required ng-disabled=\"vm.isEditParticipant\"><div \nng-messages=\"childFieldForm.firstname.$error\" ng-show=\"childFieldForm.firstname.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div></div></md-input-container><md-input-container class=\"md-block\" \nflex=\"30\"><input name=\"lastname\" ng-model=\"child.lastname\" placeholder=\"Last Name\" maxlength=\"30\" required \nng-disabled=\"vm.isEditParticipant\"><div ng-messages=\"childFieldForm.lastname.$error\" \nng-show=\"childFieldForm.lastname.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex=\"30\"><md-select name=\"relationship\" \nplaceholder=\"Please select\" ng-model=\"child.relationship\"><md-option ng-repeat=\"item in vm.childRelationships\" \nng-value=\"item.value\" ng-click=\"child.is_other_relationship = 0\">{{item.label}}</md-option><md-option \nng-model=\"child.relationship\" value=\"other\">Other</md-option></md-select><div class=\"errors\" \nng-messages=\"editParticipantForm[\'form\' + $index].$error\"><div ng-message=\"required\">Required</div></div>\n</md-input-container><md-input-container class=\"md-block\" flex=\"30\" ng-show=\"child.relationship == \'other\'\"><input \nname=\"other_relationship\" ng-model=\"child.other_relationship\" placeholder=\"Relationship\" maxlength=\"30\" \nng-required=\"child.relationship == \'other\'\"><div ng-messages=\"childFieldForm.other_relationship.$error\" \nng-show=\"childFieldForm.other_relationship.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Required</span>\n</div></div></md-input-container></div><div layout=\"row\"><div flex=\"30\" class=\"ml-10\"><div layout-gt-xs=\"row\"><div><h6 \nclass=\"mt-0 mb-0 gender-text\">Gender:</h6></div></div><div layout-gt-xs=\"row\" class=\"black mt-0\"><div><md-radio-group \nng-model=\"child.gender\" class=\"child-gender\" layout=\"row\"><md-radio-button ng-repeat=\"gender in vm.genders\" \nclass=\"md-primary\" flex-gt-xs ng-value=\"gender.value\">{{gender.label}}</md-radio-button></md-radio-group></div></div>\n</div><md-input-container flex=\"30\" class=\"md-block datepicker mb-0\"><md-datepicker ng-model=\"child.birthdate\" \nname=\"participantbdate\" md-open-on-focus md-input-name=\"participantbdate\" md-placeholder=\"Date of Birth\">\n</md-datepicker><div class=\"errors\" \nng-messages=\"childFieldForm.participantbdate.$error || vm.apiErrors[\'children.\' + $index + \'.birthdate\']\"><div \nng-message=\"valid\" class=\"date-error\">The entered value is not a date!</div><div \nng-bind=\"vm.apiErrors[\'children.\' + $index + \'.birthdate\']\"></div></div></md-input-container><div flex=\"10\" \nclass=\"mt-15 remove-child-container\"><i class=\"icon-trash\" flex=\"10\" ng-click=\"vm.removeChild(child)\"><md-tooltip \nmd-direction=\"left\">Remove child</md-tooltip></i></div></div></ng-form></div><div layout=\"row\" \nng-show=\"vm.community.application.program.name === \'Transform with FA\'\"><md-button md-no-ink \nclass=\"md-primary add-new-pastor add-pastor\" ng-click=\"vm.addChild()\">ADD CHILD (3-5 yrs. old)</md-button></div><table \nclass=\"table mb-0\"><tr ng-repeat=\"dropDownItem in vm.dropdownItems\"><td class=\"dropdown-question\">\n{{dropDownItem.question}}</td><td class=\"dropdown-item\"><md-input-container class=\"md-block\"><md-select \nname=\"form{{$index}}\" placeholder=\"Please choose\" ng-required=\"vm.participant.toggle === 1\" \nng-model=\"vm.participant[dropDownItem.key]\"><md-option ng-repeat=\"item in dropDownItem.items\" ng-value=\"item.value\" \nng-if=\"dropDownItem.key != \'wall\' || (dropDownItem.key == \'wall\' && item.value != \'wood\' && item.value != \'bamboo\')\">\n{{item.label}}</md-option></md-select><div class=\"errors\" ng-messages=\"editParticipantForm[\'form\' + $index].$error\">\n<div ng-message=\"required\">Required</div></div></md-input-container></td></tr><tr \nng-repeat=\"checkBoxItem in vm.checkBoxItems\"><td>{{checkBoxItem.question}}<div class=\"gray-text\">Select all that apply\n</div></td><td><div flex=\"100\" flex-gt-sm=\"100\" layout=\"column\"><div><fieldset class=\"standard\"><div layout=\"row\" \nlayout-wrap flex><div flex=\"50\" ng-repeat=\"item in checkBoxItem.items\"><md-checkbox \nng-checked=\"vm.isSelected(checkBoxItem.key, item.value)\" ng-click=\"vm.toggleCheckBox(checkBoxItem.key, item.value)\">\n{{ item.label }}</md-checkbox></div></div></fieldset></div></div></td></tr><tr><td>Transport<div class=\"gray-text\">\nSelect all that apply</div></td><td><div flex=\"100\" flex-gt-sm=\"100\" layout=\"column\"><div><fieldset class=\"standard\">\n<div layout=\"row\" layout-wrap flex><div flex=\"50\" class=\"options\" ng-repeat=\"item in vm.transports\" \nng-if=\"$index < vm.transports.length-1\"><md-checkbox ng-disabled=\"vm.othersDisabled\" \nng-checked=\"vm.isSelected(\'transport\', item.value)\" ng-click=\"vm.toggleCheckBox(\'transport\', item.value);\">\n{{ item.label }}</md-checkbox></div><div flex=\"50\" class=\"options\"><md-checkbox \nng-click=\"vm.toggleCheckBox(\'transport\', \'none\'); vm.othersDisabled = !vm.othersDisabled\" \nng-checked=\"vm.isSelected(\'transport\', \'none\')\" ng-disabled=\"vm.noneDisabled\">None</md-checkbox></div></div></fieldset>\n</div></div></td></tr></table><table class=\"table mb-0\"><tr><td class=\"radio-container\">\nHow many telephones/mobile phones does the family own?</td><td><md-input-container class=\"md-block mb-0\"><input \nname=\"telephones\" ng-model=\"vm.participant.telephones\" type=\"number\" min=\"0\" ng-required=\"vm.participant.toggle === 1\">\n<div ng-messages=\"editParticipantForm.telephones.$error\" ng-show=\"editParticipantForm.telephones.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-message=\"number\"><span>Invalid number</span>\n</div><div ng-message=\"min\">Invalid number</div></div></md-input-container></td></tr></table><hr><div><h5 \nclass=\"label-sep\">Information Regarding the HouseHold Head</h5><div class=\"household_con\" \nstyle=\"display: flex;\r\n                    justify-content: space-between;\r\n                    align-items: baseline\">\n<div style=\"font-size: 13px;\r\n                        color: #000\">is the Program participant the household head ?\n</div><div><md-radio-group ng-model=\"vm.participant.is_participants_household_head\" required \nng-change=\"vm.onHouseholdParticipantKnowChange()\" layout=\"row\" name=\"is_participants_household_head\"><md-radio-button \nclass=\"md-primary\" ng-value=\"1\">Yes</md-radio-button><md-radio-button class=\"md-primary\" ng-value=\"0\">No\n</md-radio-button></md-radio-group><div class=\"error-message\">{{vm.hasNoBirthRegError}}</div></div></div></div><div \nng-show=\"vm.participant.is_participants_household_head === 0\"><hr><div style=\"font-size: 13px; color: #000\">\nName of Head of Household (please write in BLOCK LETTERS)</div><div layout-gt-xs=\"row\" class=\"firstname-row\">\n<md-input-container class=\"md-block\" flex-gt-xs><input name=\"house_hold_first_name\" \nng-model=\"vm.participant.house_hold_first_name\" placeholder=\"First Name\" maxlength=\"25\" ng-disabled=\"vm.useExisting\" \nng-required=\"vm.house_hold_field_validation\"><div ng-messages=\"editParticipantForm.house_hold_first_name.$error\" \nng-show=\"editParticipantForm.house_hold_first_name.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Required\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-xs><input \nname=\"house_hold_middle_name\" ng-model=\"vm.participant.house_hold_middle_name\" maxlength=\"\" \nng-disabled=\"vm.useExisting\" placeholder=\"Middle Name\"></md-input-container><md-input-container class=\"md-block\" \nflex-gt-xs><input name=\"house_hold_last_name\" ng-model=\"vm.participant.house_hold_last_name\" \nng-disabled=\"vm.useExisting\" placeholder=\"Last Name\" ng-required=\"vm.house_hold_field_validation\"><div \nng-messages=\"editParticipantForm.house_hold_last_name.$error\" \nng-show=\"editParticipantForm.house_hold_last_name.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Required\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-xs><input \nname=\"house_hold_suffix\" ng-model=\"vm.participant.house_hold_suffix\" ng-disabled=\"vm.useExisting\" \nplaceholder=\"Nickname\"></md-input-container></div><table class=\"table mb-0\"><tr><td class=\"radio-container\">\nParticipant\'s relation to household head</td><td class=\"radio-data\"><md-radio-group \nng-model=\"vm.participant.house_hold_relation\" ng-required=\"vm.house_hold_field_validation\" layout=\"row\" \nname=\"house_hold_relation\"><md-radio-button class=\"md-primary\" ng-value=\"0\">Spouse</md-radio-button><md-radio-button \nclass=\"md-primary\" ng-value=\"1\">Son/Daughter</md-radio-button><md-radio-button class=\"md-primary\" ng-value=\"2\">\nParent/In-Law</md-radio-button><md-radio-button class=\"md-primary\" ng-value=\"3\">Others</md-radio-button>\n</md-radio-group><div class=\"error-message\">{{vm.hasNoBirthRegError}}</div></td></tr><tr><td class=\"radio-container\">\nGender of Household Head</td><td class=\"radio-data\"><md-radio-group ng-model=\"vm.participant.house_hold_gender\" \nng-required=\"vm.house_hold_field_validation\" layout=\"row\" name=\"house_hold_gender\" style=\"justify-content: end\">\n<md-radio-button ng-repeat=\"gender in vm.genders\" class=\"md-primary\" flex-gt-xs ng-value=\"gender.value\">\n{{gender.label}}</md-radio-button></md-radio-group><div class=\"error-message\">{{vm.hasNoBirthRegError}}</div></td></tr>\n</table></div><div layout-gt-xs=\"row\" style=\"width: 50%\"><md-input-container class=\"md-block mb-0\" flex-gt-xs><input \nname=\"income\" ng-model=\"vm.participant.income\" placeholder=\"What is typical 30 day household income?\" type=\"number\" \nclass=\"income\" ng-disabled=\"vm.useExisting\" min=\"1\" max=\"100000\" ng-required=\"vm.participant.toggle\"><div \nng-messages=\"editParticipantForm.income.$error\" ng-show=\"editParticipantForm.income.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-message=\"number\"><span>Invalid number</span></div><div \nng-message=\"min\">Invalid number</div><div ng-message=\"max\">Invalid number</div></div></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"(editParticipantForm.$invalid\r\n                       || editParticipantForm.$pristine || vm.saving)\" \ntype=\"submit\"><span ng-show=\"!vm.saving\">Add {{ vm.participant.is_visitor ? \"Visitor\" : \"Participant\" }}</span> <span \nng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting\n</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/transform/dialogs/add-participant-in-selection/add-participant-in-selection-dialog.html","<style>\nmd-dialog.add-participant-dialog md-dialog-content label {\r\n        font-weight: unset !important;\r\n    }\r\n\r\n    md-input-container .md-placeholder,\r\n    md-input-container label:not(.md-no-float):not(.md-container-ignore) {\r\n        color: black !important;\r\n        opacity: 1 !important;\r\n        font-weight: 100% !important;\r\n    }\r\n\r\n    input::placeholder {\r\n        color: black !important;\r\n        opacity: 1 !important;\r\n        font-weight: unset !important;\r\n    }\r\n\r\n    md-select.md-default-theme .md-select-value.md-select-placeholder,\r\n    md-select .md-select-value.md-select-placeholder {\r\n        color: black !important;\r\n    }\r\n\r\n    .table_sec1,\r\n    .table_sec1 th,\r\n    .table_sec1 td {\r\n        border: 2px solid black;\r\n        border-collapse: collapse;\r\n    }\r\n\r\n    .table_sec1 td {\r\n        padding: 18px 10px !important;\r\n    }\r\n\r\n    .td_w50 td {\r\n        width: 50%;\r\n    }\r\n\r\n    .table_sec2_radio md-radio-button .md-label {\r\n        margin-left: 15px !important;\r\n    }\r\n\r\n    .table_sec1 th {\r\n        text-align: center;\r\n        font-weight: bolder !important;\r\n        color: #000 !important;\r\n        padding: 18px 10px !important;\r\n    }\r\n\r\n    .spacebw {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n    }\r\n\r\n    .center_item {\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n\r\n    .center {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n\r\n    .dropdownItems md-radio-button .md-label {\r\n        margin-left: 14px !important;\r\n    }\r\n\r\n    .margin_b {\r\n        margin-bottom: 15px;\r\n    }\r\n\r\n    .t_head {\r\n        background: #cfcfcf;\r\n    }\n</style><md-dialog class=\"add-participant-dialog transform-dialog\" aria-label=\"New Message\"><form \nname=\"editParticipantForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.addParticipant(vm.participant)\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div><md-switch \nng-true-value=\"1\" ng-false-value=\"0\" class=\"mt-0 mb-0\" layout-align=\"center center\" ng-model=\"vm.participant.toggle\" \naria-label=\"Switch 1\"><h6 class=\"black\">Use Poverty Score Card</h6></md-switch></div><div layout-gt-xs=\"row\" \nclass=\"partner-pastor\">Partner Pastor: &nbsp; <span>{{vm.pastor.firstname}} {{vm.pastor.lastname}}</span></div><div \nlayout-gt-xs=\"row\" class=\"checkbox-row\"><div flex-gt-xs><div layout-gt-xs=\"row\"><div><h5 class=\"mb-0 mt-0\">Category:\n</h5></div><div class=\"selection\"><md-input-container class=\"md-block mb-0 mt-0\"><md-radio-group \nng-model=\"vm.participant.isCounselor\" layout=\"row\" ng-change=\"vm.onParticipantTypeChange()\" required name=\"counselor\">\n<md-radio-button class=\"md-primary\" ng-value=\"{is_counselor: 1}\">Counselor</md-radio-button><md-radio-button \nclass=\"md-primary\" ng-value=\"{is_participant: 1}\">Participant</md-radio-button><md-checkbox \nng-checked=\"vm.isReplacement\" \nng-click=\"vm.isReplacement = !vm.isReplacement;\r\n                                            vm.checked = true;\">\nIs replacement?</md-checkbox></md-radio-group><div ng-messages=\"editParticipantForm.counselor.$error\" \nng-show=\"editParticipantForm.counselor.$touched\r\n                                     || editParticipantForm.$submitted\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div></div></md-input-container></div></div></div></div>\n<div layout-gt-xs=\"row\" class=\"use-existing-select-row\" ng-show=\"vm.participant.isCounselor.is_counselor === 1\">\n<md-checkbox ng-checked=\"vm.useExisting\" ng-click=\"vm.useExisting = !vm.useExisting\">Use existing counselor?\n</md-checkbox></div><div layout-gt-xs=\"row\" class=\"use-existing-row\" ng-show=\"vm.useExisting\"><md-autocomplete flex \nmd-input-name=\"counselor\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedCounselor\" \nmd-selected-item-change=\"vm.selectCounselor(counselor)\" md-search-text=\"vm.searchCounselor\" \nmd-items=\"counselor in vm.searchCounselors(vm.searchCounselor)\" \nmd-item-text=\"counselor.firstname + \' \' + counselor.lastname\" md-require-match md-floating-label=\"Counselor\">\n<md-item-template><span md-highlight-text=\"vm.searchCounselor\">{{counselor.firstname}} {{counselor.lastname}}</span>\n</md-item-template><div class=\"errors\" ng-messages=\"editParticipantForm.counselor.$error\" \nng-if=\"editParticipantForm.counselor.$touched\r\n                         || editParticipantForm.$submitted\"><div \nng-message=\"md-require-match\">Please select an existing counselor.</div></div></md-autocomplete></div><div \nlayout-gt-xs=\"row\" class=\"mb-0 firstname-row\"><md-input-container class=\"md-block\" flex-gt-xs><input name=\"firstname\" \nng-model=\"vm.participant.firstName\" placeholder=\"First Name\" maxlength=\"30\" ng-disabled=\"vm.useExisting\" required><div \nng-messages=\"editParticipantForm.firstname.$error\" ng-show=\"editParticipantForm.firstname.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-xs><input name=\"middlename\" ng-model=\"vm.participant.middleName\" maxlength=\"30\" ng-disabled=\"vm.useExisting\" \nplaceholder=\"Middle Name\"></md-input-container></div><div layout-gt-xs=\"row\" class=\"mb-0\"><md-input-container \nclass=\"md-block\" flex-gt-xs><input name=\"lastname\" ng-model=\"vm.participant.lastName\" maxlength=\"30\" \nng-disabled=\"vm.useExisting\" placeholder=\"Last Name\" required><div ng-messages=\"editParticipantForm.lastname.$error\" \nng-show=\"editParticipantForm.lastname.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Required</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" flex-gt-xs><input name=\"suffix\" \nng-model=\"vm.participant.suffix\" maxlength=\"20\" ng-disabled=\"vm.useExisting\" placeholder=\"Nickname\">\n</md-input-container></div><div layout-gt-xs=\"row\" class=\"mt-10 gender-row\"><div flex-gt-xs><div layout-gt-xs=\"row\">\n<div><h5 class=\"mt-0 mb-0 gender-text\">Gender:</h5></div></div><div layout-gt-xs=\"row\" class=\"black\"><div>\n<md-radio-group ng-model=\"vm.participant.gender\" required ng-disabled=\"vm.useExisting\" layout=\"row\"><md-radio-button \nng-repeat=\"gender in vm.genders\" class=\"md-primary\" flex-gt-xs ng-value=\"gender.value\">{{gender.label}}\n</md-radio-button></md-radio-group></div></div></div><div flex-gt-xs><md-input-container \nclass=\"md-block datepicker mb-0\"><md-datepicker ng-model=\"vm.participant.birthdate\" name=\"participantbdate\" \nmd-open-on-focus ng-disabled=\"vm.useExisting\" md-input-name=\"participantbdate\" md-placeholder=\"Date of Birth\" \nmd-max-date=\"vm.maxDate\"></md-datepicker><div class=\"errors\" ng-messages=\"editParticipantForm.participantbdate.$error\">\n<div ng-message=\"valid\" class=\"date-error\">The entered value is not a date!</div><div ng-message=\"max\" \nclass=\"date-error\">You must be at least 13 years old!</div></div></md-input-container></div></div><div \nlayout-gt-xs=\"row\" style=\"width: 50%\"><md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"phonenumber\" \ntype=\"tel\" ng-disabled=\"vm.useExisting\" ng-model=\"vm.participant.phoneNumber\" placeholder=\"Phone Number\"><div \nng-messages=\"editParticipantForm.phonenumber.$error\" \nng-show=\"editParticipantForm.phonenumber.$touched\r\n                         || editParticipantForm.$submitted || vm.errorPhone\" \nrole=\"alert\"><div ng-bind=\"vm.errorPhone\"></div></div></md-input-container></div><div class=\"toggle-on\"><table \nclass=\"table mb-0\"><tr><td class=\"radio-container privacy-member\">PhilHealth Member?</td><td \nclass=\"radio-data privacy-data\"><md-radio-group ng-model=\"vm.participant.philhealth_member\" layout=\"row\" \nname=\"philhealth_member\"><md-radio-button class=\"md-primary\" ng-value=\"1\">Yes</md-radio-button><md-radio-button \nclass=\"md-primary\" ng-value=\"0\">No</md-radio-button></md-radio-group></td></tr><tr><td class=\"radio-container\">\n4P\'s member?</td><td class=\"radio-data\"><md-radio-group ng-model=\"vm.participant.p4\" layout=\"row\" name=\"p4\">\n<md-radio-button class=\"md-primary\" ng-value=\"1\">Yes</md-radio-button><md-radio-button class=\"md-primary\" ng-value=\"0\">\nNo</md-radio-button></md-radio-group><div class=\"error-message\">{{vm.has4psError}}</div></td></tr><tr><td \nclass=\"radio-container\">Are there any household members without birth registration?</td><td class=\"radio-data\">\n<md-radio-group ng-model=\"vm.participant.householdMembers\" layout=\"row\" name=\"householdmembers\"><md-radio-button \nclass=\"md-primary\" ng-value=\"1\">Yes</md-radio-button><md-radio-button class=\"md-primary\" ng-value=\"0\">No\n</md-radio-button></md-radio-group><div class=\"error-message\">{{vm.hasNoBirthRegError}}</div></td></tr><tr><td \nclass=\"radio-container\">Civil Status</td><td class=\"radio-data\"><md-input-container class=\"md-block\"><md-select \nname=\"civil_status\" placeholder=\"Please select\" ng-model=\"vm.participant.civil_status\" required><md-option \nng-repeat=\"item in vm.civilStatuses\" ng-value=\"item.value\">{{item.label}}</md-option></md-select><div class=\"errors\" \nng-messages=\"editParticipantForm.civil_status.$error\"><div ng-message=\"required\">Required</div></div>\n</md-input-container></td></tr><tr ng-show=\"vm.participant.civil_status == \'live_in\'\"><td class=\"radio-container\">\nDo you want to process CENOMAR?</td><td class=\"radio-data\"><md-radio-group ng-model=\"vm.participant.certificate\" \nlayout=\"row\" name=\"certificate\" ng-required=\"vm.participant.married === 1\"><md-radio-button class=\"md-primary\" \nng-value=\"1\">Yes</md-radio-button><md-radio-button class=\"md-primary\" ng-value=\"0\">No</md-radio-button>\n</md-radio-group><div class=\"error-message\">{{vm.errorCertificate}}</div></td></tr><tr><td class=\"radio-container\">\nHow many people usually live in your house and share food and income?</td><td><md-input-container \nclass=\"md-block mb-0\"><input name=\"peoplelive\" ng-model=\"vm.participant.peopleLive\" type=\"number\" min=\"0\" \nmaxlength=\"3\" ng-required=\"vm.participant.toggle === 1\"><div ng-messages=\"editParticipantForm.peoplelive.$error\" \nng-show=\"editParticipantForm.peoplelive.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Required</span></div>\n<div ng-message=\"number\"><span>Invalid number</span></div><div ng-message=\"min\">Invalid number</div><div \nng-message=\"maxlength\">Exceeds limit</div></div></md-input-container></td></tr></table><h4 \nng-show=\"vm.toAddChildren.length > 0 && vm.application.program.name === \'Transform with FA\'\" \nclass=\"black mt-10 fw-bold\">Children</h4><div ng-repeat=\"child in vm.toAddChildren\" \nng-show=\"vm.application.program.name === \'Transform with FA\'\"><hr><ng-form name=\"childFieldForm\"><div layout=\"row\">\n<md-input-container class=\"md-block\" flex=\"30\"><input name=\"childname\" ng-model=\"child.name\" placeholder=\"Child Name\" \nmaxlength=\"30\" required><div ng-messages=\"childFieldForm.childname.$error\" ng-show=\"childFieldForm.childname.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex=\"30\"><md-select name=\"relationship\" placeholder=\"Please select\" ng-model=\"child.relationship\">\n<md-option ng-repeat=\"item in vm.childRelationships\" ng-value=\"item.value\" ng-click=\"child.is_other_relationship = 0\">\n{{item.label}}</md-option><md-option ng-model=\"child.relationship\" value=\"other\">Other</md-option></md-select><div \nclass=\"errors\" ng-messages=\"editParticipantForm[\'form\' + $index].$error\"><div ng-message=\"required\">Required</div>\n</div></md-input-container><md-input-container class=\"md-block\" flex=\"30\" ng-show=\"child.relationship == \'other\'\">\n<input name=\"other_relationship\" ng-model=\"child.other_relationship\" placeholder=\"Relationship\" maxlength=\"30\" \nng-required=\"child.relationship == \'other\'\"><div ng-messages=\"childFieldForm.other_relationship.$error\" \nng-show=\"childFieldForm.other_relationship.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Required</span>\n</div></div></md-input-container></div><div layout=\"row\"><div flex=\"30\" class=\"ml-10\"><div layout-gt-xs=\"row\"><div><h6 \nclass=\"mt-0 mb-0 gender-text\">Gender:</h6></div></div><div layout-gt-xs=\"row\" class=\"black mt-0\"><div><md-radio-group \nng-model=\"child.gender\" class=\"child-gender\" layout=\"row\"><md-radio-button ng-repeat=\"gender in vm.genders\" \nclass=\"md-primary\" flex-gt-xs ng-value=\"gender.value\">{{gender.label}}</md-radio-button></md-radio-group></div></div>\n</div><md-input-container flex=\"30\" class=\"md-block datepicker mb-0\"><md-datepicker ng-model=\"child.birthdate\" \nname=\"participantbdate\" md-open-on-focus md-input-name=\"participantbdate\" md-placeholder=\"Date of Birth\">\n</md-datepicker><div class=\"errors\" \nng-messages=\"childFieldForm.participantbdate.$error || vm.apiErrors[\'children.\' + $index + \'.birthdate\']\"><div \nng-message=\"valid\" class=\"date-error\">The entered value is not a date!</div><div \nng-bind=\"vm.apiErrors[\'children.\' + $index + \'.birthdate\']\"></div></div></md-input-container><div flex=\"10\" \nclass=\"mt-15 remove-child-container\"><i class=\"icon-trash\" flex=\"10\" ng-click=\"vm.removeChild(child)\"><md-tooltip \nmd-direction=\"left\">Remove child</md-tooltip></i></div></div></ng-form></div><div layout=\"row\" \nng-show=\"vm.application.program.name === \'Transform with FA\'\"><md-button md-no-ink \nclass=\"md-primary add-new-pastor add-pastor\" ng-click=\"vm.addChild()\">ADD CHILD (3-5 yrs. old)</md-button></div><table \nclass=\"table mb-0\"><tr ng-repeat=\"dropDownItem in vm.dropdownItems\"><td class=\"dropdown-question\">\n{{dropDownItem.question}}</td><td class=\"dropdown-item\"><md-input-container class=\"md-block\"><md-select \nname=\"form{{$index}}\" placeholder=\"Please choose\" ng-required=\"vm.participant.toggle === 1\" \nng-model=\"vm.participant[dropDownItem.key]\"><md-option ng-repeat=\"item in dropDownItem.items\" ng-value=\"item.value\" \nng-if=\"dropDownItem.key != \'wall\' || (dropDownItem.key == \'wall\' && item.value != \'wood\' && item.value != \'bamboo\')\">\n{{item.label}}</md-option></md-select><div class=\"errors\" ng-messages=\"editParticipantForm[\'form\' + $index].$error\">\n<div ng-message=\"required\">Required</div></div></md-input-container></td></tr><tr \nng-repeat=\"checkBoxItem in vm.checkBoxItems\"><td>{{checkBoxItem.question}}<div class=\"gray-text\">Select all that apply\n</div></td><td><div flex=\"100\" flex-gt-sm=\"100\" layout=\"column\"><div><fieldset class=\"standard\"><div layout=\"row\" \nlayout-wrap flex><div flex=\"50\" ng-repeat=\"item in checkBoxItem.items\"><md-checkbox \nng-checked=\"vm.isSelected(checkBoxItem.key, item.value)\" ng-click=\"vm.toggleCheckBox(checkBoxItem.key, item.value)\">\n{{ item.label }}</md-checkbox></div></div></fieldset></div></div></td></tr><tr><td>Transport<div class=\"gray-text\">\nSelect all that apply</div></td><td><div flex=\"100\" flex-gt-sm=\"100\" layout=\"column\"><div><fieldset class=\"standard\">\n<div layout=\"row\" layout-wrap flex><div flex=\"50\" class=\"options\" ng-repeat=\"item in vm.transports\" \nng-if=\"$index < vm.transports.length-1\"><md-checkbox ng-disabled=\"vm.othersDisabled\" \nng-checked=\"vm.isSelected(\'transport\', item.value)\" ng-click=\"vm.toggleCheckBox(\'transport\', item.value);\">\n{{ item.label }}</md-checkbox></div><div flex=\"50\" class=\"options\"><md-checkbox \nng-click=\"vm.toggleCheckBox(\'transport\', \'none\'); vm.othersDisabled = !vm.othersDisabled\" \nng-checked=\"vm.isSelected(\'transport\', \'none\')\" ng-disabled=\"vm.noneDisabled\">None</md-checkbox></div></div></fieldset>\n</div></div></td></tr></table><table class=\"table mb-0\"><tr><td class=\"radio-container\">\nHow many telephones/mobile phones does the family own?</td><td><md-input-container class=\"md-block mb-0\"><input \nname=\"telephones\" ng-model=\"vm.participant.telephones\" type=\"number\" min=\"0\" ng-required=\"vm.participant.toggle === 1\">\n<div ng-messages=\"editParticipantForm.telephones.$error\" ng-show=\"editParticipantForm.telephones.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-message=\"number\"><span>Invalid number</span>\n</div><div ng-message=\"min\">Invalid number</div></div></md-input-container></td></tr></table><hr><div><h5 \nclass=\"label-sep\">Information Regarding the HouseHold Head</h5><div class=\"household_con\" \nstyle=\"display: flex;\r\n                    justify-content: space-between;\r\n                    align-items: baseline\">\n<div style=\"font-size: 13px;\r\n                        color: #000\">is the Program participant the household head ?\n</div><div><md-radio-group ng-model=\"vm.participant.is_participants_household_head\" \nng-change=\"vm.onHouseholdParticipantKnowChange()\" layout=\"row\" name=\"is_participants_household_head\" required>\n<md-radio-button class=\"md-primary\" ng-value=\"1\">Yes</md-radio-button><md-radio-button class=\"md-primary\" ng-value=\"0\">\nNo</md-radio-button></md-radio-group><div class=\"error-message\">{{vm.hasNoBirthRegError}}</div></div></div></div><div \nng-show=\"vm.participant.is_participants_household_head === 0\"><hr><div \nstyle=\"font-size: 13px;\r\n                color: #000\">Name of Head of Household (please write in BLOCK LETTERS)</div>\n<div layout-gt-xs=\"row\" class=\"firstname-row\"><md-input-container class=\"md-block\" flex-gt-xs><input \nname=\"house_hold_first_name\" ng-model=\"vm.participant.house_hold_first_name\" placeholder=\"First Name\" maxlength=\"25\" \nng-disabled=\"vm.useExisting\" ng-required=\"vm.house_hold_field_validation\"><div \nng-messages=\"editParticipantForm.house_hold_first_name.$error\" \nng-show=\"editParticipantForm.house_hold_first_name.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Required\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-xs><input \nname=\"house_hold_middle_name\" ng-model=\"vm.participant.house_hold_middle_name\" maxlength=\"\" \nng-disabled=\"vm.useExisting\" placeholder=\"Middle Name\"></md-input-container><md-input-container class=\"md-block\" \nflex-gt-xs><input name=\"house_hold_last_name\" ng-model=\"vm.participant.house_hold_last_name\" \nng-disabled=\"vm.useExisting\" placeholder=\"Last Name\" ng-required=\"vm.house_hold_field_validation\"><div \nng-messages=\"editParticipantForm.house_hold_last_name.$error\" \nng-show=\"editParticipantForm.house_hold_last_name.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Required\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-xs><input \nname=\"house_hold_suffix\" ng-model=\"vm.participant.house_hold_suffix\" ng-disabled=\"vm.useExisting\" \nplaceholder=\"Nickname\"></md-input-container></div><table class=\"table mb-0\"><tr><td class=\"radio-container\">\nParticipant\'s relation to household head</td><td class=\"radio-data\"><md-radio-group \nng-model=\"vm.participant.house_hold_relation\" ng-change=\"vm.onRelationHouseholdChange()\" layout=\"row\" \nname=\"house_hold_relation\" ng-required=\"vm.house_hold_field_validation\"><md-radio-button class=\"md-primary\" \nng-value=\"0\">Spouse</md-radio-button><md-radio-button class=\"md-primary\" ng-value=\"1\">Son/Daughter</md-radio-button>\n<md-radio-button class=\"md-primary\" ng-value=\"2\">Parent/In-Law</md-radio-button><md-radio-button class=\"md-primary\" \nng-value=\"3\">Others</md-radio-button></md-radio-group><div class=\"error-message\">{{vm.hasNoBirthRegError}}</div></td>\n</tr><tr><td class=\"radio-container\">Gender of Household Head</td><td class=\"radio-data\"><md-radio-group \nng-model=\"vm.participant.house_hold_gender\" ng-change=\"vm.onGenderofHouseholdHeadChange()\" layout=\"row\" \nname=\"house_hold_gender\" style=\"justify-content: end\" ng-required=\"vm.house_hold_field_validation\"><md-radio-button \nng-repeat=\"gender in vm.genders\" class=\"md-primary\" flex-gt-xs ng-value=\"gender.value\">{{gender.label}}\n</md-radio-button></md-radio-group><div class=\"error-message\">{{vm.hasNoBirthRegError}}</div></td></tr></table></div>\n<div layout-gt-xs=\"row\" style=\"width: 50%\"><md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"income\" \nng-model=\"vm.participant.income\" placeholder=\"What is typical 30 day household income?\" type=\"number\" class=\"income\" \nng-disabled=\"vm.useExisting\" min=\"0\" ng-required=\"vm.participant.toggle\"><div \nng-messages=\"editParticipantForm.income.$error\" ng-show=\"editParticipantForm.income.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-message=\"number\"><span>Invalid number</span></div><div \nng-message=\"min\">Invalid number</div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions>\n<md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel\n</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"(editParticipantForm.$invalid\r\n                       || editParticipantForm.$pristine || vm.saving)\" \ntype=\"submit\"><span ng-show=\"!vm.saving\">Add Participant</span> <span ng-show=\"vm.saving\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting</span></md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/transform/tabs/approval-lists/approval-lists.html","<form name=\"baseForm\" class=\"md-inline-form\" novalidate><div layout-gt-xs=\"row\" class=\"approval-list\">\n<md-input-container class=\"md-block select-container\" flex=\"20\"><label>Base</label><md-select \nng-model=\"vm.filters.base\" ng-model-options=\"{ trackBy: \'$value.id\' }\" ng-change=\"vm.selectBase(vm.filters)\" \nng-disabled=\"currentUser.base_id || vm.isLoading2\"><md-option value=\"all\">All Bases</md-option><md-option \nng-value=\"base\" ng-repeat=\"base in vm.bases\">{{base.name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block select-container\" flex=\"20\"><label>Branch</label><md-select \nng-disabled=\"!vm.filters.base.branches.length || currentUser.branch_id || vm.isLoading2\" ng-model=\"vm.filters.branch\" \nng-model-options=\"{ trackBy: \'$value.id\' }\" ng-change=\"vm.selectBranch(vm.filters)\" placeholder=\"Branch\"><md-option \nvalue=\"all\">All Branches</md-option><md-option ng-value=\"branch\" ng-repeat=\"branch in vm.filters.base.branches\">\n{{ branch.name }}</md-option></md-select></md-input-container><md-input-container class=\"md-block select-container\" \nflex=\"20\"><label>Program</label><md-select ng-model=\"vm.filters.program\" ng-model-options=\"{ trackBy: \'$value.id\' }\" \nng-disabled=\"vm.isLoading2\" ng-change=\"vm.selectProgram(vm.filters)\"><md-option value=\"all\">All Programs</md-option>\n<md-option ng-value=\"program\" ng-repeat=\"program in vm.programs\">{{program.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block select-container disabled-input\" flex=\"10\"><label>\nTotal Applications</label><input ng-model=\"vm.approvedApplications.total\" disabled=\"disabled\"></md-input-container>\n<md-input-container class=\"md-block select-container mb-0 disabled-input\" flex=\"10\"><label>Total Participant Override\n<md-tooltip md-direction=\"top\">Total Participant Override</md-tooltip></label><input ng-model=\"vm.totalParticipants\" \ndisabled=\"disabled\"></md-input-container><md-input-container class=\"md-block select-container mb-0 disabled-input\" \nflex=\"10\"><label>Total Children</label><input ng-model=\"vm.totalChildren\" disabled=\"disabled\"></md-input-container>\n</div></form><div class=\"all-applications approval-list\"><table class=\"table\"><thead><tr><th>Application Date</th><th>\nProgram</th><th>Location</th><th>Pastor</th><th>Counselors</th><th>Participants</th><th>Children</th><th></th></tr>\n</thead><tbody><tr ng-show=\"!vm.approvedApplications.data.length && !vm.isLoading2\"><td colspan=\"8\"><div \nclass=\"text-center\">No applications.</div></td></tr><tr ng-show=\"vm.isLoading2 && vm.approvedApplications.length < 1\">\n<td colspan=\"8\"><div class=\"text-center\">Loading applications.</div></td></tr><tr \nng-repeat=\"application in vm.approvedApplications.data\" ng-mouseover=\"application.selected = true\" \nng-mouseleave=\"application.selected = false\" ng-class=\"{backgroundWhite: application.selected}\" \nng-click=\"vm.addParticipants(application)\"><td>{{application.applied_at | date}}</td><td>{{application.program.name}}\n</td><td>{{application.base.name}}</td><td class=\"pastor-click\" \nng-click=\"vm.callPastorInformation(application.pastor, application.church); $event.stopPropagation();\">\n{{application.pastor.firstname}} {{application.pastor.lastname}}</td><td class=\"pastor-click\" \nng-click=\"vm.addParticipants(application); $event.stopPropagation();\">{{application.total_counselors}}</td><td \nclass=\"pastor-click\" ng-click=\"vm.addParticipants(application); $event.stopPropagation();\">\n{{application.total_approved_participants}}/{{application.total_participants}}</td><td>{{application.total_children}}\n</td><td><span class=\"material-icons Issues_icon\" ng-show=\"application.icon_display==1?true:false\">error_outline</span>\n</td><td class=\"icons-container\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\'\r\n           , \'pastor_coordinator\', \'branch_head\', \'area_head\', \'health_mentor\'])\">\n<i class=\"icon-pencil\" ng-click=\"vm.editApplication(application); $event.stopPropagation();\"><md-tooltip \nmd-direction=\"left\">Edit Application</md-tooltip></i><i class=\"icon-playlist-plus\" \nng-click=\"vm.addParticipants(application);\r\n                   $event.stopPropagation();\"><md-tooltip \nmd-direction=\"left\">View Participants</md-tooltip></i><i class=\"icon-check\" \nng-click=\"vm.batchSelection(application);\r\n                   $event.stopPropagation();\" \nng-hide=\"currentUser.$roles.has([\'metrics\',\r\n                   \'pastor_coordinator\', \'national\', \'health_mentor\'])\">\n<md-tooltip md-direction=\"left\">Approve Application</md-tooltip></i><i class=\"icon-trash\" \nng-click=\"vm.dropApplication(application, \'approved\');\r\n                   $event.stopPropagation();\"><md-tooltip \nmd-direction=\"left\">Drop Application</md-tooltip></i></td></tr></tbody></table><div class=\"pagination-container\" \nng-show=\"!vm.isLoading2\"><pagination items=\"vm.approvedApplications\" \ncallback=\"vm.pageChange(vm.approvedApplications.current_page, vm.filters)\"></pagination></div></div>");
$templateCache.put("app/main/transform/dialogs/approve-application/approve-application-dialog.html","<md-dialog class=\"approve-application-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.approveApplication()\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll>Move to \'For Approval\' List?</md-dialog-content><md-dialog-actions><md-button\n md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button>\n<md-button class=\"md-accent md-raised\" ng-disabled=\"vm.saving\" ng-click=\"vm.approveApplication()\"><span \nng-show=\"!vm.saving\">Approve</span> <span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"20px\"></md-progress-circular>Submitting</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/transform/dialogs/drop-application/drop-application-dialog.html","<md-dialog class=\"drop-application-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nclass=\"text-center\" ng-bind-html=\"vm.dialogBody\"></md-dialog-content><md-dialog-actions><md-button md-no-ink \nclass=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"vm.saving\" \nng-click=\"vm.passwordConfirmation ? vm.passwordConfirmation() : vm.dropApplication()\"><span ng-show=\"!vm.saving\">\n{{vm.dialogFooter}}</span> <span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\">\n</md-progress-circular>Submitting</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/transform/dialogs/issue-dialog/issues-dialog.html","<md-dialog class=\"drop-application-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"remarkForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.remarkParticipant()\"><form name=\"eventForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll>\n<md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.loadIssues\" md-diameter=\"10px\"></md-progress-circular><ul \nng-if=\"!vm.isPastor\"><li ng-repeat=\"issue in vm.issues | toArray:false\">\nPrevious participant from community {{issue.community_id}}.</li></ul><md-input-container class=\"md-block mb-0\" \nstyle=\"margin-top: 4rem\" flex-gt-xs ng-if=\"!vm.isremarks && !vm.isPastor\"><md-input-container \nclass=\"md-block select-container\"><label>Remark Reason</label><md-select ng-model=\"vm.remark\" \nng-model-options=\"{ trackBy: \'$value.id\' }\" required><md-option ng-value=\"reason\" \nng-repeat=\"reason in vm.remarkReasons\">{{reason.label}}</md-option></md-select></md-input-container><div \nng-messages=\"remarkForm.remark.$error\" \nng-show=\"remarkForm.remark.$touched\r\n                     || remarkForm.$submitted\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div></div></md-input-container><ul ng-if=\"vm.isPastor\"><li \nng-repeat=\"pastor in vm.pastors | toArray:false\">{{pastor.firstname}} {{pastor.lastname}} - {{pastor.id}}</li></ul>\n<md-input-container class=\"md-block mb-0\" style=\"margin-top: 4rem\" flex-gt-xs ng-if=\"!vm.isremarks && vm.isPastor\">\n<md-input-container class=\"md-block select-container\"><label>Remark Reason</label><md-select ng-model=\"vm.remark\" \nng-model-options=\"{ trackBy: \'$value.id\' }\" required><md-option ng-value=\"reason\" \nng-repeat=\"reason in vm.pastorRemarkReasons\">{{reason.label}}</md-option></md-select></md-input-container><div \nng-messages=\"remarkForm.remark.$error\" \nng-show=\"remarkForm.remark.$touched\r\n                     || remarkForm.$submitted\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div></div></md-input-container><div ng-if=\"vm.isremarks\" \nstyle=\"margin-top: 4rem; margin-left: 2.5rem\"><h3 style=\"font-weight: bolder\">Remark Reason</h3><p>{{vm.isremarks}}</p>\n</div></md-dialog-content><md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">Cancel</md-button><md-button type=\"submit\" class=\"md-accent md-raised pull-right\" \nng-disabled=\"remarkForm.$invalid || vm.saving\"><md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.saving\" \nmd-diameter=\"10px\"></md-progress-circular>SAVE</md-button></md-dialog-actions></form></form></md-dialog>");
$templateCache.put("app/main/transform/dialogs/edit-participant/edit-participant-dialog.html","<style>\nmd-dialog.add-participant-dialog md-dialog-content label {\r\n        font-weight: unset !important;\r\n    }\r\n\r\n    md-input-container .md-placeholder,\r\n    md-input-container label:not(.md-no-float):not(.md-container-ignore) {\r\n        color: black !important;\r\n        opacity: 1 !important;\r\n        font-weight: 100% !important;\r\n    }\r\n\r\n    input::placeholder {\r\n        color: black !important;\r\n        opacity: 1 !important;\r\n        font-weight: unset !important;\r\n    }\r\n\r\n    md-select.md-default-theme .md-select-value.md-select-placeholder,\r\n    md-select .md-select-value.md-select-placeholder {\r\n        color: black !important;\r\n    }\r\n\r\n    .table_sec1,\r\n    .table_sec1 th,\r\n    .table_sec1 td {\r\n        border: 2px solid black;\r\n        border-collapse: collapse;\r\n    }\r\n\r\n    .table_sec1 td {\r\n        padding: 18px 10px !important;\r\n    }\r\n\r\n    .td_w50 td {\r\n        width: 50%;\r\n    }\r\n\r\n    .table_sec1 th {\r\n        text-align: center;\r\n        font-weight: bolder !important;\r\n        color: #000 !important;\r\n        padding: 18px 10px !important;\r\n    }\r\n\r\n    .table_sec2_radio md-radio-button .md-label {\r\n        margin-left: 15px !important;\r\n    }\r\n\r\n    /* \r\n    .table_sec1 .spacebw md-radio-button .md-label {\r\n        margin-left: 30px !important;\r\n    } */\r\n\r\n    .spacebw {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n    }\r\n\r\n    .center_item {\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n\r\n    .center {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n\r\n    .dropdownItems md-radio-button .md-label {\r\n        margin-left: 14px !important;\r\n    }\r\n\r\n    .margin_b {\r\n        margin-bottom: 15px;\r\n    }\r\n\r\n    .t_head {\r\n        background: #cfcfcf;\r\n    }\r\n\r\n    .permission-msg {\r\n        width: 100%;\r\n        float: right;\r\n        color: red;\r\n    }\n</style><md-dialog class=\"add-participant-dialog transform-dialog\" aria-label=\"New Message\"><form \nname=\"editParticipantForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.editParticipant(vm.participant)\"><md-toolbar\n class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div><md-switch \nng-true-value=\"1\" ng-false-value=\"0\" class=\"mb-0 mt-0\" layout-align=\"center center\" ng-model=\"vm.participant.toggle\" \naria-label=\"Switch 1\" ng-disabled=\"vm.isEditParticipant\"><h6 class=\"black\">Use Poverty Score Card</h6></md-switch>\n</div><div layout-gt-xs=\"row\" class=\"partner-pastor\">Partner Pastor: &nbsp; <span>\n{{vm.pastor.firstname}} {{vm.pastor.lastname}}</span></div><div layout-gt-xs=\"row\" class=\"checkbox-row\"><div \nflex-gt-xs><div layout-gt-xs=\"row\"><div><h5 class=\"mb-0 mt-10\">Category:</h5></div><div class=\"selection\">\n<md-input-container class=\"md-block mb-0 mt-0\"><md-radio-group ng-model=\"vm.participant.isCounselor\" layout=\"row\" \nng-change=\"vm.participant.toggle = 1\" required name=\"counselor\" ng-disabled=\"vm.isEditParticipant\"><md-radio-button \nclass=\"md-primary\" ng-value=\"1\">Counselor</md-radio-button><md-radio-button class=\"md-primary\" ng-value=\"0\">Participant\n</md-radio-button><md-radio-button ng-show=\"vm.participant.has_community\" class=\"md-primary\" ng-value=\"-1\">Visitor\n</md-radio-button><md-checkbox ng-show=\"vm.participant.isCounselor !== -1\" \nng-checked=\"vm.isReplacement && vm.participant.isCounselor !== -1\" \nng-click=\"vm.isReplacement = !vm.isReplacement; vm.checked = true;\" ng-disabled=\"vm.isEditParticipant\">Is replacement?\n</md-checkbox></md-radio-group><div ng-messages=\"editParticipantForm.counselor.$error\" \nng-show=\"editParticipantForm.counselor.$touched\r\n                                     || editParticipantForm.$submitted\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div></div></md-input-container></div></div></div></div>\n<div layout-gt-xs=\"row\"><md-input-container class=\"md-block firstname-row\" flex-gt-xs><input name=\"firstname\" \nng-model=\"vm.participant.firstName\" placeholder=\"First Name\" maxlength=\"30\" ng-disabled=\"vm.isEditParticipant\" \nrequired><div ng-messages=\"editParticipantForm.firstname.$error\" \nng-show=\"editParticipantForm.firstname.$touched\r\n                         || editParticipantForm.$submitted\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-xs><input name=\"middlename\" ng-model=\"vm.participant.middleName\" maxlength=\"30\" \nng-disabled=\"vm.isEditParticipant\" placeholder=\"Middle Name\"></md-input-container></div><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"lastname\" ng-model=\"vm.participant.lastName\" \nmaxlength=\"30\" placeholder=\"Last Name\" ng-disabled=\"vm.isEditParticipant\" required><div \nng-messages=\"editParticipantForm.lastname.$error\" \nng-show=\"editParticipantForm.lastname.$touched\r\n                         || editParticipantForm.$submitted\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div></div></md-input-container><md-input-container \nclass=\"md-block mb-0\" flex-gt-xs><input name=\"suffix\" ng-model=\"vm.participant.suffix\" maxlength=\"20\" \nplaceholder=\"Nickname\" ng-disabled=\"vm.isEditParticipant\"></md-input-container></div><div layout-gt-xs=\"row\" \nclass=\"mt-10 gender-row\"><div flex-gt-xs><div layout-gt-xs=\"row\"><div><h5 class=\"mt-0 mb-0 gender-text\">Gender:</h5>\n</div></div><div layout-gt-xs=\"row\" class=\"black\"><div><md-input-container class=\"md-block mb-0 mt-0\"><md-radio-group \nng-model=\"vm.participant.gender\" required layout=\"row\" ng-disabled=\"vm.isEditParticipant\"><md-radio-button \nng-repeat=\"gender in vm.genders\" class=\"md-primary\" flex-gt-xs ng-value=\"gender.value\">{{gender.label}}\n</md-radio-button></md-radio-group><div ng-messages=\"editParticipantForm.gender.$error\" \nng-show=\"editParticipantForm.gender.$touched\r\n                                     || editParticipantForm.$submitted\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div></div></md-input-container></div></div></div><div \nflex-gt-xs><md-input-container class=\"md-block datepicker mb-0\"><md-datepicker ng-model=\"vm.participant.birthdate\" \nname=\"participantbdate\" md-open-on-focus ng-disabled=\"vm.useExisting || vm.isEditParticipant\" \nmd-input-name=\"participantbdate\" md-placeholder=\"Date of Birth\" md-max-date=\"vm.maxDate\" ng-change=\"vm.isDateValid()\">\n</md-datepicker><div class=\"errors\" ng-show=\"!vm.isDateValidParticipantBirthdate\"><div class=\"date-error\" \nstyle=\"color: red\">You must be at least 13 years old!</div></div><div class=\"errors\" \nng-messages=\"editParticipantForm.participantbdate.$error\"><div ng-message=\"valid\" class=\"date-error\">\nThe entered value is not a date!</div></div></md-input-container></div></div><h5 class=\"label-sep\">\nFollowing data is required for participants and counselors only.</h5><div layout-gt-xs=\"row\" style=\"width: 50%\">\n<md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"phonenumber\" type=\"tel\" \nng-model=\"vm.participant.phoneNumber\" ng-disabled=\"vm.isEditParticipant\" placeholder=\"Phone Number\"><div \nng-messages=\"editParticipantForm.phonenumber.$error\" \nng-show=\"editParticipantForm.phonenumber.$touched\r\n                         || editParticipantForm.$submitted || vm.errorPhone\" \nrole=\"alert\"><div ng-bind=\"vm.errorPhone\"></div></div></md-input-container></div><div class=\"toggle-on\"><table \nclass=\"table mb-0\"><tr><td class=\"radio-container privacy-member\">PhilHealth Member?</td><td \nclass=\"radio-data privacy-data\"><md-radio-group ng-model=\"vm.participant.philhealth_member\" layout=\"row\" \nname=\"philhealth_member\" ng-disabled=\"vm.isEditParticipant\"><md-radio-button class=\"md-primary\" ng-value=\"1\">Yes\n</md-radio-button><md-radio-button class=\"md-primary\" ng-value=\"0\">No</md-radio-button></md-radio-group></td></tr><tr>\n<td class=\"radio-container\">4P\'s member?</td><td class=\"radio-data\"><md-input-container class=\"md-block mb-0 mt-0\">\n<md-radio-group ng-model=\"vm.participant.p4\" layout=\"row\" name=\"p4\" ng-required=\"vm.participant.toggle === 1\" \nng-disabled=\"vm.isEditParticipant\"><md-radio-button class=\"md-primary\" ng-value=\"1\">Yes</md-radio-button>\n<md-radio-button class=\"md-primary\" ng-value=\"0\">No</md-radio-button></md-radio-group><div \nng-messages=\"editParticipantForm.p4.$error\" \nng-show=\"editParticipantForm.p4.$touched\r\n                                     || editParticipantForm.$submitted\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div></div></md-input-container></td></tr><tr><td \nclass=\"radio-container\">Are there any household members without birth registration?</td><td class=\"radio-data\">\n<md-input-container class=\"md-block mb-0 mt-0\"><md-radio-group ng-model=\"vm.participant.householdMembers\" layout=\"row\" \nng-required=\"vm.participant.toggle === 1\" name=\"householdmembers\" ng-disabled=\"vm.isEditParticipant\"><md-radio-button \nclass=\"md-primary\" ng-value=\"1\">Yes</md-radio-button><md-radio-button class=\"md-primary\" ng-value=\"0\">No\n</md-radio-button></md-radio-group><div ng-messages=\"editParticipantForm.householdmembers.$error\" \nng-show=\"editParticipantForm.householdmembers.$touched\r\n                                     || editParticipantForm.$submitted\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div></div></md-input-container></td></tr><tr><td \nclass=\"radio-container\">Civil Status</td><td class=\"radio-data\"><md-input-container class=\"md-block\"><md-select \nname=\"civil_status\" placeholder=\"Please select\" ng-disabled=\"vm.isEditParticipant\" \nng-model=\"vm.participant.civil_status\" ng-required=\"!vm.participant.is_visitor\"><md-option \nng-repeat=\"item in vm.civilStatuses\" ng-value=\"item.value\">{{item.label}}</md-option></md-select><div class=\"errors\" \nng-messages=\"editParticipantForm.civil_status.$error\"><div ng-message=\"required\">Required</div></div>\n</md-input-container></td></tr><tr ng-show=\"vm.participant.civil_status == \'live_in\'\"><td class=\"radio-container\">\nDo you want to process CENOMAR?</td><td class=\"radio-data\"><md-radio-group ng-model=\"vm.participant.certificate\" \nlayout=\"row\" name=\"certificate\" ng-disabled=\"vm.isEditParticipant\" ng-required=\"vm.participant.married === 1\">\n<md-radio-button class=\"md-primary\" ng-value=\"1\">Yes</md-radio-button><md-radio-button class=\"md-primary\" ng-value=\"0\">\nNo</md-radio-button></md-radio-group><div class=\"error-message\">{{vm.errorCertificate}}</div></td></tr><tr><td \nclass=\"radio-container\">How many people usually live in your house and share food and income?</td><td>\n<md-input-container class=\"md-block mb-0\"><input name=\"peoplelive\" ng-model=\"vm.participant.peopleLive\" type=\"number\" \nmin=\"1\" max=\"30\" maxlength=\"3\" ng-required=\"vm.participant.toggle === 1\" ng-disabled=\"vm.isEditParticipant\"><div \nng-messages=\"editParticipantForm.peoplelive.$error\" ng-show=\"editParticipantForm.peoplelive.$touched\" role=\"alert\"><div\n ng-message=\"required\"><span>Required</span></div><div ng-message=\"number\"><span>Invalid number</span></div><div \nng-message=\"min\">Invalid number</div><div ng-message=\"max\">Invalid number</div><div ng-message=\"maxlength\">\nExceeds limit</div></div></md-input-container></td></tr></table><h4 \nng-show=\"vm.toAddChildren.length > 0 && vm.application.program.name === \'Transform with FA\'\" \nclass=\"black mt-10 fw-bold\">Children</h4><div ng-repeat=\"child in vm.toAddChildren\" \nng-show=\"vm.application.program.name === \'Transform with FA\'\"><ng-form name=\"childFieldForm\"><div layout=\"row\">\n<md-input-container class=\"md-block\" flex=\"30\"><input name=\"firstname\" ng-model=\"child.firstname\" \nplaceholder=\"First Name\" maxlength=\"30\" required ng-disabled=\"vm.isEditParticipant\"><div \nng-messages=\"childFieldForm.firstname.$error\" ng-show=\"childFieldForm.firstname.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div></div></md-input-container><md-input-container class=\"md-block\" \nflex=\"30\"><input name=\"lastname\" ng-model=\"child.lastname\" placeholder=\"Last Name\" maxlength=\"30\" required \nng-disabled=\"vm.isEditParticipant\"><div ng-messages=\"childFieldForm.lastname.$error\" \nng-show=\"childFieldForm.lastname.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex=\"30\"><md-select name=\"relationship\" \nplaceholder=\"Please select\" ng-model=\"child.relationship\" ng-disabled=\"vm.isEditParticipant\"><md-option \nng-repeat=\"item in vm.childRelationships\" ng-value=\"item.value\" ng-click=\"child.is_other_relationship = 0\">\n{{ item.label }}</md-option><md-option ng-model=\"child.relationship\" value=\"other\">Other</md-option></md-select><div \nclass=\"errors\" ng-messages=\"editParticipantForm[\'form\' + $index].$error\"><div ng-message=\"required\">Required</div>\n</div></md-input-container><md-input-container class=\"md-block\" flex=\"30\" ng-show=\"child.relationship == \'other\'\">\n<input name=\"other_relationship\" ng-model=\"child.other_relationship\" ng-disabled=\"vm.isEditParticipant\" \nplaceholder=\"Relationship\" maxlength=\"30\" ng-required=\"child.relationship == \'other\'\"><div \nng-messages=\"childFieldForm.other_relationship.$error\" ng-show=\"childFieldForm.other_relationship.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div></div></md-input-container></div><div layout=\"row\">\n<div flex=\"30\" class=\"ml-10\"><div layout-gt-xs=\"row\"><div><h6 class=\"mt-0 mb-0 gender-text\">Gender:</h6></div></div>\n<div layout-gt-xs=\"row\" class=\"black mt-0\"><div><md-radio-group ng-model=\"child.gender\" class=\"child-gender\" \nlayout=\"row\" ng-disabled=\"vm.isEditParticipant\"><md-radio-button ng-repeat=\"gender in vm.genders\" class=\"md-primary\" \nflex-gt-xs ng-value=\"gender.value\">{{gender.label}}</md-radio-button></md-radio-group></div></div></div>\n<md-input-container flex=\"30\" class=\"md-block datepicker mb-0\"><md-datepicker ng-model=\"child.birthdate\" \nname=\"participantbdate\" md-open-on-focus md-input-name=\"participantbdate\" md-placeholder=\"Date of Birth\" \nng-disabled=\"vm.isEditParticipant\"></md-datepicker><div class=\"errors\" \nng-messages=\"childFieldForm.participantbdate.$error || vm.apiErrors[\'children.\' + $index + \'.birthdate\']\"><div \nng-message=\"valid\" class=\"date-error\">The entered value is not a date!</div><div \nng-bind=\"vm.apiErrors[\'children.\' + $index + \'.birthdate\']\"></div></div></md-input-container><div flex=\"10\" \nclass=\"mt-15 remove-child-container\" ng-hide=\"vm.isEditParticipant\"><i class=\"icon-trash\" flex=\"10\" \nng-click=\"vm.removeChild(child)\"><md-tooltip md-direction=\"left\">Remove child</md-tooltip></i></div></div></ng-form>\n</div><div layout=\"row\" ng-show=\"vm.application.program.name === \'Transform with FA\'\"><md-button md-no-ink \nclass=\"md-primary add-new-pastor add-pastor\" ng-click=\"vm.addChild()\" ng-disabled=\"vm.isEditParticipant\">\nADD CHILD (3-5 yrs. old)</md-button></div><table class=\"table mb-0\"><tr ng-repeat=\"dropDownItem in vm.dropdownItems\">\n<td class=\"dropdown-question\">{{dropDownItem.question}}</td><td class=\"dropdown-item\"><md-input-container \nclass=\"md-block\"><md-select name=\"form{{$index}}\" placeholder=\"Please choose\" \nng-required=\"vm.participant.toggle === 1\" ng-model=\"vm.participant[dropDownItem.key]\" \nng-disabled=\"vm.isEditParticipant\"><md-option ng-repeat=\"item in dropDownItem.items\" ng-value=\"item.value\" \nng-if=\"dropDownItem.key != \'wall\' || (dropDownItem.key == \'wall\' && ((item.value != \'wood\' && item.value != \'bamboo\') || vm.participant[dropDownItem.key] == item.value))\">\n{{item.label}}</md-option></md-select><div class=\"errors\" \nng-show=\"editParticipantForm[\'form\' + $index].$touched\r\n                                     || editParticipantForm.$submitted\" \nng-messages=\"editParticipantForm[\'form\' + $index].$error\"><div ng-message=\"required\">Required</div></div>\n</md-input-container></td></tr><tr ng-repeat=\"checkBoxItem in vm.checkBoxItems\"><td>{{checkBoxItem.question}}<div \nclass=\"gray-text\">Select all that apply</div></td><td><div flex=\"100\" flex-gt-sm=\"100\" layout=\"column\"><div><fieldset \nclass=\"standard\"><div layout=\"row\" layout-wrap flex><div flex=\"50\" ng-repeat=\"item in checkBoxItem.items\"><md-checkbox \nng-checked=\"vm.isSelected(checkBoxItem.key, item.value)\" ng-click=\"vm.toggleCheckBox(checkBoxItem.key, item.value)\" \nng-disabled=\"vm.isEditParticipant\">{{ item.label }}</md-checkbox></div></div></fieldset></div></div></td></tr><tr><td>\nTransport<div class=\"gray-text\">Select all that apply</div></td><td><div flex=\"100\" flex-gt-sm=\"100\" layout=\"column\">\n<div><fieldset class=\"standard\"><div layout=\"row\" layout-wrap flex><div flex=\"50\" class=\"options\" \nng-repeat=\"item in vm.transports\" ng-if=\"$index < vm.transports.length-1\"><md-checkbox \nng-disabled=\"vm.othersDisabled||vm.isEditParticipant\" ng-checked=\"vm.isSelected(\'transport\', item.value)\" \nng-click=\"vm.toggleCheckBox(\'transport\', item.value);\">{{ item.label }}</md-checkbox></div><div flex=\"50\" \nclass=\"options\"><md-checkbox ng-click=\"vm.toggleCheckBox(\'transport\', \'none\'); vm.othersDisabled = !vm.othersDisabled\" \nng-checked=\"vm.isSelected(\'transport\', \'none\')\" ng-disabled=\"vm.noneDisabled||vm.isEditParticipant\">None</md-checkbox>\n</div></div></fieldset></div></div></td></tr></table><table class=\"table mb-0\"><tr><td class=\"radio-container\">\nHow many telephones/mobile phones does the family own?</td><td><md-input-container class=\"md-block mb-0\"><input \nname=\"telephones\" ng-model=\"vm.participant.telephones\" type=\"number\" min=\"0\" ng-required=\"vm.participant.toggle === 1\" \nng-disabled=\"vm.isEditParticipant\"><div ng-messages=\"editParticipantForm.telephones.$error\" \nng-show=\"editParticipantForm.telephones.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Required</span></div>\n<div ng-message=\"number\"><span>Invalid number</span></div><div ng-message=\"min\">Invalid number</div></div>\n</md-input-container></td></tr></table><div><h5 class=\"label-sep\">Information Regarding the HouseHold Head</h5><div \nclass=\"household_con\" \nstyle=\"display: flex;\r\n                    justify-content: space-between;\r\n                    align-items: baseline\">\n<div style=\"font-size: 13px;\r\n                        color: #000\">is the Program participant the household head ?\n</div><div><md-radio-group ng-model=\"vm.participant.scorecard.is_participants_household_head\" \nng-change=\"vm.onHouseholdParticipantKnowChange()\" required layout=\"row\" name=\"is_participants_household_head\" \nng-disabled=\"vm.isEditParticipant\"><md-radio-button class=\"md-primary\" ng-value=\"1\">Yes</md-radio-button>\n<md-radio-button class=\"md-primary\" ng-value=\"0\">No</md-radio-button></md-radio-group><div class=\"error-message\">\n{{vm.hasNoBirthRegError}}</div></div></div></div><div \nng-show=\"vm.participant.scorecard.is_participants_household_head == 0\"><hr><div \nstyle=\"font-size: 13px;\r\n                color: #000\">Name of Head of Household (please write in BLOCK LETTERS)</div>\n<div layout-gt-xs=\"row\" class=\"firstname-row\"><md-input-container class=\"md-block\" flex-gt-xs><input \nname=\"house_hold_first_name\" ng-model=\"vm.participant.scorecard.house_hold_first_name\" placeholder=\"First Name\" \nmaxlength=\"25\" ng-disabled=\"vm.useExisting||vm.isEditParticipant\" ng-required=\"vm.house_hold_field_validation\"><div \nng-messages=\"editParticipantForm.house_hold_first_name.$error\" \nng-show=\"editParticipantForm.house_hold_first_name.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Required\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-xs><input \nname=\"house_hold_middle_name\" ng-model=\"vm.participant.scorecard.house_hold_middle_name\" maxlength=\"\" \nng-disabled=\"vm.useExisting||vm.isEditParticipant\" placeholder=\"Middle Name\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-xs><input name=\"house_hold_last_name\" \nng-model=\"vm.participant.scorecard.house_hold_last_name\" ng-disabled=\"vm.useExisting||vm.isEditParticipant\" \nplaceholder=\"Last Name\" ng-required=\"vm.house_hold_field_validation\"><div \nng-messages=\"editParticipantForm.house_hold_last_name.$error\" \nng-show=\"editParticipantForm.house_hold_last_name.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Required\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-xs><input \nname=\"house_hold_suffix\" ng-model=\"vm.participant.scorecard.house_hold_suffix\" \nng-disabled=\"vm.useExisting||vm.isEditParticipant\" placeholder=\"Nickname\"></md-input-container></div><table \nclass=\"table mb-0\"><tr><td class=\"radio-container\">Participant\'s relation to household head</td><td class=\"radio-data\">\n<md-radio-group ng-model=\"vm.participant.scorecard.house_hold_relation\" ng-required=\"vm.house_hold_field_validation\" \nlayout=\"row\" name=\"house_hold_relation\" ng-disabled=\"vm.isEditParticipant\"><md-radio-button class=\"md-primary\" \nng-value=\"0\">Spouse</md-radio-button><md-radio-button class=\"md-primary\" ng-value=\"1\">Son/Daughter</md-radio-button>\n<md-radio-button class=\"md-primary\" ng-value=\"2\">Parent/In-Law</md-radio-button><md-radio-button class=\"md-primary\" \nng-value=\"3\">Others</md-radio-button></md-radio-group><div class=\"error-message\">{{vm.hasNoBirthRegError}}</div></td>\n</tr><tr><td class=\"radio-container\">Gender of Household Head</td><td class=\"radio-data\"><md-radio-group \nng-model=\"vm.participant.scorecard.house_hold_gender\" ng-required=\"vm.house_hold_field_validation\" layout=\"row\" \nname=\"house_hold_gender\" style=\"justify-content: end\" ng-disabled=\"vm.isEditParticipant\"><md-radio-button \nng-repeat=\"gender in vm.genders\" class=\"md-primary\" flex-gt-xs ng-value=\"gender.value\">{{gender.label}}\n</md-radio-button></md-radio-group><div class=\"error-message\">{{vm.hasNoBirthRegError}}</div></td></tr></table></div>\n<div layout-gt-xs=\"row\" style=\"width: 50%\"><md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"income\" \nng-model=\"vm.participant.income\" placeholder=\"What is typical 30 day household income?\" type=\"number\" class=\"income\" \nmin=\"1\" max=\"100000\" ng-disabled=\"vm.isEditParticipant\" ng-required=\"vm.participant.toggle\"><div \nng-messages=\"editParticipantForm.income.$error\" ng-show=\"editParticipantForm.income.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-message=\"number\"><span>Invalid number</span></div><div \nng-message=\"min\">Invalid number</div><div ng-message=\"max\">Invalid number</div></div></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions><div class=\"permission-msg\" ng-show=\"vm.isEditParticipant\">\nNote - You do not have edit permission.</div><md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"(editParticipantForm.$invalid || vm.saving || !vm.isDateValidParticipantBirthdate || !vm.checked || vm.isEditParticipant)\" \ntype=\"submit\"><span ng-show=\"!vm.saving\">Edit</span> <span ng-show=\"vm.saving\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting</span></md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/transform/dialogs/delete-participant/delete-participant-dialog.html","<md-dialog class=\"drop-application-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nclass=\"text-center\" ng-bind-html=\"vm.dialogBody\"></md-dialog-content><md-dialog-actions><md-button md-no-ink \nclass=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"vm.saving\" ng-click=\"vm.dropApplication()\"><span ng-show=\"!vm.saving\">\n{{vm.dialogFooter}}</span> <span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\">\n</md-progress-circular>Submitting</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/transform/dialogs/new-application/new-application-dialog.html","<md-dialog class=\"new-application-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"applicationForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.addNewApplication(vm.application)\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nng-show=\"!vm.secondPage\"><div layout-gt-xs=\"row\"><md-input-container class=\"md-block datepicker\" flex><h6>\nApplication Date</h6><md-datepicker ng-model=\"vm.application.date\" name=\"applicationDate\" md-open-on-focus \nmd-placeholder=\"Enter date\" md-input-name=\"applicationDate\" required></md-datepicker><div class=\"errors\" \nng-messages=\"applicationForm.applicationDate.$error\"><div ng-message=\"valid\" class=\"date-error\">\nThe entered value is not a date!</div><div ng-message=\"required\" class=\"date-error\">This date is required!</div></div>\n</md-input-container><md-input-container class=\"md-block select\" flex><label>Program</label><md-select name=\"program\" \nng-model=\"vm.application.program\" required><md-option ng-value=\"program.id\" ng-repeat=\"program in vm.programs\">\n{{program.name}}</md-option></md-select><div class=\"errors\" ng-messages=\"applicationForm.program.$error\" \nng-show=\"applicationForm.program.$touched\r\n                             || vm.apiErrors.roles\"><div \nng-message=\"required\">Required</div></div><div ng-bind=\"vm.apiErrors.roles\"></div></md-input-container><div \nclass=\"md-block\" flex><div><h6 class=\"application-id-label\">Application ID</h6></div><div><h3 class=\"application-id\">\n{{vm.application.application_id || \"--\"}}</h3></div></div></div><div><h4 class=\"new-app-label\">Pastor</h4><div \nlayout-gt-xs=\"row\"><md-autocomplete flex md-input-name=\"pastor\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedPastor\" md-selected-item-change=\"vm.selectPastor(pastor)\" \nmd-search-text=\"vm.searchPastorName\" md-search-text-change=\"vm.searchPastorChange(vm.searchPastorName)\" \nmd-items=\"pastor in vm.searchPastors(vm.searchPastorName)\" \nmd-item-text=\"pastor.firstname+\' \'+pastor.lastname+ \' (\' +pastor.id+ \')\'\" md-require-match \nmd-floating-label=\"Pastor Name or ID\"><md-item-template><table><td width=\"110px\">{{pastor.id}}</td><td width=\"110px\">\n{{pastor.is_active ? \'Active\' : \'Inactive\'}} {{pastor.member_status ? \' - \' + pastor.member_status : \'\'}}</td><td \nwidth=\"170px\">{{pastor.firstname}} {{pastor.lastname}}</td></table></md-item-template><div class=\"errors\" \nng-messages=\"applicationForm.pastor.$error\" \nng-if=\"applicationForm.pastor.$touched\r\n                                 || applicationForm.$submitted\"><div \nng-message=\"md-require-match\">Please select an existing pastor.</div></div></md-autocomplete></div><div \nlayout-gt-xs=\"row\"><md-input-container style=\"width: 100%\"><label>Country</label><md-select \nng-model=\"vm.application.country_code\" ng-change=\"vm.handleCountryChange(vm.application.country_code)\" required>\n<md-option ng-value=\"country.id\" ng-repeat=\"country in vm.countrys\">{{country.name}}</md-option></md-select><div \nclass=\"errors\" ng-messages=\"applicationForm.country_code.$error || vm.apiErrors.country_code\" \nng-show=\"applicationForm.country_code.$touched || vm.apiErrors.country_code\"><div ng-message=\"required\">Required</div>\n<div ng-bind=\"vm.apiErrors.country_code\"></div></div></md-input-container></div><div layout-gt-xs=\"row\" \nclass=\"selected-base-name\"><md-autocomplete flex required md-input-name=\"base\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedBaseName\" md-selected-item-change=\"vm.selectBaseName(base)\" \nmd-search-text-change=\"vm.searchBaseChange(vm.searchBaseName)\" md-search-text=\"vm.searchBaseName\" \nmd-items=\"base in vm.searchBaseNames(vm.searchBaseName)\" md-item-text=\"base.name\" md-require-match \nng-disabled=\"!vm.application.country_code\" md-floating-label=\"Base\" md-min-length=\"0\"><md-item-template><span \nmd-highlight-text=\"vm.searchBaseName\">{{base.name}}</span></md-item-template><div class=\"errors\" \nng-messages=\"applicationForm.base.$error\" \nng-if=\"applicationForm.base.$touched\r\n                                || applicationForm.$submitted\"><div \nng-message=\"required\">Required</div><div ng-message=\"md-require-match\">Please select an existing base.</div></div>\n</md-autocomplete><md-input-container flex><md-select required name=\"branch\" ng-disabled=\"!vm.branches.length\" \nng-model=\"vm.application.base_branch_id\" placeholder=\"Branch\"><md-option ng-value=\"branch.id\" \nng-repeat=\"branch in vm.branches\">{{ branch.name }}</md-option></md-select><div class=\"errors\" \nng-messages=\"applicationForm.branch.$error\" ng-show=\"applicationForm.branch.$touched\"><div ng-message=\"required\">\nRequired</div></div></md-input-container></div></div><p class=\"help-block\">\nIf the church is not listed, you must first add this church info as a new church profile in Thrive -> Church section. Once added, you may return and add/encode this Transform application.\n</p><div layout-gt-xs=\"row\"><md-input-container flex-gt-xs><h4 class=\"new-app-label\">Church</h4><md-select required \nname=\"church\" ng-model=\"vm.selectedChurch\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nng-change=\"vm.autoFillCommunityAddress()\" placeholder=\"Church\" flex=\"90\"><md-option ng-value=\"church\" \nng-repeat=\"church in vm.churches\">{{ church.name }}</md-option></md-select></md-input-container><md-input-container \nflex-gt-xs><h4 class=\"new-app-label\">Position</h4><md-select required name=\"church_position\" \nng-model=\"vm.application.church_position\" placeholder=\"Position\"><md-option ng-value=\"position.value\" \nng-repeat=\"position in vm.churchPositions\">{{ position.label }}</md-option></md-select><div class=\"errors\" \nng-messages=\"applicationForm.church_position.$error\" ng-show=\"applicationForm.church_position.$touched\"><div \nng-message=\"required\">Required</div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"md-block mb-0 mt-0\" flex=\"45\"><input name=\"churchcity\" \nng-model=\"vm.selectedChurch.city.name\" placeholder=\"City\" disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-block mb-0 mt-0\" flex=\"50\"><input name=\"churchbarangay\" ng-model=\"vm.selectedChurch.barangay.name\" \nplaceholder=\"Barangay\" disabled=\"disabled\"><div ng-messages=\"applicationForm.churchcity.$error\" \nng-show=\"applicationForm.churchbarangay.$touched\r\n                             || applicationForm.$submitted\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div></div></md-input-container></div><div \nlayout-gt-xs=\"row\"><div><h6 class=\"program-venue-text\">Program Venue</h6><h4 class=\"text-error\">{{vm.errorProgVenue}}\n</h4></div></div><div layout-gt-xs=\"row\" class=\"black\"><md-radio-group layout=\"row\" class=\"program-venue\" \nng-model=\"vm.application.programVenue\" ng-change=\"vm.autoFillCommunityAddress()\" required><md-radio-button \nng-repeat=\"venue in vm.programVenues\" class=\"md-primary\" ng-value=\"venue.value\">{{venue.label}}</md-radio-button>\n</md-radio-group></div><h4 class=\"new-app-label\">Transform Community Address</h4><div layout-gt-xs=\"row\">\n<md-autocomplete flex required md-input-name=\"Province\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedProvince\" md-selected-item-change=\"vm.selectProvince(Province)\" \nmd-search-text-change=\"vm.searchProvinceChange(vm.searchProvince)\" md-search-text=\"vm.searchProvince\" \nmd-items=\"Province in vm.searchProvinces(vm.searchProvince)\" md-item-text=\"Province.name\" md-require-match \nmd-floating-label=\"Province/County\" md-min-length=\"0\" ng-disabled=\"vm.application.programVenue === \'main_church\'\">\n<md-item-template><span md-highlight-text=\"vm.searchProvince\">{{Province.name}}</span></md-item-template><div \nclass=\"errors\" ng-messages=\"applicationForm.Province.$error\" \nng-if=\"applicationForm.Province.$touched\r\n                                || applicationForm.$submitted\"><div \nng-message=\"required\">Required</div><div ng-message=\"md-require-match\">Please select an existing province.</div></div>\n</md-autocomplete><md-autocomplete flex required md-input-name=\"communitycity\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedCommunityCity\" md-selected-item-change=\"vm.selectCommunityCity(communityCity)\" \nmd-search-text-change=\"vm.searchCommunityCityChange(vm.searchCommunityCity)\" md-search-text=\"vm.searchCommunityCity\" \nmd-items=\"communityCity in vm.searchCommunityCities(vm.searchCommunityCity)\" md-item-text=\"communityCity.name\" \nmd-require-match md-floating-label=\"City/Municipality/Sub County\" md-min-length=\"0\" \nng-disabled=\"!vm.selectedProvince || vm.application.programVenue === \'main_church\'\"><md-item-template><span \nmd-highlight-text=\"vm.searchCommunityCity\">{{communityCity.name}}</span></md-item-template><div class=\"errors\" \nng-messages=\"applicationForm.communitycity.$error\" \nng-if=\"applicationForm.communitycity.$touched\r\n                                || applicationForm.$submitted\"><div \nng-message=\"required\">Required</div><div ng-message=\"md-require-match\">Please select an existing city.</div></div>\n</md-autocomplete><md-autocomplete flex required md-input-name=\"communitybarangay\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedCommunityBarangay\" \nmd-selected-item-change=\"vm.selectCommunityBarangay(communityBarangay)\" \nmd-search-text-change=\"vm.searchCommunityBarangayChange(vm.searchCommunityBarangay)\" \nmd-search-text=\"vm.searchCommunityBarangay\" \nmd-items=\"communityBarangay in vm.searchCommunityBarangays(vm.searchCommunityBarangay)\" \nmd-item-text=\"communityBarangay.name\" md-require-match md-floating-label=\"Barangay/Parish\" md-min-length=\"0\" \nng-disabled=\"!vm.selectedCommunityCity || vm.application.programVenue === \'main_church\'\"><md-item-template><span \nmd-highlight-text=\"vm.searchCommunityBarangay\">{{communityBarangay.name}}</span></md-item-template><div class=\"errors\" \nng-messages=\"applicationForm.communitybarangay.$error\" \nng-if=\"applicationForm.communitybarangay.$touched\r\n                            || applicationForm.$submitted\"><div \nng-message=\"required\">Required</div><div ng-message=\"md-require-match\">Please select an existing barangay.</div></div>\n</md-autocomplete></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block mb-0\" flex><input \nname=\"communitystreet\" ng-model=\"vm.application.communityStreet\" placeholder=\"Street/Sitio/Purok/Village\" required><div\n ng-messages=\"applicationForm.communitystreet.$error\" \nng-show=\"applicationForm.communitystreet.$touched\r\n                                 || applicationForm.$submitted\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div></div></md-input-container></div><md-input-container\n class=\"md-block mb-0\" flex><input name=\"brgy_chairman\" ng-model=\"vm.application.brgyChairman\" \nplaceholder=\"Barangay Chairman\"><div ng-messages=\"applicationForm.brgy_chairman.$error\" \nng-show=\"applicationForm.brgy_chairman.$touched\r\n                         || applicationForm.$submitted\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div></div></md-input-container></div><div ng-show=\"vm.secondPage\">\n<div layout-gt-xs=\"row\"><span flex-gt-xs><div class=\"back-application\" ng-click=\"vm.secondPage = false\"><md-icon \nmd-font-icon=\"icon-chevron-left\" class=\"icon\"></md-icon><h4>Back</h4></div></span><span flex-gt-xs><div><h6 \nclass=\"application-id-label\">Application ID</h6></div><div><h3 class=\"application-id\">\n{{vm.application.application_id || \"--\"}}</h3></div></span></div><div layout-gt-xs=\"row\"><h4>\nPlease check boxes for the most appropriate answer:</h4></div><div><div layout-gt-xs=\"row\" class=\"black\"><div><h4 \nclass=\"bold-text\">Means of transportation going to the community:</h4><h4 class=\"text-error\">{{vm.errorMeansTranspo}}\n</h4></div></div><div layout-gt-xs=\"row\" class=\"black\"><div class=\"checkbox-holder\"><md-checkbox \nng-repeat=\"transpo in vm.meansTransportation\" class=\"md-primary means-transpo-checkbox\" \nng-checked=\"vm.isSelected(\'transpo\', transpo.value)\" ng-click=\"vm.toggleCheckBox(\'transpo\', transpo.value)\" \nng-value=\"transpo.value\">{{transpo.label}}</md-checkbox></div></div></div><div><div layout-gt-xs=\"row\" class=\"black\">\n<div><h4 class=\"bold-text\">Source of drinking water of participants:</h4><h4 class=\"text-error\">{{vm.errorSourceWater}}\n</h4></div></div><div layout-gt-xs=\"row\" class=\"black\"><div class=\"checkbox-holder\"><md-checkbox \nng-repeat=\"sourceWater in vm.sourcesOfWater\" class=\"md-primary means-transpo-checkbox\" \nng-checked=\"vm.isSelected(\'water\', sourceWater.value)\" ng-click=\"vm.toggleCheckBox(\'water\', sourceWater.value)\" \nng-value=\"sourceWater.value\">{{sourceWater.label}}</md-checkbox></div></div></div><div class=\"mb-20\"><div \nlayout-gt-xs=\"row\" class=\"black\"><div><h4 class=\"bold-text\">Source of income of participant / Job:</h4><h4 \nclass=\"text-error\">{{vm.errorSourceIncome}}</h4></div></div><div layout-gt-xs=\"row\" class=\"black\"><div \nclass=\"checkbox-holder\"><md-checkbox ng-repeat=\"sourceIncome in vm.sourcesOfIncome\" \nclass=\"md-primary source-income-checkbox\" ng-checked=\"vm.isSelected(\'income\', sourceIncome.value)\" \nng-click=\"vm.toggleCheckBox(\'income\', sourceIncome.value)\" ng-value=\"sourceIncome.value\">{{sourceIncome.label}}\n</md-checkbox><md-checkbox class=\"md-primary\" ng-model=\"vm.other\" ng-false-value=\"false\" ng-true-value=\"true\" \nng-click=\"vm.toggleCheckBox(\'income\', \'other\')\" ng-checked=\"vm.isSelected(\'income\', \'other\')\" ng-value=\"\'other\'\">Other\n</md-checkbox><md-input-container class=\"please-specify\" ng-show=\"vm.other\"><input name=\"specify\" \nng-model=\"vm.application.sourceIncomeText\" placeholder=\"Please specify\" \nng-required=\"vm.application.sourceIncome === \'other\'\"><div ng-messages=\"applicationForm.specify.$error\" \nng-show=\"applicationForm.specify.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Required</span></div></div>\n</md-input-container></div></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block mb-0\" flex><input \nname=\"distance\" type=\"number\" ng-model=\"vm.application.distance\" \nplaceholder=\"Distance of Community from the Office (in km)\"><div ng-messages=\"applicationForm.distance.$error\" \nng-show=\"applicationForm.distance.$touched\r\n                                 || applicationForm.$submitted\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-message=\"number\"><span>\nDistance should be a number.</span></div></div></md-input-container><md-input-container class=\"md-block mb-0\" flex>\n<label>Geographical Type</label><md-select name=\"geo_type\" ng-model=\"vm.application.geoType\"><md-option \nng-value=\"geo.value\" ng-repeat=\"geo in vm.geoType\">{{geo.label}}</md-option></md-select><div \nng-messages=\"applicationForm.geo_type.$error\" \nng-show=\"applicationForm.geo_type.$touched\r\n                                 || applicationForm.$submitted\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div></div></md-input-container></div></div></div>\n</md-dialog-content><md-dialog-actions><div ng-show=\"!vm.secondPage\" class=\"page-indicator\"><span>Page 1/2</span></div>\n<div ng-show=\"vm.secondPage\" class=\"page-indicator\"><span>Page 2/2</span></div><span class=\"flex\"></span><div \nclass=\"right-side\"><md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" ng-show=\"!vm.secondPage\" \nng-click=\"vm.secondPage = true\">Next</md-button><md-button class=\"md-accent md-raised\" ng-show=\"vm.secondPage\" \ntype=\"submit\" ng-disabled=\"vm.saving\r\n                           || applicationForm.pastor.$invalid\" \nng-click=\"vm.secondPage = true\"><span ng-show=\"!vm.saving\">Submit Application</span> <span ng-show=\"vm.saving\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting</span></md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/transform/dialogs/pastor-information/pastor-information-dialog.html","<md-dialog class=\"event-form-dialog transform-dialog\" aria-label=\"New Message\"><md-dialog-content ms-scroll><div \nclass=\"pastor-header\"><div class=\"left\"><div class=\"pastor-name\">{{vm.pastor.firstname + \' \' + vm.pastor.lastname}}\n</div><span class=\"go-to-profile\" ng-click=\"vm.goToProfile(vm.pastor)\">Go To Profile</span></div><div class=\"right\">\n<div ng-show=\"vm.pastor.contacts[0].contact_no\">{{vm.pastor.contacts[0].contact_no}}</div><div \nng-show=\"vm.pastor.contacts[1].contact_no\">{{vm.pastor.contacts[1].contact_no}}</div><div class=\"email\">\n{{vm.pastor.email}}</div></div></div><div class=\"pastor-content\"><div class=\"left-info\"><table class=\"table mb-0\"><tr \nng-repeat=\"first in vm.firstTable\"><td class=\"td-first\">{{first.name}}</td><td class=\"td-first-value\">\n{{first.value.toString()}}</td></tr></table></div><div class=\"right-info\"><table class=\"table\"><tr \nng-repeat=\"second in vm.secondTable\"><td class=\"td-first\">{{second.name}}</td><td class=\"td-first-value\">\n{{second.value | date}}</td></tr></table></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/transform/dialogs/batch-selection/batch-selection-dialog.html","<md-dialog class=\"batch-selection-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"batchSelectionForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div><div \nclass=\"row\"><div class=\"col-md-3 col-sm-3 col-xs-3\"><label>Application ID</label><p>{{vm.application.application_id}}\n</p></div><div class=\"col-md-3 col-sm-3 col-xs-3\"><label>Application Date</label><p>\n{{vm.application.applied_at | date}}</p></div><div class=\"col-md-2 col-sm-2 col-xs-2\"><label>Pastor</label><p>\n{{vm.application.pastor.firstname}} {{vm.application.pastor.lastname}}</p></div><div \nclass=\"col-md-2 col-sm-2 col-xs-2\"><label>Counselors</label><p>{{vm.application.total_counselors}}</p></div><div \nclass=\"col-md-2 col-sm-2 col-xs-2\"><label>Participants</label><p>\n{{vm.application.total_approved_participants}}/{{vm.application.total_participants}}</p></div></div><div class=\"row\">\n<div class=\"col-md-12\"><label>Location</label><p>\nBrgy. {{vm.application.community_barangay}}, {{vm.application.community_city}}</p></div></div><hr><div \nclass=\"row mt-15\"><div class=\"col-md-4\"><h3 class=\"assign-batch\">Assign To Batch</h3></div><div \nclass=\"col-md-4 pull-right\"><md-input-container class=\"md-block mb-0\" ng-show=\"vm.batches.length\"><label>Batch</label>\n<md-select ng-model=\"vm.batch\" placeholder=\"Select a batch\" required name=\"batch\"><md-option ng-value=\"batch.id\" \nng-repeat=\"batch in vm.batches\">{{ batch.short_name }}</md-option></md-select><div class=\"errors\" \nng-messages=\"batchSelectionForm.batch.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><h3 \nclass=\"no-available-batch\" ng-show=\"!vm.batches.length\">No Available batches</h3></div></div></div></md-dialog-content>\n<md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"batchSelectionForm.$invalid || vm.saving\" ng-click=\"vm.approveApplication()\"><span ng-show=\"!vm.saving\">\nApprove</span> <span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\">\n</md-progress-circular>Submitting</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/flourish/tabs/mcp/new case/new-case-dialog.html","<md-dialog class=\"edit-hbf-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"hbfForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll>\n<md-input-container class=\"md-block input-child-name-container input-week-no-container mt-24\" flex=\"70\"><label>Week:\n</label><md-select ng-model=\"vm.form.week_no\"><md-option ng-value=\"week.value\" ng-repeat=\"week in vm.weeks\">\n{{ week.label }}</md-option></md-select><div ng-messages=\"vm.apiErrors.week_no || hbfForm.week_no.$error\" \nng-show=\"hbfForm.week_no.$touched || hbfForm.week_no.$error\" role=\"alert\"><div ng-message=\"required\"><span>Required\n</span></div><div ng-bind=\"vm.apiErrors.week_no\"></div></div></md-input-container><md-autocomplete flex=\"70\" \nmd-input-name=\"guardian\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedGuardian\" md-selected-item-change=\"\" \nmd-search-text=\"vm.searchGuardians\" md-search-text=\"vm.searchGuardian\" \nstyle=\"height:20px; font-family:system-ui, Roboto\" \nmd-items=\"guardian in vm.searchGuardians(vm.communityId, vm.searchGuardian)\" md-item-text=\"guardian.fullname\" \nmd-floating-label=\"Guardian\'s Name\"><md-item-template><span md-highlight-text=\"vm.searchChurchCity\">\n{{guardian.fullname}}</span></md-item-template><div class=\"errors\" \nng-messages=\"vm.apiErrors.participant_id || vm.apiErrors.guardian_name\r\n                     || hbfForm.guardian.$error\" \nng-if=\"hbfForm.guardian.$touched\"><div ng-message=\"required\">Required</div><div ng-bind=\"vm.apiErrors.participant_id\">\n</div><div ng-bind=\"vm.apiErrors.guardian_name\"></div></div></md-autocomplete><md-input-container flex=\"40\" \nstyle=\"margin-top:-7pc; margin-left:24pc\"><p class=\"start-photo\">Start Photo</p><img \nsrc=\"http://via.placeholder.com/200x200?text=Upload\" class=\"ngf-image-select\" style=\"height:125px\" ngf-select \nng-if=\"!card.photo\" ng-model=\"card.photo\" ngf-multiple=\"false\" ngf-model-options=\"{updateOn: \'change\', debounce: 100}\" \naccept=\"image/*\"> <img class=\"ngf-image-select\" ngf-select ng-if=\"card.photo\" ngf-multiple=\"false\" \nngf-model-options=\"{updateOn: \'change\', debounce: 100}\" ngf-thumbnail=\"card.photo\" ng-model=\"card.photo\" \naccept=\"image/*\"></md-input-container><div layout=\"row\"><md-input-container \nclass=\"md-block input-child-name-container\" flex><label style=\"font-weight:400\">Child\'s First Name</label><input \nname=\"child_firstname\" ng-model=\"vm.form.child_firstname\" required><div \nng-messages=\"vm.apiErrors.child_firstname\r\n                || hbfForm.child_firstname.$error\" \nng-show=\"hbfForm.child_firstname.$touched\r\n                     || hbfForm.child_firstname.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.child_firstname\"></div></div>\n</md-input-container><md-input-container class=\"md-block input-child-name-container\" flex><label \nstyle=\"font-weight:400\">Child\'s Last Name</label><input name=\"child_lastname\" ng-model=\"vm.form.child_lastname\" \nrequired><div ng-messages=\"vm.apiErrors.child_lastname\r\n                || hbfForm.child_lastname.$error\" \nng-show=\"hbfForm.child_lastname.$touched\r\n                     || hbfForm.child_lastname.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.child_lastname\"></div></div>\n</md-input-container></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex=\"50\" \nng-show=\"vm.form.relationship !== \'Other\'\"><label>Relationship</label><md-select name=\"relationship\" \nng-model=\"vm.form.relationship\" required><md-option ng-value=\"relationship.value\" \nng-repeat=\"relationship in vm.childRelationships\">{{relationship.label}}</md-option></md-select><div \nng-messages=\"vm.apiErrors.relationship\r\n                    || hbfForm.relationship.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.relationship\"></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex=\"40\" ng-show=\"vm.form.relationship === \'Other\'\"><input \nname=\"relationshipname\" required placeholder=\"Relationship\" ng-model=\"vm.form.relationshipOther\"><div \nng-messages=\"vm.apiErrors.relationship\r\n                    || hbfForm.relationshipname.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.relationship\"></div></div>\n</md-input-container><span ng-show=\"vm.form.relationship === \'Other\'\" flex=\"10\" class=\"mt-24\" \nng-click=\"vm.form.relationship=\'\'\"><i class=\"icon-close\"><md-tooltip md-direction=\"right\">Cancel</md-tooltip></i>\n</span><md-input-container class=\"md-block\" flex=\"50\"><label style=\"font-weight:400\">Contact No</label><input \nname=\"contact_no\" ng-model=\"vm.form.contact_no\"><div \nng-messages=\"vm.apiErrors.contact_no\r\n                    || hbfForm.contact_no.$error\" \nng-show=\"hbfForm.contact_no.$touched\r\n                         || hbfForm.contact_no.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.contact_no\"></div></div>\n</md-input-container></div><div layout-gt-xs=\"row\"><div flex=\"65\"><md-input-container \nclass=\"md-block datepicker birthdate-datepicker\"><md-datepicker ng-model=\"vm.form.birthdate\" name=\"birthdate\" \nmd-open-on-focus md-placeholder=\"Enter Date\" md-input-name=\"birthdate\" ng-change=\"vm.calculateAge(vm.form)\" required>\n</md-datepicker><div class=\"errors\" \nng-messages=\"vm.apiErrors.birthdate\r\n                             || hbfForm.birthdate.$error\"><div ng-message=\"valid\" \nclass=\"date-error\">The entered value is not a date!</div><div ng-message=\"required\" class=\"date-error\">\nThis date is required!</div><div ng-bind=\"vm.apiErrors.birthdate\"></div></div></md-input-container><md-input-container \nclass=\"md-block datepicker\"><md-datepicker ng-model=\"vm.form.weight_at\" name=\"weight_at\" md-open-on-focus \nmd-input-name=\"weight_at\" md-placeholder=\"Weighing Date\" required></md-datepicker><div class=\"errors\" \nng-messages=\"vm.apiErrors.weight_at\r\n                             || hbfForm.weight_at.$error\"><div ng-message=\"valid\" \nclass=\"date-error\">The entered value is not a date!</div><div ng-message=\"required\" class=\"date-error\">\nThis date is required!</div><div ng-bind=\"vm.apiErrors.weight_at\"></div></div></md-input-container></div><div \nflex=\"30\" class=\"\"><p class=\"widget-clabel\">Gender</p><md-input-container class=\"md-block\"><md-radio-group \nng-model=\"vm.form.gender\" style=\"display:flex\"><md-radio-button ng-repeat=\"gender in vm.genders\" \nng-value=\"gender.value\" class=\"md-primary flex\">{{gender.label}}</md-radio-button></md-radio-group><div class=\"errors\" \nng-messages=\"vm.apiErrors.gender\r\n                             || hbfForm.gender.$error\"><div \nng-bind=\"vm.apiErrors.gender\"></div></div></md-input-container></div></div><div layout-gt-xs=\"row\"><div flex=\"60\"><div \nlayout-gt-xs=\"row\"><div flex><md-input-container class=\"md-block\"><label style=\"font-weight:400\">Weight (kg)</label>\n<input name=\"weight_kg\" type=\"number\" min=\"1\" ng-model=\"vm.form.weight_kg\" required><div \nng-messages=\"vm.apiErrors.weight_kg\r\n                                || hbfForm.weight_kg.$error\" \nng-show=\"hbfForm.weight_kg.$touched\r\n                                     || hbfForm.weight_kg.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div><div ng-message=\"number\"><span>Invalid number</span></div><div \nng-message=\"min\"><span>Should not be zero (0)</span></div><div ng-bind=\"vm.apiErrors.weight_kg\"></div></div>\n</md-input-container></div><div flex><md-input-container class=\"md-block\"><label style=\"font-weight:400\">Height (cm)\n</label><input name=\"height_cm\" type=\"number\" min=\"1\" ng-model=\"vm.form.height_cm\" required><div \nng-messages=\"vm.apiErrors.height_cm\r\n                                || hbfForm.height_cm.$error\" \nng-show=\"hbfForm.height_cm.$touched\r\n                                     || hbfForm.height_cm.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div><div ng-message=\"number\"><span>Invalid number</span></div><div \nng-message=\"min\"><span>Should not be zero (0)</span></div><div ng-bind=\"vm.apiErrors.height_cm\"></div></div>\n</md-input-container></div></div><md-input-container class=\"md-block\"><label style=\"font-weight:400\">Target Weight (kg)\n</label><input name=\"target_weight\" ng-model=\"vm.form.target_weight\" readonly=\"readonly\"><div \nng-messages=\"vm.apiErrors.target_weight\r\n                        || hbfForm.target_weight.$error\" \nng-show=\"hbfForm.target_weight.$touched\r\n                             || hbfForm.target_weight.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.target_weight\"></div></div>\n</md-input-container></div><div flex=\"40\" class=\"wasting-score-container\"><div class=\"col-md-12\"><label \nstyle=\"font-weight:400\">Wasting Score</label><div class=\"clearfix\"><div class=\"pull-left mr-16 text-center\" \nng-show=\"vm.form.calculatedScore\"><p class=\"widget-hlabel calc-score {{vm.form.calculatedScore.color}}\">\n{{ vm.form.calculatedScore.score || vm.form.calculatedScore.wasting_score | number : 1}}</p><p \nclass=\"widget-vlabel calc-code {{vm.form.calculatedScore.color}}\">\n{{vm.form.calculatedScore.code === \'CURED\' ? \'NORMAL\' : vm.form.calculatedScore.code}}</p></div><md-button \nclass=\"md-accent pull-left md-raised btn-calculate\" ng-click=\"vm.calculateScore(hbfForm, vm.form)\"><span \nng-show=\"vm.form.calculatedScore\">CALCULATE</span> <span ng-show=\"!vm.form.calculatedScore\">Calculate</span>\n</md-button></div></div></div></div><div layout-gt-xs=\"row\"><md-input-container flex class=\"mb-0 mt-0\" \nng-show=\"vm.form._age\r\n                                    && vm.form._age.months <= 24\"><md-checkbox value=\"1\" \nng-model=\"vm.form.breastfeeding\">Breastfeeding?</md-checkbox></md-input-container><md-input-container ng-hide=\"true\" \nflex class=\"mb-0 mt-0\"><md-checkbox value=\"1\" ng-model=\"vm.form.abcdef_test\">ABCDEF Test?</md-checkbox>\n</md-input-container><md-input-container ng-hide=\"true\" flex class=\"mb-0 mt-0\"><md-checkbox value=\"1\" \nng-model=\"vm.form.appetite_test\">Appetite Test?</md-checkbox></md-input-container></div></md-dialog-content>\n<md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" style=\"margin-right: 25pc\" \naria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button type=\"submit\" class=\"md-accent md-raised\" \nng-disabled=\"vm.saving\" ng-click=\"vm.updateHbf(hbfForm, vm.form)\"><span ng-show=\"!vm.saving\">Add Case</span> <span \nng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting\n</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/reports/base-report/tabs/dashboard2/dashboard.html","<div><h1>hello dashboard2</h1></div>");
$templateCache.put("app/main/reports/base-report/tabs/prevail/prevail.html","<div layout=\"row\"><md-input-container class=\"md-block\" flex=\"30\"><label>Base</label><md-select \nng-model=\"vm.filters.base\" ng-model-options=\"{ trackBy: \'$value.id\' }\" ng-disabled=\"currentUser.base_id\"><md-option \nng-value=\"base\" ng-repeat=\"base in vm.bases\">{{base.name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex=\"30\"><label>Batch</label><md-select ng-model=\"vm.filters.batch\" \nng-model-options=\"{ trackBy: \'$value.id\' }\" placeholder=\"Batch\" ng-change=\"vm.selectBatch(vm.filters)\"><md-option \nng-value=\"batch\" ng-repeat=\"batch in vm.batches\">{{ batch.short_name }}</md-option></md-select></md-input-container>\n<div flex=\"30\" class=\"base-report-thrive mt-20 ml-15\"><span class=\"preview\" ng-click=\"vm.getReport(vm.filters)\">\nGet Report</span></div></div><h4 ng-show=\"vm.noData\"><em>No Data to Show</em></h4><div \nclass=\"pull-right right-section\"><span class=\"download\" ng-show=\"vm.navsLength\">Download </span><span \nclass=\"download-xls-csv\" ng-show=\"vm.navsLength\"><a ng-href=\"{{vm.api.baseUrl + \'reports/xls?\' + vm.csvUrl}}\" \nclass=\"xls\" target=\"_blank\">XLS</a> <span class=\"divider\">| </span><a \nng-href=\"{{vm.api.baseUrl + \'reports/csv?\' + vm.csvUrl}}\" target=\"_blank\" class=\"csv\">CSV</a> <span class=\"divider\">| \n</span><a ng-href=\"{{vm.api.baseUrl + \'reports/pdf?\' + vm.csvUrl}}\" target=\"_blank\" class=\"csv\">PDF</a></span></div>\n<div class=\"report-table\" ng-bind-html=\"vm.table\"></div>");
$templateCache.put("app/main/reports/base-report/tabs/thrive/thrive.html","<div layout=\"row\" class=\"mb-25\"><md-input-container class=\"md-block\" flex=\"30\"><label>Base</label><md-select \nng-model=\"vm.filters.base\" ng-model-options=\"{ trackBy: \'$value.id\' }\" ng-disabled=\"currentUser.base_id\"><md-option \nng-value=\"base\" ng-repeat=\"base in vm.bases\">{{base.name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex=\"30\"><label>Batch</label><md-select ng-model=\"vm.filters.batch\" \nng-model-options=\"{ trackBy: \'$value.id\' }\" placeholder=\"Batch\"><md-option ng-value=\"batch\" \nng-repeat=\"batch in vm.batches\">{{ batch.short_name }}</md-option></md-select></md-input-container><div flex=\"30\" \nclass=\"base-report-thrive mt-20 ml-15\"><span class=\"preview\" ng-click=\"vm.getReport(vm.filters)\">Get Report</span>\n</div></div><h4 ng-show=\"vm.noData\"><em>No Data to Show</em></h4><div class=\"pull-right right-section\"><span \nclass=\"download\" ng-show=\"vm.navsLength\">Download </span><span class=\"download-xls-csv\" ng-show=\"vm.navsLength\"><a \nng-href=\"{{vm.api.baseUrl + \'reports/xls?\' + vm.csvUrl}}\" class=\"xls\" target=\"_blank\">XLS</a> <span class=\"divider\">| \n</span><a ng-href=\"{{vm.api.baseUrl + \'reports/csv?\' + vm.csvUrl}}\" target=\"_blank\" class=\"csv\">CSV</a> <span \nclass=\"divider\">| </span><a ng-href=\"{{vm.api.baseUrl + \'reports/pdf?\' + vm.csvUrl}}\" target=\"_blank\" class=\"csv\">PDF\n</a></span></div><div class=\"report-table\" ng-bind-html=\"vm.table\"></div>");
$templateCache.put("app/main/reports/base-report/tabs/transform/transform.html","<div layout=\"row\"><md-input-container class=\"md-block\" flex=\"30\"><label>Base</label><md-select \nng-model=\"vm.filters.base\" ng-model-options=\"{ trackBy: \'$value.id\' }\" ng-disabled=\"currentUser.base_id\"><md-option \nng-value=\"base\" ng-repeat=\"base in vm.bases\">{{base.name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block select-container\" flex=\"30\"><label>Program</label><md-select \nng-model=\"vm.filters.program\" ng-model-options=\"{ trackBy: \'$value.id\' }\" ng-change=\"vm.selectProgram(vm.filters)\">\n<md-option ng-value=\"program\" ng-repeat=\"program in vm.programs\">{{program.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex=\"30\"><label>Batch</label><md-select \nng-model=\"vm.filters.batch\" ng-model-options=\"{ trackBy: \'$value.id\' }\" placeholder=\"Batch\" \nng-change=\"vm.selectBatch(vm.filters)\"><md-option ng-value=\"batch\" ng-repeat=\"batch in vm.batches\">\n{{ batch.short_name }}</md-option></md-select></md-input-container><div flex=\"30\" \nclass=\"base-report-thrive mt-20 ml-15\"><span class=\"preview\" ng-click=\"vm.getReport(vm.filters)\">Get Report</span>\n</div></div><h4 ng-show=\"vm.noData\"><em>No Data to Show</em></h4><div class=\"pull-right right-section\"><span \nclass=\"download\" ng-show=\"vm.navsLength\">Download </span><span class=\"download-xls-csv\" ng-show=\"vm.navsLength\"><a \nng-href=\"{{vm.api.baseUrl + \'reports/xls?\' + vm.csvUrl}}\" class=\"xls\" target=\"_blank\">XLS</a> <span class=\"divider\">| \n</span><a ng-href=\"{{vm.api.baseUrl + \'reports/csv?\' + vm.csvUrl}}\" target=\"_blank\" class=\"csv\">CSV</a> <span \nclass=\"divider\">| </span><a ng-href=\"{{vm.api.baseUrl + \'reports/pdf?\' + vm.csvUrl}}\" target=\"_blank\" class=\"csv\">PDF\n</a></span></div><div class=\"report-table\" ng-bind-html=\"vm.table\"></div>");
$templateCache.put("app/main/reports/branch-report/tabs/prevail/prevail.html","<div layout=\"row\"><md-input-container class=\"md-block select-container\" flex=\"30\"><label>Base</label><md-select \nng-model=\"vm.filters.base\" ng-model-options=\"{ trackBy: \'$value.id\' }\" ng-change=\"vm.selectBase(vm.filters.base)\" \nng-disabled=\"currentUser.base_id\"><md-option ng-value=\"base\" ng-repeat=\"base in vm.bases\">{{base.name}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block select-container\" flex=\"30\"><label>Branch</label>\n<md-select ng-disabled=\"!vm.filters.base.branches.length\" ng-model=\"vm.filters.branch\" \nng-model-options=\"{ trackBy: \'$value.id\' }\" placeholder=\"Branch\"><md-option ng-value=\"branch\" \nng-repeat=\"branch in vm.filters.base.branches\">{{ branch.name }}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex=\"30\"><label>Batch</label><md-select ng-model=\"vm.filters.batch\" \nng-model-options=\"{ trackBy: \'$value.id\' }\" placeholder=\"Batch\" ng-change=\"vm.selectBatch(vm.filters)\"><md-option \nng-value=\"batch\" ng-repeat=\"batch in vm.batches\">{{ batch.short_name }}</md-option></md-select></md-input-container>\n<div flex=\"30\" class=\"base-report-thrive mt-20 ml-15\"><span class=\"preview\" ng-click=\"vm.getReport(vm.filters)\">\nGet Report</span></div></div><h4 ng-show=\"vm.noData\"><em>No Data to Show</em></h4><div \nclass=\"pull-right right-section\"><span class=\"download\" ng-show=\"vm.navsLength\">Download </span><span \nclass=\"download-xls-csv\" ng-show=\"vm.navsLength\"><a ng-href=\"{{vm.api.baseUrl + \'reports/xls?\' + vm.csvUrl}}\" \nclass=\"xls\" target=\"_blank\">XLS</a> <span class=\"divider\">| </span><a \nng-href=\"{{vm.api.baseUrl + \'reports/csv?\' + vm.csvUrl}}\" target=\"_blank\" class=\"csv\">CSV</a> <span class=\"divider\">| \n</span><a ng-href=\"{{vm.api.baseUrl + \'reports/pdf?\' + vm.csvUrl}}\" target=\"_blank\" class=\"csv\">PDF</a></span></div>\n<div class=\"report-table\" ng-bind-html=\"vm.table\"></div>");
$templateCache.put("app/main/reports/branch-report/tabs/transform/transform.html","<div layout=\"row\"><md-input-container class=\"md-block select-container\" flex=\"30\"><label>Base</label><md-select \nng-model=\"vm.filters.base\" ng-model-options=\"{ trackBy: \'$value.id\' }\" ng-change=\"vm.selectBase(vm.filters.base)\" \nng-disabled=\"currentUser.base_id\"><md-option ng-value=\"base\" ng-repeat=\"base in vm.bases\">{{base.name}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block select-container\" flex=\"30\"><label>Branch</label>\n<md-select ng-disabled=\"!vm.filters.base.branches.length\" ng-model=\"vm.filters.branch\" \nng-model-options=\"{ trackBy: \'$value.id\' }\" placeholder=\"Branch\"><md-option ng-value=\"branch\" \nng-repeat=\"branch in vm.filters.base.branches\">{{ branch.name }}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block select-container\" flex=\"30\"><label>Program</label><md-select \nng-model=\"vm.filters.program\" ng-model-options=\"{ trackBy: \'$value.id\' }\" ng-change=\"vm.selectProgram(vm.filters)\">\n<md-option ng-value=\"program\" ng-repeat=\"program in vm.programs\">{{program.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex=\"30\"><label>Batch</label><md-select \nng-model=\"vm.filters.batch\" ng-model-options=\"{ trackBy: \'$value.id\' }\" placeholder=\"Batch\" \nng-change=\"vm.selectBatch(vm.filters)\"><md-option ng-value=\"batch\" ng-repeat=\"batch in vm.batches\">\n{{ batch.short_name }}</md-option><md-option value=\"all\">All Batches</md-option></md-select></md-input-container><div \nflex=\"30\" class=\"base-report-thrive mt-20 ml-15\"><span class=\"preview\" ng-click=\"vm.getReport(vm.filters)\">Get Report\n</span></div></div><h4 ng-show=\"vm.noData\"><em>No Data to Show</em></h4><div class=\"pull-right right-section\"><span \nclass=\"download\" ng-show=\"vm.navsLength\">Download </span><span class=\"download-xls-csv\" ng-show=\"vm.navsLength\"><a \nng-href=\"{{vm.api.baseUrl + \'reports/xls?\' + vm.csvUrl}}\" class=\"xls\" target=\"_blank\">XLS</a> <span class=\"divider\">| \n</span><a ng-href=\"{{vm.api.baseUrl + \'reports/csv?\' + vm.csvUrl}}\" target=\"_blank\" class=\"csv\">CSV</a> <span \nclass=\"divider\">| </span><a ng-href=\"{{vm.api.baseUrl + \'reports/pdf?\' + vm.csvUrl}}\" target=\"_blank\" class=\"csv\">PDF\n</a></span></div><div class=\"report-table\" ng-bind-html=\"vm.table\"></div>");
$templateCache.put("app/main/reports/branch-report/tabs/thrive/thrive.html","<div layout=\"row\" class=\"mb-25\"><md-input-container class=\"md-block select-container\" flex=\"30\"><label>Base</label>\n<md-select ng-model=\"vm.filters.base\" ng-model-options=\"{ trackBy: \'$value.id\' }\" \nng-change=\"vm.selectBase(vm.filters.base)\" ng-disabled=\"currentUser.base_id\"><md-option ng-value=\"base\" \nng-repeat=\"base in vm.bases\">{{base.name}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block select-container\" flex=\"30\"><label>Branch</label><md-select \nng-disabled=\"!vm.filters.base.branches.length\" ng-model=\"vm.filters.branch\" \nng-model-options=\"{ trackBy: \'$value.id\' }\" placeholder=\"Branch\"><md-option ng-value=\"branch\" \nng-repeat=\"branch in vm.filters.base.branches\">{{ branch.name }}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex=\"30\"><label>Batch</label><md-select ng-model=\"vm.filters.batch\" \nng-model-options=\"{ trackBy: \'$value.id\' }\" placeholder=\"Batch\"><md-option ng-value=\"batch\" \nng-repeat=\"batch in vm.batches\">{{ batch.short_name }}</md-option></md-select></md-input-container><div flex=\"30\" \nclass=\"base-report-thrive mt-20 ml-15\"><span class=\"preview\" ng-click=\"vm.getReport(vm.filters)\">Get Report</span>\n</div></div><h4 ng-show=\"vm.noData\"><em>No Data to Show</em></h4><div class=\"pull-right right-section\"><span \nclass=\"download\" ng-show=\"vm.navsLength\">Download </span><span class=\"download-xls-csv\" ng-show=\"vm.navsLength\"><a \nng-href=\"{{vm.api.baseUrl + \'reports/xls?\' + vm.csvUrl}}\" class=\"xls\" target=\"_blank\">XLS</a> <span class=\"divider\">| \n</span><a ng-href=\"{{vm.api.baseUrl + \'reports/csv?\' + vm.csvUrl}}\" target=\"_blank\" class=\"csv\">CSV</a> <span \nclass=\"divider\">| </span><a ng-href=\"{{vm.api.baseUrl + \'reports/pdf?\' + vm.csvUrl}}\" target=\"_blank\" class=\"csv\">PDF\n</a></span></div><div class=\"report-table\" ng-bind-html=\"vm.table\"></div>");
$templateCache.put("app/main/settings/changelogs/tabs/active-users/activeusers.html","<style>\n.total-activity-container {\r\n        box-shadow: 1px 1px 3px #00000080;\r\n        border-radius: 4px;\r\n        padding: 16px;\r\n        margin: 0 20px 20px 0;\r\n    }\r\n\r\n    .total-activity-container h3 {\r\n        font-weight: bold;\r\n        color: #454545;\r\n        margin-top: 0px;\r\n        font-size: 30px;\r\n    }\r\n\r\n    .total-activity-container .count {\r\n        font-weight: 600;\r\n        color: #454545;\r\n    }\r\n\r\n    .total-activity-container .total-activity-icon {\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n    }\r\n\r\n    @media screen and (max-width: 600px) {\r\n        .total-activity-container {\r\n            margin-right: 0px;\r\n        }\r\n    }\r\n\r\n    /* For Total downloads sheet */\r\n    md-bottom-sheet.attendance-bottom-sheet {\r\n        height: 100%;\r\n    }\r\n\r\n    .total-downloads-slider-container {\r\n        height: 100%;\r\n    }\r\n\r\n    .total-downloads-slider-card {\r\n        border: 1px solid #ccc;\r\n        background: white;\r\n        height: 100%;\r\n    }\r\n\r\n    .total-downloads-slider-container .slider-header {\r\n        background: #e7e7e7;\r\n        color: #444;\r\n        padding: 10px;\r\n        padding-left: 30px;\r\n        padding-right: 26px;\r\n    }\r\n\r\n    .total-downloads-slider-container .slider-header h4 {\r\n        color: #525252;\r\n        font-weight: bold;\r\n        display: inline-block;\r\n    }\r\n\r\n    .total-downloads-slider-container .slider-header .deleted-application-close-button {\r\n        min-width: 0;\r\n        float: right;\r\n        display: inline-block;\r\n        top: -7px;\r\n    }\r\n\r\n    .total-downloads-slider-container .slider-header .deleted-application-close-button .icon-close {\r\n        vertical-align: middle;\r\n    }\r\n\r\n    .total-downloads-slider-container .slider-body {\r\n        padding: 10px;\r\n        padding-left: 30px;\r\n        padding-right: 30px;\r\n        height: calc(100% - 230px);\r\n    }\r\n\r\n    .total-downloads-slider-container table {\r\n        width: 100%;\r\n        max-width: 100%;\r\n        margin-bottom: 20px;\r\n        border-spacing: 0;\r\n        border-collapse: collapse;\r\n        background-color: transparent;\r\n    }\r\n\r\n    .total-downloads-slider-container .pagination-container {\r\n        text-align: center;\r\n    }\r\n\r\n    .total-downloads-slider-container table th {\r\n        border-top: 0;\r\n        border-bottom: 0 !important;\r\n        color: #386BBA;\r\n        vertical-align: bottom;\r\n        padding: 8px;\r\n        line-height: 1.42857143;\r\n    }\r\n\r\n    .total-downloads-slider-container table td {\r\n        border-top: 0 !important;\r\n        padding: 8px;\r\n        line-height: 1.42857143;\r\n        vertical-align: top;\r\n        border-bottom: 1px solid #ddd;\r\n        display: table-cell;\r\n    }\n</style><md-content class=\"tab-content settings-content-tab\"><div class=\"all-changelogs all-applications\"><div \nlayout-gt-xs=\"row\"><div class=\"total-activity-container\" flex=\"20\" flex-sm=\"100\" flex-xs=\"100\" role=\"button\" \nng-click=\"vm.showTotalDownloads(\'is_unique_users\')\"><div layout><div flex=\"90\"><h3>{{vm.users.TotalActivity.totalUser}}\n</h3><div class=\"count\">Total Unique Users</div></div><div flex=\"10\" class=\"total-activity-icon\"><i \nclass=\"icon-people\"></i></div></div></div><div class=\"total-activity-container\" flex=\"20\" flex-sm=\"100\" flex-xs=\"100\">\n<div layout><div flex=\"90\"><h3>{{vm.users.TotalActivity.totalLogin}}</h3><div class=\"count\">Total Login</div></div><div\n flex=\"10\" class=\"total-activity-icon\"><i class=\"icon-login\"></i></div></div></div><div \nclass=\"total-activity-container\" flex=\"20\" flex-sm=\"100\" flex-xs=\"100\"><div layout><div flex=\"90\"><h3>\n{{vm.users.TotalActivity.totalSync}}</h3><div class=\"count\">Total Sync</div></div><div flex=\"10\" \nclass=\"total-activity-icon\"><i class=\"icon-sync\"></i></div></div></div><div class=\"total-activity-container\" flex=\"20\" \nflex-sm=\"100\" flex-xs=\"100\" role=\"button\" ng-click=\"vm.showTotalDownloads()\"><div layout><div flex=\"90\"><h3>\n{{vm.users.TotalActivity.totalDownloads}}</h3><div class=\"count\">Total Downloads/Updates</div></div><div flex=\"10\" \nclass=\"total-activity-icon mt-8\"><i class=\"icon-download\"></i></div></div></div></div><table class=\"table\"><thead><tr>\n<th>User ID</th><th>User Name</th><th>Table</th><th>Activity</th><th>Date</th><th>Version</th><th>&nbsp;</th></tr>\n</thead><tbody><tr class=\"changelog\" ng-if=\"vm.isLoading\"><td colspan=\"7\"><center>Loading users</center></td></tr><tr \nclass=\"changelog\" ng-if=\"!vm.users.data.data.length && !vm.isLoading\"><td colspan=\"7\"><center>No users found.</center>\n</td></tr><tr class=\"changelog\" ng-repeat=\"user in vm.users.data.data\" ng-hide=\"vm.isLoading\"><td>{{user.user_id}}</td>\n<td>{{user.firstname}} {{user.lastname}}</td><td>{{user.table}}</td><td>{{user.activity}}</td><td>{{ user.created_at }}\n</td><td>{{ user.version }}</td><td class=\"icons-container\"><i class=\"icon-magnify\" ng-click=\"vm.viewMobilelog(user)\">\n<md-tooltip md-direction=\"left\">View Changes</md-tooltip></i></td></tr></tbody></table><div \nclass=\"pagination-container\"><pagination items=\"vm.users.data\" callback=\"vm.pageChange(vm.users.data.current_page)\">\n</pagination></div></div></md-content>");
$templateCache.put("app/main/settings/changelogs/tabs/api-errors/api-errors.html","<md-content class=\"tab-content settings-content-tab\"><div class=\"all-apiErrors all-applications\"><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex=\"30\"><label>Search</label><input \nng-model=\"vm.filters.search\" ng-change=\"vm.filterApiErrors(vm.filters)\" ng-model-options=\"{debounce: 300}\">\n</md-input-container><md-input-container class=\"md-block select-container mb-0\" flex=\"20\"><md-select \nng-model=\"vm.filters.device\" placeholder=\"Device\" ng-change=\"vm.filterApiErrors(vm.filters)\" \nng-disabled=\"vm.isLoading\"><md-option value=\"0\">All Devices</md-option><md-option ng-value=\"device\" \nng-repeat=\"device in vm.devices\">{{ device }}</md-option></md-select></md-input-container></div><table class=\"table\">\n<thead><tr><th>User</th><th>URL</th><th>Code</th><th>Message</th><th>Device</th><th>Date</th><th>&nbsp;</th></tr>\n</thead><tbody><tr class=\"apiError\" ng-if=\"!vm.apiErrors.data.length\"><td colspan=\"7\"><center>No data conflicts found.\n</center></td></tr><tr class=\"apiError\" ng-repeat=\"apiError in vm.apiErrors.data\"><td>\n{{apiError.user ? apiError.user.username : \'\'}}</td><td>{{apiError.request}}</td><td>{{apiError.code}}</td><td>\n{{apiError.message}}</td><td>{{apiError.device_type}}</td><td>{{ apiError.created_at }}</td><td \nclass=\"icons-container\"><i class=\"icon-magnify\" ng-click=\"vm.viewApiError(apiError)\"><md-tooltip md-direction=\"left\">\nView Changes</md-tooltip></i><i class=\"icon-trash\" ng-click=\"vm.deleteApiError(apiError)\"><md-tooltip \nmd-direction=\"left\">Delete ApiError</md-tooltip></i></td></tr></tbody></table><div class=\"pagination-container\">\n<pagination items=\"vm.apiErrors\" callback=\"vm.pageChange(vm.apiErrors.current_page)\"></pagination></div></div>\n</md-content>");
$templateCache.put("app/main/settings/thrive/tabs/affiliations/affiliations.html","<md-content class=\"tab-content settings-content-tab\"><div layout=\"row\" layout-align=\"start start\"><md-button \nclass=\"md-raised new-application\" ng-click=\"vm.addNewChurchAffiliation()\" \nstyle=\"background-color: #2657a0 ;text-transform: none; font-size: 14px; font-weight: bolder; color:#fff!important;letter-spacing: .010em ;text-shadow: 0.45px 0.45px #fff\">\nNew Affiliation</md-button><md-input-container style=\"width: 300px; margin-top: 10px; margin-left: 10px\"><input \nname=\"search\" ng-model=\"vm.filters.search\" ng-change=\"vm.initChurchAffiliationsTable(1, vm.filters)\" \nng-model-options=\"{\'*\': \'$inherit\', \'debounce\': 500}\" placeholder=\"Search Church Affiliation Name\" type=\"text\">\n</md-input-container></div><div class=\"all-applications\"><table class=\"table\"><thead><tr><th>Name</th><th>&nbsp;</th>\n</tr></thead><tbody><tr class=\"affiliation\" ng-if=\"!vm.affiliations.data.length\"><td colspan=\"3\"><center>\nNo affiliations found.</center></td></tr><tr class=\"affiliation-tr\" ng-repeat=\"affiliation in vm.affiliations.data\">\n<td>{{affiliation.name}}</td><td class=\"icons-container\"><i class=\"icon-pencil\" \nng-click=\"vm.editChurchAffiliation(affiliation)\"><md-tooltip md-direction=\"left\">Edit Church Affiliation</md-tooltip>\n</i><i class=\"icon-trash\" ng-click=\"vm.deleteChurchAffiliation(affiliation)\"><md-tooltip md-direction=\"left\">\nDelete Church Affiliation</md-tooltip></i></td></tr></tbody></table><div class=\"pagination-container\"><pagination \nitems=\"vm.affiliations\" callback=\"vm.pageChange(vm.affiliations.current_page)\"></pagination></div></div></md-content>");
$templateCache.put("app/main/settings/thrive/tabs/data-card/data-card.html","<style>\n.data-container {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 5rem;\r\n        margin-top: 30px;\r\n    }\r\n\r\n    .data-container .items h1 {\r\n        font-size: 4rem;\r\n        margin: 0;\r\n        padding: 0;\r\n    }\r\n\r\n    .data-container h6 {\r\n        font-size: 1.7rem;\r\n    }\n</style><md-content class=\"tab-content settings-content-tab\"><div class=\"data-container\"><div class=\"items\"><h1>\nThrive Data Card</h1></div><md-switch ng-true-value=\"true\" ng-false-value=\"false\" class=\"mb-0 mt-0\" \nng-model=\"vm.datacard\" ng-change=\"vm.onChangeDataCard(vm.datacard)\" aria-label=\"data-card-switch\"><h6>\n{{vm.datacard===true?\"On\":\"Off\"}}</h6></md-switch></div></md-content>");
$templateCache.put("app/main/settings/thrive/tabs/bases/bases.html","<md-content class=\"tab-content settings-content-tab\"><div layout=\"row\" layout-align=\"start start\"><md-button \nclass=\"md-raised new-application\" ng-click=\"vm.addNewBase()\" \nstyle=\"background-color: #2657a0 ;text-transform: none; font-size: 14px; font-weight: bolder; color:#fff!important;letter-spacing: .010em ;text-shadow: 0.45px 0.45px #fff\">\nNew Base</md-button><md-input-container style=\"width: 300px; margin-top: 10px; margin-left: 10px\"><input name=\"search\" \nng-model=\"vm.filters.search\" ng-change=\"vm.initBasesTable(vm.filters)\" \nng-model-options=\"{\'*\': \'$inherit\', \'debounce\': 500}\" placeholder=\"Search Base Name\" type=\"text\"></md-input-container>\n</div><div class=\"all-applications\"><table class=\"table\"><thead><tr><th>ID</th><th>Name</th><th>Country</th><th>\nProvinces</th><th>Branches</th><th>&nbsp;</th></tr></thead><tbody><tr class=\"base\" ng-if=\"!vm.bases.length\"><td \ncolspan=\"4\"><center>No bases found.</center></td></tr><tr class=\"base\" ng-repeat=\"base in vm.bases\"><td>\n{{base.old_id ? (\'00\' + base.old_id).slice(-2) : (\'00\' + base.id).slice(-2)}}</td><td>{{base.name}}</td><td>\n{{vm.countrysEnum[base.country_code]}}</td><td width=\"40%\"><div id=\"provinces-tags\" class=\"tags-container\"><div \nclass=\"tag\" data-ng-repeat=\"province in base.provinces\"><span class=\"tag-label nb\">{{province.name}} </span><i \nclass=\"icon-close\" ng-click=\"vm.deleteProvince(province)\"><md-tooltip md-direction=\"top\">Delete province</md-tooltip>\n</i></div><div class=\"tag add-tag\"><i class=\"icon-plus icon-add-batch\" ng-click=\"vm.addNewProvince(base)\"><md-tooltip \nmd-direction=\"top\">Add new Province</md-tooltip></i></div></div></td><td width=\"40%\"><div id=\"branches-tags\" \nclass=\"tags-container\"><div class=\"tag\" data-ng-repeat=\"branch in base.branches\"><span class=\"tag-label\" \nng-click=\"vm.editBranch(base, branch)\"><md-tooltip md-direction=\"top\">Edit branch</md-tooltip>{{branch.name}} </span><i\n class=\"icon-close\" ng-click=\"vm.deleteBranch(branch)\"><md-tooltip md-direction=\"top\">Delete branch</md-tooltip></i>\n</div><div class=\"tag add-tag\"><i class=\"icon-plus icon-add-batch\" ng-click=\"vm.addNewBranch(base)\"><md-tooltip \nmd-direction=\"top\">Add new Province</md-tooltip></i></div></div></td><td class=\"icons-container\"><i \nclass=\"icon-pencil\" ng-click=\"vm.editBase(base)\"><md-tooltip md-direction=\"left\">Edit Base</md-tooltip></i><i \nclass=\"icon-trash\" ng-click=\"vm.deleteBase(base)\"><md-tooltip md-direction=\"left\">Delete Base</md-tooltip></i></td>\n</tr></tbody></table></div></md-content>");
$templateCache.put("app/main/settings/thrive/tabs/denominations/denominations.html","<md-content class=\"tab-content settings-content-tab\"><md-button class=\"md-raised new-application\" \nng-click=\"vm.addNewDenomination()\">New Denomination</md-button><div class=\"all-applications\"><table class=\"table\">\n<thead><tr><th>Name</th><th>&nbsp;</th></tr></thead><tbody><tr class=\"denomination\" \nng-if=\"!vm.denominations.data.length\"><td colspan=\"3\"><center>No denominations found.</center></td></tr><tr \nclass=\"denomination-tr\" ng-repeat=\"denomination in vm.denominations.data\"><td>{{denomination.name}}</td><td \nclass=\"icons-container\"><i class=\"icon-pencil\" ng-click=\"vm.editDenomination(denomination)\"><md-tooltip \nmd-direction=\"left\">Edit Denomination</md-tooltip></i><i class=\"icon-trash\" \nng-click=\"vm.deleteDenomination(denomination)\"><md-tooltip md-direction=\"left\">Delete Denomination</md-tooltip></i>\n</td></tr></tbody></table><div class=\"pagination-container\"><pagination items=\"vm.denominations\" \ncallback=\"vm.pageChange(vm.denominations.current_page)\"></pagination></div></div></md-content>");
$templateCache.put("app/main/settings/changelogs/tabs/changelogs/changelogs.html","<md-content class=\"tab-content settings-content-tab\"><div class=\"all-changelogs all-applications\"><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex=\"30\"><label>Search</label><input \nng-model=\"vm.filters.search\" ng-change=\"vm.filterChangelogs(vm.filters)\" ng-model-options=\"{debounce: 300}\">\n</md-input-container><md-input-container class=\"md-block\" flex=\"20\"><label>Item ID</label><input \nng-model=\"vm.filters.item\" type=\"number\" ng-change=\"vm.filterChangelogs(vm.filters)\" \nng-model-options=\"{debounce: 300}\"></md-input-container><md-input-container class=\"md-block select-container mb-0\" \nflex=\"20\"><label>Action</label><md-select ng-model=\"vm.filters.action\" placeholder=\"Action\" \nng-change=\"vm.filterChangelogs(vm.filters)\" ng-disabled=\"vm.isLoading\"><md-option value=\"0\">All Actions</md-option>\n<md-option ng-value=\"action\" ng-repeat=\"action in vm.actions\">{{ action }}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block select-container mb-0\" flex=\"20\"><md-select ng-model=\"vm.filters.device\" \nplaceholder=\"Device\" ng-change=\"vm.filterChangelogs(vm.filters)\" ng-disabled=\"vm.isLoading\"><md-option value=\"0\">\nAll Devices</md-option><md-option ng-value=\"device\" ng-repeat=\"device in vm.devices\">{{ device }}</md-option>\n</md-select></md-input-container></div><table class=\"table\"><thead><tr><th>Table</th><th>Item ID</th><th>Action</th>\n<th>Device</th><th>User</th><th>Date</th><th>&nbsp;</th></tr></thead><tbody><tr class=\"changelog\" \nng-if=\"!vm.changelogs.data.length\"><td colspan=\"7\"><center>No changelogs found.</center></td></tr><tr \nclass=\"changelog\" ng-repeat=\"changelog in vm.changelogs.data\"><td>{{changelog.table}}</td><td>{{changelog.item_id}}\n</td><td>{{changelog.action}}</td><td>{{changelog.device_type}}</td><td>\n{{changelog.user ? changelog.user.username : \'\'}}</td><td>{{ changelog.created_at }}</td><td class=\"icons-container\"><i\n class=\"icon-magnify\" ng-click=\"vm.viewChangelog(changelog)\"><md-tooltip md-direction=\"left\">View Changes</md-tooltip>\n</i><i class=\"icon-trash\" ng-click=\"vm.deleteChangelog(changelog)\"><md-tooltip md-direction=\"left\">Delete Changelog\n</md-tooltip></i></td></tr></tbody></table><div class=\"pagination-container\"><pagination items=\"vm.changelogs\" \ncallback=\"vm.pageChange(vm.changelogs.current_page)\"></pagination></div></div></md-content>");
$templateCache.put("app/main/settings/thrive/tabs/mayors/mayors.html","<md-content class=\"tab-content settings-content-tab\"><div layout=\"row\" layout-align=\"start start\"><md-button \nclass=\"md-raised new-application\" ng-click=\"vm.addNewMayor()\" \nstyle=\"background-color: #2657a0 ;text-transform: none; font-size: 14px; font-weight: bolder; color:#fff!important;letter-spacing: .010em ;text-shadow: 0.45px 0.45px #fff\">\nNew Mayor</md-button><md-input-container style=\"width: 300px; margin-top: 10px; margin-left: 10px\"><input \nname=\"search\" ng-model=\"vm.filters.search\" ng-change=\"vm.initMayorsTable(1, vm.filters)\" \nng-model-options=\"{\'*\': \'$inherit\', \'debounce\': 500}\" placeholder=\"Search Mayor Name\" type=\"text\"></md-input-container>\n</div><div class=\"all-applications\"><table class=\"table\"><thead><tr><th>Name</th><th>Base</th><th>Municipality/City\n</th><th>&nbsp;</th></tr></thead><tbody><tr class=\"mayor\" ng-if=\"!vm.mayors.data.length\"><td colspan=\"4\"><center>\nNo mayors found.</center></td></tr><tr class=\"mayor-tr\" ng-repeat=\"mayor in vm.mayors.data\"><td>\n{{mayor.lastname}}, {{mayor.firstname}}</td><td>{{mayor.city.province.base.name}}</td><td>{{mayor.city.name}}</td><td \nclass=\"icons-container\"><i class=\"icon-pencil\" ng-click=\"vm.editMayor(mayor)\"><md-tooltip md-direction=\"left\">\nEdit Mayor</md-tooltip></i><i class=\"icon-trash\" ng-click=\"vm.deleteMayor(mayor)\"><md-tooltip md-direction=\"left\">\nDelete Mayor</md-tooltip></i></td></tr></tbody></table><div class=\"pagination-container\"><pagination items=\"vm.mayors\" \ncallback=\"vm.pageChange(vm.mayors.current_page)\"></pagination></div></div></md-content>");
$templateCache.put("app/main/settings/prevail/tabs/clusters/clusters.html","<md-content class=\"tab-content settings-content-tab\"><div layout=\"row\" layout-align=\"start start\"><md-button \nclass=\"md-raised new-application\" ng-click=\"vm.addNewCluster()\" \nstyle=\"background-color: #2657a0 ;text-transform: none; font-size: 14px; font-weight: bolder; color:#fff!important;letter-spacing: .010em ;text-shadow: 0.45px 0.45px #fff\">\nNew Cluster</md-button><div style=\"margin-left: 10px\"><md-input-container><label>Total Clusters</label><input \nng-value=\"vm.clusters.length\" disabled=\"disabled\"></md-input-container><md-input-container style=\"width: 300px\"><input \nname=\"search\" ng-model=\"vm.filters.search\" ng-change=\"vm.initClustersTable(vm.filters)\" \nng-model-options=\"{\'*\': \'$inherit\', \'debounce\': 500}\" placeholder=\"Search Cluster Name\" type=\"text\">\n</md-input-container></div></div><div class=\"all-applications\"><table class=\"table\"><thead><tr><th>ID</th><th>Base</th>\n<th>Branch</th><th>Name</th><th>&nbsp;</th></tr></thead><tbody><tr class=\"cluster\" ng-if=\"!vm.clusters.length\"><td \ncolspan=\"4\"><center>No clusters found.</center></td></tr><tr class=\"cluster\" \nng-repeat=\"cluster in vm.clusters | orderBy: \'branch.base.name\'\"><td>{{cluster.id}}</td><td>\n{{cluster.branch.base.name}}</td><td>{{cluster.branch.name}}</td><td>{{cluster.name}}</td><td class=\"icons-container\">\n<i class=\"icon-pencil\" ng-click=\"vm.editCluster(cluster)\"><md-tooltip md-direction=\"left\">Edit Cluster</md-tooltip></i>\n<i class=\"icon-trash\" ng-click=\"vm.deleteCluster(cluster)\"><md-tooltip md-direction=\"left\">Delete Cluster</md-tooltip>\n</i></td></tr></tbody></table></div></md-content>");
$templateCache.put("app/main/settings/prevail/tabs/partners/partners.html","<md-content class=\"tab-content settings-content-tab\"><div layout=\"row\" layout-align=\"start start\"><md-button \nclass=\"md-raised new-application\" ng-click=\"vm.addNewPartner()\" \nstyle=\"background-color: #2657a0 ;text-transform: none; font-size: 14px; font-weight: bolder; color:#fff!important;letter-spacing: .010em ;text-shadow: 0.45px 0.45px #fff\">\nNew Partner</md-button><md-input-container style=\"width: 300px; margin-top: 10px; margin-left: 10px\"><input \nname=\"search\" ng-model=\"vm.filters.search\" ng-change=\"vm.initPartnersTable(1, vm.filters)\" \nng-model-options=\"{\'*\': \'$inherit\', \'debounce\': 500}\" placeholder=\"Search Partner Name\" type=\"text\">\n</md-input-container></div><div class=\"all-applications\"><table class=\"table\"><thead><tr><th>Name</th><th>No. of Months\n</th><th>&nbsp;</th></tr></thead><tbody><tr class=\"partner\" ng-if=\"!vm.partners.data.length\"><td colspan=\"3\"><center>\nNo partners found.</center></td></tr><tr class=\"partner\" ng-repeat=\"partner in vm.partners.data\"><td>{{partner.name}}\n</td><td>{{partner.no_of_months}}</td><td class=\"icons-container\"><i class=\"icon-pencil\" \nng-click=\"vm.editPartner(partner)\"><md-tooltip md-direction=\"left\">Edit Partner</md-tooltip></i><i class=\"icon-trash\" \nng-click=\"vm.deletePartner(partner)\"><md-tooltip md-direction=\"left\">Delete Partner</md-tooltip></i></td></tr></tbody>\n</table><div class=\"pagination-container\"><pagination items=\"vm.partners\" \ncallback=\"vm.pageChange(vm.partners.current_page)\"></pagination></div></div></md-content>");
$templateCache.put("app/main/settings/prevail/tabs/small-group/small-group.html","<md-content class=\"tab-content settings-content-tab\"><div layout=\"row\" layout-align=\"start start\"><md-button \nclass=\"md-raised new-application\" ng-click=\"vm.addNewSmallGroup()\" \nstyle=\"background-color: #2657a0 ;text-transform: none; font-size: 14px; font-weight: bolder; color:#fff!important;letter-spacing: .010em ;text-shadow: 0.45px 0.45px #fff\">\nNew Small Group</md-button><div style=\"margin-left: 10px\"><md-input-container><label>Total Small Groups</label><input \nng-value=\"vm.smallGroups.total\" disabled=\"disabled\"></md-input-container><md-input-container style=\"width: 300px\">\n<input name=\"search\" ng-model=\"vm.filters.search\" ng-change=\"vm.initSmallGroupsTable(vm.filters)\" \nng-model-options=\"{\'*\': \'$inherit\', \'debounce\': 500}\" placeholder=\"Search Small Group Name\" type=\"text\">\n</md-input-container></div></div><div class=\"all-applications\"><table class=\"table\"><thead><tr><th>ID</th><th>Name</th>\n<th>Cluster</th><th>&nbsp;</th></tr></thead><tbody><tr class=\"smallGroup\" ng-if=\"!vm.smallGroups.data.length\"><td \ncolspan=\"4\"><center>No small groups found.</center></td></tr><tr class=\"smallGroup\" \nng-repeat=\"smallGroup in vm.smallGroups.data\"><td>{{smallGroup.id}}</td><td>{{smallGroup.name}}</td><td>\n{{smallGroup.cluster ? smallGroup.cluster.name : \"\"}}</td><td class=\"icons-container\"><i class=\"icon-pencil\" \nng-click=\"vm.editSmallGroup(smallGroup)\"><md-tooltip md-direction=\"left\">Edit Small Group</md-tooltip></i><i \nclass=\"icon-trash\" ng-click=\"vm.deleteSmallGroup(smallGroup)\"><md-tooltip md-direction=\"left\">Delete Small Group\n</md-tooltip></i></td></tr></tbody></table><div class=\"pagination-container\"><pagination items=\"vm.smallGroups\" \ncallback=\"vm.pageChange(vm.smallGroups.current_page)\"></pagination></div></div></md-content>");
$templateCache.put("app/main/settings/transform/tabs/batches/batches.html","<md-content class=\"tab-content settings-content-tab\"><div layout=\"row\" layout-align=\"start start\"><md-button \nclass=\"md-raised new-application\" ng-click=\"vm.addNewBatch()\" \nstyle=\"background-color: #2657a0 ;text-transform: none; font-size: 14px; font-weight: bolder; color:#fff!important;letter-spacing: .010em ;text-shadow: 0.45px 0.45px #fff\">\nNew Batch</md-button><md-input-container style=\"width: 300px; margin-top: 10px; margin-left: 10px\"><input \nname=\"search\" ng-model=\"vm.filters.search\" ng-change=\"vm.initBatchesTable(1, vm.filters)\" \nng-model-options=\"{\'*\': \'$inherit\', \'debounce\': 500}\" placeholder=\"Search Batch No / Stream\" type=\"text\">\n</md-input-container></div><div class=\"all-applications\"><table class=\"table\"><thead><tr><th>Batch No</th><th>Stream\n</th><th>Fiscal Year</th><th>Start Date</th><th>End Date</th><th>&nbsp;</th></tr></thead><tbody><tr class=\"batch\" \nng-if=\"!vm.batches.data.length\"><td colspan=\"5\"><center>No batches found.</center></td></tr><tr class=\"batch\" \nng-repeat=\"batch in vm.batches.data\"><td>{{batch.batch_no}}</td><td>{{batch.stream_name}}</td><td>\n{{batch.fiscal_year}}{{batch.end_year ? \'-\' + batch.end_year : \'\'}}</td><td>{{batch.start_at | date}}</td><td>\n{{batch.end_at | date}}</td><td class=\"icons-container\"><i class=\"icon-menu\" ng-click=\"vm.showBatchWeeks(batch)\">\n<md-tooltip md-direction=\"left\">Show Batch weeks</md-tooltip></i><i class=\"icon-pencil\" ng-click=\"vm.editBatch(batch)\">\n<md-tooltip md-direction=\"left\">Edit Batch</md-tooltip></i><i class=\"icon-trash\" ng-click=\"vm.deleteBatch(batch)\">\n<md-tooltip md-direction=\"left\">Delete Batch</md-tooltip></i></td></tr></tbody></table><div \nclass=\"pagination-container\"><pagination items=\"vm.batches\" callback=\"vm.pageChange(vm.batches.current_page)\">\n</pagination></div></div></md-content>");
$templateCache.put("app/main/settings/transform/tabs/donors/donors.html","<md-content class=\"tab-content settings-content-tab donor-content\"><div layout=\"row\" layout-align=\"start start\">\n<md-button class=\"md-raised new-application\" ng-click=\"vm.addNewDonor()\" \nstyle=\"background-color: #2657a0 ;text-transform: none; font-size: 14px; font-weight: bolder; color:#fff!important;letter-spacing: .010em ;text-shadow: 0.45px 0.45px #fff\">\nNew Donor</md-button><md-input-container style=\"width: 300px; margin-top: 10px; margin-left: 10px\"><input \nname=\"search\" ng-model=\"vm.filters.search\" ng-change=\"vm.initDonorsTable(1, vm.filters)\" \nng-model-options=\"{\'*\': \'$inherit\', \'debounce\': 500}\" placeholder=\"Search Donor Name\" type=\"text\"></md-input-container>\n</div><div class=\"all-applications\"><table class=\"table\"><thead><tr><th>Name</th><th>&nbsp;</th></tr></thead><tbody><tr\n class=\"donor\" ng-if=\"!vm.donors.data.length\"><td colspan=\"3\"><center>No donors found.</center></td></tr><tr \nclass=\"donor\" ng-repeat=\"donor in vm.donors.data\"><td>{{donor.name}}</td><td class=\"icons-container\"><i \nclass=\"icon-pencil\" ng-click=\"vm.editDonor(donor)\"><md-tooltip md-direction=\"left\">Edit Donor</md-tooltip></i><i \nclass=\"icon-trash\" ng-click=\"vm.deleteDonor(donor)\"><md-tooltip md-direction=\"left\">Delete Donor</md-tooltip></i></td>\n</tr></tbody></table><div class=\"pagination-container\"><pagination items=\"vm.donors\" \ncallback=\"vm.pageChange(vm.donors.current_page)\"></pagination></div></div></md-content>");
$templateCache.put("app/main/settings/transform/tabs/programs/programs.html","<md-content class=\"tab-content settings-content-tab\"><div layout=\"row\" layout-align=\"start start\"><md-button \nclass=\"md-raised new-application\" ng-click=\"vm.addNewProgram()\" \nstyle=\"background-color: #2657a0 ;text-transform: none; font-size: 14px; font-weight: bolder; color:#fff!important;letter-spacing: .010em ;text-shadow: 0.45px 0.45px #fff\">\nNew Program</md-button><md-input-container style=\"width: 300px; margin-top: 10px; margin-left: 10px\"><input \nname=\"search\" ng-model=\"vm.filters.search\" ng-change=\"vm.initProgramsTable(1, vm.filters)\" \nng-model-options=\"{\'*\': \'$inherit\', \'debounce\': 500}\" placeholder=\"Search Program Name\" type=\"text\">\n</md-input-container></div><div class=\"all-applications\"><table class=\"table\"><thead><tr><th>ID</th><th>Name</th><th>\nPilot of</th><th>Has 16 weeks</th><th>Active</th><th>&nbsp;</th></tr></thead><tbody><tr class=\"program\" \nng-if=\"!vm.programs.data.length\"><td colspan=\"5\"><center>No programs found.</center></td></tr><tr class=\"program\" \nng-repeat=\"program in vm.programs.data\"><td>{{program.id}}</td><td>{{program.name}}</td><td>{{program.parent.name}}\n</td><td>{{program.has_16th_week ? \'Yes\' : \'No\'}}</td><td>{{program.active ? \'Yes\' : \'No\'}}</td><td \nclass=\"icons-container\"><i class=\"icon-pencil\" ng-click=\"vm.editProgram(program)\"><md-tooltip md-direction=\"left\">\nEdit Program</md-tooltip></i><i class=\"icon-trash\" ng-click=\"vm.deleteProgram(program)\"><md-tooltip \nmd-direction=\"left\">Delete Program</md-tooltip></i></td></tr></tbody></table><div class=\"pagination-container\">\n<pagination items=\"vm.programs\" callback=\"vm.pageChange(vm.programs.current_page)\"></pagination></div></div>\n</md-content>");
$templateCache.put("app/main/settings/transform/tabs/products/products.html","<md-content class=\"tab-content settings-content-tab\"><div layout-gt-xs=\"row\" class=\"filters-container\" \nng-model-options=\"{ debounce: 300 }\"><md-button class=\"md-raised new-application\" ng-click=\"vm.addNewProduct()\" \nstyle=\"background-color: #2657a0 ;text-transform: none; font-size: 14px; font-weight: bolder; color:#fff!important;letter-spacing: .010em ;text-shadow: 0.45px 0.45px #fff\">\nNew Product</md-button><md-input-container class=\"md-block\" flex=\"40\"><label>Search product</label><input \nng-model=\"vm.filters.search\" ng-change=\"vm.filterProducts(vm.filters)\" ng-model-options=\"{ \'*\': \'$inherit\' }\">\n</md-input-container></div><div class=\"all-applications\"><table class=\"table\"><thead><tr><th>Name</th><th>&nbsp;</th>\n</tr></thead><tbody><tr class=\"product\" ng-if=\"!vm.products.data.length\"><td colspan=\"3\"><center>No products found.\n</center></td></tr><tr class=\"product-tr\" ng-repeat=\"product in vm.products.data\"><td>{{product.name}}</td><td \nclass=\"icons-container\"><i class=\"icon-pencil\" ng-click=\"vm.editProduct(product)\"><md-tooltip md-direction=\"left\">\nEdit Product</md-tooltip></i><i class=\"icon-trash\" ng-click=\"vm.deleteProduct(product)\"><md-tooltip \nmd-direction=\"left\">Delete Product</md-tooltip></i></td></tr></tbody></table><div class=\"pagination-container\">\n<pagination items=\"vm.products\" callback=\"vm.pageChange(vm.products.current_page)\"></pagination></div></div>\n</md-content>");
$templateCache.put("app/main/settings/transform/tabs/users/users.html","<md-content class=\"tab-content settings-content-tab\"><div layout-gt-xs=\"row\" class=\"filters-container\" \nng-model-options=\"{ debounce: 300 }\"><md-button class=\"md-raised new-application\" ng-click=\"vm.addNewUser($event)\" \nstyle=\"background-color: #2657a0 ;text-transform: none; font-size: 14px; font-weight: bolder; color:#fff!important;letter-spacing: .010em ;text-shadow: 0.45px 0.45px #fff\">\nNew User</md-button><md-input-container class=\"md-block\" flex=\"40\"><label>Search user by name, email or username\n</label><input ng-model=\"vm.filters.search\" ng-change=\"vm.filterUsers(vm.filters)\" \nng-model-options=\"{ \'*\': \'$inherit\' }\"></md-input-container></div><div class=\"all-applications\"><table class=\"table\">\n<thead><tr><th>First name</th><th>Last name</th><th>Email</th><th>Username</th><th>Role</th></tr></thead><tbody><tr \nclass=\"user\" ng-repeat=\"user in vm.users.data\"><td>{{user.firstname}}</td><td>{{user.lastname}}</td><td>{{user.email}}\n</td><td>{{user.username}}</td><td>{{vm.roles[user.roles[0]].label}}</td><td class=\"icons-container\"><i \nclass=\"icon-pencil\" ng-click=\"vm.editUser(user)\"><md-tooltip md-direction=\"left\">Edit User</md-tooltip></i><i \nclass=\"icon-trash\" ng-click=\"vm.deleteUser(user)\" ng-show=\"currentUser.username != user.username\"><md-tooltip \nmd-direction=\"left\">Delete User</md-tooltip></i></td></tr></tbody></table><div class=\"pagination-container\"><pagination\n items=\"vm.users\" callback=\"vm.pageChange(vm.users.current_page)\"></pagination></div></div></md-content>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/community/tabs/attendance/bottom-sheets/disqualified-participants/disqualified-participants.html","<md-bottom-sheet class=\"md-grid attendance-bottom-sheet\"><div class=\"disqualified-participants-slider-container\"><div \nclass=\"disqualified-participants-slider-card\"><div class=\"slider-header\"><h4 class=\"slider-title\">\nDisqualified Participants</h4><md-button ng-click=\"vm.closeDisqualifiedParticipants()\" md-no-ink \nclass=\"md-primary deleted-application-close-button\" aria-label=\"DROP\"><i class=\"icon-close\"></i></md-button></div><div \nclass=\"slider-body\"><md-content ms-scroll class=\"with-scrollbar\"><table class=\"table\"><tr><th>Participant Name</th>\n</tr><tr ng-show=\"!vm.participants.data.length\r\n                    && !vm.isLoading\"><td colspan=\"5\"><div \nclass=\"text-center\">No participants.</div></td></tr><tr ng-show=\"vm.isLoading && vm.participants.length < 1\"><td \ncolspan=\"5\"><div class=\"text-center\">Loading participants.</div></td></tr><tr \nng-repeat=\"participant in vm.participants.data\"><td class=\"name-td\"><span><img \nng-show=\"participant.type == \'counselor\'\" src=\"assets/icons/png/icon_counselor.png\"><md-tooltip md-direction=\"top\">\nOriginal Counselor</md-tooltip></span><span><img ng-show=\"participant.type == \'original\'\" \nsrc=\"assets/icons/png/icon_participant.png\"><md-tooltip md-direction=\"top\">Original Participant</md-tooltip></span>\n<span><img ng-show=\"participant.type == \'original_replacement\'\" src=\"assets/icons/png/icon_replace_participant.png\">\n<md-tooltip md-direction=\"top\">Replacement Participant</md-tooltip></span><span><img \nng-show=\"participant.type == \'counselor_replacement\'\" src=\"assets/icons/png/icon_replace_counselor.png\"><md-tooltip \nmd-direction=\"top\">Replacement Counselor</md-tooltip></span><i class=\"icon icon-gender-male icon-gender\" \nng-show=\"participant.gender === \'male\'\"><md-tooltip md-direction=\"top\">Male</md-tooltip></i><i \nclass=\"icon icon-gender-female icon-gender\" ng-show=\"participant.gender === \'female\'\"><md-tooltip md-direction=\"top\">\nFemale</md-tooltip></i><span ng-click=\"vm.editParticipant(participant)\">\n{{participant.lastname}}, {{participant.firstname}} </span><span \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_trainer\', \'health_trainer\', \'pastor_coordinator\', \'branch_head\', \'health_mentor\'])\">\n<i class=\"icon-check pull-right\" ng-click=\"vm.promoteToVisitor(participant); $event.stopPropagation();\"><md-tooltip \nmd-direction=\"left\">Promote to Visitor</md-tooltip></i><i class=\"icon-account-check pull-right\" \nng-click=\"vm.overrideParticipant(participant); $event.stopPropagation();\"><md-tooltip md-direction=\"left\">\nOverride Participant</md-tooltip></i></span></td></tr></table><div class=\"pagination-container\" \nng-show=\"!vm.isLoading\"><pagination items=\"vm.participants\" callback=\"vm.pageChange(vm.participants.current_page)\">\n</pagination></div></md-content></div></div></div></md-bottom-sheet>");
$templateCache.put("app/main/community/tabs/attendance/bottom-sheets/dropped-participants/dropped-participants.html","<md-bottom-sheet class=\"md-grid attendance-bottom-sheet\"><div class=\"dropped-participants-slider-container\"><div \nclass=\"dropped-participants-slider-card\"><div class=\"slider-header\"><h4 class=\"slider-title\">Dropped Participants</h4>\n<md-button ng-click=\"vm.closeDroppedParticipants()\" md-no-ink class=\"md-primary deleted-application-close-button\" \naria-label=\"DROP\"><i class=\"icon-close\"></i></md-button></div><div class=\"slider-body\"><md-content ms-scroll \nclass=\"with-scrollbar\"><table class=\"table\"><thead><tr><th class=\"no-content\"><span>Dropped Participants</span></th><th\n class=\"tl reason-drop\">Reason for Drop</th><th class=\"tl date-container\">Date</th></tr></thead><tbody><tr \nng-show=\"!vm.trashedParticipants.data.length\r\n                        && !vm.isLoading\"><td colspan=\"5\"><div \nclass=\"text-center\">No participants.</div></td></tr><tr ng-show=\"vm.isLoading && vm.trashedParticipants.length < 1\"><td\n colspan=\"5\"><div class=\"text-center\">Loading participants.</div></td></tr><tr \nng-repeat=\"participant in vm.trashedParticipants.data\"><td class=\"name-td\"><span><img \nng-show=\"participant.type == \'counselor\'\" src=\"assets/icons/png/icon_counselor.png\"><md-tooltip md-direction=\"top\">\nOriginal Counselor</md-tooltip></span><span><img ng-show=\"participant.type == \'original\'\" \nsrc=\"assets/icons/png/icon_participant.png\"><md-tooltip md-direction=\"top\">Original Participant</md-tooltip></span>\n<span><img ng-show=\"participant.type == \'original_replacement\'\" src=\"assets/icons/png/icon_replace_participant.png\">\n<md-tooltip md-direction=\"top\">Replacement Participant</md-tooltip></span><span><img \nng-show=\"participant.type == \'counselor_replacement\'\" src=\"assets/icons/png/icon_replace_counselor.png\"><md-tooltip \nmd-direction=\"top\">Replacement Counselor</md-tooltip></span><i class=\"icon icon-gender-male icon-gender\" \nng-show=\"participant.gender === \'male\'\"><md-tooltip md-direction=\"top\">Male</md-tooltip></i><i \nclass=\"icon icon-gender-female icon-gender\" ng-show=\"participant.gender === \'female\'\"><md-tooltip md-direction=\"top\">\nFemale</md-tooltip></i>{{participant.lastname}}, {{participant.firstname}}</td><td \nclass=\"tl no-hover reason-for-dropping\">{{participant.reasons_for_dropping}}</td><td class=\"tl\">\n{{participant.deleted_at | dateToISO | date : \'MMM. dd, yyyy\'}}</td><td><span \nng-if=\"currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_trainer\', \'health_trainer\', \'pastor_coordinator\', \'branch_head\', \'health_mentor\'])\">\n<i class=\"icon-trash pull-right\" ng-if=\"currentUser.$roles.has([\'admin\'])\" \nng-click=\"vm.hardDeleteParticipant(participant)\"><md-tooltip md-direction=\"left\">Delete Participant</md-tooltip></i><i \nclass=\"icon-refresh pull-right\" ng-click=\"vm.restoreParticipant(participant)\"><md-tooltip md-direction=\"left\">\nRestore Participant</md-tooltip></i></span></td></tr></tbody></table><div class=\"pagination-container\" \nng-show=\"!vm.isLoading\"><pagination items=\"vm.trashedParticipants\" \ncallback=\"vm.pageChange(vm.trashedParticipants.current_page)\"></pagination></div></md-content></div></div></div>\n</md-bottom-sheet>");
$templateCache.put("app/main/community/tabs/attendance/bottom-sheets/visitors-list/visitors-list.html","<md-bottom-sheet class=\"md-grid attendance-bottom-sheet\"><div class=\"visitors-list-slider-container\"><div \nclass=\"visitors-list-slider-card\"><div class=\"slider-header\"><h4 class=\"slider-title\">Visitors</h4><md-button \nng-click=\"vm.closeVisitors()\" md-no-ink class=\"md-primary deleted-application-close-button\" aria-label=\"DROP\"><i \nclass=\"icon-close\"></i></md-button></div><div class=\"slider-body\"><md-content ms-scroll class=\"with-scrollbar\">\n<md-button class=\"md-raised new-application mb-20\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'pastor_coordinator\', \'branch_head\'])\" ng-click=\"vm.addVisitor()\">\nAdd Visitor</md-button><table class=\"table\"><tr><th>Visitor Name</th></tr><tr \nng-show=\"!vm.visitors.data.length\r\n                    && !vm.isLoading\"><td colspan=\"5\"><div class=\"text-center\">\nNo visitors.</div></td></tr><tr ng-show=\"vm.isLoading && vm.visitors.length < 1\"><td colspan=\"5\"><div \nclass=\"text-center\">Loading visitors.</div></td></tr><tr ng-repeat=\"visitor in vm.visitors.data\"><td class=\"name-td\">\n{{visitor.lastname}}, {{visitor.firstname}} <span \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'pastor_coordinator\', \'branch_head\'])\"><i \nclass=\"icon-trash pull-right\" \nng-show=\"!currentUser.$roles.has([\'health_coordinator\',\r\n                                    \'pastor_coordinator\', \'livelihood_coordinator\',\r\n                                    \'donor_services\', \'donor_managers\', \'view_only\',\r\n                                    \'area_head\', \'national\'])\" \nng-click=\"vm.hardDeleteVisitor(visitor)\"><md-tooltip md-direction=\"left\">Delete Visitor</md-tooltip></i><i \nclass=\"icon-check pull-right\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'pastor_coordinator\', \'branch_head\'])\" \nng-click=\"vm.promoteVisitor(visitor); $event.stopPropagation();\"><md-tooltip md-direction=\"left\">Promote Visitor\n</md-tooltip></i></span></td></tr></table><div class=\"pagination-container\" ng-show=\"!vm.isLoading\"><pagination \nitems=\"vm.visitors\" callback=\"vm.pageChange(vm.visitors.current_page)\"></pagination></div></md-content></div></div>\n</div></md-bottom-sheet>");
$templateCache.put("app/main/community/tabs/attendance/dialogs/hard-delete-participant/hard-delete-participant-dialog.html","<md-dialog class=\"drop-application-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nclass=\"text-center\" ng-bind-html=\"vm.dialogBody\"></md-dialog-content><md-dialog-actions><md-button md-no-ink \nclass=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"vm.saving\" \nng-click=\"vm.passwordConfirmation ? vm.passwordConfirmation() : vm.deleteCallback()\"><span ng-show=\"!vm.saving\">Delete\n</span> <span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\">\n</md-progress-circular>Submitting</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/community/tabs/attendance/dialogs/promote-to-visitor/promote-to-visitor-dialog.html","<md-dialog class=\"drop-application-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nng-bind-html=\"vm.message\"></md-dialog-content><md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" \naria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"vm.saving\" ng-click=\"vm.promoteVisitor()\"><span ng-show=\"!vm.saving\">SAVE</span> <span \nng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting\n</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/community/tabs/attendance/dialogs/override-participant/override-participant-dialog.html","<md-dialog class=\"drop-application-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nng-bind-html=\"vm.message\"></md-dialog-content><md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" \naria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"vm.saving\" ng-click=\"vm.overrideParticipant()\"><span ng-show=\"!vm.saving\">SAVE</span> <span \nng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting\n</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/community/tabs/bib/bottom-sheets/bib-participants/bib-participants.html","<md-bottom-sheet class=\"md-grid cover-parent\"><div class=\"bib-participants-details-slider-container\"><div \nclass=\"slider-card\"><div class=\"slider-header\"><div class=\"row\"><div class=\"col-md-3 shl\"><div class=\"part\"><h1>\nWeek {{vm.bib.week}}</h1></div><div class=\"part\"></div></div><div class=\"col-md-9 text-right shr\"><div class=\"part\">\n<h3>{{vm.bib.capital | number:2}} PHP</h3><h4>Capital / Kit</h4></div><div class=\"part\"><h3>{{vm.bib.total_kits}}</h3>\n<h4>Total Kits</h4></div><div class=\"part\" ng-if=\"vm.bib.repayment\"><h3>{{vm.bib.total_payments | number:2}} PHP</h3>\n<h4>Total Repaid</h4></div><div class=\"part\"><h3>{{vm.bib.total_capital | number:2}} PHP</h3><h4>Total Capital</h4>\n</div><div class=\"part\" ng-if=\"vm.bib.repayment\"><h3>{{vm.bib.payment_percentage | number:2}}%</h3><h4>\nRepayment Rate (wk. {{vm.bib.community.current_week}})</h4></div><md-button md-no-ink ng-click=\"vm.hideSliderCard()\" \nclass=\"md-primary application-details-close-button\" aria-label=\"DROP\" class=\"drop-button\"><i class=\"icon-close\"></i>\n</md-button></div></div></div><div class=\"slider-body full\" ms-scroll><div class=\"table-wrapper lightbg\"><div \nclass=\"slider-content\"><md-button class=\"md-raised new-application\" \nng-show=\"vm.bib.community.application.pastor && currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_trainer\', \'health_trainer\', \'livelihood_coordinator\', \'branch_head\', \'health_mentor\'])\" \nng-click=\"vm.addPastor()\">Add Pastor</md-button><md-button class=\"md-raised new-application\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_coordinator\', \'livelihood_trainer\', \'health_trainer\', \'branch_head\', \'health_mentor\'])\" \nng-if=\"vm.availableParticipants.length\" ng-click=\"vm.addParticipant()\">Add Participant</md-button><md-button \nclass=\"md-raised new-application\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_coordinator\', \'livelihood_trainer\', \'health_trainer\', \'branch_head\', \'health_mentor\'])\" \nng-if=\"vm.availableParticipants.length\" ng-click=\"vm.addVisitor()\">Add Visitor</md-button><div \nid=\"bib-participants-wrapper\"><div class=\"all-applications bib-participants\"><table class=\"table\"><thead><tr><th \nclass=\"participant-id\">Participant ID</th><th class=\"participant-name\">Name</th><th>Type</th><th>Kits</th><th \nclass=\"text-center\">Total Payment</th><th class=\"text-center\">Balance</th><th>&nbsp;</th></tr></thead><tbody><tr \nng-show=\"!vm.participants.length\"><td colspan=\"7\" class=\"no-participants\"><div class=\"text-center\">No participants.\n</div></td></tr><tr ng-repeat=\"participant in vm.participants\" ng-show=\"!vm.isLoading1\"><td>\n{{participant.community.community_no}}{{participant.id}}</td><td class=\"name-td\"><i class=\"icon icon-gender-male\" \nng-show=\"participant.participant ? participant.participant.gender === \'male\' : participant.pastor_id ? vm.bib.community.application.pastor.gender === \'male\' : \'\'\">\n</i> <i class=\"icon icon-gender-female\" \nng-show=\"participant.participant ? participant.participant.gender === \'female\' : participant.pastor_id ? vm.bib.community.application.pastor.gender === \'female\' : \'\'\">\n</i> <i class=\"icon icon-gender-male invisible\" \nng-show=\"participant.participant ? !participant.participant.gender : false\"></i>\n {{participant.participant ? participant.participant.fullname : participant.pastor_id ? vm.bib.community.application.pastor.fullname : \'\'}}\n</td><td>{{participant.type | capitalize}}</td><td>{{participant.kits}}</td><td class=\"text-center\">\n{{participant.total_payments | number:2}}</td><td ng-class=\"{\'text-danger\' : participant.balance > 0}\" \nclass=\"text-center\">{{participant.balance | number:2}}</td><td class=\"icons-container\"><i class=\"icon-file\" \nng-click=\"vm.showNotes(participant)\"><md-tooltip md-direction=\"left\">Notes</md-tooltip></i><span \nng-click=\"vm.addPayment(participant)\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_trainer\', \'health_trainer\', \'livelihood_coordinator\', \'branch_head\', \'health_mentor\'])\">\n<img src=\"assets/icons/png/icon_coin.png\" class=\"coin\"><md-tooltip md-direction=\"left\">Add Payments</md-tooltip></span>\n<i class=\"icon-pencil pr-0\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_trainer\', \'health_trainer\', \'livelihood_coordinator\', \'branch_head\', \'health_mentor\'])\" \nng-click=\"vm.editParticipant(participant)\"><md-tooltip md-direction=\"left\">Edit</md-tooltip></i><i class=\"icon-trash\" \nng-click=\"vm.deleteParticipant(participant)\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_trainer\', \'health_trainer\', \'livelihood_coordinator\', \'branch_head\', \'health_mentor\'])\">\n<md-tooltip md-direction=\"left\">Delete Participant</md-tooltip></i></td></tr></tbody></table></div></div></div></div>\n<div class=\"table-wrapper\"><div class=\"slider-content\"><h1 class=\"mt-5\">Transactions</h1><div \nid=\"bib-transactions-wrapper\"><div class=\"all-applications bib-transactions\"><table class=\"table\"><thead><tr><th \nclass=\"participant-id\">Transaction ID</th><th class=\"transaction-name\">Name</th><th class=\"text-center\">Week</th><th \nclass=\"text-center\">Sale</th><th class=\"text-center\">Cash Payment</th><th class=\"text-center\">Non-Cash</th><th>&nbsp;\n</th></tr></thead><tbody><tr ng-show=\"!vm.payments.length\"><td colspan=\"6\" class=\"no-participants\"><div \nclass=\"text-center\">No transactions.</div></td></tr><tr ng-repeat=\"payment in vm.payments\" ng-show=\"!vm.isLoading1\" \nng-mouseover=\"payment.mouseOver = true\" ng-mouseleave=\"payment.mouseOver = false\"><td>\n{{(\"00000000\" + payment.id).slice(-8)}}</td><td>\n{{payment.participant.participant ? payment.participant.participant.fullname : payment.participant.pastor_id ? vm.bib.community.application.pastor.fullname : \'\'}}\n</td><td class=\"text-center\">{{payment.week}}</td><td ng-show=\"payment.sale\" class=\"payment-sale\">Yes</td><td \nng-show=\"!payment.sale\" class=\"text-danger text-center\">No</td><td class=\"text-center\">{{payment.cash | number:2}}</td>\n<td class=\"text-center\">{{payment.non_cash | number:2}}</td><td class=\"icons-container\">&nbsp;</td></tr></tbody>\n</table></div></div></div></div></div></div></div></md-bottom-sheet>");
$templateCache.put("app/main/community/tabs/bib/dialogs/delete-bib/delete-bib-dialog.html","<md-dialog class=\"delete-bib-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"deleteBibForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nclass=\"text-center\"><p class=\"text-muted text-reminder\"><em>\nRemoving this BIB will remove the associated bib participants and their transactions.</em></p><hr><p>\nAre you sure you want to delete this BIB?</p></md-dialog-content><md-dialog-actions><md-button md-no-ink \nclass=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button \nclass=\"md-accent md-raised\" ng-click=\"vm.passwordConfirmation()\"><span ng-show=\"!vm.saving\">Delete</span> <span \nng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting\n</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/community/tabs/bib/dialogs/repayment-bib/repayment-bib-dialog.html","<md-dialog class=\"delete-bib-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"deleteBibForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nclass=\"text-center\"><p>Are you sure you want to change repayment status?</p></md-dialog-content><md-dialog-actions>\n<md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel\n</md-button><md-button class=\"md-accent md-raised\" ng-click=\"vm.deleteBib()\"><span ng-show=\"!vm.saving\">Ok</span> <span\n ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting\n</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/community/tabs/business-loans/dialogs/add-business-loan/add-business-loan-dialog.html","<md-dialog class=\"add-business-loan-dialog transform-dialog\" aria-label=\"Add Business Loan\"><form name=\"addLoanForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveLoan()\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Add Business Loan</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll class=\"pb-0\"><div \nlayout=\"column\" style=\"min-width: 320px\"><md-input-container class=\"md-block mt-0\"><label>Product</label><md-select \nname=\"product_id\" ng-model=\"vm.loan.product_id\" required><md-option ng-value=\"product.id\" \nng-repeat=\"product in vm.products\">{{product.name}}</md-option></md-select><div \nng-messages=\"addLoanForm.product_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>Required</span></div></div>\n</md-input-container><md-input-container class=\"md-block mt-0 mb-0\"><label># of Loans</label><input name=\"loan_amount\" \ntype=\"number\" min=\"0\" ng-model=\"vm.loan.loan_amount\" required><div ng-messages=\"addLoanForm.loan_amount.$error\" \nng-show=\"addLoanForm.loan_amount.$touched || addLoanForm.$submitted\" role=\"alert\"><div ng-message=\"required\"><span>\nRequired</span></div><div ng-message=\"number\"><span>Invalid number</span></div><div ng-message=\"min\"><span>\nMust be 0 or greater</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions><md-button \nmd-no-ink class=\"md-primary cancel-button\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button \nclass=\"md-accent md-raised\" type=\"submit\" ng-disabled=\"addLoanForm.$invalid || vm.saving\"><span ng-show=\"!vm.saving\">\nSave</span> <span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\">\n</md-progress-circular>Saving</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/community/tabs/business-loans/dialogs/delete-business-loan/delete-business-loan-dialog.html","<md-dialog class=\"delete-business-loan-dialog transform-dialog\" aria-label=\"Delete Business Loan\"><form \nname=\"deleteLoanForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Delete Business Loan\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll class=\"text-center\"><p \nclass=\"text-muted text-reminder\"><em>This will permanently remove the business loan record.</em></p><hr><p>\nAre you sure you want to delete this business loan?</p></md-dialog-content><md-dialog-actions><md-button md-no-ink \nclass=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button \nclass=\"md-accent md-raised\" ng-click=\"vm.deleteLoan()\"><span ng-show=\"!vm.saving\">Delete</span> <span \nng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Deleting\n</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/community/tabs/hbf/bottom-sheets/hbf-details/hbf-details.html","<md-bottom-sheet class=\"md-grid cover-parent\"><div class=\"hbf-details-slider-container\"><div class=\"slider-card\"><div \nclass=\"slider-header clearfix\"><div class=\"text-center\"><div class=\"pull-left shl\"><div class=\"part\"><h1 \nclass=\"child-name\">{{vm.hbf.child_firstname}} {{vm.hbf.child_lastname}}</h1></div></div><div class=\"part\"><h3 \nclass=\"child-gender\">{{vm.hbf.gender}}</h3><h6>Gender</h6></div><div class=\"part\"><h3 class=\"child-age\">{{vm.hbf.age}}\n</h3><h6>Age</h6></div><div class=\"part\"><h3 class=\"child-age\">{{vm.getMeasure(vm.hbf.age)}}</h3><h6>Measure</h6></div>\n<div class=\"pull-right text-right shr\"><md-button md-no-ink class=\"md-accent md-raised\" class=\"edit-hbf\" \nng-show=\"!currentUser.$roles.has([\r\n                                   \'pastor_coordinator\',\r\n                                   \'livelihood_coordinator\', \'donor_services\',\r\n                                   \'donor_managers\', \'view_only\', \'area_head\'])\" \nng-click=\"vm.editHbf()\">Edit</md-button><md-button md-no-ink ng-click=\"vm.hideSliderCard()\" \nclass=\"md-primary application-details-close-button\" aria-label=\"DROP\" class=\"close-button\"><i class=\"icon-close\"></i>\n</md-button></div></div></div><div class=\"slider-body full\"><div class=\"clearfix mt-24\"><div layout-gt-xs=\"row\"><div \nclass=\"child-details\"><div class=\"clearfix\"><div class=\"col-lg-2 col-md-3 col-sm-4 col-xs-12\"><md-button md-no-ink \nclass=\"md-accent md-raised pull-left log-weight\" \nng-style=\"{\'background-color\': currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_trainer\', \'health_coordinator\', \'health_trainer\', \'branch_head\', \'health_mentor\']) ? \'#386bba\' : \'none\'}\" \nng-disabled=\"(vm.hbf.is_extended && vm.hbf.weight_logs_length === 18) || (!vm.hbf.is_extended && vm.hbf.weight_logs_length === 14) || vm.hbf.current_weight_log.discharge\r\n                                               || !currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_trainer\', \'health_coordinator\', \'health_trainer\', \'branch_head\', \'health_mentor\'])\" \nng-click=\"vm.logWeight(vm.hbf)\">Log Weight</md-button><md-input-container class=\"photo-container md-block\"><p \nclass=\"start-photo\">Start Photo</p><div class=\"photo-thumb\" \nstyle=\"background-image: url({{vm.hbf.before_photo_url || \'http://via.placeholder.com/200x200/ffffff/4575BE?text=UPLOAD\'}})\" \nng-mouseenter=\"vm.hbf.before_photo_hover = true\" ng-mouseleave=\"vm.hbf.before_photo_hover = false\" \nng-click=\"vm.hbf.before_photo ? vm.showLightBox(vm.hbf.before_photo_url, $event) : vm.replacePhoto(\'before\')\"><md-menu \nclass=\"photo-actions\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_trainer\', \'health_coordinator\', \'health_trainer\', \'branch_head\', \'health_mentor\']) && vm.hbf.before_photo\r\n                                                     && vm.hbf.before_photo_hover\" \nng-mouseenter=\"vm.hbf.before_photo_hover = true\" ng-mouseleave=\"vm.hbf.before_photo_hover = false\"><md-button \nclass=\"md-icon-button\" ng-mouseenter=\"$mdMenu.open()\"><i class=\"icon icon-dots-vertical s20\"></i></md-button>\n<md-menu-content width=\"2\" ng-mouseleave=\"$mdMenu.close()\"><md-menu-item><md-button \nng-click=\"vm.replacePhoto(\'before\')\">Replace</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.removePhoto(vm.hbf, \'before\', $event)\">Delete</md-button></md-menu-item></md-menu-content></md-menu></div>\n</md-input-container><md-input-container class=\"photo-container md-block\"><p class=\"end-photo\">End Photo</p><div \nclass=\"photo-thumb\" \nstyle=\"background-image: url({{vm.hbf.after_photo_url || \'http://via.placeholder.com/200x200/ffffff/4575BE?text=UPLOAD\'}})\" \nng-mouseenter=\"vm.hbf.after_photo_hover = true\" ng-mouseleave=\"vm.hbf.after_photo_hover = false\" \nng-click=\"vm.hbf.after_photo ? vm.showLightBox(vm.hbf.after_photo_url, $event) : vm.replacePhoto(\'after\')\"><md-menu \nclass=\"photo-actions\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_trainer\', \'health_coordinator\', \'health_trainer\', \'branch_head\', \'health_mentor\']) && vm.hbf.after_photo && vm.hbf.after_photo_hover\" \nng-mouseenter=\"vm.hbf.after_photo_hover = true\" ng-mouseleave=\"vm.hbf.after_photo_hover = false\"><md-button \nclass=\"md-icon-button\" ng-mouseenter=\"$mdMenu.open()\"><i class=\"icon icon-dots-vertical s20\"></i></md-button>\n<md-menu-content width=\"2\" ng-mouseleave=\"$mdMenu.close()\"><md-menu-item><md-button \nng-click=\"vm.replacePhoto(\'after\')\">Replace</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.removePhoto(vm.hbf, \'after\', $event)\">Delete</md-button></md-menu-item></md-menu-content></md-menu></div>\n</md-input-container></div><div class=\"col-lg-10 col-md-9 col-sm-8 col-xs-12\"><div \nclass=\"wasting-score-container clearfix\"><div layout-gt-xs=\"row\"><p class=\"slvlabel wasting-score-label\" flex=\"70\">\nStatus Overview</p></div><div layout-gt-xs=\"row\"><div flex=\"35\" class=\"initial\"><p class=\"wsl\">Initial</p><p \nclass=\"wsv\">{{vm.hbf.initial_weight_log.weight_kg | number : 1}} kg</p><p class=\"wst\">\n{{vm.hbf.initial_weight_log.wasting_score | number : 1}}</p><p class=\"ws-label text-center wsnobg\">\n{{ vm.hbf.initial_weight_log.code }}</p></div><div flex=\"35\"><p class=\"wsl\">Current</p><p class=\"wsv\">\n{{vm.hbf.current_weight_log.weight_kg | number : 1}} kg</p><p class=\"wst\">\n{{vm.hbf.current_weight_log.wasting_score | number : 1}}</p><p \nclass=\"ws-label text-center {{ vm.hbf.condition.color }}\">\n{{ vm.hbf.current_weight_log.code }} {{vm.hbf.current_weight_log.status_name ? \"- \" + vm.hbf.current_weight_log.status_name : \'\'}}\n</p></div><div flex=\"30\"><p class=\"wsl\">Target</p><p \nclass=\"wsv ng-class:{\'green\': vm.hbf.current_wasting_score_diff >= 0, \'red\' : vm.hbf.current_wasting_score_diff < 0}\">\n{{vm.hbf.current_weight_log.target_weight | number : 1}} kg</p><p \nclass=\"wst ng-class:{\'green\': vm.hbf.current_weight_diff >= 0, \'red\' : vm.hbf.current_weight_diff < 0}\"><span \nng-show=\"vm.hbf.current_wasting_score_diff >= 0\">+</span> {{vm.hbf.current_wasting_score_diff}}</p></div></div></div>\n<div layout-gt-xs=\"row\" class=\"add-participant-container\"><div class=\"mt-10 mr-10\"><span \nng-hide=\"vm.hbf.participant || currentUser.$roles.has([\r\n                                          \'pastor_coordinator\', \'livelihood_coordinator\',\r\n                                          \'livelihood_trainer\', \'donor_services\',\r\n                                          \'donor_managers\', \'view_only\', \'area_head\'])\">\n<i class=\"icon-account-plus\" ng-click=\"vm.addParticipant()\"><md-tooltip>Add as participant</md-tooltip></i></span>\n</div><div flex=\"50\"><div class=\"slrow\"><p class=\"slplabel\">Guardian</p><p class=\"slvlabel\">\n{{vm.hbf.participant ? vm.hbf.participant.fullname : vm.hbf.guest_name}} - {{vm.hbf.relationship | capitalize}}</p>\n</div><div class=\"slrow\"><p class=\"slplabel\">Initial Height</p><p class=\"slvlabel\"><span class=\"slv3 slvweight\">\n{{vm.hbf.initial_weight_log.height_cm}} cm</span></p></div></div><div flex=\"50\"><div class=\"slrow\"><p class=\"slplabel\">\nContact No</p><p class=\"slvlabel\">{{vm.hbf.contact_no || \'--\'}}</p></div><div class=\"slrow\"><p class=\"slplabel\">\nDate of Weighing</p><p class=\"slvlabel\"><span class=\"slv3 slvweight\">Week {{vm.hbf.initial_weight_log.week_no}}</span>\n</p></div></div></div><div id=\"weighing_chart\" class=\"text-center mt-24\"><div ng-show=\"vm.chart.data.length\"><canvas \nid=\"line\" class=\"chart chart-line\" chart-colors=\"vm.chart.colors\" chart-data=\"[vm.chart.target, vm.chart.data]\" \nchart-series=\"vm.chart.series\" chart-labels=\"vm.chart.labels\" chart-options=\"vm.chart.options\"></canvas></div><div \nclass=\"loading-chart\" ng-show=\"!vm.chart.data.length\">Loading chart</div></div></div></div></div><div \nclass=\"pull-right logs-container\"><div class=\"weight-logs-table\"><table id=\"weight-logs-table\" class=\"table\"><thead>\n<tr><th>Week</th><th>Weight (kg)</th><th>&Delta; Week (kg)</th><th>Score</th><th>Food</th><th>&nbsp;</th><th \nng-show=\"!currentUser.$roles.has([\r\n                                        \'pastor_coordinator\', \'livelihood_coordinator\',\r\n                                        \'livelihood_trainer\', \'donor_services\',\r\n                                        \'donor_managers\', \'view_only\',\r\n                                        \'area_head\'])\">\n&nbsp;</th></tr></thead><tbody><tr ng-repeat=\"week in vm.tableRows\" ng-hide=\"!vm.hbf.is_extended && week > 16\"><td>\n{{week}}</td><td>{{ vm.hbf.weight_logs[week] ? (vm.hbf.weight_logs[week].weight_kg | number : 1) : \'\'}}</td><td \nng-class=\"{\'text-green\': vm.hbf.weight_logs[week].weight_diff >= 0,\r\n                                        \'text-danger\': vm.hbf.weight_logs[week].weight_diff < 0 }\">\n<span ng-show=\"vm.hbf.weight_logs[week].weight_diff > 0\">+</span>\n {{vm.hbf.weight_logs[week] ? (vm.hbf.weight_logs[week].weight_diff | number : 1) : \'\'}}</td><td \nng-class=\"{\'text-green\': vm.hbf.weight_logs[week].color_code ===\'success\',\r\n                                      \'text-red\': vm.hbf.weight_logs[week].color_code === \'danger\',\r\n                                      \'text-orange\': vm.hbf.weight_logs[week].color_code===\'warning\'}\">\n{{ vm.hbf.weight_logs[week] ? (vm.hbf.weight_logs[week].wasting_score | number : 1) : \'\'}}</td><td>\n{{ vm.hbf.weight_logs[week] && vm.hbf.weight_logs[week].nutripacks > 0 ? vm.hbf.weight_logs[week].nutripacks : \'\' }}\n</td><td><span ng-if=\"vm.hbf.weight_logs[week] && vm.hbf.weight_logs[week].dewormed\">Dewormed<br></span>\n{{vm.hbf.weight_logs[week].discharge ? \'Discharged\' : \' \'}} {{vm.hbf.weight_logs[week].discharge && vm.hbf.weight_logs[week].mcn ? \'-\' : \'\'}} {{vm.hbf.weight_logs[week].mcn ? \'MCN\' : \'\'}}\n</td><td class=\"action-buttons\" \nng-show=\"!currentUser.$roles.has([\r\n                                        \'pastor_coordinator\', \'livelihood_coordinator\',\r\n                                        \'livelihood_trainer\', \'donor_services\',\r\n                                        \'donor_managers\', \'view_only\', \'area_head\'])\">\n<i class=\"icon-note-outline\" ng-if=\"vm.hbf.weight_logs[week] && vm.hbf.weight_logs[week].notes\" \nng-click=\"vm.editWeightLog(vm.hbf.weight_logs[week], vm.hbf)\"><md-tooltip md-direction=\"left\">View notes</md-tooltip>\n</i><i class=\"icon-pencil\" ng-if=\"vm.hbf.weight_logs[week]\" \nng-click=\"vm.editWeightLog(vm.hbf.weight_logs[week], vm.hbf)\"><md-tooltip md-direction=\"left\">Edit Weight Log\n</md-tooltip></i><i class=\"icon-trash\" \nng-if=\"vm.hbf.weight_logs[week]\r\n                                               && vm.hbf.weight_logs_length > 1\r\n                                               && week != vm.hbf.initial_weight_log.week_no\" \nng-click=\"vm.deleteWeigtLog(vm.hbf.weight_logs[week])\"><md-tooltip md-direction=\"left\">Delete Weight Log</md-tooltip>\n</i></td></tr></tbody></table></div></div></div></div></div></div></div></md-bottom-sheet>");
$templateCache.put("app/main/community/tabs/hbf/dialogs/add-weight-log/add-weight-log-dialog.html","<md-dialog class=\"add-weight-log-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"addWeightLogForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nclass=\"text-center\"><p>{{vm.hbf.child_firstname}} {{vm.hbf.child_lastname}}</p><div layout-gt-xs=\"row\" \nlayout-align=\"center center\"><md-input-container \nclass=\"md-block input-child-name-container width-350 input-week-no-container\"><label>Week:</label><md-select \nng-model=\"vm.weightLog.week_no\" ng-disabled=\"vm.saving\"><md-option ng-value=\"week.value\" ng-repeat=\"week in vm.weeks\">\n{{ week.label }}</md-option></md-select><div \nng-messages=\"vm.apiErrors.week_no\r\n                    || addWeightLogForm.week_no.$error\" \nng-show=\"addWeightLogForm.week_no.$touched\r\n                         || addWeightLogForm.week_no.$error\" role=\"alert\">\n<div ng-bind=\"vm.apiErrors.week_no\"></div></div></md-input-container></div><div layout-gt-xs=\"row\" \nlayout-align=\"center center\"><md-input-container class=\"md-block mb-0 width-350\"><input name=\"weight_kg\" type=\"number\" \nng-model=\"vm.weightLog.weight_kg\" placeholder=\"Weight (kg)\" ng-disabled=\"vm.saving\"><div \nng-messages=\"vm.apiErrors.weight_kg\r\n                    || addWeightLogForm.weight_kg.$error\" \nng-show=\"addWeightLogForm.weight_kg.$touched\" role=\"alert\"><div ng-message=\"number\"><span>Invalid number</span></div>\n<div ng-message=\"required\"><span>Required</span></div><div ng-message=\"min\"><span>Should not be zero (0)</span></div>\n<div ng-bind=\"vm.apiErrors.weight_kg\"></div></div></md-input-container></div><div layout-gt-xs=\"row\" \nlayout-align=\"center center\"><md-input-container class=\"md-block mb-0 width-350\" \nng-if=\"vm.weightLog.week_no == 2\r\n                                    || vm.weightLog.week_no == 14\r\n                                    || vm.weightLog.week_no == 15\r\n                                    || vm.weightLog.week_no == 16\r\n                                    || vm.weightLog.week_no == 29\">\n<input name=\"height_cm\" type=\"number\" min=\"1\" ng-model=\"vm.weightLog.height_cm\" placeholder=\"Height (cm)\" \nng-disabled=\"vm.saving\"><div \nng-messages=\"vm.apiErrors.height_cm\r\n                    || addWeightLogForm.height_cm.$error\" \nng-show=\"addWeightLogForm.height_cm.$touched\r\n                         || addWeightLogForm.height_cm.$error\" \nrole=\"alert\"><div ng-message=\"number\"><span>Invalid number</span></div><div ng-message=\"min\"><span>\nShould not be zero (0)</span></div><div ng-bind=\"vm.apiErrors.height_cm\"></div></div></md-input-container></div><div \nlayout-gt-xs=\"row\" layout-align=\"center center\"><md-input-container class=\"md-block mb-0 width-350\"><input \nname=\"nutripacks\" type=\"number\" ng-model=\"vm.weightLog.nutripacks\" placeholder=\"Food Dispersed\" \nng-disabled=\"vm.saving\"><div \nng-messages=\"vm.apiErrors.nutripacks\r\n                    || addWeightLogForm.nutripacks.$error\" \nng-show=\"addWeightLogForm.nutripacks.$touched\r\n                         || addWeightLogForm.nutripacks.$error\" \nrole=\"alert\"><div ng-message=\"number\"><span>Invalid number</span></div><div ng-message=\"min\"><span>\nShould at least be zero (0)</span></div><div ng-bind=\"vm.apiErrors.nutripacks\"></div></div></md-input-container></div>\n<div layout-gt-xs=\"column\" layout-align=\"center center\"><md-input-container class=\"md-block mt-0 mb-0 width-350\" flex>\n<md-checkbox ng-model=\"vm.weightLog.dewormed\">Dewormed</md-checkbox></md-input-container><md-input-container \nclass=\"md-block mt-10 mb-10 width-350\" ng-show=\"vm.weightLog.dewormed\"><label>Please select dewormed option</label>\n<md-select ng-model=\"vm.weightLog.dewormOption\" ng-required=\"vm.weightLog.dewormed\" name=\"dewormoption\" \nng-disabled=\"vm.saving\"><md-option ng-value=\"option.value\" ng-repeat=\"option in vm.dewormOptions\">{{ option.label }}\n</md-option></md-select><div ng-messages=\"addWeightLogForm.dewormoption.$error\" \nng-show=\"addWeightLogForm.dewormoption.$touched\" role=\"alert\"><div ng-message=\"required\">Required</div></div>\n</md-input-container></div><div layout-gt-xs=\"row\" layout-align=\"center center\"><md-input-container \nclass=\"md-block mt-0 mb-0 width-350\" flex><md-checkbox class=\"no-margin\" ng-model=\"vm.medicalCareNeeded\">\nMedical Care Needed</md-checkbox></md-input-container></div><div layout-gt-xs=\"column\" layout-align=\"center center\">\n<md-input-container class=\"md-block mt-0 mb-0 width-350\"><md-checkbox ng-model=\"vm.discharge\">Discharge</md-checkbox>\n</md-input-container><md-input-container class=\"md-block mt-10 mb-0 width-350\" \nng-show=\"vm.weightLog.week_no != 15 && vm.discharge\"><label>Please select discharge option</label><md-select \nng-model=\"vm.weightLog.dischargeOption\" ng-required=\"vm.discharge && vm.weightLog.week_no !=15\" name=\"dischargeoption\" \nng-disabled=\"vm.saving\"><md-option ng-value=\"option.value\" ng-repeat=\"option in vm.dischargeOptions\">{{ option.label }}\n</md-option></md-select><div ng-messages=\"addWeightLogForm.dischargeoption.$error\" \nng-show=\"addWeightLogForm.dischargeoption.$touched\" role=\"alert\"><div ng-message=\"required\">Required</div></div>\n</md-input-container><md-input-container class=\"width-350\" \nng-show=\"vm.weightLog.dischargeOption === \'refused_treatment\'\"><label>Please explain why the case refused treatment:\n</label><textarea md-no-autogrow ng-model=\"vm.weightLog.reason_for_refused_treatment\"></textarea></md-input-container>\n<md-input-container class=\"md-block mt-0 mb-0 width-350\" ng-show=\"vm.weightLog.week_no == 15 && vm.discharge \" \nflex=\"50\"><md-select ng-model=\"vm.weightLog.completed\" disabled=\"disabled\"><md-option ng-value=\"completed\" \nng-selected=\"true\">Completed Treatment</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block mt-0 mb-2 width-350\" flex \nng-show=\"vm.weightLog.week_no === 14 || vm.weightLog.week_no === 15 || vm.weightLog.week_no === 16\"><md-checkbox \nclass=\"no-margin\" ng-model=\"vm.hbf.is_extended\">Extended HBF</md-checkbox></md-input-container><md-input-container \nclass=\"md-block mt-0 mb-0 width-350\" flex><md-checkbox class=\"no-margin\" ng-model=\"vm.absent\">Absent</md-checkbox>\n</md-input-container></div><div class=\"log-notes mt-30\"><md-input-container class=\"width-350\"><label>Notes:</label>\n<textarea md-no-autogrow ng-model=\"vm.weightLog.notes\"></textarea></md-input-container></div></md-dialog-content>\n<md-dialog-actions><md-button md-no-ink class=\"md-primary pull-left\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">\nCancel</md-button><md-button type=\"submit\" class=\"md-accent md-raised pull-right\" \nng-disabled=\"addWeightLogForm.$invalid || vm.saving\" ng-click=\"vm.addWeightLog(addWeightLogForm, vm.weightLog)\">\n<md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.saving\" md-diameter=\"10px\"></md-progress-circular>Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/community/tabs/hbf/dialogs/delete-hbf/delete-hbf-dialog.html","<md-dialog class=\"delete-hbf-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"deleteHbfForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nclass=\"text-center\"><p class=\"text-muted text-reminder\"><em>\nRemoving this HBF will remove the associated child and his/her weight logs.</em></p><hr><p>\nAre you sure you want to delete this HBF?</p></md-dialog-content><md-dialog-actions><md-button md-no-ink \nclass=\"md-primary\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button \nclass=\"md-accent md-raised\" ng-click=\"vm.passwordConfirmation()\">Delete</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/community/tabs/hbf/dialogs/delete-note/delete-note-dialog.html","<md-dialog class=\"delete-note-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll>\nAre you sure you want to delete this note?</md-dialog-content><md-dialog-actions><md-button md-no-ink \nclass=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button \nclass=\"md-accent md-raised\" ng-click=\"vm.deleteNote()\">Delete</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/community/tabs/hbf/dialogs/delete-weight-log/delete-weight-log-dialog.html","<md-dialog class=\"delete-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><p>\nAre you sure to delete this weight log?</p></md-dialog-content><md-dialog-actions><md-button md-no-ink \nclass=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button \nclass=\"md-accent md-raised\" ng-click=\"vm.passwordConfirmation()\">Delete</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/community/tabs/hbf/dialogs/edit-hbf/edit-hbf-dialog.html","<md-dialog class=\"edit-hbf-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"hbfForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll>\n<md-input-container class=\"md-block input-child-name-container input-week-no-container\"><label>Week:</label><md-select \nng-model=\"vm.form.week_no\"><md-option ng-value=\"week.value\" ng-repeat=\"week in vm.weeks\">{{ week.label }}</md-option>\n</md-select><div ng-messages=\"vm.apiErrors.week_no || hbfForm.week_no.$error\" \nng-show=\"hbfForm.week_no.$touched || hbfForm.week_no.$error\" role=\"alert\"><div ng-message=\"required\"><span>Required\n</span></div><div ng-bind=\"vm.apiErrors.week_no\"></div></div></md-input-container><md-autocomplete flex required \nmd-input-name=\"guardian\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedGuardian\" \nmd-selected-item-change=\"vm.selectGuardian(guardian)\" md-search-text=\"vm.searchGuardian\" \nmd-items=\"guardian in vm.searchGuardians(vm.communityId, vm.searchGuardian)\" md-item-text=\"guardian.fullname\" \nmd-floating-label=\"Guardian\'s Name\"><md-item-template><span md-highlight-text=\"vm.searchChurchCity\">\n{{guardian.fullname}}</span></md-item-template><div class=\"errors\" \nng-messages=\"vm.apiErrors.participant_id || vm.apiErrors.guardian_name\r\n                     || hbfForm.guardian.$error\" \nng-if=\"hbfForm.guardian.$touched\"><div ng-message=\"required\">Required</div><div ng-bind=\"vm.apiErrors.participant_id\">\n</div><div ng-bind=\"vm.apiErrors.guardian_name\"></div></div></md-autocomplete><div layout=\"row\"><md-input-container \nclass=\"md-block input-child-name-container\" flex><input name=\"child_firstname\" ng-model=\"vm.form.child_firstname\" \nplaceholder=\"Child\'s First Name\" required><div \nng-messages=\"vm.apiErrors.child_firstname\r\n                || hbfForm.child_firstname.$error\" \nng-show=\"hbfForm.child_firstname.$touched\r\n                     || hbfForm.child_firstname.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.child_firstname\"></div></div>\n</md-input-container><md-input-container class=\"md-block input-child-name-container\" flex><input name=\"child_lastname\" \nng-model=\"vm.form.child_lastname\" placeholder=\"Child\'s Last Name\" required><div \nng-messages=\"vm.apiErrors.child_lastname\r\n                || hbfForm.child_lastname.$error\" \nng-show=\"hbfForm.child_lastname.$touched\r\n                     || hbfForm.child_lastname.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.child_lastname\"></div></div>\n</md-input-container></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex=\"50\" \nng-show=\"vm.form.relationship !== \'Other\'\"><label>Relationship</label><md-select name=\"relationship\" \nng-model=\"vm.form.relationship\" required><md-option ng-value=\"relationship.value\" \nng-repeat=\"relationship in vm.childRelationships\">{{relationship.label}}</md-option></md-select><div \nng-messages=\"vm.apiErrors.relationship\r\n                    || hbfForm.relationship.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.relationship\"></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex=\"40\" ng-show=\"vm.form.relationship === \'Other\'\"><input \nname=\"relationshipname\" required placeholder=\"Relationship\" ng-model=\"vm.form.relationshipOther\"><div \nng-messages=\"vm.apiErrors.relationship\r\n                    || hbfForm.relationshipname.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.relationship\"></div></div>\n</md-input-container><span ng-show=\"vm.form.relationship === \'Other\'\" flex=\"10\" class=\"mt-24\" \nng-click=\"vm.form.relationship=\'\'\"><i class=\"icon-close\"><md-tooltip md-direction=\"right\">Cancel</md-tooltip></i>\n</span><md-input-container class=\"md-block\" flex=\"50\"><input name=\"contact_no\" ng-model=\"vm.form.contact_no\" \nplaceholder=\"Contact No\"><div ng-messages=\"vm.apiErrors.contact_no\r\n                    || hbfForm.contact_no.$error\" \nng-show=\"hbfForm.contact_no.$touched\r\n                         || hbfForm.contact_no.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.contact_no\"></div></div>\n</md-input-container></div><div layout-gt-xs=\"row\"><div flex=\"65\"><md-input-container \nclass=\"md-block datepicker birthdate-datepicker\"><label>Date of Birth</label><md-datepicker \nng-model=\"vm.form.birthdate\" name=\"birthdate\" md-open-on-focus md-placeholder=\"Enter Date\" md-input-name=\"birthdate\" \nng-change=\"vm.calculateAge(vm.form)\" required></md-datepicker><div class=\"errors\" \nng-messages=\"vm.apiErrors.birthdate\r\n                             || hbfForm.birthdate.$error\"><div ng-message=\"valid\" \nclass=\"date-error\">The entered value is not a date!</div><div ng-message=\"required\" class=\"date-error\">\nThis date is required!</div><div ng-bind=\"vm.apiErrors.birthdate\"></div></div></md-input-container><md-input-container \nclass=\"md-block datepicker\"><label>Weighing Date</label><md-datepicker ng-model=\"vm.form.weight_at\" name=\"weight_at\" \nmd-open-on-focus md-input-name=\"weight_at\" required></md-datepicker><div class=\"errors\" \nng-messages=\"vm.apiErrors.weight_at\r\n                             || hbfForm.weight_at.$error\"><div ng-message=\"valid\" \nclass=\"date-error\">The entered value is not a date!</div><div ng-message=\"required\" class=\"date-error\">\nThis date is required!</div><div ng-bind=\"vm.apiErrors.weight_at\"></div></div></md-input-container></div><div \nflex=\"35\" class=\"gender-row\"><p class=\"widget-clabel\">Gender</p><md-input-container class=\"md-block\"><md-radio-group \nng-model=\"vm.form.gender\"><md-radio-button ng-repeat=\"gender in vm.genders\" ng-value=\"gender.value\" class=\"md-primary\">\n{{gender.label}}</md-radio-button></md-radio-group><div class=\"errors\" \nng-messages=\"vm.apiErrors.gender\r\n                             || hbfForm.gender.$error\"><div \nng-bind=\"vm.apiErrors.gender\"></div></div></md-input-container></div></div><div layout-gt-xs=\"row\"><div flex=\"60\"><div \nlayout-gt-xs=\"row\"><div flex><md-input-container class=\"md-block\"><input name=\"weight_kg\" type=\"number\" min=\"1\" \nng-model=\"vm.form.weight_kg\" placeholder=\"Weight (kg)\" required><div \nng-messages=\"vm.apiErrors.weight_kg\r\n                                || hbfForm.weight_kg.$error\" \nng-show=\"hbfForm.weight_kg.$touched\r\n                                     || hbfForm.weight_kg.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div><div ng-message=\"number\"><span>Invalid number</span></div><div \nng-message=\"min\"><span>Should not be zero (0)</span></div><div ng-bind=\"vm.apiErrors.weight_kg\"></div></div>\n</md-input-container></div><div flex><md-input-container class=\"md-block\"><input name=\"height_cm\" type=\"number\" \nmin=\"1\" ng-model=\"vm.form.height_cm\" placeholder=\"Height (cm)\" required><div \nng-messages=\"vm.apiErrors.height_cm\r\n                                || hbfForm.height_cm.$error\" \nng-show=\"hbfForm.height_cm.$touched\r\n                                     || hbfForm.height_cm.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div><div ng-message=\"number\"><span>Invalid number</span></div><div \nng-message=\"min\"><span>Should not be zero (0)</span></div><div ng-bind=\"vm.apiErrors.height_cm\"></div></div>\n</md-input-container></div></div><md-input-container class=\"md-block\"><input name=\"target_weight\" \nng-model=\"vm.form.target_weight | number : 1\" placeholder=\"Target Weight (kg)\" readonly=\"readonly\"><div \nng-messages=\"vm.apiErrors.target_weight\r\n                        || hbfForm.target_weight.$error\" \nng-show=\"hbfForm.target_weight.$touched\r\n                             || hbfForm.target_weight.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.target_weight\"></div></div>\n</md-input-container></div><div flex=\"40\" class=\"wasting-score-container\"><div class=\"col-md-12\"><label \nclass=\"widget-clabel\">Wasting Score</label><div class=\"clearfix\"><div class=\"pull-left mr-16 text-center\" \nng-show=\"vm.form.calculatedScore\"><p class=\"widget-hlabel calc-score {{vm.form.calculatedScore.color}}\">\n{{ vm.form.calculatedScore.score || vm.form.calculatedScore.wasting_score | number : 1}}</p><p \nclass=\"widget-vlabel calc-code {{vm.form.calculatedScore.color}}\">\n{{vm.form.calculatedScore.code === \'CURED\' ? \'NORMAL\' : vm.form.calculatedScore.code}}</p></div><md-button \nclass=\"md-accent pull-left md-raised btn-calculate\" ng-click=\"vm.calculateScore(hbfForm, vm.form)\"><span \nng-show=\"vm.form.calculatedScore\">CALCULATE</span> <span ng-show=\"!vm.form.calculatedScore\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"10px\"></md-progress-circular>Calculating...</span></md-button></div></div></div>\n</div><div layout-gt-xs=\"row\"><md-input-container flex class=\"mb-0 mt-0\" \nng-show=\"vm.form._age\r\n                                    && vm.form._age.months <= 24\"><md-checkbox value=\"1\" \nng-model=\"vm.form.breastfeeding\">Breastfeeding?</md-checkbox></md-input-container><md-input-container ng-hide=\"true\" \nflex class=\"mb-0 mt-0\"><md-checkbox value=\"1\" ng-model=\"vm.form.abcdef_test\">ABCDEF Test?</md-checkbox>\n</md-input-container><md-input-container ng-hide=\"true\" flex class=\"mb-0 mt-0\"><md-checkbox value=\"1\" \nng-model=\"vm.form.appetite_test\">Appetite Test?</md-checkbox></md-input-container></div></md-dialog-content>\n<md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">Cancel</md-button><md-button type=\"submit\" class=\"md-accent md-raised\" \nng-disabled=\"vm.saving\" ng-click=\"vm.updateHbf(hbfForm, vm.form)\"><span ng-show=\"!vm.saving\">Update</span> <span \nng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting\n</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/community/tabs/hbf/dialogs/edit-weight-log/edit-weight-log-dialog.html","<md-dialog class=\"edit-weight-log-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"editWeightLogForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nclass=\"text-center\"><p>{{vm.hbf.child_firstname}} {{vm.hbf.child_lastname}}</p><div layout-gt-xs=\"row\" \nlayout-align=\"center center\"><md-input-container \nclass=\"md-block width-350 input-child-name-container input-week-no-container\"><label>Week:</label><md-select \nng-model=\"vm.weightLog.week_no\" ng-disabled=\"vm.saving\"><md-option ng-value=\"week.value\" ng-repeat=\"week in vm.weeks\">\n{{ week.label }}</md-option></md-select><div \nng-messages=\"vm.apiErrors.week_no\r\n                    || editWeightLogForm.week_no.$error\" \nng-show=\"vm.apiErrors.week_no || editWeightLogForm.week_no.$touched\r\n                         || editWeightLogForm.week_no.$error\" \nrole=\"alert\"><div ng-bind=\"vm.apiErrors.week_no\"></div></div></md-input-container></div><div layout-gt-xs=\"column\" \nlayout-align=\"center center\"><md-input-container class=\"md-block mb-0 width-350\"><input name=\"weight_kg\" type=\"number\" \nng-model=\"vm.weightLog.weight_kg\" placeholder=\"Weight (kg)\" ng-disabled=\"vm.saving\"><div \nng-messages=\"vm.apiErrors.weight_kg\r\n                    || editWeightLogForm.weight_kg.$error\" \nng-show=\"editWeightLogForm.weight_kg.$touched\" role=\"alert\"><div ng-message=\"number\"><span>Invalid number</span></div>\n<div ng-message=\"required\"><span>Required</span></div><div ng-message=\"min\"><span>Should not be zero (0)</span></div>\n<div ng-bind=\"vm.apiErrors.weight_kg\"></div></div></md-input-container><md-input-container \nclass=\"md-block mb-0 width-350\" \nng-if=\"vm.weightLog.week_no == 2\r\n                                    || vm.weightLog.week_no == 14\r\n                                    || vm.weightLog.week_no == 15\r\n                                    || vm.weightLog.week_no == 16\r\n                                    || vm.weightLog.week_no == 29\">\n<input name=\"height_cm\" type=\"number\" min=\"1\" ng-model=\"vm.weightLog.height_cm\" placeholder=\"Height (cm)\" \nng-disabled=\"vm.saving\" required><div \nng-messages=\"vm.apiErrors.height_cm\r\n                    || editWeightLogForm.height_cm.$error\" \nng-show=\"editWeightLogForm.height_cm.$touched\r\n                         || editWeightLogForm.height_cm.$error\" \nrole=\"alert\"><div ng-message=\"number\"><span>Invalid number</span></div><div ng-message=\"min\"><span>\nShould not be zero (0)</span></div><div ng-bind=\"vm.apiErrors.height_cm\"></div></div></md-input-container></div><div \nlayout-gt-xs=\"row\" layout-align=\"center center\"><md-input-container class=\"md-block mb-0 width-350\"><input \nname=\"nutripacks\" type=\"number\" ng-model=\"vm.weightLog.nutripacks\" placeholder=\"Food Dispersed\" \nng-disabled=\"vm.saving\"><div \nng-messages=\"vm.apiErrors.nutripacks\r\n                    || addWeightLogForm.nutripacks.$error\" \nng-show=\"addWeightLogForm.nutripacks.$touched\r\n                         || addWeightLogForm.nutripacks.$error\" \nrole=\"alert\"><div ng-message=\"number\"><span>Invalid number</span></div><div ng-message=\"min\"><span>\nShould at least be zero (0)</span></div><div ng-bind=\"vm.apiErrors.nutripacks\"></div></div></md-input-container></div>\n<div layout-gt-xs=\"column\" layout-align=\"center center\"><md-input-container class=\"md-block width-350 mt-0 mb-0\" flex>\n<md-checkbox ng-model=\"vm.weightLog.dewormed\">Dewormed</md-checkbox></md-input-container><md-input-container \nclass=\"md-block mt-10 mb-10 width-350\" ng-show=\"vm.weightLog.dewormed\"><label>Please select dewormed option</label>\n<md-select ng-model=\"vm.weightLog.dewormOption\" ng-required=\"vm.weightLog.dewormed\" name=\"dewormoption\" \nng-disabled=\"vm.saving\"><md-option ng-value=\"option.value\" ng-repeat=\"option in vm.dewormOptions\">{{ option.label }}\n</md-option></md-select><div ng-messages=\"addWeightLogForm.dewormoption.$error\" \nng-show=\"addWeightLogForm.dewormoption.$touched\" role=\"alert\"><div ng-message=\"required\">Required</div></div>\n</md-input-container></div><div layout-gt-xs=\"row\" layout-align=\"center center\"><md-input-container \nclass=\"md-block width-350 mt-0 mb-0\" flex><md-checkbox class=\"no-margin\" ng-model=\"vm.medicalCareNeeded\">\nMedical Care Needed</md-checkbox></md-input-container></div><div layout-gt-xs=\"column\" layout-align=\"center center\">\n<md-input-container class=\"md-block width-350 mt-0 mb-0\" flex=\"30\"><md-checkbox ng-model=\"vm.discharge\">Discharge\n</md-checkbox></md-input-container><md-input-container class=\"md-block width-350 mt-10 mb-0\" \nng-show=\"vm.weightLog.week_no != 15 && vm.discharge\" flex=\"70\"><label>Please select discharge option</label><md-select \nng-model=\"vm.weightLog.dischargeOption\" ng-required=\"vm.discharge && vm.weightLog.week_no !=15\" name=\"dischargeoption\" \nng-disabled=\"vm.saving\"><md-option ng-value=\"option.value\" ng-repeat=\"option in vm.dischargeOptions\">{{ option.label }}\n</md-option></md-select><div ng-messages=\"editWeightLogForm.dischargeoption.$error\" \nng-show=\"editWeightLogForm.dischargeoption.$touched\" role=\"alert\"><div ng-message=\"required\">Required</div></div>\n</md-input-container><md-input-container class=\"width-350\" \nng-show=\"vm.weightLog.dischargeOption === \'refused_treatment\'\"><label>Please explain why the case refused treatment:\n</label><textarea md-no-autogrow ng-model=\"vm.weightLog.reason_for_refused_treatment\"></textarea></md-input-container>\n<md-input-container class=\"md-block width-350 mt-10 mb-0\" ng-show=\"vm.weightLog.week_no == 15 && vm.discharge \" \nflex=\"50\"><md-select ng-model=\"vm.weightLog.completed\" disabled=\"disabled\"><md-option ng-value=\"completed\" \nng-selected=\"true\">Completed Treatment</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block mt-0 mb-2 width-350\" flex \nng-show=\"vm.weightLog.week_no === 14 || vm.weightLog.week_no === 15 || vm.weightLog.week_no === 16\"><md-checkbox \nclass=\"no-margin\" ng-model=\"vm.hbf.is_extended\">Extended HBF</md-checkbox></md-input-container><md-input-container \nclass=\"md-block mt-0 mb-0 width-350\" flex><md-checkbox class=\"no-margin\" ng-model=\"vm.absent\">Absent</md-checkbox>\n</md-input-container></div><div class=\"log-notes mt-30\"><md-input-container class=\"width-350\"><label>Notes:</label>\n<textarea md-no-autogrow ng-model=\"vm.weightLog.notes\"></textarea></md-input-container></div></md-dialog-content>\n<md-dialog-actions><md-button md-no-ink class=\"md-primary pull-left\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">\nCancel</md-button><md-button type=\"submit\" class=\"md-accent md-raised pull-right\" \nng-disabled=\"editWeightLogForm.$invalid || vm.saving\" ng-click=\"vm.editWeightLog(editWeightLogForm, vm.weightLog)\">\n<md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.saving\" md-diameter=\"10px\"></md-progress-circular>Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/community/tabs/hbf/dialogs/lightbox/lightbox-dialog.html","<md-dialog class=\"lightbox-dialog transform-dialog\"><md-dialog-content class=\"text-center\"><img \nng-src=\"{{ vm.photo }}\"></md-dialog-content></md-dialog>");
$templateCache.put("app/main/community/tabs/hbf/dialogs/replace-photo/replace-photo-dialog.html","<md-dialog class=\"delete-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"photoForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nclass=\"text-center\"><md-input-container class=\"md-block\"><p>Select a Photo</p><input type=\"file\" ngf-select \nname=\"photo\" ng-model=\"vm.photo\" ng-disable=\"vm.uploading\" accept=\"image/*\" ngf-max-size=\"1MB\" required><div \nng-messages=\"photoForm.photo.$error || vm.apiErrors.photo\"><div ng-message=\"maxSize\"><span>\nImage size must be less than 1 MB</span></div><div ng-message=\"required\"><span>Required</span></div><div \nng-bind=\"vm.apiErrors.photo\"></div></div></md-input-container><md-progress-linear ng-show=\"vm.uploading\" \nmd-mode=\"indeterminate\"></md-progress-linear></md-dialog-content><md-dialog-actions><md-button md-no-ink \nclass=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"photoForm.$invalid || vm.uploading\" ng-click=\"vm.uploadPhoto(photoForm)\">\nUpload</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/community/tabs/savings/bottom-sheets/savings-group-details/savings-group-details.html","<md-bottom-sheet class=\"md-grid cover-parent\"><div class=\"savings-group-details-slider-container\"><div \nclass=\"slider-card\"><div class=\"slider-header\"><div class=\"left\" flex=\"50\"><div class=\"part\"><h4>\n{{vm.savingsGroup.group_name || \'&nbsp;\'}}</h4><h5>&nbsp;</h5></div></div><div class=\"right\" flex=\"50\"><md-button \nclass=\"md-accent md-raised\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_coordinator\', \'livelihood_trainer\', \'health_trainer\', \'branch_head\', \'health_mentor\'])\" \nng-click=\"vm.approveForPrevail()\">APPROVE FOR PREVAIL</md-button><md-button md-no-ink ng-click=\"vm.hideSliderCard()\" \nclass=\"md-primary application-details-close-button\" aria-label=\"DROP\" class=\"drop-button\"><i class=\"icon-close\"></i>\n</md-button></div></div><div class=\"slider-body full\"><div class=\"table-wrapper lightbg\"><form \nname=\"savingsGroupDetailsForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.addSavingsDetails(vm.details, vm.stats)\"><div class=\"slider-content\"><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block datepicker\" flex><h6>Transform Graduation Date</h6><md-datepicker \nng-model=\"vm.details.report_at\" name=\"applicationDate\" md-open-on-focus \nng-disabled=\"!currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_trainer\', \'health_trainer\', \'livelihood_coordinator\', \'branch_head\',\'health_mentor\'])\" \nmd-placeholder=\"Enter date\" md-input-name=\"detailsDate\" required></md-datepicker><div class=\"errors\" \nng-messages=\"savingsGroupDetailsForm.applicationDate.$error\"><div ng-message=\"valid\" class=\"date-error\">\nThe entered value is not a date!</div><div ng-message=\"required\" class=\"date-error\">This date is required!</div></div>\n</md-input-container></div><div layout-gt-xs=\"row\"><h3 flex=\"15\">Membership</h3><div flex=\"20\" class=\"ml-15\"><div>\nICM Participants</div><h2 class=\"mt-5\">{{vm.stats.total_icm_participants}}</h2></div><div flex=\"20\"><div>\nNon ICM Participants</div><h2 class=\"mt-5\">{{vm.stats.total_non_icm_participants}}</h2></div><div flex=\"10\"><div>Total\n</div><h2 class=\"mt-5\">{{vm.stats.total_participants}}</h2></div><div class=\"to-right\"><div class=\"col-sm-3\"><div>Male\n</div><h2 class=\"mt-5 blue\">{{vm.stats.total_male_participants}}</h2></div><div class=\"col-sm-3\"><div>Female</div><h2 \nclass=\"mt-5 pink\">{{vm.stats.total_female_participants}}</h2></div><div class=\"col-sm-6\"><div>Kid Savers</div><h2 \nclass=\"mt-5 orange\">{{vm.stats.total_kid_savers}}</h2></div></div></div><div layout-gt-xs=\"row\" class=\"mt-35\"><h3 \nflex=\"15\">Contributions and Social Fund</h3><div flex=\"20\" class=\"ml-15\"><md-input-container class=\"md-block\"><input \nname=\"contribution\" type=\"number\" min=\"1\" required ng-model=\"vm.details.total_contributions\" \nng-disabled=\"!currentUser.$roles.has([\'admin\', \'livelihood_trainer\', \'health_trainer\', \'metrics\', \'livelihood_coordinator\', \'branch_head\',\'health_mentor\'])\" \nplaceholder=\"Total Contributions\"><div ng-messages=\"savingsGroupDetailsForm.contribution.$error\" \nng-show=\"savingsGroupDetailsForm.contribution.$touched\r\n                                 || savingsGroupDetailsForm.$submitted\" \nrole=\"alert\"><div ng-message=\"number\"><span>Invalid number</span></div><div ng-message=\"min\"><span>Required</span>\n</div><div ng-message=\"required\"><span>Required</span></div></div></md-input-container></div><div flex=\"20\">\n<md-input-container class=\"md-block\"><input name=\"withdrawn\" min=\"0\" required ng-max=\"vm.details.total_contributions\" \nng-model=\"vm.details.total_withdrawn\" placeholder=\"Total Withdrawn\" \nng-disabled=\"!currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_trainer\', \'health_trainer\', \'livelihood_coordinator\', \'branch_head\',\'health_mentor\'])\" \ntype=\"number\"><div ng-messages=\"savingsGroupDetailsForm.withdrawn.$error\" \nng-show=\"savingsGroupDetailsForm.withdrawn.$touched\r\n                                 || savingsGroupDetailsForm.$submitted\" \nrole=\"alert\"><div ng-message=\"number\"><span>Invalid number</span></div><div ng-message=\"max\"><span>Invalid value</span>\n</div><div ng-message=\"min\"><span>Required</span></div><div ng-message=\"required\"><span>Required</span></div></div>\n</md-input-container></div><div flex=\"20\"><md-input-container class=\"md-block\"><input name=\"balance\" type=\"number\" \nmin=\"0\" ng-disabled=\"true\" ng-value=\"(vm.details.total_contributions - vm.details.total_withdrawn) | number:2\" \nng-model=\"vm.details.balance\" placeholder=\"Balance\"><div ng-messages=\"savingsGroupDetailsForm.balance.$error\" \nng-show=\"savingsGroupDetailsForm.balance.$touched\r\n                                 || savingsGroupDetailsForm.$submitted\" \nrole=\"alert\"><div ng-message=\"number\"><span>Invalid number</span></div></div></md-input-container></div></div><div \nlayout-gt-xs=\"row\"><h3 flex=\"15\">&nbsp;</h3><div flex=\"20\" class=\"ml-15\"><md-input-container class=\"md-block\"><input \nname=\"totalloans\" min=\"0\" ng-model=\"vm.details.total_loans_released\" \nng-disabled=\"!currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_trainer\', \'health_trainer\', \'livelihood_coordinator\', \'branch_head\',\'health_mentor\'])\" \nplaceholder=\"Total Loans Released\" type=\"number\"><div ng-messages=\"savingsGroupDetailsForm.totalloans.$error\" \nng-show=\"savingsGroupDetailsForm.totalloans.$touched\r\n                                 || savingsGroupDetailsForm.$submitted\" \nrole=\"alert\"><div ng-message=\"number\"><span>Invalid number</span></div></div></md-input-container></div><div flex=\"20\">\n<md-input-container class=\"md-block\"><input name=\"noloans\" min=\"0\" ng-model=\"vm.details.no_of_loans_released\" \nplaceholder=\"No. of Loans Released\" \nng-disabled=\"!currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_trainer\', \'health_trainer\', \'livelihood_coordinator\', \'branch_head\',\'health_mentor\'])\" \ntype=\"number\"><div ng-messages=\"savingsGroupDetailsForm.noloans.$error\" \nng-show=\"savingsGroupDetailsForm.noloans.$touched\r\n                                 || savingsGroupDetailsForm.$submitted\" \nrole=\"alert\"><div ng-message=\"number\"><span>Invalid number</span></div></div></md-input-container></div><div flex=\"20\">\n<md-input-container class=\"md-block\"><input name=\"repayments\" min=\"0\" ng-model=\"vm.details.total_loans_repayments\" \nplaceholder=\"Total Loan Repayments\" \nng-disabled=\"!currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_trainer\', \'health_trainer\', \'livelihood_coordinator\', \'branch_head\',\'health_mentor\'])\" \ntype=\"number\"><div ng-messages=\"savingsGroupDetailsForm.repayments.$error\" \nng-show=\"savingsGroupDetailsForm.repayments.$touched\r\n                                 || savingsGroupDetailsForm.$submitted\" \nrole=\"alert\"><div ng-message=\"number\"><span>Invalid number</span></div></div></md-input-container></div><div flex=\"20\">\n<md-input-container class=\"md-block\"><input name=\"payout\" min=\"0\" ng-model=\"vm.details.total_social_fund_payout\" \nplaceholder=\"Total Social Fund Payout\" \nng-disabled=\"!currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_trainer\', \'health_trainer\', \'livelihood_coordinator\', \'branch_head\',\'health_mentor\'])\" \ntype=\"number\"><div ng-messages=\"savingsGroupDetailsForm.payout.$error\" \nng-show=\"savingsGroupDetailsForm.payout.$touched\r\n                                 || savingsGroupDetailsForm.$submitted\" \nrole=\"alert\"><div ng-message=\"number\"><span>Invalid number</span></div></div></md-input-container></div></div><div \nlayout-gt-xs=\"row\" class=\"mt-10\"><h3 flex=\"15\">Group Business</h3><div flex=\"20\" class=\"ml-15\"><md-input-container \nclass=\"md-block\"><input name=\"capital\" min=\"0\" ng-model=\"vm.details.total_capital_for_business\" \nng-disabled=\"!currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_trainer\', \'health_trainer\', \'livelihood_coordinator\', \'branch_head\',\'health_mentor\'])\" \nplaceholder=\"Total Capital for Business\" type=\"number\"><div ng-messages=\"savingsGroupDetailsForm.capital.$error\" \nng-show=\"savingsGroupDetailsForm.capital.$touched\r\n                                 || savingsGroupDetailsForm.$submitted\" \nrole=\"alert\"><div ng-message=\"number\"><span>Invalid number</span></div></div></md-input-container></div><div flex=\"20\">\n<md-input-container class=\"md-block\"><input name=\"sales\" min=\"0\" ng-model=\"vm.details.gross_sale\" \nng-disabled=\"!currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_trainer\', \'health_trainer\', \'livelihood_coordinator\', \'branch_head\',\'health_mentor\'])\" \nplaceholder=\"Gross Sales\"><div ng-messages=\"savingsGroupDetailsForm.sales.$error\" \nng-show=\"savingsGroupDetailsForm.sales.$touched\r\n                                 || savingsGroupDetailsForm.$submitted\" \nrole=\"alert\"><div ng-message=\"number\"><span>Invalid number</span></div></div></md-input-container></div></div><div \nlayout-gt-xs=\"row\" class=\"mt-10\"><h3 flex=\"15\">&nbsp;</h3><md-button class=\"md-accent md-raised\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_trainer\', \'health_trainer\', \'livelihood_coordinator\', \'branch_head\',\'health_mentor\'])\" \nng-disabled=\"savingsGroupDetailsForm.$invalid || savingsGroupDetailsForm.$pristine || vm.saving\" type=\"submit\"><span \nng-show=\"!vm.saving\">Save</span> <span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"20px\" class=\"mt-10\"></md-progress-circular>Saving</span></md-button></div></div></form></div></div></div>\n</div></md-bottom-sheet>");
$templateCache.put("app/main/community/tabs/savings/dialogs/add-non-icm-participant/add-non-icm-participant-dialog.html","<md-dialog class=\"add-non-icm-participant-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"addNonICMForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.addParticipant(vm.participant)\" novalidate><md-toolbar class=\"md-accent md-hue-2\">\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex=\"70\"><input\n name=\"firstname\" ng-model=\"vm.participant.firstname\" maxlength=\"30\" md-autofocus placeholder=\"First Name\" required>\n<div ng-messages=\"addNonICMForm.firstname.$error\" \nng-show=\"addNonICMForm.firstname.$touched\r\n                                 || addNonICMForm.$submitted\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div></div></md-input-container><md-radio-group \nng-model=\"vm.participant.gender\" required flex=\"20\"><h5>Gender</h5><md-radio-button ng-repeat=\"gender in vm.genders\" \nclass=\"md-primary\" ng-value=\"gender.value\">{{gender.label}}</md-radio-button></md-radio-group></div><div \nlayout-align-gt-xs=\"row\"><md-input-container class=\"md-block lastname\" flex=\"70\"><input name=\"lastname\" maxlength=\"30\" \nng-model=\"vm.participant.lastname\" placeholder=\"Last Name\" required><div ng-messages=\"addNonICMForm.lastname.$error\" \nng-show=\"addNonICMForm.lastname.$touched\r\n                                 || addNonICMForm.$submitted\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div></div></md-input-container></div><div layout-align-gt-xs=\"row\">\n<md-input-container class=\"md-block mb-0\"><input name=\"phonenumber\" type=\"tel\" ng-model=\"vm.participant.phone_number\" \nmaxlength=\"20\" placeholder=\"Contact No.\"><div ng-messages=\"addNonICMForm.phonenumber.$error\" \nng-show=\"addNonICMForm.phonenumber.$touched\r\n                         || addNonICMForm.$submitted || vm.errorPhone\" \nrole=\"alert\"><div ng-bind=\"vm.errorPhone\"></div></div></md-input-container></div><div layout-gt-xs=\"row\" \nclass=\"adjust-top\"><md-input-container class=\"md-block\" flex=\"70\"><label>Role</label><md-select \nng-model=\"vm.participant.sg_role\" required name=\"role\" ng-change=\"vm.selectBase(vm.filters)\" \nng-disabled=\"currentUser.base_id\"><md-option ng-value=\"role.value\" ng-repeat=\"role in vm.roles\">{{role.label}}\n</md-option></md-select><div ng-messages=\"addNonICMForm.role.$error\" \nng-show=\"addNonICMForm.role.$touched\r\n                                 || addNonICMForm.$submitted\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div></div></md-input-container><span flex=\"30\" class=\"checkbox\">\n<md-checkbox ng-click=\"vm.kidSaver = !vm.kidSaver\">Kid Saver</md-checkbox></span></div><div \nclass=\"replace-text text-center\" ng-show=\"vm.displayReplace && vm.participant.sg_role===\'leader\'\">\n(this will replace the previous SG Leader)</div></md-dialog-content><md-dialog-actions><md-button md-no-ink \nclass=\"md-primary pull-left\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button \ntype=\"submit\" class=\"md-accent md-raised pull-right\" \nng-disabled=\"addNonICMForm.$invalid\r\n                       || addNonICMForm.$pristine || vm.saving\">\n<md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.saving\" md-diameter=\"10px\"></md-progress-circular>OK\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/community/tabs/savings/dialogs/approve-for-prevail/approve-for-prevail-dialog.html","<style>\n.cda_menu_container {\r\n        position: relative;\r\n    }\r\n\r\n    .cda_menu {\r\n        display: block;\r\n        position: absolute;\r\n        width: 100%;\r\n        padding: 14px;\r\n        overflow: hidden;\r\n        background-color: white;\r\n        box-shadow: 0 7px 8px -4px rgba(0, 0, 0, .2), 0 13px 19px 2px rgba(0, 0, 0, .14), 0 5px 24px 4px rgba(0, 0, 0, .12);\r\n    }\r\n\r\n    .cda_menu .title {\r\n        font-size: 20px;\r\n        font-weight: 800;\r\n        color: #585858;\r\n    }\r\n\r\n    .cda_menu_container .date {\r\n        margin: 0;\r\n        margin-top: -15px;\r\n        color: #232323;\r\n        font-weight: 600;\r\n        font-size: 14px;\r\n    }\r\n\r\n    .cda_menu md-dialog-actions .md-button {\r\n        margin: 0 4px !important;\r\n    }\r\n\r\n    ._md-datepicker-floating-label>md-datepicker .md-datepicker-button {\r\n        top: -2px !important;\r\n    }\n</style><md-dialog class=\"new-user-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"addSavingsGroupForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.addSavingsGroup(vm.savingsGroup)\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block\"><label>Savings Group Name</label><input name=\"name\" ng-model=\"vm.savingsGroup.name\" required \nmd-autofocus><div ng-messages=\"addSavingsGroupForm.name.$error\" ng-show=\"addSavingsGroupForm.name.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><label>Cluster</label><md-select ng-model=\"vm.savingsGroup.cluster\" \nng-model-options=\"{ trackBy: \'$value.id\' }\" required><md-option ng-value=\"cluster\" ng-repeat=\"cluster in vm.clusters\">\n{{cluster.name}}</md-option></md-select></md-input-container><md-autocomplete flex required md-input-name=\"pastor\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.savingsGroup.pastor\" md-selected-item-change=\"vm.selectPastor(pastor)\" \nmd-search-text=\"vm.searchPastor\" md-items=\"pastor in vm.searchPastors(vm.searchPastor)\" \nmd-item-text=\"pastor.firstname + \' \' + pastor.lastname\" md-require-match md-floating-label=\"Pastor\"><md-item-template>\n<table><td width=\"170px\">{{pastor.firstname}} {{pastor.lastname}}</td></table></md-item-template><div class=\"errors\" \nng-messages=\"addSavingsGroupForm.pastor.$error\" \nng-if=\"addSavingsGroupForm.pastor.$touched\r\n                         || addSavingsGroupForm.$submitted\"><div \nng-message=\"required\">Required.</div><div ng-message=\"md-require-match\">Please select an existing pastor.</div></div>\n</md-autocomplete>Select Partners:<div flex=\"100\" flex-gt-sm=\"100\" layout=\"column\"><div><fieldset class=\"standard\"><div\n layout=\"row\" layout-wrap flex class=\"cda_menu_container\"><div flex=\"50\" ng-repeat=\"partner in vm.partners\">\n<md-checkbox ng-checked=\"vm.isChecked(partner.id)\" ng-click=\"vm.selectPartner(partner)\">{{ partner.name }}\n</md-checkbox><p class=\"date\" ng-if=\"vm.isChecked(partner.id)\" ng-click=\"vm.onEditDate(partner.id)\">\n{{vm.isChecked(partner.id).start_at | date:\'MM/dd/yyyy\'}} to {{vm.isChecked(partner.id).end_at | date:\'MM/dd/yyyy\'}}\n</p></div><div class=\"cda_menu\" ng-if=\"vm.checkedPartner\"><div layout-gt-xs=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.checkedPartner.name}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeCDADialog()\" \naria-label=\"Close dialog\" translate><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\"><md-datepicker name=\"start_at\" md-open-on-focus \nng-model=\"vm.checkedPartner.start_at\" md-placeholder=\"Start Date\" md-min-date=\"vm.today\" \nmd-max-date=\"vm.checkedPartner.end_at\" required></md-datepicker></md-input-container><md-input-container \nclass=\"md-block\"><md-datepicker name=\"end_at\" md-open-on-focus ng-model=\"vm.checkedPartner.end_at\" \nmd-placeholder=\"End Date\" md-min-date=\"vm.checkedPartner.start_at\" ng-disabled=\"!vm.checkedPartner.start_at\">\n</md-datepicker></md-input-container></div><div layout-gt-xs=\"row\" layout-align=\"end center\"><md-button type=\"button\" \nclass=\"md-accent md-raised\" ng-disabled=\"!vm.checkedPartner.start_at || !vm.checkedPartner.end_at\" \nng-click=\"vm.saveCDADate(vm.checkedPartner)\"><span>Save</span></md-button></div></div></div></fieldset></div></div>\n</md-dialog-content><md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"addSavingsGroupForm.$invalid || addSavingsGroupForm.$pristine || vm.saving || !vm.checked\" type=\"submit\">\n<span ng-show=\"!vm.saving\">Save</span> <span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"20px\"></md-progress-circular>Submitting</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/community/tabs/savings/dialogs/assign-role/assign-role-dialog.html","<md-dialog class=\"assign-role-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"assignRoleForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.assignRole(vm.participant.phone_number, vm.role)\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div>Assign <span \nclass=\"bold-text\">{{vm.role.label}}</span> role to</div><div class=\"bold-text mt-15\">\n{{vm.participantObj.lastname}}, {{vm.participantObj.firstname}} ?</div><div layout-align-gt-xs=\"row\">\n<md-input-container class=\"md-block mb-0 mt-35\"><input name=\"phonenumber\" type=\"tel\" \nng-model=\"vm.participant.phone_number\" placeholder=\"Contact No.\"><div ng-messages=\"assignRoleForm.phonenumber.$error\" \nng-show=\"vm.errorPhone || assignRoleForm.phonenumber.$touched\r\n                         || assignRoleForm.$submitted\" \nrole=\"alert\"><div ng-bind=\"vm.errorPhone\"></div></div></md-input-container></div><div class=\"replace-text text-center\" \nng-show=\"vm.displayReplace\">(this will replace the previous SG Leader)</div></md-dialog-content><md-dialog-actions>\n<md-button md-no-ink class=\"md-primary pull-left\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised pull-right\" ng-disabled=\"vm.saving\"><span ng-show=\"vm.saving\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting </span><span \nng-show=\"!vm.saving\">OK</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/community/tabs/savings/dialogs/edit-contact-no/edit-contact-no-dialog.html","<md-dialog class=\"edit-contact-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"editContactForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.editContact(vm.participant)\" novalidate><md-toolbar class=\"md-accent md-hue-2\">\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout-gt-xs=\"row\"><md-input-container class=\"md-block mb-0\" flex=\"70\">\n<input name=\"phonenumber\" type=\"tel\" md-autofocus ng-model=\"vm.participant.phone_number\" maxlength=\"20\" \nplaceholder=\"Contact No.\"><div ng-messages=\"editContactForm.phonenumber.$error\" \nng-show=\"vm.errorPhone || editContactForm.phonenumber.$touched\r\n                         || editContactForm.$submitted\" \nrole=\"alert\"><div ng-message=\"maxlength\"><span>Exceed limit</span></div><div ng-message=\"required\">Required.</div><div \nng-bind=\"vm.errorPhone\"></div></div></md-input-container><span flex=\"30\" class=\"checkbox\"><md-checkbox \nng-checked=\"vm.participant.is_kid_saver\" ng-click=\"vm.participant.is_kid_saver = !vm.participant.is_kid_saver\">\nKid Saver</md-checkbox></span></div></md-dialog-content><md-dialog-actions><md-button md-no-ink \nclass=\"md-primary pull-left\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button \ntype=\"submit\" class=\"md-accent md-raised pull-right\" ng-disabled=\"editContactForm.$invalid || vm.saving\">\n<md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.saving\" md-diameter=\"10px\"></md-progress-circular>SAVE\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/community/tabs/savings/dialogs/edit-dream-save-id/edit-dream-save-id-dialog.html","<md-dialog class=\"edit-contact-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"editContactForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.editDreamSaveId(vm.participant)\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block mb-0\" flex=\"70\"><input name=\"dreamsave\" type=\"text\" \nid=\"dreamsave_id\" ng-model=\"vm.participant.dreamsave\" placeholder=\"DreamSave ID\" maxlength=\"9\" minlength=\"9\" required \nmd-autofocus style=\"font-size: 2.5rem; margin-bottom: 15px\" ng-change=\"vm.handleDreamSaveId()\" \nng-keypress=\"vm.checkNumberKey($event)\"><div ng-show=\"vm.isVerify\"><span style=\"color: green\">\nDreamSave ID is available for entry.</span></div><div ng-messages=\"editContactForm.dreamsave.$error\" \nng-show=\"vm.errorPhone || editContactForm.dreamsave.$touched\r\n                         || editContactForm.$submitted\" \nrole=\"alert\"><div ng-message=\"maxlength\"><span>Exceed limit</span></div><div ng-message=\"minlength\"><span>\nEnter 9 digit DreamSave ID</span></div><div ng-message=\"required\">Required.</div><div ng-bind=\"vm.errorDreamSaveId\" \nstyle=\"opacity: 1;\r\n                        margin-top: 3px;\r\n                        font-weight: bold;\r\n                        font-size: 13px\">\n</div></div></md-input-container><div style=\"margin: auto\" ng-if=\"vm.showClear\"><md-button md-no-ink \nclass=\"md-primary\" ng-click=\"vm.editDreamSaveId({dreamsave : \'\'})\"><md-progress-circular md-mode=\"indeterminate\" \nng-if=\"vm.clear\" md-diameter=\"10px\"></md-progress-circular>Clear</md-button></div></div></md-dialog-content>\n<md-dialog-actions><md-button md-no-ink class=\"md-primary pull-left\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">\nCancel</md-button><md-button md-no-ink class=\"md-primary pull-left\" aria-label=\"Verify\" \nng-disabled=\"editContactForm.$invalid || vm.verifying || vm.defualtVerify\" \nng-click=\"vm.VerifyDreamSaveId(vm.participant)\"><md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.verifying\" \nmd-diameter=\"10px\"></md-progress-circular>Verify</md-button><md-button type=\"submit\" \nclass=\"md-accent md-raised pull-right\" ng-disabled=\"!vm.isVerify|| vm.saving\"><md-progress-circular \nmd-mode=\"indeterminate\" ng-if=\"vm.saving\" md-diameter=\"10px\"></md-progress-circular>SAVE</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/community/tabs/savings/dialogs/join-existing-group/join-existing-group-dialog.html","<md-dialog class=\"assign-role-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"joinExistingForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.joinExistingGroup(vm.selectedSavingsGroup)\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"text-error\" ng-if=\"!vm.hasSGData\"><p><em>Cannot join to existing <strong>Savings Group</strong>\n because there\'s no <strong>Savings Group Data</strong> on this community. Please add the SG Data in the <strong>\nSavings Group Details</strong> dialog.</em></p></div><div layout-gt-xs=\"row\"><md-autocomplete flex required \nmd-input-name=\"savingsgroup\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedSavingsGroup\" \nmd-selected-item-change=\"vm.selectSavingsGroup(savingsgroup)\" md-search-text=\"vm.searchSavingsGroup\" \nmd-items=\"savingsgroup in vm.searchSavingsGroups(vm.searchSavingsGroup)\" md-item-text=\"savingsgroup.name\" \nmd-require-match md-floating-label=\"Savings Group\" md-min-length=\"0\" ng-disabled=\"!vm.hasSGData\"><md-item-template>\n<table><td class=\"width-50\">{{savingsgroup.id}}</td><td>{{savingsgroup.name}}</td></table></md-item-template><div \nclass=\"errors\" ng-messages=\"joinExistingForm.savingsgroup.$error\" \nng-show=\"joinExistingForm.savingsgroup.$touched\r\n                         || joinExistingForm.$submitted || vm.apiErrors.community_id\">\n<div ng-message=\"required\">Required.</div><div ng-bind=\"vm.apiErrors.community_id\"></div><div \nng-message=\"md-require-match\">Please select an existing savings group.</div></div></md-autocomplete></div>\n</md-dialog-content><md-dialog-actions><md-button md-no-ink class=\"md-primary pull-left\" aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">Cancel</md-button><md-button type=\"submit\" class=\"md-accent md-raised pull-right\" \nng-disabled=\"!vm.hasSGData || vm.saving\"><span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"20px\"></md-progress-circular>Submitting </span><span ng-show=\"!vm.saving\">Save</span></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/community-savings-group/tabs/members/dialogs/add-non-icm-participant/add-non-icm-participant-dialog.html","<md-dialog class=\"add-non-icm-participant-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"addNonICMForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.addParticipant(vm.participant)\" novalidate><md-toolbar class=\"md-accent md-hue-2\">\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout-gt-xs=\"row\"><md-input-container class=\"md-block mb-40\" flex>\n<label>Community</label><md-select name=\"application_id\" ng-model=\"vm.participant.application_id\" required><md-option \nng-value=\"community.application_id\" ng-repeat=\"community in vm.savings.communities\">{{community.community_no}}\n</md-option></md-select><div class=\"errors\" ng-messages=\"eventForm.community.$error || vm.apiErrors.application_id\" \nng-show=\"eventForm.application_id.$touched || vm.apiErrors.application_id\"><div ng-message=\"required\">Required</div>\n<div ng-bind=\"vm.apiErrors.application_id\"></div></div></md-input-container></div><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex=\"70\"><input name=\"firstname\" ng-model=\"vm.participant.firstname\" \nmaxlength=\"30\" placeholder=\"First Name\" required><div ng-messages=\"addNonICMForm.firstname.$error\" \nng-show=\"addNonICMForm.firstname.$touched\r\n                                 || addNonICMForm.$submitted\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div></div></md-input-container><md-radio-group \nng-model=\"vm.participant.gender\" required flex=\"20\"><h5>Gender</h5><md-radio-button ng-repeat=\"gender in vm.genders\" \nclass=\"md-primary\" ng-value=\"gender.value\">{{gender.label}}</md-radio-button></md-radio-group></div><div \nlayout-align-gt-xs=\"row\"><md-input-container class=\"md-block lastname\" flex=\"70\"><input name=\"lastname\" maxlength=\"30\" \nng-model=\"vm.participant.lastname\" placeholder=\"Last Name\" required><div ng-messages=\"addNonICMForm.lastname.$error\" \nng-show=\"addNonICMForm.lastname.$touched\r\n                                 || addNonICMForm.$submitted\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div></div></md-input-container></div><div layout-align-gt-xs=\"row\">\n<md-input-container class=\"md-block mb-0\"><input name=\"phonenumber\" type=\"tel\" ng-model=\"vm.participant.phone_number\" \nmaxlength=\"20\" placeholder=\"Contact No.\"><div ng-messages=\"addNonICMForm.phonenumber.$error\" \nng-show=\"addNonICMForm.phonenumber.$touched\r\n                         || addNonICMForm.$submitted || vm.errorPhone\" \nrole=\"alert\"><div ng-bind=\"vm.errorPhone\"></div></div></md-input-container></div><div layout-gt-xs=\"row\" \nclass=\"adjust-top\"><md-input-container class=\"md-block\" flex=\"70\"><label>Role</label><md-select \nng-model=\"vm.participant.sg_role\" required name=\"role\" ng-change=\"vm.selectBase(vm.filters)\" \nng-disabled=\"currentUser.base_id\"><md-option ng-value=\"role.value\" ng-repeat=\"role in vm.roles\">{{role.label}}\n</md-option></md-select><div ng-messages=\"addNonICMForm.role.$error\" \nng-show=\"addNonICMForm.role.$touched\r\n                                 || addNonICMForm.$submitted\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div></div></md-input-container><span flex=\"30\" class=\"checkbox\">\n<md-checkbox ng-click=\"vm.kidSaver = !vm.kidSaver\">Kid Saver</md-checkbox></span></div></md-dialog-content>\n<md-dialog-actions><md-button md-no-ink class=\"md-primary pull-left\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">\nCancel</md-button><md-button type=\"submit\" class=\"md-accent md-raised pull-right\" \nng-disabled=\"addNonICMForm.$invalid\r\n                       || addNonICMForm.$pristine || vm.saving\">\n<md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.saving\" md-diameter=\"10px\"></md-progress-circular>OK\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/community-savings-group/tabs/members/dialogs/leave-savings-group/leave-savings-group-dialog.html","<md-dialog class=\"leave-savings-group-dialog transform-dialog\" aria-label=\"Leave Savings Group\"><form \nname=\"leaveSGForm\" class=\"md-inline-form\" ng-submit=\"vm.handleSubmit()\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{ vm.dialogTitle }}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block\"><md-datepicker name=\"date\" md-open-on-focus ng-model=\"vm.form.date\" md-placeholder=\"Date left\" \nrequired></md-datepicker><div ng-messages=\"leaveSGForm.date.$error\" \nng-show=\"leaveSGForm.date.$touched || leaveSgForm.$submitted\" role=\"alert\"><div ng-message=\"required\"><span>Required\n</span></div></div></md-input-container><md-input-container class=\"md-block select-container\" flex=\"70\" required>\n<label>Reason For Leaving</label><md-select name=\"reasons\" ng-model=\"vm.form.reasons\"><md-option ng-value=\"reason\" \nng-repeat=\"reason in vm.reasons\">{{ reason }}</md-option></md-select><div ng-messages=\"leaveSGForm.reasons.$error\" \nng-show=\"leaveSGForm.reasons.$touched || leaveSgForm.$submitted\" role=\"alert\"><div ng-message=\"required\"><span>Required\n</span></div></div></md-input-container><md-input-container class=\"md-block mt-20\" flex=\"70\" \nng-if=\"vm.showOtherReason()\"><textarea name=\"reasons\" ng-model=\"vm.form.otherReason\" maxlength=\"30\" \nplaceholder=\"Reason\" required></textarea><div ng-messages=\"leaveSGForm.reasons.$error\" \nng-show=\"leaveSGForm.reasons.$touched || leaveSgForm.$submitted\" role=\"alert\"><div ng-message=\"required\"><span>Required\n</span></div></div></md-input-container></md-dialog-content><md-dialog-actions><md-button md-no-ink \nclass=\"md-primary pull-left\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button \ntype=\"submit\" class=\"md-accent md-raised pull-right\" ng-disabled=\"leaveSGForm.$invalid || vm.saving\">\n<md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.saving\" md-diameter=\"10px\"></md-progress-circular>OK\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/community-savings-group/tabs/savings-group-data/bottom-sheets/savings-group-details/savings-group-details.html","<md-bottom-sheet class=\"md-grid cover-parent\"><div class=\"savings-group-details-slider-container\"><div \nclass=\"slider-card\"><div class=\"slider-header\"><div class=\"left\" flex=\"50\"><div class=\"part\"><h4>\n{{vm.savingsGroup.name}}</h4><h5>Savings Group Name</h5></div></div><div class=\"right\" flex=\"50\"><md-button md-no-ink \nng-click=\"vm.hideSliderCard()\" class=\"md-primary application-details-close-button\" aria-label=\"DROP\"><i \nclass=\"icon-close\"></i></md-button></div></div><div class=\"slider-body full\"><div class=\"table-wrapper lightbg\"><form \nname=\"savingsGroupDetailsForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.addSGData(vm.details)\"><div \nclass=\"slider-content\"><div layout-gt-xs=\"row\" layout-align=\"start center\"><md-input-container \nclass=\"md-block datepicker\" flex><h6>Date*</h6><md-datepicker ng-model=\"vm.details.report_at\" name=\"applicationDate\" \nmd-open-on-focus md-placeholder=\"Enter date\" md-input-name=\"detailsDate\" \nng-change=\"vm.onDateChange(vm.details.report_at)\" required></md-datepicker><div class=\"errors\" \nng-messages=\"savingsGroupDetailsForm.applicationDate.$error || vm.report_at_error\"><div ng-message=\"valid\" \nclass=\"date-error\">The entered value is not a date!</div><div ng-message=\"required\" class=\"date-error\">\nThis date is required!</div><div ng-bind=\"vm.report_at_error\"></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Attendance/Engagement</label><md-select name=\"type\" \nng-model=\"vm.details.type_of_attendance\" required><md-option ng-value=\"type\" ng-repeat=\"type in vm.attendanceTypes\">\n{{ type }}</md-option></md-select><div class=\"errors\" ng-messages=\"savingsGroupDetailsForm.type.$error\"><div \nng-message=\"required\" class=\"date-error\">Required</div></div></md-input-container><md-input-container \nclass=\"md-block ml-64\" flex ng-style=\"!vm.visible_updated_form && {\'visibility\':\'hidden\'}\"><md-checkbox name=\"updated\" \nng-model=\"vm.details.updated_form\">SG Updated Form</md-checkbox></md-input-container></div><div layout-gt-xs=\"row\"><h3 \nflex=\"15\">Contributions and Social Fund</h3><div flex=\"20\" class=\"ml-15\"><md-input-container class=\"md-block\"><input \nname=\"contribution\" ng-min=\"vm.minContributions\" ng-max=\"vm.maxContributions\" ng-required=\"vm.details.total_withdrawn\" \nng-model=\"vm.details.total_contributions\" placeholder=\"Total Contributions\" ng-disabled=\"!vm.details.updated_form \" \ntype=\"number\"><div ng-messages=\"savingsGroupDetailsForm.contribution.$error\" \nng-show=\"savingsGroupDetailsForm.contribution.$touched\r\n                                            || savingsGroupDetailsForm.$submitted\" \nrole=\"alert\"><div ng-message=\"min\"><span>Should be greater than or equal to {{ vm.minContributions }}</span></div><div \nng-message=\"max\"><span>Should be less than or equal to {{ vm.maxContributions }}</span></div><div ng-message=\"number\">\n<span>Invalid number</span></div></div></md-input-container></div><div flex=\"20\" class=\"ml-15\"><md-input-container \nclass=\"md-block\"><input name=\"withdrawn\" min=\"0\" \nng-disabled=\"!currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_coordinator\', \'branch_head\']) || !vm.details.updated_form \" \nng-max=\"vm.getMaxWithdrawal()\" ng-min=\"vm.minWithdrawal\" ng-required=\"vm.details.total_contributions\" \nng-model=\"vm.details.total_withdrawn\" placeholder=\"Total Withdrawn\" \ntype=\"\r\n                                            number\"><div \nng-messages=\"savingsGroupDetailsForm.withdrawn.$error\" \nng-show=\"savingsGroupDetailsForm.withdrawn.$touched\r\n                                 || savingsGroupDetailsForm.$submitted\" \nrole=\"alert\"><div ng-message=\"number\"><span>Invalid number</span></div><div ng-message=\"min\"><span>\nShould be greater than or equal to {{ vm.minWithdrawal }}</span></div><div ng-message=\"max\"><span>\nShould be less than or equal to {{ vm.getMaxWithdrawal() }}</span></div></div></md-input-container></div><div \nflex=\"20\"><md-input-container class=\"md-block\"><input name=\"balance\" ng-model=\"vm.details.balance\" type=\"number\" \nng-disabled=\"true\" ng-value=\"(vm.details.total_contributions - vm.details.total_withdrawn) | number:2\" \nplaceholder=\"Balance\"></md-input-container></div></div><div layout-gt-xs=\"row\"><h3 flex=\"15\">&nbsp;</h3><div flex=\"20\" \nclass=\"ml-15\"><md-input-container class=\"md-block\"><input name=\"totalloans\" min=\"0\" \nng-disabled=\"!currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_coordinator\', \'branch_head\']) || !vm.details.updated_form \" \nng-model=\"vm.details.total_loans_released\" placeholder=\"Total Loans Released\" type=\"number\"><div \nng-messages=\"savingsGroupDetailsForm.totalloans.$error\" \nng-show=\"savingsGroupDetailsForm.totalloans.$touched\r\n                                            || savingsGroupDetailsForm.$submitted\" \nrole=\"alert\"><div ng-message=\"number\"><span>Invalid number</span></div></div></md-input-container></div><div flex=\"20\">\n<md-input-container class=\"md-block\"><input name=\"noloans\" min=\"0\" \nng-disabled=\"!currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_coordinator\', \'branch_head\']) || !vm.details.updated_form\" \nng-model=\"vm.details.no_of_loans_released\" placeholder=\"No. of Loans Released\" type=\"number\"><div \nng-messages=\"savingsGroupDetailsForm.noloans.$error\" \nng-show=\"savingsGroupDetailsForm.noloans.$touched\r\n                                            || savingsGroupDetailsForm.$submitted\" \nrole=\"alert\"><div ng-message=\"number\"><span>Invalid number</span></div></div></md-input-container></div><div flex=\"20\">\n<md-input-container class=\"md-block\"><input name=\"repayments\" min=\"0\" \nng-disabled=\"!currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_coordinator\', \'branch_head\']) || !vm.details.updated_form\" \nng-model=\"vm.details.total_loans_repayments\" placeholder=\"Total Loan Repayments\" type=\"number\"><div \nng-messages=\"savingsGroupDetailsForm.repayments.$error\" \nng-show=\"savingsGroupDetailsForm.repayments.$touched\r\n                                            || savingsGroupDetailsForm.$submitted\" \nrole=\"alert\"><div ng-message=\"number\"><span>Invalid number</span></div></div></md-input-container></div><div flex=\"20\">\n<md-input-container class=\"md-block\"><input name=\"payout\" min=\"0\" \nng-disabled=\"!currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_coordinator\', \'branch_head\']) || !vm.details.updated_form\" \nng-model=\"vm.details.total_social_fund_payout\" placeholder=\"Total Social Fund Payout\" type=\"number\"><div \nng-messages=\"savingsGroupDetailsForm.payout.$error\" \nng-show=\"savingsGroupDetailsForm.payout.$touched\r\n                                            || savingsGroupDetailsForm.$submitted\" \nrole=\"alert\"><div ng-message=\"number\"><span>Invalid number</span></div></div></md-input-container></div></div><div \nlayout-gt-xs=\"row\" class=\"mt-10\"><h3 flex=\"15\">Group Business</h3><div flex=\"20\" class=\"ml-15\"><md-input-container \nclass=\"md-block\"><input name=\"capital\" min=\"0\" \nng-disabled=\"!currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_coordinator\', \'branch_head\']) || !vm.details.updated_form\" \nng-model=\"vm.details.total_capital_for_business\" placeholder=\"Total Capital for Business\" type=\"number\"><div \nng-messages=\"savingsGroupDetailsForm.capital.$error\" \nng-show=\"savingsGroupDetailsForm.capital.$touched\r\n                                            || savingsGroupDetailsForm.$submitted\" \nrole=\"alert\"><div ng-message=\"number\"><span>Invalid number</span></div></div></md-input-container></div><div flex=\"20\">\n<md-input-container class=\"md-block\"><input name=\"sales\" min=\"0\" \nng-disabled=\"!currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_coordinator\', \'branch_head\']) || !vm.details.updated_form\" \nng-model=\"vm.details.gross_sale\" placeholder=\"Gross Sales\" type=\"number\"><div \nng-messages=\"savingsGroupDetailsForm.sales.$error\" \nng-show=\"savingsGroupDetailsForm.sales.$touched\r\n                                            || savingsGroupDetailsForm.$submitted\" \nrole=\"alert\"><div ng-message=\"number\"><span>Invalid number</span></div></div></md-input-container></div></div><div \nlayout-gt-xs=\"row\" class=\"mt-10\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'livelihood_coordinator\', \'branch_head\']) \"><h3 flex=\"15\">&nbsp;\n</h3><md-button class=\"md-accent md-raised\" ng-disabled=\" vm.saving || !vm.details.updated_form\" type=\"submit\"><span \nng-show=\"!vm.saving\">Save</span> <span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"20px\" class=\"mt-10\"></md-progress-circular>Saving</span></md-button></div></div></form></div></div></div>\n</div></md-bottom-sheet>");
$templateCache.put("app/main/flourish/tabs/chc/dialogs/new-chc/new-chc-dialog.html","<md-dialog class=\"new-user-dialog pastor-dialog transform-dialog\"><form name=\"pastorForm\" class=\"md-inline-form\" \nng-submit=\"vm.addNewPastor(vm.pastor, pastorForm)\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><h2>Personal Information</h2><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block select-container mb-0\" flex=\"50\"><label>Batch</label><md-select ng-model=\"vm.filters.batch\" \nng-model-options=\"{ trackBy: \'$value.id\' }\" placeholder=\"Batch\" ng-disabled=\"vm.isLoading3\" \nng-change=\"vm.selectBatch(vm.filters)\"><md-option value=\"all\">All Batches</md-option><md-option ng-value=\"batch\" \nng-repeat=\"batch in vm.batches\">{{ batch.short_name }}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block select-container mb-0\" flex=\"50\"><label>Community Name</label><md-select ng-model=\"vm.filters.batch\" \nng-model-options=\"{ trackBy: \'$value.id\' }\" placeholder=\"Batch\" ng-disabled=\"vm.isLoading3\" \nng-change=\"vm.selectBatch(vm.filters)\"><md-option value=\"all\">All Community</md-option><md-option ng-value=\"batch\" \nng-repeat=\"batch in vm.batches\">{{ batch.month }}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block select-container mb-0\" flex=\"40\"><label>Select CHC</label><md-select ng-model=\"vm.filters.cluster\" \nng-model-options=\"{ trackBy: \'$value.id\' }\" ng-change=\"vm.selectCluster(vm.filters)\"><md-option value=\"all\">All CHC\n</md-option></md-select></md-input-container></div><md-input-container class=\"md-block select-container mt-24\" \nflex=\"40\"><label>Cluster</label><md-select ng-model=\"vm.filters.cluster\" ng-model-options=\"{ trackBy: \'$value.id\' }\" \nng-change=\"vm.selectCluster(vm.filters)\"><md-option value=\"all\">All Clusters</md-option><md-option ng-value=\"cluster\" \nng-repeat=\"cluster in vm.clusters\">{{cluster.name}}</md-option></md-select></md-input-container><h2>Address</h2><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block mb-10\" flex><label>Base</label><md-select name=\"base\" \nng-disabled=\"!vm.bases.length || vm.currentUser.base_id\" ng-model=\"vm.pastor.base\" placeholder=\"Base\" required>\n<md-option ng-value=\"base\" ng-repeat=\"base in vm.bases\">{{ base.name }}</md-option></md-select><div \nng-messages=\"pastorForm.base.$error\" \nng-show=\"pastorForm.base.$touched\r\n                         || vm.apiErrors.base_id\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.base_id\"></div></div></md-input-container>\n<md-input-container class=\"md-block mb-10\" flex><label>District</label><md-select name=\"district\" \nng-disabled=\"!vm.pastor.base.districts.length\" ng-model=\"vm.pastor.district\" placeholder=\"District\" required><md-option\n ng-value=\"district\" ng-repeat=\"district in vm.pastor.base.districts\">{{ district.name }}</md-option></md-select><div \nng-messages=\"pastorForm.district.$error\" \nng-show=\"pastorForm.district.$touched\r\n                         || vm.apiErrors.district_id\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.district_id\"></div></div>\n</md-input-container></div><div layout-gt-xs=\"row\"><md-autocomplete flex required md-input-name=\"province\" \nmd-selected-item=\"vm.pastor.province\" md-selected-item-change=\"vm.selectProvince(province)\" \nmd-search-text=\"vm.searchProvince\" md-items=\"province in vm.searchProvinces(vm.searchProvince)\" \nmd-item-text=\"province.name\" md-no-cache=\"1\" md-require-match md-floating-label=\"Province\"><md-item-template><span \nmd-highlight-text=\"vm.searchProvince\">{{province.name}}</span></md-item-template><div class=\"errors\" \nng-messages=\"pastorForm.province.$error\r\n                         || vm.apiErrors.province_id\" \nng-if=\"pastorForm.province.$touched\r\n                         || pastorForm.$submitted\"><div ng-message=\"required\">\nRequired</div><div ng-message=\"md-require-match\">Please select a province.</div><div \nng-bind=\"vm.apiErrors.province_id\"></div></div></md-autocomplete><md-autocomplete flex required md-input-name=\"city\" \nmd-selected-item=\"vm.pastor.city\" md-selected-item-change=\"vm.selectCity(city)\" md-search-text=\"vm.searchCity\" \nmd-items=\"city in vm.searchCities(vm.searchCity)\" md-item-text=\"city.name\" md-no-cache=\"1\" md-require-match \nmd-floating-label=\"City\" ng-disabled=\"!vm.pastor.province_id\"><md-item-template><span \nmd-highlight-text=\"vm.searchCity\">{{city.name}}</span></md-item-template><div class=\"errors\" \nng-messages=\"pastorForm.city.$error\" \nng-if=\"pastorForm.city.$touched\r\n                         || pastorForm.$submitted\"><div ng-message=\"required\">Required\n</div><div ng-message=\"md-require-match\">Please select a city.</div></div></md-autocomplete><md-autocomplete flex \nrequired md-input-name=\"barangay\" md-selected-item=\"vm.pastor.barangay\" \nmd-selected-item-change=\"vm.selectBarangay(barangay)\" md-search-text=\"vm.searchBarangay\" \nmd-items=\"barangay in vm.searchBarangays(vm.searchBarangay)\" md-item-text=\"barangay.name\" md-no-cache=\"1\" \nmd-require-match md-floating-label=\"Barangay\" ng-disabled=\"!vm.pastor.city_id\"><md-item-template><span \nmd-highlight-text=\"vm.searchBarangay\">{{barangay.name}}</span></md-item-template><div class=\"errors\" \nng-messages=\"pastorForm.barangay.$error\" \nng-if=\"pastorForm.barangay.$touched\r\n                         || pastorForm.$submitted\"><div ng-message=\"required\">\nRequired</div><div ng-message=\"md-require-match\">Please select a barangay.</div></div></md-autocomplete></div>\n<md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"address\" ng-model=\"vm.pastor.address\" \nplaceholder=\"Other/More Address\" type=\"text\" maxlength=\"120\" class=\"pastor\"><div \nng-messages=\"pastorForm.address.$error\" \nng-show=\"pastorForm.address.$touched\r\n                     || vm.apiErrors.address\" role=\"alert\"><div \nng-bind=\"vm.apiErrors.address\"></div></div></md-input-container><h2>Education</h2><div layout-gt-xs=\"row\">\n<md-input-container class=\"\" flex=\"30\"><label class=\"ml-1\">Educational Attainment</label><md-select \nname=\"educational_attainment\" ng-disabled=\"!vm.educational_attainment.length\" \nng-model=\"vm.pastor.educational_attainment\" placeholder=\"Educational Attainment\" required><md-option \nng-value=\"status.value\" ng-repeat=\"status in vm.educational_attainment\">{{ status.label }}</md-option></md-select><div \nng-messages=\"pastorForm.educational_attainment.$error\" \nng-show=\"pastorForm.educational_attainment.$touched\r\n                         || vm.apiErrors.educational_attainment\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.educational_attainment\">\n</div></div></md-input-container></div><h2>Date</h2><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" \nflex-gt-xs><label>Date of Training</label><md-datepicker ng-model=\"vm.pastor.birth_date\" name=\"birth_date\" \nmd-open-on-focus md-placeholder=\"Trained\" md-input-name=\"birth_date\" required></md-datepicker><div \nng-messages=\"pastorForm.birth_date.$error\" \nng-show=\"pastorForm.birth_date.$touched\r\n                         || vm.apiErrors.birth_date\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.birth_date\"></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-xs><label>Date of Selection</label><md-datepicker \nng-model=\"vm.pastor.birth_date\" name=\"birth_date\" md-open-on-focus md-placeholder=\"Selected\" \nmd-input-name=\"birth_date\" required></md-datepicker><div ng-messages=\"pastorForm.birth_date.$error\" \nng-show=\"pastorForm.birth_date.$touched\r\n                         || vm.apiErrors.birth_date\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.birth_date\"></div></div>\n</md-input-container></div><h2>Kit Received</h2><div layout-gt-xs=\"row\"><p>This is One from above...</p></div>\n</md-dialog-content><md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"pastorForm.$invalid || vm.saving\" type=\"submit\"><span ng-show=\"!vm.saving\">Create Chc</span> <span \nng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting\n</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/prevail/tabs/savings-groups/dialogs/add-new-sg/add-new-sg-dialog.html","<style>\n.cda_menu_container {\r\n        position: relative;\r\n    }\r\n\r\n    .cda_menu {\r\n        display: block;\r\n        position: absolute;\r\n        width: 100%;\r\n        padding: 14px;\r\n        overflow: hidden;\r\n        background-color: white;\r\n        box-shadow: 0 7px 8px -4px rgba(0, 0, 0, .2), 0 13px 19px 2px rgba(0, 0, 0, .14), 0 5px 24px 4px rgba(0, 0, 0, .12);\r\n    }\r\n\r\n    .cda_menu .title {\r\n        font-size: 20px;\r\n        font-weight: 800;\r\n        color: #585858;\r\n    }\r\n\r\n    .cda_menu_container .date {\r\n        margin: 0;\r\n        margin-top: -15px;\r\n        color: #232323;\r\n        font-weight: 600;\r\n        font-size: 14px;\r\n    }\r\n\r\n    .cda_menu md-dialog-actions .md-button {\r\n        margin: 0 4px !important;\r\n    }\r\n\r\n    ._md-datepicker-floating-label>md-datepicker .md-datepicker-button {\r\n        top: -2px !important;\r\n    }\n</style><md-dialog class=\"new-user-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"addSavingsGroupForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.addSavingsGroup(vm.savingsGroup)\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block mb-0\"><label>Savings Group Name</label><input name=\"name\" ng-model=\"vm.savingsGroup.name\" required \nmd-autofocus maxlength=\"50\"><div ng-messages=\"addSavingsGroupForm.name.$error\" \nng-show=\"addSavingsGroupForm.name.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Required</span></div></div>\n</md-input-container><md-input-container style=\"width: 100%\"><label>Country</label><md-select \nng-model=\"vm.savingsGroup.country_code\" ng-change=\"vm.handleCountryChange(vm.savingsGroup.country_code)\" required>\n<md-option ng-value=\"country.id\" ng-repeat=\"country in vm.countrys\">{{country.name}}</md-option></md-select><div \nclass=\"errors\" ng-messages=\"addSavingsGroupForm.country_code.$error || vm.apiErrors.country_code\" \nng-show=\"addSavingsGroupForm.country_code.$touched || vm.apiErrors.country_code\"><div ng-message=\"required\">Required\n</div><div ng-bind=\"vm.apiErrors.country_code\"></div></div></md-input-container><md-input-container \nclass=\"md-block mb-40\" flex><label>Base</label><md-select ng-model=\"vm.savingsGroup.base\" name=\"base\" required \nng-disabled=\"vm.currentUser.base_id || !vm.savingsGroup.country_code\" ng-model-options=\"{ trackBy: \'$value.id\' }\" \nng-change=\"vm.selectBase()\"><md-option ng-value=\"base\" ng-repeat=\"base in vm.bases\">{{base.name}}</md-option>\n</md-select><div ng-messages=\"addSavingsGroupForm.base.$error\" ng-show=\"addSavingsGroupForm.base.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div></div></md-input-container><md-autocomplete flex \nrequired ng-disabled=\"vm.isEdit && !currentUser.$roles.has([\'admin\'])\" md-input-name=\"stream\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.savingsGroup.stream\" md-selected-item-change=\"vm.selectStream(stream)\" \nmd-search-text=\"vm.searchStream\" md-items=\"stream in vm.searchStreams(vm.searchStream)\" \nmd-item-text=\"\'Batch \' + stream.batch_no + \' of \' + stream.fiscal_year + \' - \' + stream.stream_name\" md-require-match \nmd-floating-label=\"Stream\"><md-item-template><table><td width=\"170px\">\nBatch {{stream.batch_no}} of {{stream.fiscal_year}} - {{stream.stream_name}}</td></table></md-item-template><div \nclass=\"errors\" ng-messages=\"addSavingsGroupForm.stream.$error\" \nng-if=\"addSavingsGroupForm.stream.$touched\r\n                         || addSavingsGroupForm.$submitted\"><div \nng-message=\"required\">Required.</div><div ng-message=\"md-require-match\">Please select an existing stream.</div></div>\n</md-autocomplete><md-input-container class=\"md-block mt-35 mb-40\" flex><label>Cluster</label><md-select \nng-model=\"vm.savingsGroup.cluster\" name=\"cluster\" required \nng-disabled=\"!vm.savingsGroup.base.clusters.length || vm.currentUser.cluster_id\" \nng-model-options=\"{ trackBy: \'$value.id\' }\" ng-change=\"vm.changeCluster(vm.savingsGroup.cluster.id)\"><md-option \nng-value=\"cluster\" ng-repeat=\"cluster in vm.savingsGroup.base.clusters | orderBy: \'name\'\">{{cluster.name}}</md-option>\n</md-select><div ng-messages=\"addSavingsGroupForm.cluster.$error\" ng-show=\"addSavingsGroupForm.cluster.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div></div></md-input-container><md-input-container \nclass=\"md-block mt-35 mb-40\" flex><label>Small Group</label><md-select ng-model=\"vm.savingsGroup.small_group\" \nname=\"small_group\" ng-disabled=\"!vm.savingsGroup.cluster\" ng-model-options=\"{ trackBy: \'$value.id\' }\"><md-option \nng-value=\"\" ng-disabled=\"true\" ng-if=\"vm.small_groups.length===0\">No Small Group Founded</md-option><md-option \nng-value=\"small_group\" ng-repeat=\"small_group in vm.small_groups | orderBy: \'name\'\">{{small_group.name}}</md-option>\n</md-select><div ng-messages=\"addSavingsGroupForm.small_group.$error\" \nng-show=\"addSavingsGroupForm.small_group.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Required</span></div>\n</div></md-input-container><md-autocomplete flex required md-input-name=\"pastor\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.savingsGroup.pastor\" md-selected-item-change=\"vm.selectPastor(pastor)\" \nmd-search-text=\"vm.searchPastor\" md-items=\"pastor in vm.searchPastors(vm.searchPastor)\" \nmd-item-text=\"pastor.firstname + \' \' + pastor.lastname\" md-require-match md-floating-label=\"Pastor\"><md-item-template>\n<table><td width=\"170px\">{{pastor.firstname}} {{pastor.lastname}}</td></table></md-item-template><div class=\"errors\" \nng-messages=\"addSavingsGroupForm.pastor.$error\" \nng-if=\"addSavingsGroupForm.pastor.$touched\r\n                         || addSavingsGroupForm.$submitted\"><div \nng-message=\"required\">Required.</div><div ng-message=\"md-require-match\">Please select an existing pastor.</div></div>\n</md-autocomplete>Select Partners:<div flex=\"100\" flex-gt-sm=\"100\" layout=\"column\"><div><fieldset class=\"standard\"><div\n layout=\"row\" layout-wrap flex class=\"cda_menu_container\"><div flex=\"50\" ng-repeat=\"partner in vm.partners\">\n<md-checkbox ng-checked=\"vm.isChecked(partner.id)\" ng-click=\"vm.selectPartner(partner)\">{{ partner.name }}\n</md-checkbox><p class=\"date\" ng-if=\"vm.isChecked(partner.id)\" ng-click=\"vm.onEditDate(partner.id)\">\n{{vm.isChecked(partner.id).start_at | date:\'MM/dd/yyyy\'}} to {{vm.isChecked(partner.id).end_at | date:\'MM/dd/yyyy\'}}\n</p></div><div class=\"cda_menu\" ng-if=\"vm.checkedPartner\"><div layout-gt-xs=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.checkedPartner.name}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeCDADialog()\" \naria-label=\"Close dialog\" translate><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\"><md-datepicker name=\"start_at\" md-open-on-focus \nng-model=\"vm.checkedPartner.start_at\" md-placeholder=\"Start Date\" md-min-date=\"vm.today\" \nmd-max-date=\"vm.checkedPartner.end_at\" required></md-datepicker></md-input-container><md-input-container \nclass=\"md-block\"><md-datepicker name=\"end_at\" md-open-on-focus ng-model=\"vm.checkedPartner.end_at\" \nmd-placeholder=\"End Date\" md-min-date=\"vm.checkedPartner.start_at\" ng-disabled=\"!vm.checkedPartner.start_at\">\n</md-datepicker></md-input-container></div><div layout-gt-xs=\"row\" layout-align=\"end center\"><md-button type=\"button\" \nclass=\"md-accent md-raised\" ng-disabled=\"!vm.checkedPartner.start_at || !vm.checkedPartner.end_at\" \nng-click=\"vm.saveCDADate(vm.checkedPartner)\"><span>Save</span></md-button></div></div></div></fieldset></div></div>\n</md-dialog-content><md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"addSavingsGroupForm.$invalid || addSavingsGroupForm.$pristine || vm.saving || !vm.checked\" type=\"submit\">\n<span>Save</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/prevail/tabs/savings-groups/dialogs/reason-for-dropping/reason-for-dropping-dialog.html","<md-dialog class=\"drop-savings-group-dialog transform-dialog\" aria-label=\"Drop Savings Group\"><form name=\"dropSGForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.passwordConfirmation()\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{ vm.dialogTitle }}\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block select-container\"><label>\nReason For Leaving</label><md-select name=\"reason\" ng-model=\"vm.form.reason\"><md-option ng-value=\"reason\" \nng-repeat=\"reason in vm.reasons\">{{ reason }}</md-option></md-select><div ng-messages=\"dropSGForm.reason.$error\" \nng-show=\"dropSGForm.reason.$touched || leaveSgForm.$submitted\" role=\"alert\"><div ng-message=\"required\"><span>Required\n</span></div></div></md-input-container><md-input-container class=\"md-block mt-50\" ng-if=\"vm.form.reason === \'Other\'\">\n<label>Please specify a reason:</label><textarea name=\"otherReason\" ng-model=\"vm.form.otherReason\" maxlength=\"30\" \nplaceholder=\"Reasons for leaving\"></textarea><div ng-messages=\"dropSGForm.reasons.$error\" \nng-show=\"dropSGForm.otherReason.$touched || leaveSgForm.$submitted\" role=\"alert\"><div ng-message=\"required\"><span>\nRequired</span></div></div></md-input-container></md-dialog-content><md-dialog-actions><md-button md-no-ink \nclass=\"md-primary pull-left\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button \ntype=\"submit\" class=\"md-accent md-raised pull-right\" ng-disabled=\"dropSGForm.$invalid || vm.saving\">\n<md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.saving\" md-diameter=\"10px\"></md-progress-circular>OK\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/thrive/tabs/churches/bottom-sheets/church-details/church-details.html","<md-bottom-sheet class=\"md-list cover-parent\"><div class=\"deleted-application-slider-container\"><div \nclass=\"church-details-slider-card\"><form name=\"churchDetailsForm\" class=\"md-inline-form\" novalidate><div \nclass=\"slider-header\"><div class=\"left\" flex=\"70\"><div class=\"part\"><h4>{{vm.church.name || \'&nbsp;\'}}</h4><h5>\nChurch Name</h5></div></div><md-button ng-click=\"vm.closeBottomSheet()\" md-no-ink \nclass=\"md-primary deleted-application-close-button\" aria-label=\"DROP\"><i class=\"icon-close\"></i></md-button><div \nclass=\"right\" flex=\"30\"><md-button class=\"md-accent md-raised\" \nng-show=\"(currentUser.$roles.has([\'admin\']) || vm.userCountry !== \'PH\') && !vm.clickedEdit\" ng-click=\"vm.setFocus()\">\nEDIT CHURCH</md-button><md-button class=\"md-accent md-raised\" \nng-show=\"(currentUser.$roles.has([\'admin\']) || vm.userCountry !== \'PH\') && vm.clickedEdit\" \nng-disabled=\"vm.saving && vm.clickedEdit\" ng-click=\"vm.editChurch(vm.church, churchDetailsForm)\"><span \nng-show=\"!vm.saving\">SAVE</span> <span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"20px\"></md-progress-circular>Submitting</span></md-button></div></div><div class=\"slider-body\" \nng-style=\"{\'height\': vm.sliderHeight + \'px\' }\"><div class=\"details-container\" layout=\"row\" \nlayout-align=\"space-between start\"><div class=\"main-md-content\"><h2>Church Information</h2><div layout-gt-xs=\"row\" \nclass=\"mt-10\"><div class=\"md-block\" flex-gt-xs ng-show=\"!vm.clickedEdit\"><label class=\"label-info-personal\">Church Name\n</label><div class=\"value-info-personal\">{{vm.church.name}}</div></div><div class=\"md-block\" flex-gt-xs \nng-show=\"!vm.clickedEdit\"><label class=\"label-info-personal\">Church Affiliation</label><div \nclass=\"value-info-personal\">{{vm.church.affiliation.name}}</div></div><md-input-container class=\"md-block mb-0\" \nflex-gt-xs ng-show=\"vm.clickedEdit\"><input name=\"name\" ng-model=\"vm.church.name\" placeholder=\"Church Name\" type=\"text\" \nclass=\"church\" id=\"church-name-details\" maxlength=\"50\" md-autofocus required><div \nng-messages=\"churchDetailsForm.name.$error\" \nng-show=\"churchDetailsForm.name.$touched\r\n                                         || vm.apiErrors.name\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div><div ng-message=\"maxlength\"><span>Exceeds limit</span></div><div \nng-bind=\"vm.apiErrors.name\"></div></div></md-input-container><md-autocomplete flex required ng-show=\"vm.clickedEdit\" \nmd-input-name=\"denomination\" md-selected-item=\"vm.selectedDenomination\" \nmd-selected-item-change=\"vm.selectDenomination(denomination)\" md-search-text=\"vm.searchDenomination\" \nmd-items=\"denomination in vm.searchDenominations(vm.searchDenomination)\" md-item-text=\"denomination.name\" \nmd-no-cache=\"1\" md-require-match md-floating-label=\"Church Affiliation\" style=\"height: 60px\"><md-item-template><span \nmd-highlight-text=\"vm.searchDenomination\">{{denomination.name}}</span></md-item-template><div class=\"errors\" \nng-messages=\"churchDetailsForm.denomination.$error\" \nng-if=\"churchDetailsForm.denomination.$touched\r\n                                         || churchDetailsForm.$submitted\">\n<div ng-message=\"required\">Required</div><div ng-message=\"md-require-match\">Please select a church affiliation.</div>\n</div></md-autocomplete></div><div layout-gt-xs=\"row\" class=\"mt-10\" ng-show=\"!vm.clickedEdit\"><div class=\"md-block\" \nflex-gt-xs ng-show=\"!vm.clickedEdit\"><label class=\"label-info-personal\">Province</label><div \nclass=\"value-info-personal\">{{vm.church.province.name}}</div></div><div class=\"md-block\" flex-gt-xs \nng-show=\"!vm.clickedEdit\"><label class=\"label-info-personal\">City</label><div class=\"value-info-personal\">\n{{vm.church.city.name}}</div></div><div class=\"md-block\" flex-gt-xs ng-show=\"!vm.clickedEdit\"><label \nclass=\"label-info-personal\">Barangay</label><div class=\"value-info-personal\">{{vm.church.barangay.name}}</div></div>\n</div><div layout-gt-xs=\"row\" class=\"mt-10\" ng-show=\"vm.clickedEdit\"><md-autocomplete flex required \nmd-input-name=\"province\" md-selected-item=\"vm.selectedProvince\" md-selected-item-change=\"vm.selectProvince(province)\" \nmd-search-text=\"vm.searchProvince\" md-items=\"province in vm.searchProvinces(vm.searchProvince)\" \nmd-item-text=\"province.name\" md-no-cache=\"1\" md-min-length=\"0\" md-require-match md-floating-label=\"Province\">\n<md-item-template><span md-highlight-text=\"vm.searchProvince\">{{province.name}}</span></md-item-template><div \nclass=\"errors\" ng-messages=\"churchDetailsForm.province.$error\" \nng-if=\"churchDetailsForm.province.$touched\r\n                                         || churchDetailsForm.$submitted\">\n<div ng-message=\"required\">Required</div><div ng-message=\"md-require-match\">Please select a province.</div></div>\n</md-autocomplete><md-autocomplete flex required md-input-name=\"city\" md-selected-item=\"vm.selectedCity\" \nmd-selected-item-change=\"vm.selectCity(city)\" md-search-text=\"vm.searchCity\" \nmd-items=\"city in vm.searchCities(vm.searchCity)\" md-item-text=\"city.name\" md-no-cache=\"1\" md-min-length=\"0\" \nmd-require-match md-floating-label=\"City\" ng-disabled=\"!vm.church.province_id\"><md-item-template><span \nmd-highlight-text=\"vm.searchCity\">{{city.name}}</span></md-item-template><div class=\"errors\" \nng-messages=\"churchDetailsForm.city.$error\" \nng-if=\"churchDetailsForm.city.$touched\r\n                                         || churchDetailsForm.$submitted\"><div \nng-message=\"required\">Required</div><div ng-message=\"md-require-match\">Please select a city.</div></div>\n</md-autocomplete><md-autocomplete flex required md-input-name=\"barangay\" md-selected-item=\"vm.selectedBarangay\" \nmd-selected-item-change=\"vm.selectBarangay(barangay)\" md-search-text=\"vm.searchBarangay\" \nmd-items=\"barangay in vm.searchBarangays(vm.searchBarangay)\" md-item-text=\"barangay.name\" md-no-cache=\"1\" \nmd-min-length=\"0\" md-require-match md-floating-label=\"Barangay\" ng-disabled=\"!vm.church.city_id\"><md-item-template>\n<span md-highlight-text=\"vm.searchBarangay\">{{barangay.name}}</span></md-item-template><div class=\"errors\" \nng-messages=\"churchDetailsForm.barangay.$error\" \nng-if=\"churchDetailsForm.barangay.$touched\r\n                                         || churchDetailsForm.$submitted\">\n<div ng-message=\"required\">Required</div><div ng-message=\"md-require-match\">Please select a barangay.</div></div>\n</md-autocomplete></div><div class=\"md-block mt-10\" flex-gt-xs ng-show=\"!vm.clickedEdit\"><label \nclass=\"label-info-personal\">Other/More Address</label><div class=\"value-info-personal\">{{vm.church.address}}</div>\n</div><div class=\"md-block mt-10\" flex-gt-xs ng-show=\"!vm.clickedEdit\"><label class=\"label-info-personal\">\nAdded through ICM</label><div class=\"value-info-personal\">{{vm.church.added_by_icm ? \'Yes\' : \'No\'}}</div></div>\n<md-input-container class=\"md-block mb-0 mt-0\" flex-gt-xs ng-show=\"vm.clickedEdit\"><input name=\"address\" \nng-model=\"vm.church.address\" placeholder=\"Other/More Address\" type=\"text\" maxlength=\"120\" class=\"pastor\"><div \nng-messages=\"churchDetailsForm.address.$error\" \nng-show=\"churchDetailsForm.address.$touched\r\n                                     || vm.apiErrors.address\" \nrole=\"alert\"><div ng-bind=\"vm.apiErrors.address\"></div></div></md-input-container><md-input-container \nclass=\"md-block edit-added-icm\" flex-gt-xs ng-show=\"vm.clickedEdit\"><div class=\"checkbox-holder\"><md-checkbox \nclass=\"md-primary\" ng-model=\"vm.church.added_by_icm\" value=\"1\">Added through ICM</md-checkbox></div><div \nng-messages=\"churchDetailsForm.added_through_icm.$error\" \nng-show=\"churchDetailsForm.added_through_icm.$touched\r\n                                     || vm.apiErrors.added_through_icm\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.added_through_icm\"></div>\n</div></md-input-container></div><div class=\"main-md-content\"><div><h2>Pastors</h2><md-button \nclass=\"md-raised new-application ml-0\" ng-show=\"currentUser.$roles.has([\'admin\']) || vm.userCountry !== \'PH\'\" \nng-click=\"vm.addNewPastor(vm.church)\">New Pastor</md-button><table class=\"table\"><tr><th>ID</th><th>Name</th><th>\nPosition</th></tr><tr ng-show=\"!vm.pastors.data.length\r\n                                    && !vm.isLoading1\"><td \ncolspan=\"5\"><div class=\"text-center\">No pastors.</div></td></tr><tr \nng-show=\"vm.isLoading1\r\n                                    && vm.pastors.length < 1\"><td colspan=\"5\"><div \nclass=\"text-center\">Loading pastors.</div></td></tr><tr ng-repeat=\"pastor in vm.pastors.data\" \nng-click=\"vm.goToProfile(pastor)\"><td>{{pastor.id}}</td><td>{{pastor.fullname}}</td><td>{{pastor.pastor_position}}</td>\n<td class=\"icons-container\" ng-show=\"currentUser.$roles.has([\'admin\']) || vm.userCountry !== \'PH\'\"><i \nclass=\"icon-trash\" ng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'pastor_coordinator\', \'branch_head\'])\" \nng-click=\"vm.deletePastor(vm.church, pastor);\r\n                                               $event.stopPropagation();\">\n<md-tooltip md-direction=\"left\">Delete Pastor</md-tooltip></i></td></tr></table><div class=\"pagination-container\" \nng-show=\"!vm.isLoading1\"><pagination items=\"vm.pastors\" callback=\"vm.pageChange(vm.pastors.current_page)\"></pagination>\n</div></div><div class=\"pt-25\"><h2>Lay Leaders</h2><md-button class=\"md-raised add-button\" \nng-show=\"currentUser.$roles.has([\'admin\']) || vm.userCountry !== \'PH\'\" ng-click=\"vm.addNewLayLeader(vm.church)\">\nAdd New Lay Leader</md-button><md-button class=\"md-raised add-button\" \nng-show=\"currentUser.$roles.has([\'admin\']) || vm.userCountry !== \'PH\'\" ng-click=\"vm.addExistingLayLeader(vm.church)\">\nAdd Existing Lay Leader</md-button><table class=\"table\"><tr><th>ID</th><th>Name</th></tr><tr \nng-show=\"!vm.layleaders.data.length\r\n                                    && !vm.isLoading2\"><td colspan=\"5\"><div \nclass=\"text-center\">No Lay Leaders.</div></td></tr><tr \nng-show=\"vm.isLoading2\r\n                                    && vm.layleaders.length < 1\"><td colspan=\"5\"><div \nclass=\"text-center\">Loading Lay Leaders.</div></td></tr><tr ng-repeat=\"layleader in vm.layleaders.data\" \nng-click=\"vm.goToCommunity(layleader)\"><td>{{layleader.id}}</td><td>{{layleader.fullname}}</td><td \nclass=\"icons-container\" ng-show=\"currentUser.$roles.has([\'admin\']) || vm.userCountry !== \'PH\'\"><i class=\"icon-pencil\" \nng-click=\"vm.editLayleader(layleader, vm.church);$event.stopPropagation();\"><md-tooltip md-direction=\"left\">\nEdit Lay Leader</md-tooltip></i><i class=\"icon-check\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'pastor_coordinator\', \'branch_head\'])\" \nng-click=\"vm.promoteCounselor(layleader, vm.church);\r\n                                               $event.stopPropagation();\">\n<md-tooltip md-direction=\"left\">Promote Lay Leader</md-tooltip></i><i class=\"icon-trash\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'pastor_coordinator\', \'branch_head\'])\" \nng-click=\"vm.deleteLayleader(vm.church, layleader);\r\n                                               $event.stopPropagation();\">\n<md-tooltip md-direction=\"left\">Delete Lay Leader</md-tooltip></i></td></tr></table><div class=\"pagination-container\" \nng-show=\"!vm.isLoading1\"><pagination items=\"vm.layleaders\" \ncallback=\"vm.pageChangeLayleaders(vm.layleaders.current_page)\"></pagination></div></div></div></div></div></form></div>\n</div></md-bottom-sheet>");
$templateCache.put("app/main/thrive/tabs/churches/dialogs/add-layleader/add-layleader-dialog.html","<md-dialog class=\"new-user-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"addExistingLayLeader\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.addLayLeader(vm.participant)\"><md-toolbar class=\"md-accent md-hue-2\">\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-xs>\n<input name=\"firstname\" ng-model=\"vm.participant.firstname\" placeholder=\"First Name\" md-autofocus maxlength=\"30\" \nrequired><div ng-messages=\"addExistingLayLeader.firstname.$error\" ng-show=\"addExistingLayLeader.firstname.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-xs><input name=\"middlename\" ng-model=\"vm.participant.middlename\" maxlength=\"30\" \nplaceholder=\"Middle Name\"></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" \nflex-gt-xs><input name=\"lastname\" ng-model=\"vm.participant.lastname\" maxlength=\"30\" placeholder=\"Last Name\" required>\n<div ng-messages=\"addExistingLayLeader.lastname.$error\" ng-show=\"addExistingLayLeader.lastname.$touched\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-xs><input name=\"suffix\" ng-model=\"vm.participant.suffix\" maxlength=\"20\" placeholder=\"Nickname\">\n</md-input-container></div><div layout-gt-xs=\"row\"><div flex-gt-xs><div layout-gt-xs=\"row\" class=\"gray-text\"><div><h5 \nclass=\"mb-0 mt-0\">Gender:</h5></div></div><div layout-gt-xs=\"row\" class=\"black-text\"><div><md-radio-group \nng-model=\"vm.participant.gender\" required layout=\"row\"><md-radio-button ng-repeat=\"gender in vm.genders\" \nclass=\"md-primary\" flex-gt-xs ng-value=\"gender.value\">{{gender.label}}</md-radio-button></md-radio-group></div></div>\n</div><div flex-gt-xs><md-input-container class=\"md-block datepicker\"><md-datepicker \nng-model=\"vm.participant.birthdate\" name=\"participantbdate\" md-open-on-focus md-input-name=\"participantbdate\" \nmd-placeholder=\"Date of Birth\"></md-datepicker><div class=\"errors\" \nng-messages=\"addExistingLayLeader.participantbdate.$error\"><div ng-message=\"valid\" class=\"date-error\">\nThe entered value is not a date!</div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions>\n<md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel\n</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"addExistingLayLeader.$invalid\r\n                       || addExistingLayLeader.$pristine || vm.saving\" \ntype=\"submit\"><span ng-show=\"!vm.saving\">{{vm.footerTitle}}</span> <span ng-show=\"vm.saving\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting</span></md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/thrive/tabs/churches/dialogs/delete-church/delete-church-dialog.html","<md-dialog class=\"delete-dialog transform-dialog\" aria-label=\"Drop Pastor\"><form name=\"deleteChurchForm \" \nclass=\"md-inline-form\" ng-submit=\"vm.passwordConfirmation()\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block mb-0\"><label>Reason for Dropping</label>\n<md-select name=\"reason\" ng-model=\"vm.form.reason\"><md-option ng-value=\"reason\" ng-repeat=\"reason in vm.reason\">\n{{ reason }}</md-option></md-select><div ng-messages=\"deleteChurchForm .reason.$error\" \nng-show=\"deleteChurchForm .reason.$touched || leavePastorForm.$submitted\" role=\"alert\"><div ng-message=\"required\">\n<span>Required</span></div></div></md-input-container></md-dialog-content><md-dialog-actions><md-button md-no-ink \nclass=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"deleteChurchForm .$invalid || vm.saving\" type=\"submit\"><md-progress-circular \nmd-mode=\"indeterminate\" ng-if=\"vm.saving\" md-diameter=\"20px\"></md-progress-circular>OK</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/thrive/tabs/churches/dialogs/add-pastor/add-pastor.html","<md-dialog class=\"new-user-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"pastorInChurchForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.addPastor(vm.pastor, pastorInChurchForm)\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout-gt-xs=\"row\"><md-autocomplete flex md-autofocus md-input-name=\"pastor\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedPastor\" md-selected-item-change=\"vm.selectPastor(pastor)\" \nmd-search-text=\"vm.searchPastorName\" md-search-text-change=\"vm.searchPastorChange(vm.searchPastorName)\" \nmd-items=\"pastor in vm.searchPastors(vm.searchPastorName)\" \nmd-item-text=\"pastor.firstname+\' \'+pastor.lastname+ \' (\' +pastor.id+ \')\'\" md-require-match \nmd-floating-label=\"Pastor Name or ID\"><md-item-template><table><td width=\"100px\">{{pastor.id}}</td><td width=\"100px\">\n{{pastor.is_active ? \'Active\' : \'Inactive\'}}</td><td width=\"170px\">{{pastor.firstname}} {{pastor.lastname}}</td>\n</table></md-item-template><div class=\"errors\" ng-messages=\"pastorInChurchForm.pastor.$error\" \nng-if=\"pastorInChurchForm.pastor.$touched\r\n                         || pastorInChurchForm.$submitted\"><div \nng-message=\"md-require-match\">Please select an existing pastor.</div></div></md-autocomplete><md-input-container \nclass=\"md-block\" flex=\"35\"><label>Position</label><md-select name=\"position\" ng-disabled=\"!vm.church_position.length\" \nng-model=\"vm.pastor.position\" placeholder=\"Position\" required><md-option ng-value=\"status.value\" \nng-repeat=\"status in vm.church_position\">{{ status.label }}</md-option></md-select><div \nng-messages=\"pastorInChurchForm.position.$error\" \nng-show=\"pastorInChurchForm.position.$touched\r\n                         || vm.apiErrors.church_position\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.church_position\"></div></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions><md-button md-no-ink \nclass=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"pastorInChurchForm.$invalid || vm.saving\" type=\"submit\"><span \nng-show=\"!vm.saving\">Add Pastor</span> <span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"20px\"></md-progress-circular>Submitting</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/thrive/tabs/churches/dialogs/edit-church/edit-church-dialog.html","<md-dialog class=\"edit-user-dialog edit-church transform-dialog\"><form name=\"churchForm\" class=\"md-inline-form\" \nnovalidate ng-submit=\"vm.editChurch(vm.church, churchForm)\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout-gt-xs=\"row\"><md-input-container class=\"md-block mb-0\" flex-gt-xs>\n<input name=\"name\" ng-model=\"vm.church.name\" placeholder=\"Church Name\" type=\"text\" class=\"church\" maxlength=\"50\" \nmd-autofocus required><div ng-messages=\"churchForm.name.$error\" \nng-show=\"churchForm.name.$touched || vm.apiErrors.name\" role=\"alert\"><div ng-message=\"required\"><span>Required</span>\n</div><div ng-message=\"maxlength\"><span>Exceeds limit</span></div><div ng-bind=\"vm.apiErrors.name\"></div></div>\n</md-input-container><md-autocomplete flex required md-input-name=\"affiliation\" \nmd-selected-item=\"vm.selectedChurchAffiliation\" md-selected-item-change=\"vm.selectChurchAffiliation(affiliation)\" \nmd-search-text=\"vm.searchChurchAffiliation\" \nmd-items=\"affiliation in vm.searchChurchAffiliations(vm.searchChurchAffiliation)\" md-item-text=\"affiliation.name\" \nmd-no-cache=\"1\" md-require-match md-floating-label=\"Church Affiliation / Denomination\"><md-item-template><span \nmd-highlight-text=\"vm.searchChurchAffiliation\">{{affiliation.name}}</span></md-item-template><div class=\"errors\" \nng-messages=\"churchForm.affiliation.$error\" ng-if=\"churchForm.affiliation.$touched || churchForm.$submitted\"><div \nng-message=\"required\">Required</div><div ng-message=\"md-require-match\">Please select a affiliation.</div></div>\n</md-autocomplete></div><div layout-gt-xs=\"row\"><md-autocomplete flex required md-input-name=\"province\" \nmd-selected-item=\"vm.selectedProvince\" md-selected-item-change=\"vm.selectProvince(province)\" \nmd-search-text=\"vm.searchProvince\" md-items=\"province in vm.searchProvinces(vm.searchProvince)\" \nmd-item-text=\"province.name\" md-no-cache=\"1\" md-require-match md-floating-label=\"Province\" md-min-length=\"0\">\n<md-item-template><span md-highlight-text=\"vm.searchProvince\">{{province.name}}</span></md-item-template><div \nclass=\"errors\" ng-messages=\"churchForm.province.$error\" ng-if=\"churchForm.province.$touched || churchForm.$submitted\">\n<div ng-message=\"required\">Required</div><div ng-message=\"md-require-match\">Please select a province.</div></div>\n</md-autocomplete><md-autocomplete flex required md-input-name=\"city\" md-selected-item=\"vm.selectedCity\" \nmd-selected-item-change=\"vm.selectCity(city)\" md-search-text=\"vm.searchCity\" \nmd-items=\"city in vm.searchCities(vm.searchCity)\" md-item-text=\"city.name\" md-no-cache=\"1\" md-require-match \nmd-floating-label=\"City\" ng-disabled=\"!vm.church.province_id\" md-min-length=\"0\"><md-item-template><span \nmd-highlight-text=\"vm.searchCity\">{{city.name}}</span></md-item-template><div class=\"errors\" \nng-messages=\"churchForm.city.$error\" ng-if=\"churchForm.city.$touched || churchForm.$submitted\"><div \nng-message=\"required\">Required</div><div ng-message=\"md-require-match\">Please select a city.</div></div>\n</md-autocomplete><md-autocomplete flex required md-input-name=\"barangay\" md-selected-item=\"vm.selectedBarangay\" \nmd-selected-item-change=\"vm.selectBarangay(barangay)\" md-search-text=\"vm.searchBarangay\" \nmd-items=\"barangay in vm.searchBarangays(vm.searchBarangay)\" md-item-text=\"barangay.name\" md-no-cache=\"1\" \nmd-require-match md-floating-label=\"Barangay\" md-min-length=\"0\" ng-disabled=\"!vm.church.city_id\"><md-item-template>\n<span md-highlight-text=\"vm.searchBarangay\">{{barangay.name}}</span></md-item-template><div class=\"errors\" \nng-messages=\"churchForm.barangay.$error\" ng-if=\"churchForm.barangay.$touched || churchForm.$submitted\"><div \nng-message=\"required\">Required</div><div ng-message=\"md-require-match\">Please select a barangay.</div></div>\n</md-autocomplete></div><md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"address\" \nng-model=\"vm.church.address\" placeholder=\"Other/More Address\" type=\"text\" class=\"church\" maxlength=\"120\"><div \nng-messages=\"churchForm.address.$error\" ng-show=\"churchForm.address.$touched || vm.apiErrors.address\" role=\"alert\"><div\n ng-bind=\"vm.apiErrors.address\"></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-xs><div \nclass=\"checkbox-holder\"><md-checkbox class=\"md-primary\" ng-model=\"vm.church.added_by_icm\" value=\"1\">Added through ICM\n</md-checkbox></div><div ng-messages=\"churchForm.added_through_icm.$error\" \nng-show=\"churchForm.added_through_icm.$touched\r\n                     || vm.apiErrors.added_through_icm\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.added_through_icm\"></div></div>\n</md-input-container></md-dialog-content><md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" \naria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"churchForm.$invalid || vm.saving\" type=\"submit\"><span ng-show=\"!vm.saving\">Edit Church</span> <span \nng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting\n</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/thrive/tabs/churches/dialogs/add-existing-layleader/add-existing-layleader-dialog.html","<md-dialog class=\"new-user-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"layleaderInChurchForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.addLayLeader(vm.layleader, pastorInChurchForm)\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout-gt-xs=\"row\"><md-autocomplete flex md-autofocus required md-input-name=\"pastor\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedLayleader\" md-selected-item-change=\"vm.selectLayleader(layleader)\" \nmd-search-text=\"vm.searchLayleaderName\" md-items=\"layleader in vm.searchLayleaders(vm.searchLayleaderName)\" \nmd-item-text=\"layleader.firstname+\' \'+layleader.lastname\" md-require-match md-floating-label=\"Layleader Name\">\n<md-item-template><table><td width=\"170px\">{{layleader.firstname}} {{layleader.lastname}}</td></table>\n</md-item-template><div class=\"errors\" ng-messages=\"layleaderInChurchForm.pastor.$error\" \nng-if=\"layleaderInChurchForm.pastor.$touched\r\n                         || layleaderInChurchForm.$submitted\"><div \nng-message=\"required\">Required.</div><div ng-message=\"md-require-match\">Please select an existing pastor.</div></div>\n</md-autocomplete></div></md-dialog-content><md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" \naria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"layleaderInChurchForm.$invalid || vm.saving\" type=\"submit\"><span ng-show=\"!vm.saving\">Add Lay Leader\n</span> <span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\">\n</md-progress-circular>Submitting</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/thrive/tabs/churches/dialogs/new-church/new-church-dialog.html","<style>\n.note-alert {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n        gap: 8px;\r\n        padding: 12px;\r\n        font-size: 13px;\r\n        font-weight: 600;\r\n        background-color: #FFF4E5;\r\n        color: #866331;\r\n        border-radius: 4px;\r\n        margin-bottom: 30px;\r\n    }\r\n    \r\n    .note-alert .item{\r\n        display: flex;\r\n        align-items: center;\r\n    }\n</style><md-dialog class=\"new-user-dialog edit-church transform-dialog\"><form name=\"churchForm\" class=\"md-inline-form\" \nng-submit=\"vm.addNewChurch(vm.church, churchForm)\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout-gt-xs=\"row\" ng-show=\"vm.showAlertNote\" class=\"note-alert\"><div \nclass=\"item\"><i class=\"icon icon-alert-box\"><md-tooltip md-direction=\"bottom\">Note</md-tooltip></i><span>\nNote: Before adding a new church, please check that it is has no existing record in the ICM database.</span></div>\n<button mat-icon-button type=\"button\" ng-click=\"vm.closeNote()\"><i class=\"icon icon-close\"><md-tooltip \nmd-direction=\"bottom\">Close</md-tooltip></i></button></div><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-xs><input name=\"name\" ng-model=\"vm.church.name\" placeholder=\"Church Name\" type=\"text\" \nclass=\"church\" maxlength=\"50\" md-autofocus required><div ng-messages=\"churchForm.name.$error\" \nng-show=\"churchForm.name.$touched || vm.apiErrors.name\" role=\"alert\"><div ng-message=\"required\"><span>Required</span>\n</div><div ng-message=\"maxlength\"><span>Exceeds limit</span></div><div ng-bind=\"vm.apiErrors.name\"></div></div>\n</md-input-container><md-autocomplete flex required md-input-name=\"affiliation\" \nmd-selected-item=\"vm.selectedChurchAffiliation\" md-selected-item-change=\"vm.selectChurchAffiliation(affiliation)\" \nmd-search-text=\"vm.searchChurchAffiliation\" \nmd-items=\"affiliation in vm.searchChurchAffiliations(vm.searchChurchAffiliation)\" md-item-text=\"affiliation.name\" \nmd-no-cache=\"1\" md-require-match md-floating-label=\"Church Affiliation / Denomination\"><md-item-template><span \nmd-highlight-text=\"vm.searchChurchAffiliation\">{{affiliation.name}}</span></md-item-template><div class=\"errors\" \nng-messages=\"churchForm.affiliation.$error\" \nng-if=\"churchForm.affiliation.$touched\r\n                         || churchForm.$submitted\"><div ng-message=\"required\">\nRequired</div><div ng-message=\"md-require-match\">Please select a affiliation.</div></div></md-autocomplete></div><div \nlayout-gt-xs=\"row\"><md-autocomplete flex required md-input-name=\"province\" md-selected-item=\"vm.selectedProvince\" \nmd-selected-item-change=\"vm.selectProvince(province)\" md-search-text=\"vm.searchProvince\" \nmd-items=\"province in vm.searchProvinces(vm.searchProvince)\" md-item-text=\"province.name\" md-no-cache=\"1\" \nmd-require-match md-floating-label=\"Province\" md-min-length=\"0\"><md-item-template><span \nmd-highlight-text=\"vm.searchProvince\">{{province.name}}</span></md-item-template><div class=\"errors\" \nng-messages=\"churchForm.province.$error\" \nng-if=\"churchForm.province.$touched\r\n                         || churchForm.$submitted\"><div ng-message=\"required\">\nRequired</div><div ng-message=\"md-require-match\">Please select a province.</div></div></md-autocomplete>\n<md-autocomplete flex required md-input-name=\"city\" md-selected-item=\"vm.selectedCity\" \nmd-selected-item-change=\"vm.selectCity(city)\" md-search-text=\"vm.searchCity\" \nmd-items=\"city in vm.searchCities(vm.searchCity)\" md-item-text=\"city.name\" md-no-cache=\"1\" md-require-match \nmd-floating-label=\"City\" ng-disabled=\"!vm.church.province_id\" md-min-length=\"0\"><md-item-template><span \nmd-highlight-text=\"vm.searchCity\">{{city.name}}</span></md-item-template><div class=\"errors\" \nng-messages=\"churchForm.city.$error\" \nng-if=\"churchForm.city.$touched\r\n                         || churchForm.$submitted\"><div ng-message=\"required\">Required\n</div><div ng-message=\"md-require-match\">Please select a city.</div></div></md-autocomplete><md-autocomplete flex \nrequired md-input-name=\"barangay\" md-selected-item=\"vm.selectedBarangay\" \nmd-selected-item-change=\"vm.selectBarangay(barangay)\" md-search-text=\"vm.searchBarangay\" \nmd-items=\"barangay in vm.searchBarangays(vm.searchBarangay)\" md-item-text=\"barangay.name\" md-no-cache=\"1\" \nmd-require-match md-floating-label=\"Barangay\" ng-disabled=\"!vm.church.city_id\" md-min-length=\"0\"><md-item-template>\n<span md-highlight-text=\"vm.searchBarangay\">{{barangay.name}}</span></md-item-template><div class=\"errors\" \nng-messages=\"churchForm.barangay.$error\" \nng-if=\"churchForm.barangay.$touched\r\n                         || churchForm.$submitted\"><div ng-message=\"required\">\nRequired</div><div ng-message=\"md-require-match\">Please select a barangay.</div></div></md-autocomplete></div>\n<md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"address\" ng-model=\"vm.church.address\" \nplaceholder=\"Other/More Address\" type=\"text\" class=\"church\" maxlength=\"120\"><div \nng-messages=\"churchForm.address.$error\" \nng-show=\"churchForm.address.$touched\r\n                     || vm.apiErrors.address\" role=\"alert\"><div \nng-bind=\"vm.apiErrors.address\"></div></div></md-input-container><md-input-container class=\"md-block mb-0\" flex-gt-xs>\n<div class=\"checkbox-holder\"><md-checkbox class=\"md-primary\" ng-model=\"vm.church.added_by_icm\" value=\"1\">\nAdded through ICM</md-checkbox></div><div ng-messages=\"churchForm.added_through_icm.$error\" \nng-show=\"churchForm.added_through_icm.$touched\r\n                     || vm.apiErrors.added_through_icm\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.added_through_icm\"></div></div>\n</md-input-container></md-dialog-content><md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" \naria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"churchForm.$invalid || vm.saving\" type=\"submit\"><span ng-show=\"!vm.saving\">Add Church</span> <span \nng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting\n</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/thrive/tabs/churches/dialogs/promote-counselor/promote-counselor-dialog.html","<md-dialog class=\"edit-user-dialog edit-church transform-dialog\"><form name=\"promoteCounselorForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.promoteCounselor(vm.counselor, promoteCounselorForm)\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><h2>\nPersonal Information</h2><div layout-gt-xs=\"row\"><md-input-container class=\"md-block mb-0\" flex-gt-xs><input \nname=\"firstname\" ng-model=\"vm.counselor.firstname\" placeholder=\"First Name\" type=\"text\" class=\"pastor\" md-autofocus \nrequired><div ng-messages=\"promoteCounselorForm.firstname.$error\" \nng-show=\"promoteCounselorForm.firstname.$touched\r\n                         || vm.apiErrors.firstname\" role=\"alert\"><div\n ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.firstname\"></div></div>\n</md-input-container><md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"middlename\" \nng-model=\"vm.counselor.middlename\" placeholder=\"Middle Name\" type=\"text\" class=\"pastor\" required><div \nng-messages=\"promoteCounselorForm.middlename.$error\" \nng-show=\"promoteCounselorForm.middlename.$touched\r\n                         || vm.apiErrors.middlename\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.middlename\"></div></div>\n</md-input-container><md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"lastname\" \nng-model=\"vm.counselor.lastname\" placeholder=\"Last Name\" type=\"text\" class=\"pastor\" required><div \nng-messages=\"promoteCounselorForm.lastname.$error\" \nng-show=\"promoteCounselorForm.lastname.$touched\r\n                         || vm.apiErrors.lastname\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.lastname\"></div></div></md-input-container>\n</div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-xs><label>Birthday</label><md-datepicker \nng-model=\"vm.counselor.birth_date\" name=\"birth_date\" md-open-on-focus md-placeholder=\"Birthday\" \nmd-input-name=\"birth_date\" required></md-datepicker><div ng-messages=\"promoteCounselorForm.birth_date.$error\" \nng-show=\"promoteCounselorForm.birth_date.$touched\r\n                         || vm.apiErrors.birth_date\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.birth_date\"></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-xs><label>Gender</label><md-select name=\"gender\" \nng-disabled=\"!vm.gender.length\" ng-model=\"vm.counselor.gender\" placeholder=\"Gender\" required><md-option \nng-value=\"status.value\" ng-repeat=\"status in vm.gender\">{{ status.label }}</md-option></md-select><div \nng-messages=\"promoteCounselorForm.gender.$error\" \nng-show=\"promoteCounselorForm.gender.$touched\r\n                         || vm.apiErrors.gender\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.gender\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-xs><label>Marital Status</label><md-select name=\"status\" \nng-disabled=\"!vm.marital_status.length\" ng-model=\"vm.counselor.status\" placeholder=\"Marital Status\" required><md-option\n ng-value=\"status.value\" ng-repeat=\"status in vm.marital_status\">{{ status.label }}</md-option></md-select><div \nng-messages=\"promoteCounselorForm.status.$error\" \nng-show=\"promoteCounselorForm.status.$touched\r\n                         || vm.apiErrors.status\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.status\"></div></div></md-input-container>\n</div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"email\" \nng-model=\"vm.counselor.email\" placeholder=\"Email Address\" type=\"text\" class=\"pastor\" ng-pattern=\"/^.+@.+\\..+$/\"><div \nng-messages=\"promoteCounselorForm.email.$error\" \nng-show=\"promoteCounselorForm.email.$touched\r\n                         || vm.apiErrors.email\" role=\"alert\"><div \nng-message=\"pattern\"><span>Must be a valid email address.</span></div><div ng-bind=\"vm.apiErrors.email\"></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-xs><label>Educational Attainment</label><md-select \nname=\"educational_attainment\" ng-disabled=\"!vm.educational_attainment.length\" \nng-model=\"vm.counselor.educational_attainment\" placeholder=\"Educational Attainment\" required><md-option \nng-value=\"status.value\" ng-repeat=\"status in vm.educational_attainment\">{{ status.label }}</md-option></md-select><div \nng-messages=\"promoteCounselorForm.educational_attainment.$error\" \nng-show=\"promoteCounselorForm.educational_attainment.$touched\r\n                         || vm.apiErrors.educational_attainment\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.educational_attainment\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-xs><label>Attended Seminary</label>\n<md-select name=\"seminary\" ng-disabled=\"!vm.yesno.length\" ng-model=\"vm.counselor.seminary\" \nplaceholder=\"Attended Seminary\" required><md-option ng-value=\"option.value\" ng-repeat=\"option in vm.yesno\">\n{{ option.label }}</md-option></md-select><div ng-messages=\"promoteCounselorForm.seminary.$error\" \nng-show=\"promoteCounselorForm.seminary.$touched\r\n                         || vm.apiErrors.seminary\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.seminary\"></div></div></md-input-container>\n</div><h2>Address</h2><div layout-gt-xs=\"row\"><md-input-container class=\"md-block mb-10\" flex=\"50\"><label>Base</label>\n<md-select name=\"base\" ng-disabled=\"!vm.bases.length\" ng-model=\"vm.counselor.base_id\" placeholder=\"Base\" required>\n<md-option ng-value=\"base.id\" ng-click=\"vm.selectBase(base)\" ng-repeat=\"base in vm.bases\">{{ base.name }}</md-option>\n</md-select><div ng-messages=\"promoteCounselorForm.base.$error\" \nng-show=\"promoteCounselorForm.base.$touched\r\n                         || vm.apiErrors.base_id\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.base_id\"></div></div></md-input-container>\n<md-input-container class=\"md-block mb-10\" flex=\"50\"><label>District</label><md-select name=\"district\" \nng-disabled=\"!vm.counselor.base.districts.length\" ng-model=\"vm.counselor.district_id\" placeholder=\"District\" required>\n<md-option ng-value=\"district.id\" ng-repeat=\"district in vm.counselor.base.districts\">{{ district.name }}</md-option>\n</md-select><div ng-messages=\"promoteCounselorForm.district.$error\" \nng-show=\"promoteCounselorForm.district.$touched\r\n                         || vm.apiErrors.district_id\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.district_id\"></div></div>\n</md-input-container></div><div layout-gt-xs=\"row\"><md-autocomplete flex required md-input-name=\"province\" \nmd-selected-item=\"vm.counselor.province\" md-selected-item-change=\"vm.selectProvince(province)\" \nmd-search-text=\"vm.searchProvince\" md-items=\"province in vm.searchProvinces(vm.searchProvince)\" \nmd-item-text=\"province.name\" md-no-cache=\"1\" md-require-match md-floating-label=\"Province\"><md-item-template><span \nmd-highlight-text=\"vm.searchProvince\">{{province.name}}</span></md-item-template><div class=\"errors\" \nng-messages=\"promoteCounselorForm.province.$error\r\n                         || vm.apiErrors.province_id\" \nng-if=\"promoteCounselorForm.province.$touched\r\n                         || promoteCounselorForm.$submitted\"><div \nng-message=\"required\">Required</div><div ng-message=\"md-require-match\">Please select an province.</div><div \nng-bind=\"vm.apiErrors.province_id\"></div></div></md-autocomplete><md-autocomplete flex required md-input-name=\"city\" \nmd-selected-item=\"vm.counselor.city\" md-selected-item-change=\"vm.selectCity(city)\" md-search-text=\"vm.searchCity\" \nmd-items=\"city in vm.searchCities(vm.searchCity)\" md-item-text=\"city.name\" md-no-cache=\"1\" md-require-match \nmd-floating-label=\"City\" ng-disabled=\"!vm.counselor.province_id\"><md-item-template><span \nmd-highlight-text=\"vm.searchCity\">{{city.name}}</span></md-item-template><div class=\"errors\" \nng-messages=\"promoteCounselorForm.city.$error\" \nng-if=\"promoteCounselorForm.city.$touched\r\n                         || promoteCounselorForm.$submitted\"><div \nng-message=\"required\">Required</div><div ng-message=\"md-require-match\">Please select an city.</div></div>\n</md-autocomplete><md-autocomplete flex required md-input-name=\"barangay\" md-selected-item=\"vm.counselor.barangay\" \nmd-selected-item-change=\"vm.selectBarangay(barangay)\" md-search-text=\"vm.searchBarangay\" \nmd-items=\"barangay in vm.searchBarangays(vm.searchBarangay)\" md-item-text=\"barangay.name\" md-no-cache=\"1\" \nmd-require-match md-floating-label=\"Barangay\" ng-disabled=\"!vm.counselor.city_id\"><md-item-template><span \nmd-highlight-text=\"vm.searchBarangay\">{{barangay.name}}</span></md-item-template><div class=\"errors\" \nng-messages=\"promoteCounselorForm.barangay.$error\" \nng-if=\"promoteCounselorForm.barangay.$touched\r\n                         || promoteCounselorForm.$submitted\"><div \nng-message=\"required\">Required</div><div ng-message=\"md-require-match\">Please select an barangay.</div></div>\n</md-autocomplete></div><md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"address\" \nng-model=\"vm.counselor.address\" placeholder=\"Other/More Address\" type=\"text\" class=\"pastor\"><div \nng-messages=\"promoteCounselorForm.address.$error\" \nng-show=\"promoteCounselorForm.address.$touched\r\n                     || vm.apiErrors.address\" role=\"alert\"><div \nng-bind=\"vm.apiErrors.address\"></div></div></md-input-container><h2>Contact Information</h2><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"contacts1\" ng-model=\"vm.counselor.contacts1\" \nplaceholder=\"Contact No. 1\" type=\"text\" class=\"pastor\"><div ng-messages=\"promoteCounselorForm.contacts1.$error\" \nng-show=\"promoteCounselorForm.contacts1.$touched\r\n                         || vm.apiErrors.contacts[0]\" role=\"alert\">\n<div ng-bind=\"vm.apiErrors.contacts[0]\"></div></div></md-input-container><md-input-container class=\"md-block mb-0\" \nflex-gt-xs><input name=\"contacts[1]\" ng-model=\"vm.counselor.contacts\" placeholder=\"Contact No. 2\" type=\"text\" \nclass=\"pastor\"><div ng-messages=\"promoteCounselorForm.contacts1.$error\" \nng-show=\"promoteCounselorForm.contacts[1].$touched\r\n                         || vm.apiErrors.contacts[1]\" role=\"alert\">\n<div ng-bind=\"vm.apiErrors.contacts\"></div></div></md-input-container><md-input-container class=\"md-block mb-0\" \nflex-gt-xs><input name=\"contacts3\" ng-model=\"vm.counselor.contacts3\" placeholder=\"Contact No. 3\" type=\"text\" \nclass=\"pastor\"><div ng-messages=\"promoteCounselorForm.contacts3.$error\" \nng-show=\"promoteCounselorForm.contacts1.$touched\r\n                         || vm.apiErrors.contacts[2]\" role=\"alert\">\n<div ng-bind=\"vm.apiErrors.contacts[2]\"></div></div></md-input-container></div></md-dialog-content><md-dialog-actions>\n<md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel\n</md-button><md-button class=\"md-accent md-raised\" ng-disabled=\"promoteCounselorForm.$invalid || vm.saving\" \ntype=\"submit\"><span ng-show=\"!vm.saving\">Promote to Pastor</span> <span ng-show=\"vm.saving\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting</span></md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/thrive/tabs/districts/dialogs/add-district/add-district-dialog.html","<md-dialog class=\"new-user-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"districtForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.addDistrict(vm.district, districtForm)\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout-gt-xs=\"row\"><md-autocomplete flex required ng-disabled=\"vm.currentUser.base_id\" md-input-name=\"base\" \nmd-autofocus md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedBaseName\" \nmd-selected-item-change=\"vm.selectBaseName(base)\" md-search-text-change=\"vm.searchBaseChange(vm.searchBaseName)\" \nmd-search-text=\"vm.searchBaseName\" md-items=\"base in vm.searchBaseNames(vm.searchBaseName)\" md-item-text=\"base.name\" \nmd-require-match md-floating-label=\"Base\"><md-item-template><span md-highlight-text=\"vm.searchBaseName\">{{base.name}}\n</span></md-item-template><div class=\"errors\" ng-messages=\"districtForm.base.$error\" \nng-if=\"districtForm.base.$touched || districtForm.$submitted\"><div ng-message=\"required\">Required</div><div \nng-message=\"md-require-match\">Please select an existing base.</div></div></md-autocomplete><md-input-container flex>\n<md-select ng-disabled=\"!vm.branches.length || vm.currentUser.branch_id\" ng-model=\"vm.district.branch_id\" required \nname=\"branch\" placeholder=\"Branch\"><md-option ng-value=\"branch.id\" ng-repeat=\"branch in vm.branches\">{{ branch.name }}\n</md-option></md-select><div ng-messages=\"districtForm.branch.$error\" \nng-show=\"districtForm.branch.$touched || vm.apiErrors.branch_id\" role=\"alert\"><div ng-message=\"required\"><span>Required\n</span></div><div ng-bind=\"vm.apiErrors.branch_id\"></div></div></md-input-container></div><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"name\" ng-model=\"vm.district.name\" placeholder=\"Name\" \nclass=\"batch\" maxlength=\"30\" required><div ng-messages=\"districtForm.name.$error\" \nng-show=\"districtForm.name.$touched || vm.apiErrors.name\" role=\"alert\"><div ng-message=\"required\"><span>Required</span>\n</div><div ng-bind=\"vm.apiErrors.name\"></div></div></md-input-container></div></md-dialog-content><md-dialog-actions>\n<md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel\n</md-button><md-button class=\"md-accent md-raised\" ng-disabled=\"districtForm.$invalid || vm.saving\" type=\"submit\"><span\n ng-show=\"!vm.saving\">Add District</span> <span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"20px\"></md-progress-circular>Submitting</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/thrive/tabs/districts/dialogs/edit-district/edit-district-dialog.html","<md-dialog class=\"new-user-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"districtForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.editDistrict(vm.district, districtForm)\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout-gt-xs=\"row\"><md-autocomplete flex required ng-disabled=\"vm.currentUser.base_id\" md-input-name=\"base\" \nmd-autofocus md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedBaseName\" \nmd-selected-item-change=\"vm.selectBaseName(base)\" md-search-text-change=\"vm.searchBaseChange(vm.searchBaseName)\" \nmd-search-text=\"vm.searchBaseName\" md-items=\"base in vm.searchBaseNames(vm.searchBaseName)\" md-item-text=\"base.name\" \nmd-require-match md-floating-label=\"Base\"><md-item-template><span md-highlight-text=\"vm.searchBaseName\">{{base.name}}\n</span></md-item-template><div class=\"errors\" ng-messages=\"districtForm.base.$error\" \nng-if=\"districtForm.base.$touched\r\n                         || districtForm.$submitted\"><div ng-message=\"required\">\nRequired</div><div ng-message=\"md-require-match\">Please select an existing base.</div></div></md-autocomplete>\n<md-input-container flex><md-select ng-disabled=\"!vm.branches.length || vm.currentUser.branch_id\" \nng-model=\"vm.district.branch_id\" required name=\"branch\" placeholder=\"Branch\"><md-option ng-value=\"branch.id\" \nng-repeat=\"branch in vm.branches\">{{ branch.name }}</md-option></md-select><div \nng-messages=\"districtForm.branch.$error\" \nng-show=\"districtForm.branch.$touched\r\n                         || vm.apiErrors.branch_id\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.branch_id\"></div></div>\n</md-input-container></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block mb-0\" flex-gt-xs><input \nname=\"name\" ng-model=\"vm.district.name\" placeholder=\"Name\" class=\"batch\" maxlength=\"30\" required><div \nng-messages=\"districtForm.name.$error\" ng-show=\"districtForm.name.$touched || vm.apiErrors.name\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.name\"></div></div></md-input-container>\n</div></md-dialog-content><md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"districtForm.$invalid || vm.saving\" type=\"submit\"><span ng-show=\"!vm.saving\">Edit District</span> <span \nng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting\n</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/thrive/tabs/pastors/dialogs/add-church/add-church-dialog.html","<style>\n.chips span {\r\n        border-radius: 16px;\r\n        box-sizing: border-box;\r\n        font-size: 12px;\r\n        cursor: default;\r\n        display: block;\r\n        float: left;\r\n        height: 27px;\r\n        line-height: 27px;\r\n        margin: 0px 6px 0 0;\r\n        max-width: 100%;\r\n        padding: 0 8px;\r\n        background: rgb(224, 224, 224);\r\n        color: rgb(66, 66, 66);\r\n    }\r\n\r\n    .chips-tooltip {\r\n        gap: 8px;\r\n    }\r\n\r\n    .chips-tooltip span {\r\n        border-right: 1px solid ghostwhite;\r\n        padding-right: 8px;\r\n    }\r\n\r\n    .chips-tooltip span:last-child {\r\n        border: none !important;\r\n        padding-right: 0 !important;\r\n    }\r\n\r\n    md-autocomplete,\r\n    md-input-container {\r\n        margin: 0 !important;\r\n    }\r\n\r\n    md-autocomplete md-autocomplete-wrap {\r\n        height: 40px !important;\r\n    }\n</style><md-dialog class=\"new-user-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"newChurchForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.addNewChurch(vm.church, newChurchForm)\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout-gt-xs=\"row\"><md-autocomplete flex=\"50\" md-input-name=\"pastor\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedChurch\" md-selected-item-change=\"vm.selectChurch(church)\" \nmd-search-text=\"vm.searchChurch\" md-items=\"church in vm.searchChurches(vm.searchChurch)\" md-item-text=\"church.name\" \nmd-require-match required md-floating-label=\"Church\"><md-item-template>{{church.name}}<md-tooltip \nmd-direction=\"bottom\" ng-if=\"church.barangay || church.city || church.province\"><div layout-gt-xs=\"row\" \nclass=\"chips-tooltip\"><span ng-if=\"church.barangay\">{{church.barangay.name}} </span><span ng-if=\"church.city\">\n{{church.city.name}} </span><span ng-if=\"church.province\">{{church.province.name}}</span></div></md-tooltip>\n</md-item-template><div class=\"errors\" ng-messages=\"newChurchForm.pastor.$error\" \nng-if=\"newChurchForm.pastor.$touched\r\n                         || newChurchForm.$submitted\"><div \nng-message=\"md-require-match\">Please select an existing church.</div><div ng-message=\"required\">Required.</div></div>\n</md-autocomplete><md-input-container class=\"md-block\" flex=\"50\"><label>Position</label><md-select name=\"position\" \nng-disabled=\"!vm.church_position.length\" ng-model=\"vm.church.position\" placeholder=\"Position\" required><md-option \nng-value=\"status.value\" ng-repeat=\"status in vm.church_position\">{{ status.label }}</md-option></md-select><div \nng-messages=\"newChurchForm.position.$error\" \nng-show=\"newChurchForm.position.$touched\r\n                         || vm.apiErrors.church_position\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.church_position\"></div></div>\n</md-input-container></div><div layout-gt-xs=\"row\" class=\"chips\"><span ng-if=\"vm.selectedChurch.barangay\">\n{{vm.selectedChurch.barangay.name}}<md-tooltip md-direction=\"bottom\">Barangay</md-tooltip></span><span \nng-if=\"vm.selectedChurch.city\">{{vm.selectedChurch.city.name}}<md-tooltip md-direction=\"bottom\">City</md-tooltip>\n</span><span ng-if=\"vm.selectedChurch.province\">{{vm.selectedChurch.province.name}}<md-tooltip md-direction=\"bottom\">\nProvince</md-tooltip></span></div></md-dialog-content><md-dialog-actions><md-button md-no-ink \nclass=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"newChurchForm.$invalid || vm.saving\" type=\"submit\"><span ng-show=\"!vm.saving\">\nAdd Church</span> <span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\">\n</md-progress-circular>Submitting</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/thrive/tabs/pastors/dialogs/add-contact/add-contact-dialog.html","<md-dialog class=\"new-user-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"contactNumForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.addNewContact(vm.contact, contactNumForm)\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block mb-0\" flex-gt-xs><input name=\"number\" ng-model=\"vm.contact.number\" placeholder=\"Contact Number\" \ntype=\"text\" class=\"base\" md-autofocus required><div ng-messages=\"contactNumForm.number.$error\" \nng-show=\"contactNumForm.number.$touched\r\n                     || vm.apiErrors.number\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.contact_no\"></div></div>\n</md-input-container></md-dialog-content><md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" \naria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"contactNumForm.$invalid || vm.saving\" type=\"submit\"><span ng-show=\"!vm.saving\">Add Contact</span> <span \nng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting\n</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/thrive/tabs/pastors/dialogs/delete-pastor/delete-pastor-dialog.html","<md-dialog class=\"delete-dialog transform-dialog\" aria-label=\"Drop Pastor\"><form name=\"deletePastorForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.passwordConfirmation()\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block mb-0\"><label>Reason for Dropping</label>\n<md-select name=\"reason\" ng-model=\"vm.form.reason\"><md-option ng-value=\"reason\" ng-repeat=\"reason in vm.reason\">\n{{ reason }}</md-option></md-select><div ng-messages=\"deletePastorForm.reason.$error\" \nng-show=\"deletePastorForm.reason.$touched || leavePastorForm.$submitted\" role=\"alert\"><div ng-message=\"required\"><span>\nRequired</span></div></div></md-input-container></md-dialog-content><md-dialog-actions><md-button md-no-ink \nclass=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"deletePastorForm.$invalid || vm.pastors\" type=\"submit\"><md-progress-circular \nmd-mode=\"indeterminate\" ng-if=\"vm.pastors\" md-diameter=\"20px\"></md-progress-circular>OK</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/thrive/tabs/pastors/dialogs/edit-church/edit-pastor-church-dialog.html","<style>\n.chips span {\r\n        border-radius: 16px;\r\n        box-sizing: border-box;\r\n        font-size: 12px;\r\n        cursor: default;\r\n        display: block;\r\n        float: left;\r\n        height: 27px;\r\n        line-height: 27px;\r\n        margin: 0px 6px 0 0;\r\n        max-width: 100%;\r\n        padding: 0 8px;\r\n        background: rgb(224, 224, 224);\r\n        color: rgb(66, 66, 66);\r\n    }\r\n\r\n    .chips-tooltip {\r\n        gap: 8px;\r\n    }\r\n\r\n    .chips-tooltip span {\r\n        border-right: 1px solid ghostwhite;\r\n        padding-right: 8px;\r\n    }\r\n\r\n    .chips-tooltip span:last-child {\r\n        border: none !important;\r\n        padding-right: 0 !important;\r\n    }\r\n\r\n    md-autocomplete,\r\n    md-input-container {\r\n        margin: 0 !important;\r\n    }\r\n\r\n    md-autocomplete md-autocomplete-wrap {\r\n        height: 40px !important;\r\n    }\n</style><md-dialog class=\"new-user-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"newChurchForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.editChurch(vm.church, newChurchForm)\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout-gt-xs=\"row\"><md-autocomplete flex=\"50\" md-input-name=\"pastor\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedChurch\" md-selected-item-change=\"vm.selectChurch(church)\" \nmd-search-text=\"vm.searchChurch\" md-items=\"church in vm.searchChurches(vm.searchChurch)\" md-item-text=\"church.name\" \nmd-require-match disabled=\"disabled\" md-floating-label=\"Church\"><md-item-template>{{church.name}}<md-tooltip \nmd-direction=\"bottom\" ng-if=\"church.barangay || church.city || church.province\"><div layout-gt-xs=\"row\" \nclass=\"chips-tooltip\"><span ng-if=\"church.barangay\">{{church.barangay.name}} </span><span ng-if=\"church.city\">\n{{church.city.name}} </span><span ng-if=\"church.province\">{{church.province.name}}</span></div></md-tooltip>\n</md-item-template><div class=\"errors\" ng-messages=\"newChurchForm.pastor.$error\" \nng-if=\"newChurchForm.pastor.$touched\r\n                         || newChurchForm.$submitted\"><div \nng-message=\"md-require-match\">Please select an existing church.</div><div ng-message=\"required\">Required.</div></div>\n</md-autocomplete><md-input-container class=\"md-block\" flex=\"50\"><label>Position</label><md-select name=\"position\" \nng-disabled=\"!vm.church_position.length\" ng-model=\"vm.church.position\" placeholder=\"Position\" required><md-option \nng-value=\"status.value\" ng-repeat=\"status in vm.church_position\">{{ status.label }}</md-option></md-select><div \nng-messages=\"newChurchForm.position.$error\" \nng-show=\"newChurchForm.position.$touched\r\n                         || vm.apiErrors.church_position\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.church_position\"></div></div>\n</md-input-container></div><div layout-gt-xs=\"row\" class=\"chips\"><span ng-if=\"vm.selectedChurch.barangay\">\n{{vm.selectedChurch.barangay.name}}<md-tooltip md-direction=\"bottom\">Barangay</md-tooltip></span><span \nng-if=\"vm.selectedChurch.city\">{{vm.selectedChurch.city.name}}<md-tooltip md-direction=\"bottom\">City</md-tooltip>\n</span><span ng-if=\"vm.selectedChurch.province\">{{vm.selectedChurch.province.name}}<md-tooltip md-direction=\"bottom\">\nProvince</md-tooltip></span></div></md-dialog-content><md-dialog-actions><md-button md-no-ink \nclass=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"newChurchForm.$invalid || vm.saving\" type=\"submit\"><span ng-show=\"!vm.saving\">\nUpdate Church</span> <span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\">\n</md-progress-circular>Submitting</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/thrive/tabs/pastors/dialogs/edit-contact/edit-contact-dialog.html","<md-dialog class=\"new-user-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"editContactNumForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.editContact(vm.contact, editContactNumForm)\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block mb-0\" flex-gt-xs><input name=\"number\" ng-model=\"vm.contact.number\" placeholder=\"Contact Number\" \ntype=\"text\" class=\"base\" md-autofocus required><div ng-messages=\"editContactNumForm.number.$error\" \nng-show=\"editContactNumForm.number.$touched\r\n                     || vm.apiErrors.number\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.contact_no\"></div></div>\n</md-input-container></md-dialog-content><md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" \naria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"editContactNumForm.$invalid || vm.saving\" type=\"submit\"><span ng-show=\"!vm.saving\">Edit Contact</span> \n<span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>\nSubmitting</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/thrive/tabs/pastors/dialogs/edit-datacard/edit-datacard-dialog.html","<md-dialog class=\"new-user-dialog transform-dialog data-card-dialog\"><form name=\"editThriveForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.editThriveCard(vm.thrive, editThriveForm)\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><h2 \nclass=\"datacard-title\">Thrive Data Card</h2><md-input-container class=\"md-block datepicker mt-0 mb-0\"><h6>Thrive Date\n</h6><md-datepicker ng-model=\"vm.thrive.attended_at\" name=\"thrivedate\" md-open-on-focus required \nmd-placeholder=\"Enter date\" md-input-name=\"thrivedate\"></md-datepicker><div class=\"errors\" \nng-messages=\"editThriveForm.thrivedate.$error\"><div ng-message=\"valid\" class=\"date-error\">\nThe entered value is not a date!</div><div ng-message=\"required\" class=\"date-error\">This date is required!</div></div>\n</md-input-container><div layout-gt-xs=\"row\"><div class=\"md-block\" flex-gt-xs><label class=\"label-info-personal\">\nPastor Name</label><div class=\"value-info-personal\">{{vm.name}}</div></div><div class=\"md-block\" flex-gt-xs><label \nclass=\"label-info-personal\">Base - District</label><div class=\"value-info-personal\">{{vm.base}}</div></div></div><div \nclass=\"mt-30\"><table class=\"table mb-0\"><tr><td class=\"v-middle\">Attendance:</td><td><md-input-container \nclass=\"md-block mb-0 mt-0\"><md-radio-group layout=\"row\" name=\"attendance\" required \nng-disabled=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\"><md-checkbox \nng-model=\"vm.thrive.is_meeting\" class=\"ml-16\">Meeting</md-checkbox><md-checkbox ng-model=\"vm.thrive.is_training\" \nclass=\"ml-16\">Training</md-checkbox></md-radio-group><div ng-messages=\"thriveForm.attendance.$error\" \nng-show=\"thriveForm.attendance.$touched || thriveForm.$submitted\" role=\"alert\"><div ng-message=\"required\" \nng-hide=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\"><span>Required</span></div></div>\n</md-input-container></td></tr><tr><td class=\"v-middle\">How many Lay Leaders did you bring?</td><td><md-input-container\n class=\"md-block mb-0\"><input name=\"timothys\" ng-model=\"vm.thrive.no_of_timothy\" type=\"number\" min=\"0\" \nng-disabled=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\" required><div \nng-messages=\"thriveForm.timothys.$error\" \nng-show=\"thriveForm.timothys.$touched\r\n                                             || thriveForm.$submitted\" \nrole=\"alert\" ng-hide=\"currentUser.$roles.has([\'area_head\', \'branch_head\', \'view_only\'])\"><div ng-message=\"required\">\n<span>Required</span></div><div ng-message=\"number\"><span>Invalid number</span></div><div ng-message=\"min\">\nInvalid number</div></div></md-input-container></td></tr><tr><td class=\"v-middle\">How many adults attended last Sunday\n</td><td><md-input-container class=\"md-block mb-0\"><input name=\"adults\" ng-model=\"vm.thrive.adults_last_sunday\" \ntype=\"number\" min=\"0\" required><div ng-messages=\"editThriveForm.adults.$error\" \nng-show=\"editThriveForm.adults.$touched\r\n                                     || editThriveForm.$submitted\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-message=\"number\"><span>Invalid number</span>\n</div><div ng-message=\"min\">Invalid number</div></div></md-input-container></td></tr><tr><td class=\"v-middle\">\nHow many kids(13 and under) attended last Sunday?</td><td><md-input-container class=\"md-block mb-0\"><input name=\"kids\" \nng-model=\"vm.thrive.kids_last_sunday\" type=\"number\" min=\"0\" required><div ng-messages=\"editThriveForm.kids.$error\" \nng-show=\"editThriveForm.kids.$touched\r\n                                     || editThriveForm.$submitted\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div><div ng-message=\"number\"><span>Invalid number</span></div><div \nng-message=\"min\">Invalid number</div></div></md-input-container></td></tr><tr><td class=\"v-middle\">\nWhat was the total offering last Sunday?</td><td><md-input-container class=\"md-block mb-0\"><input name=\"offering\" \nng-model=\"vm.thrive.offerings_last_sunday\" type=\"number\" min=\"0\" required><div \nng-messages=\"editThriveForm.offering.$error\" \nng-show=\"editThriveForm.offering.$touched\r\n                                     || editThriveForm.$submitted\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-message=\"number\"><span>Invalid number</span>\n</div><div ng-message=\"min\">Invalid number</div></div></md-input-container></td></tr><tr><td class=\"v-middle\">\nAttended Thrive Health Check</td><td><md-checkbox class=\"ml-16\" ng-model=\"vm.thrive.health_check\"></md-checkbox></td>\n</tr></table></div></md-dialog-content><md-dialog-actions><md-button md-no-ink type=\"reset\" \nng-click=\"vm.resetForm(editThriveForm, vm)\" class=\"md-primary cancel-button\" aria-label=\"CLEAR\">CLEAR</md-button>\n<md-button type=\"submit\" \nng-disabled=\"editThriveForm.$invalid\r\n                       || editThriveForm.$pristine || vm.saving || (!vm.thrive.is_meeting && !vm.thrive.is_training)\" \nclass=\"md-accent md-raised pull-right\"><span ng-show=\"!vm.saving\">SAVE</span> <span ng-show=\"vm.saving\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting</span></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/thrive/tabs/pastors/dialogs/edit-pastor/edit-pastor-dialog.html","<md-dialog class=\"edit-user-dialog pastor-dialog transform-dialog\"><form name=\"pastorForm\" class=\"md-inline-form\" \nng-submit=\"vm.editPastor(vm.pastor.id, vm.pastor, pastorForm)\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><h2>Personal Information</h2><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block mb-0\" flex-gt-xs><input name=\"firstname\" ng-model=\"vm.pastor.firstname\" placeholder=\"First Name\" \ntype=\"text\" class=\"pastor\" md-autofocus maxlength=\"30\" required><div ng-messages=\"pastorForm.firstname.$error\" \nng-show=\"pastorForm.firstname.$touched\r\n                         || vm.apiErrors.firstname\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-message=\"maxlength\"><span>Exceeds limit</span></div><div \nng-bind=\"vm.apiErrors.firstname\"></div></div></md-input-container><md-input-container class=\"md-block mb-0\" flex-gt-xs>\n<input name=\"middlename\" ng-model=\"vm.pastor.middlename\" placeholder=\"Middle Name\" type=\"text\" class=\"pastor\" \nmaxlength=\"30\" required><div ng-messages=\"pastorForm.middlename.$error\" \nng-show=\"pastorForm.middlename.$touched\r\n                         || vm.apiErrors.middlename\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-message=\"maxlength\"><span>Exceeds limit</span></div><div \nng-bind=\"vm.apiErrors.middlename\"></div></div></md-input-container><md-input-container class=\"md-block mb-0\" \nflex-gt-xs><input name=\"lastname\" ng-model=\"vm.pastor.lastname\" placeholder=\"Last Name\" type=\"text\" class=\"pastor\" \nmaxlength=\"30\" required><div ng-messages=\"pastorForm.lastname.$error\" \nng-show=\"pastorForm.lastname.$touched\r\n                         || vm.apiErrors.lastname\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-message=\"maxlength\"><span>Exceeds limit</span></div><div \nng-bind=\"vm.apiErrors.lastname\"></div></div></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-xs><label>Birthday</label><md-datepicker ng-model=\"vm.pastor.birth_date\" name=\"birth_date\" \nmd-open-on-focus md-placeholder=\"Birthday\" md-input-name=\"birth_date\" required></md-datepicker><div \nng-messages=\"pastorForm.birth_date.$error\" \nng-show=\"pastorForm.birth_date.$touched\r\n                         || vm.apiErrors.birth_date\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.birth_date\"></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-xs><label>Gender</label><md-select name=\"gender\" \nng-disabled=\"!vm.gender.length\" ng-model=\"vm.pastor.gender\" placeholder=\"Gender\" required><md-option \nng-value=\"status.value\" ng-repeat=\"status in vm.gender\">{{ status.label }}</md-option></md-select><div \nng-messages=\"pastorForm.gender.$error\" \nng-show=\"pastorForm.gender.$touched\r\n                         || vm.apiErrors.gender\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.gender\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-xs><label>Marital Status</label><md-select name=\"status\" \nng-disabled=\"!vm.marital_status.length\" ng-model=\"vm.pastor.status\" placeholder=\"Marital Status\" required><md-option \nng-value=\"status.value\" ng-repeat=\"status in vm.marital_status\">{{ status.label }}</md-option></md-select><div \nng-messages=\"pastorForm.status.$error\" \nng-show=\"pastorForm.status.$touched\r\n                         || vm.apiErrors.status\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.status\"></div></div></md-input-container>\n</div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"email\" \nng-model=\"vm.pastor.email\" placeholder=\"Email Address\" type=\"text\" class=\"pastor\" ng-pattern=\"/^.+@.+\\..+$/\"><div \nng-messages=\"pastorForm.email.$error\" \nng-show=\"pastorForm.email.$touched\r\n                         || vm.apiErrors.email\" role=\"alert\"><div \nng-message=\"pattern\"><span>Must be a valid email address.</span></div><div ng-bind=\"vm.apiErrors.email\"></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-xs><label>Educational Attainment</label><md-select \nname=\"educational_attainment\" ng-disabled=\"!vm.educational_attainment.length\" \nng-model=\"vm.pastor.educational_attainment\" placeholder=\"Educational Attainment\" required><md-option \nng-value=\"status.value\" ng-repeat=\"status in vm.educational_attainment\">{{ status.label }}</md-option></md-select><div \nng-messages=\"pastorForm.educational_attainment.$error\" \nng-show=\"pastorForm.educational_attainment.$touched\r\n                         || vm.apiErrors.educational_attainment\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.educational_attainment\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-xs><label>Attended Seminary</label>\n<md-select name=\"seminary\" ng-disabled=\"!vm.yesno.length\" ng-model=\"vm.pastor.seminary\" \nplaceholder=\"Attended Seminary\" required><md-option ng-value=\"option.value\" ng-repeat=\"option in vm.yesno\">\n{{ option.label }}</md-option></md-select><div ng-messages=\"pastorForm.seminary.$error\" \nng-show=\"pastorForm.seminary.$touched\r\n                         || vm.apiErrors.seminary\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.seminary\"></div></div></md-input-container>\n</div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex=\"35\"><label>Is a member</label><md-select \nname=\"member\" disabled=\"disabled\" ng-model=\"vm.pastor.is_member\" placeholder=\"Is a member\"><md-option \nng-value=\"option.value\" ng-repeat=\"option in vm.yesno\">{{ option.label }}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex=\"35\"><label>Is Active</label><md-select name=\"active\" disabled=\"disabled\" \nng-model=\"vm.pastor.active\" placeholder=\"Is Active\"><md-option ng-value=\"option.value\" ng-repeat=\"option in vm.yesno\">\n{{ option.label }}</md-option></md-select></md-input-container></div><h2>Address</h2><div layout-gt-xs=\"row\">\n<md-input-container style=\"width: 100%\"><label>Country</label><md-select ng-model=\"vm.pastor.country_code\" \nng-change=\"vm.handleCountryChange(vm.pastor.country_code)\" required><md-option ng-value=\"country.id\" \nng-repeat=\"country in vm.countrys\">{{country.name}}</md-option></md-select><div class=\"errors\" \nng-messages=\"pastorForm.country_code.$error || vm.apiErrors.country_code\" \nng-show=\"pastorForm.country_code.$touched || vm.apiErrors.country_code\"><div ng-message=\"required\">Required</div><div \nng-bind=\"vm.apiErrors.country_code\"></div></div></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block mb-10\" flex><label>Base</label><md-select name=\"base\" \nng-disabled=\"!vm.bases.length || vm.currentUser.base_id || !vm.pastor.country_code\" ng-model=\"vm.pastor.base_id\" \nplaceholder=\"Base\" ng-change=\"vm.handleChangeBase()\" required><md-option ng-value=\"base.id\" \nng-click=\"vm.selectBase(base)\" ng-repeat=\"base in vm.bases\">{{ base.name }}</md-option></md-select><div \nng-messages=\"pastorForm.base.$error\" \nng-show=\"pastorForm.base.$touched\r\n                         || vm.apiErrors.base_id\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.base_id\"></div></div></md-input-container>\n<md-input-container class=\"md-block mb-10\" flex><label>District</label><md-select name=\"district\" \nng-disabled=\"!vm.pastor.base.districts.length\" ng-model=\"vm.pastor.district_id\" placeholder=\"District\" required>\n<md-option ng-value=\"district.id\" ng-repeat=\"district in vm.pastor.base.districts\">{{ district.name }}</md-option>\n</md-select><div ng-messages=\"pastorForm.district.$error\" \nng-show=\"pastorForm.district.$touched\r\n                         || vm.apiErrors.district_id\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.district_id\"></div></div>\n</md-input-container></div><div layout-gt-xs=\"row\"><md-autocomplete flex required md-input-name=\"province\" \nmd-selected-item=\"vm.pastor.province\" md-selected-item-change=\"vm.selectProvince(province)\" \nmd-search-text=\"vm.searchProvince\" md-items=\"province in vm.searchProvinces(vm.searchProvince)\" \nmd-item-text=\"province.name\" md-no-cache=\"1\" md-require-match md-floating-label=\"Province\" \nng-disabled=\"!vm.pastor.base_id\" md-min-length=\"0\"><md-item-template><span md-highlight-text=\"vm.searchProvince\">\n{{province.name}}</span></md-item-template><div class=\"errors\" \nng-messages=\"pastorForm.province.$error\r\n                         || vm.apiErrors.province_id\" \nng-if=\"pastorForm.province.$touched\r\n                         || pastorForm.$submitted\"><div ng-message=\"required\">\nRequired</div><div ng-message=\"md-require-match\">Please select an province.</div><div \nng-bind=\"vm.apiErrors.province_id\"></div></div></md-autocomplete><md-autocomplete flex required md-input-name=\"city\" \nmd-selected-item=\"vm.pastor.city\" md-selected-item-change=\"vm.selectCity(city)\" md-search-text=\"vm.searchCity\" \nmd-items=\"city in vm.searchCities(vm.searchCity)\" md-item-text=\"city.name\" md-no-cache=\"1\" md-require-match \nmd-floating-label=\"City\" ng-disabled=\"!vm.pastor.province_id\" md-min-length=\"0\"><md-item-template><span \nmd-highlight-text=\"vm.searchCity\">{{city.name}}</span></md-item-template><div class=\"errors\" \nng-messages=\"pastorForm.city.$error\" ng-if=\"pastorForm.city.$touched || pastorForm.$submitted\"><div \nng-message=\"required\">Required</div><div ng-message=\"md-require-match\">Please select an city.</div></div>\n</md-autocomplete><md-autocomplete flex required md-input-name=\"barangay\" md-selected-item=\"vm.pastor.barangay\" \nmd-selected-item-change=\"vm.selectBarangay(barangay)\" md-search-text=\"vm.searchBarangay\" \nmd-items=\"barangay in vm.searchBarangays(vm.searchBarangay)\" md-item-text=\"barangay.name\" md-no-cache=\"1\" \nmd-require-match md-floating-label=\"Barangay\" ng-disabled=\"!vm.pastor.city_id\" md-min-length=\"0\"><md-item-template>\n<span md-highlight-text=\"vm.searchBarangay\">{{barangay.name}}</span></md-item-template><div class=\"errors\" \nng-messages=\"pastorForm.barangay.$error\" \nng-if=\"pastorForm.barangay.$touched\r\n                         || pastorForm.$submitted\"><div ng-message=\"required\">\nRequired</div><div ng-message=\"md-require-match\">Please select an barangay.</div></div></md-autocomplete></div>\n<md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"address\" ng-model=\"vm.pastor.address\" \nplaceholder=\"Other/More Address\" type=\"text\" maxlength=\"120\" class=\"pastor\"><div \nng-messages=\"pastorForm.address.$error\" ng-show=\"pastorForm.address.$touched || vm.apiErrors.address\" role=\"alert\"><div\n ng-bind=\"vm.apiErrors.address\"></div></div></md-input-container><h2>Contact Information</h2><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"messenger_id\" ng-model=\"vm.pastor.messenger_id\" \nplaceholder=\"Messenger ID\" type=\"text\" maxlength=\"15\" class=\"pastor\"><div ng-messages=\"pastorForm.messenger_id.$error\" \nng-show=\"pastorForm.messenger_id.$touched\r\n                        || vm.errorMessager\" role=\"alert\"><div \nng-bind=\"vm.errorMessager\"></div></div></md-input-container><md-input-container class=\"md-block mb-0\" flex-gt-xs>\n<label>Smartphone</label><md-select name=\"has_smartphone\" ng-disabled=\"!vm.yesno.length\" \nng-model=\"vm.pastor.has_smartphone\" placeholder=\"Smartphone\" required><md-option ng-value=\"option.value\" \nng-repeat=\"option in vm.yesno\">{{ option.label }}</md-option></md-select><div \nng-messages=\"pastorForm.has_smartphone.$error\" \nng-show=\"pastorForm.has_smartphone.$touched\r\n                         || vm.apiErrors.has_smartphone\" role=\"alert\"><div\n ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.has_smartphone\"></div></div>\n</md-input-container></div><h2>Go Viral Pastor Mentor</h2><div layout-gt-xs=\"row\"><md-autocomplete flex \nmd-input-name=\"selectGoViralPastorMentor\" md-selected-item=\"vm.pastor.selectGoViralPastorMentor\" \nmd-selected-item-change=\"vm.selectGoViralPastorMentor(pastor)\" md-search-text=\"vm.searchGoViralPastorMentor\" \nmd-items=\"pastor in vm.searchGoViralPastorMentors(vm.searchGoViralPastorMentor)\" \nmd-item-text=\"pastor.firstname+\' \'+pastor.lastname+ \' (\' +pastor.id+ \')\'\" md-require-match md-min-length=\"0\" \nmd-floating-label=\"Pastor Name or ID\"><md-item-template><span md-highlight-text=\"vm.searchGoViralPastorMentor\">\n{{pastor.firstname}} {{pastor.lastname}} - {{pastor.id}}</span></md-item-template><div class=\"errors\" \nng-messages=\"pastorForm.selectGoViralPastorMentor.$error\" \nng-if=\"pastorForm.selectGoViralPastorMentor.$touched\r\n                         || pastorForm.$submitted\"><div \nng-message=\"md-require-match\">Please select a pastor.</div></div></md-autocomplete></div></md-dialog-content>\n<md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"pastorForm.$invalid || vm.saving\" type=\"submit\"><span ng-show=\"!vm.saving\">Update Pastor</span> <span \nng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting\n</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/thrive/tabs/pastors/dialogs/new-pastor/new-pastor-dialog.html","<md-dialog class=\"new-user-dialog pastor-dialog transform-dialog\"><form name=\"pastorForm\" class=\"md-inline-form\" \nng-submit=\"vm.addNewPastor(vm.pastor, pastorForm)\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><h2>Personal Information</h2><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block mb-0\" flex-gt-xs><input name=\"firstname\" ng-model=\"vm.pastor.firstname\" placeholder=\"First Name\" \ntype=\"text\" class=\"pastor\" md-autofocus maxlength=\"30\" required><div ng-messages=\"pastorForm.firstname.$error\" \nng-show=\"pastorForm.firstname.$touched\r\n                         || vm.apiErrors.firstname\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-message=\"maxlength\"><span>Exceeds limit</span></div><div \nng-bind=\"vm.apiErrors.firstname\"></div></div></md-input-container><md-input-container class=\"md-block mb-0\" flex-gt-xs>\n<input name=\"middlename\" ng-model=\"vm.pastor.middlename\" placeholder=\"Middle Name\" type=\"text\" class=\"pastor\" \nmaxlength=\"30\" required><div ng-messages=\"pastorForm.middlename.$error\" \nng-show=\"pastorForm.middlename.$touched\r\n                         || vm.apiErrors.middlename\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-message=\"maxlength\"><span>Exceeds limit</span></div><div \nng-bind=\"vm.apiErrors.middlename\"></div></div></md-input-container><md-input-container class=\"md-block mb-0\" \nflex-gt-xs><input name=\"lastname\" ng-model=\"vm.pastor.lastname\" placeholder=\"Last Name\" type=\"text\" maxlength=\"30\" \nclass=\"pastor\" required><div ng-messages=\"pastorForm.lastname.$error\" \nng-show=\"pastorForm.lastname.$touched\r\n                         || vm.apiErrors.lastname\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-message=\"maxlength\"><span>Exceeds limit</span></div><div \nng-bind=\"vm.apiErrors.lastname\"></div></div></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-xs><label>Birthday</label><md-datepicker ng-model=\"vm.pastor.birth_date\" name=\"birth_date\" \nmd-open-on-focus md-placeholder=\"Birthday\" md-input-name=\"birth_date\" required></md-datepicker><div \nng-messages=\"pastorForm.birth_date.$error\" \nng-show=\"pastorForm.birth_date.$touched\r\n                         || vm.apiErrors.birth_date\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.birth_date\"></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-xs><label>Gender</label><md-select name=\"gender\" \nng-disabled=\"!vm.gender.length\" ng-model=\"vm.pastor.gender\" placeholder=\"Gender\" required><md-option \nng-value=\"status.value\" ng-repeat=\"status in vm.gender\">{{ status.label }}</md-option></md-select><div \nng-messages=\"pastorForm.gender.$error\" \nng-show=\"pastorForm.gender.$touched\r\n                         || vm.apiErrors.gender\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.gender\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-xs><label>Marital Status</label><md-select name=\"status\" \nng-disabled=\"!vm.marital_status.length\" ng-model=\"vm.pastor.status\" placeholder=\"Marital Status\" required><md-option \nng-value=\"status.value\" ng-repeat=\"status in vm.marital_status\">{{ status.label }}</md-option></md-select><div \nng-messages=\"pastorForm.status.$error\" \nng-show=\"pastorForm.status.$touched\r\n                         || vm.apiErrors.status\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.status\"></div></div></md-input-container>\n</div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"email\" \nng-model=\"vm.pastor.email\" placeholder=\"Email Address\" type=\"text\" class=\"pastor\" ng-pattern=\"/^.+@.+\\..+$/\"><div \nng-messages=\"pastorForm.email.$error\" \nng-show=\"pastorForm.email.$touched\r\n                         || vm.apiErrors.email\" role=\"alert\"><div \nng-message=\"pattern\"><span>Must be a valid email address.</span></div><div ng-bind=\"vm.apiErrors.email\"></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-xs><label>Educational Attainment</label><md-select \nname=\"educational_attainment\" ng-disabled=\"!vm.educational_attainment.length\" \nng-model=\"vm.pastor.educational_attainment\" placeholder=\"Educational Attainment\" required><md-option \nng-value=\"status.value\" ng-repeat=\"status in vm.educational_attainment\">{{ status.label }}</md-option></md-select><div \nng-messages=\"pastorForm.educational_attainment.$error\" \nng-show=\"pastorForm.educational_attainment.$touched\r\n                         || vm.apiErrors.educational_attainment\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.educational_attainment\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-xs><label>Attended Seminary</label>\n<md-select name=\"seminary\" ng-disabled=\"!vm.yesno.length\" ng-model=\"vm.pastor.seminary\" \nplaceholder=\"Attended Seminary\" required><md-option ng-value=\"option.value\" ng-repeat=\"option in vm.yesno\">\n{{ option.label }}</md-option></md-select><div ng-messages=\"pastorForm.seminary.$error\" \nng-show=\"pastorForm.seminary.$touched\r\n                         || vm.apiErrors.seminary\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.seminary\"></div></div></md-input-container>\n</div><h2>Address</h2><div layout-gt-xs=\"row\"><md-input-container style=\"width: 100%\"><label>Country</label><md-select \nng-model=\"vm.pastor.country_code\" ng-change=\"vm.handleCountryChange(vm.pastor.country_code)\" required><md-option \nng-value=\"country.id\" ng-repeat=\"country in vm.countrys\">{{country.name}}</md-option></md-select><div class=\"errors\" \nng-messages=\"pastorForm.country_code.$error || vm.apiErrors.country_code\" \nng-show=\"pastorForm.country_code.$touched || vm.apiErrors.country_code\"><div ng-message=\"required\">Required</div><div \nng-bind=\"vm.apiErrors.country_code\"></div></div></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block mb-10\" flex><label>Base</label><md-select name=\"base\" \nng-disabled=\"!vm.bases.length || vm.currentUser.base_id || !vm.pastor.country_code\" ng-model=\"vm.pastor.base\" \nplaceholder=\"Base\" ng-change=\"vm.manageGoTOViralPastor(\'base\')\" required><md-option ng-value=\"base\" \nng-repeat=\"base in vm.bases\">{{ base.name }}</md-option></md-select><div ng-messages=\"pastorForm.base.$error\" \nng-show=\"pastorForm.base.$touched\r\n                         || vm.apiErrors.base_id\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.base_id\"></div></div></md-input-container>\n<md-input-container class=\"md-block mb-10\" flex><label>District</label><md-select name=\"district\" \nng-disabled=\"!vm.pastor.base.districts.length\" ng-model=\"vm.pastor.district\" placeholder=\"District\" \nng-change=\"vm.manageGoTOViralPastor()\" required><md-option ng-value=\"district\" \nng-repeat=\"district in vm.pastor.base.districts\">{{ district.name }}</md-option></md-select><div \nng-messages=\"pastorForm.district.$error\" \nng-show=\"pastorForm.district.$touched\r\n                         || vm.apiErrors.district_id\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.district_id\"></div></div>\n</md-input-container></div><div layout-gt-xs=\"row\"><md-autocomplete flex required md-input-name=\"province\" \nmd-selected-item=\"vm.pastor.province\" md-selected-item-change=\"vm.selectProvince(province)\" \nmd-search-text=\"vm.searchProvince\" md-items=\"province in vm.searchProvinces(vm.searchProvince)\" \nmd-item-text=\"province.name\" md-no-cache=\"1\" md-require-match md-floating-label=\"Province\" \nng-disabled=\"!vm.pastor.base\" md-min-length=\"0\"><md-item-template><span md-highlight-text=\"vm.searchProvince\">\n{{province.name}}</span></md-item-template><div class=\"errors\" \nng-messages=\"pastorForm.province.$error\r\n                         || vm.apiErrors.province_id\" \nng-if=\"pastorForm.province.$touched\r\n                         || pastorForm.$submitted\"><div ng-message=\"required\">\nRequired</div><div ng-message=\"md-require-match\">Please select a province.</div><div \nng-bind=\"vm.apiErrors.province_id\"></div></div></md-autocomplete><md-autocomplete flex required md-input-name=\"city\" \nmd-selected-item=\"vm.pastor.city\" md-selected-item-change=\"vm.selectCity(city)\" md-search-text=\"vm.searchCity\" \nmd-items=\"city in vm.searchCities(vm.searchCity)\" md-item-text=\"city.name\" md-no-cache=\"1\" md-require-match \nmd-floating-label=\"City\" ng-disabled=\"!vm.pastor.province_id\" md-min-length=\"0\"><md-item-template><span \nmd-highlight-text=\"vm.searchCity\">{{city.name}}</span></md-item-template><div class=\"errors\" \nng-messages=\"pastorForm.city.$error\" \nng-if=\"pastorForm.city.$touched\r\n                         || pastorForm.$submitted\"><div ng-message=\"required\">Required\n</div><div ng-message=\"md-require-match\">Please select a city.</div></div></md-autocomplete><md-autocomplete flex \nrequired md-input-name=\"barangay\" md-selected-item=\"vm.pastor.barangay\" \nmd-selected-item-change=\"vm.selectBarangay(barangay)\" md-search-text=\"vm.searchBarangay\" \nmd-items=\"barangay in vm.searchBarangays(vm.searchBarangay)\" md-item-text=\"barangay.name\" md-no-cache=\"1\" \nmd-require-match md-floating-label=\"Barangay\" ng-disabled=\"!vm.pastor.city_id\" md-min-length=\"0\"><md-item-template>\n<span md-highlight-text=\"vm.searchBarangay\">{{barangay.name}}</span></md-item-template><div class=\"errors\" \nng-messages=\"pastorForm.barangay.$error\" \nng-if=\"pastorForm.barangay.$touched\r\n                         || pastorForm.$submitted\"><div ng-message=\"required\">\nRequired</div><div ng-message=\"md-require-match\">Please select a barangay.</div></div></md-autocomplete></div>\n<md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"address\" ng-model=\"vm.pastor.address\" \nplaceholder=\"Other/More Address\" type=\"text\" maxlength=\"120\" class=\"pastor\"><div \nng-messages=\"pastorForm.address.$error\" \nng-show=\"pastorForm.address.$touched\r\n                     || vm.apiErrors.address\" role=\"alert\"><div \nng-bind=\"vm.apiErrors.address\"></div></div></md-input-container><h2>Contact Information</h2><div layout-gt-xs=\"row\">\n<md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"messengerId\" ng-model=\"vm.pastor.messengerId\" \nplaceholder=\"Messenger ID\" type=\"text\" maxlength=\"15\" class=\"pastor\"><div ng-messages=\"pastorForm.messengerId.$error\" \nng-show=\"pastorForm.messengerId.$touched\r\n                        || vm.errorMessager\" role=\"alert\"><div \nng-bind=\"vm.errorMessager\"></div></div></md-input-container><md-input-container class=\"md-block mb-0\" flex-gt-xs>\n<label>Smartphone</label><md-select name=\"hasSmartphone\" ng-disabled=\"!vm.yesno.length\" \nng-model=\"vm.pastor.hasSmartphone\" placeholder=\"Smartphone\" required><md-option ng-value=\"option.value\" \nng-repeat=\"option in vm.yesno\">{{ option.label }}</md-option></md-select><div \nng-messages=\"pastorForm.hasSmartphone.$error\" \nng-show=\"pastorForm.hasSmartphone.$touched\r\n                         || vm.apiErrors.hasSmartphone\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.hasSmartphone\"></div></div>\n</md-input-container></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block mb-0\" flex-gt-xs><input \nname=\"contacts1\" ng-model=\"vm.pastor.contacts1\" placeholder=\"Contact No. 1\" type=\"text\" maxlength=\"15\" class=\"pastor\">\n<div ng-messages=\"pastorForm.contacts1.$error\" \nng-show=\"pastorForm.contacts1.$touched\r\n                            || vm.errorPhone1\" role=\"alert\"><div \nng-bind=\"vm.errorPhone1\"></div></div></md-input-container><md-input-container class=\"md-block mb-0\" flex-gt-xs><input \nname=\"contacts2\" ng-model=\"vm.pastor.contacts2\" placeholder=\"Contact No. 2\" type=\"text\" maxlength=\"15\" class=\"pastor\">\n<div ng-messages=\"pastorForm.contacts2.$error\" \nng-show=\"pastorForm.contacts2.$touched\r\n                         || vm.errorPhone2\" role=\"alert\"><div \nng-bind=\"vm.errorPhone2\"></div></div></md-input-container><md-input-container class=\"md-block mb-0\" flex-gt-xs><input \nname=\"contacts3\" ng-model=\"vm.pastor.contacts3\" placeholder=\"Contact No. 3\" type=\"text\" maxlength=\"15\" class=\"pastor\">\n<div ng-messages=\"pastorForm.contacts3.$error\" \nng-show=\"pastorForm.contacts3.$touched\r\n                         || vm.errorPhone3\" role=\"alert\"><div \nng-bind=\"vm.errorPhone3\"></div></div></md-input-container></div><h2>Church Information</h2><div layout-gt-xs=\"row\">\n<md-autocomplete flex md-input-name=\"church\" md-selected-item=\"vm.pastor.church\" \nmd-selected-item-change=\"vm.selectChurch(church)\" md-search-text=\"vm.searchChurch\" \nmd-items=\"church in vm.searchChurches(vm.searchChurch)\" \nmd-item-text=\"church.id + \' \' + church.name + \' - \' + church.city.name + \', \' + church.province.name\" md-no-cache=\"1\" \nmd-require-match md-floating-label=\"Church\"><md-item-template><span md-highlight-text=\"vm.searchChurch\">\n{{church.id}} {{church.name}} - {{church.city.name}}, {{church.province.name}}</span></md-item-template><div \nclass=\"errors\" ng-messages=\"pastorForm.church.$error\" \nng-if=\"pastorForm.church.$touched\r\n                         || pastorForm.$submitted\"><div \nng-message=\"md-require-match\">Please select a church.</div></div></md-autocomplete><md-input-container \nclass=\"md-block\" ng-hide=\"vm.pastor.position === \'other\'\" flex=\"35\"><label>Position</label><md-select name=\"position\" \nng-disabled=\"!vm.church_position.length\" ng-model=\"vm.pastor.position\" placeholder=\"Position\"><md-option \nng-value=\"status.value\" ng-repeat=\"status in vm.church_position\">{{ status.label }}</md-option></md-select><div \nng-messages=\"pastorForm.position.$error\" \nng-show=\"pastorForm.position.$touched\r\n                         || vm.apiErrors.church_position\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.church_position\"></div></div>\n</md-input-container><md-input-container class=\"md-block mb-0\" ng-show=\"vm.pastor.position === \'other\'\" flex=\"35\">\n<input name=\"otherposition\" ng-model=\"vm.pastor.otherposition\" placeholder=\"Position\" type=\"text\" maxlength=\"120\" \nclass=\"pastor\"></md-input-container><md-button md-no-ink flex=\"15\" ng-show=\"vm.pastor.position === \'other\'\" \nclass=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.pastor.position=\'\'\">Cancel</md-button></div><h2>\nGo Viral Pastor Mentor</h2><div layout-gt-xs=\"row\"><md-autocomplete flex md-input-name=\"selectGoViralPastorMentor\" \nmd-selected-item=\"vm.pastor.selectGoViralPastorMentor\" md-selected-item-change=\"vm.selectGoViralPastorMentor(pastor)\" \nmd-search-text=\"vm.searchGoViralPastorMentor\" \nmd-items=\"pastor in vm.searchGoViralPastorMentors(vm.searchGoViralPastorMentor)\" \nmd-item-text=\"pastor.firstname+\' \'+pastor.lastname+ \' (\' +pastor.id+ \')\'\" md-require-match \nmd-floating-label=\"Pastor Name or ID\" md-min-length=\"0\"><md-item-template><span \nmd-highlight-text=\"vm.searchGoViralPastorMentor\">{{pastor.firstname}} {{pastor.lastname}} - {{pastor.id}}</span>\n</md-item-template><div class=\"errors\" ng-messages=\"pastorForm.selectGoViralPastorMentor.$error\" \nng-if=\"pastorForm.selectGoViralPastorMentor.$touched\r\n                         || pastorForm.$submitted\"><div \nng-message=\"md-require-match\">Please select a pastor.</div></div></md-autocomplete></div></md-dialog-content>\n<md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"pastorForm.$invalid || vm.saving\" type=\"submit\"><span ng-show=\"!vm.saving\">Create Pastor</span> <span \nng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting\n</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/thrive/tabs/pastors/bottom-sheets/pastor-details/pastor-details.html","<md-bottom-sheet class=\"md-list cover-parent\" flex=\"100\"><div class=\"deleted-application-slider-container\" \nstyle=\"padding-left: 16%\"><div class=\"pastor-details-slider-card\"><form name=\"pastorDetailsForm\" \nclass=\"md-inline-form\" novalidate><div class=\"slider-header\"><div class=\"left\" flex=\"70\"><div class=\"part\"><h4>\n{{vm.pastor.firstname + \' \' + vm.pastor.lastname}}</h4><h5>Pastor</h5></div></div><md-button \nng-click=\"vm.closeBottomSheet()\" md-no-ink class=\"md-primary deleted-application-close-button edit-pastor\" \naria-label=\"DROP\"><i class=\"icon-close\"></i></md-button><div class=\"right\" flex=\"30\"><md-button \nclass=\"md-accent md-raised\" \nng-show=\"(currentUser.$roles.has([\'admin\'])  || vm.userCountry !== \'PH\') && !vm.clickedEdit\" ng-click=\"vm.setFocus()\">\nEDIT PASTOR</md-button><md-button class=\"md-accent md-raised\" ng-disabled=\"vm.saving || pastorDetailsForm.$invalid\" \nng-show=\"currentUser.$roles.has([\'admin\']) || vm.userCountry !== \'PH\' && vm.clickedEdit\" \nng-click=\"vm.editPastor(vm.pastor, pastorDetailsForm)\"><span ng-show=\"!vm.saving\">SAVE</span> <span \nng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting\n</span></md-button></div></div><div class=\"slider-body\" ng-style=\"{\'height\': vm.sliderHeight + \'px\' }\"><div \nclass=\"slider-body-container\"><md-content class=\"pastor-content\"><h2>Personal Information</h2><div layout-gt-xs=\"row\">\n<div class=\"md-block\" flex-gt-xs ng-show=\"!vm.clickedEdit\"><label class=\"label-info-personal\">First Name</label><div \nclass=\"value-info-personal\">{{vm.pastor.firstname}}</div></div><div class=\"md-block\" flex-gt-xs \nng-show=\"!vm.clickedEdit\"><label class=\"label-info-personal\">Middle Name</label><div class=\"value-info-personal\">\n{{vm.pastor.middlename}}</div></div><div class=\"md-block\" flex-gt-xs ng-show=\"!vm.clickedEdit\"><label \nclass=\"label-info-personal\">Last Name</label><div class=\"value-info-personal\">{{vm.pastor.lastname}}</div></div>\n{{vm.focused}}<md-input-container class=\"md-block mb-0\" flex-gt-xs ng-show=\"vm.clickedEdit\"><input name=\"firstname\" \nng-model=\"vm.pastor.firstname\" placeholder=\"First Name\" type=\"text\" class=\"pastor\" id=\"pastor-name-details\" \nmaxlength=\"30\" required><div ng-messages=\"pastorDetailsForm.firstname.$error\" \nng-show=\"pastorDetailsForm.firstname.$touched\r\n                                         || vm.apiErrors.firstname\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-message=\"maxlength\"><span>Exceeds limit\n</span></div><div ng-bind=\"vm.apiErrors.firstname\"></div></div></md-input-container><md-input-container \nclass=\"md-block mb-0\" flex-gt-xs ng-show=\"vm.clickedEdit\"><input name=\"middlename\" ng-model=\"vm.pastor.middlename\" \nplaceholder=\"Middle Name\" type=\"text\" class=\"pastor\" maxlength=\"30\" required><div \nng-messages=\"pastorDetailsForm.middlename.$error\" \nng-show=\"pastorDetailsForm.middlename.$touched\r\n                                         || vm.apiErrors.middlename\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-message=\"maxlength\"><span>Exceeds limit\n</span></div><div ng-bind=\"vm.apiErrors.middlename\"></div></div></md-input-container><md-input-container \nclass=\"md-block mb-0\" flex-gt-xs ng-show=\"vm.clickedEdit\"><input name=\"lastname\" ng-model=\"vm.pastor.lastname\" \nplaceholder=\"Last Name\" type=\"text\" class=\"pastor\" maxlength=\"30\" required><div \nng-messages=\"pastorDetailsForm.lastname.$error\" \nng-show=\"pastorDetailsForm.lastname.$touched\r\n                                         || vm.apiErrors.lastname\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-message=\"maxlength\"><span>Exceeds limit\n</span></div><div ng-bind=\"vm.apiErrors.lastname\"></div></div></md-input-container></div><div layout-gt-xs=\"row\" \nng-show=\"!vm.clickedEdit\" class=\"mt-10\"><div class=\"md-block\" flex-gt-xs><label class=\"label-info-personal\">Birthdate\n</label><div class=\"value-info-personal\">{{vm.pastor.birth_date}}</div></div><div class=\"md-block\" flex-gt-xs><label \nclass=\"label-info-personal\">Gender</label><div class=\"value-info-personal\">{{vm.pastor.gender | capitalize}}</div>\n</div></div><div layout-gt-xs=\"row\" class=\"clicked\" ng-show=\"vm.clickedEdit\"><md-input-container class=\"md-block\" \nflex-gt-xs><label class=\"birthday-label\">Birthday</label><md-datepicker ng-model=\"vm.pastor.birth_date\" \nname=\"birth_date\" md-open-on-focus md-placeholder=\"Birthday\" md-input-name=\"birth_date\" required></md-datepicker><div \nng-messages=\"pastorDetailsForm.birth_date.$error\" \nng-show=\"pastorDetailsForm.birth_date.$touched\r\n                                         || vm.apiErrors.birth_date\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.birth_date\"></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-xs><label>Gender</label><md-select name=\"gender\" \nng-disabled=\"!vm.gender.length\" ng-model=\"vm.pastor.gender\" placeholder=\"Gender\" required><md-option \nng-value=\"status.value\" ng-repeat=\"status in vm.gender\">{{ status.label }}</md-option></md-select><div \nng-messages=\"pastorDetailsForm.gender.$error\" \nng-show=\"pastorDetailsForm.gender.$touched\r\n                                         || vm.apiErrors.gender\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.gender\"></div></div>\n</md-input-container></div><div layout-gt-xs=\"row\" ng-show=\"!vm.clickedEdit\" class=\"mt-10\"><div class=\"md-block\" \nflex-gt-xs><label class=\"label-info-personal\">Marital Status</label><div class=\"value-info-personal\">\n{{vm.pastor.status | capitalize}}</div></div><div class=\"md-block\" flex-gt-xs><label class=\"label-info-personal\">Email\n</label><div class=\"value-info-personal\">{{vm.pastor.email}}</div></div></div><div layout-gt-xs=\"row\" class=\"clicked\" \nng-show=\"vm.clickedEdit\"><md-input-container class=\"md-block\" flex-gt-xs><label>Marital Status</label><md-select \nname=\"status\" ng-disabled=\"!vm.marital_status.length\" ng-model=\"vm.pastor.status\" placeholder=\"Marital Status\" \nrequired><md-option ng-value=\"status.value\" ng-repeat=\"status in vm.marital_status\">{{ status.label }}</md-option>\n</md-select><div ng-messages=\"pastorDetailsForm.status.$error\" \nng-show=\"pastorDetailsForm.status.$touched\r\n                                         || vm.apiErrors.status\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.status\"></div></div>\n</md-input-container><md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"email\" \nng-model=\"vm.pastor.email\" placeholder=\"Email Address\" type=\"text\" class=\"pastor\" ng-pattern=\"/^.+@.+\\..+$/\"><div \nng-messages=\"pastorDetailsForm.email.$error\" \nng-show=\"pastorDetailsForm.email.$touched\r\n                                         || vm.apiErrors.email\" \nrole=\"alert\"><div ng-message=\"pattern\"><span>Must be a valid email address.</span></div><div \nng-bind=\"vm.apiErrors.email\"></div></div></md-input-container></div><div layout-gt-xs=\"row\" ng-show=\"!vm.clickedEdit\" \nclass=\"mt-10\"><div class=\"md-block\" flex-gt-xs><label class=\"label-info-personal\">Educational Attainment</label><div \nclass=\"value-info-personal\">{{vm.pastor.displayEducation_attainment.label}}</div></div><div class=\"md-block\" \nflex-gt-xs><label class=\"label-info-personal\">Attended Seminary</label><div class=\"value-info-personal\">\n{{vm.pastor.seminary === true ? \'Yes\' : \'No\'}}</div></div></div><div layout-gt-xs=\"row\" class=\"clicked\" \nng-show=\"vm.clickedEdit\"><md-input-container class=\"md-block\" flex-gt-xs><label>Educational Attainment</label>\n<md-select name=\"educational_attainment\" ng-disabled=\"!vm.educational_attainment.length\" \nng-model=\"vm.pastor.educational_attainment\" placeholder=\"Educational Attainment\" required><md-option \nng-value=\"status.value\" ng-repeat=\"status in vm.educational_attainment\">{{ status.label }}</md-option></md-select><div \nng-messages=\"pastorDetailsForm.educational_attainment.$error\" \nng-show=\"pastorDetailsForm.educational_attainment.$touched\r\n                                         || vm.apiErrors.educational_attainment\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.educational_attainment\">\n</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-xs><label>Attended Seminary</label>\n<md-select name=\"seminary\" ng-disabled=\"!vm.yesno.length\" ng-model=\"vm.pastor.seminary\" \nplaceholder=\"Attended Seminary\" required><md-option ng-value=\"option.value\" ng-repeat=\"option in vm.yesno\">\n{{ option.label }}</md-option></md-select><div ng-messages=\"pastorDetailsForm.seminary.$error\" \nng-show=\"pastorDetailsForm.seminary.$touched\r\n                                         || vm.apiErrors.seminary\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.seminary\"></div></div>\n</md-input-container></div><div layout-gt-xs=\"row\" ng-show=\"!vm.clickedEdit\" class=\"mt-10\"><div class=\"md-block\" \nflex-gt-xs><label class=\"label-info-personal\">Is a member</label><div class=\"value-info-personal\">\n{{vm.datacards.length > 2 ? \'Yes\' : \'No\'}}</div></div><div class=\"md-block\" flex-gt-xs><label \nclass=\"label-info-personal\">Is Active</label><div class=\"value-info-personal\">{{vm.pastor.is_active ? \'Yes\' : \'No\'}}\n</div></div></div><div layout-gt-xs=\"row\" ng-show=\"vm.clickedEdit\" class=\"mt-10\"><md-input-container class=\"md-block\" \nflex=\"35\"><label>Is a member</label><md-select name=\"member\" ng-model=\"vm.pastor.is_member\" disabled=\"disabled\" \nplaceholder=\"Is a member\" required><md-option ng-value=\"option.value\" ng-repeat=\"option in vm.yesno\">{{ option.label }}\n</md-option></md-select><div ng-messages=\"pastorForm.member.$error\" \nng-show=\"pastorForm.member.$touched\r\n                                         || vm.apiErrors.member\" role=\"alert\"><div\n ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.member\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex=\"35\"><label>Is Active</label><md-select name=\"active\" disabled=\"disabled\" \nng-model=\"vm.pastor.active\" placeholder=\"Is Active\" required><md-option ng-value=\"option.value\" \nng-repeat=\"option in vm.yesno\">{{ option.label }}</md-option></md-select><div ng-messages=\"pastorForm.active.$error\" \nng-show=\"pastorForm.active.$touched\r\n                                         || vm.apiErrors.active\" role=\"alert\"><div\n ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.active\"></div></div></md-input-container>\n</div><h2 class=\"mt-10\">Address</h2><div layout-gt-xs=\"row\" class=\"address-label mt-10\"><div class=\"md-block\" \nflex-gt-xs ng-show=\"!vm.clickedEdit\"><label class=\"label-info-personal\">Country</label><div \nclass=\"value-info-personal\">{{vm.countrysEnum[vm.pastor.country_code]}}</div></div><md-input-container \nstyle=\"width: 100%\" ng-show=\"vm.clickedEdit\"><label>Country</label><md-select ng-model=\"vm.pastor.country_code\" \nng-change=\"vm.handleCountryChange(vm.pastor.country_code)\" required><md-option ng-value=\"country.id\" \nng-repeat=\"country in vm.countrys\">{{country.name}}</md-option></md-select><div class=\"errors\" \nng-messages=\"pastorDetailsForm.country_code.$error || vm.apiErrors.country_code\" \nng-show=\"pastorDetailsForm.country_code.$touched || vm.apiErrors.country_code\"><div ng-message=\"required\">Required\n</div><div ng-bind=\"vm.apiErrors.country_code\"></div></div></md-input-container></div><div layout-gt-xs=\"row\" \nclass=\"mt-10\"><div class=\"md-block\" flex-gt-xs ng-show=\"!vm.clickedEdit\"><label class=\"label-info-personal\">Base\n</label><div class=\"value-info-personal\">{{vm.pastor.base.name}}</div></div><div class=\"md-block\" flex-gt-xs \nng-show=\"!vm.clickedEdit\"><label class=\"label-info-personal\">District</label><div class=\"value-info-personal\">\n{{vm.pastor.district.name}}</div></div><md-input-container class=\"md-block mb-10\" flex-gt-xs ng-show=\"vm.clickedEdit\">\n<label>Base</label><md-select name=\"base\" ng-disabled=\"!vm.bases.length || !vm.pastor.country_code\" \nng-model=\"vm.pastor.base_id\" placeholder=\"Base\" required><md-option ng-value=\"base.id\" ng-click=\"vm.selectBase(base)\" \nng-repeat=\"base in vm.bases\">{{ base.name }}</md-option></md-select><div ng-messages=\"pastorDetailsForm.base.$error\" \nng-show=\"pastorDetailsForm.base.$touched\r\n                                         || vm.apiErrors.base_id\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.base_id\"></div></div>\n</md-input-container><md-input-container class=\"md-block mb-10\" flex-gt-xs ng-show=\"vm.clickedEdit\"><label>District\n</label><md-select name=\"district\" ng-disabled=\"!vm.pastor.base.districts.length\" ng-model=\"vm.pastor.district_id\" \nplaceholder=\"District\" required><md-option ng-value=\"district.id\" ng-repeat=\"district in vm.pastor.base.districts\">\n{{ district.name }}</md-option></md-select><div ng-messages=\"pastorDetailsForm.district.$error\" \nng-show=\"pastorDetailsForm.district.$touched\r\n                                         || vm.apiErrors.district_id\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.district_id\"></div></div>\n</md-input-container></div><div layout-gt-xs=\"row\" ng-show=\"!vm.clickedEdit\" class=\"mt-10\"><div class=\"md-block\" \nflex-gt-xs ng-show=\"!vm.clickedEdit\"><label class=\"label-info-personal\">Province</label><div \nclass=\"value-info-personal\">{{vm.pastor.province.name}}</div></div><div class=\"md-block\" flex-gt-xs \nng-show=\"!vm.clickedEdit\"><label class=\"label-info-personal\">City</label><div class=\"value-info-personal\">\n{{vm.pastor.city.name}}</div></div><div class=\"md-block\" flex-gt-xs ng-show=\"!vm.clickedEdit\"><label \nclass=\"label-info-personal\">Barangay</label><div class=\"value-info-personal\">{{vm.pastor.barangay.name}}</div></div>\n</div><div layout-gt-xs=\"row\" class=\"mt-10\" ng-show=\"vm.clickedEdit\"><md-autocomplete flex required \nmd-input-name=\"province\" md-selected-item=\"vm.pastor.province\" md-selected-item-change=\"vm.selectProvince(province)\" \nmd-search-text=\"vm.searchProvince\" md-items=\"province in vm.searchProvinces(vm.searchProvince)\" \nmd-item-text=\"province.name\" md-no-cache=\"1\" md-require-match md-floating-label=\"Province\"><md-item-template><span \nmd-highlight-text=\"vm.searchProvince\">{{province.name}}</span></md-item-template><div class=\"errors\" \nng-messages=\"pastorDetailsForm.province.$error\r\n                                         || vm.apiErrors.province_id\" \nng-if=\"pastorDetailsForm.province.$touched\r\n                                         || pastorDetailsForm.$submitted\">\n<div ng-message=\"required\">Required</div><div ng-message=\"md-require-match\">Please select an province.</div><div \nng-bind=\"vm.apiErrors.province_id\"></div></div></md-autocomplete><md-autocomplete flex required md-input-name=\"city\" \nmd-selected-item=\"vm.pastor.city\" md-selected-item-change=\"vm.selectCity(city)\" md-search-text=\"vm.searchCity\" \nmd-items=\"city in vm.searchCities(vm.searchCity)\" md-item-text=\"city.name\" md-no-cache=\"1\" md-require-match \nmd-floating-label=\"City\" ng-disabled=\"!vm.pastor.province_id\"><md-item-template><span \nmd-highlight-text=\"vm.searchCity\">{{city.name}}</span></md-item-template><div class=\"errors\" \nng-messages=\"pastorDetailsForm.city.$error\" \nng-if=\"pastorDetailsForm.city.$touched\r\n                                         || pastorDetailsForm.$submitted\"><div \nng-message=\"required\">Required</div><div ng-message=\"md-require-match\">Please select an city.</div></div>\n</md-autocomplete><md-autocomplete flex required md-input-name=\"barangay\" md-selected-item=\"vm.pastor.barangay\" \nmd-selected-item-change=\"vm.selectBarangay(barangay)\" md-search-text=\"vm.searchBarangay\" \nmd-items=\"barangay in vm.searchBarangays(vm.searchBarangay)\" md-item-text=\"barangay.name\" md-no-cache=\"1\" \nmd-require-match md-floating-label=\"Barangay\" ng-disabled=\"!vm.pastor.city_id\"><md-item-template><span \nmd-highlight-text=\"vm.searchBarangay\">{{barangay.name}}</span></md-item-template><div class=\"errors\" \nng-messages=\"pastorDetailsForm.barangay.$error\" \nng-if=\"pastorDetailsForm.barangay.$touched\r\n                                         || pastorDetailsForm.$submitted\">\n<div ng-message=\"required\">Required</div><div ng-message=\"md-require-match\">Please select an barangay.</div></div>\n</md-autocomplete></div><div class=\"md-block mt-10\" flex-gt-xs ng-show=\"!vm.clickedEdit\"><label \nclass=\"label-info-personal\">Other/More Address</label><div class=\"value-info-personal\">{{vm.pastor.address}}</div>\n</div><md-input-container class=\"md-block mb-0 mt-0\" flex-gt-xs ng-show=\"vm.clickedEdit\"><input name=\"address\" \nng-model=\"vm.pastor.address\" placeholder=\"Other/More Address\" type=\"text\" maxlength=\"120\" class=\"pastor\"><div \nng-messages=\"pastorDetailsForm.address.$error\" \nng-show=\"pastorDetailsForm.address.$touched\r\n                                     || vm.apiErrors.address\" \nrole=\"alert\"><div ng-bind=\"vm.apiErrors.address\"></div></div></md-input-container><div class=\"md-block mt-20\" \nflex-gt-xs ng-show=\"!vm.clickedEdit\"><label class=\"label-info-personal\">Messenger ID</label><div \nclass=\"value-info-personal\">{{vm.pastor.messenger_id}}</div></div><md-input-container class=\"md-block mb-0 mt-10\" \nflex-gt-xs ng-show=\"vm.clickedEdit\"><input name=\"messenger_id\" ng-model=\"vm.pastor.messenger_id\" \nplaceholder=\"Messenger ID\" type=\"text\" class=\"pastor\"><div ng-messages=\"pastorDetailsForm.messenger_id.$error\" \nng-show=\"pastorDetailsForm.messenger_id.$touched\r\n                                     || vm.apiErrors.messenger_id\" \nrole=\"alert\"><div ng-bind=\"vm.apiErrors.messenger_id\"></div></div></md-input-container><div class=\"md-block mt-20\" \nflex-gt-xs ng-show=\"!vm.clickedEdit\"><label class=\"label-info-personal\">Smartphone</label><div \nclass=\"value-info-personal\">{{vm.pastor.has_smartphone ? \"Yes\" : \"No\"}}</div></div><md-input-container \nclass=\"md-block mb-0 mt-10\" flex-gt-xs ng-show=\"vm.clickedEdit\"><label>Smartphone</label><md-select \nname=\"has_smartphone\" ng-disabled=\"!vm.yesno.length\" ng-model=\"vm.pastor.has_smartphone\" placeholder=\"Smartphone\" \nrequired><md-option ng-value=\"option.value\" ng-repeat=\"option in vm.yesno\">{{ option.label }}</md-option></md-select>\n<div ng-messages=\"pastorDetailsForm.has_smartphone.$error\" \nng-show=\"pastorDetailsForm.has_smartphone.$touched\r\n                                     || vm.apiErrors.has_smartphone\" \nrole=\"alert\"><div ng-bind=\"vm.apiErrors.has_smartphone\"></div></div></md-input-container></md-content><md-content \nclass=\"pastor-content\"><div class=\"pt-10\" style=\"position: relative\"><h2>Pastor Group Assignment</h2><md-select \nflex=\"50\" name=\"status\" ng-model=\"vm.pastor.group_leader\" ng-disabled=\"!vm.clickedEdit\" style=\"font-size:12px\" \nplaceholder=\"Select Group Assignment\" data-md-container-class=\"selectdemoSelectHeader\"><md-optgroup \nlabel=\"Select Group Assignment\"><md-option value=\"0\" \nng-style=\"!vm.pastor.group_leader && !vm.pastor.group_leader_id && {\'font-weight\':\'700\'}\">Unassign</md-option>\n<md-option value=\"1\" ng-style=\"vm.pastor.group_leader > 0 && { \'font-weight\':\'700\'}\">Group Facilitator</md-option>\n<md-option ng-if=\"vm.selectedgroupleaders.length > 0\" ng-repeat=\"facilitator in vm.selectedgroupleaders\" \nvalue=\"facilitator\">Member - {{facilitator.firstname + \' \' + facilitator.lastname }} ({{facilitator.id}})</md-option>\n</md-optgroup></md-select></div><div class=\"pt-10\"><h2>Go Viral Pastor Mentor</h2><div layout-gt-xs=\"row\">\n<md-autocomplete flex md-input-name=\"selectGoViralPastorMentor\" md-selected-item=\"vm.pastor.selectGoViralPastorMentor\" \nmd-selected-item-change=\"vm.selectGoViralPastorMentor(pastor)\" md-search-text=\"vm.searchGoViralPastorMentor\" \nmd-items=\"pastor in vm.searchGoViralPastorMentors(vm.searchGoViralPastorMentor)\" \nmd-item-text=\"pastor.firstname+\' \'+pastor.lastname+ \' (\' +pastor.id+ \')\'\" md-min-length=\"0\" md-require-match \nmd-floating-label=\"Pastor Name or ID\"><md-item-template><span md-highlight-text=\"vm.searchGoViralPastorMentor\">\n{{pastor.firstname}} {{pastor.lastname}} - {{pastor.id}}</span></md-item-template><div class=\"errors\" \nng-messages=\"pastorForm.selectGoViralPastorMentor.$error\" \nng-if=\"pastorForm.selectGoViralPastorMentor.$touched\r\n                                             || pastorForm.$submitted\">\n<div ng-message=\"md-require-match\">Please select a pastor.</div></div></md-autocomplete></div></div><div class=\"pt-10\">\n<h2>Churches</h2><md-button class=\"md-raised new-application ml-0\" \nng-show=\"currentUser.$roles.has([\'admin\']) || vm.userCountry !== \'PH\'\" ng-click=\"vm.addNewChurch(vm.pastor)\" \nstyle=\"background-color: #2657a0 ;text-transform: none; font-size: 14px; font-weight: bolder; color:#fff!important;letter-spacing: .010em ;text-shadow: 0.45px 0.45px #fff\">\nNew Church</md-button><table class=\"table\"><tr><th>ID</th><th>Name</th><th>Position</th><th>Location</th></tr><tr \nng-show=\"!vm.churches.length\r\n                                    && !vm.isLoading1\"><td colspan=\"5\" \nclass=\"no-churches\"><div class=\"text-center\">No churches.</div></td></tr><tr \nng-show=\"vm.isLoading1\r\n                                    && vm.churches.length < 1\"><td colspan=\"5\"><div \nclass=\"text-center\">Loading churches.</div></td></tr><tr ng-repeat=\"church in vm.churches\"><td><a \nui-sref=\"app.thrive.churches.details({id : church.id})\">{{church.id}}</a></td><td><a \nui-sref=\"app.thrive.churches.details({id : church.id})\">{{church.name}}</a></td><td>\n{{church.pastor_position || church.pivot.position || \'\'}}</td><td>{{church.province.name}}</td><td \nclass=\"icons-container\" ng-show=\"currentUser.$roles.has([\'admin\']) || vm.userCountry !== \'PH\'\"><i class=\"icon-pencil\" \nng-click=\"vm.editChurch(church)\"><md-tooltip md-direction=\"left\">Edit Position</md-tooltip></i><i class=\"icon-trash\" \nng-click=\"vm.deleteChurch(church)\"><md-tooltip md-direction=\"left\">Delete Church</md-tooltip></i></td></tr></table>\n</div><div class=\"pt-10\"><h2>Data Cards</h2><table class=\"table\"><tr><th>ID</th><th>Thrive Date</th><th>&nbsp;</th>\n</tr><tr ng-show=\"!vm.datacards.length\r\n                                    && !vm.isLoading1\"><td colspan=\"5\"><div \nclass=\"text-center\">No data cards.</div></td></tr><tr \nng-show=\"vm.isLoading1\r\n                                    && vm.datacards.length < 1\"><td colspan=\"5\"><div \nclass=\"text-center\">Loading data cards.</div></td></tr><tr ng-repeat=\"datacard in vm.datacards\"><td>{{datacard.id}}\n</td><td>{{datacard.attended_at | dateToISO | date : \'MMM. dd, yyyy\'}}</td><td class=\"icons-container\" \nng-show=\"currentUser.$roles.has([\'admin\']) || vm.userCountry !== \'PH\'                                         && datacard.attended_at | dateToISO | date : \'yyyy-MM-dd\' >= (vm.today | dateToISO | date : \'yyyy-MM-dd\')\">\n<i class=\"icon-pencil\" ng-click=\"vm.editDataCard(datacard)\"><md-tooltip md-direction=\"left\">Edit Data Card</md-tooltip>\n</i><i class=\"icon-trash\" ng-click=\"vm.deleteDataCard(datacard)\"><md-tooltip md-direction=\"left\">Delete Data Card\n</md-tooltip></i></td></tr></table></div><div class=\"pt-10\"><h2>Contacts</h2><md-button \nclass=\"md-raised new-application ml-0\" ng-show=\"currentUser.$roles.has([\'admin\']) || vm.userCountry !== \'PH\'\" \nng-click=\"vm.addContact()\" \nstyle=\"background-color: #2657a0 ;text-transform: none; font-size: 14px; font-weight: bolder; color:#fff!important;letter-spacing: .010em ;text-shadow: 0.45px 0.45px #fff\">\nNew Contact</md-button><table class=\"table\"><tr><th>Contact no.</th><th>&nbsp;</th></tr><tr \nng-show=\"!vm.pastor.contacts.length\r\n                                    && !vm.isLoading1\"><td colspan=\"5\"><div \nclass=\"text-center\">No contacts.</div></td></tr><tr \nng-show=\"vm.isLoading1\r\n                                    && vm.pastor.contacts.length < 1\"><td colspan=\"5\"><div \nclass=\"text-center\">Loading contacts.</div></td></tr><tr ng-repeat=\"contact in vm.pastor.contacts\"><td>\n{{contact.contact_no}}</td><td class=\"icons-container\"><i class=\"icon-pencil\" \nng-show=\"currentUser.$roles.has([\'admin\']) || vm.userCountry !== \'PH\'\" ng-click=\"vm.editContact(contact)\"><md-tooltip \nmd-direction=\"left\">Edit Contact</md-tooltip></i><i class=\"icon-trash\" \nng-show=\"currentUser.$roles.has([\'admin\']) || vm.userCountry !== \'PH\'\" ng-click=\"vm.deleteContact(contact)\"><md-tooltip\n md-direction=\"left\">Delete Contact</md-tooltip></i></td></tr></table></div></md-content></div></div></form></div>\n</div></md-bottom-sheet>");
$templateCache.put("app/main/transform/tabs/reports/bottom-sheets/report-preview/report-preview.html","<md-bottom-sheet class=\"md-grid cover-parent\"><div class=\"application-details-slider-container\"><div \nclass=\"slider-card\"><div class=\"slider-header-report text-center\"><span class=\"report-date pull-left\">\n{{vm.reportDate | date: \'MMMM dd, yyyy\'}} Report</span> <span class=\"sheets\">{{vm.navsLength}} sheets generated</span> \n<span class=\"pull-right right-section\"><span class=\"download\" ng-show=\"vm.navsLength\">Download</span> <span \nclass=\"download-xls-csv\" ng-show=\"vm.navsLength\"><a ng-href=\"{{vm.api.baseUrl + \'reports/xls?\' + vm.csvUrl}}\" \nclass=\"xls\" target=\"_blank\">XLS</a> <span class=\"divider\">| </span><a \nng-href=\"{{vm.api.baseUrl + \'reports/csv?\' + vm.csvUrl}}\" target=\"_blank\" class=\"csv\">CSV</a></span><md-button \nmd-no-ink ng-click=\"vm.hideSliderCard()\" class=\"md-primary application-details-close-button\" aria-label=\"DROP\"><i \nclass=\"icon-close\"></i></md-button></span></div><div class=\"slider-body-report\"><form name=\"previewReportForm\" \nclass=\"md-inline-form\" novalidate><div layout-gt-xs=\"row\"><md-input-container flex=\"30\" ng-show=\"vm.navsLength > 0\">\n<label>Show</label><md-select name=\"batch\" ng-model=\"vm.reportSelect\" ng-change=\"vm.drawTable(vm.reportSelect)\">\n<md-option ng-value=\"key\" ng-repeat=\"(key,value) in vm.report.navs\">{{value}}</md-option></md-select>\n</md-input-container></div><div ng-show=\"vm.loading && !vm.noData\" class=\"no-data\">Loading preview</div><div \nng-show=\"vm.noData\" class=\"no-data\">No data to show</div></form><div class=\"report-table\" ng-bind-html=\"vm.table\">\n</div></div></div></div></md-bottom-sheet>");
$templateCache.put("app/main/transform/tabs/applications/bottom-sheets/deleted-applications/deleted-applications.html","<md-bottom-sheet class=\"md-grid cover-parent\"><div class=\"deleted-application-slider-container\"><div \nclass=\"deleted-applications-slider-card\"><div class=\"slider-header\"><h4 class=\"slider-title\">Deleted Applications</h4>\n<md-button ng-click=\"vm.closeDeletedApplications()\" md-no-ink class=\"md-primary deleted-application-close-button\" \naria-label=\"DROP\"><i class=\"icon-close\"></i></md-button></div><div class=\"slider-body\"><md-content ms-scroll \nclass=\"with-scrollbar\"><table class=\"table\"><tr><th>ID</th><th>Application Date</th><th>Location</th><th>Pastor</th>\n</tr><tr ng-show=\"!vm.deletedApplications.data.length\r\n                    && !vm.isLoading\"><td colspan=\"5\"><div \nclass=\"text-center\">No applications.</div></td></tr><tr ng-show=\"vm.isLoading && vm.deletedApplications.length < 1\"><td\n colspan=\"5\"><div class=\"text-center\">Loading applications.</div></td></tr><tr \nng-repeat=\"application in vm.deletedApplications.data\" ng-mouseover=\"application.selected = true\" \nng-mouseleave=\"application.selected = false\" ng-class=\"{backgroundWhite: application.selected}\" \nng-click=\"vm.callPastorInformation(application.pastor)\"><td>{{application.application_id}}</td><td>\n{{application.applied_at | date}}</td><td>Brgy. {{application.community_barangay}}, {{application.community_city}}</td>\n<td class=\"pastor-click\" \nng-click=\"vm.callPastorInformation(application.pastor);\r\n                            $event.stopPropagation();\">\n{{application.pastor.firstname}} {{application.pastor.lastname}}</td><td class=\"icons-container\" \nng-show=\"currentUser.$roles.has([\'admin\',\r\n                            \'metrics\', \'pastor_coordinator\', \'branch_head\', \'health_mentor\'])\">\n<i class=\"icon-refresh\" \nng-click=\"vm.restoreApplication(application);\r\n                               $event.stopPropagation();\"><md-tooltip \nmd-direction=\"left\">Restore Application</md-tooltip></i><i class=\"icon-trash\" \nng-click=\"vm.deleteApplication(application);\r\n                               $event.stopPropagation();\"><md-tooltip \nmd-direction=\"left\">Delete Application</md-tooltip></i></td></tr></table><div class=\"pagination-container\" \nng-show=\"!vm.isLoading\"><pagination items=\"vm.deletedApplications\" \ncallback=\"vm.pageChange(vm.deletedApplications.current_page)\"></pagination></div></md-content></div></div></div>\n</md-bottom-sheet>");
$templateCache.put("app/main/transform/tabs/reports/dialogs/add-report-template/add-report-template-dialog.html","<md-dialog class=\"new-user-dialog transform-dialog\"><form name=\"reportTemplateForm\" class=\"md-inline-form\" \nng-submit=\"vm.addReportTemplate(vm.report, reportTemplateForm)\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"name\" \nng-model=\"vm.report.name\" placeholder=\"Template Name\" type=\"text\" class=\"product\" maxlength=\"50\" md-autofocus required>\n<div ng-messages=\"reportTemplateForm.name.$error\" \nng-show=\"reportTemplateForm.name.$touched\r\n                     || vm.apiErrors.name\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.name\"></div></div></md-input-container>\n</md-dialog-content><md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"reportTemplateForm.$invalid || vm.saving\" type=\"submit\"><span ng-show=\"!vm.saving\">Save Template</span> \n<span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>\nSubmitting</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/transform/tabs/reports/dialogs/edit-report-template/edit-report-template-dialog.html","<md-dialog class=\"new-user-dialog transform-dialog\"><form name=\"reportTemplateForm\" class=\"md-inline-form\" \nng-submit=\"vm.editReportTemplate(vm.report, reportTemplateForm)\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div\n class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"name\" \nng-model=\"vm.report.name\" placeholder=\"Template Name\" type=\"text\" class=\"product\" md-autofocus maxlength=\"50\" required>\n<div ng-messages=\"reportTemplateForm.name.$error\" \nng-show=\"reportTemplateForm.name.$touched\r\n                     || vm.apiErrors.name\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.name\"></div></div></md-input-container>\n</md-dialog-content><md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"reportTemplateForm.$invalid || vm.saving\" type=\"submit\"><span ng-show=\"!vm.saving\">Edit Template</span> \n<span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>\nSubmitting</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/transform/tabs/approval-lists/bottom-sheets/application-participants/application-participants.html","<md-bottom-sheet class=\"md-grid cover-parent\"><div class=\"application-details-slider-container\"><div \nclass=\"slider-card\"><div class=\"slider-header\"><div class=\"left\" flex=\"50\"><div class=\"part\"><h4>\n{{vm.application.pastor.firstname + \' \' + vm.application.pastor.lastname}}</h4><h5>Pastor</h5></div><div class=\"part\">\n<h4>{{vm.application.pastor.contacts[0].contact_no}}</h4><h5>Contact No.</h5></div><div class=\"part\"><h4>\nBrgy. {{vm.application.community_barangay}}, {{vm.application.community_city}}</h4><h5>Location</h5></div><div \nclass=\"part counselors\"><h4 ng-show=\"!vm.isLoadingParticipants\">{{vm.application.total_counselors}}</h4><h5>Counselors\n</h5></div><div class=\"part participants\"><h4 ng-show=\"!vm.isLoadingParticipants\">\n{{vm.application.total_approved_participants}}/{{vm.application.total_participants}}</h4><h5>Participants</h5></div>\n</div><div class=\"right\" flex=\"50\"><md-button class=\"md-accent md-raised\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'pastor_coordinator\', \'branch_head\', \'health_mentor\'])\" \nng-click=\"vm.addParticipant()\">ADD PARTICIPANT</md-button><md-button md-no-ink ng-click=\"vm.dropApplication()\" \nng-show=\"currentUser.$roles.has([\'admin\', \'metrics\', \'pastor_coordinator\', \'branch_head\', \'area_head\', \'health_mentor\'])\" \nclass=\"md-primary cancel-button\" aria-label=\"DROP\">DROP</md-button><md-button class=\"md-accent md-raised\" \nng-show=\"currentUser.$roles.has([\'admin\', \'branch_head\', \'aread_head\'])\" ng-click=\"vm.approveApplication()\">APPROVE\n</md-button><md-button md-no-ink ng-click=\"vm.hideSliderCard()\" class=\"md-primary application-details-close-button\" \naria-label=\"DROP\"><i class=\"icon-close\"></i></md-button></div></div><div class=\"slider-body\"><md-content ms-scroll \nclass=\"with-scrollbar\"><table class=\"table\" ng-show=\"vm.originals.length > 0 || vm.counselors.length > 0\" \nng-show=\"!vm.isLoadingParticipants\"><thead><tr><th>No.</th><th>Participants</th><th class=\"text-center\">Issue/s</th><th\n class=\"text-center\">Poverty Score</th><th class=\"text-center\">Status</th><th></th></tr></thead><tbody><tr \nng-repeat=\"participant in vm.originals | toArray:false | orderBy:\'participant_no\'\"><td>{{$index + 1}}</td><td \nclass=\"participants-click\" ng-click=\"vm.editParticipant(participant, vm.application.pastor)\"><span \nclass=\"participant-icon\"><img ng-show=\"participant.type == \'counselor\'\" src=\"assets/icons/png/icon_counselor.png\">\n<md-tooltip md-direction=\"top\">Original Counselor</md-tooltip></span><span class=\"participant-icon\"><img \nng-show=\"participant.type == \'original\'\" src=\"assets/icons/png/icon_participant.png\"><md-tooltip md-direction=\"top\">\nOriginal Participant</md-tooltip></span><span class=\"participant-icon\"><img \nng-show=\"participant.type == \'original_replacement\'\" src=\"assets/icons/png/icon_replace_participant.png\"><md-tooltip \nmd-direction=\"top\">Replacement Participant</md-tooltip></span><span class=\"participant-icon\"><img \nng-show=\"participant.type == \'counselor_replacement\'\" src=\"assets/icons/png/icon_replace_counselor.png\"><md-tooltip \nmd-direction=\"top\">Replacement Counselor</md-tooltip></span>{{participant.firstname}} {{participant.lastname}}</td><td \nclass=\"text-center\"><span class=\"material-icons Issues_icon\" ng-show=\"participant.icon_display==1?true:false\" \nng-click=\"vm.issuesDialog(participant, vm.application.pastor)\">error_outline</span></td><td class=\"text-center\" \nng-class=\"{\'qualified\' : participant.selection_score >= 81,\r\n                                \'disqualified\' : participant.selection_score <= 49.9,\r\n                                \'overriden\' : participant.selection_score >= 50 && participant.selection_score <= 80.9 }\">\n{{participant.scorecard ? participant.selection_score : \'\'}}</td><td class=\"text-center\"><i \nclass=\"icon-check qualified\" ng-click=\"vm.changeStatus(participant, currentUser.$roles.first())\" \nng-class=\"{\'cursor\' : currentUser.$roles.has([\r\n                                   \'admin\', \'metrics\', \'pastor_coordinator\',\r\n                                   \'branch_head\'])}\" \nng-show=\"participant.status===\'qualified\'\"><md-tooltip md-direction=\"left\" ng-show=\"participant.status===\'qualified\'\">\nQualified</md-tooltip></i><i class=\"icon-close disqualified\" \nng-click=\"vm.changeStatus(participant, currentUser.$roles.first())\" \nng-class=\"{\'cursor\' : currentUser.$roles.has([\r\n                                   \'admin\', \'metrics\', \'pastor_coordinator\',\r\n                                   \'branch_head\'])}\" \nng-show=\"participant.status===\'disqualified\'\"><md-tooltip md-direction=\"left\" \nng-show=\"participant.status===\'disqualified\'\">Disqualified</md-tooltip></i><i class=\"icon-check overriden\" \nng-click=\"vm.changeStatus(participant, currentUser.$roles.first())\" \nng-class=\"{\'cursor\' : currentUser.$roles.has([\r\n                                   \'admin\', \'metrics\', \'pastor_coordinator\',\r\n                                   \'branch_head\'])}\" \nng-show=\"participant.status===\'overriden\'\"><md-tooltip md-direction=\"left\" ng-show=\"participant.status===\'overriden\'\">\nOverriden</md-tooltip></i></td><td><i class=\"icon-pencil\" style=\"font-size: 20px; color: #bbb; margin-right: 8px\" \nng-show=\"currentUser.$roles.has([\'admin\',   \'metrics\', \'pastor_coordinator\',  \'branch_head\', \'health_mentor\'])\" \nng-click=\"vm.editParticipant(participant, vm.application.pastor); $event.stopPropagation();\"><md-tooltip \nmd-direction=\"left\">Edit Participant</md-tooltip></i><i class=\"icon-trash\" \nng-click=\"vm.deleteParticipant(participant)\" \nng-show=\"currentUser.$roles.has([\'admin\',   \'metrics\', \'pastor_coordinator\',  \'branch_head\', \'health_mentor\'])\">\n<md-tooltip md-direction=\"left\">Remove Participant</md-tooltip></i></td></tr><tr \nng-repeat=\"participant in vm.counselors | toArray:false | orderBy:\'firstname\'\"><td>-</td><td \nclass=\"participants-click\" ng-click=\"vm.editParticipant(participant, vm.application.pastor)\"><span \nclass=\"participant-icon\"><img ng-show=\"participant.type == \'counselor\'\" src=\"assets/icons/png/icon_counselor.png\">\n<md-tooltip md-direction=\"top\">Original Counselor</md-tooltip></span><span class=\"participant-icon\"><img \nng-show=\"participant.type == \'original\'\" src=\"assets/icons/png/icon_participant.png\"><md-tooltip md-direction=\"top\">\nOriginal Participant</md-tooltip></span><span class=\"participant-icon\"><img \nng-show=\"participant.type == \'original_replacement\'\" src=\"assets/icons/png/icon_replace_participant.png\"><md-tooltip \nmd-direction=\"top\">Replacement Participant</md-tooltip></span><span class=\"participant-icon\"><img \nng-show=\"participant.type == \'counselor_replacement\'\" src=\"assets/icons/png/icon_replace_counselor.png\"><md-tooltip \nmd-direction=\"top\">Replacement Counselor</md-tooltip></span>{{participant.firstname}} {{participant.lastname}}</td><td>\n</td><td class=\"text-center\" \nng-class=\"{\'qualified\' : participant.selection_score >= 81,\r\n                                \'disqualified\' : participant.selection_score <= 49,\r\n                                \'overriden\' : participant.selection_score >= 50 && participant.selection_score <= 80 }\">\n{{participant.scorecard ? participant.selection_score : \'\'}}</td><td class=\"text-center\"><i \nclass=\"icon-check qualified\" ng-click=\"vm.changeStatus(participant, currentUser.$roles.first())\" \nng-class=\"{\'cursor\' : currentUser.$roles.has([\r\n                                   \'admin\', \'metrics\', \'pastor_coordinator\',\r\n                                   \'branch_head\'])}\" \nng-show=\"participant.status===\'qualified\'\"><md-tooltip md-direction=\"left\" ng-show=\"participant.status===\'qualified\'\">\nQualified</md-tooltip></i><i class=\"icon-close disqualified\" \nng-click=\"vm.changeStatus(participant, currentUser.$roles.first())\" \nng-class=\"{\'cursor\' : currentUser.$roles.has([\r\n                                   \'admin\', \'metrics\', \'pastor_coordinator\',\r\n                                   \'branch_head\'])}\" \nng-show=\"participant.status===\'disqualified\'\"><md-tooltip md-direction=\"left\" \nng-show=\"participant.status===\'disqualified\'\">Disqualified</md-tooltip></i><i class=\"icon-check overriden\" \nng-click=\"vm.changeStatus(participant, currentUser.$roles.first())\" \nng-class=\"{\'cursor\' : currentUser.$roles.has([\r\n                                   \'admin\', \'metrics\', \'pastor_coordinator\',\r\n                                   \'branch_head\'])}\" \nng-show=\"participant.status===\'overriden\'\"><md-tooltip md-direction=\"left\" ng-show=\"participant.status===\'overriden\'\">\nOverriden</md-tooltip></i></td><td><i class=\"icon-trash\" \nng-show=\"currentUser.$roles.has([\'admin\',\r\n                                   \'metrics\', \'pastor_coordinator\',\r\n                                   \'branch_head\'])\" \nng-click=\"vm.deleteParticipant(participant)\"><md-tooltip md-direction=\"left\">Remove Participant</md-tooltip></i></td>\n</tr></tbody></table><div class=\"loading-participants\" \nng-show=\"vm.originals.length < 1 || vm.counselors.length < 1\r\n                         && !vm.isLoadingParticipants\">\nNo participants added yet</div><div class=\"loading-participants\" ng-show=\"vm.isLoadingParticipants\">\nLoading Participants</div></md-content></div></div></div></md-bottom-sheet>");
$templateCache.put("app/main/community/tabs/bib/bottom-sheets/dialogs/add-bib-pastor/add-bib-pastor-dialog.html","<md-dialog class=\"delete-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"bibParticipantForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.addParticipant(vm.participant, vm.bib, bibParticipantForm)\" novalidate><md-toolbar\n class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll class=\"text-center\">\n<div layout-gt-xs=\"row\"><md-input-container flex=\"70\"><label>Pastor Name</label><md-select \nng-model=\"vm.participant.fullname\" . placeholder=\"Pastor Name\"><md-option ng-value=\"type.value\" \nng-repeat=\"type in vm.pastor\">{{type.label}}</md-option></md-select></md-input-container><md-input-container flex=\"30\">\n<label>Type</label><md-select ng-model=\"vm.participant.type\" . placeholder=\"Type\" required><md-option \nng-value=\"type.value\" ng-repeat=\"type in vm.types\">{{type.label}}</md-option></md-select><div \nng-messages=\"bibParticipantForm.type.$error\" \nng-show=\"bibParticipantForm.type.$touched\r\n                         || vm.apiErrors.type\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.type\"></div></div></md-input-container>\n</div><div layout-gt-xs=\"row\"><md-input-container flex=\"50\"><input name=\"base_capital\" \nng-model=\"vm.participant.base_capital\" placeholder=\"Capital\" required><div \nng-messages=\"bibParticipantForm.base_capital.$error\" \nng-show=\"bibParticipantForm.base_capital.$touched\r\n                         || vm.apiErrors.base_capital\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.base_capital\"></div></div>\n</md-input-container><span class=\"php\">PHP</span><md-input-container flex=\"30\" class=\"ml-20\"><input name=\"kits\" \nng-model=\"vm.participant.kits\" placeholder=\"Kits Given\" type=\"number\" min=\"0\" required><div \nng-messages=\"bibParticipantForm.kits.$error\" ng-show=\"bibParticipantForm.kits.$touched || vm.apiErrors.kits\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-message=\"min\"><span>Invalid input</span>\n</div><div ng-message=\"number\"><span>Invalid input</span></div><div ng-bind=\"vm.apiErrors.kits\"></div></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions><md-button md-no-ink \nclass=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">CANCEL</md-button><md-button \nclass=\"md-accent md-raised\" \nng-disabled=\"bibParticipantForm.$invalid\r\n                       || bibParticipantForm.$pristine || vm.saving\" \ntype=\"submit\"><span ng-show=\"!vm.saving\">SAVE</span> <span ng-show=\"vm.saving\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting</span></md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/settings/changelogs/tabs/active-users/bottom-sheets/total-downloads/total-downloads.html","<style>\n.table-sync {\r\n        margin-bottom: 0 !important;\r\n    }\r\n\r\n    .table-sync tr th {\r\n        color: #386BBA;\r\n    }\r\n\r\n    .table-sync tbody tr td {\r\n        color: #000000de;\r\n    }\n</style><md-bottom-sheet class=\"md-grid attendance-bottom-sheet\"><div class=\"total-downloads-slider-container\"><div \nclass=\"total-downloads-slider-card\"><div class=\"slider-header\"><h4 class=\"slider-title\">\n{{vm.is_unique_users ? \"Total Unique Users\":\"Total Downloads/Updates\"}}</h4><md-button ng-click=\"vm.closeSheet()\" \nmd-no-ink class=\"md-primary deleted-application-close-button\" aria-label=\"DROP\"><i class=\"icon-close\"></i></md-button>\n</div><div class=\"slider-body\"><md-content ms-scroll class=\"with-scrollbar\"><table class=\"table\" \nng-hide=\"vm.is_unique_users\"><thead><tr><th>User ID</th><th>User Name</th><th>Version</th><th>Download Date</th><th>\nUpdate Date</th></tr></thead><tbody><tr ng-if=\"vm.isLoading\"><td colspan=\"4\"><center>Loading...</center></td></tr><tr \nng-if=\"!vm.totalDownloads.data.length && !vm.isLoading\"><td colspan=\"4\"><center>No data found.</center></td></tr><tr \nng-repeat=\"user in vm.totalDownloads.data\" ng-hide=\"vm.isLoading\"><td colspan=\"2\" ng-hide=\"user.user_id\">\nUser is not logged in yet.</td><td ng-show=\"user.user_id\">{{user.user_id}}</td><td ng-show=\"user.user_id\">\n{{user.firstname}} {{user.lastname}}</td><td>{{user.version}}</td><td>{{user.is_download ? user.app_created_at :\"\" }}\n</td><td>{{ user.is_download ? \"\" : user.app_updated_at }}</td></tr></tbody></table><div class=\"pagination-container\" \nng-hide=\"vm.is_unique_users\"><pagination items=\"vm.totalDownloads.data\" \ncallback=\"vm.pageChange(vm.totalDownloads.current_page)\"></pagination></div><table class=\"table\" \nng-show=\"vm.is_unique_users\"><thead><tr><th>User ID</th><th>User Name</th><th>Email</th><th>Username</th><th>Role</th>\n</tr></thead><tbody><tr ng-if=\"vm.isLoading\"><td colspan=\"4\"><center>Loading...</center></td></tr><tr \nng-if=\"!vm.totalUniqueUsers.data.length && !vm.isLoading\"><td colspan=\"4\"><center>No user found.</center></td></tr><tr \nng-repeat=\"user in vm.totalUniqueUsers.data\" ng-hide=\"vm.isLoading\"><td>{{user.id}}</td><td><md-menu id=\"sync-menu\" \nmd-position-mode=\"left bottom\"><div ng-click=\"$mdOpenMenu()\" style=\"width: fit-content\">\n{{user.firstname}} {{user.lastname}}</div><md-menu-content width=\"15\"><table class=\"table table-sync\" \nstyle=\"margin-bottom: 0\"><thead><tr><th style=\"color: #386BBA\">Activity</th><th style=\"color: #386BBA\">Date</th><th \nstyle=\"color: #386BBA\">Version</th></tr></thead><tbody><tr \nng-show=\"!user.activity && !user.created_at_log && !user.app_version\"><td colspan=\"3\" style=\"color: #000000de\"><center>\nNo user found.</center></td></tr><tr ng-hide=\"user.activity || user.created_at_log || user.app_version\"><td \nstyle=\"color: #000000de\">{{user.activity}}</td><td style=\"color: #000000de\">{{user.created_at_log}}</td><td \nstyle=\"color: #000000de\">{{user.app_version}}</td></tr></tbody></table></md-menu-content></md-menu></td><td>\n{{user.email}}</td><td>{{user.username}}</td><td>{{user.roles[0]}}</td></tr></tbody></table><div \nclass=\"pagination-container\" ng-show=\"vm.is_unique_users\"><pagination items=\"vm.totalUniqueUsers.data\" \ncallback=\"vm.pageChange(vm.totalUniqueUsers.current_page)\"></pagination></div></md-content></div></div></div>\n</md-bottom-sheet>");
$templateCache.put("app/main/settings/changelogs/tabs/api-errors/dialogs/view-api-errors/view-api-errors-dialog.html","<md-dialog class=\"view-apiError-dialog transform-dialog\"><md-dialog-content ms-scroll><div class=\"row apiError-rows\">\n<div class=\"col-lg-4 col-md-4 col-sm-6\"><div class=\"apiError-data\"><span class=\"lbl\">User</span> <span class=\"val\">\n{{ vm.apiError.user ? vm.apiError.user.username : \'\' }}</span></div></div><div class=\"col-lg-4 col-md-4 col-sm-6\"><div \nclass=\"apiError-data\"><span class=\"lbl\">URL</span> <span class=\"val\">{{ vm.apiError.request }}</span></div></div><div \nclass=\"col-lg-4 col-md-4 col-sm-6\"><div class=\"apiError-data\"><span class=\"lbl\">Date</span> <span class=\"val\">\n{{ vm.apiError.created_at }}</span></div></div><div class=\"col-lg-4 col-md-4 col-sm-6\"><div class=\"apiError-data\"><span\n class=\"lbl\">Desktop</span> <span class=\"val\">{{ vm.apiError.is_desktop ? \'Yes\' : \'No\' }}</span></div></div><div \nclass=\"col-lg-4 col-md-4 col-sm-6\"><div class=\"apiError-data\"><span class=\"lbl\">Mobile</span> <span class=\"val\">\n{{ vm.apiError.is_mobile ? \'Yes\' : \'No\' }}</span></div></div><div class=\"col-lg-4 col-md-4 col-sm-6\"><div \nclass=\"apiError-data\"><span class=\"lbl\">Tablet</span> <span class=\"val\">{{ vm.apiError.is_tablet ? \'Yes\' : \'No\' }}\n</span></div></div><div class=\"col-lg-4 col-md-4 col-sm-6\"><div class=\"apiError-data\"><span class=\"lbl\">Device</span> \n<span class=\"val\">{{ vm.apiError.device }}</span></div></div><div class=\"col-lg-4 col-md-4 col-sm-6\"><div \nclass=\"apiError-data\"><span class=\"lbl\">Platform</span> <span class=\"val\">{{ vm.apiError.platform }}</span></div></div>\n<div class=\"col-lg-4 col-md-4 col-sm-6\"><div class=\"apiError-data\"><span class=\"lbl\">Browser</span> <span class=\"val\">\n{{ vm.apiError.browser }}</span></div></div><div class=\"col-lg-12\"><div class=\"apiError-data\"><span class=\"lbl\">Message\n</span> <span class=\"val\">{{ vm.apiError.message }}</span></div></div></div><div class=\"apiError-dumps\"><div \nclass=\"apiError-dump\"><p class=\"dump-title\">Data</p><pre>{{ vm.apiError.params | json }}</pre></div><div \nclass=\"apiError-dump\"><p class=\"dump-title\">Error Dump</p><pre>{{ vm.apiError.log }}</pre></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/settings/thrive/tabs/affiliations/dialogs/save-affiliation/save-affiliation-dialog.html","<md-dialog class=\"new-user-dialog transform-dialog\"><form name=\"affiliationForm\" class=\"md-inline-form\" \nng-submit=\"vm.saveChurchAffiliation(vm.affiliation, affiliationForm)\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block mb-0\" flex-gt-xs><input name=\"name\" ng-model=\"vm.affiliation.name\" \nplaceholder=\"Church Affiliation Name\" type=\"text\" class=\"affiliation\" md-autofocus maxlength=\"100\" required><div \nng-messages=\"affiliationForm.name.$error\" ng-show=\"affiliationForm.name.$touched || vm.apiErrors.name\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div><div ng-message=\"maxlength\"><span>Exceeds limit</span></div><div \nng-bind=\"vm.apiErrors.name\"></div></div></md-input-container></md-dialog-content><md-dialog-actions><md-button \nmd-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button\n class=\"md-accent md-raised\" ng-disabled=\"affiliationForm.$invalid || vm.saving\" type=\"submit\"><span \nng-show=\"!vm.saving\">Save</span> <span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"20px\"></md-progress-circular>Submitting</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/settings/thrive/tabs/bases/dialogs/delete-base/delete-base-dialog.html","<md-dialog class=\"delete-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nclass=\"text-center\"><p class=\"text-muted text-reminder\"><em>\nRemoving this base will also remove the base of the associated application and communities.</em></p><hr><p>\nAre you sure you want to delete this base?</p></md-dialog-content><md-dialog-actions><md-button md-no-ink \nclass=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"vm.saving\" ng-click=\"vm.passwordConfirmation()\"><span ng-show=\"!vm.saving\">\nDelete Base</span> <span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\">\n</md-progress-circular>Submitting</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/settings/thrive/tabs/bases/dialogs/delete-branch/delete-branch-dialog.html","<md-dialog class=\"delete-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nclass=\"text-center\"><p>Are you sure to delete this branch?</p></md-dialog-content><md-dialog-actions><md-button \nmd-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button\n class=\"md-accent md-raised\" ng-disabled=\"vm.saving\" ng-click=\"vm.passwordConfirmation()\"><span ng-show=\"!vm.saving\">\nDelete Branch</span> <span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\">\n</md-progress-circular>Submitting</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/settings/thrive/tabs/bases/dialogs/delete-province/delete-province-dialog.html","<md-dialog class=\"delete-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nclass=\"text-center\"><p>Are you sure to remove this province?</p></md-dialog-content><md-dialog-actions><md-button \nmd-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button\n class=\"md-accent md-raised\" ng-disabled=\"vm.saving\" ng-click=\"vm.passwordConfirmation()\"><span ng-show=\"!vm.saving\">\nDelete Province</span> <span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\">\n</md-progress-circular>Submitting</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/settings/thrive/tabs/bases/dialogs/edit-branch/edit-branch-dialog.html","<md-dialog class=\"edit-user-dialog edit-branch-dialog transform-dialog\"><form name=\"branchForm\" class=\"md-inline-form\" \nnovalidate ng-submit=\"vm.editBranch(vm.branch, branchForm)\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout-gt-xs=\"row\"><md-input-container class=\"md-block mb-0\" flex><input\n name=\"name\" ng-model=\"vm.branch.name\" placeholder=\"Branch Name\" type=\"text\" class=\"branch\" md-autofocus required><div \nng-messages=\"branchForm.name.$error\" ng-show=\"branchForm.name.$touched || vm.apiErrors.name\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.name\"></div></div></md-input-container>\n<md-input-container class=\"md-block mb-0\" flex><label>Base</label><md-select ng-model=\"vm.branch.base_id\"><md-option \nng-value=\"base.id\" ng-repeat=\"base in vm.bases\">{{base.name}}</md-option></md-select></md-input-container></div><label>\nAdd municipalities / cities</label><p class=\"errmsg\" ng-show=\"!vm.provinceIds.length\">\nPlease associate at least one province to the base.</p><md-chips ng-model=\"vm.selectedCities\" md-autocomplete-snap \nmd-require-match=\"true\"><md-autocomplete ng-disabled=\"!vm.provinceIds.length\" md-selected-item=\"vm.selectedCity\" \nmd-search-text=\"vm.searchCityText\" md-items=\"city in vm.searchCities(vm.searchCityText)\" md-item-text=\"city.name\" \nplaceholder=\"Search municipality / City\"><span md-highlight-text=\"vm.searchCityText\">\n{{city.name}} ({{ city.province.name }})</span></md-autocomplete><md-chip-template><span><strong>\n{{ $chip.name }} ({{ $chip.province.name }})</strong></span></md-chip-template></md-chips></md-dialog-content>\n<md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"branchForm.$invalid || vm.saving\" type=\"submit\"><span ng-show=\"!vm.saving\">Edit Branch</span> <span \nng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting\n</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/settings/thrive/tabs/bases/dialogs/new-branch/new-branch-dialog.html","<md-dialog class=\"new-user-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"branchForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.addNewBranch(vm.branch, branchForm)\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block mb-0\" flex-gt-xs><input name=\"name\" ng-model=\"vm.branch.name\" placeholder=\"Branch Name\" type=\"text\" \nclass=\"branch\" md-autofocus required><div ng-messages=\"branchForm.name.$error\" \nng-show=\"branchForm.name.$touched || vm.apiErrors.name\" role=\"alert\"><div ng-message=\"required\"><span>Required</span>\n</div><div ng-bind=\"vm.apiErrors.name\"></div></div></md-input-container></md-dialog-content><md-dialog-actions>\n<md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel\n</md-button><md-button class=\"md-accent md-raised\" ng-disabled=\"branchForm.$invalid || vm.saving\" type=\"submit\"><span \nng-show=\"!vm.saving\">Create Branch</span> <span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"20px\"></md-progress-circular>Submitting</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/settings/thrive/tabs/bases/dialogs/new-province/new-province-dialog.html","<md-dialog class=\"new-user-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"provinceForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.addNewProvince(vm.province, provinceForm)\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-autocomplete flex \nclass=\"autocomplete-no-bottom-and-top margin-right-15\" md-input-name=\"province\" md-selected-item=\"vm.province\" \nmd-search-text=\"vm.searchProvince\" md-items=\"province in vm.searchProvinces(vm.searchProvince)\" \nmd-item-text=\"province.name\" md-no-cache=\"1\" md-floating-label=\"Province\" required md-require-match><md-item-template>\n<span md-highlight-text=\"vm.searchProvince\">{{province.name}}</span></md-item-template><div class=\"errors\" \nng-messages=\"provinceForm.province.$error\" \nng-if=\"provinceForm.province.$touched\r\n                     || provinceForm.$submitted\"><div ng-message=\"required\">\nRequired</div><div ng-message=\"md-require-match\">Please select a province.</div></div></md-autocomplete>\n</md-dialog-content><md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"provinceForm.$invalid || vm.saving\" type=\"submit\"><span ng-show=\"!vm.saving\">Add Province</span> <span \nng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting\n</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/settings/thrive/tabs/bases/dialogs/save-base/save-base-dialog.html","<md-dialog class=\"edit-user-dialog transform-dialog\"><form name=\"baseForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveBase(vm.base, baseForm)\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"name\" \nng-model=\"vm.base.name\" placeholder=\"Base Name\" type=\"text\" class=\"base\" maxlength=\"50\" md-autofocus required><div \nng-messages=\"baseForm.name.$error\" ng-show=\"baseForm.name.$touched || vm.apiErrors.name\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.name\"></div></div></md-input-container>\n<md-input-container style=\"width: 100%\"><label>Country</label><md-select ng-model=\"vm.base.country_code\" \nng-change=\"vm.handleCountryChange(vm.base.country_code)\" required><md-option ng-value=\"country.id\" \nng-repeat=\"country in vm.countrys\">{{country.name}}</md-option></md-select><div class=\"errors\" \nng-messages=\"baseForm.country_code.$error || vm.apiErrors.country_code\" \nng-show=\"baseForm.country_code.$touched || vm.apiErrors.country_code\"><div ng-message=\"required\">Required</div><div \nng-bind=\"vm.apiErrors.country_code\"></div></div></md-input-container></md-dialog-content><md-dialog-actions><md-button \nmd-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button\n class=\"md-accent md-raised\" ng-disabled=\"baseForm.$invalid || vm.saving\" type=\"submit\"><span ng-show=\"!vm.saving\">Save\n</span> <span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\">\n</md-progress-circular>Submitting</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/settings/thrive/tabs/denominations/dialogs/save-denomination/save-denomination-dialog.html","<md-dialog class=\"new-user-dialog transform-dialog\"><form name=\"denominationForm\" class=\"md-inline-form\" \nng-submit=\"vm.saveDenomination(vm.denomination, denominationForm)\" novalidate><md-toolbar class=\"md-accent md-hue-2\">\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"name\" \nng-model=\"vm.denomination.name\" placeholder=\"Denomination Name\" type=\"text\" class=\"denomination\" md-autofocus \nmaxlength=\"100\" required><div ng-messages=\"denominationForm.name.$error\" \nng-show=\"denominationForm.name.$touched || vm.apiErrors.name\" role=\"alert\"><div ng-message=\"required\"><span>Required\n</span></div><div ng-message=\"maxlength\"><span>Exceeds limit</span></div><div ng-bind=\"vm.apiErrors.name\"></div></div>\n</md-input-container></md-dialog-content><md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" \naria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"denominationForm.$invalid || vm.saving\" type=\"submit\"><span ng-show=\"!vm.saving\">Save</span> <span \nng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting\n</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/settings/changelogs/tabs/changelogs/dialogs/view-changelog/view-changelog-dialog.html","<md-dialog class=\"view-changelog-dialog transform-dialog\"><md-dialog-content ms-scroll><div class=\"row changelog-rows\">\n<div class=\"col-lg-4 col-md-4 col-sm-6\"><div class=\"changelog-data\"><span class=\"lbl\">Table</span> <span class=\"val\">\n{{ vm.changelog.table }}</span></div></div><div class=\"col-lg-4 col-md-4 col-sm-6\"><div class=\"changelog-data\"><span \nclass=\"lbl\">Item ID</span> <span class=\"val\">{{ vm.changelog.item_id }}</span></div></div><div \nclass=\"col-lg-4 col-md-4 col-sm-6\"><div class=\"changelog-data\"><span class=\"lbl\">Action</span> <span class=\"val\">\n{{ vm.changelog.action }}</span></div></div><div class=\"col-lg-4 col-md-4 col-sm-6\"><div class=\"changelog-data\"><span \nclass=\"lbl\">Desktop</span> <span class=\"val\">{{ vm.changelog.is_desktop ? \'Yes\' : \'No\' }}</span></div></div><div \nclass=\"col-lg-4 col-md-4 col-sm-6\"><div class=\"changelog-data\"><span class=\"lbl\">Mobile</span> <span class=\"val\">\n{{ vm.changelog.is_mobile ? \'Yes\' : \'No\' }}</span></div></div><div class=\"col-lg-4 col-md-4 col-sm-6\"><div \nclass=\"changelog-data\"><span class=\"lbl\">Tablet</span> <span class=\"val\">{{ vm.changelog.is_tablet ? \'Yes\' : \'No\' }}\n</span></div></div><div class=\"col-lg-4 col-md-4 col-sm-6\"><div class=\"changelog-data\"><span class=\"lbl\">Device</span> \n<span class=\"val\">{{ vm.changelog.device }}</span></div></div><div class=\"col-lg-4 col-md-4 col-sm-6\"><div \nclass=\"changelog-data\"><span class=\"lbl\">Platform</span> <span class=\"val\">{{ vm.changelog.platform }}</span></div>\n</div><div class=\"col-lg-4 col-md-4 col-sm-6\"><div class=\"changelog-data\"><span class=\"lbl\">Browser</span> <span \nclass=\"val\">{{ vm.changelog.browser }}</span></div></div><div class=\"col-lg-4 col-md-4 col-sm-6\"><div \nclass=\"changelog-data\"><span class=\"lbl\">Date</span> <span class=\"val\">{{ vm.changelog.created_at }}</span></div></div>\n</div><div class=\"changelog-dumps\"><div class=\"changelog-dump\"><p class=\"dump-title\">Data</p><pre>\n{{ vm.changelog.data | json }}</pre></div><div class=\"changelog-dump\"><p class=\"dump-title\">Request Information</p>\n<pre>{{ vm.changelog.info | json }}</pre></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/settings/thrive/tabs/mayors/dialogs/save-mayor/save-mayor-dialog.html","<md-dialog class=\"new-user-dialog transform-dialog\"><form name=\"mayorForm\" class=\"md-inline-form\" \nng-submit=\"vm.saveMayor(vm.mayor, vm.selectedCity, mayorForm)\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block mb-0\"><input name=\"email\" \nng-model=\"vm.mayor.email\" placeholder=\"Email\" type=\"email\" class=\"mayor-email-input\" md-autofocus required><div \nng-messages=\"mayorForm.email.$error\" ng-show=\"mayorForm.email.$touched || vm.apiErrors.email\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.email\"></div></div></md-input-container>\n<div layout=\"row\"><md-input-container class=\"md-block mb-0\"><input name=\"firstname\" ng-model=\"vm.mayor.firstname\" \nplaceholder=\"First Name\" type=\"text\" class=\"mayor-firstname-input\" md-autofocus required><div \nng-messages=\"mayorForm.firstname.$error\" ng-show=\"mayorForm.firstname.$touched || vm.apiErrors.firstname\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.firstname\"></div></div>\n</md-input-container><md-input-container class=\"md-block mb-0\"><input name=\"lastname\" ng-model=\"vm.mayor.lastname\" \nplaceholder=\"Last Name\" type=\"text\" class=\"mayor-lastname-input\" md-autofocus required><div \nng-messages=\"mayorForm.lastname.$error\" ng-show=\"mayorForm.lastname.$touched || vm.apiErrors.lastname\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.lastname\"></div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block mb-0\" flex><label>Base</label>\n<md-select name=\"base\" ng-model=\"vm.selectedBase\" ng-model-options=\"{ trackBy: \'$value.id\' }\" \nng-change=\"vm.selectBase(vm.selectedBase)\" required><md-option ng-value=\"base\" ng-repeat=\"base in vm.bases\">\n{{ base.name }}</md-option></md-select><div ng-messages=\"mayorForm.base.$error\" \nng-show=\"mayorForm.base.$touched || vm.apiErrors.base\" role=\"alert\"><div ng-message=\"required\"><span>Required</span>\n</div></div></md-input-container><md-input-container class=\"md-block mb-0\" flex><label>Municipality/City</label>\n<md-select name=\"city\" ng-model=\"vm.selectedCity\" ng-model-options=\"{ trackBy: \'$value.id\' }\" required><md-option \nng-value=\"city\" ng-repeat=\"city in vm.cities\">{{ city.name }}</md-option></md-select><div \nng-messages=\"mayorForm.city.$error\" ng-show=\"mayorForm.city.$touched || vm.apiErrors.city\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.city_id\"></div></div></md-input-container>\n</div></md-dialog-content><md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"mayorForm.$invalid || vm.saving\" type=\"submit\"><span ng-show=\"!vm.saving\">Save</span> <span \nng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting\n</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/settings/prevail/tabs/clusters/dialogs/save-cluster/save-cluster-dialog.html","<md-dialog class=\"edit-user-dialog transform-dialog\"><form name=\"clusterForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveCluster(vm.cluster, clusterForm)\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label>Base\n</label><md-select ng-model=\"vm.cluster.base\" ng-model-options=\"{ trackBy: \'$value.id\' }\" required \nng-change=\"vm.selectBase(vm.cluster)\" name=\"base_id\"><md-option ng-value=\"base\" ng-repeat=\"base in vm.bases\">\n{{base.name}}</md-option></md-select><div ng-messages=\"clusterForm.base_id.$error\" \nng-show=\"clusterForm.base_id.$touched || vm.apiErrors.base_id\" role=\"alert\"><div ng-message=\"required\"><span>Required\n</span></div><div ng-bind=\"vm.apiErrors.base_id\"></div></div></md-input-container><md-input-container \nclass=\"md-block mb-0\" flex-gt-xs><label>Branch</label><md-select ng-model=\"vm.cluster.branch\" \nng-model-options=\"{ trackBy: \'$value.id\' }\" required ng-disabled=\"!vm.cluster.base.branches.length\" name=\"branch_id\">\n<md-option ng-value=\"branch\" ng-repeat=\"branch in vm.cluster.base.branches\">{{branch.name}}</md-option></md-select><div\n ng-messages=\"clusterForm.branch_id.$error\" ng-show=\"clusterForm.branch_id.$touched || vm.apiErrors.branch_id\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.branch_id\"></div></div>\n</md-input-container></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><input name=\"name\" \nng-model=\"vm.cluster.name\" placeholder=\"Name\" class=\"cluster\" maxlength=\"100\" required><div \nng-messages=\"clusterForm.name.$error\" ng-show=\"clusterForm.name.$touched || vm.apiErrors.name\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.name\"></div></div></md-input-container>\n</div></md-dialog-content><md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"clusterForm.$invalid || clusterForm.$pristine || vm.saving\" type=\"submit\"><span ng-show=\"!vm.saving\">Save\n</span> <span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\">\n</md-progress-circular>Submitting</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/settings/prevail/tabs/partners/dialogs/save-partner/save-partner-dialog.html","<md-dialog class=\"new-user-dialog transform-dialog\"><form name=\"partnerForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.savePartner(vm.partner, partnerForm)\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"name\" \nng-model=\"vm.partner.name\" placeholder=\"Partner Name\" type=\"text\" class=\"partner\" md-autofocus maxlength=\"100\" \nrequired><div ng-messages=\"partnerForm.name.$error\" ng-show=\"partnerForm.name.$touched || vm.apiErrors.name\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.name\"></div></div>\n</md-input-container><md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"no_of_months\" \nng-model=\"vm.partner.no_of_months\" placeholder=\"No of months\" type=\"number\" class=\"partner\" maxlength=\"5\" min=\"1\" \nrequired><div ng-messages=\"partnerForm.no_of_months.$error\" \nng-show=\"partnerForm.no_of_months.$touched || vm.apiErrors.no_of_months\" role=\"alert\"><div ng-message=\"required\"><span>\nRequired</span></div><div ng-message=\"number\"><span>Should be a number.</span></div><div ng-message=\"maxlength\"><span>\nExceed limit</span></div><div ng-bind=\"vm.apiErrors.no_of_months\"></div></div></md-input-container></md-dialog-content>\n<md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"partnerForm.$invalid || vm.saving\" type=\"submit\"><span ng-show=\"!vm.saving\">Save</span> <span \nng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting\n</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/settings/prevail/tabs/small-group/dialogs/save-small-group/save-small-group-dialog.html","<md-dialog class=\"edit-user-dialog transform-dialog\"><form name=\"smallGroup\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveSmallGroup(vm.smallGroup, smallGroup)\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label>Base\n</label><md-select ng-model=\"vm.smallGroup.base\" ng-model-options=\"{ trackBy: \'$value.id\' }\" required name=\"base_id\" \nng-change=\"vm.baseChange(vm.smallGroup.base)\"><md-option ng-value=\"base\" ng-repeat=\"base in vm.bases\">{{base.name}}\n</md-option></md-select><div ng-messages=\"smallGroup.base_id.$error\" \nng-show=\"smallGroup.base_id.$touched || vm.apiErrors.base_id\" role=\"alert\"><div ng-message=\"required\"><span>Required\n</span></div><div ng-bind=\"vm.apiErrors.base_id\"></div></div></md-input-container><md-autocomplete \nclass=\"md-block mb-0\" flex-gt-xs flex required md-input-name=\"cluster\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedClusterName\" md-selected-item-change=\"vm.selectClusterName(cluster)\" \nmd-search-text-change=\"vm.searchClusterChange(vm.searchClusterName)\" md-search-text=\"vm.searchClusterName\" \nmd-items=\"cluster in vm.searchClusterNames(vm.searchClusterName)\" md-item-text=\"cluster.name\" md-require-match \nmd-floating-label=\"Cluster\" md-min-length=\"0\" ng-disabled=\"!vm.smallGroup.base\"><md-item-template><span \nmd-highlight-text=\"vm.searchClusterName\">{{cluster.name}}</span></md-item-template><div class=\"errors\" \nng-messages=\"smallGroup.cluster.$error\" \nng-if=\"smallGroup.cluster.$touched\r\n                             || smallGroup.$submitted\"><div ng-message=\"required\">\nRequired</div><div ng-message=\"md-require-match\">Please select an existing cluster.</div></div></md-autocomplete></div>\n<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><input name=\"name\" ng-model=\"vm.smallGroup.name\" \nplaceholder=\"Name\" class=\"smallGroup\" maxlength=\"100\" required><div ng-messages=\"smallGroup.name.$error\" \nng-show=\"smallGroup.name.$touched || vm.apiErrors.name\" role=\"alert\"><div ng-message=\"required\"><span>Required</span>\n</div><div ng-bind=\"vm.apiErrors.name\"></div></div></md-input-container></div></md-dialog-content><md-dialog-actions>\n<md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel\n</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"smallGroup.$invalid || smallGroup.$pristine || vm.saving\" type=\"submit\"><span ng-show=\"!vm.saving\">Save\n</span> <span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\">\n</md-progress-circular>Submitting</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/settings/transform/tabs/batches/bottom-sheets/batch-weeks/batch-weeks.html","<md-bottom-sheet class=\"md-grid cover-parent\"><div class=\"batch-weeks-slider-container\"><div \nclass=\"batch-weeks-slider-card\"><div class=\"slider-header\"><h4 class=\"slider-title\">Batch Weeks</h4><md-button \nng-click=\"vm.closeBatchWeek()\" md-no-ink class=\"md-primary batch-week-close-button\" aria-label=\"DROP\"><i \nclass=\"icon-close\"></i></md-button></div><div class=\"slider-body\"><md-content ms-scroll class=\"with-scrollbar\">\n<md-button class=\"md-raised new-application new-week\" ng-show=\"vm.weeks.length < 16\" ng-click=\"vm.addWeek()\">\nNew Batch Week</md-button><table class=\"table\"><tr><th>Week</th><th>Start Date</th><th>End Date</th><th>&nbsp;</th>\n</tr><tr ng-show=\"!vm.weeks.length\r\n                    && !vm.isLoading\"><td colspan=\"5\"><div class=\"text-center\">\nNo batch weeks.</div></td></tr><tr ng-show=\"vm.isLoading\"><td colspan=\"5\"><div class=\"text-center\">Loading batch weeks.\n</div></td></tr><tr ng-repeat=\"week in vm.weeks\"><td>{{week.week}}</td><td>{{week.start_at | date}}</td><td>\n{{week.end_at | date}}</td><td><span class=\"icons-container\"><i class=\"icon-pencil\" \nng-click=\"vm.editWeek(vm.weeks, $index);\"><md-tooltip md-direction=\"left\">Edit Week</md-tooltip></i></span><span \nclass=\"icons-container\"><i class=\"icon-trash\" ng-click=\"vm.deleteWeek(week);\"><md-tooltip md-direction=\"left\">\nDelete Week</md-tooltip></i></span></td></tr></table></md-content></div></div></div></md-bottom-sheet>");
$templateCache.put("app/main/settings/transform/tabs/batches/dialogs/add-batch-week/add-batch-week.html","<md-dialog class=\"new-user-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"weekForm\" \nclass=\"md-inline-form\" ng-submit=\"weekForm.$valid && vm.addNewBatchWeek(vm.week, weekForm)\" novalidate><input \ntype=\"hidden\" ng-model=\"vm.week.batch_id\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout-gt-xs=\"row\"><md-input-container class=\"md-block mb-0\" flex=\"50\">\n<input name=\"week\" ng-model=\"vm.week.week\" placeholder=\"Week No.\" type=\"number\" class=\"week\" min=\"vm.lastWeek.week\" \nmax=\"16\" md-autofocus required><div ng-messages=\"weekForm.week.$error\" \nng-show=\"weekForm.week.$touched || vm.apiErrors.week\" role=\"alert\"><div ng-message=\"required\"><span>Required</span>\n</div><div ng-message=\"number\"><span>Week should be between 1 and 15</span></div><div ng-message=\"min\"><span>\nWeek should be between 1 and 15</span></div><div ng-message=\"max\"><span>Week should be between 1 and 15</span></div>\n<div ng-bind=\"vm.apiErrors.week\"></div></div></md-input-container></div><div class=\"row datepickers-week\">\n<md-input-container class=\"col-md-6\"><label>Start Date</label><md-datepicker ng-model=\"vm.week.start_at\" \nname=\"startdate\" md-open-on-focus=\"true\" md-min-date=\"vm.lastWeek.end_at\" md-max-date=\"vm.week.end_at\" required>\n</md-datepicker><div ng-messages=\"weekForm.startdate.$error\" \nng-show=\"weekForm.startdate.$touched || vm.apiErrors.start_at\" role=\"alert\"><div ng-message=\"required\"><span>Required\n</span></div><div ng-bind=\"vm.apiErrors.start_at\"></div></div></md-input-container><md-input-container \nclass=\"col-md-6\"><label>End Date</label><md-datepicker ng-model=\"vm.week.end_at\" name=\"enddate\" \nmd-min-date=\"vm.week.start_at\" md-open-on-focus=\"true\"></md-datepicker><div ng-messages=\"weekForm.startdate.$error\" \nng-show=\"weekForm.startdate.$touched || vm.apiErrors.end_at\" role=\"alert\"><div ng-bind=\"vm.apiErrors.end_at\"></div>\n</div></md-input-container></div><div class=\"error-date\">{{vm.errorDate}}</div></md-dialog-content><md-dialog-actions>\n<md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel\n</md-button><md-button class=\"md-accent md-raised\" ng-disabled=\"weekForm.$invalid || vm.saving\" type=\"submit\"><span \nng-show=\"!vm.saving\">Create Batch Week</span> <span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"20px\"></md-progress-circular>Submitting</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/settings/transform/tabs/batches/dialogs/edit-batch/edit-batch-dialog.html","<md-dialog class=\"edit-user-dialog transform-dialog\"><form name=\"batchForm\" class=\"md-inline-form\" novalidate \nng-submit=\"batchForm.$valid && vm.editBatch(vm.batch, batchForm)\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout-gt-xs=\"row\"><md-input-container class=\"md-block mb-0\" flex-gt-xs>\n<input name=\"batch_no\" ng-model=\"vm.batch.batch_no\" placeholder=\"Batch No.\" type=\"text\" class=\"batch\" md-autofocus \nrequired><div ng-messages=\"batchForm.batch_no.$error\" ng-show=\"batchForm.batch_no.$touched || vm.apiErrors.batch_no\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.batch_no\"></div></div>\n</md-input-container><md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"stream_name\" \nng-model=\"vm.batch.stream_name\" placeholder=\"Stream\" required class=\"stream\" maxlength=\"70\"><div \nng-messages=\"batchForm.stream_name.$error\" ng-show=\"batchForm.stream_name.$touched || vm.apiErrors.stream_name\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-message=\"maxlength\"><span>Exceed limit\n</span></div><div ng-bind=\"vm.apiErrors.stream_name\"></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"fiscal_year\" ng-model=\"vm.batch.fiscal_year\" \nplaceholder=\"Start Year\" type=\"number\" class=\"batch\" maxlength=\"4\" minlength=\"4\" min=\"2005\" required><div \nng-messages=\"batchForm.fiscal_year.$error\" ng-show=\"batchForm.fiscal_year.$touched || vm.apiErrors.fiscal_year\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-message=\"maxlength\"><span>Invalid year\n</span></div><div ng-message=\"minlength\"><span>Invalid year</span></div><div ng-message=\"number\"><span>Invalid year\n</span></div><div ng-message=\"min\"><span>Invalid year</span></div><div ng-bind=\"vm.apiErrors.fiscal_year\"></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex><input name=\"end_year\" ng-model=\"vm.batch.end_year\" \nplaceholder=\"End Year\" type=\"number\" maxlength=\"4\" minlength=\"4\" ng-min=\"{{vm.batch.fiscal_year + 1}}\" required><div \nng-show=\"batchForm.end_year.$touched\" ng-messages=\"batchForm.end_year.$error\"><div ng-message=\"required\"><span>Required\n</span></div><div ng-message=\"maxlength\"><span>Invalid year</span></div><div ng-message=\"minlength\"><span>Invalid year\n</span></div><div ng-message=\"number\"><span>Invalid year</span></div><div ng-message=\"min\"><span>Invalid year</span>\n</div></div></md-input-container></div><div class=\"datepickers-batch row\"><md-input-container class=\"col-md-6\"><label>\nStart Date</label><md-datepicker ng-model=\"vm.batch.start_at\" name=\"startdate\" md-open-on-focus=\"true\" required>\n</md-datepicker><div ng-messages=\"batchForm.startdate.$error\" \nng-show=\"batchForm.startdate.$touched || vm.apiErrors.start_at\" role=\"alert\"><div ng-message=\"required\"><span>Required\n</span></div><div ng-bind=\"vm.apiErrors.start_at\"></div></div></md-input-container><md-input-container \nclass=\"col-md-6\"><label>End Date</label><md-datepicker ng-model=\"vm.batch.end_at\" md-open-on-focus=\"true\">\n</md-datepicker><div ng-messages=\"batchForm.startdate.$error\" \nng-show=\"batchForm.startdate.$touched || vm.apiErrors.end_at\" role=\"alert\"><div ng-message=\"required\"><span>Required\n</span></div><div ng-bind=\"vm.apiErrors.end_at\"></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"batchForm.$invalid || vm.saving\" type=\"submit\"><span ng-show=\"!vm.saving\">Edit Batch</span> <span \nng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting\n</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/settings/transform/tabs/batches/dialogs/edit-batch-week/edit-batch-week.html","<md-dialog class=\"new-user-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"weekForm\" \nclass=\"md-inline-form\" ng-submit=\"weekForm.$valid && vm.editBatchWeek(vm.week, weekForm)\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block mb-0\" flex=\"50\"><input name=\"week\" ng-model=\"vm.week.week\" \nplaceholder=\"Week No.\" type=\"number\" class=\"week\" min=\"1\" max=\"16\" md-autofocus required><div \nng-messages=\"weekForm.week.$error\" ng-show=\"weekForm.week.$touched || vm.apiErrors.week\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-message=\"number\"><span>Week should be between 1 and 15</span>\n</div><div ng-message=\"min\"><span>Week should be between 1 and 15</span></div><div ng-message=\"max\"><span>\nWeek should be between 1 and 15</span></div><div ng-bind=\"vm.apiErrors.week\"></div></div></md-input-container></div>\n<div class=\"row datepickers-week\"><md-input-container class=\"col-md-6\"><label>Start Date</label><md-datepicker \nng-model=\"vm.week.start_at\" name=\"startdate\" md-open-on-focus=\"true\" md-min-date=\"vm.min_date\" \nmd-max-date=\"vm.week.end_at\" required></md-datepicker><div ng-messages=\"weekForm.startdate.$error\" \nng-show=\"weekForm.startdate.$touched || vm.apiErrors.start_at\" role=\"alert\"><div ng-message=\"required\"><span>Required\n</span></div><div ng-bind=\"vm.apiErrors.start_at\"></div></div></md-input-container><md-input-container \nclass=\"col-md-6\"><label>End Date</label><md-datepicker ng-model=\"vm.week.end_at\" name=\"enddate\" \nmd-min-date=\"vm.week.start_at\" md-max-date=\"vm.max_date\" md-open-on-focus=\"true\"></md-datepicker><div \nng-messages=\"weekForm.startdate.$error\" ng-show=\"weekForm.startdate.$touched || vm.apiErrors.end_at\" role=\"alert\"><div \nng-bind=\"vm.apiErrors.end_at\"></div></div></md-input-container></div><div class=\"error-date\">{{vm.errorDate}}</div>\n</md-dialog-content><md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"weekForm.$invalid || vm.saving\" type=\"submit\"><span ng-show=\"!vm.saving\">Update Batch Week</span> <span \nng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting\n</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/settings/transform/tabs/batches/dialogs/new-batch/new-batch-dialog.html","<md-dialog class=\"new-user-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"batchForm\" \nclass=\"md-inline-form\" ng-submit=\"batchForm.$valid && vm.addNewBatch(vm.batch, batchForm)\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"batch_no\" \nng-model=\"vm.batch.batch_no\" placeholder=\"Batch No.\" type=\"text\" class=\"batch\" md-autofocus required><div \nng-messages=\"batchForm.batch_no.$error\" ng-show=\"batchForm.batch_no.$touched || vm.apiErrors.batch_no\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.batch_no\"></div></div>\n</md-input-container><md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"stream_name\" \nng-model=\"vm.batch.stream_name\" placeholder=\"Stream\" class=\"stream\" required maxlength=\"70\"><div \nng-messages=\"batchForm.stream_name.$error\" ng-show=\"batchForm.stream_name.$touched || vm.apiErrors.stream_name\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-message=\"maxlength\"><span>Exceed limit\n</span></div><div ng-bind=\"vm.apiErrors.stream_name\"></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"fiscal_year\" ng-model=\"vm.batch.fiscal_year\" \nplaceholder=\"Start Year\" type=\"number\" class=\"batch\" maxlength=\"4\" minlength=\"4\" min=\"2005\" required><div \nng-messages=\"batchForm.fiscal_year.$error\" ng-show=\"batchForm.fiscal_year.$touched || vm.apiErrors.fiscal_year\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-message=\"maxlength\"><span>Invalid year\n</span></div><div ng-message=\"minlength\"><span>Invalid year</span></div><div ng-message=\"number\"><span>Invalid year\n</span></div><div ng-message=\"min\"><span>Invalid year</span></div><div ng-bind=\"vm.apiErrors.fiscal_year\"></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex><input name=\"end_year\" ng-model=\"vm.batch.end_year\" \nplaceholder=\"End Year\" type=\"number\" maxlength=\"4\" minlength=\"4\" ng-min=\"{{vm.batch.fiscal_year + 1}}\" required><div \nng-show=\"batchForm.end_year.$touched\" ng-messages=\"batchForm.end_year.$error\"><div ng-message=\"required\"><span>Required\n</span></div><div ng-message=\"maxlength\"><span>Invalid year</span></div><div ng-message=\"minlength\"><span>Invalid year\n</span></div><div ng-message=\"number\"><span>Invalid year</span></div><div ng-message=\"min\"><span>Invalid year</span>\n</div></div></md-input-container></div><div class=\"row datepickers-batch\"><md-input-container class=\"col-md-6\"><label>\nStart Date</label><md-datepicker ng-model=\"vm.batch.start_at\" name=\"startdate\" md-open-on-focus=\"true\" required>\n</md-datepicker><div ng-messages=\"batchForm.startdate.$error\" \nng-show=\"batchForm.startdate.$touched || vm.apiErrors.start_at\" role=\"alert\"><div ng-message=\"required\"><span>Required\n</span></div><div ng-bind=\"vm.apiErrors.start_at\"></div></div></md-input-container><md-input-container \nclass=\"col-md-6\"><label>End Date</label><md-datepicker ng-model=\"vm.batch.end_at\" name=\"enddate\" \nmd-open-on-focus=\"true\"></md-datepicker><div ng-messages=\"batchForm.startdate.$error\" \nng-show=\"batchForm.startdate.$touched || vm.apiErrors.end_at\" role=\"alert\"><div ng-bind=\"vm.apiErrors.end_at\"></div>\n</div></md-input-container></div><div class=\"error-date\">{{vm.errorDate}}</div></md-dialog-content><md-dialog-actions>\n<md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel\n</md-button><md-button class=\"md-accent md-raised\" ng-disabled=\"batchForm.$invalid || vm.saving\" type=\"submit\"><span \nng-show=\"!vm.saving\">Create Batch</span> <span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"20px\"></md-progress-circular>Submitting</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/settings/transform/tabs/donors/dialogs/save-donor/save-donor-dialog.html","<md-dialog class=\"edit-user-dialog transform-dialog\"><form name=\"donorForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveDonor(vm.donor, donorForm)\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"name\" \nng-model=\"vm.donor.name\" placeholder=\"Donor Name\" type=\"text\" class=\"donor\" maxlength=\"30\" md-autofocus required><div \nng-messages=\"donorForm.name.$error\" ng-show=\"donorForm.name.$touched || vm.apiErrors.name\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-message=\"maxlength\"><span>Exceeds limit</span></div><div \nng-bind=\"vm.apiErrors.name\"></div></div></md-input-container></md-dialog-content><md-dialog-actions><md-button \nmd-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button\n class=\"md-accent md-raised\" ng-disabled=\"donorForm.$invalid || vm.saving\" type=\"submit\"><span ng-show=\"!vm.saving\">\nSave</span> <span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\">\n</md-progress-circular>Submitting</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/settings/transform/tabs/programs/dialogs/save-program/save-program-dialog.html","<md-dialog class=\"edit-user-dialog transform-dialog\"><form name=\"programForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveProgram(vm.program, programForm)\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block mb-40\" flex-gt-xs><input name=\"name\" \nng-model=\"vm.program.name\" placeholder=\"Program Name\" type=\"text\" class=\"program\" md-autofocus required><div \nng-messages=\"programForm.name.$error\" ng-show=\"programForm.name.$touched || vm.apiErrors.name\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.name\"></div></div></md-input-container>\n<md-input-container class=\"md-block mb-0\"><label>Pilot of</label><md-select ng-model=\"vm.program.parent_program_id\" \nname=\"parent_program_id\"><md-option ng-value=\"program.id\" ng-repeat=\"program in vm.programs\">{{ program.name }}\n</md-option></md-select><div class=\"errors\" \nng-messages=\"programForm.parent_program_id.$error || vm.apiErrors.parent_program_id\" \nng-show=\"eventForm.parent_program_id.$touched || vm.apiErrors.parent_program_id\"><div ng-message=\"required\">Required\n</div><div ng-bind=\"vm.apiErrors.parent_program_id\"></div></div></md-input-container><md-input-container \nclass=\"md-block mb-0\" flex-gt-xs><md-checkbox ng-model=\"vm.program.has_16th_week\" class=\"mb-0 mt-0\">Has 16 weeks\n</md-checkbox></md-input-container><md-input-container class=\"md-block mb-0 mt-0\" flex-gt-xs><md-checkbox \nng-model=\"vm.program.active\">Is Active</md-checkbox></md-input-container></md-dialog-content><md-dialog-actions>\n<md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel\n</md-button><md-button class=\"md-accent md-raised\" ng-disabled=\"programForm.$invalid || vm.saving || vm.loading\" \ntype=\"submit\"><span ng-show=\"!vm.saving\">Save</span> <span ng-show=\"vm.saving\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting</span></md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/settings/transform/tabs/products/dialogs/delete-product/delete-product-dialog.html","<md-dialog class=\"delete-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nclass=\"text-center\"><p class=\"text-muted text-reminder\"><em>\nDeleting this product will also remove all the bibs and bib participant transactions associated to this product.</em>\n</p><hr><p>Are you sure to delete this product?</p></md-dialog-content><md-dialog-actions><md-button md-no-ink \nclass=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"vm.saving\" ng-click=\"vm.passwordConfirmation()\"><span ng-show=\"!vm.saving\">\nDelete Product</span> <span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\">\n</md-progress-circular>Submitting</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/settings/transform/tabs/products/dialogs/save-product/save-product-dialog.html","<md-dialog class=\"edit-user-dialog transform-dialog\"><form name=\"productForm\" class=\"md-inline-form\" novalidate \nng-submit=\"vm.saveProduct(vm.product, productForm)\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block mb-0\" flex-gt-xs><input name=\"name\" \nng-model=\"vm.product.name\" placeholder=\"Product Name\" type=\"text\" class=\"product\" md-autofocus maxlength=\"100\" \nrequired><div ng-messages=\"productForm.name.$error\" ng-show=\"productForm.name.$touched || vm.apiErrors.name\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.name\"></div></div>\n</md-input-container></md-dialog-content><md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" \naria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"productForm.$invalid || vm.saving\" type=\"submit\"><span ng-show=\"!vm.saving\">Save</span> <span \nng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting\n</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/settings/transform/tabs/users/dialogs/edit-user/edit-user-dialog.html","<md-dialog class=\"edit-user-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.editUser(vm.user, eventForm)\"><md-toolbar class=\"md-accent md-hue-2\">\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block\"><label>First name</label><input \nname=\"firstname\" ng-model=\"vm.user.firstname\" required md-autofocus><div ng-messages=\"eventForm.firstname.$error\" \nng-show=\"eventForm.firstname.$touched || vm.apiErrors.firstname\" role=\"alert\"><div ng-message=\"required\"><span>Required\n</span></div><div ng-bind=\"vm.apiErrors.firstname\"></div></div></md-input-container><md-input-container \nclass=\"md-block\"><label>Last name</label><input name=\"lastname\" ng-model=\"vm.user.lastname\" required><div \nng-messages=\"eventForm.lastname.$error\" ng-show=\"eventForm.lastname.$touched || vm.apiErrors.lastname\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.lastname\"></div></div>\n</md-input-container><md-input-container class=\"md-block\"><label>Email</label><input name=\"email\" \nng-model=\"vm.user.email\" required><div ng-messages=\"eventForm.email.$error\" \nng-show=\"eventForm.email.$touched || vm.apiErrors.email\" role=\"alert\"><div ng-message=\"required\"><span>Required</span>\n</div><div ng-message=\"taken\"><span>Email is already taken</span></div><div ng-message=\"pattern\">Must be a valid email\n</div><div ng-bind=\"vm.apiErrors.email\"></div></div></md-input-container><md-input-container class=\"md-block\"><label>\nUsername</label><input minlength=\"5\" name=\"username\" ng-model=\"vm.user.username\" required><div \nng-messages=\"eventForm.username.$error\" ng-show=\"eventForm.username.$touched || vm.apiErrors.username\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div><div ng-message=\"taken\"><span>Username is already taken</span>\n</div><div ng-message=\"minlength\"><span>Should have minimum of 5 characters</span></div><div \nng-bind=\"vm.apiErrors.username\"></div></div></md-input-container><md-input-container class=\"md-block\"><label>\nNew password</label><input minlength=\"5\" name=\"password\" type=\"password\" ng-model=\"vm.user.password\" \nng-required=\"vm.user.confirmPassword\"><div ng-messages=\"eventForm.password.$error\" \nng-show=\"eventForm.password.$touched || vm.apiErrors.password\" role=\"alert\"><div ng-message=\"minlength\">\nShould have minimum of 5 characters</div><div ng-bind=\"vm.apiErrors.password\"></div></div></md-input-container>\n<md-input-container class=\"md-block mb-0\"><label>Confirm password</label><input name=\"confirmpassword\" type=\"password\" \nng-pattern=\"{{vm.user.password}}\" ng-model=\"vm.user.confirmPassword\" ng-required=\"vm.user.password\"><div \nng-messages=\"eventForm.confirmpassword.$error\" \nng-show=\"eventForm.confirmpassword.$touched || vm.apiErrors.password_confirmation\" role=\"alert\"><div \nng-message=\"pattern\"><span>Not equal</span></div><div ng-message=\"required\"><span>Required</span></div><div \nng-bind=\"vm.apiErrors.password_confirmation\"></div></div></md-input-container><md-input-container \nclass=\"md-block mb-40\"><label>Country</label><md-select ng-model=\"vm.user.country_code\" \nng-change=\"vm.handleCountryChange(vm.user.country_code)\" required><md-option ng-value=\"country.id\" \nng-repeat=\"country in vm.countrys\">{{country.name}}</md-option></md-select><div class=\"errors\" \nng-messages=\"eventForm.country_code.$error || vm.apiErrors.country_code\" \nng-show=\"eventForm.country_code.$touched || vm.apiErrors.country_code\"><div ng-message=\"required\">Required</div><div \nng-bind=\"vm.apiErrors.country_code\"></div></div></md-input-container><md-input-container class=\"md-block mb-40\"><label>\nBase</label><md-select ng-model=\"vm.user.base_id\" ng-disabled=\"!vm.user.country_code\" required><md-option \nng-value=\"-1\">All Bases</md-option><md-option ng-value=\"base.id\" ng-click=\"vm.selectBase(base)\" \nng-repeat=\"base in vm.bases\">{{base.name}}</md-option></md-select><div class=\"errors\" \nng-messages=\"eventForm.base_id.$error || vm.apiErrors.base_id\" \nng-show=\"eventForm.base_id.$touched || vm.apiErrors.base_id\"><div ng-message=\"required\">Required</div><div \nng-bind=\"vm.apiErrors.base_id\"></div></div></md-input-container><md-input-container class=\"md-block mb-40\"><label>\nBranch</label><md-select ng-model=\"vm.user.branch_id\" required><md-option ng-value=\"-1\">All Branches</md-option>\n<md-option ng-value=\"branch.id\" ng-repeat=\"branch in vm.branches\">{{branch.name}}</md-option></md-select><div \nclass=\"errors\" ng-messages=\"eventForm.branch_id.$error || vm.apiErrors.branch_id\" \nng-show=\"eventForm.branch_id.$touched || vm.apiErrors.branch_id\"><div ng-message=\"required\">Required</div><div \nng-bind=\"vm.apiErrors.branch_id\"></div></div></md-input-container><md-input-container class=\"md-block\"><label>Role\n</label><md-select name=\"role\" ng-model=\"vm.user.role\" required><md-option ng-value=\"role.value\" \nng-repeat=\"role in vm.roles\">{{role.label}}</md-option></md-select><div class=\"errors\" \nng-messages=\"eventForm.role.$error\" ng-show=\"eventForm.role.$touched || vm.apiErrors.roles\"><div ng-message=\"required\">\nRequired</div><div ng-bind=\"vm.apiErrors.roles\"></div></div></md-input-container></md-dialog-content>\n<md-dialog-actions><md-button md-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"eventForm.$invalid || vm.saving\" type=\"submit\"><span ng-show=\"!vm.saving\">Edit User</span> <span \nng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20px\"></md-progress-circular>Submitting\n</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/settings/transform/tabs/users/dialogs/new-user/new-user-dialog.html","<md-dialog class=\"new-user-dialog transform-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.addNewUser(vm.user, eventForm)\" novalidate><md-toolbar class=\"md-accent md-hue-2\">\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block\"><label>First name</label><input \nname=\"firstname\" ng-model=\"vm.user.firstname\" required md-autofocus><div ng-messages=\"eventForm.firstname.$error\" \nng-show=\"eventForm.firstname.$touched || vm.apiErrors.firstname\" role=\"alert\"><div ng-message=\"required\"><span>Required\n</span></div><div ng-bind=\"vm.apiErrors.firstname\"></div></div></md-input-container><md-input-container \nclass=\"md-block\"><label>Last name</label><input name=\"lastname\" ng-model=\"vm.user.lastname\" required><div \nng-messages=\"eventForm.lastname.$error\" ng-show=\"eventForm.lastname.$touched || vm.apiErrors.lastname\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div><div ng-bind=\"vm.apiErrors.lastname\"></div></div>\n</md-input-container><md-input-container class=\"md-block\"><label>Email</label><input ng-pattern=\"/^.+@.+\\..+$/\" \nname=\"email\" ng-model=\"vm.user.email\" required><div ng-messages=\"eventForm.email.$error\" \nng-show=\"eventForm.email.$touched || vm.apiErrors.email\" role=\"alert\"><div ng-message=\"required\"><span>Required</span>\n</div><div ng-message=\"taken\"><span>Email is already taken</span></div><div ng-message=\"pattern\">Must be a valid email\n</div><div ng-bind=\"vm.apiErrors.email\"></div></div></md-input-container><md-input-container class=\"md-block\"><label>\nUsername</label><input minlength=\"5\" name=\"username\" ng-model=\"vm.user.username\" required><div \nng-messages=\"eventForm.username.$error\" ng-show=\"eventForm.username.$touched || vm.apiErrors.username\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div><div ng-message=\"taken\"><span>Username is already taken</span>\n</div><div ng-message=\"minlength\"><span>Should have minimum of 5 characters</span></div><div \nng-bind=\"vm.apiErrors.username\"></div></div></md-input-container><md-input-container class=\"md-block\"><label>Password\n</label><input minlength=\"5\" name=\"password\" type=\"password\" ng-model=\"vm.user.password\" required><div \nng-messages=\"eventForm.password.$error\" ng-show=\"eventForm.password.$touched || vm.apiErrors.password\" role=\"alert\">\n<div ng-message=\"required\"><span>Required</span></div><div ng-message=\"minlength\">Should have minimum of 5 characters\n</div><div ng-bind=\"vm.apiErrors.password\"></div></div></md-input-container><md-input-container class=\"md-block mb-0\">\n<label>Confirm password</label><input name=\"confirmpassword\" type=\"password\" ng-pattern=\"{{vm.user.password}}\" \nng-model=\"vm.user.confirmPassword\" required><div ng-messages=\"eventForm.confirmpassword.$error\" \nng-show=\"eventForm.confirmpassword.$touched || vm.apiErrors.password_confirmation\" role=\"alert\"><div \nng-message=\"required\"><span>Required</span></div><div ng-message=\"pattern\"><span>Not equal</span></div><div \nng-bind=\"vm.apiErrors.password_confirmation\"></div></div></md-input-container><md-input-container \nclass=\"md-block mb-40\"><label>Country</label><md-select ng-model=\"vm.user.country_code\" \nng-change=\"vm.handleCountryChange(vm.user.country_code)\" required><md-option ng-value=\"country.id\" \nng-repeat=\"country in vm.countrys\">{{country.name}}</md-option></md-select><div class=\"errors\" \nng-messages=\"eventForm.country_code.$error || vm.apiErrors.country_code\" \nng-show=\"eventForm.country_code.$touched || vm.apiErrors.country_code\"><div ng-message=\"required\">Required</div><div \nng-bind=\"vm.apiErrors.country_code\"></div></div></md-input-container><md-input-container class=\"md-block mb-40\"><label>\nBase</label><md-select ng-model=\"vm.user.base_id\" ng-disabled=\"!vm.user.country_code\" required><md-option \nng-value=\"-1\">All Bases</md-option><md-option ng-value=\"base.id\" ng-click=\"vm.selectBase(base)\" \nng-repeat=\"base in vm.bases\">{{base.name}}</md-option></md-select><div class=\"errors\" \nng-messages=\"eventForm.base_id.$error || vm.apiErrors.base_id\" \nng-show=\"eventForm.base_id.$touched || vm.apiErrors.base_id\"><div ng-message=\"required\">Required</div><div \nng-bind=\"vm.apiErrors.base_id\"></div></div></md-input-container><md-input-container class=\"md-block mb-40\"><label>\nBranch</label><md-select ng-model=\"vm.user.branch_id\" required><md-option ng-value=\"-1\">All Branches</md-option>\n<md-option ng-value=\"branch.id\" ng-repeat=\"branch in vm.branches\">{{branch.name}}</md-option></md-select><div \nclass=\"errors\" ng-messages=\"eventForm.branch_id.$error || vm.apiErrors.branch_id\" \nng-show=\"eventForm.branch_id.$touched || vm.apiErrors.branch_id\"><div ng-message=\"required\">Required</div><div \nng-bind=\"vm.apiErrors.branch_id\"></div></div></md-input-container><md-input-container class=\"md-block\"><label>Role\n</label><md-select name=\"role\" ng-model=\"vm.user.role\" required><md-option ng-value=\"role.value\" \nng-repeat=\"role in vm.roles\">{{role.label}}</md-option></md-select><div ng-messages=\"eventForm.role.$error\" \nng-show=\"eventForm.role.$touched || vm.apiErrors.roles\" role=\"alert\"><div ng-message=\"required\">Required</div><div \nng-bind=\"vm.apiErrors.roles\"></div></div></md-input-container></md-dialog-content><md-dialog-actions><md-button \nmd-no-ink class=\"md-primary cancel-button\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button\n class=\"md-accent md-raised\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine || vm.saving\" type=\"submit\"><span \nng-show=\"!vm.saving\">Create User</span> <span ng-show=\"vm.saving\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"20px\"></md-progress-circular>Submitting</span></md-button></md-dialog-actions></form></md-dialog>");}]);